(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-advanced-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('werk-advanced-tabs')) {
    customElements.define(
      'werk-advanced-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.n = this.tabs.length;
          this.cur = Math.max(0, this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true'));
          this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.reduce) this.dataset.motion = 'off';
          this.motion = this.dataset.motion === 'on';
          this.auto = this.dataset.autoplay === 'true' && !this.reduce && this.n > 1;
          this.dur = (parseFloat(this.dataset.duration) || 6) * 1000;
          this.stopOnPick = this.dataset.stop !== 'false';
          this.state = this.auto ? 'play' : 'off'; // play · paused (button) · stopped (a visitor picked a tab) · off
          this.holds = new Set(['view']); // hover · focus · view · tab · editor – the timer runs while this is empty
          this.pauseBtn = this.querySelector('[data-pause]');
          this.count = this.querySelector('[data-count]');
          this.indicator = this.querySelector('.werk-advanced-tabs_pill, .werk-advanced-tabs_mark');
          this.rail = this.querySelector('.werk-advanced-tabs_rail');
          if (this.pauseBtn && !this.auto) this.pauseBtn.hidden = true;
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });

          this.tabs.forEach((t, i) => on(t, 'click', () => this.pick(i)));
          on(this, 'keydown', (e) => this.onKey(e));
          on(this.pauseBtn, 'click', () => this.toggle());
          // hover pauses only over the tabs and the pause button – where someone is about to click. A pointer resting
          // on the picture or the text must not stop the timer. Read from the target on the root, so a tab that changes
          // under the pointer never leaves a hold behind.
          const aim = (e) => e.pointerType === 'mouse' && !!e.target.closest?.('[role="tablist"], [data-pause]');
          on(this, 'pointerover', (e) => this.hold('hover', aim(e)));
          on(this, 'pointerleave', () => this.hold('hover', false));
          // only keyboard focus pauses (a clicked tab keeps its focus)
          on(this, 'focusin', (e) => this.hold('focus', e.target.matches(':focus-visible') && !!e.target.closest('[role="tablist"]')));
          on(this, 'focusout', (e) => !this.contains(e.relatedTarget) && this.hold('focus', false));
          on(document, 'visibilitychange', () => this.hold('tab', document.hidden));
          on(document, 'shopify:block:select', (e) => this.onEditor(e, true));
          on(document, 'shopify:block:deselect', (e) => this.onEditor(e, false));
          on(this.rail, 'scroll', () => this.edges(), { passive: true });
          this.querySelectorAll('[data-swipe]').forEach((el) => this.swipe(el, on));
          this.querySelectorAll('video[data-video]').forEach((v) => {
            v.loop = false;
            on(v, 'playing', () => v.classList.add('is-playing'));
            on(v, 'ended', () => (this.running() && this.n > 1 ? this.next() : v.play().catch(() => {})));
          });

          this.io = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting && !this.seen) {
                this.seen = true;
                this.querySelectorAll('.werk-advanced-tabs_item img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
              }
              this.hold('view', !entry.isIntersecting);
              this.media();
            },
            { threshold: 0.35 }
          );
          this.io.observe(this);
          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => (this.place(false), this.edges()));
          });
          this.ro.observe(this);
          const list = this.querySelector('[role="tablist"]');
          if (list) this.ro.observe(list);
          document.fonts?.ready.then(() => this.isConnected && (this.place(false), this.edges()));

          this.select(this.cur);
          this.place(false);
          this.classList.add('is-ready');
          this.label();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          this.ro?.disconnect();
          cancelAnimationFrame(this.raf);
          cancelAnimationFrame(this.vraf);
          this.anim?.cancel();
        }

        // ---------- switching ----------
        go(i, dir) {
          if (i === this.cur || i < 0 || i >= this.n) return;
          this.style.setProperty('--dir', dir || (i > this.cur ? 1 : -1));
          const prev = this.cur;
          this.cur = i;
          this.querySelectorAll(`.werk-advanced-tabs_item[data-i="${prev}"]`).forEach((el) => el.classList.remove('is-on', 'is-from'));
          const next = [...this.querySelectorAll(`.werk-advanced-tabs_item[data-i="${i}"]`)];
          // enter from the side the tab lies on – unless it is still on its way out, then it simply turns around
          if (this.motion) {
            next.forEach((el) => {
              const m = el.querySelector('.werk-advanced-tabs_media, .werk-advanced-tabs_line');
              if (!m || parseFloat(getComputedStyle(m).opacity) < 0.05) el.classList.add('is-from');
            });
            void this.offsetWidth;
          }
          next.forEach((el) => el.classList.remove('is-from'));
          next.forEach((el) => el.classList.add('is-on'));
          this.select(i);
          this.place(true);
          this.restart();
        }

        select(i) {
          this.tabs.forEach((t, k) => {
            t.setAttribute('aria-selected', String(k === i));
            t.tabIndex = k === i ? 0 : -1;
          });
          if (this.count) this.count.textContent = `${String(i + 1).padStart(2, '0')} / ${String(this.n).padStart(2, '0')}`;
        }

        next() {
          this.go((this.cur + 1) % this.n, 1);
        }

        // a visitor picked a tab: they have taken over
        pick(i, dir) {
          if (this.state === 'play' && this.stopOnPick) this.setState('stopped');
          if (i === this.cur) return this.restart();
          this.go(i, dir);
        }

        // ---------- the moving indicator (pill / ink card) ----------
        place(animate) {
          const ind = this.indicator;
          const tab = this.tabs[this.cur];
          if (!ind || !tab) return;
          if (!animate || !this.motion) this.classList.add('no-anim');
          ind.style.setProperty('--x', tab.offsetLeft + 'px');
          ind.style.setProperty('--y', tab.offsetTop + 'px');
          ind.style.setProperty('--w', tab.offsetWidth + 'px');
          ind.style.setProperty('--h', tab.offsetHeight + 'px');
          if (this.classList.contains('no-anim')) {
            void ind.offsetWidth;
            this.classList.remove('no-anim');
          }
          // keep the active segment in view inside its rail (never scrolls the page)
          const r = this.rail;
          if (r && r.scrollWidth > r.clientWidth + 1) {
            const left = tab.offsetLeft + 4 - (r.clientWidth - tab.offsetWidth) / 2;
            r.scrollTo({ left, behavior: animate && this.motion ? 'smooth' : 'auto' });
          }
        }

        edges() {
          const r = this.rail;
          if (!r) return;
          const over = r.scrollWidth > r.clientWidth + 1;
          r.classList.toggle('is-overflow', over);
          r.classList.toggle('is-start', over && r.scrollLeft < 2);
          r.classList.toggle('is-end', over && r.scrollLeft > r.scrollWidth - r.clientWidth - 2);
        }

        // ---------- autoplay ----------
        running() {
          return this.state === 'play' && this.holds.size === 0;
        }

        hold(reason, set) {
          const had = this.holds.has(reason);
          if (set === had) return;
          set ? this.holds.add(reason) : this.holds.delete(reason);
          this.sync();
        }

        setState(state) {
          this.state = state;
          this.classList.toggle('is-paused', state === 'paused' || state === 'stopped');
          this.classList.toggle('is-stopped', state === 'stopped');
          this.label();
          if (state === 'stopped') this.stopTimer();
          this.sync();
        }

        toggle() {
          if (this.state === 'play') return this.setState('paused');
          const fresh = this.state === 'stopped';
          this.setState('play');
          if (fresh) this.restart();
        }

        label() {
          if (!this.pauseBtn) return;
          const d = this.pauseBtn.dataset;
          this.pauseBtn.setAttribute('aria-label', this.state === 'play' ? d.labelPause : d.labelPlay);
        }

        timerEl() {
          const all = this.querySelectorAll('[data-timer]');
          return all.length > 1 ? all[this.cur] : all[0];
        }

        video() {
          return this.querySelector(`.werk-advanced-tabs_item[data-i="${this.cur}"] video[data-video]`);
        }

        stopTimer() {
          this.anim?.cancel();
          this.anim = null;
          cancelAnimationFrame(this.vraf);
          this.querySelectorAll('[data-timer]').forEach((t) => (t.style.scale = ''));
        }

        restart() {
          this.stopTimer();
          this.media();
          if (!this.auto || this.state === 'stopped' || this.state === 'off') return;
          const el = this.timerEl();
          const v = this.video();
          if (v) {
            // a video tab plays for as long as its video – the fill follows the playhead
            const tick = () => {
              if (!this.isConnected) return;
              if (v.duration) el && (el.style.scale = `${Math.min(1, v.currentTime / v.duration)} 1`);
              this.vraf = requestAnimationFrame(tick);
            };
            tick();
            return;
          }
          if (!el) return;
          this.anim = el.animate([{ scale: '0 1' }, { scale: '1 1' }], { duration: this.dur, easing: 'linear', fill: 'forwards' });
          this.anim.onfinish = () => this.running() && this.next();
          this.sync();
        }

        sync() {
          if (this.anim) {
            if (this.running()) {
              if (this.anim.playState === 'finished') this.next();
              else this.anim.play();
            } else this.anim.pause();
          } else if (this.auto && this.state === 'play' && !this.started) {
            this.started = true;
            this.restart();
            return;
          }
          this.media();
        }

        // the active tab's video plays while the section is in view (never with reduced motion / animations off)
        media() {
          const active = this.video();
          this.querySelectorAll('video[data-video]').forEach((v) => {
            const play = v === active && this.motion && !this.holds.has('view') && !this.holds.has('tab') && this.state !== 'paused';
            if (play) {
              if (v.preload === 'none') v.preload = 'auto';
              v.play().catch(() => v.classList.remove('is-playing'));
            } else {
              v.pause();
              if (v !== active) v.currentTime = 0;
            }
          });
        }

        // ---------- input ----------
        onKey(e) {
          const t = e.target.closest('[role="tab"]');
          if (!t) return;
          const i = this.tabs.indexOf(t);
          const map = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: this.n - 1 };
          if (!(e.key in map)) return;
          e.preventDefault();
          const k = (map[e.key] + this.n) % this.n;
          this.tabs[k].focus();
          this.pick(k, k > i ? 1 : -1);
        }

        onEditor(e, selected) {
          const i = this.tabs.findIndex((t) => t.dataset.block === e.detail?.blockId);
          if (i < 0) return;
          if (selected) this.go(i);
          this.hold('editor', selected);
        }

        // swipe the picture on touch screens; rubber band at both ends
        swipe(el, on) {
          let x0 = 0, y0 = 0, t0 = 0, dx = 0, drag = false, id = null;
          const media = () => this.querySelector(`[data-swipe] .werk-advanced-tabs_item[data-i="${this.cur}"] .werk-advanced-tabs_media`);
          on(el, 'pointerdown', (e) => {
            if (e.pointerType === 'mouse' || this.n < 2) return;
            id = e.pointerId;
            x0 = e.clientX;
            y0 = e.clientY;
            t0 = performance.now();
            dx = 0;
            drag = false;
          });
          on(el, 'pointermove', (e) => {
            if (e.pointerId !== id) return;
            dx = e.clientX - x0;
            if (!drag && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(e.clientY - y0)) {
              drag = true;
              el.setPointerCapture?.(id);
              this.hold('drag', true);
            }
            if (!drag) return;
            const edge = (dx > 0 && this.cur === 0) || (dx < 0 && this.cur === this.n - 1);
            const m = media();
            if (m) (m.style.transition = 'none'), (m.style.translate = `${edge ? dx * 0.25 : dx * 0.5}px 0`);
          });
          const end = (e) => {
            if (e.pointerId !== id) return;
            id = null;
            const m = media();
            if (m) (m.style.transition = ''), (m.style.translate = '');
            if (!drag) return;
            drag = false;
            this.hold('drag', false);
            const v = dx / Math.max(1, performance.now() - t0);
            const go = Math.abs(dx) > el.clientWidth * 0.18 || Math.abs(v) > 0.45;
            if (go && dx < 0 && this.cur < this.n - 1) this.pick(this.cur + 1, 1);
            else if (go && dx > 0 && this.cur > 0) this.pick(this.cur - 1, -1);
          };
          on(el, 'pointerup', end);
          on(el, 'pointercancel', end);
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-build-a-box"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-build-a-box')) {
    customElements.define(
      'werk-build-a-box',
      class extends HTMLElement {
        connectedCallback() {
          const q = (s) => this.querySelector(s);
          try {
            this.d = JSON.parse(q('script[data-werk]').textContent);
            this.t = JSON.parse(q('script[data-werk-t]').textContent);
          } catch {
            return;
          }
          this.fixed = this.d.look === 'fixed';
          this.P = new Map(this.d.products.map((p) => [String(p.id), p]));
          this.V = new Map();
          this.d.products.forEach((p) => p.v.forEach((v) => this.V.set(String(v.id), { ...v, pid: String(p.id) })));
          const parse = (str) =>
            String(str || '')
              .split(/[,;]+/)
              .map((x) => x.trim().split(/\s*:\s*/))
              .map(([a, b]) => ({ q: parseInt(a, 10), p: parseFloat(String(b || '').replace(',', '.')) || 0 }))
              .filter((x) => x.q > 0)
              .sort((a, b) => a.q - b.q);
          this.tiers = parse(this.d.tiers);
          this.sizes = parse(this.d.sizes);
          if (!this.sizes.length) this.sizes = [{ q: 3, p: 0 }];
          this.size = this.sizes[0].q;
          this.min = Math.max(1, this.d.min || 1);
          this.units = [];
          this.inner = q('.werk-build-a-box_inner');
          this.panel = q('[data-panel]');
          this.side = q('.werk-build-a-box_side');
          this.sheet = q('.werk-build-a-box_sheet');
          this.btn = q('[data-submit]');
          this.cards = [...this.querySelectorAll('.werk-build-a-box_card')];
          this.speed = this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'keydown', (e) => {
            if (e.key === 'Escape' && this.pickEl) {
              const card = this.pickEl.closest('.werk-build-a-box_card');
              this.closePick();
              card?.querySelector('[data-card-add]:not([hidden]), [data-card-plus]')?.focus();
            }
          });
          on(document, 'pointerdown', (e) => {
            if (this.pickEl && !this.pickEl.contains(e.target) && !e.target.closest('[data-card-add], [data-card-plus], [data-card-media]')) this.closePick();
          });
          on(this.sheet, 'close', () => this.side.append(this.panel));
          on(this.sheet, 'click', (e) => e.target === this.sheet && this.closeSheet());
          on(this.sheet, 'click', (e) => this.dragged && (e.stopPropagation(), e.preventDefault(), (this.dragged = false)), { capture: true });
          on(this.sheet, 'pointerdown', (e) => this.dragStart(e));
          on(this.sheet, 'pointermove', (e) => this.dragMove(e));
          on(this.sheet, 'pointerup', (e) => this.dragEnd(e));
          on(this.sheet, 'pointercancel', (e) => this.dragEnd(e));
          on(window, 'resize', () => {
            if (this.sheet.open && getComputedStyle(this.side).display !== 'none') {
              this.sheet.close();
              this.side.append(this.panel);
            }
            this.dock();
          });
          on(window, 'scroll', () => this.dock(), { passive: true });
          this.dock();
          this.buildSizes();
          this.render();
        }

        // A theme bar fixed at the bottom (bottom nav, chat button row …) would cover the box bar: sit on top of it.
        dock() {
          if (this.dockRaf) return;
          this.dockRaf = requestAnimationFrame(() => {
            this.dockRaf = 0;
            if (!this.isConnected) return;
            let off = 0;
            if (this.sheetMode()) {
              // sample the strip the bar covers (floating docks keep a gap to the edge)
              for (const pt of [0.2, 0.5, 0.8].flatMap((x) => [4, 24, 48, 72].map((y) => [innerWidth * x, innerHeight - y]))) {
                for (const n of document.elementsFromPoint(pt[0], pt[1])) {
                  if (this.contains(n) || n === document.body || n === document.documentElement) continue;
                  let a = n;
                  while (a && a !== document.body && getComputedStyle(a).position !== 'fixed') a = a.parentElement;
                  if (a && a !== document.body) {
                    const r = a.getBoundingClientRect();
                    if (r.height < innerHeight / 3) off = Math.max(off, Math.ceil(innerHeight - r.top));
                  }
                  break;
                }
              }
            }
            if (off !== this.dockOff) {
              this.dockOff = off;
              this.inner.style.setProperty('--werk-dock', off + 'px');
            }
          });
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.dockRaf);
          this.ac?.abort();
          clearTimeout(this.tm);
          this.ghosts?.forEach((g) => g.remove());
          if (this.sheet?.open) this.sheet.close();
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        // ---------- helpers ----------
        // last one in the box: the minus becomes a bin
        static BIN = '<svg class="werk-build-a-box_bin" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2.5 4h11M6.5 4V2.5h3V4M4 4l.7 9.5h6.6L12 4M6.8 6.5v4.5M9.2 6.5v4.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        money(cents) {
          const f = (n, d, ts, ds) => {
            const [i, fr] = (n / 100).toFixed(d).split('.');
            return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (fr ? ds + fr : '');
          };
          const map = {
            amount: () => f(cents, 2, ',', '.'),
            amount_no_decimals: () => f(cents, 0, ',', '.'),
            amount_with_comma_separator: () => f(cents, 2, '.', ','),
            amount_no_decimals_with_comma_separator: () => f(cents, 0, '.', ','),
            amount_with_space_separator: () => f(cents, 2, ' ', ','),
            amount_no_decimals_with_space_separator: () => f(cents, 0, ' ', ','),
            amount_with_apostrophe_separator: () => f(cents, 2, "'", '.'),
          };
          // fallback built in pieces: two curly braces in a row would be read as Liquid
          return (this.d.money || '$' + '{' + '{amount}' + '}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (map[k] || map.amount)());
        }
        fill(str, vals) {
          return String(str || '').replace(/\[(\w+)\]/g, (m, k) => (k in vals ? vals[k] : m));
        }
        pct(p) {
          // decimal separator from the settings (default “,”); whole numbers have none
          return p ? this.fill(this.t.pct, { p: String(p).replace('.', this.t.dec || ',') }) : '';
        }
        esc(s) {
          return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
        }
        items(n) {
          return n === 1 ? this.t.countOne || this.fill(this.t.count, { n }) : this.fill(this.t.count, { n });
        }
        count(pid) {
          return this.units.filter((u) => u.pid === pid).length;
        }
        cap() {
          return this.fixed ? this.size : Infinity;
        }
        sheetMode() {
          return getComputedStyle(this.side).display === 'none';
        }
        calc() {
          const n = this.units.length;
          const sub = this.units.reduce((a, u) => a + (this.V.get(u.vid)?.p || 0), 0);
          let pct = 0;
          let next = null;
          if (this.fixed) {
            if (n >= this.size) pct = this.sizes.find((x) => x.q === this.size)?.p || 0;
          } else {
            for (const t of this.tiers) {
              if (n >= t.q) pct = t.p;
              else if (!next) next = t;
            }
          }
          const disc = Math.round((sub * pct) / 100);
          return { n, sub, pct, disc, total: sub - disc, next };
        }

        // ---------- actions ----------
        onClick(e) {
          const el = e.target.closest('button, a');
          if (!el || !this.contains(el)) return;
          const card = el.closest('.werk-build-a-box_card');
          const pid = card?.dataset.pid;
          if (el.matches('[data-card-media]')) {
            // a second tap on the image closes its picker; a full box, a sold-out product or (without duplicates) one already in the box does nothing
            if (this.pickEl && card.contains(this.pickEl)) return this.closePick();
            const p = this.P.get(pid);
            if (this.units.length >= this.cap() || !p.v.some((v) => v.a) || (!this.d.dup && this.count(pid))) return;
          }
          if (el.matches('[data-card-add], [data-card-plus], [data-card-media]')) {
            const p = this.P.get(pid);
            const avail = p.v.filter((v) => v.a);
            if (avail.length > 1) this.openPick(card);
            else if (avail.length) this.add(pid, String(avail[0].id), card);
          } else if (el.matches('[data-card-minus]')) {
            const i = this.units.map((u) => u.pid).lastIndexOf(pid);
            if (i > -1) this.removeAt(i);
          } else if (el.matches('[data-pick-val]')) {
            this.pickVid = el.dataset.pickVal;
            this.pickUpdate();
          } else if (el.matches('[data-pick-opt]')) {
            const i = +el.dataset.pickOpt;
            this.pickSel[i] = el.dataset.pickV;
            // a combination that isn't available: switch the other options to the first one that is
            const p = this.pickP;
            if (!p.v.some((x) => x.a && x.o.every((o, j) => o === this.pickSel[j]))) {
              const alt = p.v.find((x) => x.a && x.o[i] === el.dataset.pickV);
              if (alt) this.pickSel = [...alt.o];
            }
            this.pickUpdate();
          } else if (el.matches('[data-pick-add]')) {
            const vid = this.pickVid;
            const c = this.pickEl.closest('.werk-build-a-box_card');
            this.closePick();
            if (vid) this.add(c.dataset.pid, vid, c);
            c.querySelector('[data-card-plus]')?.focus();
          } else if (el.matches('[data-rm]')) {
            this.removeAt(+el.dataset.rm);
          } else if (el.matches('[data-line-minus]')) {
            const i = this.units.map((u) => u.vid).lastIndexOf(el.dataset.lineMinus);
            if (i > -1) this.removeAt(i);
          } else if (el.matches('[data-line-plus]')) {
            const v = this.V.get(el.dataset.linePlus);
            if (v) this.add(v.pid, el.dataset.linePlus, null);
          } else if (el.matches('[data-size]')) {
            this.size = +el.dataset.size;
            if (this.units.length > this.size) this.units.length = this.size;
            this.hideDone();
            this.buildSizes();
            this.render();
          } else if (el.matches('[data-submit]')) {
            this.submit();
          } else if (el.matches('[data-open]')) {
            this.sheet.style.animation = '';
            this.sheet.append(this.panel);
            this.sheet.showModal();
            // start focus on the box itself, not on the first button (iOS draws a focus ring on the handle otherwise)
            this.panel.tabIndex = -1;
            this.panel.focus({ preventScroll: true });
          } else if (el.matches('[data-close]')) {
            this.closeSheet();
          }
        }

        add(pid, vid, from) {
          if (this.units.length >= this.cap()) return;
          const v = this.V.get(vid);
          if (!v || !v.a) return;
          if (!this.d.dup && this.count(pid)) return;
          this.units.push({ pid, vid });
          this.hideDone();
          this.render({ from: from?.querySelector('.werk-build-a-box_img'), vid });
        }

        removeAt(i) {
          this.units.splice(i, 1);
          this.hideDone();
          this.render();
        }

        // "Added – you save …" (or an error) belongs to the last set: it goes as soon as the box changes
        hideDone() {
          const d = this.querySelector('[data-done]');
          if (!d || d.hidden) return;
          d.hidden = true;
          d.classList.remove('is-error');
        }

        // ---------- sheet: tap the handle, or drag the handle / head down to close ----------
        closeSheet(from = 0) {
          const sh = this.sheet;
          if (!sh.open || this.closing) return;
          // move the box back right away – the dialog's close event can come late
          const shut = () => {
            sh.close();
            this.side.append(this.panel);
          };
          if (!this.speed) return shut();
          this.closing = true;
          const a = sh.animate([{ translate: `0 ${from}px` }, { translate: '0 100%' }], { duration: 260, easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)', fill: 'forwards' });
          const done = () => {
            this.closing = false;
            shut();
            a.cancel();
          };
          a.finished.then(done, done);
        }
        dragStart(e) {
          if (!e.target.closest('.werk-build-a-box_grab, .werk-build-a-box_phead') || e.target.closest('.werk-build-a-box_x') || e.button) return;
          this.drag = { id: e.pointerId, y0: e.clientY, dy: 0, on: false, s: [{ y: e.clientY, t: e.timeStamp }] };
        }
        dragMove(e) {
          const d = this.drag;
          if (!d || e.pointerId !== d.id) return;
          d.dy = Math.max(0, e.clientY - d.y0);
          if (!d.on && d.dy > 6) {
            d.on = true;
            try {
              this.sheet.setPointerCapture(e.pointerId);
            } catch {}
            this.sheet.style.animation = 'none';
          }
          if (!d.on) return;
          d.s.push({ y: e.clientY, t: e.timeStamp });
          if (d.s.length > 5) d.s.shift();
          this.sheet.style.translate = `0 ${d.dy}px`;
        }
        dragEnd(e) {
          const d = this.drag;
          if (!d || e.pointerId !== d.id) return;
          this.drag = null;
          if (!d.on) return;
          this.dragged = true;
          setTimeout(() => (this.dragged = false), 0);
          const a = d.s[0];
          const b = d.s[d.s.length - 1];
          const v = b.t - a.t > 0 && e.timeStamp - b.t < 90 ? (b.y - a.y) / (b.t - a.t) : 0;
          this.sheet.style.translate = '';
          if (d.dy > 90 || v > 0.5) this.closeSheet(d.dy);
          else if (this.speed) this.sheet.animate([{ translate: `0 ${d.dy}px` }, { translate: '0 0' }], { duration: 320, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
        }

        // one list for products with one option, one row per option otherwise (Color · Size …)
        openPick(card) {
          this.closePick();
          const p = this.P.get(card.dataset.pid);
          const first = p.v.find((v) => v.a);
          const el = document.createElement('div');
          el.className = 'werk-build-a-box_pick';
          el.setAttribute('role', 'group');
          el.setAttribute('aria-label', this.t.choose + ': ' + p.t);
          el.dataset.lenisPrevent = '';
          this.pickP = p;
          this.pickVid = String(first.id);
          if ((p.on || []).length > 1) {
            this.pickSel = [...first.o];
            el.innerHTML =
              p.on
                .map((name, i) => {
                  const vals = [...new Set(p.v.map((v) => v.o[i]))];
                  return `<div class="werk-build-a-box_pgroup"><p class="werk-build-a-box_pick-lab">${this.esc(name)}</p><div class="werk-build-a-box_vals" role="radiogroup" aria-label="${this.esc(name)}">${vals
                    .map((x) => `<button type="button" class="werk-build-a-box_val" role="radio" data-pick-opt="${i}" data-pick-v="${this.esc(x)}">${this.esc(x)}</button>`)
                    .join('')}</div></div>`;
                })
                .join('') + `<button type="button" class="werk-build-a-box_pick-add" data-pick-add></button>`;
          } else {
            this.pickSel = null;
            el.innerHTML =
              (p.o ? `<p class="werk-build-a-box_pick-lab">${this.esc(p.o)}</p>` : '') +
              `<div class="werk-build-a-box_vals" role="radiogroup">${p.v
                .map((v) => `<button type="button" class="werk-build-a-box_val" role="radio" data-pick-val="${v.id}"${v.a ? '' : ' disabled'}>${this.esc(v.t)} · ${this.money(v.p)}</button>`)
                .join('')}</div><button type="button" class="werk-build-a-box_pick-add" data-pick-add></button>`;
          }
          card.querySelector('.werk-build-a-box_media').append(el);
          this.pickEl = el;
          this.pickUpdate();
          el.querySelector('[aria-checked="true"]')?.focus();
        }

        pickUpdate() {
          const p = this.pickP;
          const el = this.pickEl;
          if (this.pickSel) {
            const sel = this.pickSel;
            const v = p.v.find((x) => x.o.every((o, i) => o === sel[i]));
            this.pickVid = v && v.a ? String(v.id) : null;
            el.querySelectorAll('[data-pick-opt]').forEach((b) => {
              const i = +b.dataset.pickOpt;
              b.setAttribute('aria-checked', String(sel[i] === b.dataset.pickV));
              // crossed out when no available variant has it together with the other choices
              b.classList.toggle('is-out', !p.v.some((x) => x.a && x.o[i] === b.dataset.pickV && x.o.every((o, j) => j === i || o === sel[j])));
            });
          } else el.querySelectorAll('[data-pick-val]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.pickVal === this.pickVid)));
          const v = this.V.get(this.pickVid || '');
          const add = el.querySelector('[data-pick-add]');
          add.disabled = !v;
          add.textContent = v ? `${this.t.add} · ${this.money(v.p).replace(/<[^>]*>/g, '')}` : this.t.soldOut || '—';
        }

        closePick() {
          this.pickEl?.remove();
          this.pickEl = null;
        }

        // ---------- render ----------
        render(fly) {
          const T = this.t;
          const c = this.calc();
          const full = c.n >= this.cap();
          const active = document.activeElement;
          const key = this.contains(active) ? active.dataset.k : null;
          this.toggleAttribute('data-has', c.n > 0);

          // cards
          this.cards.forEach((card) => {
            const p = this.P.get(card.dataset.pid);
            if (!p) return;
            const n = this.count(card.dataset.pid);
            const out = !p.v.some((v) => v.a);
            card.classList.toggle('is-in', n > 0);
            card.classList.toggle('is-full', full && !n && !out);
            card.classList.toggle('is-out', out);
            card.classList.toggle('is-single', !this.d.dup);
            const badge = card.querySelector('.werk-build-a-box_badge');
            if (n) badge.textContent = this.d.dup ? `${T.inSet} · ${n}` : T.inSet;
            const add = card.querySelector('[data-card-add]');
            const step = card.querySelector('[data-card-step]');
            add.hidden = !!n || out || full;
            step.hidden = !n;
            card.querySelector('[data-card-full]').hidden = !(full && !n && !out);
            card.querySelector('[data-card-out]').hidden = !out;
            card.querySelector('[data-card-n]').textContent = n;
            const minus = card.querySelector('[data-card-minus]');
            const bin = n === 1;
            if (minus.dataset.bin !== String(bin)) {
              minus.dataset.bin = bin;
              minus.innerHTML = bin ? this.constructor.BIN : '−';
            }
            card.querySelector('[data-card-plus]').disabled = full || !this.d.dup;
            const multi = p.v.filter((v) => v.a).length > 1;
            card.querySelector('[data-add-text]').textContent = multi ? T.choose : T.add;
          });

          // head
          this.querySelector('[data-count]').textContent = this.fixed ? `${c.n} / ${this.size}` : this.items(c.n);

          // visual
          const vis = this.querySelector('[data-visual]');
          if (this.fixed) {
            const slots = [];
            for (let i = 0; i < this.size; i++) {
              const u = this.units[i];
              const no = String(i + 1).padStart(2, '0');
              if (u) {
                const p = this.P.get(u.pid);
                const v = this.V.get(u.vid);
                const name = p.t + (v.t ? ' · ' + v.t : '');
                slots.push(
                  `<div class="werk-build-a-box_slot"><div class="werk-build-a-box_tile is-filled" data-slot="${i}">${p.img ? `<img src="${this.esc(p.img)}" alt="">` : ''}<button type="button" class="werk-build-a-box_rm" data-rm="${i}" data-k="rm${i}" aria-label="${this.esc(T.remove + ': ' + name)}">×</button></div><span class="werk-build-a-box_cap">${this.esc(p.t)}</span></div>`
                );
              } else {
                slots.push(`<div class="werk-build-a-box_slot"><div class="werk-build-a-box_tile" data-slot="${i}"><b>+</b><i>${no}</i></div><span class="werk-build-a-box_cap is-empty">${this.esc(T.emptySlot)}</span></div>`);
              }
            }
            const bars = Array.from({ length: this.size }, (_, i) => `<i class="${i < c.n ? 'is-on' : ''}"></i>`).join('');
            vis.innerHTML = `<div class="werk-build-a-box_insert" style="--c: ${Math.min(this.size, 3)}">${slots.join('')}</div><div class="werk-build-a-box_bars">${bars}</div>`;
            vis.removeAttribute('aria-hidden');
          } else if (this.tiers.length) {
            const max = this.tiers[this.tiers.length - 1].q;
            if (!this.track) {
              const alt = this.tiers.length > 3;
              vis.innerHTML = `<div class="werk-build-a-box_track${alt ? ' has-up' : ''}"><span class="werk-build-a-box_line"></span><span class="werk-build-a-box_fill"></span><span class="werk-build-a-box_now"></span>${this.tiers
                .map((t, i) => `<span class="werk-build-a-box_tier${alt && i % 2 ? ' is-up' : ''}" style="--x: ${(t.q / max) * 100}%"><i></i><span>${t.q}${t.p ? ' · ' + this.esc(this.pct(t.p)) : ''}</span></span>`)
                .join('')}</div>`;
              this.track = vis.firstElementChild;
            }
            this.track.style.setProperty('--f', Math.min(c.n / max, 1).toFixed(4));
            this.track.querySelectorAll('.werk-build-a-box_tier').forEach((el, i) => el.classList.toggle('is-on', c.n >= this.tiers[i].q));
          } else vis.hidden = true;

          // hint
          let hint = '';
          // hints only talk about discounts – without a percentage the button already says what's missing
          if (this.fixed) {
            const sz = this.sizes.find((x) => x.q === this.size);
            if (c.n < this.size) hint = sz?.p ? this.fill(T.moreFixed, { n: this.size - c.n, pct: this.pct(sz.p) }) : '';
            else hint = this.fill(T.fullFixed, { pct: sz?.p ? this.pct(sz.p) : '' });
          } else if (c.next) hint = c.next.p ? this.fill(T.nextTier, { n: c.next.q - c.n, pct: this.pct(c.next.p) }) : '';
          else if (c.pct) hint = this.fill(T.bestTier, { pct: this.pct(c.pct) });
          this.querySelector('[data-hint]').textContent = hint.replace(/\s+·\s*$|\s+$/g, '').trim();

          // lines (Classic)
          if (!this.fixed) {
            const lines = [];
            this.units.forEach((u) => {
              const l = lines.find((x) => x.vid === u.vid);
              if (l) l.n++;
              else lines.push({ vid: u.vid, pid: u.pid, n: 1 });
            });
            this.querySelector('[data-lines]').innerHTML = lines
              .map((l) => {
                const p = this.P.get(l.pid);
                const v = this.V.get(l.vid);
                const meta = (v.t ? v.t + ' · ' : '') + this.money(v.p);
                return `<li class="werk-build-a-box_li" data-line="${l.vid}"><span class="werk-build-a-box_thumb">${p.img ? `<img src="${this.esc(p.img)}" alt="">` : ''}</span><span><span class="werk-build-a-box_lname">${this.esc(p.t)}</span><span class="werk-build-a-box_lmeta">${this.esc(meta)}</span></span><span class="werk-build-a-box_step"><button type="button" data-line-minus="${l.vid}" data-k="m${l.vid}" aria-label="${this.esc(T.remove + ': ' + p.t)}">${l.n === 1 ? this.constructor.BIN : '−'}</button><span class="werk-build-a-box_n">${l.n}</span><button type="button" data-line-plus="${l.vid}" data-k="p${l.vid}" aria-label="${this.esc(T.add + ': ' + p.t)}"${this.d.dup ? '' : ' disabled'}>+</button></span><span class="werk-build-a-box_lprice">${this.money(v.p * l.n)}</span></li>`;
              })
              .join('');
          }

          // summary
          this.querySelector('[data-sub]').innerHTML = this.money(c.sub);
          const dRow = this.querySelector('[data-disc-row]');
          const nextPct = this.fixed ? this.sizes.find((x) => x.q === this.size)?.p : c.next?.p;
          dRow.hidden = !c.pct && !nextPct;
          dRow.classList.toggle('is-muted', !c.pct);
          this.querySelector('[data-disc-label]').textContent = this.fill(T.discount, { pct: this.pct(c.pct || nextPct) });
          this.querySelector('[data-disc]').innerHTML = c.pct ? '− ' + this.money(c.disc) : this.esc(this.fill(T.discountAt, { n: this.fixed ? this.fill(T.size, { n: this.size }) : this.fill(T.count, { n: c.next?.q || '' }) }));
          this.querySelector('[data-strike]').innerHTML = c.disc ? this.money(c.sub) : '';
          this.querySelector('[data-total]').innerHTML = this.money(c.total);

          // button
          const ready = this.fixed ? c.n === this.size : c.n >= this.min;
          const need = (this.fixed ? this.size : this.min) - c.n;
          if (!this.btn.dataset.state) this.btn.disabled = !ready;
          let label;
          if (ready) label = this.fill(this.fixed ? T.btnFixed : T.btnClassic, { n: c.n });
          else if (!c.n) label = this.fill(T.empty, { n: this.fixed ? this.size : this.tiers[0]?.q || this.min });
          else label = this.fill(need === 1 ? T.needOne : T.need, { n: need });
          this.querySelector('[data-btn-label]').textContent = label;
          this.querySelector('[data-btn-price]').innerHTML = this.money(c.total);

          // tray
          const max = this.fixed ? this.size : this.tiers.length ? this.tiers[this.tiers.length - 1].q : Math.max(c.n, 1);
          this.querySelector('[data-edge]').style.setProperty('--f', Math.min(c.n / max, 1).toFixed(4));
          const last = this.units.slice(-3).reverse();
          this.querySelector('[data-thumbs]').innerHTML = (last.length ? last : [null]).map((u) => `<span>${u && this.P.get(u.pid).img ? `<img src="${this.esc(this.P.get(u.pid).img)}" alt="">` : ''}</span>`).join('');
          this.querySelector('[data-tray-a]').textContent = (this.fixed ? `${c.n} / ${this.size}` : this.items(c.n)) + (c.pct ? ' · ' + this.pct(c.pct) : '');
          this.querySelector('[data-tray-b]').innerHTML = this.money(c.total);

          if (key) this.querySelector(`[data-k="${key}"]`)?.focus();
          else if (this.contains(active) && active.closest('[hidden]')) {
            // the focused card button was swapped (add ↔ stepper): keep the focus on the card
            active.closest('.werk-build-a-box_card')?.querySelector('[data-card-step]:not([hidden]) [data-card-plus]:not(:disabled), [data-card-step]:not([hidden]) [data-card-minus], [data-card-add]:not([hidden])')?.focus();
          }
          if (fly?.from && this.speed) this.fly(fly.from, fly.vid);
        }

        buildSizes() {
          const box = this.querySelector('[data-sizes]');
          if (!this.fixed || this.sizes.length < 2) return void (box.hidden = true);
          box.hidden = false;
          box.innerHTML = this.sizes
            .map(
              (s) =>
                `<button type="button" class="werk-build-a-box_size" role="radio" data-size="${s.q}" aria-checked="${s.q === this.size}">${this.esc(this.fill(this.t.size, { n: s.q }))}${s.p ? `<small>${this.esc(this.pct(s.p))}</small>` : ''}</button>`
            )
            .join('');
        }

        // ---------- the image flies into its compartment / line / the bar ----------
        fly(from, vid) {
          let to;
          if (this.sheetMode() && !this.sheet.open) to = this.querySelector('[data-thumbs] span');
          else if (this.fixed) to = this.querySelector(`[data-slot="${this.units.length - 1}"]`);
          else to = this.querySelector(`[data-line="${vid}"] .werk-build-a-box_thumb`);
          if (!to) return;
          const a = from.getBoundingClientRect();
          const b = to.getBoundingClientRect();
          if (!a.width || !b.width || b.bottom < 0 || b.top > innerHeight) return;
          const g = document.createElement('img');
          g.src = from.currentSrc || from.src;
          g.alt = '';
          g.className = 'werk-build-a-box_ghost';
          Object.assign(g.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
          this.inner.append(g);
          (this.ghosts ||= new Set()).add(g);
          const ease = getComputedStyle(this.inner).getPropertyValue('--werk-ease').trim() || 'ease';
          to.style.opacity = '0';
          const anim = g.animate(
            [
              { transform: 'translate(0, 0) scale(1, 1)', opacity: 1 },
              { transform: `translate(${b.left - a.left}px, ${b.top - a.top}px) scale(${b.width / a.width}, ${b.height / a.height})`, opacity: 1 },
            ],
            { duration: 560, easing: ease }
          );
          const end = () => {
            g.remove();
            this.ghosts.delete(g);
            to.style.opacity = '';
          };
          anim.finished.then(() => {
            end();
            to.animate([{ scale: 0.9 }, { scale: 1 }], { duration: 320, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' });
          }, end);
        }

        // ---------- add the whole set to the cart ----------
        async submit() {
          const btn = this.btn;
          if (btn.dataset.state || btn.disabled) return;
          const done = this.querySelector('[data-done]');
          done.hidden = true;
          done.classList.remove('is-error');
          btn.dataset.state = 'loading';
          const id = Math.random().toString(36).slice(2, 6).toUpperCase();
          const items = [];
          this.units.forEach((u) => {
            const it = items.find((x) => String(x.id) === u.vid);
            if (it) it.quantity++;
            else items.push({ id: +u.vid, quantity: 1, properties: { _set: id } });
          });
          const finish = (saved) => {
            btn.dataset.state = 'added';
            clearTimeout(this.tm);
            this.tm = setTimeout(() => {
              delete btn.dataset.state;
              this.units = [];
              this.render();
              done.innerHTML = this.esc(saved ? this.fill(this.t.saved, { amount: '__A__' }) : this.t.added).replace('__A__', saved ? this.money(saved) : '') + ` <a href="${this.esc(this.d.cart)}">${this.esc(this.t.viewCart)}</a>`;
              done.hidden = false;
            }, 1400);
          };
          try {
            if (this.d.demo) {
              await new Promise((r) => setTimeout(r, 700));
              finish(this.calc().disc);
              return;
            }
            const root = window.Shopify?.routes?.root || '/';
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            const cartP = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: items.map((x) => ({ merchandiseId: x.id, quantity: x.quantity })),
              promise: cartP.then((cc) => ({ cart: { totalQuantity: cc.item_count }, detail: { itemCount: cc.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart(root);
            const cart = await cartP.catch(() => null);
            // what Shopify really took off for this set's lines (automatic discounts)
            const saved = cart ? cart.items.filter((x) => x.properties?._set === id).reduce((a, x) => a + (x.original_line_price - x.final_line_price), 0) : 0;
            finish(saved);
          } catch (err) {
            delete btn.dataset.state;
            done.textContent = this.fill(this.t.error, { message: err?.description || err?.message || '' }).trim();
            done.classList.add('is-error');
            done.hidden = false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-burst-loader"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('werk-burst-loader')) {
    // cubic-bezier as a function (Newton steps), for the rAF timeline
    const bezier = (x1, y1, x2, y2) => {
      const cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx;
      const cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
      const sx = (t) => ((ax * t + bx) * t + cx) * t;
      const sy = (t) => ((ay * t + by) * t + cy) * t;
      const dx = (t) => (3 * ax * t + 2 * bx) * t + cx;
      return (x) => {
        if (x <= 0) return 0;
        if (x >= 1) return 1;
        let t = x;
        for (let i = 0; i < 8; i++) {
          const e = sx(t) - x;
          if (Math.abs(e) < 1e-5) break;
          const d = dx(t);
          if (Math.abs(d) < 1e-6) break;
          t -= e / d;
        }
        return sy(Math.min(1, Math.max(0, t)));
      };
    };
    const EASES = {
      signature: [0.6234, 0.058, 0, 0.9095],
      smooth: [0.38, 0.005, 0.215, 1],
      bounce: [0.35, 1.5, 0.6, 1],
      snap: [0.16, 1, 0.3, 1],
      glide: [0.76, 0, 0.24, 1],
    };
    const easeOut = bezier(0.16, 1, 0.3, 1); // tiles pop in
    const easeIn = bezier(0.55, 0, 0.8, 0.2); // exit: fast out
    const clamp01 = (v) => Math.min(1, Math.max(0, v));
    const seg = (t, a, b) => clamp01((t - a) / (b - a));

    // shapes: inside test in normalised coordinates (-1 … 1, y down) and their width : height
    const SHAPES = {
      cloud: [1.25, (x, y) => {
        const b = (cx, cy, r) => (x - cx) ** 2 / (r * 1.25) ** 2 + (y - cy) ** 2 / r ** 2 < 1;
        return b(0, 0.05, 0.62) || b(-0.48, 0.18, 0.42) || b(0.5, 0.15, 0.44) || b(-0.15, -0.32, 0.4) || b(0.28, -0.25, 0.38);
      }],
      circle: [1, (x, y) => x * x + y * y < 0.8],
      pill: [1.6, (x, y) => { const d = Math.max(Math.abs(x) - 0.53, 0); return d * d + y * y < 0.1764; }],
      star: [1, (x, y) => {
        const a = Math.atan2(y, x) + Math.PI / 2;
        return Math.hypot(x, y) < 0.4 + 0.55 * Math.pow((Math.cos(5 * a) + 1) / 2, 1.6);
      }],
      heart: [1, (x, y) => { const X = x * 1.25, Y = -(y * 1.25) + 0.25; return (X * X + Y * Y - 1) ** 3 - X * X * Y ** 3 < 0; }],
    };

    // seeded random: the same shape always gets the same layout
    const rng = (seed) => () => {
      seed = (seed + 0x6d2b79f5) | 0;
      let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };

    // fill a shape densely: jittered hex grid, keep the points inside, centre first
    const layout = (shape, count) => {
      const inside = SHAPES[shape][1];
      const R = rng(7 + shape.length);
      const pts = [];
      for (let step = 0.34; pts.length < count && step > 0.05; step *= 0.9) {
        pts.length = 0;
        for (let row = 0, y = -1; y <= 1; y += step * 0.87, row++) {
          for (let x = -1 + ((row % 2) * step) / 2; x <= 1; x += step) {
            const jx = x + (R() - 0.5) * step * 0.7, jy = y + (R() - 0.5) * step * 0.7;
            if (inside(jx, jy)) pts.push({ x: jx, y: jy });
          }
        }
      }
      pts.sort((a, b) => a.x * a.x + a.y * a.y - (b.x * b.x + b.y * b.y));
      pts[0] = { x: 0, y: 0 }; // the top picture sits dead centre
      return pts.slice(0, count);
    };

    // timeline in ms at speed 100 %
    const T = { flash: 1150, zoom: 2150, burst: 2500, end: 3300 };
    const FLASH = 9; // pictures in the flash (~130 ms each)
    const RATIO = 1.24; // tile height : width

    customElements.define(
      'werk-burst-loader',
      class extends HTMLElement {
        connectedCallback() {
          this.box = this.querySelector('.werk-burst-loader_inner');
          this.stage = this.querySelector('.werk-burst-loader_stage');
          this.bg = this.querySelector('.werk-burst-loader_bg');
          this.countEl = this.querySelector('.werk-burst-loader_count');
          this.logoEl = this.querySelector('.werk-burst-loader_logo');
          try {
            this.data = JSON.parse(this.querySelector('script[data-werk]').textContent);
          } catch (e) {
            this.data = { pictures: [] };
          }
          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el.addEventListener(type, fn, { signal: ac.signal, ...o });
          on(this.box, 'click', () => this.skip());
          on(document, 'keydown', (e) => e.key === 'Escape' && this.skip());
          on(window, 'resize', () => this.raf && this.measure(), { passive: true });
          // the top layer stacks in opening order: a theme popover opened later (a nav dock, a drawer) would sit above
          // the intro – while it plays, step back on top
          on(document, 'toggle', (e) => e.target !== this.box && e.newState === 'open' && this.classList.contains('is-on') && this.raise(), { capture: true });

          if (window.Shopify?.designMode) {
            // editor: never on its own (it would block editing) – on select, and after a change while selected
            const mine = (e) => e.detail?.sectionId === this.dataset.section;
            on(document, 'shopify:section:select', (e) => mine(e) && this.play());
            on(document, 'shopify:section:deselect', (e) => mine(e) && this.finish());
            if (document.readyState === 'complete') this.play();
            return;
          }
          if (this.classList.contains('is-on')) this.play();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.stop();
          try { this.box.hidePopover(); } catch (e) {}
        }

        stop() {
          cancelAnimationFrame(this.raf);
          clearTimeout(this.timer);
          this.raf = 0;
          this.run = (this.run || 0) + 1; // invalidates a play() still waiting for pictures
        }

        show() {
          this.classList.add('is-on');
          this.classList.remove('is-leaving');
          this.raise();
        }

        // (re)open the overlay as the newest top-layer element – hide + show in one task, so nothing paints between
        raise() {
          try {
            if (this.box.matches(':popover-open')) this.box.hidePopover();
            this.box.showPopover();
          } catch (e) {
            this.box.classList.add('is-fallback');
          }
        }

        finish() {
          this.stop();
          this.classList.remove('is-on', 'is-leaving');
          try { this.box.hidePopover(); } catch (e) {}
          this.stage.replaceChildren();
          this.tiles = [];
        }

        skip() {
          if (this.dataset.skip === 'false' || !this.classList.contains('is-on')) return;
          if (this.still) return this.finish();
          if (!this.raf) return; // still loading: the timeline starts at the burst
          const t = (performance.now() - this.start) * this.speed;
          if (t < T.burst) this.start = performance.now() - T.burst / this.speed;
        }

        async play() {
          this.stop();
          const run = this.run;
          this.show();
          this.stage.replaceChildren();
          this.bg.style.opacity = 1;
          if (this.logoEl) this.logoEl.style.opacity = 1;
          if (this.countEl) (this.countEl.style.opacity = 1), (this.countEl.textContent = '000');

          this.speed = Math.max(0.5, (+this.dataset.speed || 100) / 100);
          this.still = this.dataset.motion === 'off' || matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          if (this.still) return this.calm(run);

          const e = EASES[this.dataset.ease] || EASES.signature;
          this.ease = bezier(...e);
          const pics = this.data.pictures || [];
          if (!pics.length) return this.finish();
          // load (and key) every picture first, at most 1.5 s – late ones fill in as they arrive
          this.sources = pics.map((p) => ({ ...p, ready: null }));
          const loads = this.sources.map((p) => this.load(p));
          await Promise.race([Promise.all(loads), new Promise((r) => (this.timer = setTimeout(r, 1500)))]);
          if (run !== this.run || !this.isConnected) return;
          this.build();
          this.start = performance.now();
          this.raf = requestAnimationFrame((n) => this.frame(n));
        }

        // reduced motion / animations off: logo and counter for a moment, then a short fade
        calm(run) {
          if (this.countEl) this.countEl.textContent = '100';
          this.timer = setTimeout(() => {
            if (run !== this.run) return;
            this.classList.add('is-leaving');
            this.box.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 400, fill: 'forwards' }).finished.then(
              () => run === this.run && (this.finish(), this.box.getAnimations().forEach((a) => a.cancel())),
              () => {}
            );
          }, 500);
        }

        // one picture → an image (cut-out: white keyed to transparent once, so every tile stays fully opaque)
        load(p) {
          const cut = this.dataset.picture !== 'card';
          const get = (cors) =>
            new Promise((resolve, reject) => {
              const im = new Image();
              if (cors) im.crossOrigin = 'anonymous';
              im.decoding = 'async';
              im.onload = () => resolve(im);
              im.onerror = reject;
              im.src = p.u;
            });
          return get(true)
            .then((im) => {
              if (!cut) return (p.ready = im);
              const c = document.createElement('canvas');
              c.width = im.naturalWidth;
              c.height = im.naturalHeight;
              const x = c.getContext('2d', { willReadFrequently: true });
              x.drawImage(im, 0, 0);
              const d = x.getImageData(0, 0, c.width, c.height);
              const a = d.data;
              // whiteness = darkest channel; from 97 % fully transparent, up to 90 % fully opaque
              const HI = 0.97 * 255, LO = 0.9 * 255;
              for (let i = 0; i < a.length; i += 4) {
                const m = Math.min(a[i], a[i + 1], a[i + 2]);
                if (m >= HI) a[i + 3] = 0;
                else if (m > LO) a[i + 3] = Math.round((255 * (HI - m)) / (HI - LO));
              }
              x.putImageData(d, 0, 0);
              return (p.ready = c);
            })
            .catch(() =>
              // no CORS on that server: draw it as it is, with multiply
              get(false).then((im) => ((p.raw = cut), (p.ready = im)), () => (p.ready = false))
            )
            .then(() => this.tiles?.forEach((t) => t.src === p && this.draw(t)));
        }

        build() {
          const shape = SHAPES[this.dataset.shape] ? this.dataset.shape : 'cloud';
          const count = Math.min(80, Math.max(8, +this.dataset.count || 56));
          const pts = layout(shape, count);
          const R = rng(42);
          const n = this.sources.length;
          // shuffle the order once so repeats don't sit next to each other
          const order = this.sources.map((_, i) => i).sort(() => R() - 0.5);
          const frag = document.createDocumentFragment();
          this.tiles = pts.map((p, i) => {
            const el = document.createElement('div');
            el.className = 'werk-burst-loader_tile';
            const canvas = document.createElement('canvas');
            el.appendChild(canvas);
            frag.appendChild(el);
            return { el, canvas, p, d: Math.hypot(p.x, p.y), s: 0.82 + R() * 0.36, delay: R(), spin: (R() - 0.5) * 40, src: this.sources[order[i % n]] };
          });
          // the top picture swaps through the flash, then twice more while the cloud settles
          this.hero = this.tiles[0];
          this.hero.s = 1.15;
          this.hero.el.style.zIndex = 1000;
          this.tiles.slice(1).forEach((t) => (t.el.style.zIndex = Math.round(R() * 100)));
          this.flash = Array.from({ length: FLASH + 3 }, (_, i) => this.sources[order[(i * 5 + 3) % n]]);
          this.hero.src = this.flash[0];
          this.stage.appendChild(frag);
          this.shape = shape;
          this.measure();
        }

        measure() {
          const w = this.box.clientWidth || innerWidth;
          const h = this.box.clientHeight || innerHeight;
          const m = Math.min(w, h);
          const asp = SHAPES[this.shape][0];
          const halfH = m * 0.4;
          const halfW = Math.min(w * 0.42, halfH * asp);
          const t = Math.max(48, m * 0.12); // tile width
          const flashScale = (h * 0.46) / (t * RATIO * this.hero.s);
          const dpr = Math.min(devicePixelRatio || 1, 2);
          this.stage.style.setProperty('--t', t + 'px');
          this.geo = { halfW, halfH, flashScale, far: Math.hypot(w, h) };
          // canvas size: tiles at their own size, the top picture big enough for the flash
          this.tiles.forEach((tile, i) => {
            const cw = Math.ceil(t * tile.s * dpr * (i === 0 ? flashScale : 1));
            tile.canvas.width = Math.min(cw, 960);
            tile.canvas.height = Math.round(tile.canvas.width * RATIO);
            this.draw(tile);
          });
        }

        // draw a tile's picture into its canvas: cut-outs fit in, cards fill (cover)
        draw(tile) {
          const c = tile.canvas;
          const x = c.getContext('2d');
          x.clearRect(0, 0, c.width, c.height);
          const src = tile.src;
          tile.el.classList.toggle('is-raw', !!src.raw);
          this.aiTag(tile);
          const im = src.ready;
          if (!im) return;
          const iw = im.naturalWidth || im.width, ih = im.naturalHeight || im.height;
          const fit = this.dataset.picture === 'card' ? Math.max : Math.min;
          const k = fit(c.width / iw, c.height / ih);
          const dw = iw * k, dh = ih * k;
          x.imageSmoothingQuality = 'high';
          x.drawImage(im, (c.width - dw) / 2, (c.height - dh) / 2, dw, dh);
        }

        // AI label (EU AI Act) on own pictures that ask for one; tiles are small, so only the (i)
        aiTag(tile) {
          const pos = tile.src.ai;
          let tag = tile.el.querySelector('.werk-burst-loader_aitag');
          if (!pos || !this.data.label) return tag?.remove();
          if (!tag) {
            tag = document.createElement('span');
            tag.className = 'werk-burst-loader_aitag';
            tag.setAttribute('data-mini', '');
            tag.innerHTML = '<i aria-hidden="true">i</i><span></span>';
            tile.el.appendChild(tag);
          }
          tag.dataset.pos = pos;
          tag.lastChild.textContent = this.data.label;
        }

        frame(now) {
          if (!this.isConnected) return;
          // the first rAF timestamp can sit a hair before start (it is the frame's start time) – never below 0
          const t = Math.max(0, (now - this.start) * this.speed);
          const { halfW, halfH, flashScale, far } = this.geo;

          // camera: close during the flash, then pulls back to 1
          const cam = flashScale + (1 - flashScale) * this.ease(seg(t, T.flash, T.zoom));
          this.stage.style.transform = `scale(${cam})`;

          // the top picture: fast during the flash, then twice more
          const idx = t < T.flash ? Math.floor(t / (T.flash / FLASH)) : FLASH + Math.min(2, Math.floor((t - T.flash) / 380));
          const src = this.flash[Math.min(idx, this.flash.length - 1)];
          if (this.hero.src !== src) (this.hero.src = src), this.draw(this.hero);

          const bp = t - T.burst;
          for (let i = 0; i < this.tiles.length; i++) {
            const tile = this.tiles[i];
            const { p, d, s } = tile;
            const x = p.x * halfW, y = p.y * halfH;
            let op, sc, tx = x, ty = y, rot = 0;
            if (i === 0) {
              op = 1;
              sc = s;
            } else {
              // pops in from the centre outward while the camera pulls back, drifting slightly into place
              const a = T.flash + 80 + d * 700 + tile.delay * 120;
              const k = easeOut(seg(t, a, a + 360));
              op = k;
              sc = s * (0.4 + 0.6 * k);
              tx = x * (0.85 + 0.15 * k);
              ty = y * (0.85 + 0.15 * k);
            }
            if (bp > 0) {
              // burst: the outside leaves first, every tile flies off along its own ray from the centre
              const len = d || 1e-4;
              const ux = (p.x || 1e-4) / len, uy = (p.y || -1) / len;
              const lag = (1 - Math.min(d, 1)) * 140 + tile.delay * 60;
              const k = easeIn(seg(bp, lag, lag + 520));
              tx += ux * far * 0.9 * k;
              ty += uy * far * 0.9 * k;
              rot = tile.spin * k;
              sc *= 1 + 0.25 * k;
              if (i === 0) {
                const kh = easeIn(seg(bp, 120, 520));
                sc = s * (1 - 0.9 * kh);
                op = 1 - kh;
              }
            }
            tile.el.style.opacity = op;
            tile.el.style.transform = `translate3d(${tx}px, ${ty}px, 0) rotate(${rot}deg) scale(${sc})`;
          }

          // the background fades while the burst clears, logo and counter go first
          if (bp > 0 && !this.classList.contains('is-leaving')) this.classList.add('is-leaving');
          this.bg.style.opacity = 1 - seg(bp, 260, 760);
          const top = 1 - seg(bp, 0, 300);
          if (this.logoEl) this.logoEl.style.opacity = top;
          if (this.countEl) {
            this.countEl.style.opacity = top;
            this.countEl.textContent = String(Math.round(100 * clamp01(t / T.burst))).padStart(3, '0');
          }

          if (t >= T.end) return this.finish();
          this.raf = requestAnimationFrame((n) => this.frame(n));
        }

        // theme colours: the background and text colour of the page around the section
        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-collection-trail"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  // werk options · the moving parts of the option presets (src/_shared/werk-options.css). Glide: one indicator per group
  // (.werk-collection-trail_opts) glides to the new choice – the leading edge first, the trailing one follows (clip-path or translate,
  // WAAPI). Ink drop: the ink floods in from the click point and drains from the old choice towards the new one; a light
  // follows the cursor on light grounds (data-opt-tone); thumbs get an ink bar along their foot. Sections set ARIA as usual – a MutationObserver picks
  // every change up, nothing else to call. werkOptions(root, prefix, signal) – once per section instance.
  window.werkOptions ||= (root, p, signal) => {
    const SEL = '[aria-checked="true"],[aria-pressed="true"],[aria-current="true"]';
    const on = (el) => el.matches(SEL);
    const preset = () => root.dataset.opt || '';
    const css = (name, fb) => getComputedStyle(root).getPropertyValue(name).trim() || fb;
    const speed = () => {
      const s = parseFloat(css('--werk-speed', '1'));
      return Number.isFinite(s) ? s : 1;
    };
    const ease = () => css('--werk-ease', 'cubic-bezier(0.6234, 0.058, 0, 0.9095)');
    const groups = () => [...root.querySelectorAll(`.${p}_opts`)];
    const items = (g) => [...g.children].filter((el) => el.classList.contains(`${p}_opt`));
    const shapeOf = (el) => ({ swatch: 'ring', thumb: 'ring', value: 'line', row: 'row' })[el.dataset.kind] || 'fill';
    const last = new WeakMap(); // group → control the indicator stands on
    const tap = new WeakMap(); // control → last pointer point inside it

    // ---------- glide ----------
    const box = (g, el) => {
      const a = g.getBoundingClientRect(), b = el.getBoundingClientRect();
      const r = { l: b.left - a.left, t: b.top - a.top, r: b.right - a.left, b: b.bottom - a.top, w: b.width, h: b.height };
      if (shapeOf(el) === 'line') r.t = r.b - 2;
      if (shapeOf(el) === 'ring') {
        const o = 4;
        Object.assign(r, { l: r.l - o, t: r.t - o, r: r.r + o, b: r.b + o, w: r.w + 2 * o, h: r.h + 2 * o });
      }
      return r;
    };
    const radius = (el) => {
      const k = shapeOf(el);
      if (k === 'line') return 1;
      const r = parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0;
      return k === 'ring' ? (el.dataset.kind === 'swatch' ? 999 : r + 4) : r;
    };
    const clip = (g, r, rad) => `inset(${r.t}px ${g.clientWidth - r.r}px ${g.clientHeight - r.b}px ${r.l}px round ${rad}px)`;
    const indOf = (g) => {
      let ind = g.querySelector(`:scope > .${p}_opt-ind`);
      if (!ind) {
        ind = document.createElement('span');
        ind.className = `${p}_opt-ind`;
        ind.setAttribute('aria-hidden', 'true');
        g.prepend(ind);
      }
      return ind;
    };
    const place = (g, el, from) => {
      const ind = indOf(g), k = shapeOf(el), b = box(g, el), rad = radius(el);
      ind.dataset.shape = k;
      ind.getAnimations().forEach((a) => a.cancel());
      if (k === 'row') ind.style.setProperty('--ind-cy', `${(b.t + b.b) / 2 - 10}px`);
      if (k === 'ring') {
        ind.style.setProperty('--ind-w', `${b.w}px`);
        ind.style.setProperty('--ind-h', `${b.h}px`);
        ind.style.setProperty('--ind-r', `${rad}px`);
        ind.style.setProperty('--ind-x', `${b.l}px`);
        ind.style.setProperty('--ind-y', `${b.t}px`);
      } else ind.style.setProperty('--ind-clip', clip(g, b, rad));
      g.classList.add('has-ind');
      if (!from || from === el || !speed()) return;
      const a = box(g, from), d = 460 * speed();
      if (k === 'ring') {
        const dx = a.l - b.l, dy = a.t - b.t;
        ind.animate(
          [{ translate: `${a.l}px ${a.t}px`, scale: '1' }, { scale: '0.86', offset: 0.45 }, { translate: `${b.l}px ${b.t}px`, scale: '1' }],
          { duration: d, easing: ease() }
        );
        return;
      }
      // leading edge first: the edge on the side of travel runs ahead, the other one follows
      const mid = {};
      for (const [lo, hi] of [['l', 'r'], ['t', 'b']]) {
        const fwd = b[lo] >= a[lo];
        const lead = fwd ? hi : lo, trail = fwd ? lo : hi;
        mid[lead] = a[lead] + (b[lead] - a[lead]) * 0.82;
        mid[trail] = a[trail] + (b[trail] - a[trail]) * 0.22;
      }
      ind.animate([{ clipPath: clip(g, a, radius(from)) }, { clipPath: clip(g, mid, rad), offset: 0.42 }, { clipPath: clip(g, b, rad) }], {
        duration: d,
        easing: ease(),
      });
    };
    const sync = (g, animate) => {
      if (preset() !== 'glide') return g.classList.remove('has-ind');
      const el = items(g).find(on);
      if (!el) return g.classList.remove('has-ind');
      place(g, el, animate ? last.get(g) : null);
      last.set(g, el);
    };

    // ---------- ink drop ----------
    const reach = (el, x, y) => Math.hypot(Math.max(x, el.offsetWidth - x), Math.max(y, el.offsetHeight - y)) + 2;
    const toward = (el, other) => {
      // the point on el's edge facing the other control
      const a = el.getBoundingClientRect(), b = other.getBoundingClientRect();
      const cx = Math.min(Math.max(b.left + b.width / 2, a.left), a.right) - a.left;
      const cy = Math.min(Math.max(b.top + b.height / 2, a.top), a.bottom) - a.top;
      return [cx, cy];
    };
    const ink = (el, open, at) => {
      if (preset() !== 'ink' || !speed() || el.dataset.kind === 'swatch') return;
      const w = el.offsetWidth, [x, y] = at || [w / 2, el.offsetHeight / 2];
      const r = reach(el, x, y);
      // thumbs: a bar along the foot runs out from the click; everything else: a circle of ink
      const [big, none] = el.dataset.kind === 'thumb'
        ? ['inset(0px 0px 0px 0px)', `inset(0px ${w - x}px 0px ${x}px)`]
        : [`circle(${r}px at ${x}px ${y}px)`, `circle(0px at ${x}px ${y}px)`];
      // bigger controls take longer, so a wide row doesn't flood in a blink
      const d = Math.min(380 + r * 1.8, 900) * (open ? 1 : 0.68) * speed();
      el.animate(
        { clipPath: open ? [none, big] : [big, none], opacity: [1, 1] },
        { pseudoElement: '::after', duration: d, easing: open ? 'cubic-bezier(0.16, 1, 0.3, 1)' : 'cubic-bezier(0.55, 0, 0.8, 0.2)' }
      );
    };

    // ---------- watch ARIA ----------
    const mo = new MutationObserver((list) => {
      const seen = new Set();
      for (const m of list) {
        const el = m.target;
        if (!el.classList?.contains(`${p}_opt`) || seen.has(el)) continue;
        seen.add(el);
        const g = el.parentElement?.classList.contains(`${p}_opts`) ? el.parentElement : null;
        if (on(el)) {
          const prev = g && last.get(g);
          if (preset() === 'ink') {
            ink(el, true, tap.get(el) || (prev && prev !== el ? toward(el, prev) : null));
            if (prev && prev !== el) ink(prev, false, toward(prev, el));
          }
          if (g) {
            if (preset() === 'glide') sync(g, true);
            else last.set(g, el);
          }
        } else if (!g) ink(el, false, tap.get(el));
        tap.delete(el);
      }
    });
    mo.observe(root, { subtree: true, attributes: true, attributeFilter: ['aria-checked', 'aria-pressed', 'aria-current'] });
    signal?.addEventListener('abort', () => mo.disconnect());

    // ---------- pointer: click point, light ----------
    const pt = (el, e) => {
      const r = el.getBoundingClientRect();
      return [e.clientX - r.left, e.clientY - r.top, r];
    };
    root.addEventListener('pointerdown', (e) => {
      const el = e.target.closest?.(`.${p}_opt`);
      if (el) tap.set(el, pt(el, e).slice(0, 2));
    }, { signal });
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    root.addEventListener('pointermove', (e) => {
      if (!fine.matches || preset() !== 'ink') return;
      const el = e.target.closest?.(`.${p}_opt`);
      if (!el) return;
      const [x, y] = pt(el, e);
      el.style.setProperty('--mx', `${x}px`);
      el.style.setProperty('--my', `${y}px`);
    }, { signal });

    // ---------- keep indicators in place ----------
    // light or dark ground from the paper colour's luminance (theme colours can be anything)
    const probe = document.createElement('i');
    probe.setAttribute('aria-hidden', 'true');
    const tone = () => {
      probe.style.cssText = 'position:absolute;width:0;height:0;color:var(--opt-paper)';
      root.append(probe);
      const [r, g, b] = (getComputedStyle(probe).color.match(/[\d.]+/g) || [255, 255, 255]).map(Number);
      probe.remove();
      const t = 0.2126 * r + 0.7152 * g + 0.0722 * b < 128 ? 'dark' : 'light';
      if (root.dataset.optTone !== t) root.dataset.optTone = t;
    };
    const all = () => {
      tone();
      groups().forEach((g) => sync(g, false));
    };
    const ro = new ResizeObserver(() => requestAnimationFrame(all));
    groups().forEach((g) => ro.observe(g));
    signal?.addEventListener('abort', () => ro.disconnect());
    const mp = new MutationObserver(all);
    mp.observe(root, { attributes: true, attributeFilter: ['data-opt', 'class', 'style'] });
    signal?.addEventListener('abort', () => mp.disconnect());
    document.fonts?.ready.then(all);
    all();
    return { refresh: all };
  };
  if (!customElements.get('werk-collection-trail')) {
    // Trail shapes in design pixels (Figma frames: desktop 1440 × 900, tablet 768 × 1024, phone 390 × 844).
    // Each shape is a chain of cubic curves; the stop is the middle of the chain (by length). Tablet and phone
    // only map the part above the dock (dt = design y of the dock top), so the trail never runs under it.
    const PATHS = {
      desktop: {
        s_curve: [[[1600, -80], [1300, -70], [1080, 200], [900, 450]], [[900, 450], [740, 670], [650, 900], [700, 1200]]],
        arc: [[[1580, 180], [1250, 40], [1000, 200], [860, 450]], [[860, 450], [720, 700], [880, 980], [1100, 1120]]],
        wave: [[[1560, 300], [1350, 80], [1150, 620], [900, 450]], [[900, 450], [700, 300], [640, 760], [760, 1120]]],
      },
      tablet: {
        s_curve: [[[900, 20], [700, 20], [560, 220], [450, 400]], [[450, 400], [340, 580], [120, 520], [-180, 560]]],
        arc: [[[880, 120], [620, -40], [430, 160], [440, 400]], [[440, 400], [450, 620], [180, 640], [-180, 520]]],
      },
      phone: {
        s_curve: [[[480, 110], [380, 130], [300, 200], [215, 340]], [[215, 340], [140, 460], [30, 440], [-200, 490]]],
        arc: [[[470, 200], [330, 40], [190, 160], [205, 340]], [[205, 340], [215, 500], [60, 520], [-200, 440]]],
      },
    };
    const DESIGN = { desktop: { w: 1440, h: 900, card: 420 }, tablet: { w: 768, h: 1024, dt: 700, card: 330 }, phone: { w: 390, h: 844, dt: 642, card: 240 } };
    const SIZE = { small: 0.82, medium: 1, large: 1.18 };
    const LEAD = 0.7; // the first card is already on its way in when the trail starts
    const HOLD = 0.18; // how far before the first stop the dock still shows the start text
    const READY = 0.15; // the dock appears once the first card is this close to the stop
    const STOP = 0.04; // a card counts as “at the stop” this close to it (snap brings it there exactly)
    const BLUR = 26;
    const clamp = (v, a = 0, b = 1) => (v < a ? a : v > b ? b : v);
    const smooth = (t) => t * t * (3 - 2 * t);
    // cubic-bezier as a function (Newton steps, bisection fallback) – the snap follows the section's easing
    const bezier = (x1, y1, x2, y2) => {
      const f = (t, a, b) => ((1 - 3 * b + 3 * a) * t + (3 * b - 6 * a)) * t * t + 3 * a * t;
      const d = (t, a, b) => 3 * (1 - 3 * b + 3 * a) * t * t + 2 * (3 * b - 6 * a) * t + 3 * a;
      return (x) => {
        if (x <= 0 || x >= 1) return x <= 0 ? 0 : 1;
        let t = x;
        for (let i = 0; i < 6; i++) {
          const sl = d(t, x1, x2);
          if (Math.abs(sl) < 1e-6) break;
          t -= (f(t, x1, x2) - x) / sl;
        }
        if (t < 0 || t > 1 || Math.abs(f(t, x1, x2) - x) > 1e-4) {
          let lo = 0, hi = 1;
          for (let i = 0; i < 24; i++) {
            t = (lo + hi) / 2;
            f(t, x1, x2) < x ? (lo = t) : (hi = t);
          }
        }
        return f(t, y1, y2);
      };
    };

    // samples a chain of cubic curves into an arc-length table: at(f) = point at f ∈ [0, 1] of the length
    const sampler = (segs) => {
      const pts = [];
      segs.forEach((s, i) => {
        for (let k = i ? 1 : 0; k <= 120; k++) {
          const t = k / 120, u = 1 - t;
          const a = u * u * u, b = 3 * u * u * t, c = 3 * u * t * t, d = t * t * t;
          pts.push([a * s[0][0] + b * s[1][0] + c * s[2][0] + d * s[3][0], a * s[0][1] + b * s[1][1] + c * s[2][1] + d * s[3][1]]);
        }
      });
      const L = [0];
      for (let i = 1; i < pts.length; i++) L.push(L[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
      const total = L[L.length - 1] || 1;
      const n = pts.length - 1;
      const dl = Math.hypot(pts[n][0] - pts[n - 1][0], pts[n][1] - pts[n - 1][1]) || 1;
      const dir = [(pts[n][0] - pts[n - 1][0]) / dl, (pts[n][1] - pts[n - 1][1]) / dl];
      // at(f): point at f of the length; beyond the end the trail runs on straight (cards leave the screen there)
      const at = (f) => {
        if (f > 1) return [pts[n][0] + dir[0] * (f - 1) * total, pts[n][1] + dir[1] * (f - 1) * total];
        const d = clamp(f) * total;
        let lo = 0, hi = L.length - 1;
        while (hi - lo > 1) {
          const m = (lo + hi) >> 1;
          L[m] < d ? (lo = m) : (hi = m);
        }
        const r = (d - L[lo]) / (L[hi] - L[lo] || 1);
        return [pts[lo][0] + (pts[hi][0] - pts[lo][0]) * r, pts[lo][1] + (pts[hi][1] - pts[lo][1]) * r];
      };
      at.total = total;
      return at;
    };

    customElements.define(
      'werk-collection-trail',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.werk-collection-trail_track');
          this.stage = this.querySelector('.werk-collection-trail_stage');
          this.dock = this.querySelector('[data-dock]');
          if (!this.stage || !this.dock) return;
          try {
            this.d = JSON.parse(this.querySelector('[data-werk]').textContent);
            this.t = JSON.parse(this.querySelector('[data-werk-t]').textContent);
          } catch {
            return;
          }
          this.items = [...this.querySelectorAll('.werk-collection-trail_item')].map((el) => {
            const card = el.querySelector('.werk-collection-trail_card');
            return { el, card, name: card?.getAttribute('aria-label') || '', inner: el.querySelector('.werk-collection-trail_card-in'), i: +el.dataset.i };
          });
          this.n = this.items.length;
          this.svgPath = this.querySelector('.werk-collection-trail_path path');
          this.sel = {}; // chosen options per product, kept while the trail moves on
          this.shown = -2; // what the dock shows: 0 … n − 1 product (-2 = nothing yet)
          this.still = matchMedia('(prefers-reduced-motion: reduce)');
          this.fine = matchMedia('(hover: hover) and (pointer: fine)');
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          // hover / press / gliding choice of the option chips; the script builds the indicator itself (class werk-collection-trail_opt-ind –
          // named here so the build keeps its styles)
          this.opts = window.werkOptions?.(this, 'werk-collection-trail', ac.signal);
          // Horizon scrolls div.page-wrapper, not the window – listen to every scroll on the page
          on(document, 'scroll', () => (this.wake(), this.queueSnap()), { capture: true, passive: true });
          // the visitor takes over: a running snap stops at once
          on(window, 'wheel', (e) => this.onWheel(e), { passive: false });
          on(window, 'touchstart', () => ((this.touching = true), this.stopScroll()), { passive: true });
          on(window, 'touchend', () => ((this.touching = false), this.queueSnap()), { passive: true });
          on(window, 'pointerdown', () => this.stopScroll(), { passive: true });
          // only keys that scroll the page take over – ← → are the trail's own (they start a scroll here)
          on(window, 'keydown', (e) => ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(e.key) && this.stopScroll(), { passive: true });
          on(window, 'resize', () => this.wake(true), { passive: true });
          on(this.still, 'change', () => this.setup());
          on(document, 'shopify:block:select', (e) => this.onSelect(e));
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'change', (e) => this.onChange(e));
          on(this, 'keydown', (e) => this.onKey(e));
          this.setup();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          this.ro?.disconnect();
          cancelAnimationFrame(this.raf);
          cancelAnimationFrame(this.scrollRaf);
          clearTimeout(this.addTm);
          clearTimeout(this.snapTm);
          this.running = false;
        }

        // ---------- trail or plain list ----------
        setup() {
          this.io?.disconnect();
          this.ro?.disconnect();
          cancelAnimationFrame(this.raf);
          this.running = false;
          this.live = this.n > 0 && this.dataset.motion === 'on' && !this.still.matches && !!this.track;
          this.classList.toggle('is-live', this.live);
          if (!this.live) {
            this.classList.remove('is-trail');
            for (const it of this.items) {
              it.el.removeAttribute('style');
              it.el.classList.remove('is-halt');
              it.inner?.removeAttribute('style');
              it.card?.removeAttribute('tabindex');
              it.card?.setAttribute('aria-label', it.name);
              it.halt = undefined;
              it.b = undefined;
            }
            return;
          }
          this.total = this.n > 1 ? this.n - 1 + LEAD : 0;
          this.gap = (+this.dataset.gap || 28) / 100;
          const m = getComputedStyle(this.querySelector('.werk-collection-trail_inner')).getPropertyValue('--werk-ease').match(/cubic-bezier\(([^)]+)\)/);
          this.ease = bezier(...(m ? m[1].split(',').map(parseFloat) : [0.6234, 0.058, 0, 0.9095]));
          this.reserveKey = '';
          this.measure();
          this.p = this.read();
          this.render(this.p);
          // until the observer reports (it can lag in background tabs), trust the box
          const r = this.track.getBoundingClientRect();
          this.vis = r.bottom > 0 && r.top < innerHeight;
          this.io = new IntersectionObserver(([e]) => {
            this.vis = e.isIntersecting;
            this.wake(true);
          });
          this.io.observe(this.track);
          this.ro = new ResizeObserver(() => this.wake(true));
          this.ro.observe(this);
          document.fonts?.ready.then(() => this.isConnected && this.live && this.wake(true));
        }

        layout() {
          const w = this.offsetWidth;
          return w >= 990 ? 'desktop' : w >= 750 ? 'tablet' : 'phone';
        }

        // a sticky / fixed theme header over the top of the screen, a fixed bar docked at the bottom (nav, cookies, chat)
        bars() {
          const skip = (hit) => this.contains(hit) || hit === document.documentElement || hit === document.body;
          let top = 0;
          for (const hit of document.elementsFromPoint(innerWidth / 2, 2)) {
            if (skip(hit)) continue;
            for (let el = hit; el && el !== document.body; el = el.parentElement) {
              const p = getComputedStyle(el).position;
              if (p !== 'fixed' && p !== 'sticky') continue;
              const r = el.getBoundingClientRect();
              if (r.top <= 2 && r.height < innerHeight * 0.3) top = Math.max(top, r.bottom);
              break;
            }
          }
          let foot = innerHeight;
          for (const x of [innerWidth / 2, innerWidth * 0.2, innerWidth * 0.8])
            for (const y of [innerHeight - 4, innerHeight - 32, innerHeight - 64])
              for (const hit of document.elementsFromPoint(x, y)) {
                if (skip(hit)) continue;
                for (let el = hit; el && el !== document.body; el = el.parentElement) {
                  if (getComputedStyle(el).position !== 'fixed') continue;
                  const r = el.getBoundingClientRect();
                  if (r.bottom >= innerHeight - 80 && r.height < innerHeight * 0.3 && r.top > innerHeight * 0.5) foot = Math.min(foot, r.top);
                  break;
                }
              }
          const set = (k, v) => {
            const val = Math.round(v) + 'px';
            if (this.style.getPropertyValue(k) !== val) this.style.setProperty(k, val);
          };
          // against the stage where it will stick, not where it is right now: while the section scrolls in, the part
          // of the stage still below the screen would count as covered – the cards shrank and grew on the way in
          const pin = parseFloat(getComputedStyle(this.stage).top) || 0;
          set('--lift-top', top > 0 ? Math.max(0, top - pin) : 0);
          set('--lift-bottom', foot < innerHeight ? Math.max(0, pin + this.stage.offsetHeight - foot) : 0);
          this.barsAt = performance.now();
        }

        measure() {
          this.bars();
          const W = this.stage.clientWidth;
          const H = this.stage.clientHeight;
          const mode = this.layout();
          const changed = mode !== this.lastMode;
          this.lastMode = mode;
          const D = DESIGN[mode];
          this.W = W;
          this.H = H;
          this.blurOn = mode === 'desktop' && this.dataset.blur !== 'false' && this.fine.matches;
          // the dock is rebuilt when the layout changes (chips on desktop & tablet, selects on the phone)
          if ((changed || W !== this.W0) && this.shown >= 0) this.fillDock(this.shown, false);
          this.W0 = W;
          const right = this.classList.contains('is-dock-right') && mode === 'desktop';

          const u = mode === 'desktop' ? Math.min(W / 1440, 1) : mode === 'tablet' ? Math.min(W / 768, 1.1) : Math.min(W / 390, 1.15);
          // y range of the trail: desktop the whole stage; tablet & phone down to the dock. The room for the dock is
          // the tallest dock of all products (measured once per width), so the trail never moves when one arrives.
          let yScale = H / D.h;
          this.dockTop = H;
          if (mode !== 'desktop') {
            this.dockTop = H - this.dockRoom(mode, W, Math.max(0, (D.h - D.dt) * u));
            yScale = (this.dockTop - 16) / D.dt;
          }
          this.lastH = H;
          const xScale = W / D.w;
          let segs = PATHS[mode][this.dataset.path] || PATHS[mode].s_curve;
          segs = segs.map((s) => s.map(([x, y]) => [right ? W - x * xScale : x * xScale, y * yScale]));
          // card size: design width × size setting, never taller than 64 % of the stage
          const ratio = parseFloat(getComputedStyle(this).getPropertyValue('--ratio')) || 1.25;
          let cw = D.card * u * (SIZE[this.dataset.size] || 1);
          if (cw * ratio > H * 0.64) cw = (H * 0.64) / ratio;
          let ch = cw * ratio;

          // the stop sits low (58 % of the stage on desktop, a little below the middle of the free room on tablet & phone)
          // and keeps clear of the heading when it sits above it: the whole trail slides, the card only gets smaller
          // when there is no room at all. Nothing here depends on the product in the dock.
          const head = this.querySelector('.werk-collection-trail_head');
          const box = (n) => n && n.offsetWidth ? { l: n.offsetLeft, t: n.offsetTop, r: n.offsetLeft + n.offsetWidth, b: n.offsetTop + n.offsetHeight } : null;
          this.headBox = box(head);
          let at = sampler(segs);
          const [hx, hy] = at(0.5);
          const hits = (b) => b && hx - cw / 2 < b.r + 16 && hx + cw / 2 > b.l - 16;
          const top = hits(this.headBox) ? this.headBox.b + 20 : 16;
          let bottom = mode === 'desktop' ? H - 24 : this.dockTop - 12;
          if (ch > bottom - top) {
            ch = Math.max(100, bottom - top);
            cw = ch / ratio;
          }
          const want = mode === 'desktop' ? H * 0.58 : top + (bottom - top) * 0.55;
          const ny = clamp(want, top + ch / 2, Math.max(top + ch / 2, bottom - ch / 2));
          if (Math.abs(ny - hy) > 0.5) {
            segs = segs.map((sg) => sg.map(([x, y]) => [x, y + ny - hy]));
            at = sampler(segs);
          }
          this.at = at;
          // how far past the end of the trail a leaving card has to go to be fully off the screen (at its biggest)
          const hw = (cw * 1.42) / 2 + 8, hh = (ch * 1.42) / 2 + 8;
          let run = 0;
          for (; run < 6; run += 0.02) {
            const [x, y] = at(1 + run);
            if (x + hw < 0 || x - hw > W || y - hh > H || y + hh < 0) break;
          }
          this.runOut = run;
          if (this.svgPath) {
            const f = (v) => v.toFixed(1);
            this.svgPath.setAttribute('d', 'M' + f(segs[0][0][0]) + ' ' + f(segs[0][0][1]) + segs.map((sg) => ' C' + sg.slice(1).map((q) => f(q[0]) + ' ' + f(q[1])).join(' ')).join(''));
            this.svgPath.parentElement.setAttribute('viewBox', `0 0 ${W} ${H}`);
          }
          this.cw = cw;
          this.ch = ch;
          this.stage.style.setProperty('--cw', cw.toFixed(1) + 'px');
          this.fitDock();
          this.fitWord(mode);
        }

        // the tallest dock of all products (and the start text) at this width, plus its gap to the bottom
        dockRoom(mode, W, min) {
          const key = mode + W + ':' + this.n + ':' + (this.style.getPropertyValue('--lift-bottom') || '');
          if (key === this.reserveKey) return this.reserve;
          const probe = this.dock.cloneNode(false);
          probe.removeAttribute('data-dock');
          probe.setAttribute('aria-hidden', 'true');
          probe.style.cssText = 'visibility:hidden;pointer-events:none;';
          const inner = document.createElement('div');
          inner.className = 'werk-collection-trail_dock-in';
          probe.append(inner);
          this.stage.append(probe);
          let h = 0;
          for (let i = 0; i < this.n; i++) {
            inner.innerHTML = this.dockHTML(i);
            h = Math.max(h, probe.offsetHeight);
          }
          const gap = this.H - (probe.offsetTop + probe.offsetHeight);
          probe.remove();
          this.reserveKey = key;
          this.reserve = Math.max(min, h + Math.max(0, gap));
          return this.reserve;
        }

        // the background word: one line that fits the stage (phones: up to a third of its height)
        fitWord(mode) {
          const w = this.querySelector('.werk-collection-trail_word');
          if (!w) return;
          w.style.fontSize = '';
          const base = parseFloat(getComputedStyle(w).fontSize);
          let size = base;
          if (mode === 'phone') {
            for (let i = 0; i < 12 && w.offsetHeight > this.H * 0.34 && size > 24; i++) w.style.fontSize = (size *= 0.88) + 'px';
          } else if (w.scrollWidth > this.W * 0.94) {
            w.style.fontSize = Math.max(24, (size * this.W * 0.94) / w.scrollWidth) + 'px';
          }
        }

        headBottom() {
          const h = this.querySelector('.werk-collection-trail_head');
          return h ? h.offsetTop + h.offsetHeight + 24 : 40;
        }

        // desktop: when the dock would run into the heading, first the description goes, then the options turn into
        // dropdowns and the name keeps one line (compact)
        fitDock() {
          const d = this.dock;
          d.classList.remove('no-desc');
          this.fitLevel(d);
          // the dock's box: cards that pass behind it fade
          this.dockBox = d.offsetWidth ? { l: d.offsetLeft, t: d.offsetTop, r: d.offsetLeft + d.offsetWidth, b: d.offsetTop + d.offsetHeight } : null;
        }
        fitLevel(d) {
          if (this.lastMode !== 'desktop' || this.shown < 0) return;
          const clear = () => d.offsetTop >= this.headBottom();
          if (clear()) return;
          d.classList.add('no-desc');
          if (clear() || this.compact) return;
          this.compact = true;
          d.querySelector('.werk-collection-trail_dock-in').innerHTML = this.dockHTML(this.shown);
          this.update(this.shown);
        }

        read() {
          const r = this.track.getBoundingClientRect();
          const len = r.height - this.stage.offsetHeight;
          return len > 0 ? clamp(-r.top / len) : 1;
        }

        // ---------- loop: only while the section is in view and something moves ----------
        wake(remeasure) {
          if (!this.live) return;
          if (remeasure) this.dirty = true;
          else if (performance.now() - (this.barsAt || 0) > 700) {
            const a = this.style.getPropertyValue('--lift-top') + this.style.getPropertyValue('--lift-bottom');
            this.bars();
            if (a !== this.style.getPropertyValue('--lift-top') + this.style.getPropertyValue('--lift-bottom')) this.dirty = true;
          }
          if (!this.vis || this.running) return;
          this.running = true;
          this.idle = 0;
          this.last = performance.now();
          this.raf = requestAnimationFrame((t) => this.tick(t));
        }

        tick(now) {
          if (!this.isConnected || !this.live) return (this.running = false);
          if (this.dirty) {
            this.dirty = false;
            this.measure();
          }
          const dt = Math.min((now - this.last) / 1000, 1 / 20);
          this.last = now;
          const goal = this.read();
          // scroll only sets the goal; the shown value glides after it, frame-rate independent
          this.p += (goal - this.p) * (1 - Math.exp(-dt * 12));
          if (Math.abs(goal - this.p) < 0.0003) this.p = goal;
          this.render(this.p);
          this.idle = this.p === goal ? this.idle + 1 : 0;
          if (this.idle > 20 || !this.vis) return (this.running = false);
          this.raf = requestAnimationFrame((t) => this.tick(t));
        }

        // the card grows all the way towards the visitor: small and soft far away, sharp at the stop, bigger still as
        // it leaves – and by the time the next card stands at the stop it has left the screen
        // s ≤ 0.5: on its way in (0 = far away); out = 0 … 1: on its way out (1 = the next card is at the stop)
        look(s, out) {
          if (out > 0) {
            const scale = 1 + 0.42 * Math.pow(out, 1.25);
            return { scale, op: 1, blur: this.blurOn ? BLUR * 0.45 * Math.pow(out, 1.5) : 0 };
          }
          const scale = 0.3 + 0.7 * Math.pow(s / 0.5, 1.5);
          let op = s < 0.07 ? s / 0.07 : 1;
          let blur = 0;
          if (this.blurOn) blur = BLUR * Math.pow(1 - s / 0.5, 1.2);
          else op *= 0.5 + 0.5 * (s / 0.5);
          return { scale, op, blur };
        }

        render(p) {
          const f = this.n > 1 ? p * this.total - LEAD : 0;
          const fe = f;
          const near = Math.round(f) || 0;
          const atStop = Math.abs(f - near) <= STOP && near >= 0 && near < this.n;
          for (const it of this.items) {
            const s = 0.5 + (fe - it.i) * this.gap;
            // leaving: one station from the stop to off the screen (second half of the trail + run-out)
            const out = s > 0.5 ? (fe - it.i) : 0;
            const st = it.el.style;
            if (s < -0.04 || out > 1.02) {
              if (st.visibility !== 'hidden') st.visibility = 'hidden';
              continue;
            }
            const c = clamp(s);
            const [x, y] = out > 0 ? this.at(0.5 + Math.min(out, 1) * (0.5 + this.runOut)) : this.at(c);
            const v = this.look(c, out);
            const w = this.cw;
            const h = this.ch;
            const halt = atStop && it.i === near;
            const px = x - w / 2;
            const py = y - h / 2;
            // cards passing behind the heading or the dock fade, so the text stays readable
            if (!halt) {
              const k = v.scale;
              const r = { l: px + (w * (1 - k)) / 2, t: py + (h * (1 - k)) / 2, r: px + (w * (1 + k)) / 2, b: py + (h * (1 + k)) / 2 };
              const over = (b) => b && r.l < b.r && r.r > b.l && r.t < b.b && r.b > b.t;
              if (over(this.headBox) || over(this.dockBox)) v.op *= 0.2;
            }
            st.visibility = v.op > 0.01 ? 'visible' : 'hidden';
            st.transform = `translate3d(${px.toFixed(1)}px,${py.toFixed(1)}px,0) scale(${v.scale.toFixed(4)})`;
            st.opacity = v.op.toFixed(3);
            // the card at the stop in front, then the ones coming in (the nearer, the higher), the leaving one at the back
            st.zIndex = String(halt ? 40 : out > 0 ? 9 : 10 + Math.round(c * 20));
            st.setProperty('--sc', v.scale.toFixed(3));
            if (it.inner) {
              const b = Math.round(v.blur);
              if (it.b !== b) {
                it.b = b;
                it.inner.style.filter = b > 0 ? `blur(${b}px)` : '';
              }
            }
            if (it.halt !== halt) {
              it.halt = halt;
              it.el.classList.toggle('is-halt', halt);
              it.card.tabIndex = halt ? 0 : -1;
              it.card.setAttribute('aria-label', halt || !this.t.go ? it.name : this.fill(this.t.go, { product: it.name }));
            }
          }
          // the dock: the product the trail is heading for (the first one from the start) – it changes halfway
          // between two stops, so the new text has risen by the time its card arrives
          // before the first product stands at the stop the dock stays away (-1)
          const want = f < -READY ? -1 : clamp(near, 0, this.n - 1);
          if (want !== this.shown) {
            this.dock.classList.toggle('is-waiting', want < 0);
            if (want < 0) this.shown = -1;
            else this.fillDock(want, true);
          }
          this.cur = f < -0.5 ? -1 : clamp(near, 0, this.n - 1);
        }

        // ---------- dock ----------
        esc(v) {
          return String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
        }
        fill(text, map) {
          return String(text || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));
        }
        money(cents) {
          const f = (n, d, ts, ds) => {
            const [i, fr] = (n / 100).toFixed(d).split('.');
            return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (fr ? ds + fr : '');
          };
          const map = {
            amount: () => f(cents, 2, ',', '.'),
            amount_no_decimals: () => f(cents, 0, ',', '.'),
            amount_with_comma_separator: () => f(cents, 2, '.', ','),
            amount_no_decimals_with_comma_separator: () => f(cents, 0, '.', ','),
            amount_with_space_separator: () => f(cents, 2, ' ', ','),
            amount_no_decimals_with_space_separator: () => f(cents, 0, ' ', ','),
            amount_with_apostrophe_separator: () => f(cents, 2, "'", '.'),
          };
          // fallback built in pieces: two curly braces in a row would be read as Liquid
          return (this.d.money || '$' + '{' + '{amount}' + '}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (map[k] || map.amount)());
        }

        product(i) {
          return this.d.products[i];
        }
        selection(p) {
          if (!this.sel[p.id]) {
            const v = p.v.find((x) => x.id === p.sel) || p.v[0];
            this.sel[p.id] = v ? [...v.o] : [];
          }
          return this.sel[p.id];
        }
        variant(p) {
          const sel = this.selection(p);
          return p.v.find((v) => v.o.every((o, k) => o === sel[k])) || null;
        }
        // a value is sold out when the variant with it (and the other choices) can't be bought
        soldValue(p, k, value) {
          const sel = [...this.selection(p)];
          sel[k] = value;
          const v = p.v.find((x) => x.o.every((o, j) => o === sel[j]));
          return !v || !v.a;
        }

        async fillDock(i, animate) {
          const prev = this.shown;
          this.shown = i;
          const inner = this.dock.querySelector('.werk-collection-trail_dock-in');
          const html = this.dockHTML(i);
          const speed = this.dataset.motion === 'on' && !this.still.matches && !!inner.animate;
          const token = (this.dockToken = (this.dockToken || 0) + 1);
          (this.dockAnims || []).forEach((a) => a.cancel());
          this.dockAnims = [];
          const run = (el, frames, o) => {
            const a = el.animate(frames, { fill: 'backwards', ...o });
            this.dockAnims.push(a);
            return a;
          };
          if (animate && speed && prev >= 0) {
            // out: the name's words slip up out of their mask, everything else fades a touch upwards
            const words = [...inner.querySelectorAll('.werk-collection-trail_w > span')];
            const rest = [...inner.children].filter((c) => !c.querySelector('.werk-collection-trail_w'));
            const outs = [
              ...words.map((w, k) => run(w, [{ transform: 'translateY(0)' }, { transform: 'translateY(-108%)' }], { duration: 300, delay: k * 18, easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)', fill: 'forwards' })),
              ...rest.map((c) => run(c, [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-6px)' }], { duration: 220, easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)', fill: 'forwards' })),
            ];
            const nameRow = inner.querySelector('.werk-collection-trail_name-row');
            if (nameRow && !words.length) outs.push(run(nameRow, [{ opacity: 1 }, { opacity: 0 }], { duration: 220, fill: 'forwards' }));
            await Promise.all(outs.map((a) => a.finished.catch(() => {})));
            if (token !== this.dockToken) return;
            this.dockAnims.forEach((a) => a.cancel());
            this.dockAnims = [];
          }
          inner.innerHTML = html;
          this.compact = false;
          if (i >= 0) this.update(i);
          this.fitDock();
          this.opts?.refresh();
          if (animate && speed) {
            const ease = getComputedStyle(this.querySelector('.werk-collection-trail_inner')).getPropertyValue('--werk-ease').trim() || 'ease-out';
            const soft = 'cubic-bezier(0.22, 1, 0.36, 1)';
            // in: the name rises word by word out of its masks, then price, options and buttons
            const words = [...inner.querySelectorAll('.werk-collection-trail_w > span')];
            words.forEach((w, k) => run(w, [{ transform: 'translateY(108%) rotate(3deg)' }, { transform: 'translateY(0) rotate(0deg)' }], { duration: 820, delay: 40 + k * 45, easing: ease }));
            const after = 90 + words.length * 45;
            const rest = [...inner.children].filter((c) => !c.querySelector('.werk-collection-trail_w') && !c.hidden);
            const narrowRow = inner.querySelector('.werk-collection-trail_name-row [data-price]');
            if (narrowRow) rest.unshift(narrowRow);
            rest.forEach((c, k) => run(c, [{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'none' }], { duration: 760, delay: after + k * 80, easing: soft }));
            // chips come in with their group (the gliding indicator is one layer for the whole group)
            inner.querySelectorAll('.werk-collection-trail_select').forEach((c, k) => run(c, [{ opacity: 0, transform: 'translateY(8px) scale(0.96)' }, { opacity: 1, transform: 'none' }], { duration: 520, delay: after + 160 + k * 35, easing: soft }));
          }
        }

        dockHTML(i) {
          const p = this.product(i);
          const d = this.d;
          const pad = (v) => String(v).padStart(2, '0');
          const mode = this.lastMode;
          const narrow = mode !== 'desktop';
          let opts = '';
          // a product that only sells with a subscription can't be added from here: the button leads to its page
          const buy = d.add && !p.sp;
          if (buy && d.opts && p.o.length) {
            const phone = mode === 'phone' || this.compact;
            const blocks = p.o.map((name, k) => {
              const vals = p.ov[k] || [];
              if (phone || vals.length > 6) {
                return `<label class="werk-collection-trail_select"><span class="werk-collection-trail_option-label">${this.esc(name)}</span><select data-opt="${k}" aria-label="${this.esc(name)}">${vals.map((v) => `<option value="${this.esc(v)}">${this.esc(v)}</option>`).join('')}</select></label>`;
              }
              return `<div class="werk-collection-trail_option"><p class="werk-collection-trail_option-label" id="werk-${this.id}-o${k}">${this.esc(name)}</p><div class="werk-collection-trail_chips werk-collection-trail_opts" role="radiogroup" aria-labelledby="werk-${this.id}-o${k}">${vals.map((v) => `<button type="button" class="werk-collection-trail_chip werk-collection-trail_opt" data-kind="chip" role="radio" aria-checked="false" data-opt="${k}" data-value="${this.esc(v)}"><span class="werk-collection-trail_opt-label">${this.esc(v)}</span></button>`).join('')}</div></div>`;
            });
            // long option names or values: one field per line, so nothing is cut
            const stack = mode === 'phone' && (p.o.length > 2 || p.o.some((name, k) => name.length + Math.max(0, ...(p.ov[k] || []).map((v) => v.length)) > 15));
            opts = phone ? `<div class="werk-collection-trail_selects${stack ? ' is-stack' : ''}">${blocks.join('')}</div>` : `<div class="werk-collection-trail_options">${blocks.join('')}</div>`;
          }
          const arrow = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14m-5.5-5.5L19 12l-5.5 5.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          const icons = '<svg class="werk-collection-trail_spin" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-opacity=".25" stroke-width="2"/><path d="M20 12a8 8 0 0 0-8-8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><svg class="werk-collection-trail_check" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          const btnClass = 'werk-collection-trail_btn' + (this.classList.contains('is-theme-buttons') ? ' button' : '');
          const btn = d.add && p.sp && this.t.link
            ? `<a class="${btnClass}" href="${this.esc(p.u || '#')}" data-view><span class="werk-collection-trail_btn-roll"><span class="werk-collection-trail_btn-row"><span class="werk-collection-trail_btn-dot" aria-hidden="true">${arrow}</span><span>${this.esc(this.t.link)}</span></span></span></a>`
            : buy
            ? `<button type="button" class="${btnClass}" data-add><span class="werk-collection-trail_btn-roll"><span class="werk-collection-trail_btn-row"><span class="werk-collection-trail_btn-dot" aria-hidden="true">${arrow}</span><span data-label>${this.esc(this.t.add)}</span><span class="werk-collection-trail_sep" aria-hidden="true">·</span><span data-add-price></span></span><span class="werk-collection-trail_btn-row" aria-hidden="true">${icons}</span><span class="werk-collection-trail_btn-row" aria-hidden="true">${icons}${this.esc(this.t.added)}</span></span></button>`
            : '';
          const link = d.link && this.t.link && !p.sp ? `<a class="werk-collection-trail_link" href="${this.esc(p.u || '#')}"><span class="werk-collection-trail_link-dot" aria-hidden="true">${arrow}</span><span class="werk-collection-trail_link-text"><span>${this.esc(this.t.link)}</span></span><span aria-hidden="true">→</span></a>` : '';
          const desc = d.desc && p.d ? `<p class="werk-collection-trail_desc">${this.esc(p.d)}</p>` : '';
          return `<div class="werk-collection-trail_name-row"><h3 class="werk-collection-trail_name${p.t.length > 44 ? ' is-xlong' : p.t.length > 22 ? ' is-long' : ''}" aria-live="polite" aria-label="${this.esc(p.t)}">${this.words(p.t)}</h3>${narrow ? '<p class="werk-collection-trail_price" data-price></p>' : ''}</div>
            ${desc}${narrow ? '' : '<p class="werk-collection-trail_price" data-price></p>'}
            ${narrow ? '' : opts}
            ${btn || link || (narrow && opts) ? `<div class="werk-collection-trail_actions">${narrow ? opts : ''}${btn}${link}</div>` : ''}
            <p class="werk-collection-trail_error" role="status" data-error hidden></p>`;
        }

        // a name as words in masks (the dock animates them); the heading keeps the whole name as its label
        words(text) {
          return String(text || '')
            .split(/\s+/)
            .filter(Boolean)
            .map((w) => `<span class="werk-collection-trail_w" aria-hidden="true"><span>${this.esc(w)}</span></span>`)
            .join(' ');
        }

        // current choice → chips, selects, price, button
        update(i) {
          const p = this.product(i);
          if (!p) return;
          const sel = this.selection(p);
          const v = this.variant(p);
          this.dock.querySelectorAll('.werk-collection-trail_chip').forEach((b) => {
            const k = +b.dataset.opt;
            b.setAttribute('aria-checked', String(sel[k] === b.dataset.value));
            b.toggleAttribute('data-out', this.soldValue(p, k, b.dataset.value));
          });
          this.dock.querySelectorAll('select[data-opt]').forEach((s) => {
            const k = +s.dataset.opt;
            [...s.options].forEach((o) => (o.textContent = o.value + (this.soldValue(p, k, o.value) ? ' – ' + (this.t.soldOut || '') : '')));
            s.value = sel[k];
          });
          const price = v ? this.money(v.p) : '';
          this.dock.querySelectorAll('[data-price], [data-add-price]').forEach((el) => (el.textContent = price));
          const btn = this.dock.querySelector('[data-add]');
          if (btn) {
            const ok = !!v && v.a;
            btn.disabled = !ok;
            btn.querySelector('[data-label]').textContent = !v ? this.fill(this.t.choose, { option: p.o[0] || '' }) : ok ? this.t.add : this.t.soldOut;
            btn.querySelectorAll('.werk-collection-trail_sep, [data-add-price]').forEach((el) => (el.hidden = !ok));
          }
          // phones drop the price beside the name while the button carries it
          this.dock.classList.toggle('is-priced', !!btn && !!v && v.a);
        }

        onChange(e) {
          const s = e.target.closest('select[data-opt]');
          if (!s || this.shown < 0) return;
          const p = this.product(this.shown);
          this.selection(p)[+s.dataset.opt] = s.value;
          this.update(this.shown);
        }

        onClick(e) {
          const chip = e.target.closest('.werk-collection-trail_chip');
          if (chip && this.shown >= 0) {
            const p = this.product(this.shown);
            this.selection(p)[+chip.dataset.opt] = chip.dataset.value;
            return this.update(this.shown);
          }
          if (e.target.closest('[data-add]')) return this.add(e.target.closest('[data-add]'));
          const card = e.target.closest('.werk-collection-trail_card');
          if (card && this.live) {
            const it = this.items.find((x) => x.card === card);
            if (it && !it.halt) {
              e.preventDefault();
              return this.go(it.i);
            }
          }
          // demo cards and links have no product page
          const a = e.target.closest('a[href="#"]');
          if (a && this.d.demo) e.preventDefault();
        }

        onKey(e) {
          if (!this.live || e.target.closest('select, input, textarea')) return;
          const k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!k) return;
          // repeated presses count from where the page is already heading
          const from = this.target ?? (this.cur < 0 ? -1 : this.cur);
          const to = clamp(from + k, 0, this.n - 1);
          if (to === from) return;
          e.preventDefault();
          this.go(to, true);
        }

        // scrolls the page so product i stands at the stop (with the section's easing)
        go(i, focus) {
          if (!this.live) return;
          this.target = i;
          clearTimeout(this.targetTm);
          this.targetTm = setTimeout(() => (this.target = null), 1400);
          this.scrollTo(i);
          if (focus) {
            const it = this.items.find((x) => x.i === i);
            setTimeout(() => it?.card.focus({ preventScroll: true }), this.scrollMs || 0);
          }
        }

        // page offset that brings station f to the stop
        scrollTo(f) {
          cancelAnimationFrame(this.scrollRaf);
          const sc = this.scroller();
          const r = this.track.getBoundingClientRect();
          const len = r.height - this.stage.offsetHeight;
          const goal = this.n > 1 ? clamp((f + LEAD) / this.total) : 0;
          const from = sc === window ? scrollY : sc.scrollTop;
          const delta = goal * len + r.top;
          if (Math.abs(delta) < 1) return;
          const moving = this.dataset.motion === 'on' && !this.still.matches;
          const dur = moving ? clamp(440 + (Math.abs(delta) / Math.max(1, len / Math.max(1, this.total))) * 300, 440, 1100) : 0;
          this.scrollMs = dur;
          // 'instant': themes with scroll-behavior: smooth (Horizon's page-wrapper) would ease every single step again
          const set = (y) => sc.scrollTo({ top: y, behavior: 'instant' });
          if (!dur) return set(from + delta);
          this.animating = true;
          const t0 = performance.now();
          const step = (now) => {
            const t = clamp((now - t0) / dur);
            set(from + delta * this.ease(t));
            if (t < 1 && this.animating) this.scrollRaf = requestAnimationFrame(step);
            else this.animating = false;
          };
          this.scrollRaf = requestAnimationFrame(step);
        }

        stopScroll() {
          if (!this.animating) return;
          cancelAnimationFrame(this.scrollRaf);
          this.animating = false;
        }

        // Snap (default): once the visitor stops scrolling inside the trail, it settles on the nearest product
        queueSnap() {
          if (!this.live || this.dataset.scroll === 'free' || this.animating || this.touching) return;
          clearTimeout(this.snapTm);
          this.snapTm = setTimeout(() => this.snap(), 150);
        }
        snap() {
          if (this.animating || this.touching || !this.isConnected) return;
          const p = this.read();
          if (p <= 0 || p >= 1 || this.n < 2) return;
          const f = p * this.total - LEAD;
          if (f < -0.35) return; // still at the start: leave it
          const k = clamp(Math.round(f), 0, this.n - 1);
          if (Math.abs(f - k) > 0.004) this.scrollTo(k);
        }

        // Step (setting, mouse and trackpad on wide screens): one wheel gesture = one product. Trackpad momentum
        // after the gesture is swallowed; at the first and last product the page scrolls on as usual.
        onWheel(e) {
          if (!this.live) return;
          const step = this.dataset.scroll === 'step' && this.lastMode === 'desktop' && this.fine.matches && this.n > 1;
          if (!step) return this.stopScroll();
          if (Math.abs(e.deltaY) < 3 || e.ctrlKey) return;
          const r = this.track.getBoundingClientRect();
          if (r.top > 1 || r.bottom < this.stage.offsetHeight - 1) return; // the trail isn't pinned
          const now = performance.now();
          const fresh = now - (this.lastWheel || 0) > 220;
          this.lastWheel = now;
          const dir = e.deltaY > 0 ? 1 : -1;
          const f = this.read() * this.total - LEAD;
          const at = this.target ?? (f < -0.35 ? -1 : clamp(Math.round(f), 0, this.n - 1));
          if ((dir < 0 && at <= 0 && f <= STOP) || (dir > 0 && at >= this.n - 1)) return; // let the page go on
          e.preventDefault();
          if (!fresh || this.animating) return;
          this.go(clamp(at + dir, 0, this.n - 1));
        }

        scroller() {
          let el = this.parentElement;
          while (el && el !== document.body && el !== document.documentElement) {
            const o = getComputedStyle(el).overflowY;
            if ((o === 'auto' || o === 'scroll') && el.scrollHeight > el.clientHeight + 1) return el;
            el = el.parentElement;
          }
          return window;
        }

        // ---------- theme editor: picking a product block brings it to the stop ----------
        onSelect(e) {
          if (!this.contains(e.target)) return;
          const it = this.items.find((x) => x.el.dataset.block === e.detail?.blockId);
          if (!it) return;
          if (this.live) {
            this.go(it.i);
          } else it.el.scrollIntoView({ block: 'nearest', inline: 'start' });
        }

        // ---------- add to cart ----------
        async add(btn) {
          const p = this.product(this.shown);
          const v = p && this.variant(p);
          if (!v || !v.a || btn.dataset.state) return;
          const err = this.dock.querySelector('[data-error]');
          if (err) err.hidden = true;
          btn.dataset.state = 'loading';
          const done = () => {
            btn.dataset.state = 'added';
            clearTimeout(this.addTm);
            this.addTm = setTimeout(() => delete btn.dataset.state, 1800);
          };
          try {
            if (this.d.demo) {
              await new Promise((r) => setTimeout(r, 700));
              return done();
            }
            const root = window.Shopify?.routes?.root || '/';
            const items = [{ id: v.id, quantity: 1 }];
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            const cartP = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: items.map((x) => ({ merchandiseId: x.id, quantity: x.quantity })),
              promise: cartP.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            await window.werkThemeCart?.(root);
            done();
            if (this.d.after === 'cart_drawer') {
              const horizon = document.querySelector('theme-drawer#cart-drawer');
              const dawn = document.querySelector('cart-drawer');
              const drawer = typeof horizon?.open === 'function' ? horizon : typeof dawn?.open === 'function' ? dawn : null;
              setTimeout(() => (drawer ? drawer.open(btn) : (location.href = this.d.cart)), 700);
            }
          } catch (e) {
            delete btn.dataset.state;
            if (err) {
              err.textContent = this.fill(this.t.error, { message: e?.description || e?.message || '' }).trim();
              err.hidden = false;
            }
          }
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-cursor-reveal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('werk-cursor-reveal')) {
    // cubic-bezier as a function (Newton steps) – the lens opens with the section's easing
    const bezier = (str) => {
      const n = (str.match(/[-\d.]+/g) || [0.6234, 0.058, 0, 0.9095]).map(Number);
      const [x1, y1, x2, y2] = n.length === 4 ? n : [0.6234, 0.058, 0, 0.9095];
      const f = (a, b, t) => 3 * a * (1 - t) ** 2 * t + 3 * b * (1 - t) * t * t + t ** 3;
      return (x) => {
        let t = x;
        for (let i = 0; i < 6; i++) {
          const d = 3 * x1 * (1 - t) ** 2 + 6 * (x2 - x1) * (1 - t) * t + 3 * (1 - x2) * t * t;
          if (Math.abs(d) < 1e-6) break;
          t -= (f(x1, x2, t) - x) / d;
          t = Math.min(1, Math.max(0, t));
        }
        return f(y1, y2, t);
      };
    };

    customElements.define(
      'werk-cursor-reveal',
      class extends HTMLElement {
        connectedCallback() {
          const q = (sel) => this.querySelector(sel);
          try {
            this.d = JSON.parse(q('script[data-werk]').textContent);
          } catch {
            return;
          }
          this.look = this.dataset.look;
          this.kind = this.dataset.mode;
          this.inner = q('.werk-cursor-reveal_inner');
          this.stage = q('[data-stage]');
          this.lensEl = q('[data-lens]');
          this.label = q('[data-label]');
          this.canvas = q('[data-ink]');
          this.ctx = this.canvas?.getContext('2d');
          const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.motion = this.dataset.motion === 'on' && !reduced;
          if (!this.motion) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.design = !!(this.d.design || window.Shopify?.designMode);
          this.fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
          this.k = { tight: 24, smooth: 11, lazy: 5 }[this.d.follow] || 11;
          this.trail = Math.max(0.2, parseFloat(this.d.trail) || 1.2);
          this.period = { slow: 13, fast: 6 }[this.d.auto] || 9;
          // state: lens position (x, y), target (tx, ty), radius r (0 … R), open = where r is heading
          Object.assign(this, { x: 0, y: 0, tx: 0, ty: 0, r: 0, open: 0, px: 0, py: 0, t: 0, pts: [], hold: false, pointer: false, autoOff: 0, last: 0, lastPt: null, tile: null });
          this.ease = bezier(getComputedStyle(this.inner).getPropertyValue('--werk-ease'));
          this.tiles = [...this.querySelectorAll('[data-field] .werk-cursor-reveal_tile')];
          this.total = new Set(this.tiles.map((t) => t.dataset.n)).size;

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          on(this.stage, 'pointermove', (e) => this.onMove(e));
          on(this.stage, 'pointerenter', (e) => this.onMove(e));
          on(this.stage, 'pointerleave', (e) => this.onLeave(e));
          on(this.stage, 'click', (e) => this.onClick(e));
          on(this.stage, 'focusin', (e) => this.onFocus(e));
          on(this.stage, 'focusout', () => { if (!this.hold) this.release(); });
          on(document, 'visibilitychange', () => this.wake());
          on(document, 'shopify:block:select', (e) => this.onBlock(e, true));
          on(document, 'shopify:block:deselect', (e) => this.onBlock(e, false));
          this.querySelectorAll('img').forEach((img) => on(img, 'load', () => this.measure(), { once: true }));

          this.ro = new ResizeObserver(() => this.measure());
          this.ro.observe(this.stage);
          this.io = new IntersectionObserver(([en]) => { this.visible = en.isIntersecting; this.wake(); });
          this.io.observe(this.stage);
          document.fonts?.ready.then(() => this.isConnected && this.measure());
          if (this.dataset.fit === 'fit' && this.kind === 'product') this.edges();
          this.measure();
          // start: open on the product in the editor, with reduced motion on touch, and for the auto path
          const [fx, fy] = this.focus();
          this.x = this.tx = fx;
          this.y = this.ty = fy;
          if (this.design || !this.fine) this.open = 1;
          if (this.design || (!this.motion && !this.fine)) this.r = this.open * this.R;
          this.classList.add('is-ready');
          this.wake();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.ro?.disconnect();
          this.io?.disconnect();
          cancelAnimationFrame(this.raf);
          this.raf = 0;
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          const fg = getComputedStyle(this).color;
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', fg);
        }

        // ---------- geometry ----------
        measure() {
          if (!this.isConnected) return;
          const st = this.stage.getBoundingClientRect();
          const cs = getComputedStyle(this.inner);
          this.W = st.width;
          this.H = st.height;
          this.u = parseFloat(cs.getPropertyValue('--werk-u')) || 1;
          this.R = Math.max(20, (parseFloat(this.d.lens) || 200) * this.u * (parseFloat(cs.getPropertyValue('--lens-f')) || 1));
          this.stage.style.setProperty('--R', this.R + 'px');
          this.small = this.W < 990;
          this.fitHeading(st);
          // the text block: the automatic path keeps the lens clear of it
          const card = this.querySelector('.werk-cursor-reveal_card')?.getBoundingClientRect();
          this.yMin = 0;
          this.yMax = this.H;
          if (card && card.height) {
            const top = card.top - st.top, bottom = card.bottom - st.top;
            if (top + bottom > this.H) this.yMax = top;
            else this.yMin = bottom;
          }
          // tile rects in stage coordinates, without parallax
          this.rects = this.tiles.map((t) => {
            const b = t.getBoundingClientRect();
            return { t, x: b.left - st.left - this.px, y: b.top - st.top - this.py, w: b.width, h: b.height };
          });
          if (this.canvas) {
            this.canvas.width = Math.round(this.W);
            this.canvas.height = Math.round(this.H);
            this.inkColor = getComputedStyle(this.stage).backgroundColor;
            this.soft = Math.min(0.95, parseFloat(getComputedStyle(this).getPropertyValue('--werk-soft')) || 0);
          }
          this.sizeLabel();
          if (!this.pointer && !this.hold) {
            const [fx, fy] = this.focus();
            this.tx = fx;
            this.ty = fy;
            if (!this.raf) Object.assign(this, { x: fx, y: fy });
          }
          this.dirty = true;
          this.wake();
        }

        // long headings shrink (down to 40 %) until they fit 3 lines (4 on phones) between the kicker and the bottom
        fitHeading(st) {
          const h = this.querySelector('.werk-cursor-reveal_heading');
          const card = this.querySelector('.werk-cursor-reveal_card');
          if (!h || !card) return;
          const kick = this.querySelector('.werk-cursor-reveal_kicker');
          const top = (kick ? kick.getBoundingClientRect().bottom - st.top : 0) + 12 * this.u;
          const max = this.W < 750 ? 4.3 : 3.3;
          let k = 1;
          h.style.setProperty('--tscale', k);
          for (let i = 0; i < 9; i++) {
            const lines = h.offsetHeight / (parseFloat(getComputedStyle(h).lineHeight) || 1);
            const c = card.getBoundingClientRect();
            if (lines <= max && c.top - st.top >= top && c.bottom - st.top <= this.H + 1) break;
            k -= 0.075;
            h.style.setProperty('--tscale', k.toFixed(3));
          }
        }

        // where the product sits: the focus point of the picture mapped through object-fit (collection: the middle)
        focus() {
          const W = this.W || 1, H = this.H || 1;
          if (this.kind === 'collection') return [W * 0.58, H * 0.4];
          const [fx, fy] = String(W < 750 ? this.d.focusM : this.d.focus).split(/\s+/).map((v) => parseFloat(v) / 100);
          const img = this.querySelector('.werk-cursor-reveal_under .werk-cursor-reveal_img');
          const nw = img?.naturalWidth, nh = img?.naturalHeight;
          if (!nw || !nh) return [W * (fx || 0.5), H * (fy || 0.5)];
          const fit = this.dataset.fit === 'fit' ? Math.min : Math.max;
          const s = fit(W / nw, H / nh);
          const dw = nw * s, dh = nh * s;
          const pos = getComputedStyle(img).objectPosition.split(' ').map((v) => parseFloat(v) / 100);
          return [(W - dw) * (pos[0] ?? 0.5) + dw * (fx || 0.5), (H - dh) * (pos[1] ?? 0.5) + dh * (fy || 0.5)];
        }

        // ---------- input ----------
        local(e) {
          const b = this.stage.getBoundingClientRect();
          return [e.clientX - b.left, e.clientY - b.top];
        }
        onMove(e) {
          if (e.pointerType === 'touch' || !this.fine) return;
          [this.tx, this.ty] = this.local(e);
          if (!this.pointer) {
            this.pointer = true;
            this.classList.add('is-pointer');
            if (!this.r) [this.x, this.y] = [this.tx, this.ty]; // grow out of the pointer, don't fly in
          }
          if (e.type === 'pointermove') this.classList.add('is-moved');
          this.open = 1;
          this.wake();
        }
        onLeave(e) {
          if (e.pointerType === 'touch' || !this.fine) return;
          this.pointer = false;
          this.classList.remove('is-pointer');
          if (!this.hold && !this.design) this.open = 0;
          this.wake();
        }
        // touch: a tap on the lens follows the link underneath, a tap beside it sends the lens there
        onClick(e) {
          if (this.fine || e.target.closest('.werk-cursor-reveal_content a')) return;
          const [x, y] = this.local(e);
          if (Math.hypot(x - this.x, y - this.y) > this.r * 0.9 || this.r < this.R * 0.5) {
            e.preventDefault();
            Object.assign(this, { tx: x, ty: y, open: 1, autoOff: performance.now() + 4000 });
            this.wake();
          }
        }
        onFocus(e) {
          if (!e.target.matches(':focus-visible')) return;
          const t = e.target.closest('.werk-cursor-reveal_tile, [data-hit]');
          if (!t) return;
          this.show(t);
        }
        show(t) {
          const r = this.rects?.find((o) => o.t === t);
          const [x, y] = r ? [r.x + r.w / 2 + this.px, r.y + r.h / 2 + this.py] : this.focus();
          Object.assign(this, { tx: x, ty: y, open: 1, autoOff: performance.now() + 6000 });
          this.wake();
        }
        release() {
          if (!this.pointer && this.fine && !this.design) this.open = 0;
          this.wake();
        }
        onBlock(e, on) {
          if ('werk-' + e.detail?.sectionId !== this.id) return;
          const t = this.querySelector(`[data-field] [data-block="${e.detail?.blockId}"]`);
          this.hold = on && !!t;
          if (this.hold) this.show(t);
          else this.release();
        }

        // ---------- loop: runs only while visible and something moves ----------
        wake() {
          if (this.raf || !this.isConnected || !this.visible || document.hidden) return;
          this.last = performance.now();
          this.raf = requestAnimationFrame((now) => this.tick(now));
        }
        tick(now) {
          this.raf = 0;
          if (!this.isConnected) return;
          const dt = Math.min(1 / 30, (now - this.last) / 1000);
          this.last = now;
          const W = this.W, H = this.H, R = this.R;
          let busy = false;

          // auto path on touch: a slow figure over the product (collection: over the field)
          if (!this.fine && this.motion && !this.hold && now > this.autoOff) {
            const [fx, fy] = this.focus();
            const col = this.kind === 'collection';
            const ax = W * (col ? 0.3 : 0.2), ay = H * (col ? 0.2 : 0.12);
            const cx = col ? W / 2 : fx, cy = col ? H * 0.42 : fy;
            // slower near the product, so it lingers there
            const near = col ? 1 : 0.35 + 0.65 * Math.min(1, Math.hypot(this.tx - fx, this.ty - fy) / (ax * 0.5));
            this.t += (dt * near * Math.PI * 2) / this.period;
            // inside the stage, and off the text: the band between the edges and the text block
            const lo = Math.max(R * 0.4, this.yMin + R * 0.8), hi = Math.min(H - R * 0.4, this.yMax - R * 0.9);
            const mid = hi > lo ? (lo + hi) / 2 : cy, half = hi > lo ? (hi - lo) / 2 : 0;
            const cy2 = Math.min(mid + half, Math.max(mid - half, cy)), ay2 = Math.min(ay, half);
            this.tx = Math.min(W - R * 0.4, Math.max(R * 0.4, cx + ax * Math.sin(this.t * 2 + 0.5)));
            this.ty = Math.min(Math.max(lo, hi), Math.max(lo, cy2 + ay2 * Math.sin(this.t * 3)));
            this.open = 1;
            busy = true;
          }

          // follow: frame-rate independent damping (instant without motion)
          const a = this.motion ? 1 - Math.exp(-dt * this.k) : 1;
          const ox = this.x, oy = this.y;
          this.x += (this.tx - this.x) * a;
          this.y += (this.ty - this.y) * a;
          if (Math.abs(this.tx - this.x) + Math.abs(this.ty - this.y) > 0.3) busy = true;

          // radius: eased tween towards open × R
          const goal = this.open * R;
          if (this.r !== goal) {
            if (!this.motion) this.r = goal;
            else {
              if (this.rGoal !== goal) Object.assign(this, { rGoal: goal, rFrom: this.r, rT: 0 });
              this.rT = Math.min(1, this.rT + dt / (goal > this.rFrom ? 0.45 : 0.35));
              this.r = this.rFrom + (goal - this.rFrom) * this.ease(this.rT);
              if (this.rT >= 1) this.r = goal;
            }
            busy = true;
          }

          // collection: the field leans a little towards the lens
          if (this.kind === 'collection' && this.motion) {
            const gx = this.open ? -(this.x / W - 0.5) * 24 * this.u : 0;
            const gy = this.open ? -(this.y / H - 0.5) * 24 * this.u : 0;
            const b = 1 - Math.exp(-dt * 3);
            this.px += (gx - this.px) * b;
            this.py += (gy - this.py) * b;
            if (Math.abs(gx - this.px) + Math.abs(gy - this.py) > 0.1) busy = true;
          }

          if (this.canvas) busy = this.ink(now, dt, Math.hypot(this.x - ox, this.y - oy)) || busy;
          this.paint();
          if (busy || this.dirty) {
            this.dirty = false;
            this.raf = requestAnimationFrame((n) => this.tick(n));
          }
        }

        // ---------- A · Ink: the cover is a canvas, the trail is cut out of it and dries back ----------
        ink(now, dt, moved) {
          const R = this.R;
          const life = this.trail * 1000;
          if (!this.motion) this.pts = [];
          if (this.motion && this.r > 1) {
            const lp = this.lastPt;
            const step = 7 * this.u;
            if (!lp || Math.hypot(this.x - lp.x, this.y - lp.y) > step) {
              const speed = moved / Math.max(dt, 0.001);
              const p = { x: this.x, y: this.y, r: this.r * (0.82 + Math.random() * 0.14), t: now };
              this.pts.push(p);
              this.lastPt = p;
              // a fast stroke throws a drop now and then
              if (speed > 1400 * this.u && Math.random() < 0.12) {
                const ang = Math.random() * Math.PI * 2, dist = this.r * (0.9 + Math.random() * 0.5);
                this.pts.push({ x: this.x + Math.cos(ang) * dist, y: this.y + Math.sin(ang) * dist, r: R * (0.04 + Math.random() * 0.05), t: now });
              }
            }
          }
          this.pts = this.pts.filter((p) => now - p.t < life);
          if (this.pts.length > 160) this.pts.splice(0, this.pts.length - 160);
          const c = this.ctx, W = this.canvas.width, H = this.canvas.height;
          c.globalCompositeOperation = 'source-over';
          c.fillStyle = this.inkColor;
          c.fillRect(0, 0, W, H);
          c.globalCompositeOperation = 'destination-out';
          const soft = this.soft;
          const hole = (x, y, r) => {
            if (r < 0.5) return;
            const g = c.createRadialGradient(x, y, r * (1 - soft), x, y, r);
            g.addColorStop(0, '#000');
            g.addColorStop(1, 'rgba(0,0,0,0)');
            c.fillStyle = g;
            c.beginPath();
            c.arc(x, y, r, 0, Math.PI * 2);
            c.fill();
          };
          for (const p of this.pts) {
            const age = (now - p.t) / life;
            hole(p.x, p.y, p.r * (1 - age) ** 1.4);
          }
          hole(this.x, this.y, this.r);
          return this.pts.length > 0;
        }

        // ---------- write the state to CSS ----------
        paint() {
          const s = this.stage.style;
          const set = (k, v) => { if (this['_' + k] !== v) { this['_' + k] = v; s.setProperty(k, v); } };
          set('--x', this.x.toFixed(1) + 'px');
          set('--y', this.y.toFixed(1) + 'px');
          set('--r', this.r.toFixed(1) + 'px');
          set('--k', (this.r / this.R).toFixed(3));
          if (this.kind === 'collection') {
            set('--px', this.px.toFixed(2) + 'px');
            set('--py', this.py.toFixed(2) + 'px');
            this.hit();
          }
          this.place();
        }

        // collection: which product is under the lens → the label shows it
        hit() {
          const x = this.x - this.px, y = this.y - this.py;
          const o = this.rects?.find((o) => x >= o.x && x <= o.x + o.w && y >= o.y && y <= o.y + o.h);
          const t = o?.t || null;
          if (t === this.tile) return;
          this.tile = t;
          if (!this.label) return;
          if (!t) return;
          const d = t.dataset;
          const set = (sel, v) => { const el = this.label.querySelector(sel); if (el) el.textContent = v; };
          set('[data-l-t]', d.t);
          set('[data-l-p]', d.p);
          set('[data-l-d]', d.ty ? ' · ' + d.ty : '');
          set('[data-l-fig]', `${this.d.fig ? this.d.fig + ' ' : ''}${String(d.n).padStart(2, '0')} / ${String(this.total).padStart(2, '0')}`);
          set('[data-l-cap]', `${d.t} · ${d.p} →`);
          this.sizeLabel();
        }

        // label size, measured only when its text or the layout changes (not every frame)
        sizeLabel() {
          const L = this.label;
          if (!L) return;
          L.classList.toggle('is-row', this.look === 'xray' && this.small);
          this.lw = L.offsetWidth;
          this.lh = L.offsetHeight;
        }

        // the label hangs on the lens and stays inside the stage
        place() {
          const L = this.label;
          if (!L) return;
          const on = this.r > this.R * 0.6 && (this.kind === 'product' || !!this.tile);
          L.classList.toggle('is-on', on);
          if (!on) return;
          const u = this.u, x = this.x, y = this.y, r = this.r || this.R;
          const row = this.look === 'xray' && this.small;
          const w = this.lw || 0, h = this.lh || 0;
          let lx, ly;
          switch (this.look) {
            case 'xray':
              if (row) [lx, ly] = [x - w / 2, y + r + 28 * u];
              else {
                [lx, ly] = [x + r + 32 * u, y - 58 * u];
                if (lx + w > this.W - 16 * u) lx = x - r - 32 * u - w;
              }
              if (ly + h > this.H - 16 * u) ly = y - r - 28 * u - h;
              break;
            case 'inside':
              [lx, ly] = [x - w / 2, y + r + 16 * u];
              if (ly + h > this.H - 12 * u) ly = y - r - 16 * u - h;
              break;
            case 'spotlight':
              [lx, ly] = [x + r * 0.24, y + r * 0.59];
              break;
            default:
              [lx, ly] = [x + 24 * u, y + 22 * u];
          }
          lx = Math.min(this.W - w - 12 * u, Math.max(12 * u, lx));
          ly = Math.min(this.H - h - 12 * u, Math.max(12 * u, ly));
          const s = L.style;
          s.setProperty('--lx', lx.toFixed(1) + 'px');
          s.setProperty('--ly', ly.toFixed(1) + 'px');
        }

        // "Fit": a photo on its own background gets that background continued – its edge pixels, stretched out to the
        // stage (read from a 32 px copy). Same idea as Drop Countdown, done for every picture on its own (Inside has two).
        // Cut-outs with transparency keep the section background.
        edges() {
          this.querySelectorAll('.werk-cursor-reveal_media').forEach((media) => {
            const img = media.querySelector('.werk-cursor-reveal_img');
            if (!img || img.tagName !== 'IMG') return;
            if (!img.complete || !img.currentSrc) return img.addEventListener('load', () => this.edge(media, img), { once: true });
            this.edge(media, img);
          });
        }
        edge(media, img) {
          const src = img.currentSrc || img.src;
          if (!src) return;
          const probe = new Image();
          probe.crossOrigin = 'anonymous';
          probe.onload = () => {
            try {
              const w = probe.naturalWidth, h = probe.naturalHeight;
              const c = document.createElement('canvas');
              c.width = w;
              c.height = h;
              const x = c.getContext('2d', { willReadFrequently: true });
              x.drawImage(probe, 0, 0);
              const strip = (vertical, fromEnd) => {
                const len = vertical ? h : w;
                const px = [];
                let alpha = 0;
                for (let i = 0; i < len; i++) {
                  const d = vertical ? x.getImageData(fromEnd ? w - 2 : 0, i, 2, 1).data : x.getImageData(i, fromEnd ? h - 2 : 0, 1, 2).data;
                  const v = [0, 0, 0];
                  for (let k = 0; k < d.length; k += 4) { v[0] += d[k] / 2; v[1] += d[k + 1] / 2; v[2] += d[k + 2] / 2; alpha += d[k + 3] / 2; }
                  px.push(v);
                }
                const stops = px.map((_, i) => {
                  const win = px.slice(Math.max(0, i - 3), i + 4);
                  return `rgb(${[0, 1, 2].map((k) => Math.round(win.reduce((a, v) => a + v[k], 0) / win.length)).join(' ')})`;
                });
                return { stops, a: alpha / len / 255 };
              };
              const sides = w / h < this.W / this.H;
              const [p, q] = sides ? [strip(true, false), strip(true, true)] : [strip(false, false), strip(false, true)];
              if (p.a < 0.9 || q.a < 0.9) return;
              const g = (stops, dir) => `linear-gradient(${dir}, ${stops.join(', ')})`;
              media.style.background = sides
                ? `${g(p.stops, 'to bottom')} left / 50% 100% no-repeat, ${g(q.stops, 'to bottom')} right / 50% 100% no-repeat`
                : `${g(p.stops, 'to right')} top / 100% 50% no-repeat, ${g(q.stops, 'to right')} bottom / 100% 50% no-repeat`;
              // the photo's own edge fades into the continuation
              const ar = this.W / this.H;
              const inset = sides ? (1 - w / h / ar) * 50 : (1 - ar / (w / h)) * 50;
              const m = `linear-gradient(${sides ? '90deg' : '180deg'}, transparent ${inset}%, #000 ${inset + 2.5}%, #000 ${100 - inset - 2.5}%, transparent ${100 - inset}%)`;
              img.style.maskImage = m;
              img.style.webkitMaskImage = m;
            } catch {}
          };
          const u = new URL(src, location.href);
          u.searchParams.set('width', '32');
          probe.src = u.href;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-door-calendar"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-door-calendar')) {
    customElements.define(
      'werk-door-calendar',
      class extends HTMLElement {
        connectedCallback() {
          const q = (sel) => this.querySelector(sel);
          try {
            this.d = JSON.parse(q('script[data-werk]').textContent);
            this.t = JSON.parse(q('script[data-werk-t]').textContent);
          } catch {
            return;
          }
          this.speed = this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.root = window.Shopify?.routes?.root || '/';
          this.design = !!(this.d.design || window.Shopify?.designMode);
          this.skew = Date.now() - this.d.now * 1000 > 5 * 60000 ? 0 : 0;
          this.fake = null;
          this.grid = q('[data-grid]');
          this.dialog = q('[data-dialog]');
          this.remind = q('[data-remind]');
          this.rmode = 'next';
          this.key = 'werk-door-calendar:' + this.d.key;
          try {
            this.opened = new Set(JSON.parse(localStorage.getItem(this.key) || '[]'));
          } catch {
            this.opened = new Set();
          }
          const dayMs = 864e5;
          this.doors = [...this.querySelectorAll('[data-door]')].map((el) => ({ el, n: +el.dataset.n, id: el.dataset.block, open: +el.dataset.opens * 1000, day: +el.dataset.close * 1000 }));
          const byTime = [...this.doors].sort((a, b) => a.open - b.open);
          byTime.forEach((x, i) => {
            const next = byTime[i + 1];
            x.close = this.d.openFor === 'next' && next ? next.open : x.day > x.open ? x.day : x.open + dayMs;
          });
          this.first = byTime[0];
          this.last = byTime[byTime.length - 1];

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'change', (e) => {
            const sel = e.target.closest('[data-variant]');
            if (sel) this.pickVariant(sel);
          });
          on(this, 'keydown', (e) => {
            if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.werk-door-calendar_behind')) {
              e.preventDefault();
              this.onClick(e);
            }
          });
          for (const dlg of [this.dialog, this.remind]) on(dlg, 'click', (e) => { if (e.target === dlg) dlg.close(); });
          on(document, 'visibilitychange', () => { if (!document.hidden) this.tick(true); });
          on(document, 'shopify:block:select', (e) => this.onBlock(e));
          this.ro = new ResizeObserver(() => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.layout()); });
          this.ro.observe(this);
          document.fonts?.ready.then(() => this.isConnected && this.layout());
          this.setupPreview();
          this.syncTime();
          this.tick(true);
          this.loop = () => {
            if (!this.isConnected) return;
            this.tick();
            this.tm = setTimeout(this.loop, 1000 - (this.now() % 1000) + 20);
          };
          this.loop();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.ro?.disconnect();
          clearTimeout(this.tm);
          clearTimeout(this.toastTm);
          clearTimeout(this.fetchTm);
          cancelAnimationFrame(this.raf);
          this.doors?.forEach((x) => x.sc?.destroy());
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        now() {
          return this.fake ?? Date.now() + (this.skew || 0);
        }

        // a device clock that is off must not open doors early: compare once with the server's Date header
        async syncTime() {
          try {
            const t0 = Date.now();
            const r = await fetch(this.root + 'cart.js', { cache: 'no-store' });
            const h = r.headers.get('date');
            if (!h) return;
            const diff = Date.parse(h) + 500 - (t0 + Date.now()) / 2;
            if (Math.abs(diff) > 2000) {
              this.skew = diff;
              this.tick(true);
            }
          } catch {}
        }

        fmt(ms, o) {
          try {
            return new Intl.DateTimeFormat(document.documentElement.lang || undefined, o).format(new Date(ms));
          } catch {
            return new Date(ms).toLocaleString();
          }
        }

        // ---------- states ----------
        stateOf(x, now) {
          if (now < x.open) return 'locked';
          if (this.opened.has(x.id)) return 'opened';
          if (now < x.close) return 'today';
          const after = this.d.after;
          if (after === 'open' && now < this.last.close) return 'late';
          if (after === 'catch_up' && now < x.close + (parseInt(this.d.catchUp, 10) || 1) * 864e5) return 'late';
          if (after === 'peek') return 'peek';
          return 'missed';
        }

        validUntil(x) {
          const after = this.d.after;
          if (after === 'open') return this.last.close;
          if (after === 'catch_up') return x.close + (parseInt(this.d.catchUp, 10) || 1) * 864e5;
          return x.close;
        }

        tick(force) {
          const now = this.now();
          // states change only at door times: re-render when the set of states differs
          const sig = this.doors.map((x) => this.stateOf(x, now)).join();
          if (force || sig !== this.sig) {
            this.sig = sig;
            this.render(now);
          }
          this.clock(now);
        }

        render(now) {
          const t = this.t;
          const openable = (st) => st === 'today' || st === 'late';
          let feature = null;
          for (const x of this.doors) {
            const st = this.stateOf(x, now);
            const el = x.el;
            if (el.dataset.state !== 'loading') el.dataset.state = st;
            const meta = el.querySelector('[data-meta]');
            const days = Math.ceil((x.open - now) / 864e5);
            let label = t.door.replace('[n]', x.n);
            if (st === 'locked') {
              meta.textContent = this.fmt(x.open, { day: '2-digit', month: 'short' });
              label += ' · ' + this.opensText(x, now);
            } else if (st === 'today') {
              meta.textContent = t.openNow;
              label += ' · ' + t.openNow;
            } else if (st === 'late') {
              const left = Math.ceil((this.validUntil(x) - now) / 864e5);
              meta.textContent = this.d.after === 'catch_up' ? (left <= 1 ? t.lastDay : t.daysLeft.replace('[n]', left)) : t.stillOpen;
              label += ' · ' + meta.textContent;
            } else if (st === 'missed' || st === 'peek') {
              meta.textContent = '';
              label += ' · ' + t.missed;
            } else meta.textContent = '';
            const leaf = el.querySelector('[data-leaf]');
            leaf.setAttribute('aria-label', label);
            leaf.disabled = st === 'missed' || st === 'opened' || st === 'peek';
            const behind = el.querySelector('[data-behind]');
            if (st === 'opened' && behind.querySelector('template')) {
              behind.tabIndex = 0;
              behind.setAttribute('role', 'button');
              behind.setAttribute('aria-label', t.door.replace('[n]', x.n));
            } else {
              behind.removeAttribute('tabindex');
              behind.removeAttribute('role');
            }
            if (!feature && now >= x.open && now < x.close) feature = x; // today's door, opened or not
            // scratch: a layer over the content of every door that can be opened now
            if (this.d.openStyle === 'scratch' && openable(st) && behind.querySelector('template')) {
              if (!x.sc) this.mountScratch(x);
            } else if (x.sc && !x.sc.done) {
              x.sc.destroy();
              x.sc = null;
            }
            const bar = this.querySelector(`[data-bar="${x.id}"]`);
            if (bar) {
              bar.className = this.opened.has(x.id) ? 'is-on' : st === 'missed' || st === 'peek' ? 'is-miss' : '';
            }
          }
          // Bold: today's door is the big one; without one, the next door to open, else the last
          if (!feature) feature = this.doors.filter((x) => x.open > now).sort((a, b) => a.open - b.open)[0] || this.last;
          this.doors.forEach((x) => x.el.classList.toggle('is-feature', x === feature));
          this.feature = feature;
          const count = this.querySelector('[data-count]');
          if (count) count.textContent = t.count.replace('[n]', this.doors.filter((x) => this.opened.has(x.id)).length).replace('[total]', this.doors.length);
          const rb = this.querySelector('[data-remind-open]');
          if (rb) rb.hidden = !this.doors.some((x) => x.open > now);
          this.layout();
        }

        opensText(x, now) {
          const t = this.t;
          const d0 = new Date(now);
          const d1 = new Date(x.open);
          const sameDay = d0.toDateString() === d1.toDateString();
          const tomorrow = new Date(d0.getFullYear(), d0.getMonth(), d0.getDate() + 1).toDateString() === d1.toDateString();
          if (sameDay) return t.opensAt.replace('[time]', this.fmt(x.open, { hour: '2-digit', minute: '2-digit' }));
          if (tomorrow) return t.opensTomorrow;
          const days = Math.round((new Date(d1.toDateString()) - new Date(d0.toDateString())) / 864e5);
          return t.opensIn.replace('[n]', days).replace('[date]', this.fmt(x.open, { day: '2-digit', month: 'short' }));
        }

        clock(now) {
          const nextEl = this.querySelector('[data-next]');
          const clockEl = this.querySelector('[data-clock]');
          if (!nextEl || !clockEl) return;
          const next = this.doors.filter((x) => x.open > now).sort((a, b) => a.open - b.open)[0];
          if (!next) {
            nextEl.textContent = this.t.done;
            clockEl.textContent = '';
            clockEl.hidden = true;
            return;
          }
          clockEl.hidden = false;
          nextEl.textContent = this.t.next.replace('[n]', next.n);
          let s = Math.max(0, Math.floor((next.open - now) / 1000));
          const d = Math.floor(s / 86400);
          s %= 86400;
          const p = (v) => String(v).padStart(2, '0');
          clockEl.textContent = (d ? d + (this.t.days || '') + ' ' : '') + `${p(Math.floor(s / 3600))}:${p(Math.floor(s / 60) % 60)}:${p(s % 60)}`;
        }

        // ---------- layout: phone rows without holes, the note next to today's door ----------
        layout() {
          const cs = getComputedStyle(this.grid);
          const cols = cs.gridTemplateColumns.split(' ').length;
          const phone = cs.gridAutoFlow.startsWith('row') && !cs.gridAutoFlow.includes('dense');
          const items = [...this.doors].sort((a, b) => (+a.el.style.getPropertyValue('--o') || 0) - (+b.el.style.getPropertyValue('--o') || 0));
          items.forEach((x) => (x.el.style.gridColumn = ''));
          if (phone) {
            // full-width doors (big / feature) can leave a short row before them: the last door of that row stretches
            let col = 0;
            let prev = null;
            const full = (x) => getComputedStyle(x.el).gridColumnStart === '1' && getComputedStyle(x.el).gridColumnEnd === '-1';
            for (const x of items) {
              if (full(x)) {
                if (col > 0 && prev) prev.el.style.gridColumn = `span ${cols - col + 1}`;
                col = 0;
                prev = null;
                continue;
              }
              col++;
              prev = x;
              if (col === cols) col = 0;
            }
            if (col > 0 && prev) prev.el.style.gridColumn = `span ${cols - col + 1}`;
          }
          const note = this.querySelector('[data-note]');
          if (note) {
            const f = this.doors.find((x) => x.el.dataset.state === 'today');
            const show = !!f && cols >= 6 && this.dataset.look !== 'minimal';
            note.classList.toggle('is-on', show);
            if (show) {
              const r = f.el.getBoundingClientRect();
              const box = this.querySelector('.werk-door-calendar_inner').getBoundingClientRect();
              note.style.left = `${r.left - box.left + r.width * 0.3 - note.offsetWidth}px`;
              note.style.top = `${r.top - box.top - note.offsetHeight + 4}px`;
            }
          }
        }

        // ---------- opening ----------
        onClick(e) {
          if (e.target.closest('.werk-door-calendar_scratch')) return; // rubbing ends in a click – only the rubbed share opens the door
          const el = e.target.closest('[data-leaf], [data-behind], [data-close], [data-copy], [data-add], [data-remind-open], [data-mode], [data-ics], [data-google], [data-preview-now], [data-preview-reset]');
          if (!el) return;
          if (el.matches('[data-close]')) return el.closest('dialog').close();
          if (el.matches('[data-copy]')) return this.copy(el);
          if (el.matches('[data-add]')) return this.add(el);
          if (el.matches('[data-remind-open]')) return this.openRemind();
          if (el.matches('[data-mode]')) return this.setMode(el.dataset.mode);
          if (el.matches('[data-ics]')) return this.ics();
          if (el.matches('[data-google]')) return (el.href = this.google());
          if (el.matches('[data-preview-now]')) return this.setFake(null);
          if (el.matches('[data-preview-reset]')) return this.resetPreview();
          const door = this.doors.find((x) => x.el === el.closest('[data-door]'));
          if (!door) return;
          const st = door.el.dataset.state;
          if (st === 'locked') return this.shake(door);
          if (st === 'opened' && el.matches('[data-behind]')) return this.show(door);
          if (st === 'today' || st === 'late') {
            if (this.d.openStyle === 'scratch' && door.sc) return door.sc.reveal();
            this.open(door);
          }
        }

        shake(door) {
          const el = door.el;
          el.querySelector('[data-tip]').textContent = this.opensText(door, this.now());
          el.classList.remove('is-shake', 'is-tip');
          void el.offsetWidth;
          el.classList.add('is-shake', 'is-tip');
          clearTimeout(door.tipTm);
          door.tipTm = setTimeout(() => {
            el.classList.remove('is-shake', 'is-tip');
            el.querySelector('[data-tip]').textContent = '';
          }, 1800);
        }

        async open(door) {
          if (!door.el.querySelector('[data-behind] template')) {
            const ok = await this.fetchDoor(door);
            if (!ok) return;
          }
          this.opened.add(door.id);
          if (!this.fake) {
            try {
              localStorage.setItem(this.key, JSON.stringify([...this.opened]));
            } catch {}
          }
          door.el.dataset.state = 'opened';
          this.tick(true);
          setTimeout(() => this.show(door), this.d.openStyle === 'scratch' ? 250 : 650 * this.speed);
        }

        mountScratch(x) {
          const box = x.el.querySelector('[data-behind]');
          const color = getComputedStyle(x.el).getPropertyValue('--werk-door').trim() || '#2A2927';
          const hot = getComputedStyle(x.el).getPropertyValue('--werk-hot').trim() || '#F2571F';
          const mono = getComputedStyle(this.querySelector('.werk-door-calendar_inner')).getPropertyValue('--werk-mono');
          const font = getComputedStyle(this.querySelector('.werk-door-calendar_inner')).getPropertyValue('--werk-font');
          const label = this.t.scratch;
          x.sc = this.scratch(box, {
            color,
            threshold: 0.45,
            paint: (ctx, w, h) => {
              const u = Math.min(w, h);
              ctx.fillStyle = hot;
              ctx.globalAlpha = 0.9;
              ctx.font = `500 ${Math.round(u * 0.42)}px ${font}`;
              ctx.textBaseline = 'top';
              ctx.fillText(String(x.n), u * 0.08, u * 0.1);
              ctx.globalAlpha = 0.6;
              ctx.fillStyle = getComputedStyle(this.querySelector('.werk-door-calendar_inner')).color;
              ctx.font = `500 ${Math.max(10, Math.round(u * 0.07))}px ${mono}`;
              ctx.textBaseline = 'bottom';
              ctx.fillText(label.toUpperCase(), u * 0.08, h - u * 0.08);
              ctx.globalAlpha = 1;
            },
            onDone: () => this.open(x),
          });
        }

        // the page came from a cache made before the door opened: fetch this section fresh for its content
        async fetchDoor(door) {
          door.el.dataset.state = 'loading';
          for (let i = 0; i < 12; i++) {
            try {
              const url = `${location.pathname}?section_id=${encodeURIComponent(this.d.section)}&werk=${Date.now()}`;
              const r = await fetch(url, { cache: 'no-store' });
              if (r.ok) {
                const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
                const fresh = doc.querySelector(`[data-block="${CSS.escape(door.id)}"] [data-behind]`);
                if (fresh?.querySelector('template')) {
                  door.el.querySelector('[data-behind]').innerHTML = fresh.innerHTML;
                  door.el.dataset.state = '';
                  return true;
                }
              }
            } catch {}
            await new Promise((res) => (this.fetchTm = setTimeout(res, 2500)));
            if (!this.isConnected) return false;
          }
          door.el.dataset.state = '';
          this.tick(true);
          this.toast(this.t.error);
          return false;
        }

        show(door) {
          const tpl = door.el.querySelector('[data-behind] template');
          if (!tpl || !this.dialog) return;
          const type = door.el.querySelector('.werk-door-calendar_type')?.textContent || '';
          this.querySelector('[data-dialog-label]').textContent = type;
          const body = this.querySelector('[data-dialog-body]');
          body.replaceChildren(tpl.content.cloneNode(true));
          const valid = body.querySelector('[data-valid]');
          if (valid) {
            const until = this.validUntil(door) - 60000;
            valid.textContent = this.t.valid.replace('[time]', this.fmt(until, { weekday: 'short', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })) + ' ' + this.t.yourTime;
          }
          this.dialog.showModal();
          this.dialog.focus({ preventScroll: true });
        }

        async copy(btn) {
          const code = btn.dataset.copy;
          try {
            await navigator.clipboard.writeText(code);
          } catch {
            const r = document.createRange();
            r.selectNodeContents(btn.previousElementSibling);
            getSelection().removeAllRanges();
            getSelection().addRange(r);
            try { document.execCommand('copy'); } catch {}
          }
          btn.textContent = this.t.copied;
          this.toast(this.t.toast);
        }

        toast(text) {
          const el = this.querySelector('[data-toast]');
          if (!el) return;
          // inside an open modal the page layer is inert: show the toast in the dialog's top layer
          const dlg = [this.dialog, this.remind].find((d) => d?.open);
          if (dlg && el.parentElement !== dlg) dlg.append(el);
          el.textContent = text;
          el.classList.add('is-on');
          clearTimeout(this.toastTm);
          this.toastTm = setTimeout(() => el.classList.remove('is-on'), 2200);
        }

        pickVariant(sel) {
          const opt = sel.selectedOptions[0];
          const box = sel.closest('[data-dialog-body]');
          const price = box?.querySelector('[data-price]');
          if (price && opt?.dataset.price) price.textContent = opt.dataset.price;
          const add = box?.querySelector('[data-add]');
          if (add) add.dataset.add = sel.value;
        }

        async add(btn) {
          if (btn.dataset.state || btn.disabled) return;
          const id = btn.dataset.add;
          const msg = btn.closest('[data-dialog-body]')?.querySelector('[data-msg]');
          if (msg) msg.hidden = true;
          btn.dataset.state = 'loading';
          const done = () => {
            btn.dataset.state = 'added';
            setTimeout(() => delete btn.dataset.state, 1800);
          };
          if (!id) return setTimeout(done, 700); // demo product
          try {
            const items = [{ id: +id, quantity: 1 }];
            const res = await fetch(this.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            const cartP = fetch(this.root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: items.map((x) => ({ merchandiseId: x.id, quantity: x.quantity })),
              promise: cartP.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart(this.root);
            done();
          } catch (err) {
            delete btn.dataset.state;
            if (msg) {
              msg.textContent = (err?.description || err?.message || '').trim() || this.t.error;
              msg.hidden = false;
            }
          }
        }

        // ---------- reminder: .ics for Apple Calendar / Outlook, a link for Google – made in the browser ----------
        openRemind() {
          if (!this.remind) return;
          this.setMode(this.d.remindMode === 'daily' ? 'daily' : this.rmode);
          this.remind.showModal();
          this.remind.focus({ preventScroll: true });
        }

        setMode(m) {
          this.rmode = this.d.remindMode === 'both' ? m : this.d.remindMode;
          this.querySelectorAll('[data-mode]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.mode === this.rmode)));
          const ev = this.events();
          const info = this.querySelector('[data-remind-info]');
          if (info && ev[0]) {
            const when = this.fmt(ev[0].open, { weekday: 'short', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
            info.textContent = `${this.t.door.replace('[n]', ev[0].n)} · ${when} ${this.t.yourTime}${ev.length > 1 ? ' · +' + (ev.length - 1) : ''}`;
          }
        }

        events() {
          const now = this.now();
          const up = this.doors.filter((x) => x.open > now).sort((a, b) => a.open - b.open);
          return this.rmode === 'daily' ? up : up.slice(0, 1);
        }

        stamp(ms) {
          return new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
        }

        title(n) {
          return String(this.d.remindTitle || '').replace('[n]', n).trim();
        }

        google() {
          const ev = this.events();
          if (!ev[0]) return '#';
          const url = location.href.split('#')[0];
          const text = [String(this.d.remindText || '').trim(), url].filter(Boolean).join('\n\n');
          const daily = ev.length > 1;
          const title = daily ? String(this.d.remindTitle || '').replace(/\s*\[n\]\s*/, ' ').trim() : this.title(ev[0].n);
          return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${this.stamp(ev[0].open)}/${this.stamp(ev[0].open + 15 * 60000)}&details=${encodeURIComponent(text)}${daily ? '&recur=' + encodeURIComponent(`RRULE:FREQ=DAILY;COUNT=${ev.length}`) : ''}`;
        }

        ics() {
          const ev = this.events();
          if (!ev[0]) return;
          const url = location.href.split('#')[0];
          const e = (str) => String(str || '').replace(/[\\;,]/g, (x) => '\\' + x).replace(/\r?\n/g, '\\n');
          const text = [String(this.d.remindText || '').trim(), url].filter(Boolean).join('\n\n');
          const alert = parseInt(this.d.remindAlert, 10) || 0;
          const lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//werk//Door Calendar//EN'];
          for (const x of ev) {
            lines.push('BEGIN:VEVENT', `UID:${x.open}-${x.id}@werk.build`, `DTSTAMP:${this.stamp(Date.now())}`, `DTSTART:${this.stamp(x.open)}`, `DTEND:${this.stamp(x.open + 15 * 60000)}`, `SUMMARY:${e(this.title(x.n))}`, `DESCRIPTION:${e(text)}`, `URL:${url}`);
            lines.push('BEGIN:VALARM', `TRIGGER:-PT${alert}M`, 'ACTION:DISPLAY', `DESCRIPTION:${e(this.title(x.n))}`, 'END:VALARM', 'END:VEVENT');
          }
          lines.push('END:VCALENDAR');
          const a = document.createElement('a');
          a.href = URL.createObjectURL(new Blob([lines.join('\r\n')], { type: 'text/calendar' }));
          a.download = (this.title(ev[0].n) || 'door').replace(/[^\w-]+/g, '-').toLowerCase() + '.ics';
          document.body.append(a);
          a.click();
          a.remove();
          setTimeout(() => URL.revokeObjectURL(a.href), 4000);
        }

        // ---------- theme editor: preview any moment of the calendar ----------
        setupPreview() {
          const range = this.querySelector('[data-preview-range]');
          if (!range || !this.first) return;
          const h = 3600e3;
          const from = Math.floor((this.first.open - 864e5) / h) * h;
          const to = Math.ceil((this.last.close + 864e5) / h) * h;
          range.min = 0;
          range.max = Math.round((to - from) / h);
          range.step = 1;
          this.previewFrom = from;
          range.addEventListener('input', () => this.setFake(from + range.value * h, true), { signal: this.ac.signal });
          this.setFake(null);
        }

        setFake(ms, fromRange) {
          this.fake = ms;
          const range = this.querySelector('[data-preview-range]');
          const out = this.querySelector('[data-preview-out]');
          const now = this.now();
          if (range && !fromRange) range.value = Math.round((now - this.previewFrom) / 3600e3);
          if (out) out.textContent = this.fmt(now, { weekday: 'short', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) + (ms == null && this.t.nowTime ? ' · ' + this.t.nowTime : '');
          this.doors.forEach((x) => {
            if (x.sc && !x.sc.done) x.sc.destroy();
            x.sc = null;
          });
          this.tick(true);
        }

        // Reset in the preview bar: every door closed again (also the ones opened at the real time), back to now
        resetPreview() {
          this.opened = new Set();
          try {
            localStorage.removeItem(this.key);
          } catch {}
          [this.dialog, this.remind].forEach((dl) => dl?.open && dl.close());
          this.doors.forEach((x) => {
            delete x.el.dataset.state;
            x.el.classList.remove('is-shake', 'is-tip');
          });
          this.setFake(null);
        }

        onBlock(e) {
          const door = this.doors.find((x) => x.el === e.target);
          if (!door) return;
          if (this.querySelector('[data-preview-range]')) this.setFake(door.open + 3600e3);
          door.el.scrollIntoView({ block: 'center', behavior: this.speed ? 'smooth' : 'auto' });
        }

        // ---------- scratch to reveal (src/_shared/werk-scratch.js + werk-scratch.css) ----------
        // Pasted into the section's class: this.scratch(box, options) lays a canvas over box and returns
        // { reveal(), destroy(), done }. Options: color, threshold (share rubbed off, 0–1), brush (px), paint(ctx, w, h)
        // for what is printed on the layer, onDone(). No pointer capture on press, so a tap still reaches the page.
        scratch(box, o = {}) {
          const c = document.createElement('canvas');
          c.className = 'werk-door-calendar_scratch';
          c.setAttribute('aria-hidden', 'true');
          box.append(c);
          const ctx = c.getContext('2d');
          const ac = new AbortController();
          const sig = { signal: ac.signal };
          let w = 0;
          let h = 0;
          let done = false;
          let last = null;
          let moved = 0;
          const paint = () => {
            const r = box.getBoundingClientRect();
            if (!r.width || !r.height) return;
            const dpr = Math.min(window.devicePixelRatio || 1, 2);
            w = r.width;
            h = r.height;
            c.width = Math.round(w * dpr);
            c.height = Math.round(h * dpr);
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            ctx.globalCompositeOperation = 'source-over';
            ctx.fillStyle = o.color || '#2A2927';
            ctx.fillRect(0, 0, w, h);
            o.paint?.(ctx, w, h);
          };
          paint();
          const ro = new ResizeObserver(() => !done && !moved && paint());
          ro.observe(box);
          const brush = () => o.brush || Math.max(22, Math.min(w, h) * 0.16);
          const pos = (e) => {
            const r = c.getBoundingClientRect();
            return [e.clientX - r.left, e.clientY - r.top];
          };
          const rub = (a, b) => {
            ctx.globalCompositeOperation = 'destination-out';
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';
            ctx.lineWidth = brush();
            ctx.beginPath();
            ctx.moveTo(a[0], a[1]);
            ctx.lineTo(b[0], b[1]);
            ctx.stroke();
          };
          // share of the layer already rubbed off, read from a coarse grid
          const cleared = () => {
            const d = ctx.getImageData(0, 0, c.width, c.height).data;
            const n = 28;
            let clear = 0;
            for (let y = 0; y < n; y++)
              for (let x = 0; x < n; x++) {
                const i = ((Math.floor(((y + 0.5) / n) * c.height) * c.width + Math.floor(((x + 0.5) / n) * c.width)) << 2) + 3;
                if (d[i] < 40) clear++;
              }
            return clear / (n * n);
          };
          const finish = () => {
            if (done) return;
            done = true;
            c.classList.add('is-done');
            ro.disconnect();
            ac.abort();
            o.onDone?.();
            setTimeout(() => c.remove(), 700);
          };
          let pid = null;
          c.addEventListener('pointerdown', (e) => {
            if (done || e.button > 0) return;
            pid = e.pointerId;
            last = pos(e);
            rub(last, [last[0] + 0.1, last[1]]);
          }, sig);
          window.addEventListener('pointermove', (e) => {
            if (pid !== e.pointerId || done) return;
            const p = pos(e);
            moved += Math.hypot(p[0] - last[0], p[1] - last[1]);
            rub(last, p);
            last = p;
          }, sig);
          const up = (e) => {
            if (pid !== e.pointerId) return;
            pid = null;
            if (!done && cleared() >= (o.threshold || 0.5)) finish();
          };
          window.addEventListener('pointerup', up, sig);
          window.addEventListener('pointercancel', up, sig);
          return {
            reveal: finish,
            destroy() {
              ro.disconnect();
              ac.abort();
              c.remove();
            },
            get done() {
              return done;
            },
          };
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-drop-countdown"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-drop-countdown')) {
    customElements.define(
      'werk-drop-countdown',
      class extends HTMLElement {
        connectedCallback() {
          const q = (sel) => this.querySelector(sel);
          try {
            this.d = JSON.parse(q('script[data-werk]').textContent);
            this.t = JSON.parse(q('script[data-werk-t]').textContent);
          } catch {
            return;
          }
          this.look = this.d.look === 'veil' ? 'veil' : 'odometer';
          this.inner = q('.werk-drop-countdown_inner');
          this.groups = q('[data-groups]');
          this.speed = this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.root = window.Shopify?.routes?.root || '/';
          this.design = !!(this.d.design || window.Shopify?.designMode);
          this.skew = 0;
          this.state = '';
          this.product = null;

          // the drop: seconds from Liquid (store time zone); empty or unreadable = a demo countdown
          const rel = parseInt(this.d.release, 10);
          this.demo = !(rel > 1e9);
          this.release = this.demo ? this.nextDemo() : rel * 1000;
          const end = parseInt(this.d.ends, 10);
          this.ends = end > 1e9 ? end * 1000 : 0;
          if (this.d.raw && this.demo && this.design) this.note(this.t.invalid);

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'change', (e) => {
            const sel = e.target.closest('[data-select]');
            if (sel) this.pick(+sel.dataset.select, sel.value);
          });
          on(document, 'click', (e) => { if (!e.target.closest('[data-cal]')) this.menu(false); });
          on(document, 'keydown', (e) => { if (e.key === 'Escape') this.menu(false); });
          on(document, 'visibilitychange', () => { if (!document.hidden) this.tick(); });
          this.sheet = q('[data-sheet]');
          on(this.sheet, 'click', (e) => { if (e.target === this.sheet) this.sheet.close(); });

          this.ro = new ResizeObserver(() => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.fit()); });
          this.ro.observe(this);
          document.fonts?.ready.then(() => this.isConnected && this.fit());

          this.localTimes();
          this.syncTime();
          if (this.look === 'veil') this.probe();
          else if (this.dataset.fit === 'fit') this.edges();
          this.loop = () => {
            if (!this.isConnected) return;
            this.tick();
            this.tm = setTimeout(this.loop, 1000 - (this.now() % 1000) + 20);
          };
          this.loop();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.ro?.disconnect();
          clearTimeout(this.tm);
          clearTimeout(this.pollTm);
          clearTimeout(this.addTm);
          cancelAnimationFrame(this.raf);
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        note(text) {
          const n = this.querySelector('[data-note]');
          n.textContent = text;
          n.hidden = false;
        }

        now() {
          return Date.now() + (this.skew || 0);
        }

        // demo (no date set): always the next Friday 18:00 in the visitor's time – it rolls on, so it never runs out
        nextDemo() {
          const now = this.now();
          const d = new Date(now);
          d.setHours(18, 0, 0, 0);
          d.setDate(d.getDate() + ((5 - d.getDay() + 7) % 7));
          if (d.getTime() <= now) d.setDate(d.getDate() + 7);
          return d.getTime();
        }

        // a device clock that is off must not move the drop: compare once with the server's Date header
        async syncTime() {
          try {
            const t0 = Date.now();
            const r = await fetch(this.root + 'cart.js', { cache: 'no-store' });
            const h = r.headers.get('date');
            if (!h) return;
            const diff = Date.parse(h) + 500 - (t0 + Date.now()) / 2;
            if (Math.abs(diff) > 2000) {
              this.skew = diff;
              this.tick();
            }
          } catch {}
        }

        fmt(ms, o) {
          try {
            return new Intl.DateTimeFormat(document.documentElement.lang || undefined, o).format(new Date(ms));
          } catch {
            return new Date(ms).toLocaleString();
          }
        }

        localTimes() {
          const day = this.fmt(this.release, { weekday: 'short', day: 'numeric', month: 'short' });
          const time = this.fmt(this.release, { hour: '2-digit', minute: '2-digit' });
          let zone = '';
          try {
            zone = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { timeZoneName: 'short' }).formatToParts(new Date(this.release)).find((x) => x.type === 'timeZoneName')?.value || '';
          } catch {}
          this.querySelectorAll('[data-when]').forEach((el) => (el.textContent = `${day} · ${time}${zone ? ' ' + zone : ''}`));
          this.querySelectorAll('[data-local]').forEach((el) => (el.textContent = `${day} · ${time} ${this.t.yourTime}`.trim()));
          this.timeLabel = time;
        }

        // ---------- the clock ----------
        tick() {
          const now = this.now();
          if (this.demo && now >= this.release) {
            this.release = this.nextDemo();
            this.localTimes();
          }
          let st;
          if (this.ends && now >= this.ends) st = this.d.afterEnd === 'sold_out' ? 'soldout' : 'ended';
          else if (now < this.release - 60000) st = 'teaser';
          else if (now < this.release) st = 'soon';
          else if (this.product) st = this.product.available ? 'live' : 'soldout';
          else st = this.failed ? 'fallback' : 'unlocking';
          if (st === 'unlocking') this.unlock();
          this.setState(st, now);
          this.draw(now);
        }

        setState(st, now) {
          const after = this.d.after;
          if (st === 'live' && after === 'link') st = 'fallback';
          const hide = !this.design && ((after === 'hide' && /live|soldout|fallback/.test(st)) || (st === 'ended' && this.d.afterEnd === 'hide'));
          this.hidden = hide;
          if (st === this.state) return;
          this.state = st;
          this.dataset.state = st;
          const t = this.t;
          const word = this.querySelector('[data-word]');
          const words = { unlocking: t.unlocking, live: t.live, fallback: t.live, soldout: t.soldOut, ended: t.ended };
          word.hidden = !words[st];
          this.groups.hidden = !!words[st];
          this.querySelector('[data-word-text]').textContent = words[st] || '';
          const buy = this.querySelector('[data-buy]');
          const go = this.querySelector('[data-go]');
          const msg = this.querySelector('[data-msg]');
          buy.hidden = st !== 'live';
          go.hidden = !(st === 'fallback' && this.d.go);
          msg.hidden = st !== 'soldout' || !t.soldOutText;
          if (st === 'soldout') msg.textContent = t.soldOutText;
          if (st === 'live' && !this.built) this.buildBuy();
          this.status(now);
          const sr = this.querySelector('[data-sr]');
          sr.setAttribute('aria-live', 'polite');
          sr.textContent = words[st] || '';
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.fit());
        }

        status(now) {
          const t = this.t;
          const st = this.state;
          let text = t.upcoming + (this.d.edition ? ' · ' + this.d.edition : '');
          if (st === 'soon') text = t.soon;
          else if (st === 'unlocking') text = t.unlocking;
          else if (st === 'live' || st === 'fallback') {
            const mins = Math.max(0, Math.floor((now - this.release) / 60000));
            // after an hour the minutes stop counting; after a day the date comes in
            let tpl = t.liveSince;
            if (mins >= 60) tpl = tpl.replace(/\s*·[^·]*\[n\][^·]*$/, '').replace(/[^·]*\[n\][^·]*·\s*/, '');
            const at = mins >= 1440 ? `${this.fmt(this.release, { day: 'numeric', month: 'short' })}, ${this.timeLabel || ''}` : this.timeLabel || '';
            text = tpl.replace('[time]', at).replace('[n]', mins);
          } else if (st === 'soldout') text = t.soldOut;
          else if (st === 'ended') text = t.ended;
          this.querySelectorAll('[data-status]').forEach((el) => {
            if (el.textContent !== text) el.textContent = text;
          });
        }

        draw(now) {
          const left = Math.max(0, Math.ceil((this.release - now) / 1000));
          const d = Math.floor(left / 86400);
          const h = Math.floor((left % 86400) / 3600);
          const m = Math.floor((left % 3600) / 60);
          const sec = left % 60;
          const show = { d: d > 0, h: true, m: true, s: this.d.seconds !== false || this.state === 'soon' };
          const vals = { d, h, m, s: sec };
          let changed = false;
          for (const k of ['d', 'h', 'm', 's']) {
            const g = this.groups.querySelector(`[data-g="${k}"]`);
            const sep = this.groups.querySelector(`[data-sep="${k}"]`);
            const off = !show[k];
            if (g.hidden !== off) { g.hidden = off; changed = true; }
            if (sep) {
              const prevShown = k === 'h' ? show.d : true;
              const hideSep = off || !prevShown;
              if (sep.hidden !== hideSep) { sep.hidden = hideSep; changed = true; }
            }
            if (!off && this.digits(g, String(vals[k]).padStart(2, '0'))) changed = true;
          }
          if (changed) this.fit();
          // seconds line (Odometer): this minute's progress, in the last minute the time that's left
          const line = this.querySelector('[data-sec]');
          if (line) line.style.setProperty('--sec', this.state === 'soon' ? left / 60 : (60 - sec) / 60);
          if (this.look === 'veil') this.veil(now);
          if (this.state === 'live' || this.state === 'fallback') this.status(now);
          // screen readers: the remaining time once a minute, not every second
          const minute = Math.floor(left / 60);
          if (minute !== this.lastMinute && this.state === 'teaser') {
            this.lastMinute = minute;
            const sr = this.querySelector('[data-sr]');
            sr.removeAttribute('aria-live');
            const T = this.t;
            sr.textContent = [d && `${d} ${d === 1 ? T.day : T.days}`, `${h} ${h === 1 ? T.hour : T.hours}`, `${m} ${m === 1 ? T.minute : T.minutes}`].filter(Boolean).join(' ');
          }
        }

        // one rolling column per digit; returns true when the number of digits changed
        digits(g, str) {
          const num = g.querySelector('[data-num]');
          let built = false;
          if (num.childElementCount !== str.length) {
            num.innerHTML = [...str].map(() => '<span class="werk-drop-countdown_d"><span class="werk-drop-countdown_col">0\n1\n2\n3\n4\n5\n6\n7\n8\n9</span></span>').join('');
            built = true;
          }
          [...num.children].forEach((d, i) => d.firstChild.style.setProperty('--n', str[i]));
          return built;
        }

        u() {
          return parseFloat(getComputedStyle(this.inner).getPropertyValue('--werk-u')) || 1;
        }

        // digits as large as the width allows: font size from the number of characters
        fit() {
          if (!this.groups || !this.isConnected) return;
          const u = this.u();
          const vis = [...this.groups.children].filter((el) => !el.hidden);
          let chars = 0;
          vis.forEach((el) => (chars += el.classList.contains('werk-drop-countdown_sep') ? 1 : el.querySelector('[data-num]').childElementCount || 2));
          const wide = this.inner.clientWidth >= 990;
          const base = this.look === 'veil' ? (this.inner.clientWidth >= 990 ? 104 : this.inner.clientWidth >= 750 ? 72 : 40) * (this.inner.clientWidth >= 750 ? u : u * 1) : 196 * u;
          const max = this.look === 'odometer' && chars <= 8 ? base * 1.28 : base;
          let width;
          if (this.look === 'veil') {
            const cap = this.querySelector('.werk-drop-countdown_capsule');
            const cs = getComputedStyle(cap);
            width = this.inner.clientWidth - parseFloat(getComputedStyle(cap.parentElement).paddingLeft) - parseFloat(getComputedStyle(cap.parentElement).paddingRight) - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - 8;
            if (wide) width = Math.min(width, 1000 * u);
          } else width = this.groups.clientWidth || this.inner.clientWidth;
          const gaps = this.look === 'veil' ? (vis.length - 1) * parseFloat(getComputedStyle(this.groups).columnGap || 0) : 0;
          const fs = Math.max(12, Math.min(max, (width - gaps) / (chars * 0.6)));
          this.groups.style.setProperty('--fs', fs.toFixed(2) + 'px');
          const word = this.querySelector('[data-word]');
          if (this.look === 'odometer') word.style.setProperty('--fs', Math.min(max, width / ((word.textContent.trim().length + 1) * 0.6)).toFixed(2) + 'px');
          this.fitTitle();
        }

        // long names: two lines (three on phones in the Veil), then the type gets smaller – down to 60 % – before it's cut
        fitTitle() {
          const t = this.querySelector('.werk-drop-countdown_title:not(.werk-drop-countdown_title--bar)');
          if (!t || !t.offsetWidth) return;
          const max = this.look === 'veil' && this.inner.clientWidth < 750 ? 3 : 2;
          let scale = 1;
          t.style.setProperty('--tscale', 1);
          const lines = () => t.scrollHeight / (parseFloat(getComputedStyle(t).fontSize) * 1.02);
          while (lines() > max + 0.35 && scale > 0.6) {
            scale = Math.round((scale - 0.05) * 100) / 100;
            t.style.setProperty('--tscale', scale);
          }
        }

        // ---------- Veil: the picture sharpens over the last hours ----------
        veil(now) {
          const win = Math.max(1, this.d.veilWindow || 72) * 3600000;
          const live = !/teaser|soon|unlocking/.test(this.state);
          const r = live ? 0 : Math.min(1, Math.max(0, (this.release - now) / win));
          const blur = Math.round((this.d.veilMax ?? 44) * r * 10) / 10;
          if (blur !== this.blur) {
            this.blur = blur;
            const stage = this.querySelector('.werk-drop-countdown_stage');
            stage.style.setProperty('--blur', blur);
            stage.style.setProperty('--scrim', (1 - r).toFixed(3));
            const pct = Math.round((1 - r) * 100);
            const meter = this.querySelector('[data-clear]');
            if (meter) meter.textContent = `${this.t.clears} · ${pct} %`;
            stage.style.setProperty('--clear', (1 - r).toFixed(3));
          }
        }

        // "Text on the image: Auto" – brightness of a 16 px copy of the picture
        probe() {
          if (this.dataset.vtext !== 'auto' || !this.dataset.probe) return;
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = () => {
            try {
              const c = document.createElement('canvas');
              c.width = c.height = 16;
              const x = c.getContext('2d', { willReadFrequently: true });
              x.drawImage(img, 0, 0, 16, 16);
              const px = x.getImageData(0, 0, 16, 16).data;
              let l = 0;
              for (let i = 0; i < px.length; i += 4) l += (0.2126 * px[i] + 0.7152 * px[i + 1] + 0.0722 * px[i + 2]) / 255;
              this.dataset.tone = l / (px.length / 4) < 0.5 ? 'light' : 'dark';
            } catch {}
          };
          img.src = this.dataset.probe;
        }

        // "Fit": a photo on its own background gets that background continued – its edge pixels, row by row (or column
        // by column), stretched out to the frame (read from a 32 px copy). Cut-outs with transparency keep the image color.
        edges() {
          if (!this.dataset.probe) return;
          const media = this.querySelector('.werk-drop-countdown_media');
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = () => {
            try {
              const w = img.naturalWidth, h = img.naturalHeight;
              const c = document.createElement('canvas');
              c.width = w;
              c.height = h;
              const x = c.getContext('2d', { willReadFrequently: true });
              x.drawImage(img, 0, 0);
              // the outer 3 px averaged, then smoothed along the edge – a dark spot on the edge doesn't become a streak
              const strip = (vertical, fromEnd) => {
                const len = vertical ? h : w;
                const depth = Math.min(3, vertical ? w : h);
                const px = [];
                let alpha = 0;
                for (let i = 0; i < len; i++) {
                  const d = vertical ? x.getImageData(fromEnd ? w - depth : 0, i, depth, 1).data : x.getImageData(i, fromEnd ? h - depth : 0, 1, depth).data;
                  const c = [0, 0, 0];
                  for (let k = 0; k < d.length; k += 4) { c[0] += d[k]; c[1] += d[k + 1]; c[2] += d[k + 2]; alpha += d[k + 3] / depth; }
                  px.push(c.map((v) => v / depth));
                }
                const stops = px.map((_, i) => {
                  const win = px.slice(Math.max(0, i - 3), i + 4);
                  return `rgb(${[0, 1, 2].map((k) => Math.round(win.reduce((a, v) => a + v[k], 0) / win.length)).join(' ')})`;
                });
                return { stops, a: alpha / len / 255 };
              };
              const sides = w / h < media.clientWidth / media.clientHeight; // narrower than the frame: bars left and right
              const [p, q] = sides ? [strip(true, false), strip(true, true)] : [strip(false, false), strip(false, true)];
              if (p.a < 0.9 || q.a < 0.9) return;
              const g = (stops, dir) => `linear-gradient(${dir}, ${stops.join(', ')})`;
              media.style.background = sides
                ? `${g(p.stops, 'to bottom')} left / 50% 100% no-repeat, ${g(q.stops, 'to bottom')} right / 50% 100% no-repeat`
                : `${g(p.stops, 'to right')} top / 100% 50% no-repeat, ${g(q.stops, 'to right')} bottom / 100% 50% no-repeat`;
              // the photo's own edge fades into the continuation (a darker rim on the photo would show as a line)
              const frameAr = media.clientWidth / media.clientHeight;
              const inset = sides ? (1 - w / h / frameAr) * 50 : (1 - frameAr / (w / h)) * 50;
              const soft = 2.5;
              const dir = sides ? '90deg' : '180deg';
              const m = `linear-gradient(${dir}, transparent ${inset}%, #000 ${inset + soft}%, #000 ${100 - inset - soft}%, transparent ${100 - inset}%)`;
              const pic = media.querySelector('.werk-drop-countdown_img');
              pic.style.maskImage = m;
              pic.style.webkitMaskImage = m;
            } catch {}
          };
          img.src = this.dataset.probe;
        }

        // ---------- unlock: ask Shopify for the product until it's there ----------
        unlock() {
          if (this.polling || this.product || this.failed) return;
          if (!this.d.handle) {
            if (this.demo) this.product = this.d.demo;
            else this.failed = true;
            this.isDemoProduct = !!this.product;
            return this.tick();
          }
          this.polling = true;
          let tries = 0;
          const go = async () => {
            if (!this.isConnected) return;
            tries++;
            try {
              const r = await fetch(`${this.root}products/${encodeURIComponent(this.d.handle)}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
              if (r.ok) {
                const p = await r.json();
                if (p.available || tries >= 60) {
                  this.product = p;
                  this.polling = false;
                  return this.tick();
                }
              }
            } catch {}
            if (tries >= 60) {
              this.failed = true;
              this.polling = false;
              return this.tick();
            }
            this.pollTm = setTimeout(go, 2500 + Math.random() * 1500);
          };
          go();
        }

        // ---------- buy: options, availability, add to cart ----------
        norm(p) {
          let names = (p.options || []).map((o) => (typeof o === 'string' ? o : o.name));
          const vs = (p.variants || []).map((v) => ({
            id: v.id,
            o: v.options || [v.option1, v.option2, v.option3].filter((x) => x != null),
            a: !!v.available,
            p: v.price,
            c: v.compare_at_price,
          }));
          if (vs.length === 1 && (names.length <= 1) && /^(Title|Default Title)$/.test(names[0] || 'Title') ) names = [];
          const values = names.map((_, i) => [...new Set(vs.map((v) => v.o[i]))]);
          return { names, vs, values };
        }

        buildBuy() {
          this.built = true;
          const P = (this.P = this.norm(this.product));
          const first = P.vs.find((v) => v.a) || P.vs[0];
          this.sel = first ? [...first.o] : [];
          const total = P.values.reduce((a, v) => a + v.length, 0);
          this.buyMode = P.names.length === 0 ? 'single' : P.names.length >= 3 || total > 20 ? 'panel' : 'inline';
          const buy = this.querySelector('[data-buy]');
          if (this.buyMode === 'panel') {
            buy.innerHTML = `<span class="werk-drop-countdown_summary" data-summary></span>${this.btn('choose', this.t.choose)}`;
            this.querySelector('[data-sheet-body]').innerHTML = `<div class="werk-drop-countdown_buy">${this.opts(true)}${this.btn('add', this.t.addCart)}<p class="werk-drop-countdown_msg" data-add-msg hidden></p></div>`;
          } else {
            buy.innerHTML = `${this.buyMode === 'inline' ? this.opts(false) : ''}${this.btn('add', this.t.addCart)}<p class="werk-drop-countdown_msg" data-add-msg hidden></p>`;
          }
          this.update();
        }

        btn(kind, label) {
          const spin = '<svg class="werk-drop-countdown_spin" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-opacity=".25" stroke-width="2"/><path d="M20 12a8 8 0 0 0-8-8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
          const check = '<svg class="werk-drop-countdown_check" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          const arrow = '<span class="werk-drop-countdown_btn-dot" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M5 12h14m-5.5-5.5L19 12l-5.5 5.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
          const cls = 'werk-drop-countdown_btn' + (this.classList.contains('is-theme-buttons') ? ' button' : '') + (kind === 'add' ? ' werk-drop-countdown_btn--add' : '');
          const rows = kind === 'add'
            ? `<span class="werk-drop-countdown_btn-row">${arrow}<span data-add-label>${this.esc(label)}</span></span><span class="werk-drop-countdown_btn-row" aria-hidden="true">${spin}</span><span class="werk-drop-countdown_btn-row" aria-hidden="true">${check}${this.esc(this.t.added)}</span>`
            : `<span class="werk-drop-countdown_btn-row">${arrow}<span>${this.esc(label)}</span></span>`;
          return `<button type="button" class="${cls}" data-${kind}><span class="werk-drop-countdown_btn-roll">${rows}</span></button>`;
        }

        opts(inSheet) {
          const P = this.P;
          return `<div class="werk-drop-countdown_opts">${P.names
            .map((name, i) => {
              const vals = P.values[i];
              const select = vals.length > 24 || (!inSheet && this.look === 'veil' && vals.length > 9);
              const label = `<p class="werk-drop-countdown_opt-label">${this.esc(name)} — <span data-opt-val="${i}"></span></p>`;
              if (select) {
                return `<div class="werk-drop-countdown_opt">${label}<label class="werk-drop-countdown_select"><span class="werk-drop-countdown_sr">${this.esc(name)}</span><select data-select="${i}">${vals
                  .map((v) => `<option value="${this.esc(v)}">${this.esc(name)} · ${this.esc(v)}</option>`)
                  .join('')}</select></label></div>`;
              }
              return `<div class="werk-drop-countdown_opt" role="group" aria-label="${this.esc(name)}">${label}<div class="werk-drop-countdown_vals">${vals
                .map((v) => {
                  const sw = /colou?r|farbe|couleur/i.test(name) && CSS.supports('color', v.toLowerCase().replace(/\s+/g, '')) ? `<span class="werk-drop-countdown_swatch" style="background:${v.toLowerCase().replace(/\s+/g, '')}"></span>` : '';
                  return `<button type="button" class="werk-drop-countdown_val" data-val data-i="${i}" data-v="${this.esc(v)}" aria-pressed="false">${sw}${this.esc(v)}</button>`;
                })
                .join('')}</div></div>`;
            })
            .join('')}</div>`;
        }

        variant() {
          return this.P.vs.find((v) => v.o.every((x, k) => x === this.sel[k]));
        }

        // a value nobody can buy with the other choices: switch to the closest variant that is in stock
        pick(i, v) {
          this.sel[i] = v;
          const cur = this.variant();
          if (!cur || !cur.a) {
            const c = this.P.vs.filter((x) => x.o[i] === v && x.a).sort((a, b) => b.o.filter((x, k) => x === this.sel[k]).length - a.o.filter((x, k) => x === this.sel[k]).length)[0];
            if (c) this.sel = [...c.o];
          }
          this.update();
        }

        update() {
          const P = this.P;
          this.querySelectorAll('[data-val]').forEach((b) => {
            const i = +b.dataset.i;
            const v = b.dataset.v;
            const ok = P.vs.some((x) => x.a && x.o[i] === v && x.o.every((y, k) => k === i || y === this.sel[k]));
            b.classList.toggle('is-out', !ok);
            b.setAttribute('aria-pressed', String(this.sel[i] === v));
          });
          this.querySelectorAll('[data-select]').forEach((s) => (s.value = this.sel[+s.dataset.select]));
          this.querySelectorAll('[data-opt-val]').forEach((el) => (el.textContent = this.sel[+el.dataset.optVal] || ''));
          const sum = this.querySelector('[data-summary]');
          if (sum) sum.textContent = this.sel.join(' · ');
          const v = this.variant();
          const can = v && v.a;
          this.querySelectorAll('[data-add]').forEach((b) => {
            if (b.dataset.state) return;
            b.disabled = !can;
            b.querySelector('[data-add-label]').textContent = can ? `${this.t.addCart} · ${this.money(v.p)}` : this.t.unavailable;
          });
        }

        money(cents) {
          const f = (n, d, ts, ds) => {
            const [i, fr] = (n / 100).toFixed(d).split('.');
            return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (fr ? ds + fr : '');
          };
          const fmt = this.d.money || '$\{\{amount\}\}'.replace(/\\/g, '');
          return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
            if (k === 'amount_no_decimals') return f(cents, 0, ',', '.');
            if (k === 'amount_with_comma_separator') return f(cents, 2, '.', ',');
            if (k === 'amount_no_decimals_with_comma_separator') return f(cents, 0, '.', ',');
            if (k === 'amount_with_apostrophe_separator') return f(cents, 2, "'", '.');
            return f(cents, 2, ',', '.');
          });
        }

        esc(s) {
          return String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
        }

        onClick(e) {
          const el = e.target.closest('[data-cal-toggle], [data-cal-ics], [data-cal-google], [data-val], [data-add], [data-choose], [data-sheet-close]');
          if (!el) return;
          if (el.matches('[data-cal-toggle]')) this.menu(el.getAttribute('aria-expanded') !== 'true');
          else if (el.matches('[data-cal-ics]')) { this.ics(); this.menu(false); }
          else if (el.matches('[data-cal-google]')) { el.href = this.google(); this.menu(false); }
          else if (el.matches('[data-val]')) this.pick(+el.dataset.i, el.dataset.v);
          else if (el.matches('[data-choose]')) this.sheet.showModal();
          else if (el.matches('[data-sheet-close]')) this.sheet.close();
          else if (el.matches('[data-add]')) this.add(el);
        }

        menu(open) {
          const b = this.querySelector('[data-cal-toggle]');
          const m = this.querySelector('[data-cal-menu]');
          if (!b || !m) return;
          if (open) m.querySelector('[data-cal-google]').href = this.google();
          b.setAttribute('aria-expanded', String(!!open));
          m.hidden = !open;
        }

        stamp(ms) {
          return new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
        }

        // the calendar entry: title, text + link to this page, place, length and reminder from the settings
        cal() {
          const url = location.href.split('#')[0];
          const mins = parseInt(this.d.calDuration, 10) || 30;
          return {
            title: this.d.calTitle || this.d.title || '',
            text: [String(this.d.calDetails || '').trim(), url].filter(Boolean).join('\n\n'),
            place: String(this.d.calLocation || '').trim(),
            url,
            end: this.release + mins * 60000,
            remind: parseInt(this.d.calReminder, 10) || 0,
          };
        }

        google() {
          const c = this.cal();
          return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(c.title)}&dates=${this.stamp(this.release)}/${this.stamp(c.end)}&details=${encodeURIComponent(c.text)}${c.place ? '&location=' + encodeURIComponent(c.place) : ''}`;
        }

        // .ics for Apple Calendar / Outlook, made in the browser
        icsText() {
          const c = this.cal();
          const e = (str) => String(str || '').replace(/[\\;,]/g, (x) => '\\' + x).replace(/\r?\n/g, '\\n');
          const lines = [
            'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//werk//Drop Countdown//EN', 'BEGIN:VEVENT',
            `UID:${this.release}-${this.id}@werk.build`, `DTSTAMP:${this.stamp(Date.now())}`,
            `DTSTART:${this.stamp(this.release)}`, `DTEND:${this.stamp(c.end)}`,
            `SUMMARY:${e(c.title)}`, `DESCRIPTION:${e(c.text)}`, `URL:${c.url}`,
          ];
          if (c.place) lines.push(`LOCATION:${e(c.place)}`);
          if (c.remind > 0) lines.push('BEGIN:VALARM', `TRIGGER:-PT${c.remind}M`, 'ACTION:DISPLAY', `DESCRIPTION:${e(c.title)}`, 'END:VALARM');
          lines.push('END:VEVENT', 'END:VCALENDAR');
          return lines.join('\r\n');
        }

        ics() {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(new Blob([this.icsText()], { type: 'text/calendar' }));
          a.download = (this.d.title || 'drop').replace(/[^\w-]+/g, '-').toLowerCase() + '.ics';
          document.body.append(a);
          a.click();
          a.remove();
          setTimeout(() => URL.revokeObjectURL(a.href), 4000);
        }

        async add(btn) {
          if (btn.dataset.state || btn.disabled) return;
          const v = this.variant();
          if (!v || !v.a) return;
          const msg = btn.parentElement.querySelector('[data-add-msg]');
          if (msg) msg.hidden = true;
          btn.dataset.state = 'loading';
          const done = () => {
            btn.dataset.state = 'added';
            clearTimeout(this.addTm);
            this.addTm = setTimeout(() => {
              delete btn.dataset.state;
              if (this.sheet.open) this.sheet.close();
              this.update();
            }, 1600);
          };
          if (this.isDemoProduct || !this.d.handle) {
            setTimeout(done, 700);
            return;
          }
          try {
            const items = [{ id: v.id, quantity: 1 }];
            const res = await fetch(this.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            const cartP = fetch(this.root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: items.map((x) => ({ merchandiseId: x.id, quantity: x.quantity })),
              promise: cartP.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart(this.root);
            done();
          } catch (err) {
            delete btn.dataset.state;
            if (msg) {
              msg.textContent = this.t.error.replace('[message]', err?.description || err?.message || '').trim();
              msg.hidden = false;
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-drop-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('werk-drop-list')) {
    customElements.define(
      'werk-drop-list',
      class extends HTMLElement {
        connectedCallback() {
          const q = (sel) => this.querySelector(sel);
          try {
            this.d = JSON.parse(q('script[data-werk]').textContent);
            this.t = JSON.parse(q('script[data-werk-t]').textContent);
          } catch {
            return;
          }
          this.look = ['board', 'rail', 'tickets'].includes(this.d.look) ? this.d.look : 'board';
          this.inner = q('.werk-drop-list_inner');
          this.list = q('[data-list]');
          this.track = q('[data-track]');
          this.dialog = q('[data-dialog]');
          this.speed = this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.root = window.Shopify?.routes?.root || '/';
          this.design = !!(this.d.design || window.Shopify?.designMode);
          this.skew = 0;

          // the dates: ms from Liquid (store time zone); demo dates roll with the clock so the demo never runs out
          const base = this.nextFriday();
          // days from the next Friday 18:00, and the hour (calendar maths, so a DST change in between doesn't shift them)
          const demoAt = [[-13, 18], [-7, 18], [0, 18], [8, 12], [14, 18], [21, 18]].map(([dd, hh]) => {
            const x = new Date(base);
            x.setDate(x.getDate() + dd);
            x.setHours(hh, 0, 0, 0);
            return x.getTime();
          });
          this.items = [...this.list.children].map((el) => {
            const it = { el, at: parseInt(el.dataset.at, 10) || 0, end: parseInt(el.dataset.end, 10) || 0 };
            if (el.dataset.demo != null) {
              const k = +el.dataset.demo;
              it.at = k < 6 ? demoAt[k] : 0;
              if (k === 2) {
                const x = new Date(base);
                x.setDate(x.getDate() - 1);
                x.setHours(20, 0, 0, 0);
                it.end = x.getTime();
              }
            }
            it.draw = el.dataset.draw === 'true';
            it.sold = el.dataset.sold === 'true';
            it.key = el.dataset.key;
            it.sizes = el.dataset.sizes ? el.dataset.sizes.split('|') : [];
            it.parts = { date: el.querySelector('[data-date]'), time: el.querySelector('[data-time]'), status: el.querySelector('[data-status]'), kind: el.querySelector('[data-kind]'), stamp: el.querySelector('[data-stamp]'), tick: el.querySelector('[data-tick]'), sr: el.querySelector('[data-sr]') };
            return it;
          });
          // by date, TBA last (Liquid sorted already – this keeps demo dates and edits in order)
          this.items.sort((a, b) => (a.at || 9e15) - (b.at || 9e15));
          this.items.forEach((it, i) => {
            this.list.append(it.el);
            const no = it.el.querySelector('.werk-drop-list_no span');
            if (no) no.textContent = `${this.t.no || ''} ${String(i + 1).padStart(2, '0')}`.trim();
          });
          if (this.design && this.items.some((it) => it.el.dataset.at === '' && !it.el.dataset.demo && it.el.querySelector('[data-date]').textContent.trim() !== this.t.tba)) console.warn(this.t.invalid);

          try {
            this.entries = new Set(JSON.parse(localStorage.getItem('werk-drop-list-entries') || '[]'));
          } catch {
            this.entries = new Set();
          }

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          on(this, 'click', (e) => this.onClick(e));
          on(document, 'visibilitychange', () => { if (!document.hidden) this.tick(); });
          on(this.dialog, 'click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
          on(this.dialog?.querySelector('form'), 'submit', (e) => this.submit(e));
          on(document, 'shopify:block:select', (e) => this.select(e));
          if (this.look === 'rail') this.rail(on);
          if (this.look === 'tickets') {
            this.ro = new ResizeObserver(() => this.perf());
            this.ro.observe(this.list);
            document.fonts?.ready.then(() => this.isConnected && this.perf());
          }

          this.localTimes();
          this.tick(true);
          this.restore();
          this.syncTime();
          if (this.look === 'tickets') requestAnimationFrame(() => this.toNext());

          // the board rattles in once it scrolls into view
          if (this.look === 'board' && this.speed) {
            this.io = new IntersectionObserver((es) => {
              if (es.some((e) => e.isIntersecting)) {
                this.io.disconnect();
                this.rattleAll();
              }
            }, { threshold: 0.25 });
            this.io.observe(this.list);
          }
          this.loop = () => {
            if (!this.isConnected) return;
            this.tick();
            this.tm = setTimeout(this.loop, 1000 - (this.now() % 1000) + 20);
          };
          this.tm = setTimeout(this.loop, 1000 - (this.now() % 1000) + 20);
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          this.ro?.disconnect();
          clearTimeout(this.tm);
          clearInterval(this.capT);
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        now() {
          return Date.now() + (this.skew || 0);
        }

        // demo: the next drop is always the coming Friday 18:00 in the visitor's time
        nextFriday() {
          const now = Date.now();
          const d = new Date(now);
          d.setHours(18, 0, 0, 0);
          d.setDate(d.getDate() + ((5 - d.getDay() + 7) % 7));
          if (d.getTime() <= now) d.setDate(d.getDate() + 7);
          return d.getTime();
        }

        // a device clock that is off must not move the drops: compare once with the server's Date header
        async syncTime() {
          try {
            const t0 = Date.now();
            const r = await fetch(this.root + 'cart.js', { cache: 'no-store' });
            const h = r.headers.get('date');
            if (!h) return;
            const diff = Date.parse(h) + 500 - (t0 + Date.now()) / 2;
            if (Math.abs(diff) > 2000) {
              this.skew = diff;
              this.tick();
            }
          } catch {}
        }

        fmt(ms, o) {
          try {
            return new Intl.DateTimeFormat(document.documentElement.lang || undefined, o).format(new Date(ms));
          } catch {
            return new Date(ms).toLocaleString();
          }
        }

        // dates in the visitor's own time zone
        localTimes() {
          for (const it of this.items) {
            if (!it.at) {
              it.dateText = it.parts.date.textContent.trim();
              it.timeText = '--:--';
              continue;
            }
            it.dateText = this.day(it.at);
            it.timeText = this.fmt(it.at, { hour: '2-digit', minute: '2-digit', hour12: false });
            it.tickText = this.fmt(it.at, { day: '2-digit', month: '2-digit' });
            if (it.parts.tick) it.parts.tick.textContent = it.tickText;
            it.parts.sr.textContent = this.fmt(it.at, { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
          }
          if (this.look !== 'board') {
            for (const it of this.items) {
              it.parts.date.textContent = it.dateText;
              it.parts.time.textContent = it.timeText;
            }
          }
        }

        // FRI 09 OCT in the visitor's language, without commas or dots
        day(ms) {
          const part = (o) => this.fmt(ms, o).replace(/[.,]/g, '');
          return `${part({ weekday: 'short' })} ${part({ day: '2-digit' })} ${part({ month: 'short' })}`;
        }

        pad(n) {
          return String(n).padStart(2, '0');
        }

        // the state of every date, worked out every second
        tick(first) {
          const now = this.now();
          const live = (this.d.live || 24) * 36e5;
          let nextSet = false;
          const past = [];
          for (const it of this.items) {
            let state;
            if (!it.at) state = 'tba';
            else if (it.at > now) {
              state = !nextSet && this.d.next ? 'next' : 'soon';
              nextSet = true;
            } else if (now - it.at < live && !it.sold) state = 'live';
            else state = it.sold ? 'sold' : 'released';
            if (state === 'released' || state === 'sold') past.push(it);
            it.state = state;
          }
          // keep only the latest past drops
          past.sort((a, b) => b.at - a.at);
          const keep = Math.max(0, this.d.past ?? 2);
          const hide = new Set(past.slice(keep));
          let layout = false;

          for (const it of this.items) {
            const el = it.el;
            const was = el.dataset.state;
            if (was !== it.state) {
              el.dataset.state = it.state;
              layout = true;
              if (!first && (it.state === 'released' || it.state === 'sold' || it.state === 'live')) {
                el.classList.remove('is-flipped');
                void el.offsetWidth;
                el.classList.add('is-flipped');
              }
            }
            if (el.hidden !== hide.has(it)) {
              el.hidden = hide.has(it);
              layout = true;
            }
            const diff = it.at - now;
            const drawOpen = it.draw && it.state !== 'tba' && it.at > now && !(it.end && it.end <= now);
            el.toggleAttribute('data-draw-open', drawOpen);

            // status text
            let status = '';
            if (it.state === 'tba') status = this.t.tba;
            else if (it.state === 'live') status = this.t.live;
            else if (it.state === 'released') status = this.t.released;
            else if (it.state === 'sold') status = this.t.soldOut;
            else if (it.state === 'next') status = this.countdown(diff);
            else status = this.until(diff);
            it.statusText = status;

            // the action for this moment
            let act = it.el.querySelector('.werk-drop-list_act--view') ? 'view' : 'none';
            if (it.state === 'tba') act = 'coming';
            else if (it.state === 'sold') act = 'sold';
            else if (it.state === 'live' || it.state === 'released') act = it.el.querySelector('.werk-drop-list_act--shop') ? 'shop' : 'none';
            else if (it.draw) act = this.entries.has(it.key) ? 'in' : drawOpen ? 'draw' : 'closed';
            el.dataset.act = act;

            // the ticket stub's label
            let kind = '';
            if (it.draw && (it.state === 'next' || it.state === 'soon')) kind = this.entries.has(it.key) ? this.t.entered : drawOpen ? this.t.drawOpen : this.t.drawClosed;
            else if (it.state === 'soon' || it.state === 'next') kind = this.t.firstCome;
            else kind = status;
            if (it.parts.kind.textContent !== kind) it.parts.kind.textContent = kind;
            const stamp = it.state === 'sold' ? this.t.soldOut : this.t.released;
            if (it.parts.stamp.textContent !== stamp) it.parts.stamp.textContent = stamp;

            if (it.state === 'next') this.units(el, diff);
          }

          if (this.look === 'tickets') this.perf();
          if (this.look === 'board') this.flaps(first);
          else for (const it of this.items) if (it.parts.status.textContent !== it.statusText) it.parts.status.textContent = it.statusText;

          const clock = this.querySelector('[data-clock]');
          if (clock) clock.textContent = `${this.day(now)} · ${this.fmt(now, { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })}`.toLocaleUpperCase();
          if (this.look === 'rail') this.placeNow(layout || first);
        }

        countdown(ms) {
          const s = Math.max(0, Math.floor(ms / 1000));
          const d = Math.floor(s / 86400);
          const h = Math.floor((s % 86400) / 3600);
          const m = Math.floor((s % 3600) / 60);
          if (d > 0) return `${d}${this.t.dayShort} ${this.pad(h)}:${this.pad(m)}`;
          return this.d.seconds ? `${this.pad(h)}:${this.pad(m)}:${this.pad(s % 60)}` : `${this.pad(h)}:${this.pad(m)}`;
        }

        // calendar days from today (Sat 17 Oct is "in 13 days" all Sunday 4 Oct long), hours under two days
        until(ms) {
          const h = Math.ceil(ms / 36e5);
          if (h >= 48) {
            const a = new Date(this.now());
            const b = new Date(this.now() + ms);
            const days = Math.round((new Date(b.getFullYear(), b.getMonth(), b.getDate()) - new Date(a.getFullYear(), a.getMonth(), a.getDate())) / 864e5);
            return this.t.days.replace('[n]', days);
          }
          return this.t.hours.replace('[n]', Math.max(1, h));
        }

        units(el, ms) {
          const s = Math.max(0, Math.floor(ms / 1000));
          const v = { d: Math.min(99, Math.floor(s / 86400)), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
          el.querySelectorAll('[data-u]').forEach((b) => {
            const t = this.pad(v[b.dataset.u]);
            if (b.textContent !== t) b.textContent = t;
          });
        }

        // ---------- board: split flaps ----------
        flaps(first) {
          const up = (s) => s.toLocaleUpperCase();
          const cols = { date: 10, time: 5, status: 10 };
          for (const it of this.items) {
            cols.date = Math.max(cols.date, it.dateText.length);
            cols.time = Math.max(cols.time, it.timeText.length);
            cols.status = Math.max(cols.status, it.statusText.length);
          }
          if (this.cols?.date !== cols.date || this.cols?.time !== cols.time || this.cols?.status !== cols.status) {
            this.cols = cols;
            this.inner.style.setProperty('--dc', cols.date);
            this.inner.style.setProperty('--tc', cols.time);
            this.inner.style.setProperty('--sc', cols.status);
            for (const it of this.items) for (const k of ['date', 'time', 'status']) it.parts[k].textContent = '';
          }
          for (const it of this.items) {
            this.cells(it.parts.date, up(it.dateText), cols.date, first);
            this.cells(it.parts.time, it.timeText, cols.time, first);
            this.cells(it.parts.status, up(it.statusText), cols.status, first);
          }
        }

        cells(host, text, n, quiet) {
          let row = host.firstElementChild;
          if (!row || !row.classList.contains('werk-drop-list_cells')) {
            host.textContent = '';
            row = document.createElement('span');
            row.className = 'werk-drop-list_cells';
            for (let i = 0; i < n; i++) {
              const c = document.createElement('span');
              c.className = 'werk-drop-list_cell';
              c.innerHTML = '<b></b>';
              row.append(c);
            }
            host.append(row);
            quiet = true;
          }
          const hold = this.speed && this.waiting !== false;
          const chars = [...text.padEnd(n, ' ')].slice(0, n);
          [...row.children].forEach((c, i) => {
            const ch = chars[i] === ' ' ? '\u00a0' : chars[i];
            const b = c.firstChild;
            c.dataset.c = ch;
            if (hold) return (b.textContent = '\u00a0');
            if (b.textContent === ch) return;
            if (quiet || !this.speed) b.textContent = ch;
            else this.flip(b, ch, i * 30);
          });
        }

        // one cell rattles through a few characters, then lands
        flip(b, ch, delay, steps = 3) {
          const pool = 'ABCDEFGHIJKLMNOPRSTUVWXYZ0123456789';
          const token = (b._t = (b._t || 0) + 1);
          for (let k = 0; k <= steps; k++) {
            setTimeout(() => {
              if (b._t !== token || !b.isConnected) return;
              b.textContent = k === steps ? ch : pool[(Math.random() * pool.length) | 0];
              b.animate?.([{ transform: 'rotateX(0deg)' }, { transform: 'rotateX(-80deg)', opacity: 0.6 }, { transform: 'rotateX(0deg)' }], { duration: 70, easing: 'ease-out' });
            }, delay + k * 55);
          }
        }

        rattleAll() {
          this.waiting = false;
          this.items.forEach((it, r) => {
            for (const k of ['date', 'time', 'status']) {
              const row = it.parts[k].firstElementChild;
              if (!row) continue;
              [...row.children].forEach((c, i) => {
                const ch = c.dataset.c;
                if (ch && ch !== '\u00a0') this.flip(c.firstChild, ch, r * 90 + i * 24 + (k === 'status' ? 160 : k === 'time' ? 80 : 0), 4 + ((Math.random() * 4) | 0));
              });
            }
          });
        }

        // ---------- rail: drag, arrows, the now line ----------
        rail(on) {
          const tr = this.track;
          let x0 = 0;
          let s0 = 0;
          let moved = false;
          let down = false;
          // capture only once it is a drag – capturing on pointerdown retargets the click to the track (buttons and links stop working)
          on(tr, 'pointerdown', (e) => {
            if (e.pointerType !== 'mouse' || e.button !== 0) return;
            x0 = e.clientX;
            s0 = tr.scrollLeft;
            moved = false;
            down = true;
          });
          on(tr, 'pointermove', (e) => {
            if (!down) return;
            const dx = e.clientX - x0;
            if (!moved && Math.abs(dx) > 4) {
              moved = true;
              tr.setPointerCapture(e.pointerId);
              tr.classList.add('is-drag');
            }
            if (moved) tr.scrollLeft = s0 - dx;
          });
          const end = () => {
            down = false;
            tr.classList.remove('is-drag');
          };
          on(tr, 'pointerup', end);
          on(tr, 'pointercancel', end);
          on(tr, 'click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, { capture: true });
          on(tr, 'scroll', () => this.arrows(), { passive: true });
          this.ro = new ResizeObserver(() => this.placeNow(true));
          this.ro.observe(tr);
          document.fonts?.ready.then(() => this.isConnected && this.placeNow(true, true));
        }

        placeNow(relayout, jump) {
          const line = this.querySelector('[data-now]');
          if (!line) return;
          const now = this.now();
          const vis = this.items.filter((it) => !it.el.hidden);
          let a = null;
          let b = null;
          for (const it of vis) {
            if (it.at && it.at <= now) a = it;
            else if (!b && it.at > now) b = it;
          }
          const gap = parseFloat(getComputedStyle(this.list).columnGap) || 32;
          let x;
          if (a && b) {
            const f = Math.min(0.8, Math.max(0.2, (now - a.at) / (b.at - a.at)));
            const ar = a.el.offsetLeft + a.el.offsetWidth;
            x = ar + (b.el.offsetLeft - ar) * f;
          } else if (b) x = b.el.offsetLeft - gap / 2;
          else if (a) x = a.el.offsetLeft + a.el.offsetWidth + gap / 2;
          else x = 0;
          x = Math.round(x);
          this.list.style.setProperty('--now', x + 'px');
          line.style.setProperty('--now', x + 'px');
          const pill = this.querySelector('[data-now-pill]');
          const label = `${this.t.now} · ${this.fmt(now, { hour: '2-digit', minute: '2-digit', hour12: false })}`;
          if (pill.textContent !== label) pill.textContent = label;
          this.nowX = x;
          requestAnimationFrame(() => line.classList.add('is-ready'));
          if (jump || (relayout && !this.jumped)) this.jumpNow(false);
          this.arrows();
        }

        jumpNow(smooth = true) {
          const tr = this.track;
          if (!tr || this.nowX == null) return;
          this.jumped = true;
          const left = Math.max(0, this.nowX - tr.clientWidth * (tr.clientWidth < 750 ? 0.08 : 0.3));
          tr.scrollTo({ left, behavior: smooth && this.speed ? 'smooth' : 'auto' });
        }

        arrows() {
          const tr = this.track;
          const [prev, next] = this.querySelectorAll('[data-step]');
          if (!prev) return;
          prev.disabled = tr.scrollLeft <= 2;
          next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 2;
        }

        // tickets: where the perforation runs (top of the stub) – the mask punches the notches and holes there
        perf() {
          for (const it of this.items) {
            const y = it.el.querySelector('.werk-drop-list_stub')?.offsetTop;
            if (y && it.perf !== y) {
              it.perf = y;
              it.el.style.setProperty('--perf', y + 'px');
            }
          }
        }

        // tickets on phones: a swipe row that starts at the next drop
        toNext() {
          const tr = this.track;
          if (!tr || tr.scrollWidth <= tr.clientWidth + 2) return;
          const it = this.items.find((x) => !x.el.hidden && (x.state === 'next' || x.state === 'soon' || x.state === 'live'));
          if (it) tr.scrollLeft = Math.max(0, it.el.offsetLeft - 16);
        }

        // ---------- clicks, editor ----------
        onClick(e) {
          const t = e.target.closest('[data-open], [data-close], [data-jump], [data-step]');
          if (!t) return;
          if (t.hasAttribute('data-open')) this.open(this.items.find((it) => it.el.contains(t)));
          else if (t.hasAttribute('data-close')) this.dialog.close();
          else if (t.hasAttribute('data-jump')) this.jumpNow();
          else if (t.dataset.step) {
            const card = this.items.find((it) => !it.el.hidden)?.el;
            const w = (card?.offsetWidth || 240) + 40;
            this.track.scrollBy({ left: +t.dataset.step * w * (this.track.clientWidth > 900 ? 2 : 1), behavior: this.speed ? 'smooth' : 'auto' });
          }
        }

        select(e) {
          const it = this.items.find((x) => x.el.dataset.block === e.detail?.blockId);
          if (!it) return;
          it.el.hidden = false;
          if (this.look === 'rail') this.track.scrollTo({ left: Math.max(0, it.el.offsetLeft - 40), behavior: 'smooth' });
          else if (this.look === 'tickets' && this.track.scrollWidth > this.track.clientWidth) this.track.scrollTo({ left: it.el.offsetLeft - 16, behavior: 'smooth' });
        }

        // ---------- draw ----------
        open(it, error) {
          if (!it || !this.dialog) return;
          this.current = it;
          const q = (s) => this.dialog.querySelector(s);
          const name = it.el.querySelector('.werk-drop-list_name').textContent;
          q('[data-dlg-name]').textContent = name;
          const meta = it.el.querySelector('.werk-drop-list_meta')?.cloneNode(true);
          meta?.querySelector('.werk-drop-list_meta-draw')?.remove();
          q('[data-dlg-meta]').textContent = [it.dateText, it.timeText, meta?.textContent.trim()].filter(Boolean).join(' · ');
          q('[data-dlg-kicker]').textContent = `${this.t.enter} · ${it.el.querySelector('.werk-drop-list_no span')?.textContent || ''}`;
          const thumb = q('[data-dlg-thumb]');
          const img = it.el.querySelector('.werk-drop-list_img');
          thumb.innerHTML = img ? `<img src="${img.currentSrc || img.src}" alt="">` : '';
          // sizes: the product's first option
          const box = q('[data-sizes]');
          const chips = q('[data-chips]');
          chips.textContent = '';
          const show = this.d.askSize && it.sizes.length > 1;
          box.hidden = !show;
          if (show) {
            q('[data-size-name]').textContent = it.el.dataset.sizeName;
            const field = this.d.target === 'contact' ? 'contact[Size]' : 'werk-size';
            it.sizes.forEach((v, i) => {
              const l = document.createElement('label');
              l.innerHTML = '<input type="radio"><span></span>';
              const inp = l.firstChild;
              inp.name = field;
              inp.value = v;
              inp.required = i === 0;
              l.lastChild.textContent = v;
              chips.append(l);
            });
          }
          const err = q('[data-error]');
          err.hidden = !error;
          err.textContent = error || '';
          q('[data-step-form]').hidden = false;
          q('[data-step-done]').hidden = true;
          if (!this.dialog.open) this.dialog.showModal();
        }

        submit(e) {
          const it = this.current;
          const form = e.target;
          if (!it) return e.preventDefault();
          const size = form.querySelector('[data-chips] input:checked')?.value || '';
          const slug = (v) => String(v).toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          const tags = form.querySelector('[data-tags]');
          if (tags) tags.value = ['werk-draw', 'draw-' + it.key, size && `draw-${it.key}-${slug(size)}`].filter(Boolean).join(', ');
          const drop = form.querySelector('[data-f-drop]');
          if (drop) drop.value = it.el.querySelector('.werk-drop-list_name').textContent;
          const date = form.querySelector('[data-f-date]');
          if (date) date.value = `${it.dateText} ${it.timeText}`;
          try {
            sessionStorage.setItem('werk-drop-list-pending', JSON.stringify({ s: this.d.section, key: it.key, size }));
          } catch {}
          this.watchCaptcha();
        }

        // Shopify's bot check (hCaptcha) may ask for a challenge. It opens outside the dialog, and the modal dialog
        // would cover it and make it inert – so the dialog steps aside while the challenge shows, and comes back
        // (still filled in) if the challenge is closed without sending
        watchCaptcha() {
          clearInterval(this.capT);
          const shown = () => [...document.querySelectorAll('iframe[src*="hcaptcha"]')].some((fr) => {
            if (fr.closest('dialog')) return false;
            const r = fr.getBoundingClientRect();
            return r.width > 50 && r.height > 50 && r.bottom > 0 && r.top < innerHeight && getComputedStyle(fr).visibility !== 'hidden';
          });
          const t0 = Date.now();
          let aside = false;
          this.capT = setInterval(() => {
            if (shown()) {
              if (!aside && this.dialog.open) {
                aside = true;
                this.dialog.close();
              }
            } else if (aside) {
              clearInterval(this.capT);
              if (!this.dialog.open) this.dialog.showModal();
            } else if (Date.now() - t0 > 20000) clearInterval(this.capT);
          }, 150);
        }

        // after Shopify's reload: success opens the dialog in its done state, an error reopens the form
        restore() {
          let p = null;
          try {
            p = JSON.parse(sessionStorage.getItem('werk-drop-list-pending') || 'null');
          } catch {}
          if (!p || p.s !== this.d.section) return;
          const it = this.items.find((x) => x.key === p.key);
          const flag = this.querySelector('[data-posted]');
          const url = new URL(location.href);
          const posted = flag?.dataset.posted === '1' || url.searchParams.get('customer_posted') === 'true' || url.searchParams.get('contact_posted') === 'true';
          const errors = flag?.dataset.errors || '';
          try {
            sessionStorage.removeItem('werk-drop-list-pending');
          } catch {}
          if (!it) return;
          if (posted) {
            this.entries.add(it.key);
            try {
              localStorage.setItem('werk-drop-list-entries', JSON.stringify([...this.entries]));
            } catch {}
            url.searchParams.delete('customer_posted');
            url.searchParams.delete('contact_posted');
            history.replaceState(history.state, '', url.pathname + url.search);
            this.tick();
            this.open(it);
            const name = it.el.querySelector('.werk-drop-list_name').textContent;
            this.dialog.querySelector('[data-done-text]').textContent = this.t.doneText.replace('[drop]', name + (p.size ? ' · ' + p.size : '')).replace('[date]', `${it.dateText} ${it.timeText}`);
            this.dialog.querySelector('[data-step-form]').hidden = true;
            this.dialog.querySelector('[data-step-done]').hidden = false;
            if (this.look === 'tickets' && this.speed) it.el.classList.add('is-torn');
          } else if (errors) this.open(it, errors);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-hotspot-index"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-hotspot-index')) {
    customElements.define(
      'werk-hotspot-index',
      class extends HTMLElement {
        connectedCallback() {
          const q = (s) => this.querySelector(s);
          const qa = (s) => [...this.querySelectorAll(s)];
          this.frame = q('.werk-hotspot-index_frame');
          this.canvas = q('.werk-hotspot-index_canvas');
          this.svg = q('.werk-hotspot-index_lines');
          this.runner = q('.werk-hotspot-index_runner');
          this.list = q('.werk-hotspot-index_index');
          this.chips = qa('.werk-hotspot-index_chip');
          this.legend = this.dataset.look === 'legend';
          this.spots = qa('.werk-hotspot-index_hotspot');
          this.cards = qa('.werk-hotspot-index_card');
          this.i = -1;
          this.speed =
            this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.offset();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: ac.signal });
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'keydown', (e) => this.onKey(e));
          on(this, 'submit', (e) => this.onSubmit(e));
          on(this, 'pointerover', (e) => this.hover(e, true));
          on(this, 'pointerout', (e) => this.hover(e, false));
          on(document, 'shopify:block:select', (e) => {
            const i = this.spots.indexOf(e.target);
            if (i > -1) this.go(i);
          });
          on(document, 'shopify:block:deselect', (e) => {
            if (this.spots.includes(e.target)) this.close();
          });

          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.layout());
          });
          this.ro.observe(this);
          this.seed = this.hasAttribute('data-seed') && this.speed;
          if (this.seed) this.seedFrom();
          this.io = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              this.io.disconnect();
              if (this.seed) {
                this.seedFrom();
                this.classList.add('is-seeding');
                setTimeout(() => this.classList.remove('is-seeding'), 1400 + this.spots.length * 70);
              }
              requestAnimationFrame(() => this.classList.add('is-inview'));
              if (this.hasAttribute('data-open-first') && this.clientWidth >= 750 && this.i < 0) setTimeout(() => this.go(0), 600 * this.speed);
            },
            { threshold: 0.25 }
          );
          this.io.observe(this);
        }

        disconnectedCallback() {
          this.ac.abort();
          this.ro.disconnect();
          this.io.disconnect();
          clearTimeout(this.t);
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) { bg = c; break; }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        seedFrom() {
          const fw = this.frame.clientWidth / 2;
          const fh = this.frame.clientHeight / 2;
          this.spots.forEach((s, k) => {
            const [x, y] = this.pt(k);
            s.style.setProperty('--sx', fw - x + 'px');
            s.style.setProperty('--sy', fh - y + 'px');
          });
        }

        unit() {
          const w = this.clientWidth;
          return w < 750 ? Math.min(w / 390, 1.15) : w < 990 ? Math.min(w / 768, 1.1) : Math.min(w / 1440, 1);
        }

        wait(ms, fn) {
          clearTimeout(this.t);
          this.t = setTimeout(fn, ms * this.speed);
        }

        onClick(e) {
          const t = e.target.closest('[data-go], [data-action]');
          if (!t) {
            return;
          }
          const i = +t.dataset.go;
          if (t.dataset.action === 'close') return this.close();
          if (i === this.i) return this.close();
          this.go(i);
        }

        onKey(e) {
          if (this.i < 0) return;
          if (e.key === 'Escape') return this.close();
        }

        hover(e, on) {
          if (e.pointerType === 'touch') return;
          const card = e.target.closest('.werk-hotspot-index_card');
          const spot = e.target.closest('.werk-hotspot-index_hotspot');
          const i = card ? this.cards.indexOf(card) : spot ? this.spots.indexOf(spot) : -1;
          if (i < 0 || (e.relatedTarget && (card || spot).contains(e.relatedTarget))) return;
          this.spots[i].classList.toggle('is-hover', on);
          this.cards[i].classList.toggle('is-hover', on);
        }

        go(i, dir) {
          const prev = this.i;
          if (i === prev) return;
          dir = dir || (prev < 0 ? 0 : i > prev ? 1 : -1);
          this.i = i;
          this.classList.add('is-open');
          this.spots.forEach((s, k) => {
            s.classList.toggle('is-active', k === i);
            s.setAttribute('aria-expanded', k === i);
          });
          this.swap(prev, i, 0);
          this.chips.forEach((c, k) => c.classList.toggle('is-active', k === i));
          this.svg.classList.remove('is-on');
          this.wait(560, () => this.lines(true));
          if (this.legend) this.sheet(prev < 0);
          else if (this.clientWidth < 990) this.cards[i].scrollIntoView({ block: 'nearest', behavior: this.speed ? 'smooth' : 'auto' });
        }

        swap(prev, i, dir) {
          const next = this.cards[i];
          const old = this.cards[prev];
          if (old && old !== next) old.style.setProperty('--to', -dir || -1);
          this.cards.forEach((c) => c !== next && c.classList.remove('is-active'));
          next.style.setProperty('--rise', dir ? 0 : 12);
          next.style.setProperty('--from', dir);
          if (dir) {
            next.classList.add('is-prep');
            next.offsetWidth;
            next.classList.remove('is-prep');
          }
          next.classList.add('is-active');
          this.cards.forEach((c, k) => {
            const on = k === i;
            c.querySelectorAll('.werk-hotspot-index_card-media, .werk-hotspot-index_card-body').forEach((el) => (el.inert = !on));
            c.querySelector('.werk-hotspot-index_toggle').setAttribute('aria-expanded', on);
          });
        }

        close() {
          const i = this.i;
          if (i < 0) return;
          this.i = -1;
          this.classList.remove('is-open');
          this.spots.forEach((s) => {
            s.classList.remove('is-active');
            s.setAttribute('aria-expanded', 'false');
          });
          const c = this.cards[i];
          this.chips.forEach((ch) => ch.classList.remove('is-active'));
          if (this.legend) this.sheet();
          c.classList.remove('is-active');
          c.querySelectorAll('.werk-hotspot-index_card-media, .werk-hotspot-index_card-body').forEach((el) => (el.inert = true));
          c.querySelector('.werk-hotspot-index_toggle').setAttribute('aria-expanded', 'false');
          clearTimeout(this.t);
          this.lines();
        }

        layout() {
          this.offset();
          this.keep();
          this.clip();
          if (this.i < 0) return;
          if (this.svg.classList.contains('is-on')) this.lines();
          if (this.legend) this.sheet();
        }

        offset() {
          const v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
          let h = v;
          if (isNaN(v)) {
            const el = document.querySelector('.shopify-section-group-header-group, header');
            h = el && /sticky|fixed/.test(getComputedStyle(el).position) ? el.offsetHeight : 0;
          }
          this.style.setProperty('--werk-offset', h + 'px');
        }

        // Keeps every hotspot inside the crop: slides the image within its frame, and when "fit to screen"
        // would still cut hotspots off, lets the frame grow just enough to show them.
        keep() {
          const c = this.canvas;
          const f = this.frame;
          c.style.removeProperty('--fx');
          c.style.removeProperty('--fy');
          const m = 28 * this.unit();
          const xs = this.spots.map((s) => s.dataset.x / 100);
          const ys = this.spots.map((s) => s.dataset.y / 100);
          if (!xs.length) return;
          if (this.classList.contains('is-fit')) {
            const need = (Math.max(...ys) - Math.min(...ys)) * (f.clientWidth / parseFloat(getComputedStyle(this).getPropertyValue('--r'))) + 2 * m;
            this.style.setProperty('--werk-minh', Math.ceil(need) + 'px');
          }
          const axis = (frame, size, list, pos) => {
            const room = frame - size;
            if (room > -1) return;
            const lo = Math.max(room, frame - m - Math.max(...list) * size);
            const hi = Math.min(0, m - Math.min(...list) * size);
            const want = lo <= hi ? Math.min(hi, Math.max(lo, pos)) : Math.min(0, Math.max(room, frame / 2 - ((Math.min(...list) + Math.max(...list)) / 2) * size));
            return want / room;
          };
          const fx = axis(f.clientWidth, c.offsetWidth, xs, c.offsetLeft);
          const fy = axis(f.clientHeight, c.offsetHeight, ys, c.offsetTop);
          if (fx != null) c.style.setProperty('--fx', fx);
          if (fy != null) c.style.setProperty('--fy', fy);
        }

        clip() {
          const m = 12 * this.unit();
          const fw = this.frame.clientWidth;
          const fh = this.frame.clientHeight;
          this.spots.forEach((s, k) => {
            const [x, y] = this.pt(k);
            s.classList.toggle('is-out', x < m || y < m || x > fw - m || y > fh - m);
          });
        }

        pt(i) {
          const c = this.canvas;
          const s = this.spots[i];
          return [c.offsetLeft + (s.dataset.x / 100) * c.offsetWidth, c.offsetTop + (s.dataset.y / 100) * c.offsetHeight];
        }

        // Legend on phones: the open legend is lifted into the top layer as a sheet (popover="manual")
        sheet(fresh) {
          const l = this.list;
          if (!l.showPopover) return;
          const want = this.i > -1 && this.clientWidth < 750;
          const is = l.matches(':popover-open');
          if (want && !is) {
            l.showPopover();
            if (fresh && this.speed && l.animate) l.animate([{ translate: '0 24px', opacity: 0 }, { translate: '0 0', opacity: 1 }], { duration: 500, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
          }
          if (!want && is) l.hidePopover();
        }

        lines(draw) {
          const svg = this.svg;
          if (this.i < 0 || this.clientWidth < 990) return svg.classList.remove('is-on');
          const [a, b] = svg.children;
          const u = this.unit();
          const st = svg.getBoundingClientRect();
          const fr = this.frame.getBoundingClientRect();
          const hr = this.cards[this.i].querySelector('.werk-hotspot-index_card-head').getBoundingClientRect();
          const [px, py] = this.pt(this.i);
          const ry = hr.top - st.top + hr.height / 2;
          if (this.legend) {
            // from the legend's edge: a short slope, then level with the pin, ending at its ring
            const lr = this.list.getBoundingClientRect();
            const tx = fr.left - st.left + px;
            const ty = fr.top - st.top + py;
            const dir = tx >= lr.left + lr.width / 2 - st.left ? 1 : -1;
            const x1 = (dir > 0 ? lr.right : lr.left) - st.left;
            const x2 = tx - dir * 22 * u;
            const run = Math.max(60 * u, Math.abs(ty - ry) * 0.28);
            a.setAttribute('d', (x2 - x1) * dir > run + 8 ? `M${x1} ${ry} L${x1 + dir * run} ${ty} H${x2}` : `M${x1} ${ry} L${x2} ${ty}`);
            b.setAttribute('d', `M${x1} ${ry} h0`);
          } else {
            const left = this.classList.contains('is-side-left');
            const dx = left ? -1 : 1;
            const x = fr.left - st.left + px + dx * 22 * u;
            const y = fr.top - st.top + py;
            const edge = (left ? fr.left : fr.right) - st.left;
            const ex = edge - dx * 60 * u;
            a.setAttribute('d', (ex - x) * dx > 8 ? `M${x} ${y} H${ex} L${edge} ${ry}` : `M${x} ${y} L${edge} ${ry}`);
            b.setAttribute('d', `M${edge} ${ry} h${dx * 36 * u}`);
          }
          (this.legend ? [a] : [a, b]).forEach((p) => {
            const len = p.getTotalLength();
            p.style.strokeDasharray = len;
            if (draw) {
              p.style.transition = 'none';
              p.style.strokeDashoffset = len;
              p.getBoundingClientRect();
              p.style.transition = '';
            }
            p.style.strokeDashoffset = 0;
          });
          svg.classList.add('is-on');
          const r = this.runner;
          if (draw && this.speed && r.animate) {
            r.style.offsetPath = `path('${a.getAttribute('d')}')`;
            r.animate(
              [
                { offsetDistance: '0%', opacity: 0 },
                { offsetDistance: '8%', opacity: 1, offset: 0.1 },
                { offsetDistance: '92%', opacity: 1, offset: 0.9 },
                { offsetDistance: '100%', opacity: 0 },
              ],
              { duration: 1100, delay: 350, easing: 'cubic-bezier(0.38, 0.005, 0.215, 1)' }
            );
          }
        }

        fly(btn) {
          const dot = this.querySelector('.werk-hotspot-index_fly');
          const cart = document.querySelector('cart-icon, #cart-icon-bubble, [data-cart-icon], a[href$="/cart"]');
          if (!dot || !cart || !this.speed || !dot.showPopover || !dot.animate) return;
          const a = btn.getBoundingClientRect();
          const b = cart.getBoundingClientRect();
          if (!b.width) return;
          const x0 = a.left + a.width / 2;
          const y0 = a.top + a.height / 2;
          const x1 = b.left + b.width / 2;
          const y1 = b.top + b.height / 2;
          const cx = (x0 + x1) / 2;
          const cy = Math.min(y0, y1) - Math.min(180, Math.abs(y1 - y0) * 0.35 + 60);
          const frames = [];
          for (let k = 0; k <= 16; k++) {
            const t = k / 16;
            const x = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x1;
            const y = (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * cy + t * t * y1;
            frames.push({ transform: `translate(${x}px, ${y}px) scale(${1 - t * 0.55})`, opacity: t > 0.9 ? (1 - t) * 10 : 1 });
          }
          dot.showPopover();
          dot.animate(frames, { duration: 900, easing: 'cubic-bezier(0.6234, 0.058, 0, 0.9095)' }).finished.then(
            () => dot.hidePopover(),
            () => dot.hidePopover()
          );
        }

        async onSubmit(e) {
          const form = e.target.closest('.werk-hotspot-index_form');
          if (!form) return;
          e.preventDefault();
          const btn = form.querySelector('button');
          if (btn.dataset.state || btn.disabled) return;
          const id = form.elements.id?.value;
          if (!id) return void (location.href = form.dataset.fallback || '/');
          const root = window.Shopify?.routes?.root || '/';
          btn.dataset.state = 'loading';
          try {
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }),
            });
            if (!res.ok) throw new Error(res.status);
            btn.dataset.state = 'added';
            this.fly(btn);
            const cart = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: id, quantity: 1 }],
              promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart(root);
            setTimeout(() => delete btn.dataset.state, 2400);
          } catch {
            delete btn.dataset.state;
            form.submit();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-hotspot-panel"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-hotspot-panel')) {
    customElements.define(
      'werk-hotspot-panel',
      class extends HTMLElement {
        connectedCallback() {
          const q = (s) => this.querySelector(s);
          const qa = (s) => [...this.querySelectorAll(s)];
          this.frame = q('.werk-hotspot-panel_frame');
          this.canvas = q('.werk-hotspot-panel_canvas');
          this.dialog = q('.werk-hotspot-panel_dialog');
          this.drawer = this.dataset.look === 'drawer';
          this.spots = qa('.werk-hotspot-panel_hotspot');
          this.cards = qa('.werk-hotspot-panel_card');
          this.digits = qa('.werk-hotspot-panel_digit');
          this.counter = q('[data-count]');
          this.i = -1;
          this.speed =
            this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.offset();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: ac.signal });
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'keydown', (e) => this.onKey(e));
          on(this, 'submit', (e) => this.onSubmit(e));
          on(this, 'pointerdown', (e) => this.drag(e));
          on(this, 'pointerover', (e) => this.hover(e, true));
          on(this, 'pointerout', (e) => this.hover(e, false));
          on(this.dialog, 'cancel', (e) => (e.preventDefault(), this.close()));
          on(document, 'shopify:block:select', (e) => {
            const i = this.spots.indexOf(e.target);
            if (i > -1) this.go(i);
          });
          on(document, 'shopify:block:deselect', (e) => {
            if (this.spots.includes(e.target)) this.close();
          });

          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.layout());
          });
          this.ro.observe(this);
          this.seed = this.hasAttribute('data-seed') && this.speed;
          if (this.seed) this.seedFrom();
          this.io = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              this.io.disconnect();
              if (this.seed) {
                this.seedFrom();
                this.classList.add('is-seeding');
                setTimeout(() => this.classList.remove('is-seeding'), 1400 + this.spots.length * 70);
              }
              requestAnimationFrame(() => this.classList.add('is-inview'));
              if (this.hasAttribute('data-open-first') && !this.narrow() && this.i < 0) setTimeout(() => this.go(0), 600 * this.speed);
            },
            { threshold: 0.25 }
          );
          this.io.observe(this);
        }

        disconnectedCallback() {
          this.ac.abort();
          this.ro.disconnect();
          this.io.disconnect();
          clearTimeout(this.t);
          if (this.dialog.open) this.dialog.close();
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) { bg = c; break; }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        seedFrom() {
          const fw = this.frame.clientWidth / 2;
          const fh = this.frame.clientHeight / 2;
          this.spots.forEach((s, k) => {
            const [x, y] = this.pt(k);
            s.style.setProperty('--sx', fw - x + 'px');
            s.style.setProperty('--sy', fh - y + 'px');
          });
        }

        narrow() {
          return this.clientWidth < 750;
        }

        // the card opens as a modal sheet / full-screen portal on narrow sections – the Drawer stays inline
        modal() {
          return this.narrow() && !this.drawer;
        }

        unit() {
          const w = this.clientWidth;
          return w < 750 ? Math.min(w / 390, 1.15) : w < 990 ? Math.min(w / 768, 1.1) : Math.min(w / 1440, 1);
        }

        wait(ms, fn) {
          clearTimeout(this.t);
          this.t = setTimeout(fn, ms * this.speed);
        }

        onClick(e) {
          const t = e.target.closest('[data-go], [data-action]');
          if (!t) {
            if (this.i > -1 && e.target.closest('.werk-hotspot-panel_frame')) this.close();
            const d = this.dialog;
            if (e.target === d && d.matches(':modal')) {
              const r = d.getBoundingClientRect();
              if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.close();
            }
            return;
          }
          if (this.dragged) return void (this.dragged = false);
          const a = t.dataset.action;
          if (a === 'close') return this.close();
          if (a === 'next' || a === 'prev') return this.step(a === 'next' ? 1 : -1);
          const i = +t.dataset.go;
          if (i === this.i) return this.close();
          this.go(i);
        }

        onKey(e) {
          if (this.i < 0) return;
          if (e.key === 'Escape') return this.close();
          if (e.target.closest('input, textarea')) return;
          if (e.key === 'ArrowRight') this.step(1);
          if (e.key === 'ArrowLeft') this.step(-1);
        }

        hover(e, on) {
          if (e.pointerType === 'touch') return;
          const arrow = e.target.closest('.werk-hotspot-panel_arrow');
          if (!arrow || (e.relatedTarget && arrow.contains(e.relatedTarget))) return;
          if (!on || this.i < 0) return this.unpeek();
          const n = this.spots.length;
          this.peek = (this.i + (arrow.dataset.action === 'next' ? 1 : -1) + n) % n;
          this.spots[this.peek].classList.add('is-peek');
        }

        unpeek() {
          if (this.peek == null) return;
          this.spots[this.peek]?.classList.remove('is-peek');
          this.peek = null;
        }

        step(d) {
          const n = this.cards.length;
          this.go((((this.i < 0 ? 0 : this.i) + d) % n + n) % n, d);
        }

        go(i, dir) {
          const prev = this.i;
          if (i === prev) return;
          dir = dir || (prev < 0 ? 0 : i > prev ? 1 : -1);
          this.i = i;
          this.classList.add('is-open');
          this.spots.forEach((s, k) => {
            s.classList.toggle('is-active', k === i);
            s.setAttribute('aria-expanded', k === i);
          });
          const num = String(i + 1).padStart(2, '0');
          this.counter.textContent = num;
          this.digits.forEach((d, k) => d.style.setProperty('--d', num[k % 2]));
          this.unpeek();
          const was = this.dialog.open && this.dialog.dataset.state === 'open';
          this.swap(prev, i, was ? dir : 0);
          this.open();
          this.layout();
        }

        swap(prev, i, dir) {
          const next = this.cards[i];
          const old = this.cards[prev];
          if (old && old !== next) old.style.setProperty('--to', -dir || -1);
          this.cards.forEach((c) => c !== next && c.classList.remove('is-active'));
          next.style.setProperty('--rise', dir ? 0 : 12);
          next.style.setProperty('--from', dir);
          if (dir) {
            next.classList.add('is-prep');
            next.offsetWidth;
            next.classList.remove('is-prep');
          }
          next.classList.add('is-active');
          this.cards.forEach((c, k) => {
            const on = k === i;
            c.inert = !on;
          });
        }

        open() {
          const d = this.dialog;
          const modal = this.modal();
          clearTimeout(this.t);
          if (d.open && d.matches(':modal') === modal) {
            d.dataset.state = 'open';
            return;
          }
          if (d.open) d.close();
          d.dataset.state = 'closed';
          // opening focuses the dialog and the browser scrolls it into view – the window or any scrolling ancestor of the theme
          // (e.g. a body with overflow-x: hidden), smoothly with scroll-behavior: smooth. Snap them all back, instantly:
          // the Drawer waits below the image and would pull the page down by its own height.
          const keep = [[document.scrollingElement || document.documentElement]];
          for (let el = this.parentElement; el; el = el.parentElement) keep.push([el]);
          keep.forEach((k) => k.push(k[0].scrollLeft, k[0].scrollTop));
          modal ? d.showModal() : d.show();
          keep.forEach(([el, l, t]) => el.scrollTo({ left: l, top: t, behavior: 'instant' })); // unconditional: a smooth scroll may not have moved yet
          if (modal) this.fit();
          // inline drawer on phones: bring it into view once it has unfolded
          if (this.drawer && this.narrow()) setTimeout(() => d.isConnected && d.open && d.scrollIntoView({ block: 'nearest', behavior: this.speed ? 'smooth' : 'auto' }), 620 * this.speed);
          d.offsetWidth;
          requestAnimationFrame(() => requestAnimationFrame(() => (d.dataset.state = 'open')));
        }

        close() {
          const i = this.i;
          if (i < 0) return;
          this.i = -1;
          const d = this.dialog;
          const focusBack = d.contains(document.activeElement) || this.cards[i].contains(document.activeElement);
          this.classList.remove('is-open');
          this.spots.forEach((s) => {
            s.classList.remove('is-active');
            s.setAttribute('aria-expanded', 'false');
          });
          this.pan();
          d.dataset.state = 'closed';
          this.wait(620, () => {
            d.close();
            this.cards[i].classList.remove('is-active');
            this.cards[i].inert = true;
          });
          if (focusBack) this.spots[i].focus({ preventScroll: true });
        }

        layout() {
          this.offset();
          this.keep();
          this.clip();
          if (this.i < 0) return;
          const d = this.dialog;
          if (d.open && d.matches(':modal') !== this.modal()) this.open();
          this.pan();
        }

        offset() {
          const v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
          let h = v;
          if (isNaN(v)) {
            const el = document.querySelector('.shopify-section-group-header-group, header');
            h = el && /sticky|fixed/.test(getComputedStyle(el).position) ? el.offsetHeight : 0;
          }
          this.style.setProperty('--werk-offset', h + 'px');
        }

        drag(e) {
          const d = this.dialog;
          if (!d.open || !d.matches(':modal') || e.button > 0 || this.i < 0) return;
          if (e.target.closest('a, input, .werk-hotspot-panel_form, .werk-hotspot-panel_arrows, .werk-hotspot-panel_close')) return;
          const pull = !!e.target.closest('.werk-hotspot-panel_grabber, .werk-hotspot-panel_card-media');
          const card = this.cards[this.i];
          const x0 = e.clientX;
          const y0 = e.clientY;
          const t0 = performance.now();
          let axis = '';
          let dx = 0;
          let dy = 0;
          const move = (ev) => {
            dx = ev.clientX - x0;
            dy = ev.clientY - y0;
            if (!axis && Math.hypot(dx, dy) > 8) axis = Math.abs(dx) > Math.abs(dy) ? 'x' : pull ? 'y' : '-';
            if (axis === 'x' && this.cards.length > 1) {
              this.dragged = true;
              card.style.transition = 'none';
              card.style.translate = dx * 0.5 + 'px 0';
              card.style.opacity = 1 - Math.min(0.6, Math.abs(dx) / 500);
            }
            if (axis === 'y') {
              this.dragged = true;
              d.style.transition = 'none';
              d.style.transform = 'translateY(' + Math.max(0, dy) + 'px)';
            }
          };
          const up = () => {
            removeEventListener('pointermove', move);
            removeEventListener('pointerup', up);
            removeEventListener('pointercancel', up);
            card.style.transition = card.style.translate = card.style.opacity = '';
            d.style.transition = d.style.transform = '';
            const v = performance.now() - t0;
            if (axis === 'x' && this.cards.length > 1 && (Math.abs(dx) > 60 || Math.abs(dx) / v > 0.5)) this.step(dx < 0 ? 1 : -1);
            if (axis === 'y' && (dy > 90 || dy / v > 0.5)) this.close();
            setTimeout(() => (this.dragged = false), 0);
          };
          addEventListener('pointermove', move);
          addEventListener('pointerup', up);
          addEventListener('pointercancel', up);
        }

        // Keeps every hotspot inside the crop: slides the image within its frame, and when "fit to screen"
        // would still cut hotspots off, lets the frame grow just enough to show them.
        keep() {
          const c = this.canvas;
          const f = this.frame;
          c.style.removeProperty('--fx');
          c.style.removeProperty('--fy');
          const m = 28 * this.unit();
          const xs = this.spots.map((s) => s.dataset.x / 100);
          const ys = this.spots.map((s) => s.dataset.y / 100);
          if (!xs.length) return;
          if (this.classList.contains('is-fit')) {
            const need = (Math.max(...ys) - Math.min(...ys)) * (f.clientWidth / parseFloat(getComputedStyle(this).getPropertyValue('--r'))) + 2 * m;
            this.style.setProperty('--werk-minh', Math.ceil(need) + 'px');
          }
          const axis = (frame, size, list, pos) => {
            const room = frame - size;
            if (room > -1) return;
            const lo = Math.max(room, frame - m - Math.max(...list) * size);
            const hi = Math.min(0, m - Math.min(...list) * size);
            const want = lo <= hi ? Math.min(hi, Math.max(lo, pos)) : Math.min(0, Math.max(room, frame / 2 - ((Math.min(...list) + Math.max(...list)) / 2) * size));
            return want / room;
          };
          const fx = axis(f.clientWidth, c.offsetWidth, xs, c.offsetLeft);
          const fy = axis(f.clientHeight, c.offsetHeight, ys, c.offsetTop);
          if (fx != null) c.style.setProperty('--fx', fx);
          if (fy != null) c.style.setProperty('--fy', fy);
        }

        clip() {
          const m = 12 * this.unit();
          const fw = this.frame.clientWidth;
          const fh = this.frame.clientHeight;
          this.spots.forEach((s, k) => {
            const [x, y] = this.pt(k);
            s.classList.toggle('is-out', x < m || y < m || x > fw - m || y > fh - m);
          });
        }

        fit() {
          const top = innerHeight - this.dialog.offsetHeight;
          const fr = this.frame.getBoundingClientRect();
          const room = document.documentElement.scrollHeight - innerHeight - scrollY;
          const by = Math.max(0, Math.min(fr.bottom - top + 12, fr.top - 12, room));
          if (by > 0) scrollBy({ top: by, behavior: this.speed ? 'smooth' : 'auto' });
          this.vis = Math.max(fr.height * 0.4, Math.min(fr.height, top - (fr.top - by) - 12));
        }

        pt(i) {
          const c = this.canvas;
          const s = this.spots[i];
          return [c.offsetLeft + (s.dataset.x / 100) * c.offsetWidth, c.offsetTop + (s.dataset.y / 100) * c.offsetHeight];
        }

        pan() {
          const c = this.canvas;
          if (this.i < 0) {
            c.style.transform = '';
            c.style.removeProperty('--s');
            return;
          }
          const z = +this.dataset.zoom || 1;
          const fw = this.frame.clientWidth;
          const fh = this.frame.clientHeight;
          const pw = this.narrow() || this.drawer ? 0 : this.dialog.offsetWidth;
          const left = this.classList.contains('is-side-left') && !this.drawer;
          const a = left ? pw : 0;
          const b = left ? fw : fw - pw;
          const l0 = c.offsetLeft;
          const t0 = c.offsetTop;
          const s = this.spots[this.i];
          // the drawer covers the bottom of the frame: centre the spot in what stays visible above it
          let vis = this.narrow() && this.vis ? this.vis : fh;
          if (this.drawer && !this.narrow()) vis = fh - this.dialog.offsetHeight;
          const at = (k) => {
            const w = c.offsetWidth * k;
            const h = c.offsetHeight * k;
            const tx = Math.min(a - l0, Math.max(b - w - l0, (a + b) / 2 - l0 - (s.dataset.x / 100) * w));
            const ty = Math.min(-t0, Math.max(fh - h - t0, vis / 2 - t0 - (s.dataset.y / 100) * h));
            return [tx, ty, t0 + ty + (s.dataset.y / 100) * h];
          };
          let k = z;
          let [tx, ty, sy] = at(k);
          // a spot near the bottom edge would hide behind the drawer – zoom in a little more until it clears it
          while (this.drawer && vis < fh && sy > vis - 36 * this.unit() && k < 2.4) [tx, ty, sy] = at((k += 0.05));
          c.style.transform = `translate(${tx}px, ${ty}px) scale(${k})`;
          c.style.setProperty('--s', k);
        }

        fly(btn) {
          const dot = this.querySelector('.werk-hotspot-panel_fly');
          const cart = document.querySelector('cart-icon, #cart-icon-bubble, [data-cart-icon], a[href$="/cart"]');
          if (!dot || !cart || !this.speed || !dot.showPopover || !dot.animate) return;
          const a = btn.getBoundingClientRect();
          const b = cart.getBoundingClientRect();
          if (!b.width) return;
          const x0 = a.left + a.width / 2;
          const y0 = a.top + a.height / 2;
          const x1 = b.left + b.width / 2;
          const y1 = b.top + b.height / 2;
          const cx = (x0 + x1) / 2;
          const cy = Math.min(y0, y1) - Math.min(180, Math.abs(y1 - y0) * 0.35 + 60);
          const frames = [];
          for (let k = 0; k <= 16; k++) {
            const t = k / 16;
            const x = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x1;
            const y = (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * cy + t * t * y1;
            frames.push({ transform: `translate(${x}px, ${y}px) scale(${1 - t * 0.55})`, opacity: t > 0.9 ? (1 - t) * 10 : 1 });
          }
          dot.showPopover();
          dot.animate(frames, { duration: 900, easing: 'cubic-bezier(0.6234, 0.058, 0, 0.9095)' }).finished.then(
            () => dot.hidePopover(),
            () => dot.hidePopover()
          );
        }

        async onSubmit(e) {
          const form = e.target.closest('.werk-hotspot-panel_form');
          if (!form) return;
          e.preventDefault();
          const btn = form.querySelector('button');
          if (btn.dataset.state || btn.disabled) return;
          const id = form.elements.id?.value;
          if (!id) return void (location.href = form.dataset.fallback || '/');
          const root = window.Shopify?.routes?.root || '/';
          btn.dataset.state = 'loading';
          try {
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }),
            });
            if (!res.ok) throw new Error(res.status);
            btn.dataset.state = 'added';
            this.fly(btn);
            const cart = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: id, quantity: 1 }],
              promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart(root);
            setTimeout(() => delete btn.dataset.state, 2400);
          } catch {
            delete btn.dataset.state;
            form.submit();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-hotspot-popover"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-hotspot-popover')) {
    customElements.define(
      'werk-hotspot-popover',
      class extends HTMLElement {
        connectedCallback() {
          const q = (s) => this.querySelector(s);
          const qa = (s) => [...this.querySelectorAll(s)];
          this.frame = q('.werk-hotspot-popover_frame');
          this.canvas = q('.werk-hotspot-popover_canvas');
          this.dialog = q('.werk-hotspot-popover_dialog');
          this.leader = q('.werk-hotspot-popover_leader');
          this.spots = qa('.werk-hotspot-popover_hotspot');
          this.cards = qa('.werk-hotspot-popover_card');
          this.digits = qa('.werk-hotspot-popover_digit');
          this.counter = q('[data-count]');
          this.i = -1;
          this.speed =
            this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.offset();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: ac.signal });
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'keydown', (e) => this.onKey(e));
          on(this, 'submit', (e) => this.onSubmit(e));
          on(this, 'pointerdown', (e) => this.drag(e));
          on(this, 'pointerover', (e) => this.hover(e, true));
          on(this, 'pointerout', (e) => this.hover(e, false));
          on(this.dialog, 'cancel', (e) => (e.preventDefault(), this.close()));
          on(document, 'shopify:block:select', (e) => {
            const i = this.spots.indexOf(e.target);
            if (i > -1) this.go(i);
          });
          on(document, 'shopify:block:deselect', (e) => {
            if (this.spots.includes(e.target)) this.close();
          });

          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.layout());
          });
          this.ro.observe(this);
          this.seed = this.hasAttribute('data-seed') && this.speed;
          if (this.seed) this.seedFrom();
          this.io = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              this.io.disconnect();
              if (this.seed) {
                this.seedFrom();
                this.classList.add('is-seeding');
                setTimeout(() => this.classList.remove('is-seeding'), 1400 + this.spots.length * 70);
              }
              requestAnimationFrame(() => this.classList.add('is-inview'));
              if (this.hasAttribute('data-open-first') && !this.narrow() && this.i < 0) setTimeout(() => this.go(0), 600 * this.speed);
            },
            { threshold: 0.25 }
          );
          this.io.observe(this);
        }

        disconnectedCallback() {
          this.ac.abort();
          this.ro.disconnect();
          this.io.disconnect();
          clearTimeout(this.t);
          if (this.dialog.open) this.dialog.close();
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) { bg = c; break; }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        seedFrom() {
          const fw = this.frame.clientWidth / 2;
          const fh = this.frame.clientHeight / 2;
          this.spots.forEach((s, k) => {
            const [x, y] = this.pt(k);
            s.style.setProperty('--sx', fw - x + 'px');
            s.style.setProperty('--sy', fh - y + 'px');
          });
        }

        narrow() {
          return this.clientWidth < 750;
        }

        // the card opens as a modal sheet / full-screen portal on narrow sections – the Drawer stays inline
        modal() {
          return this.narrow();
        }

        unit() {
          const w = this.clientWidth;
          return w < 750 ? Math.min(w / 390, 1.15) : w < 990 ? Math.min(w / 768, 1.1) : Math.min(w / 1440, 1);
        }

        wait(ms, fn) {
          clearTimeout(this.t);
          this.t = setTimeout(fn, ms * this.speed);
        }

        onClick(e) {
          const t = e.target.closest('[data-go], [data-action]');
          if (!t) {
            if (this.i > -1 && e.target.closest('.werk-hotspot-popover_frame')) this.close();
            const d = this.dialog;
            if (e.target === d && d.matches(':modal')) {
              const r = d.getBoundingClientRect();
              if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.close();
            }
            return;
          }
          if (this.dragged) return void (this.dragged = false);
          const a = t.dataset.action;
          if (a === 'close') return this.close();
          if (a === 'next' || a === 'prev') return this.step(a === 'next' ? 1 : -1);
          const i = +t.dataset.go;
          if (i === this.i) return this.close();
          this.go(i);
        }

        onKey(e) {
          if (this.i < 0) return;
          if (e.key === 'Escape') return this.close();
          if (e.target.closest('input, textarea')) return;
          if (e.key === 'ArrowRight') this.step(1);
          if (e.key === 'ArrowLeft') this.step(-1);
        }

        hover(e, on) {
          if (e.pointerType === 'touch') return;
          const arrow = e.target.closest('.werk-hotspot-popover_arrow');
          if (!arrow || (e.relatedTarget && arrow.contains(e.relatedTarget))) return;
          if (!on || this.i < 0) return this.unpeek();
          const n = this.spots.length;
          this.peek = (this.i + (arrow.dataset.action === 'next' ? 1 : -1) + n) % n;
          this.spots[this.peek].classList.add('is-peek');
        }

        unpeek() {
          if (this.peek == null) return;
          this.spots[this.peek]?.classList.remove('is-peek');
          this.peek = null;
        }

        step(d) {
          const n = this.cards.length;
          this.go((((this.i < 0 ? 0 : this.i) + d) % n + n) % n, d);
        }

        go(i, dir) {
          const prev = this.i;
          if (i === prev) return;
          dir = dir || (prev < 0 ? 0 : i > prev ? 1 : -1);
          this.i = i;
          this.classList.add('is-open');
          this.spots.forEach((s, k) => {
            s.classList.toggle('is-active', k === i);
            s.setAttribute('aria-expanded', k === i);
          });
          const num = String(i + 1).padStart(2, '0');
          this.counter.textContent = num;
          this.digits.forEach((d, k) => d.style.setProperty('--d', num[k % 2]));
          this.unpeek();
          const was = this.dialog.open && this.dialog.dataset.state === 'open';
          if (was && !this.narrow()) {
            this.dialog.dataset.state = 'closed';
            this.leader.classList.remove('is-on');
            this.wait(200, () => {
              this.swap(prev, i, 0);
              this.place();
              this.dialog.dataset.state = 'open';
            });
            return;
          }
          this.swap(prev, i, was ? dir : 0);
          this.open();
          this.layout();
        }

        swap(prev, i, dir) {
          const next = this.cards[i];
          const old = this.cards[prev];
          if (old && old !== next) old.style.setProperty('--to', -dir || -1);
          this.cards.forEach((c) => c !== next && c.classList.remove('is-active'));
          next.style.setProperty('--rise', dir ? 0 : 12);
          next.style.setProperty('--from', dir);
          if (dir) {
            next.classList.add('is-prep');
            next.offsetWidth;
            next.classList.remove('is-prep');
          }
          next.classList.add('is-active');
          this.cards.forEach((c, k) => {
            const on = k === i;
            c.inert = !on;
          });
          this.lens(i);
        }

        open() {
          const d = this.dialog;
          const modal = this.modal();
          clearTimeout(this.t);
          if (d.open && d.matches(':modal') === modal) {
            d.dataset.state = 'open';
            return;
          }
          if (d.open) d.close();
          d.dataset.state = 'closed';
          // opening focuses the dialog and the browser scrolls it into view – the window or any scrolling ancestor of the theme
          // (e.g. a body with overflow-x: hidden), smoothly with scroll-behavior: smooth. Snap them all back, instantly:
          // the Drawer waits below the image and would pull the page down by its own height.
          const keep = [[document.scrollingElement || document.documentElement]];
          for (let el = this.parentElement; el; el = el.parentElement) keep.push([el]);
          keep.forEach((k) => k.push(k[0].scrollLeft, k[0].scrollTop));
          modal ? d.showModal() : d.show();
          keep.forEach(([el, l, t]) => el.scrollTo({ left: l, top: t, behavior: 'instant' })); // unconditional: a smooth scroll may not have moved yet
          this.place();
          if (modal) this.fit();
          d.offsetWidth;
          requestAnimationFrame(() => requestAnimationFrame(() => (d.dataset.state = 'open')));
        }

        close() {
          const i = this.i;
          if (i < 0) return;
          this.i = -1;
          const d = this.dialog;
          const focusBack = d.contains(document.activeElement) || this.cards[i].contains(document.activeElement);
          this.classList.remove('is-open');
          this.spots.forEach((s) => {
            s.classList.remove('is-active');
            s.setAttribute('aria-expanded', 'false');
          });
          this.leader.classList.remove('is-on');
          d.dataset.state = 'closed';
          this.wait(620, () => {
            d.close();
            this.cards[i].classList.remove('is-active');
            this.cards[i].inert = true;
          });
          if (focusBack) this.spots[i].focus({ preventScroll: true });
        }

        layout() {
          this.offset();
          this.keep();
          this.clip();
          if (this.i < 0) return;
          const d = this.dialog;
          if (d.open && d.matches(':modal') !== this.modal()) this.open();
          this.place();
          this.lens(this.i);
        }

        offset() {
          const v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
          let h = v;
          if (isNaN(v)) {
            const el = document.querySelector('.shopify-section-group-header-group, header');
            h = el && /sticky|fixed/.test(getComputedStyle(el).position) ? el.offsetHeight : 0;
          }
          this.style.setProperty('--werk-offset', h + 'px');
        }

        drag(e) {
          const d = this.dialog;
          if (!d.open || !d.matches(':modal') || e.button > 0 || this.i < 0) return;
          if (e.target.closest('a, input, .werk-hotspot-popover_form, .werk-hotspot-popover_arrows, .werk-hotspot-popover_close')) return;
          const pull = true;
          const card = this.cards[this.i];
          const x0 = e.clientX;
          const y0 = e.clientY;
          const t0 = performance.now();
          let axis = '';
          let dx = 0;
          let dy = 0;
          const move = (ev) => {
            dx = ev.clientX - x0;
            dy = ev.clientY - y0;
            if (!axis && Math.hypot(dx, dy) > 8) axis = Math.abs(dx) > Math.abs(dy) ? 'x' : pull ? 'y' : '-';
            if (axis === 'x' && this.cards.length > 1) {
              this.dragged = true;
              card.style.transition = 'none';
              card.style.translate = dx * 0.5 + 'px 0';
              card.style.opacity = 1 - Math.min(0.6, Math.abs(dx) / 500);
            }
            if (axis === 'y') {
              this.dragged = true;
              d.style.transition = 'none';
              d.style.transform = 'translateY(' + Math.max(0, dy) + 'px)';
            }
          };
          const up = () => {
            removeEventListener('pointermove', move);
            removeEventListener('pointerup', up);
            removeEventListener('pointercancel', up);
            card.style.transition = card.style.translate = card.style.opacity = '';
            d.style.transition = d.style.transform = '';
            const v = performance.now() - t0;
            if (axis === 'x' && this.cards.length > 1 && (Math.abs(dx) > 60 || Math.abs(dx) / v > 0.5)) this.step(dx < 0 ? 1 : -1);
            if (axis === 'y' && (dy > 90 || dy / v > 0.5)) this.close();
            setTimeout(() => (this.dragged = false), 0);
          };
          addEventListener('pointermove', move);
          addEventListener('pointerup', up);
          addEventListener('pointercancel', up);
        }

        // Keeps every hotspot inside the crop: slides the image within its frame, and when "fit to screen"
        // would still cut hotspots off, lets the frame grow just enough to show them.
        keep() {
          const c = this.canvas;
          const f = this.frame;
          c.style.removeProperty('--fx');
          c.style.removeProperty('--fy');
          const m = 28 * this.unit();
          const xs = this.spots.map((s) => s.dataset.x / 100);
          const ys = this.spots.map((s) => s.dataset.y / 100);
          if (!xs.length) return;
          if (this.classList.contains('is-fit')) {
            const need = (Math.max(...ys) - Math.min(...ys)) * (f.clientWidth / parseFloat(getComputedStyle(this).getPropertyValue('--r'))) + 2 * m;
            this.style.setProperty('--werk-minh', Math.ceil(need) + 'px');
          }
          const axis = (frame, size, list, pos) => {
            const room = frame - size;
            if (room > -1) return;
            const lo = Math.max(room, frame - m - Math.max(...list) * size);
            const hi = Math.min(0, m - Math.min(...list) * size);
            const want = lo <= hi ? Math.min(hi, Math.max(lo, pos)) : Math.min(0, Math.max(room, frame / 2 - ((Math.min(...list) + Math.max(...list)) / 2) * size));
            return want / room;
          };
          const fx = axis(f.clientWidth, c.offsetWidth, xs, c.offsetLeft);
          const fy = axis(f.clientHeight, c.offsetHeight, ys, c.offsetTop);
          if (fx != null) c.style.setProperty('--fx', fx);
          if (fy != null) c.style.setProperty('--fy', fy);
        }

        clip() {
          const m = 12 * this.unit();
          const fw = this.frame.clientWidth;
          const fh = this.frame.clientHeight;
          this.spots.forEach((s, k) => {
            const [x, y] = this.pt(k);
            s.classList.toggle('is-out', x < m || y < m || x > fw - m || y > fh - m);
          });
        }

        fit() {
          const top = innerHeight - this.dialog.offsetHeight;
          const fr = this.frame.getBoundingClientRect();
          const room = document.documentElement.scrollHeight - innerHeight - scrollY;
          const by = Math.max(0, Math.min(fr.bottom - top + 12, fr.top - 12, room));
          if (by > 0) scrollBy({ top: by, behavior: this.speed ? 'smooth' : 'auto' });
          this.vis = Math.max(fr.height * 0.4, Math.min(fr.height, top - (fr.top - by) - 12));
        }

        pt(i) {
          const c = this.canvas;
          const s = this.spots[i];
          return [c.offsetLeft + (s.dataset.x / 100) * c.offsetWidth, c.offsetTop + (s.dataset.y / 100) * c.offsetHeight];
        }

        // Lens: fills the active card's magnifier with the main image, zoomed in on the hotspot
        lens(i) {
          const box = this.cards[i]?.querySelector('.werk-hotspot-popover_lens');
          if (!box) return;
          const img = box.firstElementChild;
          const main = this.canvas.querySelector('.werk-hotspot-popover_img');
          const z = parseFloat(getComputedStyle(this).getPropertyValue('--werk-lens-z')) || 2;
          const D = box.offsetWidth;
          const cw = this.canvas.offsetWidth * z;
          const ch = this.canvas.offsetHeight * z;
          if (!D || !cw || !main) return;
          if (!img.getAttribute('src')) {
            // the smallest source that is still sharp at this zoom
            const need = cw * Math.min(devicePixelRatio || 1, 2);
            const list = (main.getAttribute('srcset') || '')
              .split(',')
              .map((p) => p.trim().split(/\s+/))
              .filter((p) => p[0])
              .map(([u, w]) => [u, parseInt(w) || 0])
              .sort((p, q) => p[1] - q[1]);
            const pick = list.find((p) => p[1] >= need) || list[list.length - 1];
            img.addEventListener('load', () => img.classList.add('is-ready'), { once: true });
            img.src = pick ? pick[0] : main.currentSrc || main.src;
          }
          const s = this.spots[i];
          const x = D / 2 - (s.dataset.x / 100) * cw;
          const y = D / 2 - (s.dataset.y / 100) * ch;
          Object.assign(img.style, { width: cw + 'px', height: ch + 'px', translate: `${x}px ${y}px`, transformOrigin: `${D / 2 - x}px ${D / 2 - y}px` });
        }

        place() {
          const d = this.dialog;
          const card = this.cards[this.i];
          if (!card) return;
          if (this.narrow()) return this.leader.classList.remove('is-on');
          const u = this.unit();
          const [x, y] = this.pt(this.i);
          const fw = this.frame.clientWidth;
          const fh = this.frame.clientHeight;
          const w = d.offsetWidth;
          const h = d.offsetHeight;
          const m = 16 * u;
          const r = 13 * u;
          const gap = (+card.dataset.dist || 56) * u;
          const side = 28 * u;
          const cx = (v) => Math.min(Math.max(v, m), fw - m - w);
          const cy = (v) => Math.min(Math.max(v, m), fh - m - h);
          const at = {
            above: [cx(x - w / 2), y - r - gap - h, [x - 0.5, y - r - gap, 1, gap, '50% 100%']],
            below: [cx(x - w / 2), y + r + gap, [x - 0.5, y + r, 1, gap, '50% 0%']],
            right: [x + r + side, cy(y - h / 2), [x + r, y - 0.5, side, 1, '0% 50%']],
            left: [x - r - side - w, cy(y - h / 2), [x - r - side, y - 0.5, side, 1, '100% 50%']],
          };
          const fits = ([l, t]) => l >= m - 1 && t >= m - 1 && l + w <= fw - m + 1 && t + h <= fh - m + 1;
          const pref = card.dataset.pos;
          const key =
            pref && pref !== 'auto' ? pref : ['above', 'below', 'right', 'left'].find((k) => fits(at[k])) || 'right';
          const [l, t, ln] = at[key];
          d.style.setProperty('--px', l + 'px');
          d.style.setProperty('--py', t + 'px');
          d.style.setProperty('--po', `${x - l}px ${y - t}px`);
          const vert = key === 'above' || key === 'below';
          Object.assign(this.leader.style, { left: ln[0] + 'px', top: ln[1] + 'px', width: ln[2] + 'px', height: ln[3] + 'px' });
          this.leader.style.setProperty('--lo', ln[4]);
          this.leader.style.setProperty('--lsx', vert ? 1 : 0);
          this.leader.style.setProperty('--lsy', vert ? 0 : 1);
          this.leader.classList.add('is-on');
        }

        fly(btn) {
          const dot = this.querySelector('.werk-hotspot-popover_fly');
          const cart = document.querySelector('cart-icon, #cart-icon-bubble, [data-cart-icon], a[href$="/cart"]');
          if (!dot || !cart || !this.speed || !dot.showPopover || !dot.animate) return;
          const a = btn.getBoundingClientRect();
          const b = cart.getBoundingClientRect();
          if (!b.width) return;
          const x0 = a.left + a.width / 2;
          const y0 = a.top + a.height / 2;
          const x1 = b.left + b.width / 2;
          const y1 = b.top + b.height / 2;
          const cx = (x0 + x1) / 2;
          const cy = Math.min(y0, y1) - Math.min(180, Math.abs(y1 - y0) * 0.35 + 60);
          const frames = [];
          for (let k = 0; k <= 16; k++) {
            const t = k / 16;
            const x = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x1;
            const y = (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * cy + t * t * y1;
            frames.push({ transform: `translate(${x}px, ${y}px) scale(${1 - t * 0.55})`, opacity: t > 0.9 ? (1 - t) * 10 : 1 });
          }
          dot.showPopover();
          dot.animate(frames, { duration: 900, easing: 'cubic-bezier(0.6234, 0.058, 0, 0.9095)' }).finished.then(
            () => dot.hidePopover(),
            () => dot.hidePopover()
          );
        }

        async onSubmit(e) {
          const form = e.target.closest('.werk-hotspot-popover_form');
          if (!form) return;
          e.preventDefault();
          const btn = form.querySelector('button');
          if (btn.dataset.state || btn.disabled) return;
          const id = form.elements.id?.value;
          if (!id) return void (location.href = form.dataset.fallback || '/');
          const root = window.Shopify?.routes?.root || '/';
          btn.dataset.state = 'loading';
          try {
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }),
            });
            if (!res.ok) throw new Error(res.status);
            btn.dataset.state = 'added';
            this.fly(btn);
            const cart = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: id, quantity: 1 }],
              promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart(root);
            setTimeout(() => delete btn.dataset.state, 2400);
          } catch {
            delete btn.dataset.state;
            form.submit();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-hotspot-portal"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-hotspot-portal')) {
    customElements.define(
      'werk-hotspot-portal',
      class extends HTMLElement {
        connectedCallback() {
          const q = (s) => this.querySelector(s);
          const qa = (s) => [...this.querySelectorAll(s)];
          this.frame = q('.werk-hotspot-portal_frame');
          this.canvas = q('.werk-hotspot-portal_canvas');
          this.dialog = q('.werk-hotspot-portal_dialog');
          this.spots = qa('.werk-hotspot-portal_hotspot');
          this.cards = qa('.werk-hotspot-portal_card');
          this.dots = qa('.werk-hotspot-portal_minimap-dot');
          this.digits = qa('.werk-hotspot-portal_digit');
          this.counter = q('[data-count]');
          this.i = -1;
          this.speed =
            this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.offset();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: ac.signal });
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'keydown', (e) => this.onKey(e));
          on(this, 'submit', (e) => this.onSubmit(e));
          on(this, 'pointerdown', (e) => this.drag(e));
          on(this, 'pointerover', (e) => this.hover(e, true));
          on(this, 'pointerout', (e) => this.hover(e, false));
          on(this.dialog, 'cancel', (e) => (e.preventDefault(), this.close()));
          on(document, 'shopify:block:select', (e) => {
            const i = this.spots.indexOf(e.target);
            if (i > -1) this.go(i);
          });
          on(document, 'shopify:block:deselect', (e) => {
            if (this.spots.includes(e.target)) this.close();
          });

          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.layout());
          });
          this.ro.observe(this);
          this.seed = this.hasAttribute('data-seed') && this.speed;
          if (this.seed) this.seedFrom();
          this.io = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              this.io.disconnect();
              if (this.seed) {
                this.seedFrom();
                this.classList.add('is-seeding');
                setTimeout(() => this.classList.remove('is-seeding'), 1400 + this.spots.length * 70);
              }
              requestAnimationFrame(() => this.classList.add('is-inview'));
              if (this.hasAttribute('data-open-first') && !this.narrow() && this.i < 0) setTimeout(() => this.go(0), 600 * this.speed);
            },
            { threshold: 0.25 }
          );
          this.io.observe(this);
        }

        disconnectedCallback() {
          this.ac.abort();
          this.ro.disconnect();
          this.io.disconnect();
          clearTimeout(this.t);
          if (this.dialog.open) this.dialog.close();
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) { bg = c; break; }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
          // the portal's type is always white: it takes the darker of the page's background and text colour
          const lum = (c) => { const [r, g, b] = (c.match(/[\d.]+/g) || [255, 255, 255]).map(Number); return 0.2126 * r + 0.7152 * g + 0.0722 * b; };
          const fg = getComputedStyle(this).color;
          const dark = lum(bg) <= lum(fg) ? bg : fg;
          const light = dark === bg ? fg : bg;
          // Daylight: the lighter of the two, with the darker one for its type
          const day = this.dataset.look === 'daylight';
          this.style.setProperty('--werk-portal', day ? light : dark);
          if (day) this.style.setProperty('--werk-portal-fg', dark);
        }

        seedFrom() {
          const fw = this.frame.clientWidth / 2;
          const fh = this.frame.clientHeight / 2;
          this.spots.forEach((s, k) => {
            const [x, y] = this.pt(k);
            s.style.setProperty('--sx', fw - x + 'px');
            s.style.setProperty('--sy', fh - y + 'px');
          });
        }

        narrow() {
          return this.clientWidth < 990;
        }

        // the card opens as a modal sheet / full-screen portal on narrow sections – the Drawer stays inline
        modal() {
          return this.narrow();
        }

        unit() {
          const w = this.clientWidth;
          return w < 750 ? Math.min(w / 390, 1.15) : w < 990 ? Math.min(w / 768, 1.1) : Math.min(w / 1440, 1);
        }

        wait(ms, fn) {
          clearTimeout(this.t);
          this.t = setTimeout(fn, ms * this.speed);
        }

        onClick(e) {
          const t = e.target.closest('[data-go], [data-action]');
          if (!t) {
            if (this.i > -1 && e.target.closest('.werk-hotspot-portal_frame')) this.close();
            const d = this.dialog;
            if (e.target === d && d.matches(':modal')) {
              const r = d.getBoundingClientRect();
              if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.close();
            }
            return;
          }
          if (this.dragged) return void (this.dragged = false);
          const a = t.dataset.action;
          if (a === 'close') return this.close();
          if (a === 'next' || a === 'prev') return this.step(a === 'next' ? 1 : -1);
          const i = +t.dataset.go;
          if (i === this.i && !t.closest('.werk-hotspot-portal_minimap')) return this.close();
          this.go(i);
        }

        onKey(e) {
          if (this.i < 0) return;
          if (e.key === 'Escape') return this.close();
          if (e.target.closest('input, textarea')) return;
          if (e.key === 'ArrowRight') this.step(1);
          if (e.key === 'ArrowLeft') this.step(-1);
        }

        hover(e, on) {
          if (e.pointerType === 'touch') return;
          const arrow = e.target.closest('.werk-hotspot-portal_arrow');
          if (!arrow || (e.relatedTarget && arrow.contains(e.relatedTarget))) return;
          if (!on || this.i < 0) return this.unpeek();
          const n = this.spots.length;
          this.peek = (this.i + (arrow.dataset.action === 'next' ? 1 : -1) + n) % n;
          this.spots[this.peek].classList.add('is-peek');
          this.dots[this.peek]?.classList.add('is-peek');
        }

        unpeek() {
          if (this.peek == null) return;
          this.spots[this.peek]?.classList.remove('is-peek');
          this.dots[this.peek]?.classList.remove('is-peek');
          this.peek = null;
        }

        step(d) {
          const n = this.cards.length;
          this.go((((this.i < 0 ? 0 : this.i) + d) % n + n) % n, d);
        }

        go(i, dir) {
          const prev = this.i;
          if (i === prev) return;
          dir = dir || (prev < 0 ? 0 : i > prev ? 1 : -1);
          this.i = i;
          this.classList.add('is-open');
          this.spots.forEach((s, k) => {
            s.classList.toggle('is-active', k === i);
            s.setAttribute('aria-expanded', k === i);
          });
          this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
          const num = String(i + 1).padStart(2, '0');
          this.counter.textContent = num;
          this.digits.forEach((d, k) => d.style.setProperty('--d', num[k % 2]));
          this.unpeek();
          const was = this.dialog.open && this.dialog.dataset.state === 'open';
          this.swap(prev, i, was ? dir : 0);
          this.open();
          this.layout();
        }

        swap(prev, i, dir) {
          const next = this.cards[i];
          const old = this.cards[prev];
          if (old && old !== next) old.style.setProperty('--to', -dir || -1);
          this.cards.forEach((c) => c !== next && c.classList.remove('is-active'));
          next.style.setProperty('--rise', dir ? 0 : 12);
          next.style.setProperty('--from', dir);
          if (dir) {
            next.classList.add('is-prep');
            next.offsetWidth;
            next.classList.remove('is-prep');
          }
          next.classList.add('is-active');
          this.cards.forEach((c, k) => {
            const on = k === i;
            c.inert = !on;
          });
        }

        open() {
          const d = this.dialog;
          const modal = this.modal();
          clearTimeout(this.t);
          if (d.open && d.matches(':modal') === modal) {
            d.dataset.state = 'open';
            return;
          }
          if (d.open) d.close();
          d.dataset.state = 'closed';
          this.aim(this.i, modal);
          // opening focuses the dialog and the browser scrolls it into view – the window or any scrolling ancestor of the theme
          // (e.g. a body with overflow-x: hidden), smoothly with scroll-behavior: smooth. Snap them all back, instantly:
          // the Drawer waits below the image and would pull the page down by its own height.
          const keep = [[document.scrollingElement || document.documentElement]];
          for (let el = this.parentElement; el; el = el.parentElement) keep.push([el]);
          keep.forEach((k) => k.push(k[0].scrollLeft, k[0].scrollTop));
          modal ? d.showModal() : d.show();
          keep.forEach(([el, l, t]) => el.scrollTo({ left: l, top: t, behavior: 'instant' })); // unconditional: a smooth scroll may not have moved yet
          d.offsetWidth;
          requestAnimationFrame(() => requestAnimationFrame(() => (d.dataset.state = 'open')));
        }

        close() {
          const i = this.i;
          if (i < 0) return;
          this.i = -1;
          const d = this.dialog;
          const focusBack = d.contains(document.activeElement) || this.cards[i].contains(document.activeElement);
          this.classList.remove('is-open');
          this.spots.forEach((s) => {
            s.classList.remove('is-active');
            s.setAttribute('aria-expanded', 'false');
          });
          this.aim(i, d.matches(':modal'));
          const chip = this.spots[i];
          setTimeout(() => {
            chip.classList.add('is-catch');
            setTimeout(() => chip.classList.remove('is-catch'), 800);
          }, 620 * this.speed);
          d.dataset.state = 'closed';
          this.wait(820, () => {
            d.close();
            this.cards[i].classList.remove('is-active');
            this.cards[i].inert = true;
          });
          if (focusBack) this.spots[i].focus({ preventScroll: true });
        }

        layout() {
          this.offset();
          this.keep();
          this.clip();
          if (this.i < 0) return;
          const d = this.dialog;
          if (d.open && d.matches(':modal') !== this.modal()) this.open();
          this.aim(this.i, d.matches(':modal'));
        }

        offset() {
          const v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
          let h = v;
          if (isNaN(v)) {
            const el = document.querySelector('.shopify-section-group-header-group, header');
            h = el && /sticky|fixed/.test(getComputedStyle(el).position) ? el.offsetHeight : 0;
          }
          this.style.setProperty('--werk-offset', h + 'px');
        }

        drag(e) {
          const d = this.dialog;
          if (!d.open || !d.matches(':modal') || e.button > 0 || this.i < 0) return;
          if (e.target.closest('a, input, .werk-hotspot-portal_form, .werk-hotspot-portal_arrows, .werk-hotspot-portal_close, .werk-hotspot-portal_minimap')) return;
          const pull = false;
          const card = this.cards[this.i];
          const x0 = e.clientX;
          const y0 = e.clientY;
          const t0 = performance.now();
          let axis = '';
          let dx = 0;
          let dy = 0;
          const move = (ev) => {
            dx = ev.clientX - x0;
            dy = ev.clientY - y0;
            if (!axis && Math.hypot(dx, dy) > 8) axis = Math.abs(dx) > Math.abs(dy) ? 'x' : pull ? 'y' : '-';
            if (axis === 'x' && this.cards.length > 1) {
              this.dragged = true;
              card.style.transition = 'none';
              card.style.translate = dx * 0.5 + 'px 0';
              card.style.opacity = 1 - Math.min(0.6, Math.abs(dx) / 500);
            }
            if (axis === 'y') {
              this.dragged = true;
              d.style.transition = 'none';
              d.style.transform = 'translateY(' + Math.max(0, dy) + 'px)';
            }
          };
          const up = () => {
            removeEventListener('pointermove', move);
            removeEventListener('pointerup', up);
            removeEventListener('pointercancel', up);
            card.style.transition = card.style.translate = card.style.opacity = '';
            d.style.transition = d.style.transform = '';
            const v = performance.now() - t0;
            if (axis === 'x' && this.cards.length > 1 && (Math.abs(dx) > 60 || Math.abs(dx) / v > 0.5)) this.step(dx < 0 ? 1 : -1);
            if (axis === 'y' && (dy > 90 || dy / v > 0.5)) this.close();
            setTimeout(() => (this.dragged = false), 0);
          };
          addEventListener('pointermove', move);
          addEventListener('pointerup', up);
          addEventListener('pointercancel', up);
        }

        // Keeps every hotspot inside the crop: slides the image within its frame, and when "fit to screen"
        // would still cut hotspots off, lets the frame grow just enough to show them.
        keep() {
          const c = this.canvas;
          const f = this.frame;
          c.style.removeProperty('--fx');
          c.style.removeProperty('--fy');
          const m = 28 * this.unit();
          const xs = this.spots.map((s) => s.dataset.x / 100);
          const ys = this.spots.map((s) => s.dataset.y / 100);
          if (!xs.length) return;
          if (this.classList.contains('is-fit')) {
            const need = (Math.max(...ys) - Math.min(...ys)) * (f.clientWidth / parseFloat(getComputedStyle(this).getPropertyValue('--r'))) + 2 * m;
            this.style.setProperty('--werk-minh', Math.ceil(need) + 'px');
          }
          const axis = (frame, size, list, pos) => {
            const room = frame - size;
            if (room > -1) return;
            const lo = Math.max(room, frame - m - Math.max(...list) * size);
            const hi = Math.min(0, m - Math.min(...list) * size);
            const want = lo <= hi ? Math.min(hi, Math.max(lo, pos)) : Math.min(0, Math.max(room, frame / 2 - ((Math.min(...list) + Math.max(...list)) / 2) * size));
            return want / room;
          };
          const fx = axis(f.clientWidth, c.offsetWidth, xs, c.offsetLeft);
          const fy = axis(f.clientHeight, c.offsetHeight, ys, c.offsetTop);
          if (fx != null) c.style.setProperty('--fx', fx);
          if (fy != null) c.style.setProperty('--fy', fy);
        }

        clip() {
          const m = 12 * this.unit();
          const fw = this.frame.clientWidth;
          const fh = this.frame.clientHeight;
          this.spots.forEach((s, k) => {
            const [x, y] = this.pt(k);
            s.classList.toggle('is-out', x < m || y < m || x > fw - m || y > fh - m);
          });
        }

        pt(i) {
          const c = this.canvas;
          const s = this.spots[i];
          return [c.offsetLeft + (s.dataset.x / 100) * c.offsetWidth, c.offsetTop + (s.dataset.y / 100) * c.offsetHeight];
        }

        aim(i, modal) {
          const d = this.dialog;
          const [px, py] = this.pt(i);
          const fr = this.frame.getBoundingClientRect();
          let x = px;
          let y = py;
          let w = fr.width;
          let h = fr.height;
          if (modal) {
            x += fr.left;
            y += fr.top;
            w = innerWidth;
            h = innerHeight;
          }
          d.style.setProperty('--cx', x + 'px');
          d.style.setProperty('--cy', y + 'px');
          d.style.setProperty('--cr', Math.hypot(Math.max(x, w - x), Math.max(y, h - y)) + 2 + 'px');
        }

        fly(btn) {
          const dot = this.querySelector('.werk-hotspot-portal_fly');
          const cart = document.querySelector('cart-icon, #cart-icon-bubble, [data-cart-icon], a[href$="/cart"]');
          if (!dot || !cart || !this.speed || !dot.showPopover || !dot.animate) return;
          const a = btn.getBoundingClientRect();
          const b = cart.getBoundingClientRect();
          if (!b.width) return;
          const x0 = a.left + a.width / 2;
          const y0 = a.top + a.height / 2;
          const x1 = b.left + b.width / 2;
          const y1 = b.top + b.height / 2;
          const cx = (x0 + x1) / 2;
          const cy = Math.min(y0, y1) - Math.min(180, Math.abs(y1 - y0) * 0.35 + 60);
          const frames = [];
          for (let k = 0; k <= 16; k++) {
            const t = k / 16;
            const x = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x1;
            const y = (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * cy + t * t * y1;
            frames.push({ transform: `translate(${x}px, ${y}px) scale(${1 - t * 0.55})`, opacity: t > 0.9 ? (1 - t) * 10 : 1 });
          }
          dot.showPopover();
          dot.animate(frames, { duration: 900, easing: 'cubic-bezier(0.6234, 0.058, 0, 0.9095)' }).finished.then(
            () => dot.hidePopover(),
            () => dot.hidePopover()
          );
        }

        async onSubmit(e) {
          const form = e.target.closest('.werk-hotspot-portal_form');
          if (!form) return;
          e.preventDefault();
          const btn = form.querySelector('button');
          if (btn.dataset.state || btn.disabled) return;
          const id = form.elements.id?.value;
          if (!id) return void (location.href = form.dataset.fallback || '/');
          const root = window.Shopify?.routes?.root || '/';
          btn.dataset.state = 'loading';
          try {
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }),
            });
            if (!res.ok) throw new Error(res.status);
            btn.dataset.state = 'added';
            this.fly(btn);
            const cart = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: id, quantity: 1 }],
              promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart(root);
            setTimeout(() => delete btn.dataset.state, 2400);
          } catch {
            delete btn.dataset.state;
            form.submit();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-magnetic-mega-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('werk-magnetic-mega-nav')) {
    customElements.define(
      'werk-magnetic-mega-nav',
      class extends HTMLElement {
        connectedCallback() {
          this.$ = (p) => this.querySelector(`[data-part="${p}"]`);
          this.bar = this.$('bar');
          this.panel = this.$('panel');
          this.corner = this.$('corner');
          this.guides = this.$('guides');
          if (!this.bar) return;
          try {
            this.t = JSON.parse(this.querySelector('script[data-werk-t]').textContent);
          } catch (e) {
            this.t = {};
          }
          this.phone = matchMedia('(max-width: 749px)');
          this.still = matchMedia('(prefers-reduced-motion: reduce)');
          this.key = 'werk-magnetic-mega-nav-pos';
          this.sides = ['bottom', 'top', 'left', 'right'];
          // the position is the dock's CENTRE (cx, cy) plus its current size (w, h), so turning to a side can reshape
          // the glass around its middle while the spring carries it to the edge
          this.cx = 0; this.cy = 0; this.w = 0; this.h = 0; this.scale = 1; this.sizes = {};
          this.pos = this.dataset.pos;
          if (this.hasAttribute('data-remember') && this.hasAttribute('data-draggable')) {
            try { const p = localStorage.getItem(this.key); if (this.sides.includes(p)) this.pos = p; } catch (e) {}
          }
          // top layer: fixed parts escape transformed / clipped theme containers
          [this.corner, this.bar, this.panel].forEach((el) => {
            if (!el || !el.showPopover) return;
            el.setAttribute('popover', 'manual');
            if (el !== this.panel) { el.hidden = false; el.showPopover(); }
          });
          this.classList.add('is-js');
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          this.ac = new AbortController();
          const on = (t, e, f, o = {}) => t && t.addEventListener(e, f, { signal: this.ac.signal, ...o });
          this.querySelectorAll('[data-open]').forEach((b) => on(b, 'click', () => this.toggle(b.dataset.open, b)));
          this.querySelectorAll('[data-hover]').forEach((b) => {
            on(b, 'pointerenter', (e) => this.hoverIn(b, e));
            on(b, 'pointerleave', (e) => this.hoverOut(e));
          });
          on(this.panel, 'pointerenter', () => clearTimeout(this.lt));
          on(this.panel, 'pointerleave', (e) => this.hoverOut(e));
          on(document, 'shopify:block:select', (e) => this.onBlock(e, true));
          on(document, 'shopify:block:deselect', (e) => this.onBlock(e, false));
          on(document, 'keydown', (e) => this.onKey(e));
          // ⌘K / Ctrl+K belongs to this search: caught first, so a theme's own search window (Horizon) doesn't open on top
          on(window, 'keydown', (e) => this.onShortcut(e), { capture: true });
          this.menuBtn = this.bar.querySelector('.werk-magnetic-mega-nav_menu-btn');
          on(this.$('x'), 'click', () => this.close(true));
          // an on-screen keyboard only changes the visual viewport: keep the search in what is still visible
          if (window.visualViewport) ['resize', 'scroll'].forEach((n) => on(visualViewport, n, () => this.onViewport()));
          on(document, 'pointerdown', (e) => { if (this.open && !this.panel.contains(e.target) && !this.bar.contains(e.target)) this.close(); });
          // only a new width rebuilds the dock – an on-screen keyboard changes the height and must not close the field
          on(window, 'resize', () => { clearTimeout(this.rt); this.rt = setTimeout(() => this.layout(this.vw !== document.documentElement.clientWidth), 100); });
          on(this.phone, 'change', () => this.layout());
          const grab = this.$('grabber');
          on(grab, 'pointerdown', (e) => this.dragStart(e));
          on(grab, 'pointermove', (e) => this.dragMove(e));
          on(grab, 'pointerup', () => this.dragEnd());
          on(grab, 'pointercancel', () => this.dragEnd());
          // never get stuck mid-screen: snap whenever the drag ends in a way the handle did not see
          on(grab, 'lostpointercapture', () => this.dragEnd());
          on(grab, 'dragstart', (e) => e.preventDefault());
          on(window, 'pointerup', () => this.dragEnd());
          on(window, 'blur', () => this.dragEnd());
          on(document, 'visibilitychange', () => { if (document.hidden && !this.dragging) this.layout(); });
          on(grab, 'keydown', (e) => {
            const side = { ArrowUp: 'top', ArrowDown: 'bottom', ArrowLeft: 'left', ArrowRight: 'right' }[e.key];
            if (side && !this.phone.matches) { e.preventDefault(); this.snap(side); }
          });
          on(this.$('input'), 'input', (e) => this.search(e.target.value));
          // the field in the dock: results grow out of the dock while typing
          this.field = this.$('field');
          this.type = this.$('type');
          if (this.type) {
            if (!/Mac|iPhone|iPad/.test(navigator.platform)) this.field.querySelector('kbd').textContent = `${this.t.ctrl || ''} K`.trim();
            on(this.type, 'focus', () => { this.openField(); this.onViewport(); });
            on(this.type, 'blur', () => this.onViewport());
            on(this.type, 'input', () => { this.field.classList.toggle('has-query', !!this.type.value.trim()); this.search(this.type.value, true); });
            on(this.type, 'keydown', (e) => { if (e.key === 'Escape' && !this.open) this.type.blur(); });
            on(this.field, 'focusout', (e) => this.leaveField(e));
            on(this.panel, 'focusout', (e) => { if (this.typed) this.leaveField(e); });
            // a press on a result must not count as leaving (Safari gives links no focus on click)
            on(this.panel, 'pointerdown', () => { this.pressed = true; });
            on(window, 'pointerup', () => { this.pressed = false; });
          }
          // ↑ ↓ walk through the results, ↑ on the first one goes back to the field
          on(this, 'keydown', (e) => {
            const d = e.key === 'ArrowDown' ? 1 : e.key === 'ArrowUp' ? -1 : 0;
            if (!d || this.open !== 'search') return;
            const input = this.typed ? this.type : this.$('input');
            const rows = [...this.$('results').querySelectorAll('a')], i = rows.indexOf(document.activeElement);
            if (i < 0 && (document.activeElement !== input || d < 0)) return;
            const next = i + d < 0 ? input : rows[i + d];
            if (next) { e.preventDefault(); next.focus({ preventScroll: true }); next.scrollIntoView?.({ block: 'nearest' }); }
          });
          // Theme overlays outside the top layer (Dawn's cart drawer, lightboxes, pop-ups) would sit UNDER the dock.
          // They lock the page scroll while open – then the dock steps aside. A page that is locked from the start
          // (themes that scroll an inner wrapper) is left alone.
          const locked = () => [document.documentElement, document.body].some((el) => /hidden|clip/.test(getComputedStyle(el).overflowY));
          const lockedAtStart = locked();
          this.mo = new MutationObserver(() => {
            const away = !lockedAtStart && locked();
            if (away === this.classList.contains('is-away')) return;
            this.classList.toggle('is-away', away);
            if (away) { this.close(); this.type?.blur(); }
          });
          [document.documentElement, document.body].forEach((el) => this.mo.observe(el, { attributes: true, attributeFilter: ['class', 'style'] }));
          on(this.querySelector('.werk-magnetic-mega-nav_locale'), 'change', (e) => e.currentTarget.submit());
          const cart = this.$('cart');
          on(cart, 'click', (e) => this.openCart(e));
          ['shopify:cart:lines-update', 'cart:update', 'cart:refresh', 'cart:updated', 'cart-drawer:refresh'].forEach((n) => on(document, n, () => this.refreshCart()));
          if (document.fonts) document.fonts.ready.then(() => this.layout());
          this.layout();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.sc?.abort();
          this.mo?.disconnect();
          [this.lt, this.ht, this.rt, this.st].forEach(clearTimeout);
          [this.raf, this.mraf, this.fraf].forEach(cancelAnimationFrame);
          [...(this.fx || []), ...(this.sfx || [])].forEach((a) => a.cancel());
          [this.corner, this.bar, this.panel, this.guides].forEach((el) => { try { el?.hidePopover(); } catch (e) {} });
        }

        // ---------- position ----------
        vert(p) { return p === 'left' || p === 'right'; }
        edge() { return parseFloat(getComputedStyle(this).getPropertyValue('--werk-edge')) || 24; }
        measure() {
          const b = this.bar, v = b.classList.contains('is-vertical'), s = b.classList.contains('is-searching');
          b.classList.remove('is-vertical', 'is-searching'); // the plain dock, never the one widened by the search
          // doesn't fit one row: first the search field becomes an icon, then the links move behind the menu button
          // (always measured from the full dock without the width cap, so it can't flip-flop)
          const wasCrowded = this.classList.contains('is-crowded');
          this.classList.remove('is-tight', 'is-crowded');
          if (!this.phone.matches) {
            const room = document.documentElement.clientWidth - 2 * this.edge();
            const over = () => b.offsetWidth > room;
            b.style.maxWidth = 'none';
            if (over()) this.classList.add('is-tight');
            if (over() && !this.classList.contains('is-menu-button')) this.classList.add('is-crowded');
            b.style.maxWidth = '';
          }
          // the open dropdown / mega menu lost its trigger (it moved behind the menu button, or back)
          if (this.open && this.open !== 'search' && this.open !== 'locale' && wasCrowded !== this.classList.contains('is-crowded')) this.close();
          this.sizes.h = { w: b.offsetWidth, h: b.offsetHeight };
          b.classList.add('is-vertical');
          this.sizes.v = { w: b.offsetWidth, h: b.offsetHeight };
          b.classList.toggle('is-vertical', v);
          b.classList.toggle('is-searching', s);
        }
        size(p) { return this.vert(p) ? this.sizes.v : this.sizes.h; }
        target(p) {
          const s = this.size(p), W = document.documentElement.clientWidth, H = innerHeight, m = this.edge();
          if (p === 'top') return { x: (W - s.w) / 2, y: m };
          if (p === 'left') return { x: m, y: (H - s.h) / 2 };
          if (p === 'right') return { x: W - s.w - m, y: (H - s.h) / 2 };
          return { x: (W - s.w) / 2, y: H - s.h - m };
        }
        centre(p) { const t = this.target(p), s = this.size(p); return { x: t.x + s.w / 2, y: t.y + s.h / 2 }; }
        render() {
          // the search field unfolded at the right edge: the dock grows to the left, its right edge stays put
          const dx = this.pos === 'right' && this.bar.classList.contains('is-searching') ? this.w - this.bar.offsetWidth : 0;
          this.bar.style.transform = `translate3d(${this.cx - this.w / 2 + dx}px,${this.cy - this.h / 2 - (this.lift || 0)}px,0) scale(${this.scale})`;
        }
        // Tablets: an on-screen keyboard covers the bottom of the page – while the field in the dock is in use the dock
        // is lifted above it (never past the top of what is visible).
        onViewport() {
          const vv = window.visualViewport;
          let lift = 0;
          if (vv && vv.scale <= 1.01 && this.type && document.activeElement === this.type && !this.phone.matches) {
            const m = this.edge();
            lift = Math.max(0, Math.min(this.cy + this.h / 2 + m - (vv.offsetTop + vv.height), this.cy - this.h / 2 - m - vv.offsetTop));
          }
          if (lift !== (this.lift || 0)) { this.lift = lift; this.render(); }
          if (this.open) this.place();
        }
        // the orientation the dock has or is turning to
        vertNow() { return this.morphTo ?? this.bar.classList.contains('is-vertical'); }
        setSide(p, save, animate) {
          const v = this.vert(p), turning = this.vertNow() !== v;
          this.pos = p;
          this.bar.dataset.side = p;
          if (turning && animate && this.motion() && !document.hidden) this.morph(v);
          else if (turning) { this.endMorph(); this.bar.classList.toggle('is-vertical', v); ({ w: this.w, h: this.h } = this.size(p)); }
          this.corner?.classList.toggle('is-covered', p === 'top' && this.corner.classList.contains('werk-magnetic-mega-nav_corner--center'));
          if (save && this.hasAttribute('data-remember')) try { localStorage.setItem(this.key, p); } catch (e) {}
        }
        layout(rebuild = true) {
          if (!rebuild && !this.phone.matches) {
            // same width, new height (browser bars, an on-screen keyboard): just re-centre, keep an unfolded field
            if (!this.dragging && !this.mraf) { cancelAnimationFrame(this.raf); const c = this.centre(this.pos); this.cx = c.x; this.cy = c.y; this.render(); }
            if (this.open) this.place();
            return;
          }
          this.vw = document.documentElement.clientWidth;
          cancelAnimationFrame(this.raf);
          this.endMorph();
          if (this.bar.classList.contains('is-searching')) { this.closeField(true); this.type.blur(); }
          if (this.phone.matches) {
            this.bar.classList.remove('is-vertical');
            this.bar.style.transform = '';
          } else {
            this.measure();
            this.setSide(this.pos);
            ({ w: this.w, h: this.h } = this.size(this.pos));
            const c = this.centre(this.pos);
            this.cx = c.x; this.cy = c.y; this.scale = 1;
            this.render();
          }
          // the field left the row (tight, phone) while its results were open
          if (this.typed && !this.fieldOn()) this.close();
          if (this.open) this.place();
        }
        motion() { return this.dataset.motion === 'on' && !this.still.matches; }

        // The turn – the same move as the dock on werk.build: the content blinks out, the empty glass folds along its
        // old axis into a small round shape, unfolds along the new one (the growing edge gives a little), then the new
        // layout flows in along its new axis. The spring carries the centre to the edge meanwhile.
        morph(v) {
          this.endMorph();
          const bar = this.bar, from = { w: this.w, h: this.h }, to = v ? this.sizes.v : this.sizes.h;
          const a = v ? 'w' : 'h', b = v ? 'h' : 'w'; // a folds first, b unfolds after
          const r0 = parseFloat(getComputedStyle(bar).borderTopLeftRadius) || 22, r1 = Math.min(to.w, to.h) / 2;
          const parts = () => [...bar.children].filter((el) => getComputedStyle(el).display !== 'none');
          const seg = (t, start, dur) => Math.min(1, Math.max(0, (t - start) / dur));
          const io2 = (t) => (t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2);
          const io3 = (t) => (t < 0.5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2);
          // cubic-bezier as a function (bisection on x)
          const bez = (x1, y1, x2, y2) => (x) => {
            let lo = 0, hi = 1, t = x;
            for (let i = 0; i < 20; i++) { t = (lo + hi) / 2; 3 * (1 - t) ** 2 * t * x1 + 3 * (1 - t) * t * t * x2 + t ** 3 < x ? (lo = t) : (hi = t); }
            return 3 * (1 - t) ** 2 * t * y1 + 3 * (1 - t) * t * t * y2 + t ** 3;
          };
          // soft start, 2 % over the target, then back: the "give" of the growing edge
          const g1 = bez(0.6, 0, 0.28, 0.98), g2 = bez(0.44, -0.5, 0.68, 1);
          const give = (x) => (x < 0.5 ? 1.02 * g1(x * 2) : 1.02 - 0.02 * g2(x * 2 - 1));
          const old = parts(), mid = (old.length - 1) / 2;
          bar.classList.add('is-morphing');
          this.fx = old.map((el, i) => el.animate([{ opacity: 1, scale: 1 }, { opacity: 0, scale: 0.7 }], { duration: 160, delay: Math.abs(i - mid) * 12, easing: 'cubic-bezier(0.11, 0, 0.5, 0)', fill: 'forwards' }));
          const turnAt = 0.16 + Math.ceil(mid) * 0.012, t0 = performance.now();
          let turned = false, shown = false;
          this.morphTo = v;
          const step = (now) => {
            const t = (now - t0) / 1000;
            if (!turned && t >= turnAt) {
              turned = true;
              bar.classList.add('is-blank');
              bar.classList.toggle('is-vertical', v);
              this.fx.forEach((x) => x.cancel());
              this.fx = [];
            }
            this[a] = from[a] + (to[a] - from[a]) * io3(seg(t, 0.08, 0.38));
            this[b] = from[b] + (to[b] - from[b]) * give(seg(t, 0.36, 0.55));
            const round = t < 0.46 ? io2(seg(t, 0.16, 0.3)) : 1 - io2(seg(t, 0.46, 0.3));
            bar.style.width = this.w + 'px';
            bar.style.height = this.h + 'px';
            bar.style.borderRadius = r0 + (r1 - r0) * round + 'px';
            if (!shown && t >= 0.6) {
              shown = true;
              bar.classList.remove('is-blank');
              this.fx = parts().map((el, i) => el.animate([{ opacity: 0, scale: 0.7, translate: v ? '0 -8px' : '-8px 0' }, { opacity: 1, scale: 1, translate: '0 0' }], { duration: 450, delay: i * 35, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'backwards' }));
            }
            this.render();
            if (t < 0.91) { this.mraf = requestAnimationFrame(step); return; }
            this.mraf = 0;
            this.morphTo = null;
            bar.classList.remove('is-morphing');
            bar.style.width = bar.style.height = bar.style.borderRadius = '';
            ({ w: this.w, h: this.h } = to);
            this.render();
          };
          this.mraf = requestAnimationFrame(step);
        }
        // jump to the end of a running turn (a new turn, a resize, the theme editor)
        endMorph() {
          cancelAnimationFrame(this.mraf);
          this.mraf = 0;
          this.fx?.forEach((x) => x.cancel());
          this.fx = [];
          const bar = this.bar;
          if (this.morphTo != null) {
            bar.classList.toggle('is-vertical', this.morphTo);
            ({ w: this.w, h: this.h } = this.morphTo ? this.sizes.v : this.sizes.h);
            this.morphTo = null;
          }
          bar.classList.remove('is-morphing', 'is-blank');
          bar.style.width = bar.style.height = bar.style.borderRadius = '';
        }

        // spring per axis: damping 1 = no overshoot, response in seconds
        spring(t, { damping = 1, response = 0.4, vx = 0, vy = 0 } = {}) {
          cancelAnimationFrame(this.raf);
          if (!this.motion() || document.hidden) { this.cx = t.x; this.cy = t.y; this.scale = 1; this.render(); return; }
          const k = (2 * Math.PI / response) ** 2, c = (4 * Math.PI * damping) / response;
          let vs = 0, last = performance.now();
          const step = (now) => {
            const dt = Math.min((now - last) / 1000, 1 / 30) / 4; last = now;
            for (let i = 0; i < 4; i++) {
              vx += (-k * (this.cx - t.x) - c * vx) * dt; this.cx += vx * dt;
              vy += (-k * (this.cy - t.y) - c * vy) * dt; this.cy += vy * dt;
              vs += (-k * (this.scale - 1) - c * vs) * dt; this.scale += vs * dt;
            }
            this.render();
            if (this.open) this.place();
            if (Math.abs(this.cx - t.x) < 0.3 && Math.abs(this.cy - t.y) < 0.3 && Math.abs(vx) < 5 && Math.abs(vy) < 5 && Math.abs(this.scale - 1) < 0.001) {
              this.cx = t.x; this.cy = t.y; this.scale = 1; this.render(); return;
            }
            this.raf = requestAnimationFrame(step);
          };
          this.raf = requestAnimationFrame(step);
        }
        snap(side, vx = 0, vy = 0, thrown) {
          const turning = this.vert(side) !== this.vertNow() && this.motion() && !document.hidden;
          this.setSide(side, true, true);
          this.render();
          // a little bounce only because a throw preceded it; a turn takes a touch longer so the glass travels with its morph
          this.spring(this.centre(side), turning ? { damping: thrown ? 0.78 : 0.9, response: 0.5, vx, vy } : { damping: thrown ? 0.8 : 1, response: 0.4, vx, vy });
        }

        // ---------- drag, throw, snap ----------
        project(v) { const d = 0.998; return ((v / 1000) * d) / (1 - d); }
        velocity() {
          const now = performance.now();
          this.hist = this.hist.filter((p) => now - p.t < 100);
          if (this.hist.length < 2) return { x: 0, y: 0 };
          const a = this.hist[0], b = this.hist[this.hist.length - 1], dt = (b.t - a.t) / 1000 || 1;
          return { x: (b.x - a.x) / dt, y: (b.y - a.y) / dt };
        }
        nearest(px, py) {
          let best = this.pos, bd = Infinity;
          this.sides.forEach((p) => {
            const c = this.centre(p), d = Math.hypot(c.x - px, c.y - py);
            if (d < bd) { bd = d; best = p; }
          });
          return best;
        }
        showGuides(on, active) {
          const g = this.guides;
          if (!g) return;
          if (on && g.hidden) {
            g.hidden = false;
            this.sides.forEach((p) => {
              const el = g.querySelector(`[data-side="${p}"]`), t = this.target(p), s = this.size(p);
              el.style.transform = `translate3d(${t.x}px,${t.y}px,0)`;
              el.style.width = s.w + 'px'; el.style.height = s.h + 'px';
            });
            if (g.showPopover) { g.setAttribute('popover', 'manual'); g.showPopover(); }
          }
          if (!on) { try { g.hidePopover(); } catch (e) {} g.hidden = true; return; }
          g.querySelectorAll('[data-side]').forEach((el) => el.classList.toggle('is-target', el.dataset.side === active));
        }
        dragStart(e) {
          if (this.phone.matches || e.button > 0) return;
          e.preventDefault();
          this.close();
          this.closeField(true);
          this.type?.blur();
          cancelAnimationFrame(this.raf);
          try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) {}
          this.dragging = true;
          this.offX = e.clientX - this.cx; this.offY = e.clientY - this.cy;
          this.hist = [{ x: e.clientX, y: e.clientY, t: performance.now() }];
          this.bar.classList.add('is-dragging');
          this.scale = 1.03; this.render();
          this.showGuides(true, this.pos);
        }
        dragMove(e) {
          if (!this.dragging) return;
          if (!e.buttons) return this.dragEnd(); // released somewhere we did not hear about
          this.cx = e.clientX - this.offX; this.cy = e.clientY - this.offY; this.render();
          this.hist.push({ x: e.clientX, y: e.clientY, t: performance.now() });
          const v = this.velocity();
          const side = this.nearest(this.cx + this.project(v.x), this.cy + this.project(v.y));
          this.showGuides(true, side);
          const hint = this.$('hint');
          if (hint) {
            const name = String(this.t.sides || '').split(',')[['top', 'bottom', 'left', 'right'].indexOf(side)]?.trim() || side.toUpperCase();
            hint.textContent = String(this.t.drag || '').replace('[side]', name);
            hint.style.transform = `translate3d(${e.clientX + 18}px,${e.clientY + 18}px,0)`;
          }
        }
        dragEnd() {
          if (!this.dragging) return;
          this.dragging = false;
          this.bar.classList.remove('is-dragging');
          this.showGuides(false);
          const v = this.velocity();
          this.snap(this.nearest(this.cx + this.project(v.x), this.cy + this.project(v.y)), v.x, v.y, true);
        }

        // ---------- panel ----------
        toggle(name, btn) {
          // a click right after hover opened the same panel keeps it open (the hover got there first)
          if (this.open === name && performance.now() - (this.hoverAt || 0) < 600) return;
          if (this.open === name) return this.close();
          // the menu icon shows an X while a list or a drill-down from it is open: the X closes
          if (btn === this.menuBtn && btn.classList.contains('is-open')) return this.close();
          this.show(name, btn);
        }
        show(name, btn, { focus = true, typed = false } = {}) {
          const pane = this.panel.querySelector(`[data-pane="${name}"]`);
          if (!pane) return;
          clearTimeout(this.lt);
          this.typed = typed; // results of the field in the dock: the panel shows no second field
          this.panel.classList.toggle('is-typed', typed);
          const first = !this.open;
          const prev = first ? null : this.panel.querySelector(`[data-pane="${this.open}"]`);
          const h0 = first ? 0 : this.panel.offsetHeight;
          this.panel.querySelectorAll('[data-pane]').forEach((p) => (p.hidden = p !== pane));
          this.querySelectorAll('[data-open]').forEach((b) => b.setAttribute('aria-expanded', String(b.dataset.open === name)));
          // drill-down (phones, left / right edge, or opened from inside the panel): back button, stacked columns
          const fromPanel = !!(btn && this.panel.contains(btn));
          const drill = (/^mega-/.test(name) && (fromPanel || this.phone.matches || this.bar.classList.contains('is-vertical'))) || (name === 'locale' && fromPanel);
          this.panel.classList.toggle('is-drill', drill);
          this.menuBtn?.classList.toggle('is-open', name === 'menu' || drill);
          this.open = name;
          if (!btn || !this.panel.contains(btn)) this.trigger = btn;
          this.panel.hidden = false;
          if (first && this.panel.showPopover) this.panel.showPopover();
          this.place();
          if (this.motion()) {
            const ease = 'cubic-bezier(0.16, 1, 0.3, 1)';
            const fades = [...pane.querySelectorAll('[data-fade]')];
            if (first) {
              this.panel.classList.remove('is-sizing');
              this.panel.animate([{ opacity: 0, scale: 0.94, filter: 'blur(6px)' }, { opacity: 1, scale: 1, filter: 'blur(0)' }], { duration: 350, easing: ease });
              fades.forEach((el, i) => el.animate([{ opacity: 0, translate: '0 8px' }, { opacity: 1, translate: '0 0' }], { duration: 350, delay: 60 + i * 35, easing: ease, fill: 'backwards' }));
            } else {
              // morph the height, slide the content in from the side the pointer came from
              const h1 = this.panel.offsetHeight;
              // while it morphs the content is taller than the panel (growing) or slides in past its edge – a panel that fits
              // at rest must not flash a scrollbar meanwhile (classic scrollbars also squeeze the content by their width)
              const fits = this.panel.scrollHeight <= this.panel.clientHeight + 1;
              const fx = [];
              if (Math.abs(h1 - h0) > 1) fx.push(this.panel.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 400, easing: ease }));
              const dir = Math.sign((+pane.dataset.order || 0) - (+prev?.dataset.order || 0)) || 1;
              (fades.length ? fades : [pane]).forEach((el, i) =>
                fx.push(el.animate([{ opacity: 0, translate: `${dir * 28}px 0` }, { opacity: 1, translate: '0 0' }], { duration: 380, delay: i * 30, easing: ease, fill: 'backwards' }))
              );
              const sw = (this.sw = (this.sw || 0) + 1);
              this.panel.classList.toggle('is-sizing', fits);
              Promise.allSettled(fx.map((x) => x.finished)).then(() => { if (sw === this.sw) this.panel.classList.remove('is-sizing'); });
            }
          }
          if (!focus) return;
          const target = name === 'search' ? this.$('input') : pane.querySelector('a, select, button:not([hidden])');
          (target && target.offsetParent ? target : pane.querySelector('a, select'))?.focus({ preventScroll: true });
        }
        close(restore) {
          if (!this.open) return;
          clearTimeout(this.lt);
          clearTimeout(this.ht);
          const done = () => {
            this.panel.hidden = true;
            this.panel.classList.remove('is-drill', 'is-typed');
            try { this.panel.hidePopover(); } catch (e) {}
          };
          this.querySelectorAll('[data-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
          this.menuBtn?.classList.remove('is-open');
          this.open = null;
          const typed = this.typed;
          this.typed = false;
          if (typed && document.activeElement !== this.type) this.closeField();
          // back to the field without its focus handler searching again – Escape on a result would reopen what it just closed
          if (restore) { this.quiet = true; this.trigger?.focus({ preventScroll: true }); this.quiet = false; }
          if (this.motion()) {
            this.panel.animate([{ opacity: 1, scale: 1 }, { opacity: 0, scale: 0.96 }], { duration: 200, easing: 'cubic-bezier(0.4, 0, 1, 1)' }).finished.then(() => { if (!this.open) done(); });
          } else done();
        }
        // hover intent for mega items (desktop, mouse, dock horizontal)
        canHover(e) {
          return e.pointerType === 'mouse' && !this.dragging && !this.phone.matches && !this.bar.classList.contains('is-vertical');
        }
        hoverIn(b, e) {
          if (!this.canHover(e)) return;
          clearTimeout(this.lt);
          clearTimeout(this.ht);
          const open = () => { if (this.open !== b.dataset.open) { this.hoverAt = performance.now(); this.show(b.dataset.open, b, { focus: false }); } };
          if (this.open && /^mega-/.test(this.open)) open();
          else this.ht = setTimeout(open, 120);
        }
        hoverOut(e) {
          if (e.pointerType !== 'mouse') return;
          clearTimeout(this.ht);
          if (!this.open || !/^mega-/.test(this.open) || this.panel.classList.contains('is-drill')) return;
          if (this.panel.contains(document.activeElement)) return; // keyboard users keep it open
          this.lt = setTimeout(() => this.close(), 220);
        }
        // grows out of the dock and always opens away from the edge the dock sits on
        place() {
          const r = this.bar.getBoundingClientRect(), p = this.panel, W = document.documentElement.clientWidth, H = innerHeight;
          const gap = 10, m = 16, side = this.phone.matches ? 'bottom' : this.pos;
          const vv = window.visualViewport;
          if (this.phone.matches && this.open === 'search' && vv) {
            // Phones: the keyboard slides over the dock and everything above it – the search opens at the top of what
            // stays visible and never gets taller than that, so the field and the results are always in view.
            p.style.maxWidth = '';
            p.style.maxHeight = Math.max(120, vv.height - 2 * m) + 'px';
            p.style.top = '0px';
            p.style.bottom = 'auto';
            p.style.transform = `translate3d(${vv.offsetLeft + (vv.width - p.offsetWidth) / 2}px,${vv.offsetTop + m}px,0)`;
            p.style.transformOrigin = '50% 0';
            return;
          }
          const room = side === 'bottom' ? r.top - gap - m : side === 'top' ? H - r.bottom - gap - m : H - 2 * m;
          p.style.maxHeight = Math.max(160, room) + 'px';
          // next to a vertical dock the panel only gets the room beside it (e.g. search at 768 px)
          p.style.maxWidth = side === 'left' ? W - r.right - gap - m + 'px' : side === 'right' ? r.left - gap - m + 'px' : '';
          const pw = p.offsetWidth, ph = p.offsetHeight;
          let x = r.left + r.width / 2 - pw / 2, y = r.top + r.height / 2 - ph / 2;
          if (side === 'left') x = r.right + gap;
          if (side === 'right') x = r.left - gap - pw;
          x = Math.max(m, Math.min(x, W - pw - m));
          const ox = r.left + r.width / 2 - x;
          if (side === 'bottom') {
            // anchored by its bottom edge, so height changes grow upwards out of the dock
            p.style.top = 'auto';
            p.style.bottom = H - r.top + gap + 'px';
            p.style.transform = `translate3d(${x}px,0,0)`;
            p.style.transformOrigin = `${ox}px calc(100% + ${gap + r.height / 2}px)`;
            return;
          }
          if (side === 'top') y = r.bottom + gap;
          y = Math.max(m, Math.min(y, H - ph - m));
          p.style.top = '0px';
          p.style.bottom = 'auto';
          p.style.transform = `translate3d(${x}px,${y}px,0)`;
          p.style.transformOrigin = `${ox}px ${r.top + r.height / 2 - y}px`;
        }
        onKey(e) {
          if (e.key === 'Escape' && this.open) { e.preventDefault(); this.close(true); }
        }
        onShortcut(e) {
          if (!(e.metaKey || e.ctrlKey) || e.altKey || e.key.toLowerCase() !== 'k' || !this.$('input') || this.classList.contains('is-away')) return;
          e.preventDefault();
          e.stopPropagation();
          if (this.fieldOn()) { this.type.focus({ preventScroll: true }); this.type.select(); return; }
          const b = this.querySelector('[data-open="search"]');
          this.open === 'search' ? this.close(true) : this.show('search', b);
        }

        // ---------- search field in the dock ----------
        // the field is in the row (not replaced by the icon on tight rows and phones)
        fieldOn() { return !!this.type && !this.phone.matches && getComputedStyle(this.field.parentElement).display !== 'none'; }
        // keeps the dock (right edge) and an open panel in place while a width animates
        follow(ms) {
          cancelAnimationFrame(this.fraf);
          const end = performance.now() + ms;
          const tick = (now) => { this.render(); if (this.open) this.place(); if (now < end) this.fraf = requestAnimationFrame(tick); };
          this.fraf = requestAnimationFrame(tick);
        }
        // Docked at a side the search is just an icon: focusing it unfolds the field into the page, leaving folds it back.
        openField() {
          if (this.open && !this.typed) this.close(); // searching and a menu at once would stack two layers – the search wins
          if (this.type.value.trim() && this.open !== 'search' && !this.quiet) this.search(this.type.value, true);
          const bar = this.bar, box = this.field;
          if (!bar.classList.contains('is-vertical')) return;
          const folding = this.folding;
          this.folding = false;
          this.sfx?.forEach((x) => x.cancel());
          this.sfx = [];
          if (bar.classList.contains('is-searching')) { if (folding) this.render(); return; }
          this.endMorph();
          const w0 = box.offsetWidth;
          bar.classList.add('is-searching');
          const w1 = box.offsetWidth;
          this.render();
          if (!this.motion()) return;
          const ease = 'cubic-bezier(0.16, 1, 0.3, 1)';
          this.sfx = [
            box.animate([{ width: w0 + 'px' }, { width: w1 + 'px' }], { duration: 600, easing: ease }),
            this.type.animate([{ opacity: 0, translate: '-6px 0' }, { opacity: 1, translate: '0 0' }], { duration: 400, delay: 140, easing: ease, fill: 'backwards' }),
          ];
          this.follow(620);
        }
        closeField(instant) {
          const bar = this.bar, box = this.field;
          if (!box || !bar.classList.contains('is-searching') || (this.folding && !instant)) return;
          this.sfx?.forEach((x) => x.cancel());
          this.sfx = [];
          const done = () => { this.folding = false; bar.classList.remove('is-searching'); this.render(); if (this.open) this.place(); };
          if (instant || !this.motion() || !bar.classList.contains('is-vertical')) return done();
          this.folding = true;
          const fold = box.animate([{ width: box.offsetWidth + 'px' }, { width: box.offsetHeight + 'px' }], { duration: 420, delay: 40, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'forwards' });
          this.sfx = [fold, this.type.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, easing: 'cubic-bezier(0.11, 0, 0.5, 0)', fill: 'forwards' })];
          fold.finished.then(() => { this.sfx.forEach((x) => x.cancel()); this.sfx = []; done(); }, () => {});
          this.follow(480);
        }
        leaveField(e) {
          const to = e.relatedTarget;
          if (this.pressed || (to && (this.field.contains(to) || this.panel.contains(to)))) return;
          if (this.typed) this.close();
          this.closeField();
        }
        // theme editor: selecting a block opens the panel it lives in
        onBlock(e, selected) {
          if (!this.contains(e.target)) return;
          if (!selected) return this.close();
          const pane = e.target.closest('[data-pane]');
          const btn = e.target.querySelector?.('[data-open]');
          if (pane) this.show(pane.dataset.pane, null, { focus: false });
          else if (btn) this.show(btn.dataset.open, btn, { focus: false });
        }

        // ---------- predictive search ----------
        search(q, typed) {
          clearTimeout(this.st);
          this.sc?.abort();
          const out = this.$('results');
          const none = () => { out.innerHTML = ''; if (typed && this.typed) this.close(); else if (this.open) this.place(); };
          if (!q.trim()) return none();
          this.st = setTimeout(async () => {
            this.sc = new AbortController();
            const u = new URL(this.dataset.searchUrl || '/search/suggest', location.origin);
            u.pathname += u.pathname.endsWith('.json') ? '' : '.json';
            u.searchParams.set('q', q);
            u.searchParams.set('resources[type]', 'product,collection,page,article');
            u.searchParams.set('resources[limit]', '4');
            u.searchParams.set('resources[options][unavailable_products]', 'last');
            try {
              const res = await fetch(u, { signal: this.sc.signal });
              const r = (await res.json()).resources?.results || {};
              this.renderResults(q, r);
              // typed in the dock: the results grow out of it (unless the field was left meanwhile)
              if (typed && this.open !== 'search' && document.activeElement === this.type) this.show('search', this.type, { focus: false, typed: true });
            } catch (err) {
              if (err.name !== 'AbortError') none();
            }
          }, 180);
        }
        renderResults(q, r) {
          const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
          let money = (v) => v;
          try {
            const f = new Intl.NumberFormat(this.dataset.locale || undefined, { style: 'currency', currency: this.dataset.currency || 'EUR' });
            money = (v) => f.format(parseFloat(v));
          } catch (e) {}
          const row = (item, thumb, meta) =>
            `<a class="werk-magnetic-mega-nav_row" href="${esc(item.url)}">${thumb}<span class="werk-magnetic-mega-nav_link werk-magnetic-mega-nav_row-title"><span class="werk-magnetic-mega-nav_link-text"><span>${esc(item.title)}</span></span></span>${meta}</a>`;
          const group = (title, items, fn) => (items?.length ? `<div class="werk-magnetic-mega-nav_group"><span class="werk-magnetic-mega-nav_group-title werk-magnetic-mega-nav_mono">${title}</span>${items.map(fn).join('')}</div>` : '');
          const img = (p) => {
            const src = p.featured_image?.url || p.image;
            return `<span class="werk-magnetic-mega-nav_thumb">${src ? `<img src="${esc(src)}${src.includes('?') ? '&' : '?'}width=120" alt="" width="44" height="44" loading="lazy">` : ''}</span>`;
          };
          const html =
            group(esc(this.t.products), r.products, (p) => row(p, img(p), `<span class="werk-magnetic-mega-nav_price">${esc(money(p.price))}</span>`)) +
            group(esc(this.t.collections), r.collections, (c) => row(c, '', '')) +
            group(esc(this.t.pages), [...(r.pages || []), ...(r.articles || [])], (c) => row(c, '', ''));
          const all = new URL(this.querySelector('.werk-magnetic-mega-nav_form')?.getAttribute('action') || '/search', location.origin);
          all.searchParams.set('q', q);
          const fresh = !this.$('results').children.length;
          this.$('results').innerHTML = html
            ? `${html}<a class="werk-magnetic-mega-nav_all werk-magnetic-mega-nav_link" href="${esc(all)}"><span class="werk-magnetic-mega-nav_link-text"><span>${esc(this.t.all).replace('[q]', esc(q))} →</span></span></a>`
            : `<p class="werk-magnetic-mega-nav_empty">${esc(this.t.none).replace('[q]', esc(q))}</p>`;
          // the first results flow in one after the other; while typing on they just swap
          if (fresh && this.motion()) {
            [...this.$('results').querySelectorAll('.werk-magnetic-mega-nav_group-title, .werk-magnetic-mega-nav_row, .werk-magnetic-mega-nav_all, .werk-magnetic-mega-nav_empty')].forEach((el, i) =>
              el.animate([{ opacity: 0, translate: '0 8px' }, { opacity: 1, translate: '0 0' }], { duration: 380, delay: Math.min(i, 8) * 30, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'backwards' })
            );
          }
          if (this.open) this.place();
        }

        // ---------- cart ----------
        openCart(e) {
          if (this.dataset.cart !== 'drawer') return;
          const horizon = document.querySelector('theme-drawer#cart-drawer');
          const dawn = document.querySelector('cart-drawer');
          const drawer = typeof horizon?.open === 'function' ? horizon : typeof dawn?.open === 'function' ? dawn : null;
          if (!drawer) return; // no drawer in this theme: follow the link to the cart page
          e.preventDefault();
          this.close();
          drawer.open(e.currentTarget);
        }
        async refreshCart() {
          const el = this.$('count');
          if (!el) return;
          try {
            const url = (this.dataset.cartUrl || '/cart').replace(/\/$/, '') + '.js';
            const cart = await (await fetch(url, { headers: { Accept: 'application/json' } })).json();
            const n = cart.item_count;
            if (String(n) === el.textContent && !el.hidden) return;
            el.textContent = n;
            el.hidden = n === 0;
            this.$('cart')?.setAttribute('aria-label', String((n === 1 ? this.t.cartOne : this.t.cart) || '').replace('[count]', n));
            if (n && this.motion()) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
          } catch (err) {}
        }

        themeColors() {
          const cs = getComputedStyle(document.body);
          let bg = cs.backgroundColor;
          if (!bg || /^(transparent|rgba\(.*,\s*0\))$/.test(bg)) bg = 'rgb(255, 255, 255)';
          this.style.setProperty('--werk-surface', bg);
          this.style.setProperty('--werk-fg', cs.color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-magnetic-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('werk-magnetic-nav')) {
    customElements.define(
      'werk-magnetic-nav',
      class extends HTMLElement {
        connectedCallback() {
          this.$ = (p) => this.querySelector(`[data-part="${p}"]`);
          this.bar = this.$('bar');
          this.panel = this.$('panel');
          this.corner = this.$('corner');
          this.guides = this.$('guides');
          if (!this.bar) return;
          try {
            this.t = JSON.parse(this.querySelector('script[data-werk-t]').textContent);
          } catch (e) {
            this.t = {};
          }
          this.phone = matchMedia('(max-width: 749px)');
          this.still = matchMedia('(prefers-reduced-motion: reduce)');
          this.key = 'werk-magnetic-nav-pos';
          this.sides = ['bottom', 'top', 'left', 'right'];
          // the position is the dock's CENTRE (cx, cy) plus its current size (w, h), so turning to a side can reshape
          // the glass around its middle while the spring carries it to the edge
          this.cx = 0; this.cy = 0; this.w = 0; this.h = 0; this.scale = 1; this.sizes = {};
          this.pos = this.dataset.pos;
          if (this.hasAttribute('data-remember') && this.hasAttribute('data-draggable')) {
            try { const p = localStorage.getItem(this.key); if (this.sides.includes(p)) this.pos = p; } catch (e) {}
          }
          // top layer: fixed parts escape transformed / clipped theme containers
          [this.corner, this.bar, this.panel].forEach((el) => {
            if (!el || !el.showPopover) return;
            el.setAttribute('popover', 'manual');
            if (el !== this.panel) { el.hidden = false; el.showPopover(); }
          });
          this.classList.add('is-js');
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          this.ac = new AbortController();
          const on = (t, e, f, o = {}) => t && t.addEventListener(e, f, { signal: this.ac.signal, ...o });
          this.querySelectorAll('[data-open]').forEach((b) => on(b, 'click', () => this.toggle(b.dataset.open, b)));
          on(document, 'shopify:block:select', (e) => this.onBlock(e, true));
          on(document, 'shopify:block:deselect', (e) => this.onBlock(e, false));
          on(document, 'keydown', (e) => this.onKey(e));
          // ⌘K / Ctrl+K belongs to this search: caught first, so a theme's own search window (Horizon) doesn't open on top
          on(window, 'keydown', (e) => this.onShortcut(e), { capture: true });
          this.menuBtn = this.bar.querySelector('.werk-magnetic-nav_menu-btn');
          on(this.$('x'), 'click', () => this.close(true));
          // an on-screen keyboard only changes the visual viewport: keep the search in what is still visible
          if (window.visualViewport) ['resize', 'scroll'].forEach((n) => on(visualViewport, n, () => this.onViewport()));
          on(document, 'pointerdown', (e) => { if (this.open && !this.panel.contains(e.target) && !this.bar.contains(e.target)) this.close(); });
          // only a new width rebuilds the dock – an on-screen keyboard changes the height and must not close the field
          on(window, 'resize', () => { clearTimeout(this.rt); this.rt = setTimeout(() => this.layout(this.vw !== document.documentElement.clientWidth), 100); });
          on(this.phone, 'change', () => this.layout());
          const grab = this.$('grabber');
          on(grab, 'pointerdown', (e) => this.dragStart(e));
          on(grab, 'pointermove', (e) => this.dragMove(e));
          on(grab, 'pointerup', () => this.dragEnd());
          on(grab, 'pointercancel', () => this.dragEnd());
          // never get stuck mid-screen: snap whenever the drag ends in a way the handle did not see
          on(grab, 'lostpointercapture', () => this.dragEnd());
          on(grab, 'dragstart', (e) => e.preventDefault());
          on(window, 'pointerup', () => this.dragEnd());
          on(window, 'blur', () => this.dragEnd());
          on(document, 'visibilitychange', () => { if (document.hidden && !this.dragging) this.layout(); });
          on(grab, 'keydown', (e) => {
            const side = { ArrowUp: 'top', ArrowDown: 'bottom', ArrowLeft: 'left', ArrowRight: 'right' }[e.key];
            if (side && !this.phone.matches) { e.preventDefault(); this.snap(side); }
          });
          on(this.$('input'), 'input', (e) => this.search(e.target.value));
          // the field in the dock: results grow out of the dock while typing
          this.field = this.$('field');
          this.type = this.$('type');
          if (this.type) {
            if (!/Mac|iPhone|iPad/.test(navigator.platform)) this.field.querySelector('kbd').textContent = `${this.t.ctrl || ''} K`.trim();
            on(this.type, 'focus', () => { this.openField(); this.onViewport(); });
            on(this.type, 'blur', () => this.onViewport());
            on(this.type, 'input', () => { this.field.classList.toggle('has-query', !!this.type.value.trim()); this.search(this.type.value, true); });
            on(this.type, 'keydown', (e) => { if (e.key === 'Escape' && !this.open) this.type.blur(); });
            on(this.field, 'focusout', (e) => this.leaveField(e));
            on(this.panel, 'focusout', (e) => { if (this.typed) this.leaveField(e); });
            // a press on a result must not count as leaving (Safari gives links no focus on click)
            on(this.panel, 'pointerdown', () => { this.pressed = true; });
            on(window, 'pointerup', () => { this.pressed = false; });
          }
          // ↑ ↓ walk through the results, ↑ on the first one goes back to the field
          on(this, 'keydown', (e) => {
            const d = e.key === 'ArrowDown' ? 1 : e.key === 'ArrowUp' ? -1 : 0;
            if (!d || this.open !== 'search') return;
            const input = this.typed ? this.type : this.$('input');
            const rows = [...this.$('results').querySelectorAll('a')], i = rows.indexOf(document.activeElement);
            if (i < 0 && (document.activeElement !== input || d < 0)) return;
            const next = i + d < 0 ? input : rows[i + d];
            if (next) { e.preventDefault(); next.focus({ preventScroll: true }); next.scrollIntoView?.({ block: 'nearest' }); }
          });
          // Theme overlays outside the top layer (Dawn's cart drawer, lightboxes, pop-ups) would sit UNDER the dock.
          // They lock the page scroll while open – then the dock steps aside. A page that is locked from the start
          // (themes that scroll an inner wrapper) is left alone.
          const locked = () => [document.documentElement, document.body].some((el) => /hidden|clip/.test(getComputedStyle(el).overflowY));
          const lockedAtStart = locked();
          this.mo = new MutationObserver(() => {
            const away = !lockedAtStart && locked();
            if (away === this.classList.contains('is-away')) return;
            this.classList.toggle('is-away', away);
            if (away) { this.close(); this.type?.blur(); }
          });
          [document.documentElement, document.body].forEach((el) => this.mo.observe(el, { attributes: true, attributeFilter: ['class', 'style'] }));
          on(this.querySelector('.werk-magnetic-nav_locale'), 'change', (e) => e.currentTarget.submit());
          const cart = this.$('cart');
          on(cart, 'click', (e) => this.openCart(e));
          ['shopify:cart:lines-update', 'cart:update', 'cart:refresh', 'cart:updated', 'cart-drawer:refresh'].forEach((n) => on(document, n, () => this.refreshCart()));
          if (document.fonts) document.fonts.ready.then(() => this.layout());
          this.layout();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.sc?.abort();
          this.mo?.disconnect();
          [this.lt, this.ht, this.rt, this.st].forEach(clearTimeout);
          [this.raf, this.mraf, this.fraf].forEach(cancelAnimationFrame);
          [...(this.fx || []), ...(this.sfx || [])].forEach((a) => a.cancel());
          [this.corner, this.bar, this.panel, this.guides].forEach((el) => { try { el?.hidePopover(); } catch (e) {} });
        }

        // ---------- position ----------
        vert(p) { return p === 'left' || p === 'right'; }
        edge() { return parseFloat(getComputedStyle(this).getPropertyValue('--werk-edge')) || 24; }
        measure() {
          const b = this.bar, v = b.classList.contains('is-vertical'), s = b.classList.contains('is-searching');
          b.classList.remove('is-vertical', 'is-searching'); // the plain dock, never the one widened by the search
          // doesn't fit one row: first the search field becomes an icon, then the links move behind the menu button
          // (always measured from the full dock without the width cap, so it can't flip-flop)
          const wasCrowded = this.classList.contains('is-crowded');
          this.classList.remove('is-tight', 'is-crowded');
          if (!this.phone.matches) {
            const room = document.documentElement.clientWidth - 2 * this.edge();
            const over = () => b.offsetWidth > room;
            b.style.maxWidth = 'none';
            if (over()) this.classList.add('is-tight');
            if (over() && !this.classList.contains('is-menu-button')) this.classList.add('is-crowded');
            b.style.maxWidth = '';
          }
          // the open dropdown / mega menu lost its trigger (it moved behind the menu button, or back)
          if (this.open && this.open !== 'search' && this.open !== 'locale' && wasCrowded !== this.classList.contains('is-crowded')) this.close();
          this.sizes.h = { w: b.offsetWidth, h: b.offsetHeight };
          b.classList.add('is-vertical');
          this.sizes.v = { w: b.offsetWidth, h: b.offsetHeight };
          b.classList.toggle('is-vertical', v);
          b.classList.toggle('is-searching', s);
        }
        size(p) { return this.vert(p) ? this.sizes.v : this.sizes.h; }
        target(p) {
          const s = this.size(p), W = document.documentElement.clientWidth, H = innerHeight, m = this.edge();
          if (p === 'top') return { x: (W - s.w) / 2, y: m };
          if (p === 'left') return { x: m, y: (H - s.h) / 2 };
          if (p === 'right') return { x: W - s.w - m, y: (H - s.h) / 2 };
          return { x: (W - s.w) / 2, y: H - s.h - m };
        }
        centre(p) { const t = this.target(p), s = this.size(p); return { x: t.x + s.w / 2, y: t.y + s.h / 2 }; }
        render() {
          // the search field unfolded at the right edge: the dock grows to the left, its right edge stays put
          const dx = this.pos === 'right' && this.bar.classList.contains('is-searching') ? this.w - this.bar.offsetWidth : 0;
          this.bar.style.transform = `translate3d(${this.cx - this.w / 2 + dx}px,${this.cy - this.h / 2 - (this.lift || 0)}px,0) scale(${this.scale})`;
        }
        // Tablets: an on-screen keyboard covers the bottom of the page – while the field in the dock is in use the dock
        // is lifted above it (never past the top of what is visible).
        onViewport() {
          const vv = window.visualViewport;
          let lift = 0;
          if (vv && vv.scale <= 1.01 && this.type && document.activeElement === this.type && !this.phone.matches) {
            const m = this.edge();
            lift = Math.max(0, Math.min(this.cy + this.h / 2 + m - (vv.offsetTop + vv.height), this.cy - this.h / 2 - m - vv.offsetTop));
          }
          if (lift !== (this.lift || 0)) { this.lift = lift; this.render(); }
          if (this.open) this.place();
        }
        // the orientation the dock has or is turning to
        vertNow() { return this.morphTo ?? this.bar.classList.contains('is-vertical'); }
        setSide(p, save, animate) {
          const v = this.vert(p), turning = this.vertNow() !== v;
          this.pos = p;
          this.bar.dataset.side = p;
          if (turning && animate && this.motion() && !document.hidden) this.morph(v);
          else if (turning) { this.endMorph(); this.bar.classList.toggle('is-vertical', v); ({ w: this.w, h: this.h } = this.size(p)); }
          this.corner?.classList.toggle('is-covered', p === 'top' && this.corner.classList.contains('werk-magnetic-nav_corner--center'));
          if (save && this.hasAttribute('data-remember')) try { localStorage.setItem(this.key, p); } catch (e) {}
        }
        layout(rebuild = true) {
          if (!rebuild && !this.phone.matches) {
            // same width, new height (browser bars, an on-screen keyboard): just re-centre, keep an unfolded field
            if (!this.dragging && !this.mraf) { cancelAnimationFrame(this.raf); const c = this.centre(this.pos); this.cx = c.x; this.cy = c.y; this.render(); }
            if (this.open) this.place();
            return;
          }
          this.vw = document.documentElement.clientWidth;
          cancelAnimationFrame(this.raf);
          this.endMorph();
          if (this.bar.classList.contains('is-searching')) { this.closeField(true); this.type.blur(); }
          if (this.phone.matches) {
            this.bar.classList.remove('is-vertical');
            this.bar.style.transform = '';
          } else {
            this.measure();
            this.setSide(this.pos);
            ({ w: this.w, h: this.h } = this.size(this.pos));
            const c = this.centre(this.pos);
            this.cx = c.x; this.cy = c.y; this.scale = 1;
            this.render();
          }
          // the field left the row (tight, phone) while its results were open
          if (this.typed && !this.fieldOn()) this.close();
          if (this.open) this.place();
        }
        motion() { return this.dataset.motion === 'on' && !this.still.matches; }

        // The turn – the same move as the dock on werk.build: the content blinks out, the empty glass folds along its
        // old axis into a small round shape, unfolds along the new one (the growing edge gives a little), then the new
        // layout flows in along its new axis. The spring carries the centre to the edge meanwhile.
        morph(v) {
          this.endMorph();
          const bar = this.bar, from = { w: this.w, h: this.h }, to = v ? this.sizes.v : this.sizes.h;
          const a = v ? 'w' : 'h', b = v ? 'h' : 'w'; // a folds first, b unfolds after
          const r0 = parseFloat(getComputedStyle(bar).borderTopLeftRadius) || 22, r1 = Math.min(to.w, to.h) / 2;
          const parts = () => [...bar.children].filter((el) => getComputedStyle(el).display !== 'none');
          const seg = (t, start, dur) => Math.min(1, Math.max(0, (t - start) / dur));
          const io2 = (t) => (t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2);
          const io3 = (t) => (t < 0.5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2);
          // cubic-bezier as a function (bisection on x)
          const bez = (x1, y1, x2, y2) => (x) => {
            let lo = 0, hi = 1, t = x;
            for (let i = 0; i < 20; i++) { t = (lo + hi) / 2; 3 * (1 - t) ** 2 * t * x1 + 3 * (1 - t) * t * t * x2 + t ** 3 < x ? (lo = t) : (hi = t); }
            return 3 * (1 - t) ** 2 * t * y1 + 3 * (1 - t) * t * t * y2 + t ** 3;
          };
          // soft start, 2 % over the target, then back: the "give" of the growing edge
          const g1 = bez(0.6, 0, 0.28, 0.98), g2 = bez(0.44, -0.5, 0.68, 1);
          const give = (x) => (x < 0.5 ? 1.02 * g1(x * 2) : 1.02 - 0.02 * g2(x * 2 - 1));
          const old = parts(), mid = (old.length - 1) / 2;
          bar.classList.add('is-morphing');
          this.fx = old.map((el, i) => el.animate([{ opacity: 1, scale: 1 }, { opacity: 0, scale: 0.7 }], { duration: 160, delay: Math.abs(i - mid) * 12, easing: 'cubic-bezier(0.11, 0, 0.5, 0)', fill: 'forwards' }));
          const turnAt = 0.16 + Math.ceil(mid) * 0.012, t0 = performance.now();
          let turned = false, shown = false;
          this.morphTo = v;
          const step = (now) => {
            const t = (now - t0) / 1000;
            if (!turned && t >= turnAt) {
              turned = true;
              bar.classList.add('is-blank');
              bar.classList.toggle('is-vertical', v);
              this.fx.forEach((x) => x.cancel());
              this.fx = [];
            }
            this[a] = from[a] + (to[a] - from[a]) * io3(seg(t, 0.08, 0.38));
            this[b] = from[b] + (to[b] - from[b]) * give(seg(t, 0.36, 0.55));
            const round = t < 0.46 ? io2(seg(t, 0.16, 0.3)) : 1 - io2(seg(t, 0.46, 0.3));
            bar.style.width = this.w + 'px';
            bar.style.height = this.h + 'px';
            bar.style.borderRadius = r0 + (r1 - r0) * round + 'px';
            if (!shown && t >= 0.6) {
              shown = true;
              bar.classList.remove('is-blank');
              this.fx = parts().map((el, i) => el.animate([{ opacity: 0, scale: 0.7, translate: v ? '0 -8px' : '-8px 0' }, { opacity: 1, scale: 1, translate: '0 0' }], { duration: 450, delay: i * 35, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'backwards' }));
            }
            this.render();
            if (t < 0.91) { this.mraf = requestAnimationFrame(step); return; }
            this.mraf = 0;
            this.morphTo = null;
            bar.classList.remove('is-morphing');
            bar.style.width = bar.style.height = bar.style.borderRadius = '';
            ({ w: this.w, h: this.h } = to);
            this.render();
          };
          this.mraf = requestAnimationFrame(step);
        }
        // jump to the end of a running turn (a new turn, a resize, the theme editor)
        endMorph() {
          cancelAnimationFrame(this.mraf);
          this.mraf = 0;
          this.fx?.forEach((x) => x.cancel());
          this.fx = [];
          const bar = this.bar;
          if (this.morphTo != null) {
            bar.classList.toggle('is-vertical', this.morphTo);
            ({ w: this.w, h: this.h } = this.morphTo ? this.sizes.v : this.sizes.h);
            this.morphTo = null;
          }
          bar.classList.remove('is-morphing', 'is-blank');
          bar.style.width = bar.style.height = bar.style.borderRadius = '';
        }

        // spring per axis: damping 1 = no overshoot, response in seconds
        spring(t, { damping = 1, response = 0.4, vx = 0, vy = 0 } = {}) {
          cancelAnimationFrame(this.raf);
          if (!this.motion() || document.hidden) { this.cx = t.x; this.cy = t.y; this.scale = 1; this.render(); return; }
          const k = (2 * Math.PI / response) ** 2, c = (4 * Math.PI * damping) / response;
          let vs = 0, last = performance.now();
          const step = (now) => {
            const dt = Math.min((now - last) / 1000, 1 / 30) / 4; last = now;
            for (let i = 0; i < 4; i++) {
              vx += (-k * (this.cx - t.x) - c * vx) * dt; this.cx += vx * dt;
              vy += (-k * (this.cy - t.y) - c * vy) * dt; this.cy += vy * dt;
              vs += (-k * (this.scale - 1) - c * vs) * dt; this.scale += vs * dt;
            }
            this.render();
            if (this.open) this.place();
            if (Math.abs(this.cx - t.x) < 0.3 && Math.abs(this.cy - t.y) < 0.3 && Math.abs(vx) < 5 && Math.abs(vy) < 5 && Math.abs(this.scale - 1) < 0.001) {
              this.cx = t.x; this.cy = t.y; this.scale = 1; this.render(); return;
            }
            this.raf = requestAnimationFrame(step);
          };
          this.raf = requestAnimationFrame(step);
        }
        snap(side, vx = 0, vy = 0, thrown) {
          const turning = this.vert(side) !== this.vertNow() && this.motion() && !document.hidden;
          this.setSide(side, true, true);
          this.render();
          // a little bounce only because a throw preceded it; a turn takes a touch longer so the glass travels with its morph
          this.spring(this.centre(side), turning ? { damping: thrown ? 0.78 : 0.9, response: 0.5, vx, vy } : { damping: thrown ? 0.8 : 1, response: 0.4, vx, vy });
        }

        // ---------- drag, throw, snap ----------
        project(v) { const d = 0.998; return ((v / 1000) * d) / (1 - d); }
        velocity() {
          const now = performance.now();
          this.hist = this.hist.filter((p) => now - p.t < 100);
          if (this.hist.length < 2) return { x: 0, y: 0 };
          const a = this.hist[0], b = this.hist[this.hist.length - 1], dt = (b.t - a.t) / 1000 || 1;
          return { x: (b.x - a.x) / dt, y: (b.y - a.y) / dt };
        }
        nearest(px, py) {
          let best = this.pos, bd = Infinity;
          this.sides.forEach((p) => {
            const c = this.centre(p), d = Math.hypot(c.x - px, c.y - py);
            if (d < bd) { bd = d; best = p; }
          });
          return best;
        }
        showGuides(on, active) {
          const g = this.guides;
          if (!g) return;
          if (on && g.hidden) {
            g.hidden = false;
            this.sides.forEach((p) => {
              const el = g.querySelector(`[data-side="${p}"]`), t = this.target(p), s = this.size(p);
              el.style.transform = `translate3d(${t.x}px,${t.y}px,0)`;
              el.style.width = s.w + 'px'; el.style.height = s.h + 'px';
            });
            if (g.showPopover) { g.setAttribute('popover', 'manual'); g.showPopover(); }
          }
          if (!on) { try { g.hidePopover(); } catch (e) {} g.hidden = true; return; }
          g.querySelectorAll('[data-side]').forEach((el) => el.classList.toggle('is-target', el.dataset.side === active));
        }
        dragStart(e) {
          if (this.phone.matches || e.button > 0) return;
          e.preventDefault();
          this.close();
          this.closeField(true);
          this.type?.blur();
          cancelAnimationFrame(this.raf);
          try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) {}
          this.dragging = true;
          this.offX = e.clientX - this.cx; this.offY = e.clientY - this.cy;
          this.hist = [{ x: e.clientX, y: e.clientY, t: performance.now() }];
          this.bar.classList.add('is-dragging');
          this.scale = 1.03; this.render();
          this.showGuides(true, this.pos);
        }
        dragMove(e) {
          if (!this.dragging) return;
          if (!e.buttons) return this.dragEnd(); // released somewhere we did not hear about
          this.cx = e.clientX - this.offX; this.cy = e.clientY - this.offY; this.render();
          this.hist.push({ x: e.clientX, y: e.clientY, t: performance.now() });
          const v = this.velocity();
          const side = this.nearest(this.cx + this.project(v.x), this.cy + this.project(v.y));
          this.showGuides(true, side);
          const hint = this.$('hint');
          if (hint) {
            const name = String(this.t.sides || '').split(',')[['top', 'bottom', 'left', 'right'].indexOf(side)]?.trim() || side.toUpperCase();
            hint.textContent = String(this.t.drag || '').replace('[side]', name);
            hint.style.transform = `translate3d(${e.clientX + 18}px,${e.clientY + 18}px,0)`;
          }
        }
        dragEnd() {
          if (!this.dragging) return;
          this.dragging = false;
          this.bar.classList.remove('is-dragging');
          this.showGuides(false);
          const v = this.velocity();
          this.snap(this.nearest(this.cx + this.project(v.x), this.cy + this.project(v.y)), v.x, v.y, true);
        }

        // ---------- panel ----------
        toggle(name, btn) {
          // a click right after hover opened the same panel keeps it open (the hover got there first)
          if (this.open === name && performance.now() - (this.hoverAt || 0) < 600) return;
          if (this.open === name) return this.close();
          // the menu icon shows an X while a list or a drill-down from it is open: the X closes
          if (btn === this.menuBtn && btn.classList.contains('is-open')) return this.close();
          this.show(name, btn);
        }
        show(name, btn, { focus = true, typed = false } = {}) {
          const pane = this.panel.querySelector(`[data-pane="${name}"]`);
          if (!pane) return;
          clearTimeout(this.lt);
          this.typed = typed; // results of the field in the dock: the panel shows no second field
          this.panel.classList.toggle('is-typed', typed);
          const first = !this.open;
          const prev = first ? null : this.panel.querySelector(`[data-pane="${this.open}"]`);
          const h0 = first ? 0 : this.panel.offsetHeight;
          this.panel.querySelectorAll('[data-pane]').forEach((p) => (p.hidden = p !== pane));
          this.querySelectorAll('[data-open]').forEach((b) => b.setAttribute('aria-expanded', String(b.dataset.open === name)));
          // drill-down (phones, left / right edge, or opened from inside the panel): back button, stacked columns
          const fromPanel = !!(btn && this.panel.contains(btn));
          const drill = (/^mega-/.test(name) && (fromPanel || this.phone.matches || this.bar.classList.contains('is-vertical'))) || (name === 'locale' && fromPanel);
          this.panel.classList.toggle('is-drill', drill);
          this.menuBtn?.classList.toggle('is-open', name === 'menu' || drill);
          this.open = name;
          if (!btn || !this.panel.contains(btn)) this.trigger = btn;
          this.panel.hidden = false;
          if (first && this.panel.showPopover) this.panel.showPopover();
          this.place();
          if (this.motion()) {
            const ease = 'cubic-bezier(0.16, 1, 0.3, 1)';
            const fades = [...pane.querySelectorAll('[data-fade]')];
            if (first) {
              this.panel.classList.remove('is-sizing');
              this.panel.animate([{ opacity: 0, scale: 0.94, filter: 'blur(6px)' }, { opacity: 1, scale: 1, filter: 'blur(0)' }], { duration: 350, easing: ease });
              fades.forEach((el, i) => el.animate([{ opacity: 0, translate: '0 8px' }, { opacity: 1, translate: '0 0' }], { duration: 350, delay: 60 + i * 35, easing: ease, fill: 'backwards' }));
            } else {
              // morph the height, slide the content in from the side the pointer came from
              const h1 = this.panel.offsetHeight;
              // while it morphs the content is taller than the panel (growing) or slides in past its edge – a panel that fits
              // at rest must not flash a scrollbar meanwhile (classic scrollbars also squeeze the content by their width)
              const fits = this.panel.scrollHeight <= this.panel.clientHeight + 1;
              const fx = [];
              if (Math.abs(h1 - h0) > 1) fx.push(this.panel.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 400, easing: ease }));
              const dir = Math.sign((+pane.dataset.order || 0) - (+prev?.dataset.order || 0)) || 1;
              (fades.length ? fades : [pane]).forEach((el, i) =>
                fx.push(el.animate([{ opacity: 0, translate: `${dir * 28}px 0` }, { opacity: 1, translate: '0 0' }], { duration: 380, delay: i * 30, easing: ease, fill: 'backwards' }))
              );
              const sw = (this.sw = (this.sw || 0) + 1);
              this.panel.classList.toggle('is-sizing', fits);
              Promise.allSettled(fx.map((x) => x.finished)).then(() => { if (sw === this.sw) this.panel.classList.remove('is-sizing'); });
            }
          }
          if (!focus) return;
          const target = name === 'search' ? this.$('input') : pane.querySelector('a, select, button:not([hidden])');
          (target && target.offsetParent ? target : pane.querySelector('a, select'))?.focus({ preventScroll: true });
        }
        close(restore) {
          if (!this.open) return;
          clearTimeout(this.lt);
          clearTimeout(this.ht);
          const done = () => {
            this.panel.hidden = true;
            this.panel.classList.remove('is-drill', 'is-typed');
            try { this.panel.hidePopover(); } catch (e) {}
          };
          this.querySelectorAll('[data-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
          this.menuBtn?.classList.remove('is-open');
          this.open = null;
          const typed = this.typed;
          this.typed = false;
          if (typed && document.activeElement !== this.type) this.closeField();
          // back to the field without its focus handler searching again – Escape on a result would reopen what it just closed
          if (restore) { this.quiet = true; this.trigger?.focus({ preventScroll: true }); this.quiet = false; }
          if (this.motion()) {
            this.panel.animate([{ opacity: 1, scale: 1 }, { opacity: 0, scale: 0.96 }], { duration: 200, easing: 'cubic-bezier(0.4, 0, 1, 1)' }).finished.then(() => { if (!this.open) done(); });
          } else done();
        }
        // grows out of the dock and always opens away from the edge the dock sits on
        place() {
          const r = this.bar.getBoundingClientRect(), p = this.panel, W = document.documentElement.clientWidth, H = innerHeight;
          const gap = 10, m = 16, side = this.phone.matches ? 'bottom' : this.pos;
          const vv = window.visualViewport;
          if (this.phone.matches && this.open === 'search' && vv) {
            // Phones: the keyboard slides over the dock and everything above it – the search opens at the top of what
            // stays visible and never gets taller than that, so the field and the results are always in view.
            p.style.maxWidth = '';
            p.style.maxHeight = Math.max(120, vv.height - 2 * m) + 'px';
            p.style.top = '0px';
            p.style.bottom = 'auto';
            p.style.transform = `translate3d(${vv.offsetLeft + (vv.width - p.offsetWidth) / 2}px,${vv.offsetTop + m}px,0)`;
            p.style.transformOrigin = '50% 0';
            return;
          }
          const room = side === 'bottom' ? r.top - gap - m : side === 'top' ? H - r.bottom - gap - m : H - 2 * m;
          p.style.maxHeight = Math.max(160, room) + 'px';
          // next to a vertical dock the panel only gets the room beside it (e.g. search at 768 px)
          p.style.maxWidth = side === 'left' ? W - r.right - gap - m + 'px' : side === 'right' ? r.left - gap - m + 'px' : '';
          const pw = p.offsetWidth, ph = p.offsetHeight;
          let x = r.left + r.width / 2 - pw / 2, y = r.top + r.height / 2 - ph / 2;
          if (side === 'left') x = r.right + gap;
          if (side === 'right') x = r.left - gap - pw;
          x = Math.max(m, Math.min(x, W - pw - m));
          const ox = r.left + r.width / 2 - x;
          if (side === 'bottom') {
            // anchored by its bottom edge, so height changes grow upwards out of the dock
            p.style.top = 'auto';
            p.style.bottom = H - r.top + gap + 'px';
            p.style.transform = `translate3d(${x}px,0,0)`;
            p.style.transformOrigin = `${ox}px calc(100% + ${gap + r.height / 2}px)`;
            return;
          }
          if (side === 'top') y = r.bottom + gap;
          y = Math.max(m, Math.min(y, H - ph - m));
          p.style.top = '0px';
          p.style.bottom = 'auto';
          p.style.transform = `translate3d(${x}px,${y}px,0)`;
          p.style.transformOrigin = `${ox}px ${r.top + r.height / 2 - y}px`;
        }
        onKey(e) {
          if (e.key === 'Escape' && this.open) { e.preventDefault(); this.close(true); }
        }
        onShortcut(e) {
          if (!(e.metaKey || e.ctrlKey) || e.altKey || e.key.toLowerCase() !== 'k' || !this.$('input') || this.classList.contains('is-away')) return;
          e.preventDefault();
          e.stopPropagation();
          if (this.fieldOn()) { this.type.focus({ preventScroll: true }); this.type.select(); return; }
          const b = this.querySelector('[data-open="search"]');
          this.open === 'search' ? this.close(true) : this.show('search', b);
        }

        // ---------- search field in the dock ----------
        // the field is in the row (not replaced by the icon on tight rows and phones)
        fieldOn() { return !!this.type && !this.phone.matches && getComputedStyle(this.field.parentElement).display !== 'none'; }
        // keeps the dock (right edge) and an open panel in place while a width animates
        follow(ms) {
          cancelAnimationFrame(this.fraf);
          const end = performance.now() + ms;
          const tick = (now) => { this.render(); if (this.open) this.place(); if (now < end) this.fraf = requestAnimationFrame(tick); };
          this.fraf = requestAnimationFrame(tick);
        }
        // Docked at a side the search is just an icon: focusing it unfolds the field into the page, leaving folds it back.
        openField() {
          if (this.open && !this.typed) this.close(); // searching and a menu at once would stack two layers – the search wins
          if (this.type.value.trim() && this.open !== 'search' && !this.quiet) this.search(this.type.value, true);
          const bar = this.bar, box = this.field;
          if (!bar.classList.contains('is-vertical')) return;
          const folding = this.folding;
          this.folding = false;
          this.sfx?.forEach((x) => x.cancel());
          this.sfx = [];
          if (bar.classList.contains('is-searching')) { if (folding) this.render(); return; }
          this.endMorph();
          const w0 = box.offsetWidth;
          bar.classList.add('is-searching');
          const w1 = box.offsetWidth;
          this.render();
          if (!this.motion()) return;
          const ease = 'cubic-bezier(0.16, 1, 0.3, 1)';
          this.sfx = [
            box.animate([{ width: w0 + 'px' }, { width: w1 + 'px' }], { duration: 600, easing: ease }),
            this.type.animate([{ opacity: 0, translate: '-6px 0' }, { opacity: 1, translate: '0 0' }], { duration: 400, delay: 140, easing: ease, fill: 'backwards' }),
          ];
          this.follow(620);
        }
        closeField(instant) {
          const bar = this.bar, box = this.field;
          if (!box || !bar.classList.contains('is-searching') || (this.folding && !instant)) return;
          this.sfx?.forEach((x) => x.cancel());
          this.sfx = [];
          const done = () => { this.folding = false; bar.classList.remove('is-searching'); this.render(); if (this.open) this.place(); };
          if (instant || !this.motion() || !bar.classList.contains('is-vertical')) return done();
          this.folding = true;
          const fold = box.animate([{ width: box.offsetWidth + 'px' }, { width: box.offsetHeight + 'px' }], { duration: 420, delay: 40, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'forwards' });
          this.sfx = [fold, this.type.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, easing: 'cubic-bezier(0.11, 0, 0.5, 0)', fill: 'forwards' })];
          fold.finished.then(() => { this.sfx.forEach((x) => x.cancel()); this.sfx = []; done(); }, () => {});
          this.follow(480);
        }
        leaveField(e) {
          const to = e.relatedTarget;
          if (this.pressed || (to && (this.field.contains(to) || this.panel.contains(to)))) return;
          if (this.typed) this.close();
          this.closeField();
        }
        // theme editor: selecting a block opens the panel it lives in
        onBlock(e, selected) {
          if (!this.contains(e.target)) return;
          if (!selected) return this.close();
          const pane = e.target.closest('[data-pane]');
          const btn = e.target.querySelector?.('[data-open]');
          if (pane) this.show(pane.dataset.pane, null, { focus: false });
          else if (btn) this.show(btn.dataset.open, btn, { focus: false });
        }

        // ---------- predictive search ----------
        search(q, typed) {
          clearTimeout(this.st);
          this.sc?.abort();
          const out = this.$('results');
          const none = () => { out.innerHTML = ''; if (typed && this.typed) this.close(); else if (this.open) this.place(); };
          if (!q.trim()) return none();
          this.st = setTimeout(async () => {
            this.sc = new AbortController();
            const u = new URL(this.dataset.searchUrl || '/search/suggest', location.origin);
            u.pathname += u.pathname.endsWith('.json') ? '' : '.json';
            u.searchParams.set('q', q);
            u.searchParams.set('resources[type]', 'product,collection,page,article');
            u.searchParams.set('resources[limit]', '4');
            u.searchParams.set('resources[options][unavailable_products]', 'last');
            try {
              const res = await fetch(u, { signal: this.sc.signal });
              const r = (await res.json()).resources?.results || {};
              this.renderResults(q, r);
              // typed in the dock: the results grow out of it (unless the field was left meanwhile)
              if (typed && this.open !== 'search' && document.activeElement === this.type) this.show('search', this.type, { focus: false, typed: true });
            } catch (err) {
              if (err.name !== 'AbortError') none();
            }
          }, 180);
        }
        renderResults(q, r) {
          const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
          let money = (v) => v;
          try {
            const f = new Intl.NumberFormat(this.dataset.locale || undefined, { style: 'currency', currency: this.dataset.currency || 'EUR' });
            money = (v) => f.format(parseFloat(v));
          } catch (e) {}
          const row = (item, thumb, meta) =>
            `<a class="werk-magnetic-nav_row" href="${esc(item.url)}">${thumb}<span class="werk-magnetic-nav_link werk-magnetic-nav_row-title"><span class="werk-magnetic-nav_link-text"><span>${esc(item.title)}</span></span></span>${meta}</a>`;
          const group = (title, items, fn) => (items?.length ? `<div class="werk-magnetic-nav_group"><span class="werk-magnetic-nav_group-title werk-magnetic-nav_mono">${title}</span>${items.map(fn).join('')}</div>` : '');
          const img = (p) => {
            const src = p.featured_image?.url || p.image;
            return `<span class="werk-magnetic-nav_thumb">${src ? `<img src="${esc(src)}${src.includes('?') ? '&' : '?'}width=120" alt="" width="44" height="44" loading="lazy">` : ''}</span>`;
          };
          const html =
            group(esc(this.t.products), r.products, (p) => row(p, img(p), `<span class="werk-magnetic-nav_price">${esc(money(p.price))}</span>`)) +
            group(esc(this.t.collections), r.collections, (c) => row(c, '', '')) +
            group(esc(this.t.pages), [...(r.pages || []), ...(r.articles || [])], (c) => row(c, '', ''));
          const all = new URL(this.querySelector('.werk-magnetic-nav_form')?.getAttribute('action') || '/search', location.origin);
          all.searchParams.set('q', q);
          const fresh = !this.$('results').children.length;
          this.$('results').innerHTML = html
            ? `${html}<a class="werk-magnetic-nav_all werk-magnetic-nav_link" href="${esc(all)}"><span class="werk-magnetic-nav_link-text"><span>${esc(this.t.all).replace('[q]', esc(q))} →</span></span></a>`
            : `<p class="werk-magnetic-nav_empty">${esc(this.t.none).replace('[q]', esc(q))}</p>`;
          // the first results flow in one after the other; while typing on they just swap
          if (fresh && this.motion()) {
            [...this.$('results').querySelectorAll('.werk-magnetic-nav_group-title, .werk-magnetic-nav_row, .werk-magnetic-nav_all, .werk-magnetic-nav_empty')].forEach((el, i) =>
              el.animate([{ opacity: 0, translate: '0 8px' }, { opacity: 1, translate: '0 0' }], { duration: 380, delay: Math.min(i, 8) * 30, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'backwards' })
            );
          }
          if (this.open) this.place();
        }

        // ---------- cart ----------
        openCart(e) {
          if (this.dataset.cart !== 'drawer') return;
          const horizon = document.querySelector('theme-drawer#cart-drawer');
          const dawn = document.querySelector('cart-drawer');
          const drawer = typeof horizon?.open === 'function' ? horizon : typeof dawn?.open === 'function' ? dawn : null;
          if (!drawer) return; // no drawer in this theme: follow the link to the cart page
          e.preventDefault();
          this.close();
          drawer.open(e.currentTarget);
        }
        async refreshCart() {
          const el = this.$('count');
          if (!el) return;
          try {
            const url = (this.dataset.cartUrl || '/cart').replace(/\/$/, '') + '.js';
            const cart = await (await fetch(url, { headers: { Accept: 'application/json' } })).json();
            const n = cart.item_count;
            if (String(n) === el.textContent && !el.hidden) return;
            el.textContent = n;
            el.hidden = n === 0;
            this.$('cart')?.setAttribute('aria-label', String((n === 1 ? this.t.cartOne : this.t.cart) || '').replace('[count]', n));
            if (n && this.motion()) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
          } catch (err) {}
        }

        themeColors() {
          const cs = getComputedStyle(document.body);
          let bg = cs.backgroundColor;
          if (!bg || /^(transparent|rgba\(.*,\s*0\))$/.test(bg)) bg = 'rgb(255, 255, 255)';
          this.style.setProperty('--werk-surface', bg);
          this.style.setProperty('--werk-fg', cs.color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-momentum-bento"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-momentum-bento')) {
    // Momentum hover – own physics, the principle follows Osmo's "Momentum Based Hover (Inertia)" (no code, no GSAP):
    // the pointer's speed is measured all the time; entering a tile gives it a push in that direction plus a spin
    // (offset from the centre × speed, like a torque), then a damped spring brings it back. Units: px, deg, seconds.
    const OMEGA = 2 * Math.PI * 2.2; // spring: about 2.2 swings per second
    const K = OMEGA * OMEGA;
    const VMAX = 4; // px per ms – faster flicks count as this
    const MAX_MOVE = 0.1; // of the tile's smaller side
    const MAX_SPIN = 9; // deg
    const TAP_SPIN = 3; // deg, touch wobble peak
    const clampAbs = (v, m) => (v > m ? m : v < -m ? -m : v);

    customElements.define(
      'werk-momentum-bento',
      class extends HTMLElement {
        connectedCallback() {
          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          this.still = matchMedia('(prefers-reduced-motion: reduce)');
          this.fine = matchMedia('(hover: hover) and (pointer: fine)');
          this.editor = !!window.Shopify?.designMode;
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          this.tiles = new Map();
          this.querySelectorAll('.werk-momentum-bento_tile').forEach((el) =>
            this.tiles.set(el, { el, cell: el.parentElement, x: 0, y: 0, r: 0, vx: 0, vy: 0, vr: 0, moving: false })
          );
          this.samples = [];

          // ---------- momentum (mouse / trackpad) and tap wobble (touch) ----------
          on(this, 'pointermove', (e) => {
            if (e.pointerType !== 'mouse') return;
            const s = this.samples;
            s.push({ t: e.timeStamp, x: e.clientX, y: e.clientY });
            if (s.length > 8) s.shift();
          }, { passive: true });
          on(this, 'pointerover', (e) => {
            if (e.pointerType !== 'mouse') return;
            const tile = e.target.closest?.('.werk-momentum-bento_tile');
            if (!tile || tile === this.over) return;
            this.over = tile;
            if (!this.moves('momentum') || !this.fine.matches) return;
            this.push(tile, e);
          });
          on(this, 'pointerleave', () => { this.over = null; });
          on(this, 'pointerdown', (e) => {
            if (e.pointerType === 'mouse' || !this.moves('wobble')) return;
            const tile = e.target.closest?.('.werk-momentum-bento_tile');
            if (tile) this.wobble(tile, e);
          }, { passive: true });

          // ---------- reveal: cells fade up in block order as they come into view ----------
          const cells = [...this.querySelectorAll('.werk-momentum-bento_cell')];
          if (this.dataset.motion === 'on' && !this.still.matches && !this.editor && 'IntersectionObserver' in window) {
            this.classList.add('is-reveal');
            this.io = new IntersectionObserver((entries) => {
              const hits = entries.filter((x) => x.isIntersecting).map((x) => x.target);
              hits.sort((a, b) => cells.indexOf(a) - cells.indexOf(b));
              hits.forEach((cell, i) => {
                cell.style.setProperty('--d', Math.min(i, 8) * 60 + 'ms');
                cell.classList.add('is-in');
                this.io.unobserve(cell);
              });
            }, { rootMargin: '0px 0px -6% 0px', threshold: 0.12 });
            cells.forEach((c) => this.io.observe(c));
          }

          // ---------- video: plays only in view, pause button (WCAG 2.2.2) ----------
          this.videos = [...this.querySelectorAll('.werk-momentum-bento_video')].map((video) => {
            const btn = video.closest('.werk-momentum-bento_tile').querySelector('[data-pause]');
            const v = { video, btn, user: this.still.matches || this.dataset.motion === 'off' ? 'paused' : '', seen: false };
            if (btn) {
              btn.hidden = false;
              this.paint(v);
              on(btn, 'click', () => {
                v.user = v.video.paused ? 'playing' : 'paused';
                v.user === 'playing' ? this.play(v) : v.video.pause();
                this.paint(v);
              });
            }
            on(video, 'play', () => this.paint(v));
            on(video, 'pause', () => this.paint(v));
            return v;
          });
          if (this.videos.length) {
            this.vio = new IntersectionObserver((entries) =>
              entries.forEach((x) => {
                const v = this.videos.find((y) => y.video === x.target);
                v.seen = x.isIntersecting;
                if (v.seen && v.user !== 'paused') this.play(v);
                else if (!v.seen) v.video.pause();
              }), { threshold: 0.25 });
            this.videos.forEach((v) => this.vio.observe(v.video));
          }

          this.buyBar(on);

          // ---------- theme editor: show the selected tile ----------
          on(document, 'shopify:block:select', (e) => {
            const tile = this.querySelector(`.werk-momentum-bento_tile[data-block="${e.detail?.blockId}"]`);
            if (!tile) return;
            tile.parentElement.classList.add('is-in');
            tile.scrollIntoView({ block: 'center', behavior: this.still.matches ? 'auto' : 'smooth' });
            tile.classList.add('is-selected');
            clearTimeout(this.selT);
            this.selT = setTimeout(() => tile.classList.remove('is-selected'), 1400);
          });
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          this.vio?.disconnect();
          cancelAnimationFrame(this.raf);
          clearTimeout(this.selT);
          clearTimeout(this.st);
          this.raf = 0;
        }

        moves(kind) {
          return this.dataset[kind] === 'on' && this.dataset.motion === 'on' && !this.still.matches;
        }

        // pointer speed in px/ms: the samples of the last ~120 ms plus the step to where the pointer entered.
        // Slow devices send few moves – then the last two samples within 250 ms still count.
        speed(e) {
          const now = e.timeStamp;
          let s = this.samples.filter((p) => now - p.t < 120);
          if (s.length < 2) s = this.samples.slice(-2).filter((p) => now - p.t < 250);
          const end = { t: now, x: e.clientX, y: e.clientY };
          const a = s[0] || end;
          const dt = Math.max(end.t - a.t, 8);
          if (a === end) return { x: 0, y: 0 };
          return { x: clampAbs((end.x - a.x) / dt, VMAX), y: clampAbs((end.y - a.y) / dt, VMAX) };
        }

        push(tile, e) {
          const st = this.tiles.get(tile);
          if (!st) return;
          const v = this.speed(e);
          if (Math.abs(v.x) + Math.abs(v.y) < 0.05) return;
          const box = st.cell.getBoundingClientRect();
          const push = (+this.dataset.push || 0) / 100;
          const spin = (+this.dataset.spin || 0) / 100;
          // offset from the centre, -1 … 1 on each axis
          const rx = clampAbs((e.clientX - box.left - box.width / 2) / (box.width / 2), 1);
          const ry = clampAbs((e.clientY - box.top - box.height / 2) / (box.height / 2), 1);
          st.vx += v.x * 1000 * push * 0.36;
          st.vy += v.y * 1000 * push * 0.36;
          // torque: r × v (screen y points down, so a positive value turns clockwise)
          st.vr += (rx * v.y - ry * v.x) * spin * 240;
          this.start(st);
        }

        wobble(tile, e) {
          const st = this.tiles.get(tile);
          if (!st) return;
          const box = st.cell.getBoundingClientRect();
          const rx = clampAbs((e.clientX - box.left - box.width / 2) / (box.width / 2), 1);
          const spin = Math.max(0.2, (+this.dataset.spin || 0) / 50);
          st.vr += rx * TAP_SPIN * OMEGA * Math.min(spin, 1.5);
          this.start(st);
        }

        start(st) {
          st.moving = true;
          st.cell.classList.add('is-moving');
          if (!this.raf) {
            this.last = performance.now();
            this.raf = requestAnimationFrame((t) => this.tick(t));
          }
        }

        tick(now) {
          this.raf = 0;
          if (!this.isConnected) return;
          const dt = Math.min((now - this.last) / 1000, 1 / 30);
          this.last = now;
          const zeta = 0.12 + ((+this.dataset.damping || 0) / 100) * 0.78;
          const C = 2 * zeta * OMEGA;
          let busy = false;
          for (const st of this.tiles.values()) {
            if (!st.moving) continue;
            // damped spring back to rest (semi-implicit Euler, frame-rate independent with a capped dt)
            st.vx += (-K * st.x - C * st.vx) * dt;
            st.vy += (-K * st.y - C * st.vy) * dt;
            st.vr += (-K * st.r - C * st.vr) * dt;
            st.x += st.vx * dt;
            st.y += st.vy * dt;
            st.r += st.vr * dt;
            const max = Math.min(st.cell.offsetWidth, st.cell.offsetHeight) * MAX_MOVE;
            st.x = clampAbs(st.x, max);
            st.y = clampAbs(st.y, max);
            st.r = clampAbs(st.r, MAX_SPIN);
            const rest = Math.abs(st.x) + Math.abs(st.y) < 0.05 && Math.abs(st.r) < 0.02 && Math.abs(st.vx) + Math.abs(st.vy) < 0.5 && Math.abs(st.vr) < 0.5;
            if (rest) {
              Object.assign(st, { x: 0, y: 0, r: 0, vx: 0, vy: 0, vr: 0, moving: false });
              st.el.style.removeProperty('translate');
              st.el.style.removeProperty('rotate');
              st.el.style.removeProperty('--sh');
              st.cell.classList.remove('is-moving');
              continue;
            }
            busy = true;
            st.el.style.translate = `${st.x.toFixed(2)}px ${st.y.toFixed(2)}px`;
            st.el.style.rotate = `${st.r.toFixed(3)}deg`;
            st.el.style.setProperty('--sh', Math.min(1, (Math.abs(st.x) + Math.abs(st.y)) / 12 + Math.abs(st.r) / 5).toFixed(3));
          }
          if (busy) this.raf = requestAnimationFrame((t) => this.tick(t));
        }

        // ---------- video ----------
        play(v) {
          if (v.video.preload === 'none') v.video.preload = 'auto';
          v.video.play()?.catch(() => {
            v.user = 'paused';
            this.paint(v);
          });
        }

        paint(v) {
          if (!v.btn) return;
          const paused = v.video.paused;
          v.btn.dataset.state = paused ? 'paused' : 'playing';
          v.btn.setAttribute('aria-label', paused ? v.btn.dataset.playLabel : v.btn.dataset.pauseLabel);
        }

        // ---------- product: colours and add to cart ----------
        buyBar(on) {
          const bar = this.querySelector('.werk-momentum-bento_buy');
          if (!bar) return;
          const form = bar.querySelector('[data-add]');
          const btn = bar.querySelector('.werk-momentum-bento_add');
          const price = bar.querySelector('[data-price]');
          const img = bar.parentElement.querySelector('img.werk-momentum-bento_img');
          bar.querySelectorAll('.werk-momentum-bento_swatch').forEach((sw) =>
            on(sw, 'click', () => {
              bar.querySelectorAll('.werk-momentum-bento_swatch').forEach((x) => x.setAttribute('aria-pressed', String(x === sw)));
              if (img && sw.dataset.img) {
                const next = new Image();
                next.src = sw.dataset.img;
                next.decode().then(() => {
                  img.removeAttribute('srcset');
                  img.src = sw.dataset.img;
                }, () => {});
              }
              if (!sw.dataset.id || !form) return;
              form.querySelector('[name="id"]').value = sw.dataset.id;
              if (price && sw.dataset.price) price.textContent = sw.dataset.price;
              const sold = sw.hasAttribute('data-soldout');
              if (btn) {
                btn.disabled = sold;
                const label = btn.querySelector('[data-label]');
                if (label) label.textContent = sold ? form.dataset.soldLabel : form.dataset.addLabel;
              }
            })
          );
          if (btn?.hasAttribute('data-demo')) on(btn, 'click', () => this.add(btn, null));
          if (form) on(form, 'submit', (e) => (e.preventDefault(), this.add(btn, form)));
        }

        async add(btn, form) {
          if (!btn || btn.dataset.state) return;
          btn.dataset.state = 'loading';
          const done = () => {
            btn.dataset.state = 'added';
            clearTimeout(this.st);
            this.st = setTimeout(() => delete btn.dataset.state, 2400);
          };
          if (!form) return setTimeout(done, 700); // demo product
          const root = window.Shopify?.routes?.root || '/';
          const id = +form.querySelector('[name="id"]').value;
          try {
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            done();
            const cart = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: id, quantity: 1 }],
              promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart?.(root);
          } catch (err) {
            delete btn.dataset.state;
            if (err && err.description) this.flash(btn, err.description);
            else form.submit();
          }
        }

        flash(btn, text) {
          const bar = btn.closest('.werk-momentum-bento_buy');
          const el = document.createElement('p');
          el.className = 'werk-momentum-bento_flash';
          el.setAttribute('role', 'status');
          el.textContent = text;
          bar.querySelector('.werk-momentum-bento_flash')?.remove();
          bar.append(el);
          setTimeout(() => el.remove(), 3200);
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-outfit-builder"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-outfit-builder')) {
    const mod = (v, n) => ((v % n) + n) % n;
    const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
    // cubic-bezier as a function (Newton steps, bisection fallback) – reels land on the section's easing
    const bezier = (x1, y1, x2, y2) => {
      const f = (t, a, b) => ((1 - 3 * b + 3 * a) * t + (3 * b - 6 * a)) * t * t + 3 * a * t;
      const d = (t, a, b) => 3 * (1 - 3 * b + 3 * a) * t * t + 2 * (3 * b - 6 * a) * t + 3 * a;
      return (x) => {
        if (x <= 0 || x >= 1) return x <= 0 ? 0 : 1;
        let t = x;
        for (let i = 0; i < 6; i++) {
          const s = d(t, x1, x2);
          if (Math.abs(s) < 1e-6) break;
          t -= (f(t, x1, x2) - x) / s;
        }
        if (t < 0 || t > 1 || Math.abs(f(t, x1, x2) - x) > 1e-4) {
          let lo = 0, hi = 1;
          for (let i = 0; i < 24; i++) {
            t = (lo + hi) / 2;
            f(t, x1, x2) < x ? (lo = t) : (hi = t);
          }
        }
        return f(t, y1, y2);
      };
    };
    const outCubic = (t) => 1 - (1 - t) ** 3;
    const SIZE_RE = /size|größe|grösse|groesse|^taille$|^talla$|^maat$/i;
    const COLOR_RE = /^(color|colour|farbe|couleur|kleur)$/i;

    customElements.define(
      'werk-outfit-builder',
      class extends HTMLElement {
        connectedCallback() {
          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          this.on = on;
          this.root = window.Shopify?.routes?.root || '/';
          this.still = matchMedia('(prefers-reduced-motion: reduce)');
          this.fine = matchMedia('(hover: hover) and (pointer: fine)');
          this.L = this.json('[data-labels]', {});
          this.looks = this.json('[data-looks]', []);
          this.inner = this.querySelector('.werk-outfit-builder_inner');
          this.side = this.querySelector('.werk-outfit-builder_side');
          this.sideSlot = this.querySelector('.werk-outfit-builder_side-slot');
          this.sheet = this.querySelector('.werk-outfit-builder_sheet');
          this.activeLook = -1;
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          const m = getComputedStyle(this.inner).getPropertyValue('--werk-ease').match(/cubic-bezier\(([^)]+)\)/);
          this.ease = bezier(...(m ? m[1].split(',').map(parseFloat) : [0.6234, 0.058, 0, 0.9095]));

          this.rows = [...this.querySelectorAll('.werk-outfit-builder_row')].map((el, i) => {
            const items = this.json.call(el, '[data-items]', []).map((it) => this.norm(it));
            const info = this.querySelector(`[data-info="${i}"]`);
            return { el, i, items, n: items.length, info, track: el.querySelector('.werk-outfit-builder_track'), fixed: el.hasAttribute('data-fixed'), pos: 0, cur: 0, sel: new Map(), locked: false, tiles: [], anim: null, drag: null };
          });
          this.rows = this.rows.filter((r) => r.n > 0 || (r.info && (r.info.hidden = true) && false));
          this.classList.add('is-live');
          for (const r of this.rows) this.setupRow(r);
          this.bind();
          this.start();
          this.ro = new ResizeObserver(() => this.layout());
          this.ro.observe(this);
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.ro?.disconnect();
          cancelAnimationFrame(this.raf);
          clearTimeout(this.toastT);
          clearTimeout(this.wheelT);
          this.raf = 0;
        }

        json(sel, fallback) {
          try {
            return JSON.parse(this.querySelector(sel)?.textContent || '') ?? fallback;
          } catch {
            return fallback;
          }
        }

        // one piece: handle, title, colour, url, thumb, size option index, size values, variants [id, price, available, options],
        // colour option index + colours [name, swatch colour / image, picture, thumb] (only with 2+ colours)
        norm(it) {
          const vars = (it.v || []).map(([id, p, a, o], k) => ({ id: id ?? 'demo-' + k, p, a, o: o || [] }));
          const first = vars.find((v) => v.a) || vars[0];
          const ci = it.ci ?? -1;
          const cols = ci >= 0 && (it.cols || []).length > 1 ? it.cols.map((c) => ({ n: c.n, hx: c.hx || '', sw: c.sw || '', img: c.img || '', th: c.th || c.img || '', a: vars.some((v) => v.a && v.o[ci] === c.n) })) : [];
          const out = { h: it.h, id: it.id, t: it.t || '', c: it.c || '', u: it.u || '', img: it.img || '', o: it.o ?? -1, ci, cols, col: it.c || '', sz: it.sz || [], vars, first, sel: it.sel || null, a: vars.some((v) => v.a), demo: !it.id };
          // the colour of the piece is its first available variant's (or the product page's variant, see sel)
          if (cols.length) {
            const own = out.sel != null ? vars.find((v) => v.id === out.sel) : first;
            if (own) out.c = out.col = own.o[ci];
            out.shown = cols[0].n; // the tiles show the product's own picture = its first colour
          }
          return out;
        }

        // the variants of the piece's current colour (all variants without colours)
        cvars(it) {
          return it.cols.length ? it.vars.filter((v) => v.o[it.ci] === it.col) : it.vars;
        }

        // product.js → the same shape (looks that name a product outside the row)
        fromJs(p) {
          const opts = (p.options || []).map((o) => (typeof o === 'string' ? o : o.name));
          let o = opts.findIndex((n) => SIZE_RE.test(n));
          const ci = opts.findIndex((n) => COLOR_RE.test(n));
          if (o < 0 && ci < 0 && opts.length === 1 && p.variants.length > 1) o = 0;
          const sz = o < 0 ? [] : [...new Set(p.variants.map((v) => v.options[o]))];
          const v0 = p.variants.find((v) => v.available) || p.variants[0];
          const w = (src, n) => (src ? src + (src.includes('?') ? '&' : '?') + 'width=' + n : '');
          const img = w(p.featured_image, 800);
          // product.js has no swatches: colours get the CSS colour of their name or a crop of their picture
          let cols = [];
          if (ci >= 0 && this.hasAttribute('data-swatches')) {
            const names = [...new Set(p.variants.map((v) => v.options[ci]))];
            if (names.length > 1)
              cols = names.map((n) => {
                const src = p.variants.find((v) => v.options[ci] === n && v.featured_image)?.featured_image?.src || p.featured_image;
                return { n, img: w(src, 600), th: w(src, 240) };
              });
          }
          return this.norm({ h: p.handle, id: p.id, t: p.title, c: ci >= 0 ? v0.options[ci] : '', u: p.url || `${this.root}products/${p.handle}`, img, o, ci, cols, sz, v: p.variants.map((v) => [v.id, v.price, v.available, v.options]) });
        }

        // ---------- reels ----------
        setupRow(r) {
          r.orig = [...r.track.querySelectorAll('.werk-outfit-builder_tile')];
          r.el.classList.toggle('is-single', r.n < 2);
          if (!r.fixed && r.n > 1) {
            for (const dir of [-1, 1]) {
              const b = document.createElement('button');
              b.type = 'button';
              b.className = 'werk-outfit-builder_arrow';
              b.dataset.dir = dir;
              b.tabIndex = -1;
              b.setAttribute('aria-hidden', 'true');
              b.innerHTML = `<svg viewBox="0 0 12 12" fill="none"><path d="${dir < 0 ? 'M7.5 2.5 4 6l3.5 3.5' : 'M4.5 2.5 8 6 4.5 9.5'}" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
              r.el.append(b);
            }
          }
          for (const it of r.items) if (it.sel == null && it.vars.length === 1) it.sel = it.vars[0].id;
          for (const it of r.items) if (it.sel == null && it.o < 0 && it.first) it.sel = it.first.id;
          // one size per colour (or no size at all): the colour alone picks the variant
          for (const it of r.items) if (it.sel == null && it.cols.length && it.sz.length <= 1) it.sel = this.cvars(it).find((v) => v.a)?.id ?? null;
          r.colors = r.items.some((it) => it.cols.length);
          r.items.forEach((it, k) => it.cols.length && it.col !== it.shown && this.paint(r, k, true));
        }

        // clones so both sides of the spotlight are always full, however few pieces a row has
        fill(r) {
          const s = getComputedStyle(this.inner);
          const tw = r.orig[0]?.getBoundingClientRect().width || 200;
          const gap = parseFloat(s.getPropertyValue('--tg')) || 14;
          r.step = tw + gap;
          r.w = r.el.getBoundingClientRect().width;
          const need = Math.ceil(r.w / r.step) + 3;
          const copies = r.n > 0 ? Math.max(1, Math.ceil(need / r.n)) : 1;
          if (r.copies !== copies) {
            r.tiles.filter((t) => t.clone).forEach((t) => t.el.remove());
            r.tiles = r.orig.map((el, k) => ({ el, k, clone: false }));
            for (let c = 1; c < copies; c++) {
              const frag = document.createDocumentFragment();
              r.orig.forEach((el, k) => {
                const cl = el.cloneNode(true);
                cl.querySelectorAll('.werk-outfit-builder_ghost').forEach((g) => g.remove()); // a fade in progress isn't cloned
                cl.setAttribute('aria-hidden', 'true');
                cl.querySelector('a')?.setAttribute('tabindex', '-1');
                cl.querySelector('img')?.setAttribute('loading', 'lazy');
                frag.append(cl);
                r.tiles.push({ el: cl, k, clone: true });
              });
              r.track.append(frag);
            }
            r.copies = copies;
          }
          r.len = r.tiles.length * r.step;
        }

        layout() {
          const w = this.getBoundingClientRect().width;
          if (Math.abs(w - (this.lastW || 0)) < 1 && this.rows.every((r) => r.step)) return;
          this.lastW = w;
          this.fitRows();
          this.op = parseFloat(getComputedStyle(this).getPropertyValue('--op')) || 0.4;
          for (const r of this.rows) {
            this.fill(r);
            this.draw(r);
          }
          if (!this.isPhone() && this.sheet?.open) this.closeSheet(true);
          this.fitSizes();
        }

        draw(r) {
          if (!r.len) return;
          const op = this.op;
          const half = r.len / 2;
          r.tiles.forEach((t, j) => {
            let x = mod(j * r.step - r.pos * r.step + half, r.len) - half;
            const d = Math.abs(x) / r.step;
            const o = d <= 1 ? 1 + (op - 1) * d : d <= 2 ? op + (op * 0.52 - op) * (d - 1) : op * 0.52;
            const xs = x.toFixed(1) + 'px';
            if (t.x !== xs) t.el.style.setProperty('--x', xs), (t.x = xs);
            const os = o.toFixed(3);
            if (t.o !== os) t.el.style.setProperty('--o', os), (t.o = os);
            const spot = d < 0.5;
            if (t.spot !== spot) t.el.classList.toggle('is-spot', spot), (t.spot = spot);
            const near = d >= 0.5 && d < 1.5;
            if (t.near !== near) t.el.classList.toggle('is-near', near), (t.near = near);
            const far = d >= 1.5;
            if (t.far !== far) t.el.classList.toggle('is-far', far), (t.far = far);
          });
        }

        moving() {
          return this.rows.some((r) => r.anim || r.drag?.on);
        }

        loop() {
          if (this.raf) return;
          const tick = (now) => {
            this.raf = 0;
            if (!this.isConnected) return;
            for (const r of this.rows) {
              const a = r.anim;
              if (!a) continue;
              const t = a.dur ? clamp((now - a.t0) / a.dur, 0, 1) : 1;
              r.pos = a.from + (a.to - a.from) * a.ease(t);
              this.draw(r);
              if (t >= 1) {
                r.anim = null;
                r.pos = a.to;
                this.settle(r);
                a.done?.();
              }
            }
            if (this.moving()) this.raf = requestAnimationFrame(tick);
          };
          this.raf = requestAnimationFrame(tick);
        }

        // spin a row to an absolute position (in pieces)
        go(r, to, dur, ease) {
          if (!r.n) return Promise.resolve();
          const reduce = this.still.matches || this.dataset.motion === 'off';
          r.el.classList.remove('is-rest');
          return new Promise((done) => {
            r.anim = { from: r.pos, to, t0: performance.now(), dur: reduce ? 0 : dur, ease: ease || this.ease, done };
            this.loop();
          });
        }

        step(r, by) {
          if (r.fixed || r.locked || r.n < 2) return;
          const base = r.anim ? r.anim.to : Math.round(r.pos);
          this.userMoved();
          this.go(r, base + by, 520);
        }

        settle(r) {
          r.pos = Math.round(r.pos);
          r.cur = mod(r.pos, r.n);
          r.el.classList.add('is-rest');
          this.update(r);
          this.total();
          this.fitRows();
        }

        // ---------- input ----------
        bind() {
          const on = this.on;
          for (const r of this.rows) {
            on(r.el, 'pointerdown', (e) => this.down(r, e));
            on(r.el, 'pointermove', (e) => this.move(r, e));
            on(r.el, 'pointerup', (e) => this.up(r, e));
            on(r.el, 'pointercancel', (e) => this.up(r, e, true));
            on(r.el, 'dragstart', (e) => e.preventDefault());
            on(r.el, 'click', (e) => this.tap(r, e), { capture: true });
            on(r.el, 'wheel', (e) => this.wheel(r, e), { passive: false });
            on(r.el, 'keydown', (e) => {
              if (e.target !== r.el) return;
              if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                e.preventDefault();
                this.step(r, e.key === 'ArrowLeft' ? -1 : 1);
              } else if ((e.key === 'l' || e.key === 'L') && !r.fixed) this.lock(r);
            });
            r.info?.querySelector('[data-lock]') && on(r.info.querySelector('[data-lock]'), 'click', () => this.lock(r));
            const add = r.info?.querySelector('[data-add]');
            if (add) on(add, 'click', () => this.addOne(r, add));
            if (r.info) on(r.info.querySelector('[data-sizes]'), 'click', (e) => {
              const b = e.target.closest('.werk-outfit-builder_size');
              if (!b || b.disabled || b.classList.contains('is-static')) return;
              const it = r.items[r.cur];
              it.sel = +b.dataset.id || b.dataset.id;
              r.info.classList.remove('is-missing');
              this.msg(r, '');
              this.update(r);
              this.total();
            });
            const sw = r.info?.querySelector('[data-swatches]');
            if (sw) {
              on(sw, 'click', (e) => {
                const b = e.target.closest('.werk-outfit-builder_swatch');
                if (b && !b.disabled) this.setColor(r, b.dataset.c);
              });
              // hover: the colour name previews the swatch under the pointer
              const name = r.info.querySelector('[data-color]');
              on(sw, 'pointerover', (e) => {
                const b = e.target.closest('.werk-outfit-builder_swatch');
                if (b && name && e.pointerType === 'mouse') name.textContent = b.dataset.c;
              });
              on(sw, 'pointerleave', () => name && (name.textContent = r.items[r.cur]?.c || ''));
              // arrow keys move through the colours like a radio group
              on(sw, 'keydown', (e) => {
                if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
                const bs = [...sw.querySelectorAll('.werk-outfit-builder_swatch:not(:disabled)')];
                const i = bs.indexOf(document.activeElement);
                if (i < 0) return;
                e.preventDefault();
                const b = bs[mod(i + (e.key === 'ArrowLeft' ? -1 : 1), bs.length)];
                this.setColor(r, b.dataset.c);
                sw.querySelector(`.werk-outfit-builder_swatch[data-c="${CSS.escape(b.dataset.c)}"]`)?.focus();
              });
            }
          }
          // a look without any product for these rows does nothing – hide its chip (and the group when none is left)
          const empty = (l) => !l || l.r.every((x) => x === '' || x == null);
          this.querySelectorAll('[data-look]').forEach((b) => {
            b.hidden = empty(this.looks[+b.dataset.look]);
            on(b, 'click', () => this.applyLook(+b.dataset.look));
          });
          const group = this.querySelector('.werk-outfit-builder_looks');
          if (group && !group.querySelector('[data-look]:not([hidden])')) group.hidden = true;
          on(this.querySelector('[data-shuffle]'), 'click', () => this.shuffle());
          on(this.querySelector('[data-share]'), 'click', () => this.share());
          const outfit = this.querySelector('[data-add-outfit]');
          if (outfit) on(outfit, 'click', () => this.addOutfit(outfit));
          on(this.querySelector('[data-open]'), 'click', () => this.openSheet());
          if (this.sheet) {
            on(this.sheet, 'click', (e) => e.target === this.sheet && this.closeSheet());
            on(this.sheet, 'cancel', (e) => (e.preventDefault(), this.closeSheet()));
            this.grab(this.sheet.querySelector('[data-close]'), this.side.querySelector('.werk-outfit-builder_sheet-head'));
          }
          on(document, 'shopify:block:select', (e) => this.onSelect(e));
          // a product page changes ?variant= when its size changes – pick it up before the visitor uses the section
          if (this.dataset.product) for (const t of ['pointerenter', 'focusin']) on(this, t, () => this.syncPdp());
          on(this.still, 'change', () => this.rows.forEach((r) => this.draw(r)));
        }

        down(r, e) {
          if (r.fixed || r.locked || r.n < 2 || e.button > 0 || e.target.closest('.werk-outfit-builder_arrow')) return;
          r.drag = { x: e.clientX, y: e.clientY, id: e.pointerId, pos: r.pos, on: false, moved: false, samples: [[performance.now(), r.pos]], type: e.pointerType };
          if (r.anim) {
            r.anim = null;
            r.drag.on = true;
            r.drag.moved = true;
            r.el.setPointerCapture(e.pointerId);
            r.el.classList.add('is-drag');
          }
        }

        move(r, e) {
          const d = r.drag;
          if (!d || e.pointerId !== d.id) return;
          const dx = e.clientX - d.x;
          const dy = e.clientY - d.y;
          if (!d.on) {
            const th = d.type === 'touch' ? 10 : 6;
            if (Math.abs(dy) > th && Math.abs(dy) > Math.abs(dx)) return (r.drag = null);
            if (Math.abs(dx) < th) return;
            d.on = true;
            d.moved = true;
            r.el.setPointerCapture(e.pointerId);
            r.el.classList.add('is-drag');
            r.el.classList.remove('is-rest');
            this.userMoved();
          }
          r.pos = d.pos - dx / r.step;
          const now = performance.now();
          d.samples.push([now, r.pos]);
          if (d.samples.length > 6) d.samples.shift();
          this.draw(r);
        }

        up(r, e, cancel) {
          const d = r.drag;
          if (!d || e.pointerId !== d.id) return;
          r.drag = null;
          r.el.classList.remove('is-drag');
          if (!d.on) return;
          this.suppress = d.moved;
          setTimeout(() => (this.suppress = false), 0);
          // throw: velocity from the last samples (dropped if the pointer rested)
          let v = 0;
          const s = d.samples;
          const now = performance.now();
          if (!cancel && s.length > 1 && now - s[s.length - 1][0] < 90) {
            const [t0, p0] = s[0];
            const [t1, p1] = s[s.length - 1];
            if (t1 > t0) v = (p1 - p0) / ((t1 - t0) / 1000);
          }
          v = clamp(v, -30, 30);
          const target = Math.round(r.pos + v * 0.22);
          const dist = Math.abs(target - r.pos);
          this.go(r, target, clamp(380 + dist * 110, 380, 1300), dist > 1.2 ? outCubic : this.ease);
        }

        tap(r, e) {
          if (this.suppress) return (e.preventDefault(), e.stopPropagation());
          const arrow = e.target.closest('.werk-outfit-builder_arrow');
          if (arrow) return (e.preventDefault(), this.step(r, +arrow.dataset.dir));
          const tile = e.target.closest('.werk-outfit-builder_tile');
          if (!tile) return;
          const t = r.tiles.find((x) => x.el === tile);
          if (!t) return;
          if (t.spot) {
            if (this.isPhone() && this.sheet) {
              e.preventDefault();
              this.openSheet(r.i);
            } else if (!tile.querySelector('a[href]')) e.preventDefault();
            return;
          }
          e.preventDefault();
          if (r.fixed || r.locked) return;
          const by = Math.round(parseFloat(t.x) / r.step);
          this.userMoved();
          this.go(r, Math.round(r.pos) + by, 420 + Math.abs(by) * 120);
        }

        wheel(r, e) {
          if (r.fixed || r.locked || r.n < 2) return;
          const dx = e.deltaMode === 1 ? e.deltaX * 16 : e.deltaX;
          if (Math.abs(dx) <= Math.abs(e.deltaY) || !dx) return; // vertical scrolling stays the page's
          e.preventDefault();
          r.anim = null;
          r.el.classList.remove('is-rest');
          r.pos += dx / r.step;
          this.draw(r);
          this.userMoved();
          clearTimeout(this.wheelT);
          this.wheelT = setTimeout(() => this.go(r, Math.round(r.pos), 360), 120);
        }

        userMoved() {
          if (this.activeLook < 0) return;
          this.activeLook = -1;
          this.markLook();
        }

        lock(r) {
          r.locked = !r.locked;
          r.el.classList.toggle('is-locked', r.locked);
          const b = r.info?.querySelector('[data-lock]');
          if (b) {
            b.setAttribute('aria-pressed', String(r.locked));
            const t = b.querySelector('span');
            if (t) t.textContent = r.locked ? this.L.locked || this.L.lock : this.L.lock;
          }
        }

        // ---------- start: shared link → product page → look → setting ----------
        async start() {
          this.op = parseFloat(getComputedStyle(this).getPropertyValue('--op')) || 0.4;
          for (const r of this.rows) this.fill(r);
          this.lastW = this.getBoundingClientRect().width;
          const hash = decodeURIComponent(location.hash).match(/fit=([^&]+)/);
          const pdp = this.dataset.productHandle;
          let done = false;
          if (hash) {
            const parts = hash[1].split('.');
            this.rows.forEach((r, i) => {
              const p = parts[i] || '';
              // handle, ~colour number (0 = the piece's first colour), ! = locked
              const [h, cn] = p.replace(/!$/, '').split('~');
              const k = r.items.findIndex((it) => it.h === h);
              if (k >= 0) {
                this.jump(r, k);
                const c = r.items[k].cols[+cn];
                if (c) this.setColor(r, c.n, true);
              }
              if (p.endsWith('!') && !r.fixed) this.lock(r);
            });
            done = true;
          }
          if (!done && pdp) {
            const li = this.looks.findIndex((l) => l.r.includes(pdp));
            if (li >= 0) {
              await this.applyLook(li, true);
              done = true;
            } else if (this.hasAttribute('data-recommend')) done = await this.recommend();
          }
          if (!done) {
            const st = this.dataset.start;
            const li = this.looks.findIndex((l) => l.r.some((x) => x !== '' && x != null));
            if (st === 'first_look' && li >= 0) await this.applyLook(li, true);
            else if (st === 'random') this.rows.forEach((r) => !r.fixed && this.jump(r, Math.floor(Math.random() * r.n)));
          }
          for (const r of this.rows) {
            this.draw(r);
            this.settle(r);
          }
          document.fonts?.ready.then(() => this.isConnected && (this.fitRows(), this.fitSizes()));
        }

        jump(r, k) {
          r.pos = k;
          r.cur = k;
        }

        async recommend() {
          try {
            const res = await fetch(`${this.root}recommendations/products.json?product_id=${this.dataset.product}&intent=complementary&limit=10`);
            const { products = [] } = await res.json();
            let hit = false;
            for (const r of this.rows) {
              if (r.fixed) continue;
              const k = r.items.findIndex((it) => products.some((p) => p.handle === it.h));
              if (k >= 0) this.jump(r, k), (hit = true);
            }
            return hit;
          } catch {
            return false;
          }
        }

        // ---------- looks ----------
        async applyLook(li, instant) {
          const look = this.looks[li];
          if (!look) return;
          const jobs = [];
          for (const [i, r] of this.rows.entries()) {
            if (r.fixed) continue;
            const want = look.r[i];
            let k = -1;
            if (typeof want === 'number') k = want < r.n ? want : -1;
            else if (want) {
              k = r.items.findIndex((it) => it.h === want);
              if (k < 0) k = await this.insert(r, want);
            }
            if (k < 0) continue;
            if (r.locked) this.lock(r);
            if (instant) {
              this.jump(r, k);
              continue;
            }
            let by = mod(k - mod(Math.round(r.pos), r.n), r.n);
            if (by > r.n / 2) by -= r.n;
            jobs.push(this.go(r, Math.round(r.pos) + by, 620 + i * 90 + Math.abs(by) * 60));
          }
          this.activeLook = li;
          this.markLook();
          if (instant) for (const r of this.rows) this.draw(r);
          await Promise.all(jobs);
          this.activeLook = li;
          this.markLook();
        }

        markLook() {
          this.querySelectorAll('[data-look]').forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.look === this.activeLook)));
        }

        // a look names a product the row doesn't hold: fetch it and add a tile
        async insert(r, handle) {
          try {
            const p = await fetch(`${this.root}products/${handle}.js`).then((x) => (x.ok ? x.json() : null));
            if (!p) return -1;
            const it = this.fromJs(p);
            if (it.vars.length === 1 || (it.o < 0 && it.first)) it.sel = (it.first || it.vars[0]).id;
            if (it.sel == null && it.cols.length && it.sz.length <= 1) it.sel = this.cvars(it).find((v) => v.a)?.id ?? null;
            if (it.cols.length) r.colors = true;
            const proto = r.orig[0];
            if (!proto) return -1;
            const el = proto.cloneNode(true);
            el.querySelectorAll('.werk-outfit-builder_ghost').forEach((g) => g.remove());
            el.classList.toggle('is-soldout', !it.a);
            el.removeAttribute('aria-hidden');
            const a = el.querySelector('a');
            if (a) a.href = it.u;
            const img = el.querySelector('img');
            if (img) {
              img.removeAttribute('srcset');
              img.src = this.color(it)?.img || it.img;
              img.alt = it.t;
              if (it.cols.length) it.shown = it.col;
            }
            const sr = el.querySelector('.werk-outfit-builder_sr');
            if (sr) sr.textContent = it.t;
            el.dataset.i = r.n;
            r.orig.at(-1).after(el);
            r.orig.push(el);
            r.items.push(it);
            r.n++;
            r.el.classList.toggle('is-single', r.n < 2);
            r.copies = 0;
            r.tiles.filter((t) => t.clone).forEach((t) => t.el.remove());
            r.tiles = [];
            this.fill(r);
            return r.n - 1;
          } catch {
            return -1;
          }
        }

        // ---------- shuffle: every unlocked row spins, landing top to bottom ----------
        async shuffle() {
          const jobs = [];
          let order = 0;
          for (const r of this.rows) {
            if (r.fixed || r.locked || r.n < 2) continue;
            const cur = mod(Math.round(r.pos), r.n);
            const pool = r.items.map((it, k) => k).filter((k) => k !== cur && r.items[k].a);
            if (!pool.length) continue;
            const k = pool[Math.floor(Math.random() * pool.length)];
            const by = mod(k - cur, r.n);
            const turns = 2 + (order % 2);
            jobs.push(this.go(r, Math.round(r.pos) + by + turns * r.n, 1150 + order * 120 + by * 30));
            order++;
          }
          this.activeLook = -1;
          this.markLook();
          await Promise.all(jobs);
        }

        // ---------- info column ----------
        update(r) {
          const it = r.items[r.cur];
          const box = r.info;
          if (!it) return;
          const v = this.variant(it);
          const pos = box?.querySelector('[data-pos]');
          if (pos) pos.textContent = r.n > 1 && !r.fixed ? ` · ${r.cur + 1} / ${r.n}` : '';
          if (box) {
            const name = box.querySelector('[data-name]');
            box.querySelector('[data-title]').textContent = it.t;
            box.querySelector('[data-color]').textContent = it.c;
            if (it.u) name.href = it.u;
            else name.removeAttribute('href');
            box.querySelector('[data-price]').textContent = this.money(v ? v.p : this.base(it)?.p || 0);
            const th = box.querySelector('.werk-outfit-builder_thumb');
            const thumb = this.color(it)?.th || it.img;
            if (th) thumb ? th.getAttribute('src') !== thumb && (th.src = thumb) : th.removeAttribute('src');
            if (box.dataset.item !== it.h) {
              box.dataset.item = it.h;
              box.classList.remove('is-missing');
              this.msg(r, '');
              this.swatches(r, it);
              this.sizes(r, it);
            } else this.sizeState(r, it);
            const add = box.querySelector('[data-add]');
            if (add && !add.dataset.state) add.disabled = !it.a || (v ? !v.a : false);
          }
          // the price (and size) on the spotlight tile – phone only, shown by CSS
          const chip = r.tiles.find((t) => t.spot)?.el.querySelector('.werk-outfit-builder_chip');
          r.tiles.forEach((t) => {
            const c = t.el.querySelector('.werk-outfit-builder_chip');
            if (c && c !== chip) c.textContent = '';
          });
          if (chip) chip.innerHTML = `${this.money(v ? v.p : this.base(it)?.p || 0)}${it.o >= 0 ? `<small>${v ? this.esc(v.o[it.o]) : '–'}</small>` : ''}`;
        }

        variant(it) {
          return it.sel != null ? it.vars.find((v) => v.id === it.sel) : null;
        }

        // the variant the piece stands on without a size: first available of its colour
        base(it) {
          const vs = this.cvars(it);
          return vs.find((v) => v.a) || vs[0] || it.first;
        }

        color(it) {
          return it.cols.find((c) => c.n === it.col);
        }

        // size chips: one per value of the size option; the other options (colour …) stay on the piece's base variant
        sizes(r, it) {
          const wrap = r.info.querySelector('[data-sizes]');
          wrap.textContent = '';
          if (!it.a) {
            wrap.innerHTML = `<span class="werk-outfit-builder_size is-static" aria-disabled="true">${this.esc(this.L.sold || 'Sold out')}</span>`;
            return;
          }
          if (it.o < 0) {
            if (it.vars.length <= 1 || it.first) wrap.innerHTML = `<span class="werk-outfit-builder_size is-static" role="radio" aria-checked="true">${this.esc(this.L.one || 'One size')}</span>`;
            return;
          }
          const base = this.base(it);
          const pool = this.cvars(it);
          for (const val of it.sz) {
            const v = pool.find((x) => x.o[it.o] === val && x.o.every((o, j) => j === it.o || o === base.o[j])) || pool.find((x) => x.o[it.o] === val);
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'werk-outfit-builder_size';
            b.setAttribute('role', 'radio');
            b.textContent = val;
            b.dataset.id = v ? v.id : '';
            b.disabled = !v || !v.a;
            wrap.append(b);
          }
          this.sizeState(r, it);
          this.fitSizes();
        }

        // a size line is a scroller only when its chips don't fit (so the hover shadow isn't clipped otherwise)
        fitSizes() {
          this.querySelectorAll('[data-sizes]').forEach((w) => {
            w.classList.remove('is-scroll');
            w.classList.toggle('is-scroll', w.scrollWidth > w.clientWidth + 1);
          });
        }

        sizeState(r, it) {
          r.info.querySelectorAll('button.werk-outfit-builder_size').forEach((b) => b.setAttribute('aria-checked', String(String(it.sel) === b.dataset.id)));
          r.info.querySelectorAll('.werk-outfit-builder_swatch').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.c === it.col)));
        }

        // colour swatches: the option's swatch → the CSS colour of the name ("Navy") → a crop of the colour's picture
        swatches(r, it) {
          const wrap = r.info.querySelector('[data-swatches]');
          if (!wrap) return;
          wrap.textContent = '';
          wrap.hidden = !it.cols.length;
          for (const c of it.cols) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'werk-outfit-builder_swatch';
            b.setAttribute('role', 'radio');
            b.dataset.c = c.n;
            b.disabled = !c.a;
            b.setAttribute('aria-label', c.a ? c.n : `${c.n} – ${this.L.sold || 'Sold out'}`);
            b.title = c.n;
            const css = c.n.toLowerCase().replace(/[^a-z]/g, '');
            const col = c.hx || (!c.sw && css && window.CSS?.supports('color', css) ? css : '');
            if (col) b.style.setProperty('--sw', col);
            else if (c.sw) b.style.setProperty('--sw-img', `url("${c.sw}")`);
            else if (c.th) b.style.setProperty('--sw-img', `url("${c.th}")`);
            wrap.append(b);
            // the ring takes the swatch's own colour – light ones (and pictures) keep the ink ring from the CSS
            if (col) {
              b.style.color = col;
              const [r, g, bl] = (getComputedStyle(b).color.match(/[\d.]+/g) || []).map(Number);
              b.style.removeProperty('color');
              if (r != null && (0.2126 * r + 0.7152 * g + 0.0722 * bl) / 255 < 0.62) b.style.setProperty('--ring', col);
            }
          }
          this.sizeState(r, it);
        }

        // a new colour: the size stays when it exists (and is available) in that colour
        setColor(r, name, instant) {
          const it = r.items[r.cur];
          const c = it?.cols.find((x) => x.n === name);
          if (!c || !c.a || it.col === name) return;
          const was = it.sel != null ? it.vars.find((v) => v.id === it.sel) : null;
          it.col = it.c = name;
          const pool = this.cvars(it);
          if (it.o < 0 || it.sz.length <= 1) it.sel = pool.find((v) => v.a)?.id ?? null;
          else if (was) {
            const v = pool.find((x) => x.o[it.o] === was.o[it.o]);
            it.sel = v && v.a ? v.id : null;
          }
          r.info.classList.remove('is-missing');
          this.msg(r, '');
          this.paint(r, r.cur, instant);
          this.sizes(r, it);
          this.update(r);
          this.total();
        }

        // swap the picture on every tile of piece k (the reel holds clones): decode first, then the old one fades out on top
        async paint(r, k, instant) {
          const it = r.items[k];
          const c = it && this.color(it);
          if (!c?.img || it.shown === c.n) return;
          it.shown = c.n;
          const token = (it.paintT = (it.paintT || 0) + 1);
          const imgs = [...r.track.querySelectorAll(`.werk-outfit-builder_tile[data-i="${k}"] img.werk-outfit-builder_img`)];
          if (!imgs.length) return;
          if (!instant) {
            const pre = new Image();
            pre.src = c.img;
            await pre.decode().catch(() => {});
            if (token !== it.paintT) return;
          }
          const fade = !instant && !this.still.matches && this.dataset.motion !== 'off';
          const dur = 340 * (parseFloat(getComputedStyle(this.inner).getPropertyValue('--werk-speed')) || 1);
          for (const img of imgs) {
            const tile = img.closest('.werk-outfit-builder_tile');
            if (fade && tile && !tile.classList.contains('is-far')) {
              const ghost = img.cloneNode();
              ghost.classList.add('werk-outfit-builder_ghost');
              ghost.removeAttribute('loading');
              ghost.setAttribute('aria-hidden', 'true');
              img.after(ghost);
              const done = () => ghost.remove();
              ghost.animate([{ opacity: 1 }, { opacity: 0 }], { duration: dur, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }).finished.then(done, done);
            }
            img.removeAttribute('srcset');
            img.src = c.img;
            img.alt = `${it.t} – ${c.n}`;
          }
        }

        // desktop: an info row taller than its reel (name + swatches + sizes) pulls both rows to its height.
        // Rows with colours keep the swatch line's room for every piece, so they don't jump while spinning.
        fitRows() {
          const reels = this.querySelector('.werk-outfit-builder_reels');
          const infos = this.querySelector('.werk-outfit-builder_infos');
          if (!reels || !infos) return false;
          const side = !this.isPhone() && this.sideSlot?.contains(this.side) && getComputedStyle(infos).gridTemplateRows !== 'none';
          const parts = [...this.querySelectorAll('.werk-outfit-builder_row')].map((el, i) => {
            const h = `var(--h-${el.dataset.h || 'm'})`;
            const info = this.querySelector(`[data-info="${i}"]`);
            const main = info?.querySelector('.werk-outfit-builder_info-main');
            if (!side || !main || info.hidden) return h;
            const r = this.rows.find((x) => x.el === el);
            const sw = main.querySelector('[data-swatches]');
            const msg = main.querySelector('[data-msg]');
            const gap = parseFloat(getComputedStyle(main).rowGap) || 0;
            let need = main.offsetHeight;
            if (msg && !msg.hidden) need -= msg.offsetHeight + gap;
            if (r?.colors && sw?.hidden) need += 28 + gap; // the swatch line (--s on desktop)
            return `max(${h}, ${Math.ceil(need)}px)`;
          });
          const css = parts.join(' ');
          if (css === this.rowsCss) return false;
          this.rowsCss = css;
          reels.style.setProperty('--rows', css);
          infos.style.setProperty('--rows', css);
          return true;
        }

        msg(r, text) {
          const m = r.info?.querySelector('[data-msg]');
          if (!m) return;
          m.textContent = text;
          m.hidden = !text;
        }

        // which pieces go into the outfit, and which still need a size
        outfit() {
          const ready = [];
          const missing = [];
          for (const r of this.rows) {
            const it = r.items[r.cur];
            if (!it || !it.a) continue;
            const v = this.variant(it);
            if (v && v.a) ready.push({ r, it, v });
            else missing.push(r);
          }
          return { ready, missing };
        }

        total() {
          if (this.moving()) return;
          let sum = 0;
          let n = 0;
          for (const r of this.rows) {
            const it = r.items[r.cur];
            if (!it || !it.a) continue;
            const v = this.variant(it) || this.base(it);
            sum += v ? v.p : 0;
            n++;
          }
          const price = this.money(sum);
          this.querySelectorAll('[data-total]').forEach((el) => (el.textContent = price));
          this.querySelectorAll('[data-pieces]').forEach((el) => (el.textContent = ((n === 1 && this.L.pieces1) || this.L.pieces || '[count] pieces').replace('[count]', n)));
          this.querySelectorAll('[data-count]').forEach((el) => (el.textContent = n));
          const miss = this.outfit().missing.length;
          const m = this.querySelector('[data-missing]');
          if (m) {
            m.hidden = !miss;
            m.textContent = (this.L.missing || 'Sizes missing · [count]').replace('[count]', miss);
          }
        }

        // ---------- cart ----------
        async addOne(r, btn) {
          const it = r.items[r.cur];
          const v = this.variant(it);
          if (!v) {
            this.flag(r, true);
            return;
          }
          await this.cart(btn, [{ r, it, v }]);
        }

        async addOutfit(btn) {
          const { ready, missing } = this.outfit();
          if (missing.length) {
            missing.forEach((r, i) => this.flag(r, i === 0));
            if (this.isPhone() && !this.sheet?.open) this.openSheet(missing[0].i);
            return;
          }
          if (!ready.length) return;
          await this.cart(btn, ready);
          const lab = btn.querySelector('[data-added-label]');
          if (lab) lab.textContent = ((ready.length === 1 && this.L.added1) || this.L.added || '[count] pieces added').replace('[count]', ready.length);
        }

        flag(r, first) {
          if (!r.info) return;
          r.info.classList.add('is-missing');
          this.msg(r, (this.L.pick || 'Pick a size for the [product].').replace('[product]', r.items[r.cur].t));
          r.info.classList.remove('is-pulse');
          void r.info.offsetWidth;
          r.info.classList.add('is-pulse');
          if (first && !this.isPhone()) r.info.scrollIntoView?.({ block: 'nearest', behavior: this.still.matches ? 'auto' : 'smooth' });
        }

        async cart(btn, list) {
          if (!btn || btn.dataset.state) return;
          btn.dataset.state = 'loading';
          const done = () => {
            btn.dataset.state = 'added';
            setTimeout(() => delete btn.dataset.state, 1800);
          };
          if (list.every((x) => x.it.demo)) return setTimeout(done, 700); // demo pieces without products
          const items = list.filter((x) => !x.it.demo).map((x) => ({ id: x.v.id, quantity: 1 }));
          try {
            const res = await fetch(this.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            done();
            const cart = fetch(this.root + 'cart.js').then((x) => x.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: items.map((x) => ({ merchandiseId: x.id, quantity: 1 })),
              promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart?.(this.root);
          } catch (err) {
            delete btn.dataset.state;
            this.toast((err && (err.description || err.message)) || this.L.error || 'Could not add to cart.');
          }
        }

        // ---------- share ----------
        async share() {
          const fit = this.rows
            .map((r) => {
              const it = r.items[r.cur];
              const c = it ? it.cols.findIndex((x) => x.n === it.col) : -1;
              return (it?.h || '') + (c > 0 ? '~' + c : '') + (r.locked ? '!' : '');
            })
            .join('.');
          const url = location.origin + location.pathname + location.search + '#fit=' + encodeURIComponent(fit).replace(/%2E/g, '.').replace(/%21/g, '!');
          if (navigator.share && !this.fine.matches) {
            try {
              await navigator.share({ url, title: document.title });
              return;
            } catch (e) {
              if (e?.name === 'AbortError') return;
            }
          }
          try {
            await navigator.clipboard.writeText(url);
          } catch {
            const ta = document.createElement('textarea');
            ta.value = url;
            ta.style.cssText = 'position:fixed;opacity:0';
            this.append(ta);
            ta.select();
            document.execCommand('copy');
            ta.remove();
          }
          this.toast(this.L.copied || 'Link copied');
        }

        toast(text) {
          const t = this.querySelector('[data-toast]');
          if (!t) return;
          t.textContent = text;
          t.hidden = false;
          clearTimeout(this.toastT);
          this.toastT = setTimeout(() => (t.hidden = true), 2600);
        }

        // ---------- phone sheet: the info column moves into a modal dialog ----------
        isPhone() {
          return this.getBoundingClientRect().width < 750;
        }

        openSheet(focusRow) {
          if (!this.sheet || this.sheet.open) return;
          this.sheet.append(this.side);
          this.sheet.classList.remove('is-closing');
          this.sheet.style.removeProperty('--drag');
          this.sheet.showModal();
          this.fitSizes();
          // the dialog itself takes the focus (not the grabber, which would show its focus ring after a tap)
          this.sheet.focus({ preventScroll: true });
          if (focusRow != null) this.rows[focusRow]?.info?.scrollIntoView?.({ block: 'nearest' });
        }

        closeSheet(now) {
          const sh = this.sheet;
          if (!sh?.open) return;
          const end = () => {
            sh.close();
            sh.classList.remove('is-closing');
            sh.style.removeProperty('--drag');
            this.sideSlot.append(this.side);
            this.fitSizes();
          };
          if (now || this.still.matches || this.dataset.motion === 'off') return end();
          sh.classList.add('is-closing');
          setTimeout(end, 320);
        }

        // the sheet follows the finger from the grabber or the head ("Your fit"): down past 90 px or a flick closes it,
        // less springs back; a tap on the grabber closes, a tap on the head does nothing (it holds the missing-size hint)
        grab(handle, head) {
          if (!handle) return;
          const sh = this.sheet;
          let y0 = null;
          let dy = 0;
          let t0 = 0;
          let tap = false;
          const settle = () => {
            if (!dy) return;
            sh.classList.add('is-settling');
            sh.style.removeProperty('--drag');
          };
          for (const [el, closesOnTap] of [[handle, true], [head, false]]) {
            if (!el) continue;
            this.on(el, 'pointerdown', (e) => {
              if (!sh.open || e.button > 0 || (el !== handle && e.target.closest('button, a, input, select, label'))) return;
              y0 = e.clientY;
              dy = 0;
              t0 = performance.now();
              tap = closesOnTap;
              sh.classList.remove('is-settling');
              el.setPointerCapture(e.pointerId);
            });
            this.on(el, 'pointermove', (e) => {
              if (y0 == null) return;
              dy = Math.max(0, e.clientY - y0);
              sh.style.setProperty('--drag', dy + 'px');
            });
            this.on(el, 'pointerup', () => {
              if (y0 == null) return;
              y0 = null;
              const fast = dy > 30 && dy / (performance.now() - t0) > 0.6;
              if ((tap && dy < 6) || dy > 90 || fast) this.closeSheet();
              else settle();
            });
            this.on(el, 'pointercancel', () => {
              if (y0 == null) return;
              y0 = null;
              settle();
            });
          }
        }

        // ---------- theme editor & product page ----------
        onSelect(e) {
          if (!this.contains(e.target)) return;
          const id = e.detail?.blockId;
          const li = this.looks.findIndex((l) => l.id === id);
          if (li >= 0) return this.applyLook(li);
          const r = this.rows.find((x) => x.el.dataset.block === id);
          r?.el.scrollIntoView({ block: 'center' });
        }

        syncPdp() {
          const r = this.rows.find((x) => x.fixed);
          const id = new URLSearchParams(location.search).get('variant');
          if (!r || !id) return;
          const it = r.items[0];
          const v = it?.vars.find((x) => String(x.id) === id);
          if (!v || it.sel === v.id) return;
          it.sel = v.id;
          // the product page switched colour too: follow it
          if (it.cols.length && v.o[it.ci] !== it.col) {
            it.col = it.c = v.o[it.ci];
            this.paint(r, 0);
            this.sizes(r, it);
          }
          this.update(r);
          this.total();
        }

        // ---------- helpers ----------
        money(cents) {
          const fmt = this.dataset.money || '€{' + '{amount}}';
          const v = (cents || 0) / 100;
          const fix = (n, dec, th, ds) => {
            const [a, b] = n.toFixed(dec).split('.');
            return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b ? ds + b : '');
          };
          return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
            switch (k) {
              case 'amount_no_decimals':
                return fix(v, 0, ',', '.');
              case 'amount_with_comma_separator':
                return fix(v, 2, '.', ',');
              case 'amount_no_decimals_with_comma_separator':
                return fix(v, 0, '.', ',');
              case 'amount_with_apostrophe_separator':
                return fix(v, 2, "'", '.');
              case 'amount_with_space_separator':
                return fix(v, 2, ' ', ',');
              default:
                return fix(v, 2, ',', '.');
            }
          }).replace(/<[^>]*>/g, '');
        }

        esc(s) {
          return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-product-buy-box"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-product-buy-box')) {
    customElements.define(
      'werk-product-buy-box',
      class extends HTMLElement {
        connectedCallback() {
          const q = (s) => this.querySelector(s);
          const qa = (s) => [...this.querySelectorAll(s)];
          const raw = q('script[data-werk]');
          if (!raw) return;
          try {
            this.d = JSON.parse(raw.textContent);
          } catch {
            return;
          }
          try {
            this.t = JSON.parse(q('script[data-werk-t]')?.textContent || '{}');
          } catch {
            this.t = {};
          }
          this.v = this.d.variants.find((x) => x.id === this.d.current) || this.d.variants[0];
          this.sel = this.v ? [...this.v.o] : [];
          this.qty = 1;
          this.frame = q('.werk-product-buy-box_frame');
          this.slides = qa('.werk-product-buy-box_slide');
          this.count = q('[data-count]');
          this.countSr = q('[data-count-sr]');
          this.caption = q('.werk-product-buy-box_caption');
          this.cursorEl = q('.werk-product-buy-box_cursor');
          this.cursorText = q('.werk-product-buy-box_cursor-t');
          this.vals = qa('.werk-product-buy-box_val');
          this.adds = qa('[data-add]');
          this.buy = q('.werk-product-buy-box_buy');
          this.form = q('.werk-product-buy-box_form');
          this.bar = q('.werk-product-buy-box_bar');
          this.del = q('.werk-product-buy-box_delivery');
          this.stockEl = q('.werk-product-buy-box_stock');
          this.receipt = q('[data-receipt]');
          this.qtyEl = q('[data-qty]');
          this.steps = qa('.werk-product-buy-box_step');
          this.lb = this.classList.contains('werk-product-buy-box--lookbook');
          this.slidesEl = q('.werk-product-buy-box_slides');
          this.labelEl = q('.werk-product-buy-box_label');
          this.rail = q('.werk-product-buy-box_rail');
          this.noCap = !!q('[data-no-caption]');
          this.speed = this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, opts) => el?.addEventListener(type, fn, { signal: ac.signal, ...opts });
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'submit', (e) => this.onSubmit(e));
          on(this, 'pointerover', (e) => this.onOver(e));
          on(this, 'pointerout', (e) => this.onOut(e));
          on(this.frame, 'pointermove', (e) => this.onMove(e));
          on(this.frame, 'pointerleave', () => this.frame.classList.remove('is-cursor'));
          on(this.frame, 'pointerdown', (e) => this.onDown(e));
          on(this.frame, 'keydown', (e) => {
            if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
              e.preventDefault();
              this.show(this.i + (e.key === 'ArrowLeft' ? -1 : 1), false, e.key === 'ArrowLeft' ? -1 : 1);
            }
          });
          if (this.lb) {
            // a jump from the rail holds the rail on its target until the scroll has settled
            on(window, 'scrollend', () => this.unhold());
            on(this.slidesEl, 'scrollend', () => this.unhold());
            on(window, 'resize', () => this.lbStick());
          }
          on(document, 'shopify:block:select', (e) => {
            const link = e.target.closest?.('.werk-product-buy-box_more-link');
            if (link && this.contains(link)) this.toggle(link, true);
          });

          this.delivery();
          this.update(true);
          this.fitLabels();
          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => {
              this.fitLabels();
              if (this.lb) this.lbLayout();
            });
          });
          this.ro.observe(this);
          if (this.lb && this.labelEl) this.ro.observe(this.labelEl);
          if (this.del) this.timer = setInterval(() => (this.delivery(), this.renderReceipt()), 30000);

          this.io = new IntersectionObserver(
            ([en]) => {
              if (!en.isIntersecting) return;
              this.io.disconnect();
              requestAnimationFrame(() => this.classList.add('is-inview'));
            },
            // a lookbook is taller than most screens, so a share of it may never be on screen
            this.lb ? { rootMargin: '0px 0px -15% 0px' } : { threshold: 0.15 }
          );
          this.io.observe(this);

          const anchor = this.buy || this.receipt;
          // one bar per page: the buy box passed last shows it, and only while no buy buttons are on screen
          if (anchor) {
            this.so = new IntersectionObserver(
              ([en]) => {
                this.anchor = en.isIntersecting ? 'visible' : en.boundingClientRect.top < 0 ? 'above' : 'below';
                document.dispatchEvent(new CustomEvent('werk-product-buy-box:anchor'));
              },
              { threshold: 0 }
            );
            this.so.observe(anchor);
            if (this.bar && 'showPopover' in this.bar) on(document, 'werk-product-buy-box:anchor', () => this.pickBar());
          }
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          this.so?.disconnect();
          this.ro?.disconnect();
          this.lio?.disconnect();
          cancelAnimationFrame(this.raf);
          clearTimeout(this.lt);
          clearInterval(this.timer);
          clearTimeout(this.bt);
          clearTimeout(this.st);
          try {
            this.bar?.hidePopover();
          } catch {}
        }

        // one label column for all option rows: grows for long option names (up to 45 % of the label)
        fitLabels() {
          const labs = [...this.querySelectorAll('.werk-product-buy-box_lab')];
          if (!labs.length) return;
          this.style.removeProperty('--lab-min');
          const max = Math.max(...labs.map((l) => l.scrollWidth));
          const room = labs[0].closest('.werk-product-buy-box_rest, .werk-product-buy-box_head, .werk-product-buy-box_label').clientWidth * 0.45;
          if (max > labs[0].clientWidth + 1) this.style.setProperty('--lab-min', Math.ceil(Math.min(max, room)) + 'px');
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        load(slide, lazy) {
          const img = slide?.querySelector('img');
          if (!img) return img;
          if (!lazy) img.loading = 'eager';
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          if (img.dataset.src) img.src = img.dataset.src;
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-src');
          return img;
        }

        h(x) {
          return String(x).toLowerCase().trim().replace(/['"]/g, '').replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '');
        }

        // the #tag of an option value, as Liquid's handleize made it (Grün → grun); h() only as a fallback
        tagOf(oi, val) {
          const o = this.d.options[oi];
          const k = o?.keys?.[o.values.indexOf(val)];
          return k != null ? k : this.h(val);
        }

        find(sel) {
          return this.d.variants.find((x) => x.o.every((o, j) => o === sel[j]));
        }

        // ---------- state ----------
        pick(oi, val) {
          const sel = [...this.sel];
          sel[oi] = val;
          const withVal = this.d.variants.filter((x) => x.o[oi] === val);
          const v = this.find(sel) || withVal.find((x) => x.available) || withVal[0];
          if (!v) return;
          this.v = v;
          this.sel = [...v.o];
          this.update();
        }

        update(first) {
          const v = this.v;
          if (!v) return;
          this.vals.forEach((b) => {
            const oi = +b.dataset.opt;
            const val = b.dataset.val;
            b.setAttribute('aria-checked', this.sel[oi] === val ? 'true' : 'false');
            const cand = this.d.variants.filter((x) => x.o[oi] === val && x.o.every((o, j) => j === oi || o === this.sel[j]));
            b.classList.toggle('is-out', !cand.some((x) => x.available));
          });
          this.querySelectorAll('[data-price]').forEach((el) => this.roll(el, v.price, first));
          const cmp = this.querySelector('[data-compare]');
          if (cmp) cmp.textContent = v.compare || '';
          this.adds.forEach((b) => {
            b.disabled = !v.available;
            b.classList.toggle('is-soldout', !v.available);
            const l = b.querySelector('[data-add-label]');
            if (l) l.textContent = v.available ? this.t.add : this.t.soldOut;
          });
          if (this.form?.elements.id) this.form.elements.id.value = v.id;
          const sel = this.querySelector('[data-bar-sel]');
          if (sel) sel.textContent = this.d.options.length ? v.o.join(' / ') : '';
          this.unsplit();
          this.setQty(this.qty, first);
          this.renderStock();
          this.gallery(first);
          if (!first && this.d.page) {
            const u = new URL(location.href);
            u.searchParams.set('variant', v.id);
            history.replaceState(history.state, '', u);
          }
        }

        unsplit() {
          if (!this.buy?.classList.contains('is-split')) return;
          this.buy.classList.remove('is-split');
          this.buy.querySelector('.werk-product-buy-box_split').inert = true;
        }

        max() {
          const q = this.v?.qty;
          return q == null ? 999 : Math.max(1, q);
        }

        setQty(n, first) {
          n = Math.min(Math.max(1, n), this.max());
          this.qty = n;
          if (this.qtyEl) this.roll(this.qtyEl, String(n), first);
          if (this.form?.elements.quantity) this.form.elements.quantity.value = n;
          this.steps.forEach((b) => (b.disabled = +b.dataset.step < 0 ? n <= 1 : n >= this.max()));
          this.renderReceipt();
        }

        // only the characters that change move (aligned from the right)
        roll(el, next, instant) {
          const prev = el.dataset.v;
          el.dataset.v = next;
          if (prev === next) return;
          clearTimeout(el._t);
          if (instant || prev == null || !this.speed) {
            el.textContent = next;
            return;
          }
          const a = [...prev];
          const b = [...next];
          while (a.length < b.length) a.unshift('');
          while (b.length < a.length) b.unshift('');
          const esc = (c) => c.replace(/&/g, '&amp;').replace(/</g, '&lt;');
          el.innerHTML = b.map((c, k) => (c === a[k] ? esc(c) : `<span class="werk-product-buy-box_ch"><i aria-hidden="true">${esc(a[k])}</i><i>${esc(c)}</i></span>`)).join('');
          el._t = setTimeout(() => (el.textContent = next), 480);
        }

        renderStock() {
          const el = this.stockEl;
          if (!el) return;
          const v = this.v;
          const t = +el.dataset.threshold || 5;
          // without options, [variant] goes together with the word in front of it ("in")
          const say = (s) =>
            this.d.options.length ? this.fill(s, { variant: v.o.join(' / '), count: n }) : this.fill((s || '').replace(/\s*\S*\s*\[variant\]/, '').replace(/^[\s:,–-]+/, ''), { count: n });
          let text = '';
          let n = 0;
          if (!v.available) text = say(this.t.stockOut);
          else if (v.qty != null && v.qty > 0 && v.qty <= t) {
            n = v.qty;
            text = say(n === 1 ? this.t.stockOne : this.t.stockFew);
          }
          el.hidden = !text;
          el.classList.toggle('is-last', n === 1);
          el.querySelector('[data-stock]').textContent = text;
          const filled = n ? Math.max(1, Math.min(5, Math.round((n / t) * 5))) : 0;
          el.querySelectorAll('i').forEach((d, k) => {
            d.style.setProperty('--d', k);
            d.classList.toggle('is-on', k < filled);
          });
        }

        renderReceipt() {
          const el = this.receipt;
          if (!el || el.classList.contains('is-error')) return;
          const parts = [];
          if (this.d.options.length) parts.push(this.v.o.join(' / '));
          if (this.t.qty) parts.push(this.fill(this.t.qty, { n: this.qty }));
          if (this.ships) parts.push(this.ships);
          const spans = [...el.children];
          if (spans.length !== parts.length) {
            el.innerHTML = parts.map((p) => `<span>${p.replace(/</g, '&lt;')}</span>`).join(' · ');
            return;
          }
          parts.forEach((p, k) => {
            if (spans[k].textContent === p) return;
            spans[k].textContent = p;
            if (this.speed) spans[k].animate([{ opacity: 0, filter: 'blur(2px)' }, { opacity: 1, filter: 'blur(0)' }], { duration: 400, easing: 'ease-out' });
          });
        }

        // "[count] left in [variant]" → "3 left in Sage / M"
        fill(s, map = {}) {
          return (s || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? String(map[k]) : m));
        }

        flash(msg) {
          const el = this.receipt;
          if (!el) return;
          el.classList.add('is-error');
          el.textContent = msg;
          clearTimeout(this.ft);
          this.ft = setTimeout(() => {
            el.classList.remove('is-error');
            el.textContent = '';
            this.renderReceipt();
          }, 4000);
        }

        // ---------- gallery ----------
        gallery(first) {
          if (!this.slides.length) return;
          const v = this.v;
          const tags = new Set(this.sel.map((x, oi) => this.tagOf(oi, x)));
          let list = this.slides.filter((s) => !this.hasAttribute('data-filter') || !s.dataset.tag || tags.has(s.dataset.tag));
          if (!list.length) list = [...this.slides];
          const m = v.media != null && this.slides.find((s) => s.dataset.id == v.media);
          if (m) list = [m, ...list.filter((s) => s !== m)];
          const key = list.map((s) => s.dataset.id).join();
          if (this.lb) {
            if (key !== this.key) {
              this.key = key;
              this.list = list;
              this.lbList(list, first);
            }
            this.media = v.media;
            return;
          }
          this.frame.classList.toggle('is-single', list.length < 2);
          if (key !== this.key) {
            this.key = key;
            this.list = list;
            this.show(0, first);
          } else if (m && this.cur !== m && this.media !== v.media) this.show(0);
          this.media = v.media;
        }

        show(k, instant, dir = 0) {
          const list = this.list || [];
          const n = list.length;
          if (!n) return;
          if (this.lb) return this.lbGo(Math.max(0, Math.min(k, n - 1)));
          k = ((k % n) + n) % n;
          const next = list[k];
          const token = (this.token = (this.token || 0) + 1);
          this.i = k;
          const pad = (x) => String(x).padStart(2, '0');
          if (this.count) this.count.textContent = `${pad(k + 1)} / ${pad(n)}`;
          if (this.countSr) this.countSr.textContent = this.fill(this.t.count || '[n] / [total]', { n: pad(k + 1), total: pad(n) });
          if (this.caption) this.caption.textContent = next.dataset.caption || '';
          const img = this.load(next);
          next.classList.add('is-near');
          const go = () => {
            if (token !== this.token) return;
            const prev = this.cur;
            this.cur = next;
            if (prev !== next) {
              // commit the start state (drift from the direction of travel) without a transition
              next.style.transition = 'none';
              next.style.setProperty('--dx', dir);
              next.classList.remove('is-leaving');
              void next.offsetWidth;
              next.style.transition = '';
              if (prev) {
                prev.style.setProperty('--dx', dir);
                prev.classList.remove('is-active');
                if (!instant && this.speed) {
                  prev.classList.add('is-leaving');
                  clearTimeout(prev._t);
                  prev._t = setTimeout(() => prev.classList.remove('is-leaving'), 1000);
                }
              }
              next.classList.add('is-active');
            }
            const near = new Set([next, list[(k + 1) % n], list[(k - 1 + n) % n]]);
            this.slides.forEach((s) => {
              if (s !== next) s.classList.remove('is-active');
              s.classList.toggle('is-near', near.has(s));
            });
            near.forEach((s) => this.load(s));
          };
          if (instant || !img || img.complete) go();
          else {
            const t = setTimeout(go, 900);
            (img.decode ? img.decode() : Promise.resolve()).catch(() => {}).then(() => (clearTimeout(t), go()));
          }
        }

        // ---------- lookbook: every image of the colour, a rail that follows ----------
        isRow() {
          return getComputedStyle(this.slidesEl).overflowX !== 'visible';
        }

        lbList(list, first) {
          const n = list.length;
          const pair = this.hasAttribute('data-pair') && n >= 4;
          const was = new Set(list.filter((s) => s.classList.contains('is-in')));
          this.slides.forEach((s) => list.includes(s) || s.classList.remove('is-in', 'is-half'));
          list.forEach((s, k) => {
            s.classList.add('is-in');
            s.classList.toggle('is-half', pair && (k === 2 || k === 3));
            this.load(s, true);
          });
          // DOM order = order on screen (the variant image first)
          const order = [...this.slidesEl.children].filter((c) => list.includes(c));
          if (order.some((c, k) => c !== list[k])) this.slidesEl.append(...list);
          const segs = this.rail?.querySelector('.werk-product-buy-box_segs');
          if (segs) {
            segs.innerHTML =
              n > 1 ? list.map((s, k) => `<button type="button" class="werk-product-buy-box_seg" data-seg="${k}" aria-label="${this.esc(this.railText(k, true))}"></button>`).join('') : '';
            this.rail.hidden = false;
          }
          this.i = -1;
          this.lbMark(0, first);
          this.lbObserve();
          if (first) return;
          // a new colour: back to its first image, the new images fade in
          this.lbGo(0, true);
          if (this.speed)
            list.forEach((s, k) => {
              if (was.has(s)) return;
              s.firstElementChild?.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 600, delay: Math.min(k, 4) * 70, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' });
            });
        }

        // sr: the screen reader pattern (Image number), else the visible "01 / 05"
        railText(k, sr) {
          const s = this.list[k];
          const pad = (x) => String(x).padStart(2, '0');
          const c = !this.noCap && s?.dataset.caption;
          const no = sr ? this.fill(this.t.count || '[n] / [total]', { n: pad(k + 1), total: pad(this.list.length) }) : `${pad(k + 1)} / ${pad(this.list.length)}`;
          return no + (c ? ` · ${c}` : '');
        }

        lbMark(k, instant) {
          const list = this.list || [];
          if (!list.length || k === this.i) return;
          this.i = k;
          this.cur = list[k];
          const t = this.railText(k);
          const at = t.indexOf(' · ');
          const count = at < 0 ? t : t.slice(0, at);
          const cap = at < 0 ? '' : t.slice(at);
          const n = this.rail?.querySelector('.werk-product-buy-box_rail-n');
          if (n) this.roll(n, count, instant);
          const c = this.rail?.querySelector('.werk-product-buy-box_rail-c');
          if (c) c.textContent = cap || '';
          this.rail?.querySelectorAll('.werk-product-buy-box_seg').forEach((b, j) => b.setAttribute('aria-current', j === k ? 'true' : 'false'));
        }

        // desktop: the image on the line at 45 % of the screen; swipe row: the one most in view
        lbObserve() {
          this.lio?.disconnect();
          const row = (this.row = this.isRow());
          // the observer only says when to look; lbPick() measures, so it is never behind the scroll
          this.lio = new IntersectionObserver(
            () => {
              if (!this.lock) this.lbPick();
            },
            row ? { root: this.slidesEl, threshold: [0, 0.25, 0.5, 0.75, 1] } : { rootMargin: '-45% 0px -55% 0px' }
          );
          this.list.forEach((s) => this.lio.observe(s));
        }

        // ties keep the current image (images 3 and 4 side by side cross the line together)
        lbPick() {
          const list = this.list || [];
          const box = this.row && this.slidesEl.getBoundingClientRect();
          const line = innerHeight * 0.45;
          const val = (s) => {
            if (!s) return 0;
            const r = s.getBoundingClientRect();
            if (box) return Math.max(0, Math.min(r.right, box.right) - Math.max(r.left, box.left)) / (r.width || 1);
            return r.top <= line && r.bottom > line ? 1 : 0;
          };
          let best = this.i;
          let top = val(list[this.i]);
          list.forEach((s, k) => {
            const v = val(s);
            if (v > top + 0.01) {
              best = k;
              top = v;
            }
          });
          if (best >= 0) this.lbMark(best);
        }

        lbGo(k, back) {
          const s = (this.list || [])[k];
          if (!s) return;
          let behavior = this.speed ? 'smooth' : 'auto';
          if (this.row) {
            const left = Math.max(0, s.offsetLeft - parseFloat(getComputedStyle(this.slidesEl).paddingLeft));
            if (back) behavior = 'auto';
            if (Math.abs(this.slidesEl.scrollLeft - left) > 1) {
              this.hold();
              this.slidesEl.scrollTo({ left, behavior });
            }
          } else {
            const gap = s.getBoundingClientRect().top - (parseFloat(getComputedStyle(s).scrollMarginTop) || 0);
            // after a colour switch only scroll when the gallery's top is above the screen
            if (!(back && this.frame.getBoundingClientRect().top >= 0) && Math.abs(gap) > 1) {
              this.hold();
              s.scrollIntoView({ block: 'start', behavior });
            }
          }
          this.lbMark(k);
        }

        hold() {
          this.lock = true;
          clearTimeout(this.lt);
          this.lt = setTimeout(() => this.unhold(), 1200);
        }

        unhold() {
          if (!this.lock) return;
          this.lock = false;
          clearTimeout(this.lt);
          this.lbPick();
        }

        lbLayout() {
          if (this.list && this.isRow() !== this.row) this.lbObserve();
          this.lbStick();
        }

        // sticky label: 110 from the top, or higher when it is taller than the screen, so its end stays reachable
        lbStick() {
          const l = this.labelEl;
          if (!l) return;
          if (this.row) return l.style.removeProperty('--werk-stick');
          const u = parseFloat(getComputedStyle(this.slidesEl).getPropertyValue('--werk-u')) || 1;
          l.style.setProperty('--werk-stick', Math.round(Math.min(110 * u, innerHeight - l.offsetHeight - 24)) + 'px');
        }

        esc(x) {
          return String(x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
        }

        peek(btn) {
          this.vals.forEach((b) => b.classList.remove('is-preview'));
          this.peekEl?.classList.remove('is-peek');
          this.peekEl = null;
          this.frame.classList.remove('is-preview');
          if (!btn || btn.getAttribute('aria-checked') === 'true') return;
          const oi = +btn.dataset.opt;
          const val = btn.dataset.val;
          const sel = [...this.sel];
          sel[oi] = val;
          const v = this.find(sel) || this.d.variants.find((x) => x.o[oi] === val);
          let m = v && v.media != null && this.slides.find((s) => s.dataset.id == v.media);
          if (!m) m = this.slides.find((s) => s.dataset.tag && s.dataset.tag === this.tagOf(oi, val));
          if (!m || m === this.cur) return;
          if (this.lb) {
            // the preview lies over the image in view; images already in the lookbook don't peek
            if (m.classList.contains('is-in') || !this.cur) return;
            const box = this.slidesEl.getBoundingClientRect();
            const fr = this.frame.getBoundingClientRect();
            const r = this.cur.getBoundingClientRect();
            const st = this.slidesEl.style;
            st.setProperty('--pk-t', r.top - box.top + this.slidesEl.scrollTop + 'px');
            st.setProperty('--pk-l', r.left - box.left + this.slidesEl.scrollLeft + 'px');
            st.setProperty('--pk-w', r.width + 'px');
            st.setProperty('--pk-h', r.height + 'px');
            this.frame.style.setProperty('--tg-t', r.top - fr.top + 'px');
            this.frame.style.setProperty('--tg-r', fr.right - r.right + 'px');
          }
          this.load(m);
          btn.classList.add('is-preview');
          m.classList.add('is-peek');
          this.peekEl = m;
          this.frame.classList.add('is-preview');
        }

        onOver(e) {
          if (e.pointerType !== 'mouse' || !this.hasAttribute('data-preview')) return;
          const b = e.target.closest?.('.werk-product-buy-box_val');
          if (b) this.peek(b);
        }

        onOut(e) {
          const b = e.target.closest?.('.werk-product-buy-box_val');
          if (b && !b.contains(e.relatedTarget)) this.peek(null);
        }

        onMove(e) {
          if (this.lb || e.pointerType !== 'mouse' || this.frame.classList.contains('is-single')) return;
          const r = this.frame.getBoundingClientRect();
          const x = e.clientX - r.left;
          const y = e.clientY - r.top;
          this.cursorEl.style.setProperty('--cx', x + 'px');
          this.cursorEl.style.setProperty('--cy', y + 'px');
          const t = (x < r.width / 2 ? this.t.prev : this.t.next) || '';
          if (this.cursorText.textContent !== t) this.cursorText.textContent = t;
          this.frame.classList.add('is-cursor');
        }

        onDown(e) {
          if (this.lb || e.pointerType === 'mouse') return;
          const x0 = e.clientX;
          const y0 = e.clientY;
          const up = (u) => {
            removeEventListener('pointerup', up);
            removeEventListener('pointercancel', up);
            const dx = u.clientX - x0;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(u.clientY - y0)) {
              this.swiped = true;
              this.show(this.i + (dx < 0 ? 1 : -1), false, dx < 0 ? 1 : -1);
              setTimeout(() => (this.swiped = false), 50);
            }
          };
          addEventListener('pointerup', up);
          addEventListener('pointercancel', up);
        }

        // ---------- clicks ----------
        onClick(e) {
          const t = e.target;
          const seg = t.closest('.werk-product-buy-box_seg');
          if (seg) {
            this.lbGo(+seg.dataset.seg);
            return;
          }
          const zone = t.closest('.werk-product-buy-box_zone');
          if (zone) {
            if (!this.swiped) this.show(this.i + +zone.dataset.go, false, +zone.dataset.go);
            return;
          }
          const val = t.closest('.werk-product-buy-box_val');
          if (val) {
            this.peek(null);
            this.pick(+val.dataset.opt, val.dataset.val);
            return;
          }
          const step = t.closest('.werk-product-buy-box_step');
          if (step) {
            this.setQty(this.qty + +step.dataset.step);
            this.unsplit();
            return;
          }
          const link = t.closest('.werk-product-buy-box_more-link');
          if (link) this.toggle(link);
        }

        toggle(link, force) {
          const open = force ?? link.getAttribute('aria-expanded') !== 'true';
          this.querySelectorAll('.werk-product-buy-box_more-link').forEach((l) => {
            const on = l === link && open;
            l.setAttribute('aria-expanded', on ? 'true' : 'false');
            const p = document.getElementById(l.getAttribute('aria-controls'));
            if (!p) return;
            p.classList.toggle('is-open', on);
            p.inert = !on;
          });
        }

        // ---------- add to cart ----------
        async onSubmit(e) {
          const form = e.target.closest('.werk-product-buy-box_form');
          if (!form) return;
          e.preventDefault();
          const v = this.v;
          if (this.busy || !v || !v.available) return;
          this.busy = true;
          this.unsplit();
          this.adds.forEach((b) => (b.dataset.state = 'loading'));
          const done = () => {
            this.adds.forEach((b) => (b.dataset.state = 'added'));
            clearTimeout(this.st);
            const split = this.buy?.hasAttribute('data-split');
            this.st = setTimeout(() => {
              if (split) {
                this.buy.classList.add('is-split');
                this.buy.querySelector('.werk-product-buy-box_split').inert = false;
              }
              this.adds.forEach((b) => delete b.dataset.state);
            }, split ? 1100 : 2400);
          };
          try {
            if (this.d.demo) {
              await new Promise((r) => setTimeout(r, 700));
              done();
              return;
            }
            const root = window.Shopify?.routes?.root || '/';
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: v.id, quantity: this.qty }] }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            done();
            const cart = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: v.id, quantity: this.qty }],
              promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart(root);
          } catch (err) {
            this.adds.forEach((b) => delete b.dataset.state);
            if (err && err.description) this.flash(err.description);
            else form.submit();
          } finally {
            this.busy = false;
          }
        }

        // ---------- sticky bar ----------
        pickBar() {
          const all = [...document.querySelectorAll('werk-product-buy-box')].filter((e) => e.anchor);
          const last = all.filter((e) => e.anchor === 'above').pop();
          this.sticky(last === this && !all.some((e) => e.anchor === 'visible'));
        }

        sticky(on) {
          if (on === !!this.barOn) return;
          this.barOn = on;
          const b = this.bar;
          clearTimeout(this.bt);
          if (on) {
            try {
              b.showPopover();
            } catch {}
            b.inert = false;
            requestAnimationFrame(() => requestAnimationFrame(() => b.classList.add('is-on')));
          } else {
            b.classList.remove('is-on');
            b.inert = true;
            this.bt = setTimeout(() => {
              try {
                if (!this.barOn) b.hidePopover();
              } catch {}
            }, 520 * this.speed + 20);
          }
        }

        // ---------- delivery promise (shop time zone) ----------
        delivery() {
          const el = this.del;
          this.ships = '';
          if (!el) return;
          const cut = (el.dataset.cutoff || '').trim().match(/^(\d{1,2})(?:[:.](\d{2}))?$/);
          if (!cut) {
            el.hidden = true;
            return;
          }
          const tz = this.dataset.tz || '+0000';
          const off = (tz[0] === '-' ? -1 : 1) * (+tz.slice(1, 3) * 60 + +tz.slice(3, 5));
          const now = Date.now() + off * 6e4;
          const day = Math.floor(now / 864e5);
          const mins = Math.floor((now % 864e5) / 6e4);
          const cutMin = +cut[1] * 60 + +(cut[2] || 0);
          const mode = el.dataset.days;
          const hol = (el.dataset.holidays || '').split(/[\s,;]+/).filter(Boolean);
          const wd = (d) => (((d + 4) % 7) + 7) % 7;
          const md = (d) => {
            const x = new Date(d * 864e5);
            return String(x.getUTCMonth() + 1).padStart(2, '0') + '-' + String(x.getUTCDate()).padStart(2, '0');
          };
          const open = (d) => {
            const w = wd(d);
            if (mode !== 'every' && (w === 0 || (w === 6 && mode !== 'mon_sat'))) return false;
            return !hol.includes(md(d));
          };
          let ship = day;
          if (!(open(day) && mins < cutMin)) {
            ship = day + 1;
            while (!open(ship)) ship++;
          }
          const add = (d, n) => {
            while (n > 0) {
              d++;
              if (open(d)) n--;
            }
            return d;
          };
          const tmin = Math.max(1, +el.dataset.min || 2);
          const tmax = Math.max(tmin, +el.dataset.max || tmin);
          const a1 = add(ship, tmin);
          const a2 = add(ship, tmax);
          const T = this.t;
          const esc = (c) => c.replace(/&/g, '&amp;').replace(/</g, '&lt;');
          const list = (s, n) => {
            const l = (s || '').split(',').map((x) => x.trim());
            return Array.from({ length: n }, (_, k) => l[k] || '');
          };
          const W = list(T.days, 7);
          const WS = list(T.daysShort, 7);
          const WM = list(T.daysMin, 7);
          const M = list(T.months, 12);
          const dt = (d) => new Date(d * 864e5);
          // a range in one month names the month once: "Wed 3 – Fri 5 Oct"
          const fmt = (d, month = true) =>
            this.fill(month ? T.date : (T.date || '').replace(/[\s,]*\[month\][.,]?/, ''), { weekday: WS[wd(d)], d: dt(d).getUTCDate(), month: M[dt(d).getUTCMonth()] })
              .replace(/\s{2,}/g, ' ')
              .trim();
          let a;
          if (ship === day) {
            const left = cutMin - mins;
            a = left >= 60 ? this.fill(T.countdown, { h: Math.floor(left / 60), m: left % 60 }) : this.fill(T.countdownMin, { m: left });
            this.ships = this.fill(T.shipsToday);
          } else if (ship === day + 1) {
            a = this.ships = this.fill(T.shipsTomorrow);
          } else {
            a = this.fill(T.shipsOn, { day: W[wd(ship)] });
            this.ships = this.fill(T.shipsOn, { day: WS[wd(ship)] });
          }
          const sameMonth = dt(a1).getUTCMonth() === dt(a2).getUTCMonth();
          const b = a1 === a2 ? this.fill(T.arrives, { date: fmt(a1) }) : this.fill(T.arrivesRange, { from: fmt(a1, !sameMonth), to: fmt(a2) });
          el.querySelector('[data-del-a]').textContent = a;
          el.querySelector('[data-del-b]').textContent = b;

          const len = Math.min(14, Math.max(7, a2 - day + 1));
          const pos = (d) => (((d - day + 0.5) / len) * 100).toFixed(3) + '%';
          let html = `<span class="werk-product-buy-box_route" style="--a: ${pos(day)}; --b: ${pos(a1)}"></span>`;
          if (a2 > a1) html += `<span class="werk-product-buy-box_range" style="--a: ${pos(a1)}; --b: ${pos(a2)}"></span>`;
          for (let k = 0; k < len; k++) {
            const d = day + k;
            const c = [];
            if (d === day) c.push('is-today');
            else if (d === a1 || d === a2) c.push('is-arrive');
            else if (d === ship) c.push('is-ship');
            else if (d < a1) c.push('is-way');
            if (!open(d)) c.push('is-off');
            html += `<span class="werk-product-buy-box_day ${c.join(' ')}"><i></i><span>${esc(WM[wd(d)])}</span></span>`;
          }
          const strip = el.querySelector('[data-strip]');
          strip.style.setProperty('--n', len);
          strip.innerHTML = html;
          el.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-product-canvas"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-product-canvas')) {
    customElements.define(
      'werk-product-canvas',
      class extends HTMLElement {
        connectedCallback() {
          const q = (sel) => this.querySelector(sel);
          try {
            this.d = JSON.parse(q('script[data-werk]').textContent);
            this.t = JSON.parse(q('script[data-werk-t]').textContent);
          } catch {
            return;
          }
          this.P = this.d.products;
          if (!this.P.length) return;
          this.inner = q('.werk-product-canvas_inner');
          this.stage = q('[data-stage]');
          this.panel = q('[data-panel]');
          this.scroll = q('[data-scroll]');
          this.cursor = q('[data-cursor]');
          this.addBtn = q('[data-add]');
          this.motion = this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!this.motion) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          const speed = { calm: 0.7, normal: 1, fast: 1.4 };
          this.dragK = speed[this.d.drag] || 1;
          this.wheelK = speed[this.d.wheel] || 1;
          this.zooms = [0.75, 1, 1.35];
          this.zi = 1;
          this.z = this.zt = 1;
          this.cam = { x: 0, y: 0 };
          this.tgt = { x: 0, y: 0 };
          this.tiles = [];
          this.list = this.P.map((_, i) => i);
          this.active = null;
          this.qty = 1;

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          this.on = on;

          this.buildFilters();
          this.buildIndex();
          this.measure();
          this.center();

          on(this.inner, 'pointerdown', (e) => this.down(e));
          on(this.inner, 'pointermove', (e) => this.move(e));
          on(this.inner, 'pointerup', (e) => this.up(e));
          on(this.inner, 'pointercancel', (e) => this.up(e, true));
          on(this.inner, 'pointerleave', () => (this.hover(null), this.hideCursor()));
          on(this.inner, 'wheel', (e) => this.wheel(e), { passive: false });
          on(this.inner, 'click', (e) => this.click(e));
          on(this.panel?.querySelector('[data-photo]'), 'pointerdown', (e) => this.swipe(e));
          on(this.inner, 'keydown', (e) => this.key(e));
          on(this.inner, 'dragstart', (e) => e.preventDefault());
          on(window, 'popstate', () => this.fromHash(true));
          on(document, 'visibilitychange', () => document.hidden || this.kick());
          on(document, 'shopify:block:select', (e) => {
            if (!this.contains(e.target)) return;
            const i = this.P.findIndex((p) => p.b === e.detail.blockId);
            if (i > -1) this.openProduct(i, true);
          });
          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.rz);
            this.rz = requestAnimationFrame(() => this.measure());
          });
          this.ro.observe(this.inner);
          this.io = new IntersectionObserver(([en]) => {
            this.visible = en.isIntersecting;
            if (this.visible) this.kick();
          });
          this.io.observe(this.inner);

          // fade in once the first pictures are there (with a lid, so a slow picture never blocks)
          const imgs = this.tiles.filter((t) => t.x > -this.m.w && t.x < this.m.vw && t.y > -this.m.h && t.y < this.m.vh).map((t) => t.img).filter((i) => i.getAttribute('src'));
          Promise.race([
            Promise.all(imgs.map((img) => img.complete || new Promise((r) => { img.addEventListener('load', r, { once: true }); img.addEventListener('error', r, { once: true }); }))),
            new Promise((r) => setTimeout(r, 4000)),
          ]).then(() => this.inner.classList.add('is-ready'));
          if (window.Shopify?.designMode) this.inner.classList.add('is-ready');
          this.fromHash(false);
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.ro?.disconnect();
          this.io?.disconnect();
          cancelAnimationFrame(this.raf);
          cancelAnimationFrame(this.rz);
          clearTimeout(this.tm);
          clearTimeout(this.cursorT);
          clearTimeout(this.swapTm);
          this.stage && (this.stage.textContent = '');
          this.tiles = [];
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        // ---------- helpers ----------
        money(cents) {
          const f = (n, d, ts, ds) => {
            const [i, fr] = (n / 100).toFixed(d).split('.');
            return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (fr ? ds + fr : '');
          };
          const map = {
            amount: () => f(cents, 2, ',', '.'),
            amount_no_decimals: () => f(cents, 0, ',', '.'),
            amount_with_comma_separator: () => f(cents, 2, '.', ','),
            amount_no_decimals_with_comma_separator: () => f(cents, 0, '.', ','),
            amount_with_space_separator: () => f(cents, 2, ' ', ','),
            amount_no_decimals_with_space_separator: () => f(cents, 0, ' ', ','),
            amount_with_apostrophe_separator: () => f(cents, 2, "'", '.'),
          };
          // fallback built in pieces: two curly braces in a row would be read as Liquid
          return (this.d.money || '$' + '{' + '{amount}' + '}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (map[k] || map.amount)());
        }
        esc(s) {
          return String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
        }
        fill(str, vals) {
          return String(str || '').replace(/\[(\w+)\]/g, (m, k) => (k in vals ? vals[k] : m));
        }
        // Shopify CDN pictures take a width parameter; demo / CDN files get one too
        src(url, w) {
          if (!url) return '';
          return /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1' + w) : url + (url.includes('?') ? '&' : '?') + 'width=' + w;
        }
        srcset(url, ws) {
          return ws.map((w) => `${this.src(url, w)} ${w}w`).join(', ');
        }
        mod(a, n) {
          return ((a % n) + n) % n;
        }
        priceOf(p) {
          return p.pv ? this.fill(this.t.from, { price: this.money(p.p) }) : this.money(p.p);
        }

        // ---------- filters + index ----------
        groupsOf(p) {
          const f = this.d.filter;
          if (f === 'type') return p.ty ? [p.ty] : [];
          if (f === 'group') return p.g ? [p.g] : [];
          if (f === 'tag') {
            const pre = (this.d.prefix || '').toLowerCase();
            return p.tags.filter((t) => t.toLowerCase().startsWith(pre)).map((t) => t.slice(pre.length).trim()).filter(Boolean);
          }
          return [];
        }
        buildFilters() {
          const box = this.querySelector('[data-filters]');
          const dock = this.querySelector('[data-dock]');
          const counts = new Map();
          this.P.forEach((p) => this.groupsOf(p).forEach((g) => counts.set(g, (counts.get(g) || 0) + 1)));
          if (counts.size > 1) {
            const chip = (label, n, key, on) =>
              `<button type="button" class="werk-product-canvas_chip" data-filter="${this.esc(key)}" aria-pressed="${on}"><span>${this.esc(label)}</span><span class="werk-product-canvas_chip-n">${n}</span></button>`;
            box.innerHTML = chip(this.t.all, this.P.length, '', true) + [...counts].map(([g, n]) => chip(g, n, g, false)).join('');
          }
          dock.hidden = !box.children.length && !this.querySelector('[data-zoom]');
        }
        buildIndex() {
          const ul = this.querySelector('[data-index]');
          ul.innerHTML = this.P.map(
            (p, i) => `<li><a href="${this.esc(p.u || '#' + p.h)}" data-i="${i}" aria-label="${this.esc(this.fill(this.t.open, { product: p.t }))}">${this.esc(p.t)}</a></li>`
          ).join('');
          this.on(ul, 'focusin', (e) => {
            const i = +e.target.dataset.i;
            if (Number.isNaN(i)) return;
            if (!this.list.includes(i)) this.setFilter('');
            const cell = this.nearest(i);
            this.focusCell = cell;
            this.goTo(cell);
            this.paint(true);
          });
          this.on(ul, 'focusout', () => {
            this.focusCell = null;
            this.paint(true);
          });
        }
        setFilter(key) {
          this.querySelectorAll('[data-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.filter === key)));
          const list = key ? this.P.map((p, i) => (this.groupsOf(p).includes(key) ? i : -1)).filter((i) => i > -1) : this.P.map((_, i) => i);
          if (!list.length) return;
          if (!this.motion) {
            this.list = list;
            this.paint(true);
            return;
          }
          clearTimeout(this.swapTm);
          this.inner.classList.add('is-swapping');
          this.swapTm = setTimeout(() => {
            this.list = list;
            this.paint(true);
            // in from the middle: --k = distance to the centre in cells
            const { cw, ch } = this.m;
            const cx = this.cam.x / cw;
            const cy = this.cam.y / ch;
            this.tiles.forEach((t) => {
              t.el.style.setProperty('--k', Math.round(Math.hypot(t.c - cx, t.r - cy) * 2));
              t.el.classList.add('is-in');
            });
            void this.stage.offsetWidth;
            this.inner.classList.remove('is-swapping');
            this.swapTm = setTimeout(() => this.tiles.forEach((t) => t.el.classList.remove('is-in')), 900);
          }, 190);
        }

        // ---------- measuring + the tile pool ----------
        measure() {
          const cs = getComputedStyle(this.inner);
          const num = (n) => parseFloat(cs.getPropertyValue(n)) || 0;
          const u = this.querySelector('.werk-product-canvas_probe').getBoundingClientRect().width / 1000 || 1;
          const size = parseFloat(getComputedStyle(this).getPropertyValue('--werk-size')) || 1;
          const ratio = parseFloat(getComputedStyle(this).getPropertyValue('--werk-ratio')) || 0.8;
          const w = num('--tw') * u * size;
          const h = w / ratio;
          const m = {
            w,
            h,
            cw: w + num('--gx') * u * size,
            ch: h + (num('--gy') + num('--cap')) * u * size,
            vw: this.inner.clientWidth,
            vh: this.inner.clientHeight,
          };
          if (!m.vw || !m.vh) return;
          const same = this.m && ['w', 'h', 'vw', 'vh'].every((k) => Math.abs(this.m[k] - m[k]) < 0.5);
          if (same) return;
          // keep the same world point in the middle when the size changes
          if (this.m) {
            this.cam.x *= m.cw / this.m.cw;
            this.cam.y *= m.ch / this.m.ch;
            this.tgt.x *= m.cw / this.m.cw;
            this.tgt.y *= m.ch / this.m.ch;
          }
          this.m = m;
          this.stage.style.setProperty('--pc-w', w + 'px');
          this.stage.style.setProperty('--pc-h', h + 'px');
          // enough tiles to cover the view at the smallest zoom, plus a ring
          const zmin = this.zooms[0];
          const cols = Math.ceil(m.vw / (m.cw * zmin)) + 3;
          const rows = Math.ceil(m.vh / (m.ch * zmin)) + 3;
          if (!this.tiles.length || cols !== this.PC || rows !== this.PR) this.pool(cols, rows);
          this.paint(true);
          this.placeHint();
        }
        // the hint moves above the dock when the intro card or the dock would touch it
        placeHint() {
          const hint = this.querySelector('[data-hint]');
          if (!hint) return;
          hint.classList.remove('is-lifted');
          const dock = this.querySelector('[data-dock]');
          const intro = this.querySelector('.werk-product-canvas_intro');
          this.inner.style.setProperty('--dock-h', (dock.hidden ? 0 : dock.offsetHeight) + 'px');
          const r = hint.getBoundingClientRect();
          const hit = (n) => {
            if (!n || n.hidden) return false;
            const q = n.getBoundingClientRect();
            return q.width && r.left < q.right + 8 && q.left < r.right + 8 && r.top < q.bottom + 8 && q.top < r.bottom + 8;
          };
          if (hit(dock) || hit(intro)) hint.classList.add('is-lifted');
        }
        pool(cols, rows) {
          this.PC = cols;
          this.PR = rows;
          this.stage.textContent = '';
          this.tiles = [];
          const frag = document.createDocumentFragment();
          for (let r = 0; r < rows; r++)
            for (let c = 0; c < cols; c++) {
              const el = document.createElement('a');
              el.className = 'werk-product-canvas_tile';
              el.tabIndex = -1;
              el.draggable = false;
              el.innerHTML =
                '<span class="werk-product-canvas_media"><img alt="" decoding="async" draggable="false"><img class="werk-product-canvas_img2" alt="" decoding="async" loading="lazy" draggable="false"></span><span class="werk-product-canvas_cap"><span class="werk-product-canvas_cap-num"></span><span class="werk-product-canvas_cap-name"></span><span class="werk-product-canvas_cap-price"></span></span>';
              const [img, img2] = el.querySelectorAll('img');
              const tile = { el, img, img2, sc: c, sr: r, c: null, r: null, i: -1, x: NaN, y: NaN };
              el._t = tile;
              this.tiles.push(tile);
              frag.append(el);
            }
          this.stage.append(frag);
        }
        // the product in cell (c, r): neighbours always differ, the pattern repeats in every direction
        idxAt(c, r) {
          const n = this.list.length;
          const k = Math.max(2, Math.ceil(Math.sqrt(n)));
          return this.list[this.mod(c + r * k, n)];
        }
        // world position of a cell (odd columns sit half a cell lower)
        cellPos(c, r) {
          const { cw, ch } = this.m;
          return { x: c * cw, y: r * ch + (this.mod(c, 2) ? ch / 2 : 0) };
        }
        fillTile(t, i) {
          const p = this.P[i];
          t.i = i;
          const gallery = this.d.look === 'gallery';
          const pic = p.img;
          t.el.href = p.u || '#' + p.h;
          t.el.classList.toggle('is-out', !p.a);
          const media = t.el.firstChild;
          media.querySelector('.werk-product-canvas_ph')?.remove();
          media.querySelector('.werk-product-canvas_tag')?.remove();
          media.querySelector('.werk-product-canvas_aitag')?.remove();
          if (p.ai && this.t.ai) media.insertAdjacentHTML('beforeend', `<span class="werk-product-canvas_aitag" data-pos="${this.esc(p.ai)}"><i aria-hidden="true">i</i><span>${this.esc(this.t.ai)}</span></span>`);
          if (pic) {
            t.img.hidden = false;
            t.img.sizes = Math.round(this.m.w * 1.35) + 'px';
            t.img.srcset = this.srcset(pic, [300, 450, 600, 800]);
            t.img.src = this.src(pic, 600);
            t.img.style.setProperty('--fp', p.fp || '50% 50%'); // the focal point set in Shopify – only used while tiles are cropped
          } else {
            t.img.hidden = true;
            t.img.removeAttribute('src');
            t.img.removeAttribute('srcset');
            media.insertAdjacentHTML('beforeend', `<span class="werk-product-canvas_ph">${this.esc(p.t)}</span>`);
          }
          if (gallery && p.img2) {
            t.img2.hidden = false;
            t.img2.dataset.src = this.src(p.img2, 600);
            if (t.img2.getAttribute('src')) t.img2.src = t.img2.dataset.src;
          } else {
            t.img2.hidden = true;
            t.img2.removeAttribute('src');
          }
          if (!p.a) media.insertAdjacentHTML('beforeend', `<span class="werk-product-canvas_tag">${this.esc(this.t.soldOut)}</span>`);
          const cap = t.el.lastChild.children;
          cap[0].textContent = String(i + 1).padStart(2, '0');
          cap[1].textContent = p.t;
          cap[2].textContent = this.priceOf(p);
        }
        // place every tile; `force` re-checks the content of each tile
        paint(force) {
          if (!this.m || !this.tiles.length) return;
          const { cw, ch, vw, vh } = this.m;
          const z = this.z;
          const left = this.cam.x - vw / 2 / z;
          const top = this.cam.y - vh / 2 / z;
          const c0 = Math.floor(left / cw) - 1;
          const r0 = Math.floor(top / ch) - 2;
          for (const t of this.tiles) {
            const c = c0 + this.mod(t.sc - c0, this.PC);
            const r = r0 + this.mod(t.sr - r0, this.PR);
            const i = this.idxAt(c, r);
            if (force || c !== t.c || r !== t.r || i !== t.i) {
              t.c = c;
              t.r = r;
              if (i !== t.i || force) this.fillTile(t, i);
              const a = this.active;
              t.el.classList.toggle('is-active', !!a && a.c === c && a.r === r);
              const f = this.focusCell;
              t.el.classList.toggle('is-focus', !!f && f.c === c && f.r === r);
            }
            const pos = this.cellPos(c, r);
            const x = Math.round(((pos.x - this.cam.x) * z + vw / 2) * 10) / 10;
            const y = Math.round(((pos.y - this.cam.y) * z + vh / 2) * 10) / 10;
            if (x !== t.x || y !== t.y || z !== t.z) {
              t.x = x;
              t.y = y;
              t.z = z;
              t.el.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${z})`;
            }
          }
        }
        // start the camera on a tile centre, a little inside the pattern
        center() {
          const p = this.cellPos(2, 1);
          this.cam.x = this.tgt.x = p.x + this.m.w / 2;
          this.cam.y = this.tgt.y = p.y + this.m.h / 2;
          this.paint(true);
        }

        // ---------- the loop: the camera follows its target ----------
        kick() {
          if (this.raf || !this.m) return;
          this.last = performance.now();
          this.raf = requestAnimationFrame((t) => this.tick(t));
        }
        tick(now) {
          this.raf = 0;
          if (!this.isConnected) return;
          const dt = Math.min((now - this.last) / 1000, 1 / 30);
          this.last = now;
          // frame-rate independent damping: fast while dragging, a long glide after a throw
          const k = this.dragging ? 24 : this.gliding ? 5.5 : 8;
          const a = this.motion ? 1 - Math.exp(-dt * k) : 1;
          this.cam.x += (this.tgt.x - this.cam.x) * a;
          this.cam.y += (this.tgt.y - this.cam.y) * a;
          this.z += (this.zt - this.z) * (this.motion ? 1 - Math.exp(-dt * 9) : 1);
          const still = Math.abs(this.tgt.x - this.cam.x) < 0.05 && Math.abs(this.tgt.y - this.cam.y) < 0.05 && Math.abs(this.zt - this.z) < 0.0005;
          if (still) {
            this.cam.x = this.tgt.x;
            this.cam.y = this.tgt.y;
            this.z = this.zt;
            this.gliding = false;
          }
          this.paint(false);
          this.moveCursor(dt);
          if ((!still || this.dragging || this.cursorMoving) && this.visible !== false && !document.hidden) this.raf = requestAnimationFrame((t) => this.tick(t));
        }
        goTo(cell, offsetX = 0, offsetY = 0) {
          const pos = this.cellPos(cell.c, cell.r);
          this.tgt.x = pos.x + this.m.w / 2 - offsetX / this.z;
          this.tgt.y = pos.y + this.m.h / 2 - offsetY / this.z;
          this.gliding = false;
          this.kick();
        }
        // the visible cell showing product i that is closest to the middle
        nearest(i, from) {
          const { cw, ch } = this.m;
          const c0 = Math.round((from ? this.cellPos(from.c, from.r).x : this.cam.x) / cw);
          const r0 = Math.round((from ? this.cellPos(from.c, from.r).y : this.cam.y) / ch);
          let best = null;
          let bd = Infinity;
          const n = this.list.length;
          const R = Math.max(3, Math.ceil(Math.sqrt(n)) + 2);
          for (let dc = -R; dc <= R; dc++)
            for (let dr = -R; dr <= R; dr++) {
              const c = c0 + dc;
              const r = r0 + dr;
              if (this.idxAt(c, r) !== i) continue;
              const d = dc * dc + dr * dr;
              if (d < bd) {
                bd = d;
                best = { c, r };
              }
            }
          return best || { c: c0, r: r0 };
        }

        // ---------- input ----------
        down(e) {
          // phones: the sheet follows the finger from its grabber or top bar, and closes past ~90 px
          if (this.active && this.inner.clientWidth < 750 && e.target.closest('[data-grab], .werk-product-canvas_bar') && !e.target.closest('.werk-product-canvas_icon')) {
            this.sheet = { id: e.pointerId, y: e.clientY, t: e.timeStamp, dy: 0 };
            this.panel.setPointerCapture?.(e.pointerId);
            this.panel.style.transition = 'none';
            return;
          }
          if (e.button !== 0 || e.target.closest('.werk-product-canvas_panel, .werk-product-canvas_dock')) return;
          this.ptr = { id: e.pointerId, x: e.clientX, y: e.clientY, moved: false, samples: [{ t: e.timeStamp, x: e.clientX, y: e.clientY }], touch: e.pointerType !== 'mouse' };
          this.gliding = false;
        }
        move(e) {
          if (e.pointerType === 'mouse') {
            this.cx = e.clientX;
            this.cy = e.clientY;
            // the hidden cursor already sits on the pointer, so it appears where the mouse is
            if (!this.cursorShown()) this.placeCursor();
            if (!this.ptr) return this.hover(e.target.closest('.werk-product-canvas_tile'));
          }
          const sh = this.sheet;
          if (sh && sh.id === e.pointerId) {
            sh.dy = Math.max(0, e.clientY - sh.y);
            this.panel.style.translate = `0 ${sh.dy}px`;
            return;
          }
          const p = this.ptr;
          if (!p || p.id !== e.pointerId) return;
          const dx = e.clientX - p.x;
          const dy = e.clientY - p.y;
          if (!p.moved) {
            if (Math.hypot(dx, dy) < (p.touch ? 10 : 6)) return;
            p.moved = true;
            this.dragging = true;
            this.inner.setPointerCapture?.(e.pointerId);
            this.inner.classList.add('is-dragging', 'is-moved');
            this.hover(null);
          }
          const k = this.dragK / this.z;
          this.tgt.x -= (e.clientX - (p.lx ?? p.x)) * k;
          this.tgt.y -= (e.clientY - (p.ly ?? p.y)) * k;
          p.lx = e.clientX;
          p.ly = e.clientY;
          p.samples.push({ t: e.timeStamp, x: e.clientX, y: e.clientY });
          if (p.samples.length > 8) p.samples.shift();
          this.kick();
        }
        up(e, cancel) {
          const sh = this.sheet;
          if (sh && sh.id === e.pointerId) {
            this.sheet = null;
            this.panel.style.transition = '';
            const fast = sh.dy / Math.max(1, e.timeStamp - sh.t) > 0.6;
            if (sh.dy > 4) {
              this.justDragged = true;
              setTimeout(() => (this.justDragged = false), 0);
            }
            if (!cancel && (sh.dy > 90 || (fast && sh.dy > 24))) this.close();
            // the inline offset goes, the transition carries the sheet out (closed) or back up
            this.panel.style.translate = '';
            return;
          }
          const p = this.ptr;
          if (!p || p.id !== e.pointerId) return;
          this.ptr = null;
          if (!p.moved) return;
          this.dragging = false;
          this.inner.classList.remove('is-dragging');
          this.justDragged = true;
          setTimeout(() => (this.justDragged = false), 0);
          // throw: velocity of the last ~100 ms, none when the pointer rested before letting go
          const s = p.samples.filter((x) => e.timeStamp - x.t < 100);
          if (!cancel && this.motion && s.length > 1 && e.timeStamp - s[s.length - 1].t < 90) {
            const a = s[0];
            const b = s[s.length - 1];
            const dt = Math.max(16, b.t - a.t) / 1000;
            const k = (this.dragK / this.z) * 0.32;
            // a flick never throws further than ~1.5 screens
            const cap = (v) => Math.max(-4000, Math.min(4000, v));
            this.tgt.x -= cap((b.x - a.x) / dt) * k;
            this.tgt.y -= cap((b.y - a.y) / dt) * k;
            this.gliding = true;
          }
          this.kick();
        }
        wheel(e) {
          if (e.ctrlKey || e.target.closest('.werk-product-canvas_panel, .werk-product-canvas_filters')) return;
          e.preventDefault();
          const f = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? this.m.vh : 1;
          const k = (this.wheelK * f) / this.z;
          this.tgt.x += e.deltaX * k;
          this.tgt.y += e.deltaY * k;
          this.gliding = false;
          this.inner.classList.add('is-moved');
          this.kick();
        }
        click(e) {
          const zoom = e.target.closest('[data-zoom]');
          if (zoom) return this.zoom(+zoom.dataset.zoom);
          const chip = e.target.closest('[data-filter]');
          if (chip) return this.setFilter(chip.dataset.filter);
          if (e.target.closest('[data-close], [data-grab]')) return this.justDragged || this.close();
          const step = e.target.closest('[data-step]');
          if (step) return this.step(+step.dataset.step);
          const thumb = e.target.closest('[data-thumb]');
          if (thumb) return this.showPhoto(+thumb.dataset.thumb);
          const val = e.target.closest('[data-value]');
          if (val) return this.pick(+val.dataset.opt, val.dataset.value);
          const qb = e.target.closest('[data-qty]');
          if (qb) return this.setQty(this.qty + +qb.dataset.qty);
          if (e.target.closest('[data-add]')) return this.add();
          if (e.target.closest('[data-details]')) return;
          if (e.target.closest('.werk-product-canvas_panel')) return;
          const tile = e.target.closest('.werk-product-canvas_tile');
          if (this.justDragged) {
            e.preventDefault();
            return;
          }
          if (tile) {
            // Cmd / Ctrl / Shift click: the product page in a new tab, as with any link
            if ((e.metaKey || e.ctrlKey || e.shiftKey) && this.P[tile._t.i].u) return;
            e.preventDefault();
            return this.openCell({ c: tile._t.c, r: tile._t.r });
          }
          if (this.active) this.close();
        }
        key(e) {
          if (e.key === 'Escape' && this.active) {
            e.preventDefault();
            return this.close();
          }
          if (e.target.closest('.werk-product-canvas_panel')) {
            if (this.active && e.target === this.panel.querySelector('[data-title]') && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) this.step(e.key === 'ArrowLeft' ? -1 : 1);
            return;
          }
          if (e.target.closest('[data-index] a') && e.key === 'Enter') {
            e.preventDefault();
            return this.openCell(this.nearest(+e.target.dataset.i));
          }
          if (e.target !== this.inner) return;
          const d = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
          if (!d) {
            if (e.key === '+' || e.key === '=') this.zoom(1);
            if (e.key === '-') this.zoom(-1);
            return;
          }
          e.preventDefault();
          this.tgt.x += (d[0] * this.m.cw) / this.z;
          this.tgt.y += (d[1] * this.m.ch) / this.z;
          this.inner.classList.add('is-moved');
          this.kick();
        }
        hover(tile) {
          if (tile === this.hovered) return;
          this.hovered?.classList.remove('is-hover');
          this.hovered = tile;
          clearTimeout(this.cursorT);
          if (tile) {
            tile.classList.add('is-hover');
            // the second picture only loads on the first hover
            const i2 = tile._t.img2;
            if (!i2.hidden && i2.dataset.src && i2.getAttribute('src') !== i2.dataset.src) i2.src = i2.dataset.src;
            this.showCursor();
          } else {
            // short gaps between tiles keep the cursor, so a quick sweep never fades it out and back in
            this.cursorT = setTimeout(() => this.hideCursor(), 140);
          }
        }
        showCursor() {
          if (!this.pointing) {
            // appears on the pointer, never flies in from where it faded out
            const [tx, ty] = this.cursorTarget();
            if (!this.cursorShown() || Math.hypot(tx - this.kx, ty - this.ky) > 48) this.placeCursor();
            this.pointing = true;
            this.inner.classList.add('is-pointing');
          }
          this.cursorMoving = true;
          this.kick();
        }
        hideCursor() {
          clearTimeout(this.cursorT);
          if (!this.pointing) return;
          this.pointing = false;
          this.cursorOff = performance.now();
          this.inner.classList.remove('is-pointing');
          this.cursorMoving = true;
          this.kick();
        }
        // shown, or still fading out (opacity runs 200 ms)
        cursorShown() {
          return !!this.pointing || performance.now() - (this.cursorOff || 0) < 260;
        }
        cursorTarget() {
          const r = this.inner.getBoundingClientRect();
          return [(this.cx ?? 0) - r.left + 14, (this.cy ?? 0) - r.top + 14];
        }
        placeCursor() {
          if (!this.cursor || this.cx == null) return;
          [this.kx, this.ky] = this.cursorTarget();
          this.cursor.style.translate = `${this.kx}px ${this.ky}px`;
        }
        moveCursor(dt) {
          // soft follow while shown and while fading out; once hidden, move() keeps it on the pointer
          if (!this.cursor || !this.cursorShown()) return (this.cursorMoving = false);
          const [tx, ty] = this.cursorTarget();
          if (this.kx == null) [this.kx, this.ky] = [tx, ty];
          const a = this.motion ? 1 - Math.exp(-dt * 34) : 1;
          this.kx += (tx - this.kx) * a;
          this.ky += (ty - this.ky) * a;
          this.cursor.style.translate = `${this.kx}px ${this.ky}px`;
        }
        zoom(dir) {
          const zi = Math.max(0, Math.min(this.zooms.length - 1, this.zi + dir));
          if (zi === this.zi) return;
          this.zi = zi;
          this.zt = this.zooms[zi];
          this.querySelectorAll('[data-zoom]').forEach((b) => (b.disabled = (+b.dataset.zoom < 0 && zi === 0) || (+b.dataset.zoom > 0 && zi === this.zooms.length - 1)));
          this.kick();
        }

        // ---------- panel ----------
        openCell(cell, instant) {
          const i = this.idxAt(cell.c, cell.r);
          this.active = cell;
          const first = !this.inner.classList.contains('is-open');
          this.render(i, !first);
          this.panel.hidden = false;
          void this.panel.offsetWidth;
          this.inner.classList.remove('is-closing');
          this.inner.classList.add('is-open');
          this.hover(null);
          const phone = this.inner.clientWidth < 750;
          const off = phone ? { x: 0, y: -(this.panel.offsetHeight - (this.m.vh - this.panel.offsetHeight)) / 2 } : { x: -this.panel.offsetWidth / 2, y: 0 };
          // on phones the tile sits in the strip above the sheet (or just behind it)
          if (phone) off.y = Math.max(off.y, -this.m.vh / 2 + this.m.h * this.z * 0.6);
          this.goTo(cell, off.x, off.y);
          if (instant || !this.motion) {
            this.cam.x = this.tgt.x;
            this.cam.y = this.tgt.y;
          }
          this.paint(true);
          if (first) {
            this.opener = document.activeElement;
            this.panel.querySelector('[data-title]').focus({ preventScroll: true });
          }
          if (this.d.deep) {
            const hash = '#' + this.P[i].h;
            if (location.hash !== hash) {
              if (first && !this.pushed) {
                history.pushState({ werkPc: this.id }, '', hash);
                this.pushed = true;
              } else history.replaceState(history.state, '', hash);
            }
          }
        }
        openProduct(i, instant) {
          if (!this.list.includes(i)) this.setFilter('');
          this.openCell(this.nearest(i), instant);
        }
        step(dir) {
          if (!this.active) return;
          // the tile to the right in the pattern is the next product
          this.openCell({ c: this.active.c + dir, r: this.active.r });
        }
        close(fromHistory) {
          if (!this.active) return;
          this.active = null;
          this.inner.classList.add('is-closing');
          this.inner.classList.remove('is-open');
          this.paint(true);
          clearTimeout(this.tm);
          this.tm = setTimeout(() => {
            if (!this.active) {
              this.panel.hidden = true;
              this.inner.classList.remove('is-closing');
            }
          }, this.motion ? 420 : 0);
          if (this.d.deep && !fromHistory) {
            if (this.pushed) history.back();
            else if (location.hash) history.replaceState(history.state, '', location.pathname + location.search);
          }
          this.pushed = false;
          (this.opener && this.opener !== document.body ? this.opener : this.inner).focus?.({ preventScroll: true });
        }
        fromHash(pop) {
          if (!this.d.deep) return;
          const h = decodeURIComponent(location.hash.slice(1));
          const i = h ? this.P.findIndex((p) => p.h === h) : -1;
          if (i > -1) {
            if (!this.active || this.P[this.idxAt(this.active.c, this.active.r)].h !== h) {
              this.pushed = false;
              this.openProduct(i, !pop);
              if (!pop) this.scrollIntoView({ block: 'start' });
            }
          } else if (this.active && pop) {
            this.pushed = false;
            this.close(true);
          }
        }

        render(i, swap) {
          const p = this.P[i];
          this.p = p;
          this.qty = 1;
          const n = this.list.length;
          const pos = this.list.indexOf(i);
          const fill = () => {
            const $ = (s) => this.panel.querySelector(s);
            this.setCounter($('[data-count]'), `${String(pos + 1).padStart(2, '0')} / ${String(n).padStart(2, '0')}`);
            this.panel.querySelectorAll('[data-step]').forEach((b) => (b.disabled = n < 2));
            const kick = this.d.kicker === 'vendor' ? p.ve : this.d.kicker === 'type' ? p.ty : '';
            $('[data-kicker]').textContent = kick || '';
            $('[data-title]').textContent = p.t;
            const desc = $('[data-desc]');
            if (desc) desc.textContent = p.d || '';
            const det = $('[data-details]');
            if (det) {
              det.hidden = !p.u;
              det.href = p.u || '#';
            }
            // pictures
            this.photos = p.m.length ? p.m : p.img ? [{ id: 0, s: p.img, a: p.t }] : [];
            // the panel starts with the picture the tile shows (e.g. an own tile picture that is also a product picture)
            const file = (u) => String(u || '').split('?')[0].split('/').pop();
            this.first = Math.max(0, this.photos.findIndex((m) => file(m.s) === file(p.img)));
            const th = $('[data-thumbs]');
            th.innerHTML =
              this.d.gallery && this.photos.length > 1
                ? this.photos.map((m, k) => `<button type="button" class="werk-product-canvas_thumb" data-thumb="${k}" aria-label="${this.esc(this.fill(this.t.picture, { n: k + 1, total: this.photos.length }))}"><img src="${this.esc(this.src(m.s, 120))}" alt="" loading="lazy"></button>`).join('')
                : '';
            // options
            this.sel = (p.v.find((v) => v.id === p.sel) || p.v.find((v) => v.a) || p.v[0]).o.slice();
            $('[data-options]').innerHTML = p.o
              .map(
                (o, k) =>
                  `<fieldset class="werk-product-canvas_option"><legend class="werk-product-canvas_option-label">${this.esc(o.n)} <b data-opt-now="${k}"></b></legend><div class="werk-product-canvas_values" role="radiogroup" aria-label="${this.esc(o.n)}">` +
                  o.v
                    .map((v) => {
                      const sw = v.i ? `url('${this.esc(v.i)}')` : v.c || '';
                      return `<button type="button" role="radio" class="werk-product-canvas_value${sw ? ' has-swatch' : ''}" data-opt="${k}" data-value="${this.esc(v.n)}" aria-checked="false">${sw ? `<span class="werk-product-canvas_swatch" style="--c: ${this.esc(sw)}"></span>` : ''}<span>${this.esc(v.n)}</span></button>`;
                    })
                    .join('') +
                  '</div></fieldset>'
              )
              .join('');
            this.update(true);
            this.panel.querySelector('[data-scroll]').scrollTop = 0;
          };
          if (swap && this.motion) {
            this.scroll.classList.add('is-swap');
            clearTimeout(this.swapP);
            this.swapP = setTimeout(() => {
              fill();
              void this.scroll.offsetWidth;
              this.scroll.classList.remove('is-swap');
            }, 200);
          } else fill();
        }
        variant() {
          const p = this.p;
          return p.v.find((v) => v.o.every((x, k) => x === this.sel[k])) || null;
        }
        pick(k, value) {
          this.sel[k] = value;
          this.update(false);
        }
        // a value is crossed out when no available variant has it together with the other picks
        update(first) {
          const p = this.p;
          const v = this.variant();
          this.panel.querySelectorAll('[data-value]').forEach((b) => {
            const k = +b.dataset.opt;
            const on = this.sel[k] === b.dataset.value;
            b.setAttribute('aria-checked', String(on));
            const ok = p.v.some((x) => x.a && x.o[k] === b.dataset.value && x.o.every((y, j) => j === k || y === this.sel[j]));
            b.classList.toggle('is-out', !ok);
          });
          this.panel.querySelectorAll('[data-opt-now]').forEach((b) => (b.textContent = this.sel[+b.dataset.optNow] || ''));
          const price = v ? v.p : p.p;
          const cp = v && v.cp > v.p ? `<s>${this.esc(this.money(v.cp))}</s>` : '';
          this.panel.querySelector('[data-price]').innerHTML = `<span>${this.esc(this.money(price))}</span>${cp}`;
          const btn = this.addBtn;
          const label = this.panel.querySelector('[data-add-label]');
          btn.disabled = !v || !v.a;
          label.textContent = !v ? this.fill(this.t.choose, { option: (p.o.find((o, k) => !this.sel[k]) || p.o[0] || {}).n || '' }) : v.a ? this.t.add : this.t.soldOut;
          this.setQty(this.qty);
          this.panel.querySelector('[data-error]').hidden = true;
          // the variant's own picture, otherwise the first
          let k = first ? this.first || 0 : this.photo;
          if (v && v.mi) k = Math.max(0, this.photos.findIndex((m) => m.id === v.mi));
          if (first || k !== this.photo) this.showPhoto(k, first);
        }
        setQty(n) {
          this.qty = Math.max(1, Math.min(99, n));
          const out = this.panel.querySelector('[data-qty-n]');
          if (out) out.textContent = this.qty;
          const minus = this.panel.querySelector('[data-qty="-1"]');
          if (minus) minus.disabled = this.qty === 1;
          const v = this.variant();
          this.panel.querySelector('[data-add-price]').textContent = v ? this.money(v.p * this.qty) : '';
        }
        // counter text that ticks in when it changes
        setCounter(el, text) {
          if (!el || el.textContent === text) return;
          el.textContent = '';
          if (!text) return;
          const s = document.createElement('span');
          s.className = 'werk-product-canvas_tick';
          s.textContent = text;
          el.append(s);
        }
        // ---------- photo swipe (touch only) ----------
        // the big picture follows the finger; past ~50 px or a quick flick it turns to the next / previous photo,
        // otherwise it springs back. Rubber band at the first and last photo. Vertical moves stay the sheet's scroll.
        swipe(e) {
          if (e.pointerType === 'mouse' || !this.active || (this.photos?.length || 0) < 2 || e.target.closest('[data-thumbs]')) return;
          const ph = e.currentTarget;
          const img = ph.querySelector('[data-photo-img]');
          const id = e.pointerId;
          const x0 = e.clientX;
          const y0 = e.clientY;
          let axis = '';
          let dx = 0;
          let off = 0;
          let samples = [{ t: e.timeStamp, x: x0 }];
          this.turnAnims?.forEach((a) => a.cancel());
          const ac = new AbortController();
          const o = { signal: ac.signal };
          const end = (ev, cancel) => {
            if (ev.pointerId !== id) return;
            ac.abort();
            if (axis !== 'x') return;
            const n = this.photos.length;
            // flick: speed over the last ~90 ms
            const recent = samples.filter((p) => ev.timeStamp - p.t < 90);
            const v = recent.length > 1 ? (recent[recent.length - 1].x - recent[0].x) / Math.max(1, recent[recent.length - 1].t - recent[0].t) : 0;
            const dir = cancel ? 0 : Math.abs(dx) > Math.min(56, ph.clientWidth * 0.18) || Math.abs(v) > 0.45 ? (dx < 0 ? 1 : -1) : 0;
            const k = this.photo + dir;
            if (!dir || k < 0 || k >= n) {
              img.style.translate = '';
              if (off && this.motion) this.turnAnims = [img.animate([{ translate: off + 'px 0' }, { translate: '0 0' }], { duration: 420 * this.speedF(), easing: this.easeF() })];
              return;
            }
            this.turnPhoto(k, dir, off);
          };
          addEventListener('pointermove', (ev) => {
            if (ev.pointerId !== id) return;
            dx = ev.clientX - x0;
            if (!axis && Math.hypot(dx, ev.clientY - y0) > 8) {
              axis = Math.abs(dx) > Math.abs(ev.clientY - y0) ? 'x' : 'y';
              if (axis === 'y') return ac.abort();
              ph.setPointerCapture?.(id);
            }
            if (axis !== 'x') return;
            samples.push({ t: ev.timeStamp, x: ev.clientX });
            if (samples.length > 8) samples.shift();
            const edge = (dx > 0 && this.photo === 0) || (dx < 0 && this.photo === this.photos.length - 1);
            off = edge ? dx * 0.3 : dx;
            img.style.translate = off + 'px 0';
          }, o);
          addEventListener('pointerup', (ev) => end(ev), o);
          addEventListener('pointercancel', (ev) => end(ev, true), o);
        }
        // the current photo slides out with the swipe, the next one comes in from the other side
        async turnPhoto(k, dir, from = 0) {
          const img = this.panel.querySelector('[data-photo-img]');
          img.style.translate = '';
          if (!this.motion) return this.showPhoto(k, true);
          const w = img.clientWidth;
          const out = img.animate([{ translate: from + 'px 0', opacity: 1 }, { translate: -dir * w * 0.45 + 'px 0', opacity: 0 }], { duration: 200 * this.speedF(), easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)', fill: 'forwards' });
          this.turnAnims = [out];
          await Promise.all([out.finished.catch(() => {}), this.showPhoto(k, true)]);
          if (this.turnAnims[0] !== out) return;
          out.cancel();
          this.turnAnims = [img.animate([{ translate: dir * w * 0.3 + 'px 0', opacity: 0 }, { translate: '0 0', opacity: 1 }], { duration: 520 * this.speedF(), easing: this.easeF() })];
        }
        easeF() {
          return getComputedStyle(this).getPropertyValue('--werk-ease').trim() || 'cubic-bezier(0.6234, 0.058, 0, 0.9095)';
        }
        speedF() {
          return parseFloat(getComputedStyle(this).getPropertyValue('--werk-speed')) || 1;
        }
        async showPhoto(k, instant) {
          this.photo = k;
          const m = this.photos[k];
          const img = this.panel.querySelector('[data-photo-img]');
          this.setCounter(this.panel.querySelector('[data-photo-count]'), this.photos.length > 1 ? `${k + 1} / ${this.photos.length}` : '');
          this.panel.querySelectorAll('[data-thumb]').forEach((b) => b.setAttribute('aria-current', String(+b.dataset.thumb === k)));
          if (!m) {
            img.removeAttribute('src');
            img.removeAttribute('srcset');
            img.alt = '';
            return;
          }
          const next = new Image();
          next.sizes = '(min-width: 990px) 50vw, 100vw';
          next.srcset = this.srcset(m.s, [600, 900, 1200, 1600]);
          next.src = this.src(m.s, 900);
          const token = (this.photoToken = {});
          if (!instant && this.motion && img.getAttribute('src')) {
            img.classList.add('is-fading');
            await Promise.all([next.decode().catch(() => {}), new Promise((r) => setTimeout(r, 160))]);
          } else await next.decode().catch(() => {});
          if (token !== this.photoToken) return;
          this.panel.querySelector('[data-photo]').style.setProperty('--photo-bg', `url("${this.src(m.s, 120)}")`);
          img.sizes = next.sizes;
          img.srcset = next.srcset;
          img.src = next.src;
          img.alt = m.a || this.p.t;
          img.classList.remove('is-fading');
        }

        // ---------- add to cart ----------
        async add() {
          const btn = this.addBtn;
          const v = this.variant();
          if (!v || !v.a || btn.dataset.state) return;
          const err = this.panel.querySelector('[data-error]');
          err.hidden = true;
          btn.dataset.state = 'loading';
          const done = () => {
            btn.dataset.state = 'added';
            clearTimeout(this.addTm);
            this.addTm = setTimeout(() => delete btn.dataset.state, 1600);
          };
          try {
            if (this.d.demo) {
              await new Promise((r) => setTimeout(r, 700));
              return done();
            }
            const root = window.Shopify?.routes?.root || '/';
            const items = [{ id: v.id, quantity: this.qty }];
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            const cartP = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: items.map((x) => ({ merchandiseId: x.id, quantity: x.quantity })),
              promise: cartP.then((cc) => ({ cart: { totalQuantity: cc.item_count }, detail: { itemCount: cc.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            await window.werkThemeCart(root);
            done();
            if (this.d.after === 'cart_drawer') {
              const horizon = document.querySelector('theme-drawer#cart-drawer');
              const dawn = document.querySelector('cart-drawer');
              const drawer = typeof horizon?.open === 'function' ? horizon : typeof dawn?.open === 'function' ? dawn : null;
              setTimeout(() => {
                if (drawer) {
                  this.close();
                  drawer.open(btn);
                } else location.href = this.d.cart;
              }, 700);
            }
          } catch (e) {
            delete btn.dataset.state;
            err.textContent = this.fill(this.t.error, { message: e?.description || e?.message || '' }).trim();
            err.hidden = false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-product-comparison"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-product-comparison')) {
    customElements.define(
      'werk-product-comparison',
      class extends HTMLElement {
        connectedCallback() {
          const qa = (s) => [...this.querySelectorAll(s)];
          this.inner = this.querySelector('.werk-product-comparison_inner');
          this.grid = this.querySelector('.werk-product-comparison_grid');
          this.groups = qa('.werk-product-comparison_group');
          this.panes = qa('.werk-product-comparison_pane');
          this.switches = qa('.werk-product-comparison_switch');
          this.select = this.querySelector('[data-select]');
          this.live = this.querySelector('[data-live]');
          this.k = this.shown = +this.dataset.k || 0;
          this.anims = [];
          this.speed = this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.offset();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: ac.signal });
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'keydown', (e) => this.onKey(e));
          on(this, 'submit', (e) => this.onSubmit(e));
          on(this.select, 'change', () => this.go(+this.select.value));
          // variant panel: Esc on the modal sheet animates out instead of closing hard
          this.addEventListener('cancel', (e) => {
            if (!e.target.matches?.('.werk-product-comparison_panel')) return;
            e.preventDefault();
            this.closePanel();
          }, { capture: true, signal: ac.signal });
          on(this, 'pointerdown', () => (this.ptrAt = performance.now()));
          // sheet: drag the handle / head down to close
          on(this, 'pointerdown', (e) => {
            const d = e.target.closest('.werk-product-comparison_panel');
            if (!d || !d.matches(':modal') || e.pointerType === 'mouse' || e.target.closest('button') || !e.target.closest('.werk-product-comparison_panel-handle, .werk-product-comparison_panel-head')) return;
            const y0 = e.clientY;
            let dy = 0;
            const move = (m) => { dy = Math.max(0, m.clientY - y0); d.style.translate = `0 ${dy}px`; };
            const up = () => {
              removeEventListener('pointermove', move);
              removeEventListener('pointerup', up);
              removeEventListener('pointercancel', up);
              if (dy > 80) this.closePanel();
              else d.style.translate = '';
            };
            addEventListener('pointermove', move);
            addEventListener('pointerup', up);
            addEventListener('pointercancel', up);
          });
          on(document, 'shopify:block:select', (e) => {
            if (!this.contains(e.target)) return;
            const k = e.target.dataset.k ?? e.target.closest('[data-k]')?.dataset.k;
            if (k != null) this.go(+k, { instant: true });
          });

          this.panes.forEach((p) => this.stock(p));

          this.ro = new ResizeObserver(() => {
            this.thumbs(false);
            this.fill();
            this.tight();
          });
          this.ro.observe(this);
          requestAnimationFrame(() => {
            this.thumbs(false);
            this.fill();
            this.tight();
            requestAnimationFrame(() => this.switches.forEach((s) => s.classList.add('is-ready')));
          });

          this.io = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              this.io.disconnect();
              this.classList.add('is-inview');
              // colours and other models are one click away: fetch their images now
              setTimeout(() => this.querySelectorAll('.werk-product-comparison_pane-img[loading="lazy"]').forEach((i) => (i.loading = 'eager')), 1200);
            },
            { threshold: 0, rootMargin: '0px 0px -15% 0px' }
          );
          this.io.observe(this);

          // entrance: each tile rises as it scrolls in – the ones arriving together top to bottom, left to right
          // (on a phone the tiles are one long column: revealing them all at once would play it off screen)
          if (this.speed && !window.Shopify?.designMode) {
            const items = qa('.werk-product-comparison_stage, .werk-product-comparison_group:not([hidden]) > .werk-product-comparison_tile').filter((el) => el.getClientRects().length);
            let left = items.length;
            this.classList.add('is-armed');
            this.reveal = new IntersectionObserver(
              (entries) => {
                const hits = entries.filter((en) => en.isIntersecting).map((en) => [en.target, en.boundingClientRect]);
                hits.sort(([, a], [, b]) => (Math.abs(a.top - b.top) > 8 ? a.top - b.top : a.left - b.left));
                hits.forEach(([el], i) => {
                  this.reveal.unobserve(el);
                  el.style.setProperty('--d', i * 70);
                  el.classList.add('is-in');
                });
                left -= hits.length;
                if (left <= 0) this.disarm(1600);
              },
              { threshold: 0, rootMargin: '0px 0px -12% 0px' }
            );
            items.forEach((el) => this.reveal.observe(el));
          }

          // sticky pill on mobile: visible once the switcher in the flow (head or stage) is under the header
          // and the grid is still on screen – never next to the one it stands in for
          if (this.classList.contains('has-sticky')) {
            const anchor = this.switches.find((sw) => !sw.closest('.werk-product-comparison_sticky')) || this.querySelector('.werk-product-comparison_head');
            const top = Math.round(parseFloat(this.style.getPropertyValue('--werk-offset')) || 0);
            let out = false;
            let gridIn = false;
            const set = () => this.classList.toggle('is-stuck', out && gridIn);
            this.so = new IntersectionObserver(
              (entries) => {
                for (const en of entries) {
                  if (en.target === anchor) out = !en.isIntersecting && en.boundingClientRect.top < top + 1;
                  else gridIn = en.isIntersecting;
                }
                set();
              },
              { rootMargin: `${-top}px 0px 0px 0px` }
            );
            this.so.observe(anchor);
            this.so.observe(this.grid);
          }

          // deep link: #compare=<model name>
          const m = decodeURIComponent(location.hash).match(/compare=([^&]+)/);
          if (m) {
            const name = m[1].toLowerCase().replace(/-/g, ' ');
            const opt = this.querySelector('.werk-product-comparison_option')?.parentElement;
            const all = opt ? [...opt.querySelectorAll('.werk-product-comparison_option')] : [];
            const hit = all.find((o) => o.textContent.trim().toLowerCase() === name);
            if (hit) this.go(+hit.dataset.k, { instant: true });
          }
        }

        disconnectedCallback() {
          this.ac.abort();
          this.ro.disconnect();
          this.io.disconnect();
          this.so?.disconnect();
          this.reveal?.disconnect();
          clearTimeout(this.armT);
          clearTimeout(this.paneT);
          this.anims.forEach((a) => a.cancel());
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) { bg = c; break; }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        offset() {
          const v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
          let h = v;
          if (isNaN(v)) {
            const el = document.querySelector('.shopify-section-group-header-group, header');
            h = el && /sticky|fixed/.test(getComputedStyle(el).position) ? el.offsetHeight : 0;
          }
          this.style.setProperty('--werk-offset', h + 'px');
        }

        unit() {
          const w = this.clientWidth;
          return w < 750 ? Math.min(w / 390, 1.15) : w < 990 ? Math.min(w / 768, 1.1) : Math.min(w / 1440, 1);
        }

        // animations pause in hidden tabs; never wait longer than they should take
        settle(promises, ms) {
          return Promise.race([Promise.all(promises).catch(() => {}), new Promise((r) => setTimeout(r, ms))]);
        }

        ease() {
          return getComputedStyle(this.inner).getPropertyValue('--werk-ease').trim() || 'ease';
        }

        thumbs() {
          for (const sw of this.switches) {
            const t = sw.querySelector('.werk-product-comparison_thumb');
            const o = sw.querySelector(`.werk-product-comparison_option[data-k="${this.k}"]`);
            if (!t || !o) continue;
            t.style.translate = o.offsetLeft + 'px 0';
            t.style.width = o.offsetWidth + 'px';
          }
        }

        // two columns (below 990): a tile left alone in its row – next to a full-width list, or the last one – fills the row
        fill(g = this.groups[this.shown]) {
          if (!g || !this.grid) return;
          const tiles = [...g.children].filter((el) => el.classList.contains('werk-product-comparison_tile'));
          const two = getComputedStyle(this.grid).gridTemplateColumns.split(' ').length === 2;
          const key = two + ':' + (this.clientWidth < 750);
          if (key !== g.dataset.fill) tiles.forEach((el) => el.classList.remove('is-fill'));
          g.dataset.fill = key;
          if (!two) return;
          const gw = this.grid.clientWidth;
          const boxes = tiles.map((el) => [el, el.getBoundingClientRect()]).filter(([, r]) => r.width);
          for (const [el, r] of boxes) {
            if (r.width > gw * 0.75) continue;
            if (!boxes.some(([o, q]) => o !== el && q.top < r.bottom - 1 && q.bottom > r.top + 1)) el.classList.add('is-fill');
          }
        }

        // sticky pill: drop the "X vs" label once it no longer fits
        tight() {
          const pill = this.querySelector('.werk-product-comparison_sticky-pill');
          const label = pill?.querySelector('.werk-product-comparison_sticky-label');
          if (!label) return;
          pill.classList.remove('is-tight');
          if (label.scrollWidth > label.clientWidth + 1) pill.classList.add('is-tight');
        }

        onClick(e) {
          const dlg = e.target.closest('.werk-product-comparison_panel');
          if (dlg) {
            if (e.target === dlg && dlg.matches(':modal')) {
              const r = dlg.getBoundingClientRect();
              if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) return this.closePanel();
            }
            if (e.target.closest('[data-panel-close]')) return this.closePanel();
            const pick = e.target.closest('.werk-product-comparison_opt');
            if (pick && !pick.disabled) {
              dlg._sel[pick.closest('[data-o]').dataset.o] = pick.dataset.val;
              return void this.panelSync(dlg);
            }
            if (e.target.closest('[data-panel-add]')) return this.panelAdd(dlg);
            return;
          }
          // a click anywhere else in the stage closes the panel
          if (this.openP && e.target.closest('.werk-product-comparison_stage')) return this.closePanel();
          const opt = e.target.closest('.werk-product-comparison_option');
          if (opt) return this.go(+opt.dataset.k);
          const more = e.target.closest('.werk-product-comparison_more');
          if (more) {
            const row = more.parentElement;
            const hidden = [...row.querySelectorAll('.werk-product-comparison_swatch')].filter((s) => !s.offsetParent);
            row.classList.add('is-open');
            more.setAttribute('aria-expanded', 'true');
            return hidden[0]?.focus({ preventScroll: true });
          }
          const sw = e.target.closest('.werk-product-comparison_swatch');
          if (sw) return this.swatch(sw);
        }

        onKey(e) {
          if (e.key === 'Escape' && this.openP && !this.openP.matches(':modal')) return this.closePanel();
          const opt = e.target.closest('.werk-product-comparison_option');
          if (!opt || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(e.key)) return;
          e.preventDefault();
          const list = [...opt.parentElement.querySelectorAll('.werk-product-comparison_option')];
          let i = list.indexOf(opt);
          if (e.key === 'Home') i = 0;
          else if (e.key === 'End') i = list.length - 1;
          else i = (i + (/Right|Down/.test(e.key) ? 1 : -1) + list.length) % list.length;
          this.go(+list[i].dataset.k);
          list[i].focus();
        }

        // end the entrance: every tile in place (a switch before all tiles scrolled in shows the rest at once)
        disarm(ms = 0) {
          this.reveal?.disconnect();
          clearTimeout(this.armT);
          this.armT = setTimeout(() => {
            this.classList.remove('is-armed');
            this.querySelectorAll('.is-in').forEach((el) => {
              el.classList.remove('is-in');
              el.style.removeProperty('--d');
            });
          }, ms * this.speed);
        }

        async go(k, { instant = false } = {}) {
          if (k === this.k || !this.groups[k]) return;
          if (this.openP) this.closePanel(true);
          if (this.classList.contains('is-armed')) {
            this.disarm(0);
            this.classList.remove('is-armed');
          }
          this.k = k;
          // controls + texts
          this.querySelectorAll('.werk-product-comparison_option').forEach((o) => {
            const on = +o.dataset.k === k;
            o.setAttribute('aria-checked', on);
            o.tabIndex = on && !o.closest('.werk-product-comparison_sticky') ? 0 : -1;
          });
          if (this.select) this.select.value = k;
          this.thumbs();
          this.querySelectorAll('.werk-product-comparison_head :is(.werk-product-comparison_h2, .werk-product-comparison_sub, .werk-product-comparison_head-kicker) > [data-k]').forEach((el) => {
            const was = el.hidden;
            el.hidden = +el.dataset.k !== k;
            if (was && !el.hidden && this.speed && !instant) el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 280, easing: 'ease' });
          });
          const name = this.querySelector(`.werk-product-comparison_option[data-k="${k}"]`)?.textContent.trim() || this.select?.selectedOptions[0]?.textContent;
          if (this.live && name) this.live.textContent = `${this.live.dataset.prefix} ${name}`;

          const run = (this.run = (this.run || 0) + 1);
          this.finish();
          this.pane(k, instant);
          const from = this.groups[this.shown];
          const to = this.groups[k];
          if (!this.speed || instant || from === to) {
            this.shown = k;
            return this.finish();
          }
          const u = this.unit();
          const rise = this.riseEase();
          const box = this.grid.getBoundingClientRect();
          const h0 = box.height;
          // the old tiles stay exactly where they are, lifted out of the grid, while the new ones take the grid
          const old = [...from.children].map((el) => [el, el.getBoundingClientRect()]).filter(([, r]) => r.width);
          old.forEach(([el, r]) =>
            Object.assign(el.style, {
              position: 'absolute',
              gridArea: 'auto',
              left: r.left - box.left + 'px',
              top: r.top - box.top + 'px',
              width: r.width + 'px',
              height: r.height + 'px',
              zIndex: 0,
              pointerEvents: 'none',
            })
          );
          this.ghosts = old.map(([el]) => el);
          to.hidden = false;
          this.shown = k;
          this.fill(to);
          const fresh = [...to.children].filter((el) => el.getBoundingClientRect().width);
          const h1 = this.grid.getBoundingClientRect().height;
          const a = (el, frames, o) => (this.anims.push(el.animate(frames, { fill: 'both', ...o })), this.anims[this.anims.length - 1]);
          old.forEach(([el], i) => {
            a(el, [{ opacity: 1, translate: '0 0', scale: 1 }, { opacity: 0, translate: `0 ${-14 * u}px`, scale: 0.985 }], { duration: 320, delay: i * 25, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' });
          });
          fresh.forEach((el, i) => {
            el.style.zIndex = 1;
            const d = 90 + i * 50;
            a(el, [{ opacity: 0 }, { opacity: 1 }], { duration: 420, delay: d, easing: 'cubic-bezier(0.2, 0, 0, 1)' });
            a(el, [{ translate: `0 ${28 * u}px`, scale: 0.985 }, { translate: '0 0', scale: 1 }], { duration: 760, delay: d, easing: rise });
          });
          if (Math.abs(h1 - h0) > 1) a(this.grid, [{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 520, easing: rise, fill: 'none' });
          const longest = 90 + fresh.length * 50 + 760;
          await this.settle(this.anims.map((x) => x.finished), longest + 80);
          if (run === this.run) this.finish();
        }

        // snap to the end state: one group visible, no leftover inline styles or animations
        finish() {
          this.anims.forEach((x) => x.cancel());
          this.anims = [];
          for (const el of this.ghosts || []) {
            for (const prop of ['position', 'gridArea', 'left', 'top', 'width', 'height', 'zIndex', 'pointerEvents']) el.style[prop] = '';
          }
          this.ghosts = [];
          this.groups.forEach((g, i) => {
            g.hidden = i !== this.shown;
            for (const el of g.children) el.style.zIndex = '';
          });
          this.fill();
        }

        riseEase() {
          // the signature curve starts slowly – right for slides, too hesitant for things rising in
          return this.dataset.ease === 'signature' ? 'cubic-bezier(0.16, 1, 0.3, 1)' : this.ease();
        }

        pane(k, instant) {
          if (!this.panes.length) return;
          const next = this.panes.find((p) => +p.dataset.k === k);
          const prev = this.panes.find((p) => !p.hidden && p !== next);
          if (!next) return;
          next.hidden = false;
          if (!prev) return;
          const tidy = () => this.panes.forEach((p) => {
            p.hidden = +p.dataset.k !== this.k;
            p.style.zIndex = '';
          });
          if (!this.speed || instant) return tidy();
          const ease = this.ease();
          prev.style.zIndex = 0;
          next.style.zIndex = 1;
          const img = next.querySelector('.werk-product-comparison_pane-img:not([hidden])');
          this.anims.push(next.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 420, easing: 'ease' }));
          if (img) this.anims.push(img.animate([{ scale: 0.98 }, { scale: 1 }], { duration: 620, delay: 60, easing: ease }));
          const bar = next.querySelector('.werk-product-comparison_buy');
          if (bar) this.anims.push(bar.animate([{ opacity: 0, translate: '0 8px' }, { opacity: 1, translate: '0 0' }], { duration: 420, delay: 120, easing: ease, fill: 'backwards' }));
          clearTimeout(this.paneT);
          this.paneT = setTimeout(tidy, 440);
        }

        async swatch(sw) {
          const pane = sw.closest('.werk-product-comparison_pane');
          if (!pane || sw.getAttribute('aria-pressed') === 'true') return;
          pane.querySelectorAll('.werk-product-comparison_swatch').forEach((b) => b.setAttribute('aria-pressed', b === sw));
          const name = pane.querySelector('[data-el="swatch-name"]');
          if (name) name.textContent = sw.title;
          const price = pane.querySelector('[data-el="price"]');
          if (price && sw.dataset.price) price.textContent = sw.dataset.price;
          const diff = pane.querySelector('[data-el="diff"]');
          if (diff && sw.dataset.diff) {
            diff.textContent = diff.classList.contains('werk-product-comparison_chip') ? sw.dataset.diffShort : sw.dataset.diff;
            diff.classList.toggle('is-save', 'save' in sw.dataset);
          }
          if (sw.dataset.url) pane.querySelectorAll('[data-link]').forEach((a) => (a.href = sw.dataset.url));
          const id = pane.querySelector('input[data-el="id"]');
          if (id && sw.dataset.id) id.value = sw.dataset.id;
          this.cta(pane, 'soldout' in sw.dataset);
          const v = sw.dataset.v;
          const imgs = [...pane.querySelectorAll('.werk-product-comparison_pane-img')];
          const next = imgs.find((i) => i.dataset.v === v);
          const prev = imgs.find((i) => !i.hidden && i !== next);
          if (next) {
            next.loading = 'eager';
            next.hidden = false;
            if (prev) {
              next.style.opacity = 0;
              await this.settle([next.decode()], 700);
              next.style.opacity = '';
              if (sw.getAttribute('aria-pressed') !== 'true') return void (next.hidden = true);
              if (this.speed) {
                next.style.zIndex = 1;
                const fade = next.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 380, easing: 'ease' });
                this.settle([fade.finished], 420).then(() => {
                  if (sw.getAttribute('aria-pressed') === 'true') imgs.forEach((i) => (i.hidden = i !== next));
                  next.style.zIndex = '';
                });
              } else imgs.forEach((i) => (i.hidden = i !== next));
            }
          }
        }

        async onSubmit(e) {
          const form = e.target.closest('.werk-product-comparison_form');
          if (!form) return;
          e.preventDefault();
          const btn = form.querySelector('button');
          if (btn.dataset.state || btn.disabled) return;
          if ('panel' in form.dataset) return this.openPanel(form.closest('.werk-product-comparison_pane'), form);
          this.add(form, btn);
        }

        // cart/add.js with the rolling button; false when it fell back to a normal form post
        async add(form, btn) {
          if (btn.dataset.state) return false;
          const id = form.elements.id?.value;
          if (!id) return void (location.href = form.dataset.fallback || '/');
          const root = window.Shopify?.routes?.root || '/';
          btn.dataset.state = 'loading';
          try {
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }),
            });
            if (!res.ok) throw new Error(res.status);
            btn.dataset.state = 'added';
            const cart = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: id, quantity: 1 }],
              promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart(root);
            setTimeout(() => delete btn.dataset.state, 2400);
            return true;
          } catch {
            delete btn.dataset.state;
            form.submit();
            return false;
          }
        }

        // ---------- variant panel ----------
        // with a panel, a colour is sold out only when no size of it is left
        stock(pane) {
          const dlg = pane.querySelector('.werk-product-comparison_panel');
          if (!dlg) return;
          const si = +dlg.dataset.stage;
          const vs = this.variants(pane);
          pane.querySelectorAll('.werk-product-comparison_swatch').forEach((sw) => sw.toggleAttribute('data-soldout', !vs.some((v) => v.a && (si < 0 || v.o[si] === sw.title))));
          const cur = pane.querySelector('.werk-product-comparison_swatch[aria-pressed="true"]');
          this.cta(pane, cur ? cur.hasAttribute('data-soldout') : !vs.some((v) => v.a));
        }

        cta(pane, sold) {
          const cta = pane.querySelector('[data-cta]');
          if (!cta) return;
          cta.disabled = sold;
          const label = cta.querySelector('[data-cta-label]');
          if (label) label.textContent = sold ? cta.dataset.sold : cta.dataset.add;
        }

        variants(pane) {
          if (!pane._v) {
            try {
              pane._v = JSON.parse(pane.querySelector('[data-variants]')?.textContent || '[]');
            } catch {
              pane._v = [];
            }
          }
          return pane._v;
        }

        panelVariant(dlg) {
          const si = +dlg.dataset.stage;
          const groups = [...dlg.querySelectorAll('[data-o]')];
          if (groups.some((g) => dlg._sel[g.dataset.o] == null)) return null;
          return this.variants(dlg.closest('.werk-product-comparison_pane')).find((v) => (si < 0 || v.o[si] === dlg._sv) && groups.every((g) => v.o[+g.dataset.o] === dlg._sel[g.dataset.o])) || null;
        }

        // availability per value (given the colour and what is already chosen), price and button
        panelSync(dlg, auto = false) {
          const pane = dlg.closest('.werk-product-comparison_pane');
          const si = +dlg.dataset.stage;
          const vs = this.variants(pane).filter((v) => si < 0 || v.o[si] === dlg._sv);
          const groups = [...dlg.querySelectorAll('[data-o]')];
          const fits = (v, skip) => groups.every((g) => g.dataset.o === skip || dlg._sel[g.dataset.o] == null || v.o[+g.dataset.o] === dlg._sel[g.dataset.o]);
          for (let pass = 0; pass < 2; pass++) {
            for (const g of groups) {
              const o = g.dataset.o;
              const btns = [...g.querySelectorAll('.werk-product-comparison_opt')];
              for (const b of btns) b.disabled = !vs.some((v) => v.a && v.o[+o] === b.dataset.val && fits(v, o));
              if (dlg._sel[o] != null && btns.find((b) => b.dataset.val === dlg._sel[o])?.disabled) delete dlg._sel[o];
              const open = btns.filter((b) => !b.disabled);
              if (auto && dlg._sel[o] == null && open.length === 1) dlg._sel[o] = open[0].dataset.val;
              btns.forEach((b) => b.setAttribute('aria-pressed', b.dataset.val === dlg._sel[o]));
            }
          }
          const v = this.panelVariant(dlg);
          const btn = dlg.querySelector('[data-panel-add]');
          const missing = groups.find((g) => dlg._sel[g.dataset.o] == null);
          btn.disabled = !v || !v.a;
          btn.querySelector('[data-cta-label]').textContent = v ? pane.querySelector('[data-cta]')?.dataset.add || '' : missing?.dataset.choose || '';
          if (v) {
            dlg.querySelector('[data-el="panel-price"]').textContent = v.p;
            const d = dlg.querySelector('[data-el="panel-diff"]');
            d.textContent = v.d;
            d.classList.toggle('is-save', v.s);
          }
          return v;
        }

        openPanel(pane, form) {
          const dlg = pane.querySelector('.werk-product-comparison_panel');
          if (!dlg) return this.add(form, form.querySelector('button'));
          const si = +dlg.dataset.stage;
          const sw = pane.querySelector('.werk-product-comparison_swatch[aria-pressed="true"]');
          dlg._sv = si > -1 && sw ? sw.title : null;
          dlg._sel = {};
          // start from what the bar shows for the chosen colour
          dlg.querySelector('[data-el="panel-price"]').textContent = pane.querySelector('[data-el="price"]')?.textContent || '';
          const d = dlg.querySelector('[data-el="panel-diff"]');
          d.textContent = sw?.dataset.diff || pane.querySelector('[data-el="diff"]')?.textContent || '';
          d.classList.toggle('is-save', sw ? 'save' in sw.dataset : false);
          const v = this.panelSync(dlg, true);
          // nothing left to choose (one size only): straight into the cart
          if (v && [...dlg.querySelectorAll('[data-o]')].every((g) => g.querySelectorAll('.werk-product-comparison_opt:not(:disabled)').length === 1)) {
            form.elements.id.value = v.id;
            return this.add(form, form.querySelector('button'));
          }
          const sel = dlg.querySelector('[data-el="panel-sel"]');
          if (sel) sel.textContent = dlg._sv ? ' · ' + dlg._sv : '';
          const modal = this.clientWidth < 750;
          this.openP = dlg;
          if (modal) dlg.showModal();
          else dlg.show();
          pane.closest('.werk-product-comparison_stage')?.classList.toggle('has-panel', !modal);
          if (this.speed) {
            const u = this.unit();
            dlg.animate(
              modal ? [{ translate: '0 100%' }, { translate: '0 0' }] : [{ opacity: 0, translate: `0 ${16 * u}px`, scale: 0.98 }, { opacity: 1, translate: '0 0', scale: 1 }],
              { duration: modal ? 460 : 420, easing: this.riseEase() }
            );
          }
          // keyboard: straight to the first size; tap / click: focus the panel itself, so no focus ring shows
          const byPointer = performance.now() - (this.ptrAt || -1e9) < 1500;
          (byPointer ? dlg : dlg.querySelector('.werk-product-comparison_opt:not(:disabled)') || dlg.querySelector('[data-panel-close]'))?.focus({ preventScroll: true });
        }

        closePanel(instant = false) {
          const dlg = this.openP;
          if (!dlg) return;
          this.openP = null;
          const pane = dlg.closest('.werk-product-comparison_pane');
          pane.closest('.werk-product-comparison_stage')?.classList.remove('has-panel');
          const modal = dlg.matches(':modal');
          const done = () => {
            dlg.close();
            dlg.style.translate = '';
            if (!instant) pane.querySelector('.werk-product-comparison_form button')?.focus({ preventScroll: true });
          };
          if (!this.speed || instant) done();
          else {
            const u = this.unit();
            const a = dlg.animate(
              modal ? [{ translate: getComputedStyle(dlg).translate === 'none' ? '0 0' : getComputedStyle(dlg).translate }, { translate: '0 100%' }] : [{ opacity: 1 }, { opacity: 0, translate: `0 ${12 * u}px`, scale: 0.98 }],
              { duration: modal ? 320 : 240, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
            );
            this.settle([a.finished], 400).then(() => {
              done();
              a.cancel();
            });
          }
        }

        async panelAdd(dlg) {
          const v = this.panelVariant(dlg);
          const pane = dlg.closest('.werk-product-comparison_pane');
          const form = pane.querySelector('.werk-product-comparison_form');
          if (!v || !form) return;
          form.elements.id.value = v.id;
          if (!(await this.add(form, dlg.querySelector('[data-panel-add]')))) return;
          // the bar remembers what went into the cart: "✓ Added" and "White · M"
          const picked = [dlg._sv, ...[...dlg.querySelectorAll('[data-o]')].map((g) => dlg._sel[g.dataset.o])].filter(Boolean).join(' · ');
          setTimeout(() => {
            if (this.openP === dlg) this.closePanel();
            const bar = form.querySelector('button');
            bar.dataset.state = 'added';
            setTimeout(() => delete bar.dataset.state, 2400);
            const diff = pane.querySelector('[data-el="diff"]');
            if (diff) {
              diff.textContent = picked;
              diff.classList.remove('is-save');
            }
          }, 800);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-product-deck"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  // werk options · the moving parts of the option presets (src/_shared/werk-options.css). Glide: one indicator per group
  // (.werk-product-deck_opts) glides to the new choice – the leading edge first, the trailing one follows (clip-path or translate,
  // WAAPI). Ink drop: the ink floods in from the click point and drains from the old choice towards the new one; a light
  // follows the cursor on light grounds (data-opt-tone); thumbs get an ink bar along their foot. Sections set ARIA as usual – a MutationObserver picks
  // every change up, nothing else to call. werkOptions(root, prefix, signal) – once per section instance.
  window.werkOptions ||= (root, p, signal) => {
    const SEL = '[aria-checked="true"],[aria-pressed="true"],[aria-current="true"]';
    const on = (el) => el.matches(SEL);
    const preset = () => root.dataset.opt || '';
    const css = (name, fb) => getComputedStyle(root).getPropertyValue(name).trim() || fb;
    const speed = () => {
      const s = parseFloat(css('--werk-speed', '1'));
      return Number.isFinite(s) ? s : 1;
    };
    const ease = () => css('--werk-ease', 'cubic-bezier(0.6234, 0.058, 0, 0.9095)');
    const groups = () => [...root.querySelectorAll(`.${p}_opts`)];
    const items = (g) => [...g.children].filter((el) => el.classList.contains(`${p}_opt`));
    const shapeOf = (el) => ({ swatch: 'ring', thumb: 'ring', value: 'line', row: 'row' })[el.dataset.kind] || 'fill';
    const last = new WeakMap(); // group → control the indicator stands on
    const tap = new WeakMap(); // control → last pointer point inside it

    // ---------- glide ----------
    const box = (g, el) => {
      const a = g.getBoundingClientRect(), b = el.getBoundingClientRect();
      const r = { l: b.left - a.left, t: b.top - a.top, r: b.right - a.left, b: b.bottom - a.top, w: b.width, h: b.height };
      if (shapeOf(el) === 'line') r.t = r.b - 2;
      if (shapeOf(el) === 'ring') {
        const o = 4;
        Object.assign(r, { l: r.l - o, t: r.t - o, r: r.r + o, b: r.b + o, w: r.w + 2 * o, h: r.h + 2 * o });
      }
      return r;
    };
    const radius = (el) => {
      const k = shapeOf(el);
      if (k === 'line') return 1;
      const r = parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0;
      return k === 'ring' ? (el.dataset.kind === 'swatch' ? 999 : r + 4) : r;
    };
    const clip = (g, r, rad) => `inset(${r.t}px ${g.clientWidth - r.r}px ${g.clientHeight - r.b}px ${r.l}px round ${rad}px)`;
    const indOf = (g) => {
      let ind = g.querySelector(`:scope > .${p}_opt-ind`);
      if (!ind) {
        ind = document.createElement('span');
        ind.className = `${p}_opt-ind`;
        ind.setAttribute('aria-hidden', 'true');
        g.prepend(ind);
      }
      return ind;
    };
    const place = (g, el, from) => {
      const ind = indOf(g), k = shapeOf(el), b = box(g, el), rad = radius(el);
      ind.dataset.shape = k;
      ind.getAnimations().forEach((a) => a.cancel());
      if (k === 'row') ind.style.setProperty('--ind-cy', `${(b.t + b.b) / 2 - 10}px`);
      if (k === 'ring') {
        ind.style.setProperty('--ind-w', `${b.w}px`);
        ind.style.setProperty('--ind-h', `${b.h}px`);
        ind.style.setProperty('--ind-r', `${rad}px`);
        ind.style.setProperty('--ind-x', `${b.l}px`);
        ind.style.setProperty('--ind-y', `${b.t}px`);
      } else ind.style.setProperty('--ind-clip', clip(g, b, rad));
      g.classList.add('has-ind');
      if (!from || from === el || !speed()) return;
      const a = box(g, from), d = 460 * speed();
      if (k === 'ring') {
        const dx = a.l - b.l, dy = a.t - b.t;
        ind.animate(
          [{ translate: `${a.l}px ${a.t}px`, scale: '1' }, { scale: '0.86', offset: 0.45 }, { translate: `${b.l}px ${b.t}px`, scale: '1' }],
          { duration: d, easing: ease() }
        );
        return;
      }
      // leading edge first: the edge on the side of travel runs ahead, the other one follows
      const mid = {};
      for (const [lo, hi] of [['l', 'r'], ['t', 'b']]) {
        const fwd = b[lo] >= a[lo];
        const lead = fwd ? hi : lo, trail = fwd ? lo : hi;
        mid[lead] = a[lead] + (b[lead] - a[lead]) * 0.82;
        mid[trail] = a[trail] + (b[trail] - a[trail]) * 0.22;
      }
      ind.animate([{ clipPath: clip(g, a, radius(from)) }, { clipPath: clip(g, mid, rad), offset: 0.42 }, { clipPath: clip(g, b, rad) }], {
        duration: d,
        easing: ease(),
      });
    };
    const sync = (g, animate) => {
      if (preset() !== 'glide') return g.classList.remove('has-ind');
      const el = items(g).find(on);
      if (!el) return g.classList.remove('has-ind');
      place(g, el, animate ? last.get(g) : null);
      last.set(g, el);
    };

    // ---------- ink drop ----------
    const reach = (el, x, y) => Math.hypot(Math.max(x, el.offsetWidth - x), Math.max(y, el.offsetHeight - y)) + 2;
    const toward = (el, other) => {
      // the point on el's edge facing the other control
      const a = el.getBoundingClientRect(), b = other.getBoundingClientRect();
      const cx = Math.min(Math.max(b.left + b.width / 2, a.left), a.right) - a.left;
      const cy = Math.min(Math.max(b.top + b.height / 2, a.top), a.bottom) - a.top;
      return [cx, cy];
    };
    const ink = (el, open, at) => {
      if (preset() !== 'ink' || !speed() || el.dataset.kind === 'swatch') return;
      const w = el.offsetWidth, [x, y] = at || [w / 2, el.offsetHeight / 2];
      const r = reach(el, x, y);
      // thumbs: a bar along the foot runs out from the click; everything else: a circle of ink
      const [big, none] = el.dataset.kind === 'thumb'
        ? ['inset(0px 0px 0px 0px)', `inset(0px ${w - x}px 0px ${x}px)`]
        : [`circle(${r}px at ${x}px ${y}px)`, `circle(0px at ${x}px ${y}px)`];
      // bigger controls take longer, so a wide row doesn't flood in a blink
      const d = Math.min(380 + r * 1.8, 900) * (open ? 1 : 0.68) * speed();
      el.animate(
        { clipPath: open ? [none, big] : [big, none], opacity: [1, 1] },
        { pseudoElement: '::after', duration: d, easing: open ? 'cubic-bezier(0.16, 1, 0.3, 1)' : 'cubic-bezier(0.55, 0, 0.8, 0.2)' }
      );
    };

    // ---------- watch ARIA ----------
    const mo = new MutationObserver((list) => {
      const seen = new Set();
      for (const m of list) {
        const el = m.target;
        if (!el.classList?.contains(`${p}_opt`) || seen.has(el)) continue;
        seen.add(el);
        const g = el.parentElement?.classList.contains(`${p}_opts`) ? el.parentElement : null;
        if (on(el)) {
          const prev = g && last.get(g);
          if (preset() === 'ink') {
            ink(el, true, tap.get(el) || (prev && prev !== el ? toward(el, prev) : null));
            if (prev && prev !== el) ink(prev, false, toward(prev, el));
          }
          if (g) {
            if (preset() === 'glide') sync(g, true);
            else last.set(g, el);
          }
        } else if (!g) ink(el, false, tap.get(el));
        tap.delete(el);
      }
    });
    mo.observe(root, { subtree: true, attributes: true, attributeFilter: ['aria-checked', 'aria-pressed', 'aria-current'] });
    signal?.addEventListener('abort', () => mo.disconnect());

    // ---------- pointer: click point, light ----------
    const pt = (el, e) => {
      const r = el.getBoundingClientRect();
      return [e.clientX - r.left, e.clientY - r.top, r];
    };
    root.addEventListener('pointerdown', (e) => {
      const el = e.target.closest?.(`.${p}_opt`);
      if (el) tap.set(el, pt(el, e).slice(0, 2));
    }, { signal });
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    root.addEventListener('pointermove', (e) => {
      if (!fine.matches || preset() !== 'ink') return;
      const el = e.target.closest?.(`.${p}_opt`);
      if (!el) return;
      const [x, y] = pt(el, e);
      el.style.setProperty('--mx', `${x}px`);
      el.style.setProperty('--my', `${y}px`);
    }, { signal });

    // ---------- keep indicators in place ----------
    // light or dark ground from the paper colour's luminance (theme colours can be anything)
    const probe = document.createElement('i');
    probe.setAttribute('aria-hidden', 'true');
    const tone = () => {
      probe.style.cssText = 'position:absolute;width:0;height:0;color:var(--opt-paper)';
      root.append(probe);
      const [r, g, b] = (getComputedStyle(probe).color.match(/[\d.]+/g) || [255, 255, 255]).map(Number);
      probe.remove();
      const t = 0.2126 * r + 0.7152 * g + 0.0722 * b < 128 ? 'dark' : 'light';
      if (root.dataset.optTone !== t) root.dataset.optTone = t;
    };
    const all = () => {
      tone();
      groups().forEach((g) => sync(g, false));
    };
    const ro = new ResizeObserver(() => requestAnimationFrame(all));
    groups().forEach((g) => ro.observe(g));
    signal?.addEventListener('abort', () => ro.disconnect());
    const mp = new MutationObserver(all);
    mp.observe(root, { attributes: true, attributeFilter: ['data-opt', 'class', 'style'] });
    signal?.addEventListener('abort', () => mp.disconnect());
    document.fonts?.ready.then(all);
    all();
    return { refresh: all };
  };
  if (!customElements.get('werk-product-deck')) {
    const ROT = 98; // tilt of the stacked cards (past upright, so their backs show as thin plates)
    const NEAR = 0.89; // first plate: this share of the card's height (width) from the centre
    const GAP = 0.1; // every further plate
    const SHOW = 3; // plates per side, the rest fades out
    const IDLE = 3500; // ms without input before the idle hint
    const clamp = (v, a = 0, b = 1) => (v < a ? a : v > b ? b : v);
    // cubic-bezier as a function (Newton steps, bisection fallback) – snap and riffle follow the section's easing
    const bezier = (x1, y1, x2, y2) => {
      const f = (t, a, b) => ((1 - 3 * b + 3 * a) * t + (3 * b - 6 * a)) * t * t + 3 * a * t;
      const d = (t, a, b) => 3 * (1 - 3 * b + 3 * a) * t * t + 2 * (3 * b - 6 * a) * t + 3 * a;
      return (x) => {
        if (x <= 0 || x >= 1) return x <= 0 ? 0 : 1;
        let t = x;
        for (let i = 0; i < 6; i++) {
          const sl = d(t, x1, x2);
          if (Math.abs(sl) < 1e-6) break;
          t -= (f(t, x1, x2) - x) / sl;
        }
        if (t < 0 || t > 1 || Math.abs(f(t, x1, x2) - x) > 1e-4) {
          let lo = 0, hi = 1;
          for (let i = 0; i < 24; i++) {
            t = (lo + hi) / 2;
            f(t, x1, x2) < x ? (lo = t) : (hi = t);
          }
        }
        return f(t, y1, y2);
      };
    };
    // a picture URL at another width (Shopify CDN: ?width= / &width=)
    const sized = (url, w) => (/[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1' + w) : url + (url.includes('?') ? '&' : '?') + 'width=' + w);

    customElements.define(
      'werk-product-deck',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.werk-product-deck_track');
          this.stage = this.querySelector('.werk-product-deck_stage');
          this.area = this.querySelector('.werk-product-deck_area');
          this.deck = this.querySelector('.werk-product-deck_deck');
          this.dock = this.querySelector('[data-dock]');
          this.rail = this.querySelector('.werk-product-deck_rail');
          this.ticksEl = this.querySelector('.werk-product-deck_ticks');
          this.hint = this.querySelector('.werk-product-deck_hint');
          if (!this.stage || !this.deck || !this.dock) return;
          try {
            this.d = JSON.parse(this.querySelector('[data-werk]').textContent);
            this.t = JSON.parse(this.querySelector('[data-werk-t]').textContent);
          } catch {
            return;
          }
          // the chips: “All” (every product of every chip, each once) and one per chip
          const groups = (this.d.groups || []).filter((g) => g && Array.isArray(g.p));
          const chips = [...this.querySelectorAll('.werk-product-deck_chip')];
          this.sets = [];
          if (this.d.all && groups.length > 1) {
            const seen = new Set();
            this.sets.push({ key: 'all', b: '', p: groups.flatMap((g) => g.p).filter((p) => !seen.has(p.id) && seen.add(p.id)) });
          }
          groups.forEach((g, i) => this.sets.push({ key: String(i), b: g.b, p: g.p }));
          if (!chips.length && this.sets.length > 1) this.sets = [this.sets[0]];
          chips.forEach((c) => {
            const set = this.sets.find((x) => x.key === c.dataset.g);
            const n = c.querySelector('[data-count]');
            if (n) n.textContent = set ? set.p.length : '';
            if (!set || !set.p.length) c.hidden = true;
          });
          this.chips = chips;
          this.set = this.sets.find((x) => x.p.length) || this.sets[0] || { key: '0', p: [] };
          this.sel = {}; // chosen options per product, kept while the deck moves on
          this.colors = {}; // measured card colours per picture
          this.shown = -1; // the product in the info column
          this.pos = 0;
          this.nudge = 0;
          this.still = matchMedia('(prefers-reduced-motion: reduce)');
          this.fine = matchMedia('(hover: hover) and (pointer: fine)');
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          // hover / press / gliding choice of the option chips; the script builds the indicator itself (class werk-product-deck_opt-ind –
          // named here so the build keeps its styles)
          this.opts = window.werkOptions?.(this, 'werk-product-deck', ac.signal);
          // Horizon scrolls div.page-wrapper, not the window – listen to every scroll on the page
          on(document, 'scroll', () => (this.input(), this.wake(), this.queueSnap()), { capture: true, passive: true });
          on(window, 'wheel', () => (this.input(), this.stopScroll()), { passive: true });
          on(window, 'touchstart', () => ((this.touching = true), this.input(), this.stopScroll()), { passive: true });
          on(window, 'touchend', () => ((this.touching = false), this.queueSnap()), { passive: true });
          on(window, 'pointerdown', () => (this.input(), this.stopScroll()), { passive: true });
          on(window, 'pointermove', () => this.input(), { passive: true });
          on(window, 'keydown', (e) => (this.input(), ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(e.key) && this.stopScroll()), { passive: true });
          on(window, 'resize', () => this.wake(true), { passive: true });
          on(this.still, 'change', () => this.build());
          on(document, 'shopify:block:select', (e) => this.onSelect(e));
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'change', (e) => this.onChange(e));
          on(this, 'keydown', (e) => this.onKey(e));
          on(this.area, 'pointerdown', (e) => this.dragStart(e));
          on(this.area, 'pointermove', (e) => this.dragMove(e));
          on(this.area, 'pointerup', (e) => this.dragEnd(e));
          on(this.area, 'pointercancel', (e) => this.dragEnd(e, true));
          on(this.area, 'dragstart', (e) => this.drag && e.preventDefault());
          on(this.rail, 'pointerover', (e) => e.pointerType === 'mouse' && this.peek(e.target.closest('.werk-product-deck_tick')));
          on(this.rail, 'pointerleave', () => this.peek(null));
          on(this.rail, 'focusin', (e) => this.peek(e.target.closest('.werk-product-deck_tick')));
          on(this.rail, 'focusout', () => this.peek(null));
          this.io = new IntersectionObserver(([e]) => {
            this.vis = e.isIntersecting;
            this.wake(true);
            this.input();
          });
          this.io.observe(this.track);
          this.ro = new ResizeObserver(() => this.wake(true));
          this.ro.observe(this);
          document.fonts?.ready.then(() => this.isConnected && this.wake(true));
          const r = this.track.getBoundingClientRect();
          this.vis = r.bottom > 0 && r.top < innerHeight;
          this.build();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          this.ro?.disconnect();
          cancelAnimationFrame(this.raf);
          cancelAnimationFrame(this.scrollRaf);
          cancelAnimationFrame(this.riffleRaf);
          cancelAnimationFrame(this.glideRaf);
          clearTimeout(this.addTm);
          clearTimeout(this.snapTm);
          clearTimeout(this.idleTm);
          this.flyEl?.remove();
          this.running = false;
        }

        moving() {
          return this.dataset.motion === 'on' && !this.still.matches;
        }

        // ---------- the deck of the current chip ----------
        build() {
          const list = this.set.p;
          this.n = list.length;
          const m = getComputedStyle(this.querySelector('.werk-product-deck_inner')).getPropertyValue('--werk-ease').match(/cubic-bezier\(([^)]+)\)/);
          this.ease = bezier(...(m ? m[1].split(',').map(parseFloat) : [0.6234, 0.058, 0, 0.9095]));
          this.track.style.setProperty('--steps', String(Math.max(0, this.n - 1)));
          this.drag = this.dataset.control === 'drag';
          this.dpos = clamp(this.dpos || 0, 0, Math.max(0, this.n - 1));
          const arrow = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14m-5.5-5.5L19 12l-5.5 5.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          const eager = this.closest('.shopify-section')?.previousElementSibling == null;
          this.deck.innerHTML = list
            .map((p, i) => {
              const v = this.variant(p);
              const pic = p.img
                ? `<img class="werk-product-deck_img" data-src="${this.esc(sized(p.img, 800))}" data-srcset="${[400, 600, 800, 1000, 1200].map((w) => this.esc(sized(p.img, w)) + ' ' + w + 'w').join(', ')}" sizes="(min-width: 990px) 420px, 280px" alt="${this.esc(p.alt || p.t)}" width="1000" height="${Math.round(1000 / (p.r || 0.8))}"${p.fp ? ` style="--fp: ${this.esc(p.fp)}"` : ''} loading="${eager && i < 2 ? 'eager' : 'lazy'}" draggable="false">`
                : '<svg class="werk-product-deck_ph" viewBox="0 0 100 100" aria-hidden="true"><rect x="38" y="34" width="24" height="32" rx="4"/></svg>';
              const ai = p.ai && this.t.aiLabel ? `<span class="werk-product-deck_aitag" data-pos="${this.esc(p.ai)}"><i aria-hidden="true">i</i><span>${this.esc(this.t.aiLabel)}</span></span>` : '';
              return `<li class="werk-product-deck_card" data-i="${i}"${p.b ? ` data-block="${this.esc(p.b)}"` : ''}>
                <a class="werk-product-deck_face werk-product-deck_front" href="${this.esc(p.u || '#')}" tabindex="-1" aria-label="${this.esc(p.t)}"><span class="werk-product-deck_pic">${pic}${ai}</span><span class="werk-product-deck_meta"><span class="werk-product-deck_meta-name">${this.esc(p.t)}</span><span class="werk-product-deck_meta-price">${v ? this.money(v.p) : ''}</span></span></a>
                <span class="werk-product-deck_face werk-product-deck_back" aria-hidden="true"></span>
              </li>`;
            })
            .join('');
          this.ticksEl.innerHTML = list
            .map((p, i) => `<button type="button" class="werk-product-deck_tick" data-i="${i}" aria-label="${this.esc(p.t)}"><span class="werk-product-deck_thumb" aria-hidden="true">${p.img ? `<img src="${this.esc(sized(p.img, 96))}" alt="" loading="lazy" width="32" height="40">` : ''}</span></button>`)
            .join('');
          this.cards = [...this.deck.children].map((el, i) => ({ el, front: el.querySelector('.werk-product-deck_front'), img: el.querySelector('img'), p: list[i], i, shown: false, d: null }));
          this.ticks = [...this.ticksEl.children];
          this.cards.forEach((c) => this.paint(c));
          // the info column keeps the last product until the new front card replaces it (animated after a chip change)
          this.cur = -1;
          this.measure();
          this.pos = this.read();
          this.render(this.pos);
          this.wake();
        }

        // card colour: the block's colour, one colour for all, or the picture's outer ring (a tiny copy of it)
        paint(c) {
          const p = c.p;
          const set = (col) => {
            c.col = col;
            c.el.style.setProperty('--c', col);
            c.el.style.setProperty('--cf', this.dark(col) ? '#fff' : '#1c1b1a');
            this.ticks[c.i]?.style.setProperty('--c', col);
            if (c.i === this.cur) this.style.setProperty('--card', col);
          };
          if (p.c) return set(p.c);
          if (this.d.cards === 'one' || !p.img) return;
          const key = p.img;
          if (this.colors[key]) return set(this.colors[key]);
          const im = new Image();
          im.crossOrigin = 'anonymous';
          im.decoding = 'async';
          im.onload = () => {
            try {
              const w = 24, h = Math.max(8, Math.round(24 / (p.r || 0.8)));
              const cv = document.createElement('canvas');
              cv.width = w;
              cv.height = h;
              const x = cv.getContext('2d', { willReadFrequently: true });
              x.drawImage(im, 0, 0, w, h);
              const d = x.getImageData(0, 0, w, h).data;
              let r = 0, g = 0, b = 0, a = 0, n = 0;
              for (let y = 0; y < h; y++)
                for (let i = 0; i < w; i++) {
                  if (y > 1 && y < h - 2 && i > 1 && i < w - 2) continue;
                  const k = (y * w + i) * 4;
                  r += d[k];
                  g += d[k + 1];
                  b += d[k + 2];
                  a += d[k + 3];
                  n++;
                }
              // a cut-out (transparent edge) takes the page colour
              if (a / n < 128) return;
              const col = `rgb(${Math.round(r / n)} ${Math.round(g / n)} ${Math.round(b / n)})`;
              this.colors[key] = col;
              if (this.isConnected && c.el.isConnected) set(col);
            } catch {}
          };
          im.src = sized(p.img, 48);
        }

        dark(col) {
          let h = String(col).trim();
          if (h[0] === '#') {
            h = h.slice(1);
            if (h.length < 6) h = [...h.slice(0, 3)].map((x) => x + x).join('');
            return this.dark(`rgb(${parseInt(h.slice(0, 2), 16)} ${parseInt(h.slice(2, 4), 16)} ${parseInt(h.slice(4, 6), 16)})`);
          }
          const m = h.match(/[\d.]+/g);
          if (!m || m.length < 3) return false;
          const [r, g, b] = m.map(Number);
          return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255 < 0.55;
        }

        layout() {
          const w = this.offsetWidth;
          return w >= 990 ? 'desktop' : w >= 750 ? 'tablet' : 'phone';
        }

        // a sticky / fixed theme header over the top of the screen, a fixed bar docked at the bottom (nav, cookies, chat)
        bars() {
          const skip = (hit) => this.contains(hit) || hit === document.documentElement || hit === document.body;
          let top = 0;
          for (const hit of document.elementsFromPoint(innerWidth / 2, 2)) {
            if (skip(hit)) continue;
            for (let el = hit; el && el !== document.body; el = el.parentElement) {
              const p = getComputedStyle(el).position;
              if (p !== 'fixed' && p !== 'sticky') continue;
              const r = el.getBoundingClientRect();
              if (r.top <= 2 && r.height < innerHeight * 0.3) top = Math.max(top, r.bottom);
              break;
            }
          }
          let foot = innerHeight;
          for (const x of [innerWidth / 2, innerWidth * 0.2, innerWidth * 0.8])
            for (const y of [innerHeight - 4, innerHeight - 32, innerHeight - 64])
              for (const hit of document.elementsFromPoint(x, y)) {
                if (skip(hit)) continue;
                for (let el = hit; el && el !== document.body; el = el.parentElement) {
                  if (getComputedStyle(el).position !== 'fixed') continue;
                  const r = el.getBoundingClientRect();
                  if (r.bottom >= innerHeight - 80 && r.height < innerHeight * 0.3 && r.top > innerHeight * 0.5) foot = Math.min(foot, r.top);
                  break;
                }
              }
          const set = (k, v) => {
            const val = Math.round(v) + 'px';
            if (this.style.getPropertyValue(k) !== val) this.style.setProperty(k, val);
          };
          // against the stage where it will stick, not where it is right now
          const pin = parseFloat(getComputedStyle(this.stage).top) || 0;
          set('--lift-top', top > 0 ? Math.max(0, top - pin) : 0);
          set('--lift-bottom', foot < innerHeight ? Math.max(0, pin + this.stage.offsetHeight - foot) : 0);
          this.barsAt = performance.now();
        }

        // card size: from the free room of the deck area (the stacked plates must fit above and below / left and right)
        measure() {
          this.bars();
          const mode = this.layout();
          const changed = mode !== this.lastMode;
          this.lastMode = mode;
          const lt = parseFloat(this.style.getPropertyValue('--lift-top')) || 0;
          const lb = parseFloat(this.style.getPropertyValue('--lift-bottom')) || 0;
          const W = this.area.clientWidth;
          const H = Math.max(120, this.area.clientHeight - (mode === 'phone' ? 0 : lt + lb));
          this.horiz = this.dataset.look === 'horizontal';
          let w, h;
          if (this.horiz) {
            const railRoom = mode === 'phone' ? 0 : 110;
            w = Math.min(W / (mode === 'phone' ? 1.9 : 2.45), (H - railRoom) * 0.8 * (mode === 'phone' ? 0.86 : 0.8));
            h = w / 0.8;
          } else {
            h = Math.min(H * (mode === 'phone' ? 0.42 : 0.46), 520);
            w = Math.min(h * 0.8, W * (mode === 'phone' ? 0.7 : mode === 'tablet' ? 0.54 : 0.62));
            h = w / 0.8;
          }
          this.cw = w;
          this.ch = h;
          this.cards?.forEach((c) => (c.d = null));
          this.offY = mode === 'phone' ? 0 : (lt - lb) / 2;
          const st = this.stage.style;
          st.setProperty('--cw', w.toFixed(1) + 'px');
          st.setProperty('--ch', h.toFixed(1) + 'px');
          st.setProperty('--cr', Math.round(w * 0.075) + 'px');
          st.setProperty('--cp', Math.max(6, Math.round(w * 0.04)) + 'px');
          if (changed && this.shown >= 0) this.fillDock(this.shown, false);
          this.fitDock();
        }

        // desktop & tablet, when the info column runs out of room (small laptops, long texts): first the description
        // goes, then the chips become one swipeable row, then options turn into dropdowns and the name steps down
        fitDock() {
          const d = this.dock;
          d.classList.remove('no-desc');
          this.classList.remove('is-tight');
          if (this.lastMode === 'phone' || !d.firstElementChild) return;
          const info = this.querySelector('.werk-product-deck_info');
          const over = () => info.scrollHeight > info.clientHeight + 1;
          if (!over()) return;
          d.classList.add('no-desc');
          if (!over()) return;
          this.classList.add('is-tight');
          if (!over() || this.compact || this.shown < 0) return;
          this.compact = true;
          d.firstElementChild.innerHTML = this.dockHTML(this.shown);
          this.update(this.shown);
          this.opts?.refresh();
        }

        // progress through the track: 0 … n − 1 (card f is at the front)
        read() {
          if (this.drag) return this.dpos;
          const r = this.track.getBoundingClientRect();
          const len = r.height - this.stage.offsetHeight;
          const p = len > 0 ? clamp(-r.top / len) : 0;
          return p * Math.max(0, this.n - 1);
        }
        pinned() {
          const r = this.track.getBoundingClientRect();
          // Drag: “on stage” = the section fills the middle of the screen
          if (this.drag) return r.top < innerHeight * 0.35 && r.bottom > innerHeight * 0.65;
          return r.top <= 1 && r.bottom >= this.stage.offsetHeight - 1;
        }

        // ---------- loop: only while the section is in view and something moves ----------
        wake(remeasure) {
          if (remeasure) this.dirty = true;
          else if (performance.now() - (this.barsAt || 0) > 700) {
            const a = this.style.getPropertyValue('--lift-top') + this.style.getPropertyValue('--lift-bottom');
            this.bars();
            if (a !== this.style.getPropertyValue('--lift-top') + this.style.getPropertyValue('--lift-bottom')) this.dirty = true;
          }
          if (!this.vis || this.running) return;
          this.running = true;
          this.idle = 0;
          this.last = performance.now();
          this.raf = requestAnimationFrame((t) => this.tick(t));
        }

        tick(now) {
          if (!this.isConnected) return (this.running = false);
          if (this.dirty) {
            this.dirty = false;
            this.measure();
          }
          const dt = Math.min((now - this.last) / 1000, 1 / 20);
          this.last = now;
          const goal = this.read();
          if (this.riffle != null) {
            this.render(this.riffle);
            this.raf = requestAnimationFrame((t) => this.tick(t));
            return;
          }
          if (this.drag && this.moving()) {
            // Drag: the cards follow the pointer 1:1 (the release animation does the easing)
            this.pos = goal;
          } else if (!this.moving()) {
            // reduced motion / animations off: the cards change without the flip in between
            this.pos = Math.round(goal);
          } else {
            // scroll only sets the goal; the shown value glides after it, frame-rate independent
            this.pos += (goal - this.pos) * (1 - Math.exp(-dt * 12));
            if (Math.abs(goal - this.pos) < 0.0005) this.pos = goal;
          }
          // idle hint: the next card lifts a little, twice
          let nudging = false;
          if (this.nudge0) {
            const t = (now - this.nudge0) / 1000;
            if (t < 1.6) {
              const k = t < 0.8 ? Math.sin((Math.PI * t) / 0.8) : 0.6 * Math.sin((Math.PI * (t - 0.8)) / 0.8);
              this.nudge = 0.13 * Math.max(0, k);
              nudging = true;
            } else {
              this.nudge = 0;
              this.nudge0 = 0;
            }
          }
          this.render(this.pos + this.nudge);
          this.idle = this.pos === goal && !nudging ? this.idle + 1 : 0;
          if (this.idle > 20 || !this.vis) {
            this.running = false;
            this.queueIdle();
            return;
          }
          this.raf = requestAnimationFrame((t) => this.tick(t));
        }

        // every card from its distance to the front: d = 0 faces you, |d| ≥ 1 lies tilted on the stack
        render(f) {
          const S = this.horiz ? this.cw : this.ch;
          const near = NEAR * S, gap = GAP * S;
          for (const c of this.cards) {
            const d = c.i - f;
            const ad = Math.abs(d);
            const st = c.el.style;
            if (ad > SHOW + 1.3) {
              if (c.shown) {
                c.shown = false;
                st.visibility = 'hidden';
                c.d = null;
              }
              continue;
            }
            if (!c.loaded && c.img) {
              c.loaded = true;
              c.img.srcset = c.img.dataset.srcset;
              c.img.src = c.img.dataset.src;
            }
            if (c.d === d) continue;
            c.d = d;
            const a = Math.min(ad, 1), s = Math.sign(d);
            const off = ad <= 1 ? s * near * a : s * (near + (ad - 1) * gap);
            const rot = s * ROT * a;
            const sc = 1 - 0.2 * a;
            const fade = clamp(1 - (ad - SHOW) / 1.2);
            st.transform = this.horiz
              ? `translate3d(${off.toFixed(2)}px,${this.offY.toFixed(1)}px,0) scale(${sc.toFixed(4)}) rotateY(${(-rot).toFixed(3)}deg)`
              : `translate3d(0,${(off + this.offY).toFixed(2)}px,0) scale(${sc.toFixed(4)}) rotateX(${(-rot).toFixed(3)}deg)`;
            st.opacity = fade.toFixed(3);
            st.zIndex = String(300 - Math.round(ad * 20));
            st.visibility = fade > 0.01 ? 'visible' : 'hidden';
            c.shown = fade > 0.01;
            const plate = ad >= 0.97;
            if (c.plate !== plate) c.el.classList.toggle('is-plate', (c.plate = plate));
          }
          const i = this.n ? clamp(Math.round(f), 0, this.n - 1) : -1;
          if (i !== this.cur && this.riffle == null) this.setFront(i);
        }

        setFront(i) {
          const prev = this.cards[this.cur];
          if (prev) {
            prev.el.classList.remove('is-front');
            prev.front.tabIndex = -1;
            prev.front.setAttribute('aria-label', this.t.go ? this.fill(this.t.go, { product: prev.p.t }) : prev.p.t);
          }
          this.cur = i;
          const c = this.cards[i];
          if (!c) return;
          c.el.classList.add('is-front');
          c.front.tabIndex = 0;
          c.front.setAttribute('aria-label', c.p.t);
          this.cards.forEach((x) => x !== c && x.front.getAttribute('tabindex') !== '-1' && (x.front.tabIndex = -1));
          if (c.col) this.style.setProperty('--card', c.col);
          else this.style.removeProperty('--card');
          this.ticks.forEach((t, k) => {
            t.classList.toggle('is-active', k === i);
            t.setAttribute('aria-current', String(k === i));
          });
          // the index scrolls with the front card when it holds more than fits
          const tk = this.ticks[i];
          if (tk && (this.ticksEl.scrollHeight > this.ticksEl.clientHeight + 1 || this.ticksEl.scrollWidth > this.ticksEl.clientWidth + 1)) {
            this.ticksEl.scrollTo(this.horiz ? { left: tk.offsetLeft - this.ticksEl.clientWidth / 2 + tk.offsetWidth / 2 } : { top: tk.offsetTop - this.ticksEl.clientHeight / 2 + tk.offsetHeight / 2 });
          }
          this.fillDock(i, this.shown >= 0);
        }

        // index on hover: a floating preview of the mark under the pointer (or with the keyboard focus)
        peek(tick) {
          const el = this.querySelector('.werk-product-deck_peek');
          if (!el || this.dataset.index !== 'hover') return;
          if (!tick) return el.classList.remove('is-on');
          const c = this.cards[+tick.dataset.i];
          if (!c) return;
          const pic = el.querySelector('.werk-product-deck_peek-pic');
          pic.innerHTML = c.p.img ? `<img src="${this.esc(sized(c.p.img, 120))}" alt="">` : '';
          if (c.col) pic.style.setProperty('--c', c.col);
          el.querySelector('.werk-product-deck_peek-name').textContent = c.p.t;
          const r = this.rail.getBoundingClientRect(), t = tick.getBoundingClientRect();
          el.style.setProperty('--py', `${t.top - r.top + t.height / 2}px`);
          el.style.setProperty('--px', `${t.left - r.left + t.width / 2}px`);
          el.classList.remove('is-on');
          void el.offsetWidth;
          el.classList.add('is-on');
        }

        // ---------- info column ----------
        esc(v) {
          return String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
        }
        fill(text, map) {
          return String(text || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));
        }
        money(cents) {
          const f = (n, d, ts, ds) => {
            const [i, fr] = (n / 100).toFixed(d).split('.');
            return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (fr ? ds + fr : '');
          };
          const map = {
            amount: () => f(cents, 2, ',', '.'),
            amount_no_decimals: () => f(cents, 0, ',', '.'),
            amount_with_comma_separator: () => f(cents, 2, '.', ','),
            amount_no_decimals_with_comma_separator: () => f(cents, 0, '.', ','),
            amount_with_space_separator: () => f(cents, 2, ' ', ','),
            amount_no_decimals_with_space_separator: () => f(cents, 0, ' ', ','),
            amount_with_apostrophe_separator: () => f(cents, 2, "'", '.'),
          };
          // fallback built in pieces: two curly braces in a row would be read as Liquid
          return (this.d.money || '$' + '{' + '{amount}' + '}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (map[k] || map.amount)());
        }

        product(i) {
          return this.set.p[i];
        }
        selection(p) {
          if (!this.sel[p.id]) {
            const v = p.v.find((x) => x.id === p.sel) || p.v[0];
            this.sel[p.id] = v ? [...v.o] : [];
          }
          return this.sel[p.id];
        }
        variant(p) {
          const sel = this.selection(p);
          return p.v.find((v) => v.o.every((o, k) => o === sel[k])) || null;
        }
        soldValue(p, k, value) {
          const sel = [...this.selection(p)];
          sel[k] = value;
          const v = p.v.find((x) => x.o.every((o, j) => o === sel[j]));
          return !v || !v.a;
        }

        async fillDock(i, animate) {
          const prev = this.shown;
          this.shown = i;
          const dock = this.dock;
          const speed = this.moving() && !!dock.animate;
          const token = (this.dockToken = (this.dockToken || 0) + 1);
          (this.dockAnims || []).forEach((a) => a.cancel());
          this.dockAnims = [];
          const run = (el, frames, o) => {
            const a = el.animate(frames, { fill: 'backwards', ...o });
            this.dockAnims.push(a);
            return a;
          };
          const inner0 = dock.firstElementChild;
          if (animate && speed && prev >= 0 && inner0) {
            // out: the name's words slip up out of their mask, everything else fades a touch upwards
            const words = [...inner0.querySelectorAll('.werk-product-deck_w > span')];
            const rest = [...inner0.children].filter((c) => !c.querySelector('.werk-product-deck_w'));
            const outs = [
              ...words.map((w, k) => run(w, [{ transform: 'translateY(0)' }, { transform: 'translateY(-108%)' }], { duration: 260, delay: k * 16, easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)', fill: 'forwards' })),
              ...rest.map((c) => run(c, [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-6px)' }], { duration: 200, easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)', fill: 'forwards' })),
            ];
            await Promise.all(outs.map((a) => a.finished.catch(() => {})));
            if (token !== this.dockToken) return;
            this.dockAnims.forEach((a) => a.cancel());
            this.dockAnims = [];
          }
          this.compact = false;
          dock.innerHTML = `<div class="werk-product-deck_dock-in">${this.dockHTML(i)}</div>`;
          if (i >= 0) this.update(i);
          this.fitDock();
          this.opts?.refresh();
          if (animate && speed) {
            const inner = dock.firstElementChild;
            const ease = getComputedStyle(this.querySelector('.werk-product-deck_inner')).getPropertyValue('--werk-ease').trim() || 'ease-out';
            const soft = 'cubic-bezier(0.22, 1, 0.36, 1)';
            // in: the name rises word by word out of its masks, then price, options and button
            const words = [...inner.querySelectorAll('.werk-product-deck_w > span')];
            words.forEach((w, k) => run(w, [{ transform: 'translateY(108%) rotate(3deg)' }, { transform: 'translateY(0) rotate(0deg)' }], { duration: 760, delay: 30 + k * 45, easing: ease }));
            const after = 80 + words.length * 45;
            const rest = [...inner.children].filter((c) => !c.querySelector('.werk-product-deck_w') && !c.hidden);
            const narrowPrice = inner.querySelector('.werk-product-deck_name-row [data-price]');
            if (narrowPrice) rest.unshift(narrowPrice);
            rest.forEach((c, k) => run(c, [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 680, delay: after + k * 70, easing: soft }));
          }
        }

        dockHTML(i) {
          const p = this.product(i);
          if (!p) return '';
          const mode = this.lastMode;
          const phone = mode === 'phone';
          let opts = '';
          // a product that only sells with a subscription can't be added from here: the button leads to its page
          const buy = !p.sp;
          if (buy && this.d.opts && p.o.length) {
            // phones keep chips while they fit on a line or two; long options become dropdowns (any size: more than 7 values)
            const long = this.compact || p.o.length > 2 || p.ov.some((vals) => vals.length > 7 || vals.join('').length > (phone ? 24 : 60));
            const blocks = p.o.map((name, k) => {
              const vals = p.ov[k] || [];
              if (long) return `<label class="werk-product-deck_select"><span class="werk-product-deck_option-label">${this.esc(name)}</span><select data-opt="${k}" aria-label="${this.esc(name)}">${vals.map((v) => `<option value="${this.esc(v)}">${this.esc(v)}</option>`).join('')}</select></label>`;
              return `<div class="werk-product-deck_option"><p class="werk-product-deck_option-label" id="werk-${this.id}-o${k}">${this.esc(name)}</p><div class="werk-product-deck_values werk-product-deck_opts" role="radiogroup" aria-labelledby="werk-${this.id}-o${k}">${vals.map((v) => `<button type="button" class="werk-product-deck_value werk-product-deck_opt" data-kind="chip" role="radio" aria-checked="false" data-opt="${k}" data-value="${this.esc(v)}"><span class="werk-product-deck_opt-label">${this.esc(v)}</span></button>`).join('')}</div></div>`;
            });
            const stack = phone && (p.o.length > 2 || p.o.some((name, k) => name.length + Math.max(0, ...(p.ov[k] || []).map((v) => v.length)) > 15));
            opts = long ? `<div class="werk-product-deck_selects${stack ? ' is-stack' : ''}">${blocks.join('')}</div>` : `<div class="werk-product-deck_options">${blocks.join('')}</div>`;
          }
          const arrow = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14m-5.5-5.5L19 12l-5.5 5.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          const icons = '<svg class="werk-product-deck_spin" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-opacity=".25" stroke-width="2"/><path d="M20 12a8 8 0 0 0-8-8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><svg class="werk-product-deck_check" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          const btnClass = 'werk-product-deck_btn' + (this.classList.contains('is-theme-buttons') ? ' button' : '');
          const btn = p.sp
            ? this.t.link
              ? `<a class="${btnClass}" href="${this.esc(p.u || '#')}" data-view><span class="werk-product-deck_btn-roll"><span class="werk-product-deck_btn-row"><span class="werk-product-deck_btn-dot" aria-hidden="true">${arrow}</span><span>${this.esc(this.t.link)}</span></span></span></a>`
              : ''
            : `<button type="button" class="${btnClass}" data-add><span class="werk-product-deck_btn-roll"><span class="werk-product-deck_btn-row"><span class="werk-product-deck_btn-dot" aria-hidden="true">${arrow}</span><span data-label>${this.esc(this.t.add)}</span><span class="werk-product-deck_sep" aria-hidden="true">·</span><span data-add-price></span></span><span class="werk-product-deck_btn-row" aria-hidden="true">${icons}</span><span class="werk-product-deck_btn-row" aria-hidden="true">${icons}${this.esc(this.t.added)}</span></span></button>`;
          const desc = this.d.desc && p.d && !phone ? `<p class="werk-product-deck_desc">${this.esc(p.d)}</p>` : '';
          const kicker = p.ty ? `<p class="werk-product-deck_kicker"><span>${this.esc(p.ty)}</span></p>` : '';
          const size = p.t.length > 44 || (this.compact && p.t.length > 22) ? ' is-xlong' : p.t.length > 22 || this.compact ? ' is-long' : '';
          return `${kicker}<div class="werk-product-deck_name-row"><h3 class="werk-product-deck_name${size}" aria-label="${this.esc(p.t)}">${this.words(p.t)}</h3>${phone ? '<p class="werk-product-deck_price" data-price></p>' : ''}</div>
            ${phone ? '' : '<p class="werk-product-deck_price" data-price></p>'}${desc}${opts}
            ${btn ? `<div class="werk-product-deck_actions">${btn}</div>` : ''}
            <p class="werk-product-deck_error" role="status" data-error hidden></p>`;
        }

        // a name as words in masks (the info column animates them); the heading keeps the whole name as its label
        words(text) {
          return String(text || '')
            .split(/\s+/)
            .filter(Boolean)
            .map((w) => `<span class="werk-product-deck_w" aria-hidden="true"><span>${this.esc(w)}</span></span>`)
            .join(' ');
        }

        // current choice → chips, selects, price, button, the price on the card
        update(i) {
          const p = this.product(i);
          if (!p) return;
          const sel = this.selection(p);
          const v = this.variant(p);
          this.dock.querySelectorAll('.werk-product-deck_value').forEach((b) => {
            const k = +b.dataset.opt;
            b.setAttribute('aria-checked', String(sel[k] === b.dataset.value));
            b.toggleAttribute('data-out', this.soldValue(p, k, b.dataset.value));
          });
          this.dock.querySelectorAll('select[data-opt]').forEach((s) => {
            const k = +s.dataset.opt;
            [...s.options].forEach((o) => (o.textContent = o.value + (this.soldValue(p, k, o.value) ? ' – ' + (this.t.soldOut || '') : '')));
            s.value = sel[k];
          });
          const price = v ? this.money(v.p) : '';
          this.dock.querySelectorAll('[data-price], [data-add-price]').forEach((el) => (el.textContent = price));
          const mp = this.cards[i]?.el.querySelector('.werk-product-deck_meta-price');
          if (mp && v) mp.textContent = price;
          const btn = this.dock.querySelector('[data-add]');
          if (btn) {
            const ok = !!v && v.a;
            btn.disabled = !ok;
            btn.querySelector('[data-label]').textContent = !v ? this.fill(this.t.choose, { option: p.o[0] || '' }) : ok ? this.t.add : this.t.soldOut;
            btn.querySelectorAll('.werk-product-deck_sep, [data-add-price]').forEach((el) => (el.hidden = !ok));
          }
        }

        onChange(e) {
          const s = e.target.closest('select[data-opt]');
          if (!s || this.shown < 0) return;
          const p = this.product(this.shown);
          this.selection(p)[+s.dataset.opt] = s.value;
          this.update(this.shown);
        }

        onClick(e) {
          const chip = e.target.closest('.werk-product-deck_chip');
          if (chip) return this.choose(chip);
          const val = e.target.closest('.werk-product-deck_value');
          if (val && this.shown >= 0) {
            const p = this.product(this.shown);
            this.selection(p)[+val.dataset.opt] = val.dataset.value;
            return this.update(this.shown);
          }
          if (e.target.closest('[data-add]')) return this.add(e.target.closest('[data-add]'));
          const tick = e.target.closest('.werk-product-deck_tick');
          if (tick) return this.go(+tick.dataset.i);
          // a drag that just ended is no click on a card
          if (this.dragged && performance.now() - this.dragged < 300) return e.preventDefault();
          // a card on the stack (its plate or its front) comes to the front; the front card links to the product
          const card = e.target.closest('.werk-product-deck_card');
          if (card) {
            const c = this.cards.find((x) => x.el === card);
            if (c && c.i !== this.cur) {
              e.preventDefault();
              return this.go(c.i);
            }
          }
          // demo cards and links have no product page
          const a = e.target.closest('a[href="#"]');
          if (a && this.d.demo) e.preventDefault();
        }

        onKey(e) {
          if (e.target.closest('select, input, textarea')) return;
          const k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!k || e.target.closest('.werk-product-deck_chips')) return;
          // repeated presses count from where the page is already heading
          const from = this.target ?? this.cur;
          const to = clamp(from + k, 0, this.n - 1);
          if (to === from) return;
          e.preventDefault();
          this.go(to, true);
        }

        // ---------- chips: the old deck riffles away, the new one flips in from below ----------
        choose(chip) {
          const set = this.sets.find((x) => x.key === chip.dataset.g);
          if (!set || set === this.set) return;
          this.chips.forEach((c) => c.setAttribute('aria-checked', String(c === chip)));
          cancelAnimationFrame(this.riffleRaf);
          const swap = () => {
            this.set = set;
            this.target = null;
            // back to the start of the section when the visitor is already further down
            if (this.drag) this.dpos = 0;
            else if (this.track.getBoundingClientRect().top < -1) this.jump(0);
            this.build();
          };
          if (!this.moving() || !this.vis) {
            this.riffle = null;
            return swap();
          }
          const p0 = this.pos;
          const run = Math.min(SHOW + 2, this.n - p0 + SHOW);
          const A = 420, B = 560;
          const t0 = performance.now();
          const outE = bezier(0.55, 0, 0.8, 0.2);
          const step1 = (now) => {
            const k = clamp((now - t0) / A);
            this.riffle = p0 + run * outE(k);
            this.wake();
            if (k < 1) return (this.riffleRaf = requestAnimationFrame(step1));
            this.riffle = -SHOW - 1;
            swap();
            this.riffle = -SHOW - 1;
            const t1 = performance.now();
            const step2 = (now2) => {
              const k2 = clamp((now2 - t1) / B);
              this.riffle = (-SHOW - 1) * (1 - this.ease(k2));
              this.wake();
              if (k2 < 1) return (this.riffleRaf = requestAnimationFrame(step2));
              this.riffle = null;
              this.pos = this.read();
              this.cur = -1;
              this.render(this.pos);
            };
            this.riffleRaf = requestAnimationFrame(step2);
          };
          this.riffleRaf = requestAnimationFrame(step1);
        }

        // ---------- Drag (setting): pointer and touch turn the deck, a throw carries on and settles on a card ----------
        // the pointer is only captured once the drag has started (a plain click on a card or an index mark stays a click)
        dragStart(e) {
          if (!this.drag || this.n < 2 || e.button > 0 || e.target.closest('.werk-product-deck_rail')) return;
          this.stopGlide();
          this.input();
          this.dr = { id: e.pointerId, x: e.clientX, y: e.clientY, p0: this.dpos, on: false, s: [{ t: performance.now(), p: this.dpos }] };
        }
        dragMove(e) {
          const d = this.dr;
          if (!d || e.pointerId !== d.id) return;
          const dx = e.clientX - d.x, dy = e.clientY - d.y;
          const along = this.horiz ? dx : dy, across = this.horiz ? dy : dx;
          if (!d.on) {
            if (Math.abs(along) < 6) return;
            // a move mostly across the deck is the page scrolling (touch) – let it go
            if (Math.abs(across) > Math.abs(along)) return (this.dr = null);
            d.on = true;
            this.area.setPointerCapture?.(e.pointerId);
            this.area.classList.add('is-dragging');
          }
          // one card per 0.9 × card size; past the first / last card it pulls like a rubber band
          const unit = (this.horiz ? this.cw : this.ch) * 0.9;
          let p = d.p0 - along / unit;
          const max = this.n - 1;
          if (p < 0) p = -Math.pow(-p, 0.7) * 0.35;
          else if (p > max) p = max + Math.pow(p - max, 0.7) * 0.35;
          this.dpos = p;
          const now = performance.now();
          d.s.push({ t: now, p });
          while (d.s.length > 2 && now - d.s[0].t > 100) d.s.shift();
          this.input();
          this.wake();
        }
        dragEnd(e, cancel) {
          const d = this.dr;
          if (!d || e.pointerId !== d.id) return;
          this.dr = null;
          if (!d.on) return;
          this.area.classList.remove('is-dragging');
          this.dragged = performance.now();
          // the throw: speed of the last 100 ms, a quarter second of momentum, then the nearest card
          const a = d.s[0], b = d.s[d.s.length - 1];
          const v = b.t > a.t ? (b.p - a.p) / ((b.t - a.t) / 1000) : 0;
          const to = clamp(Math.round(this.dpos + (cancel ? 0 : clamp(v, -12, 12) * 0.25)), 0, this.n - 1);
          this.glide(to);
        }
        // eases the deck to card f (Drag; index, chips, keys and the editor too)
        glide(f) {
          this.stopGlide();
          const from = this.dpos, delta = f - from;
          if (Math.abs(delta) < 0.001) return;
          const dur = this.moving() ? clamp(380 + Math.abs(delta) * 160, 380, 1000) : 0;
          if (!dur) {
            this.dpos = f;
            return this.wake();
          }
          const t0 = performance.now();
          const step = (now) => {
            const t = clamp((now - t0) / dur);
            this.dpos = from + delta * this.ease(t);
            this.wake();
            if (t < 1) this.glideRaf = requestAnimationFrame(step);
          };
          this.glideRaf = requestAnimationFrame(step);
        }
        stopGlide() {
          cancelAnimationFrame(this.glideRaf);
        }

        // ---------- scrolling: to a card, snap, idle hint ----------
        go(i, focus) {
          this.target = i;
          clearTimeout(this.targetTm);
          this.targetTm = setTimeout(() => (this.target = null), 1400);
          if (this.drag) this.glide(i);
          else this.scrollTo(i);
          if (focus) setTimeout(() => this.cards[i]?.front.focus({ preventScroll: true }), this.scrollMs || 0);
        }

        // page offset that brings card f to the front
        offset(f) {
          const r = this.track.getBoundingClientRect();
          const len = r.height - this.stage.offsetHeight;
          return (this.n > 1 ? clamp(f / (this.n - 1)) : 0) * len + r.top;
        }
        jump(f) {
          const sc = this.scroller();
          const from = sc === window ? scrollY : sc.scrollTop;
          sc.scrollTo({ top: from + this.offset(f), behavior: 'instant' });
        }
        scrollTo(f) {
          cancelAnimationFrame(this.scrollRaf);
          const sc = this.scroller();
          const from = sc === window ? scrollY : sc.scrollTop;
          const delta = this.offset(f);
          if (Math.abs(delta) < 1) return;
          const len = this.track.getBoundingClientRect().height - this.stage.offsetHeight;
          const dur = this.moving() ? clamp(440 + (Math.abs(delta) / Math.max(1, len / Math.max(1, this.n - 1))) * 260, 440, 1100) : 0;
          this.scrollMs = dur;
          // 'instant': themes with scroll-behavior: smooth (Horizon's page-wrapper) would ease every single step again
          const set = (y) => sc.scrollTo({ top: y, behavior: 'instant' });
          if (!dur) return set(from + delta);
          this.animating = true;
          const t0 = performance.now();
          const step = (now) => {
            const t = clamp((now - t0) / dur);
            set(from + delta * this.ease(t));
            if (t < 1 && this.animating) this.scrollRaf = requestAnimationFrame(step);
            else this.animating = false;
          };
          this.scrollRaf = requestAnimationFrame(step);
        }
        stopScroll() {
          if (!this.animating) return;
          cancelAnimationFrame(this.scrollRaf);
          this.animating = false;
        }
        scroller() {
          let el = this.parentElement;
          while (el && el !== document.body && el !== document.documentElement) {
            const o = getComputedStyle(el).overflowY;
            if ((o === 'auto' || o === 'scroll') && el.scrollHeight > el.clientHeight + 1) return el;
            el = el.parentElement;
          }
          return window;
        }

        // Snap: once the visitor stops scrolling inside the deck, it settles on the nearest card
        queueSnap() {
          if (this.drag) return;
          if (!this.d.snap || this.animating || this.touching || this.riffle != null) return;
          clearTimeout(this.snapTm);
          this.snapTm = setTimeout(() => this.snap(), 150);
        }
        snap() {
          if (this.animating || this.touching || !this.isConnected || this.n < 2 || !this.pinned()) return;
          const f = this.read();
          if (f <= 0 || f >= this.n - 1) return;
          const k = Math.round(f);
          if (Math.abs(f - k) > 0.004) this.scrollTo(k);
        }

        // the idle hint: after a while without input, while the deck is pinned and not at its last card
        input() {
          const now = performance.now();
          if (now - (this.inputAt || 0) < 120) return;
          this.inputAt = now;
          this.hint?.classList.remove('is-on');
          this.queueIdle();
        }
        queueIdle() {
          clearTimeout(this.idleTm);
          if (!this.d.idle || !this.moving()) return;
          this.idleTm = setTimeout(() => this.idleNudge(), IDLE);
        }
        idleNudge() {
          if (!this.isConnected || !this.vis || this.animating || this.riffle != null || !this.pinned() || this.cur >= this.n - 1 || Math.abs(this.read() - this.pos) > 0.01) return;
          this.nudge0 = performance.now();
          this.hint?.classList.add('is-on');
          this.wake();
          clearTimeout(this.idleTm);
          this.idleTm = setTimeout(() => (this.hint?.classList.remove('is-on'), this.idleNudge()), 5200);
        }

        // ---------- theme editor: a chip block shows its chip, a product block comes to the front ----------
        onSelect(e) {
          if (!this.contains(e.target)) return;
          const id = e.detail?.blockId;
          const own = this.sets.find((x) => x.key !== 'all' && x.b === id);
          if (own) {
            const chip = this.chips.find((c) => c.dataset.g === own.key);
            if (chip) this.choose(chip);
            return;
          }
          let k = this.set.p.findIndex((p) => p.b === id);
          if (k < 0) {
            const other = this.sets.find((x) => x.p.some((p) => p.b === id));
            const chip = other && this.chips.find((c) => c.dataset.g === other.key);
            if (!chip) return;
            this.choose(chip);
            k = other.p.findIndex((p) => p.b === id);
            setTimeout(() => this.go(k), 1100);
            return;
          }
          this.go(k);
        }

        // ---------- add to cart: the card flies into the theme's cart ----------
        async add(btn) {
          const i = this.shown;
          const p = this.product(i);
          const v = p && this.variant(p);
          if (!v || !v.a || btn.dataset.state) return;
          const err = this.dock.querySelector('[data-error]');
          if (err) err.hidden = true;
          btn.dataset.state = 'loading';
          const done = () => {
            btn.dataset.state = 'added';
            clearTimeout(this.addTm);
            this.addTm = setTimeout(() => delete btn.dataset.state, 1800);
            this.fly(i);
          };
          try {
            if (this.d.demo) {
              await new Promise((r) => setTimeout(r, 500));
              return done();
            }
            const root = window.Shopify?.routes?.root || '/';
            const items = [{ id: v.id, quantity: 1 }];
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            const cartP = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: items.map((x) => ({ merchandiseId: x.id, quantity: x.quantity })),
              promise: cartP.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart?.(root);
            done();
          } catch (e) {
            delete btn.dataset.state;
            if (err) {
              err.textContent = this.fill(this.t.error, { message: e?.description || e?.message || '' }).trim();
              err.hidden = false;
            }
          }
        }

        // the theme's cart icon (Horizon, Dawn and most themes), else the top right corner
        cartTarget() {
          for (const sel of ['#cart-icon-bubble', 'cart-icon', '.header__icon--cart', '[data-cart-icon]', 'header a[href$="/cart"]', 'a[href$="/cart"]']) {
            for (const el of document.querySelectorAll(sel)) {
              if (this.contains(el)) continue;
              const r = el.getBoundingClientRect();
              if (r.width && r.height && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth) return r;
            }
          }
          return { left: innerWidth - 56, top: 16, width: 32, height: 32 };
        }

        fly(i) {
          const c = this.cards[i];
          const after = this.d.after;
          const next = () => after === 'fly_next' && i === this.cur && i < this.n - 1 && this.go(i + 1);
          if (!c || after === 'none' || !this.moving() || !c.front.animate) return;
          const r = c.front.getBoundingClientRect();
          if (!r.width) return;
          const b = this.cartTarget();
          const cs = getComputedStyle(c.front);
          const pic = c.img?.currentSrc || c.img?.src || '';
          const pr = c.el.querySelector('.werk-product-deck_pic')?.getBoundingClientRect();
          // a plain copy on the page: no theme or section styles needed, removed when it has landed
          this.flyEl?.remove();
          const el = (this.flyEl = document.createElement('div'));
          el.setAttribute('aria-hidden', 'true');
          el.style.cssText = `position:fixed;left:${r.left}px;top:${r.top}px;width:${r.width}px;height:${r.height}px;z-index:2147483000;pointer-events:none;border-radius:${cs.borderTopLeftRadius};background:${cs.backgroundColor};overflow:hidden;margin:0;`;
          if (pic && pr) {
            const im = document.createElement('div');
            im.style.cssText = `position:absolute;left:${pr.left - r.left}px;top:${pr.top - r.top}px;width:${pr.width}px;height:${pr.height}px;border-radius:${getComputedStyle(c.el.querySelector('.werk-product-deck_pic')).borderTopLeftRadius};background:center/${this.classList.contains('is-contain') ? 'contain' : 'cover'} no-repeat url("${pic.replace(/"/g, '%22')}");`;
            el.append(im);
          }
          document.body.append(el);
          c.el.classList.add('is-flying');
          const dx = b.left + b.width / 2 - (r.left + r.width / 2);
          const dy = b.top + b.height / 2 - (r.top + r.height / 2);
          const a = el.animate(
            [
              { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
              { transform: `translate(${dx * 0.15}px, ${dy * 0.15 - 40}px) scale(0.82) rotate(-4deg)`, opacity: 1, offset: 0.3 },
              { transform: `translate(${dx}px, ${dy}px) scale(0.05) rotate(-12deg)`, opacity: 0.4 },
            ],
            { duration: 820, easing: 'cubic-bezier(0.6, 0, 0.2, 1)' }
          );
          const moveOn = after === 'fly_next' && i < this.n - 1;
          if (moveOn) setTimeout(next, 260);
          const end = () => {
            el.remove();
            if (this.flyEl === el) this.flyEl = null;
            c.el.classList.remove('is-flying');
            if (!moveOn) c.front.animate([{ opacity: 0, transform: 'scale(0.94)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
          };
          a.onfinish = end;
          a.oncancel = end;
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-product-finder"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  // werk options · the moving parts of the option presets (src/_shared/werk-options.css). Glide: one indicator per group
  // (.werk-product-finder_opts) glides to the new choice – the leading edge first, the trailing one follows (clip-path or translate,
  // WAAPI). Ink drop: the ink floods in from the click point and drains from the old choice towards the new one; a light
  // follows the cursor on light grounds (data-opt-tone); thumbs get an ink bar along their foot. Sections set ARIA as usual – a MutationObserver picks
  // every change up, nothing else to call. werkOptions(root, prefix, signal) – once per section instance.
  window.werkOptions ||= (root, p, signal) => {
    const SEL = '[aria-checked="true"],[aria-pressed="true"],[aria-current="true"]';
    const on = (el) => el.matches(SEL);
    const preset = () => root.dataset.opt || '';
    const css = (name, fb) => getComputedStyle(root).getPropertyValue(name).trim() || fb;
    const speed = () => {
      const s = parseFloat(css('--werk-speed', '1'));
      return Number.isFinite(s) ? s : 1;
    };
    const ease = () => css('--werk-ease', 'cubic-bezier(0.6234, 0.058, 0, 0.9095)');
    const groups = () => [...root.querySelectorAll(`.${p}_opts`)];
    const items = (g) => [...g.children].filter((el) => el.classList.contains(`${p}_opt`));
    const shapeOf = (el) => ({ swatch: 'ring', thumb: 'ring', value: 'line', row: 'row' })[el.dataset.kind] || 'fill';
    const last = new WeakMap(); // group → control the indicator stands on
    const tap = new WeakMap(); // control → last pointer point inside it

    // ---------- glide ----------
    const box = (g, el) => {
      const a = g.getBoundingClientRect(), b = el.getBoundingClientRect();
      const r = { l: b.left - a.left, t: b.top - a.top, r: b.right - a.left, b: b.bottom - a.top, w: b.width, h: b.height };
      if (shapeOf(el) === 'line') r.t = r.b - 2;
      if (shapeOf(el) === 'ring') {
        const o = 4;
        Object.assign(r, { l: r.l - o, t: r.t - o, r: r.r + o, b: r.b + o, w: r.w + 2 * o, h: r.h + 2 * o });
      }
      return r;
    };
    const radius = (el) => {
      const k = shapeOf(el);
      if (k === 'line') return 1;
      const r = parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0;
      return k === 'ring' ? (el.dataset.kind === 'swatch' ? 999 : r + 4) : r;
    };
    const clip = (g, r, rad) => `inset(${r.t}px ${g.clientWidth - r.r}px ${g.clientHeight - r.b}px ${r.l}px round ${rad}px)`;
    const indOf = (g) => {
      let ind = g.querySelector(`:scope > .${p}_opt-ind`);
      if (!ind) {
        ind = document.createElement('span');
        ind.className = `${p}_opt-ind`;
        ind.setAttribute('aria-hidden', 'true');
        g.prepend(ind);
      }
      return ind;
    };
    const place = (g, el, from) => {
      const ind = indOf(g), k = shapeOf(el), b = box(g, el), rad = radius(el);
      ind.dataset.shape = k;
      ind.getAnimations().forEach((a) => a.cancel());
      if (k === 'row') ind.style.setProperty('--ind-cy', `${(b.t + b.b) / 2 - 10}px`);
      if (k === 'ring') {
        ind.style.setProperty('--ind-w', `${b.w}px`);
        ind.style.setProperty('--ind-h', `${b.h}px`);
        ind.style.setProperty('--ind-r', `${rad}px`);
        ind.style.setProperty('--ind-x', `${b.l}px`);
        ind.style.setProperty('--ind-y', `${b.t}px`);
      } else ind.style.setProperty('--ind-clip', clip(g, b, rad));
      g.classList.add('has-ind');
      if (!from || from === el || !speed()) return;
      const a = box(g, from), d = 460 * speed();
      if (k === 'ring') {
        const dx = a.l - b.l, dy = a.t - b.t;
        ind.animate(
          [{ translate: `${a.l}px ${a.t}px`, scale: '1' }, { scale: '0.86', offset: 0.45 }, { translate: `${b.l}px ${b.t}px`, scale: '1' }],
          { duration: d, easing: ease() }
        );
        return;
      }
      // leading edge first: the edge on the side of travel runs ahead, the other one follows
      const mid = {};
      for (const [lo, hi] of [['l', 'r'], ['t', 'b']]) {
        const fwd = b[lo] >= a[lo];
        const lead = fwd ? hi : lo, trail = fwd ? lo : hi;
        mid[lead] = a[lead] + (b[lead] - a[lead]) * 0.82;
        mid[trail] = a[trail] + (b[trail] - a[trail]) * 0.22;
      }
      ind.animate([{ clipPath: clip(g, a, radius(from)) }, { clipPath: clip(g, mid, rad), offset: 0.42 }, { clipPath: clip(g, b, rad) }], {
        duration: d,
        easing: ease(),
      });
    };
    const sync = (g, animate) => {
      if (preset() !== 'glide') return g.classList.remove('has-ind');
      const el = items(g).find(on);
      if (!el) return g.classList.remove('has-ind');
      place(g, el, animate ? last.get(g) : null);
      last.set(g, el);
    };

    // ---------- ink drop ----------
    const reach = (el, x, y) => Math.hypot(Math.max(x, el.offsetWidth - x), Math.max(y, el.offsetHeight - y)) + 2;
    const toward = (el, other) => {
      // the point on el's edge facing the other control
      const a = el.getBoundingClientRect(), b = other.getBoundingClientRect();
      const cx = Math.min(Math.max(b.left + b.width / 2, a.left), a.right) - a.left;
      const cy = Math.min(Math.max(b.top + b.height / 2, a.top), a.bottom) - a.top;
      return [cx, cy];
    };
    const ink = (el, open, at) => {
      if (preset() !== 'ink' || !speed() || el.dataset.kind === 'swatch') return;
      const w = el.offsetWidth, [x, y] = at || [w / 2, el.offsetHeight / 2];
      const r = reach(el, x, y);
      // thumbs: a bar along the foot runs out from the click; everything else: a circle of ink
      const [big, none] = el.dataset.kind === 'thumb'
        ? ['inset(0px 0px 0px 0px)', `inset(0px ${w - x}px 0px ${x}px)`]
        : [`circle(${r}px at ${x}px ${y}px)`, `circle(0px at ${x}px ${y}px)`];
      // bigger controls take longer, so a wide row doesn't flood in a blink
      const d = Math.min(380 + r * 1.8, 900) * (open ? 1 : 0.68) * speed();
      el.animate(
        { clipPath: open ? [none, big] : [big, none], opacity: [1, 1] },
        { pseudoElement: '::after', duration: d, easing: open ? 'cubic-bezier(0.16, 1, 0.3, 1)' : 'cubic-bezier(0.55, 0, 0.8, 0.2)' }
      );
    };

    // ---------- watch ARIA ----------
    const mo = new MutationObserver((list) => {
      const seen = new Set();
      for (const m of list) {
        const el = m.target;
        if (!el.classList?.contains(`${p}_opt`) || seen.has(el)) continue;
        seen.add(el);
        const g = el.parentElement?.classList.contains(`${p}_opts`) ? el.parentElement : null;
        if (on(el)) {
          const prev = g && last.get(g);
          if (preset() === 'ink') {
            ink(el, true, tap.get(el) || (prev && prev !== el ? toward(el, prev) : null));
            if (prev && prev !== el) ink(prev, false, toward(prev, el));
          }
          if (g) {
            if (preset() === 'glide') sync(g, true);
            else last.set(g, el);
          }
        } else if (!g) ink(el, false, tap.get(el));
        tap.delete(el);
      }
    });
    mo.observe(root, { subtree: true, attributes: true, attributeFilter: ['aria-checked', 'aria-pressed', 'aria-current'] });
    signal?.addEventListener('abort', () => mo.disconnect());

    // ---------- pointer: click point, light ----------
    const pt = (el, e) => {
      const r = el.getBoundingClientRect();
      return [e.clientX - r.left, e.clientY - r.top, r];
    };
    root.addEventListener('pointerdown', (e) => {
      const el = e.target.closest?.(`.${p}_opt`);
      if (el) tap.set(el, pt(el, e).slice(0, 2));
    }, { signal });
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    root.addEventListener('pointermove', (e) => {
      if (!fine.matches || preset() !== 'ink') return;
      const el = e.target.closest?.(`.${p}_opt`);
      if (!el) return;
      const [x, y] = pt(el, e);
      el.style.setProperty('--mx', `${x}px`);
      el.style.setProperty('--my', `${y}px`);
    }, { signal });

    // ---------- keep indicators in place ----------
    // light or dark ground from the paper colour's luminance (theme colours can be anything)
    const probe = document.createElement('i');
    probe.setAttribute('aria-hidden', 'true');
    const tone = () => {
      probe.style.cssText = 'position:absolute;width:0;height:0;color:var(--opt-paper)';
      root.append(probe);
      const [r, g, b] = (getComputedStyle(probe).color.match(/[\d.]+/g) || [255, 255, 255]).map(Number);
      probe.remove();
      const t = 0.2126 * r + 0.7152 * g + 0.0722 * b < 128 ? 'dark' : 'light';
      if (root.dataset.optTone !== t) root.dataset.optTone = t;
    };
    const all = () => {
      tone();
      groups().forEach((g) => sync(g, false));
    };
    const ro = new ResizeObserver(() => requestAnimationFrame(all));
    groups().forEach((g) => ro.observe(g));
    signal?.addEventListener('abort', () => ro.disconnect());
    const mp = new MutationObserver(all);
    mp.observe(root, { attributes: true, attributeFilter: ['data-opt', 'class', 'style'] });
    signal?.addEventListener('abort', () => mp.disconnect());
    document.fonts?.ready.then(all);
    all();
    return { refresh: all };
  };
  if (!customElements.get('werk-product-finder')) {
    customElements.define(
      'werk-product-finder',
      class extends HTMLElement {
        connectedCallback() {
          const q = (sel) => this.querySelector(sel);
          try {
            this.d = JSON.parse(q('script[data-werk]').textContent);
          } catch {
            return;
          }
          this.t = this.d.t || {};
          this.ac = new AbortController();
          this.speed = this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.root = window.Shopify?.routes?.root || '/';
          this.design = !!(this.d.design || window.Shopify?.designMode);
          this.head = q('[data-head]');
          this.stage = q('[data-stage]');
          this.live = q('[data-live]');
          this.parse();
          this.bind();
          const key = new URLSearchParams(location.search).get(this.d.param);
          const hit = key && this.results.find((r) => r.key === key);
          if (hit) this.showResult(hit, null, true);
          else this.go(this.intro ? -1 : 0, true);
          if (this.design) this.check();
          // the intro builds up once it comes into view (in the editor and without motion it just stands)
          if (this.intro && !this.intro.hidden && this.speed && !this.design && 'IntersectionObserver' in window) {
            this.intro.classList.add('is-pre');
            this.io = new IntersectionObserver((list) => {
              if (!list.some((x) => x.isIntersecting)) return;
              this.io.disconnect();
              this.intro.classList.remove('is-pre');
              this.intro.classList.add('is-in');
            }, { threshold: 0.2 });
            this.io.observe(this.intro);
          }
          // every step has to fit the screen: measure them all, shrink the design if needed (again on resize)
          this.fit();
          document.fonts?.ready.then(() => this.isConnected && this.fit());
          let w = 0;
          this.ro = new ResizeObserver(() => {
            const nw = Math.round(this.getBoundingClientRect().width);
            if (nw === w) return;
            w = nw;
            cancelAnimationFrame(this.fitRaf);
            this.fitRaf = requestAnimationFrame(() => this.fit());
          });
          this.ro.observe(this);
          addEventListener('resize', () => { cancelAnimationFrame(this.fitRaf); this.fitRaf = requestAnimationFrame(() => this.fit()); }, { signal: this.ac.signal });
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.ro?.disconnect();
          this.io?.disconnect();
          this.outAnim?.cancel();
          cancelAnimationFrame(this.fitRaf);
          clearTimeout(this.tm);
          clearTimeout(this.copyTm);
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        // ---------- data from the markup ----------
        parse() {
          const json = (s, d) => {
            try {
              return JSON.parse(s);
            } catch {
              return d;
            }
          };
          const all = (sel, el = this) => [...el.querySelectorAll(sel)];
          this.intro = this.querySelector('[data-panel="intro"]');
          this.steps = all('[data-panel="step"]').map((el, i) => {
            const swipe = el.dataset.type === 'swipe';
            const items = swipe
              ? all('[data-card]', el).map((c) => ({ el: c, label: c.dataset.label, like: json(c.dataset.like, []), nope: json(c.dataset.nope, []), boost: c.dataset.boost === 'true', product: json(c.querySelector('script[data-product]')?.textContent, null) }))
              : all('.werk-product-finder_input', el).map((inp) => ({ el: inp, label: inp.dataset.label, pts: json(inp.dataset.points, []) }));
            const w = parseFloat(el.dataset.weight);
            const opts = el.querySelector('[data-options]');
            if (opts) opts.dataset.n = items.length;
            return { el, i, swipe, multi: el.dataset.mode === 'multi', weight: isNaN(w) ? 1 : w, name: el.dataset.name || '', heading: el.querySelector('[data-focus]')?.textContent.trim() || '', items, votes: [], block: el.dataset.block };
          });
          this.results = all('[data-panel="result"]').map((el) => ({ el, key: el.dataset.key, label: el.dataset.label || el.dataset.key, fallback: el.dataset.fallback === 'true', products: json(el.querySelector('script[data-products-json]')?.textContent, []) || [], block: el.dataset.block }));
          const total = this.querySelector('[data-total]');
          if (total) total.textContent = this.pad(this.steps.length);
          // titles rise word by word (masked lines): the words stay real text, so screen readers read them as before
          for (const h of this.querySelectorAll('.werk-product-finder_title')) {
            if (h.dataset.split) continue;
            h.dataset.split = '1';
            let k = 0;
            const walk = (node) => {
              for (const n of [...node.childNodes]) {
                if (n.nodeType === 3) {
                  const frag = document.createDocumentFragment();
                  for (const part of n.textContent.split(/(\s+)/)) {
                    if (!part) continue;
                    if (/^\s+$/.test(part)) frag.append(part);
                    else {
                      const w = document.createElement('span');
                      w.className = 'werk-product-finder_w';
                      w.innerHTML = `<span style="--k:${k++}">${this.esc(part)}</span>`;
                      frag.append(w);
                    }
                  }
                  n.replaceWith(frag);
                } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
              }
            };
            walk(h);
          }
          for (const r of this.results) {
            const box = r.el.querySelector('[data-products]');
            if (box) box.innerHTML = r.products.slice(0, this.d.max || 3).map((p, i) => this.card(p, false, i)).join('');
          }
          this.steps.filter((st) => st.swipe && st.items.length).forEach((st) => this.paint(st));
        }

        bind() {
          const o = { signal: this.ac.signal };
          // hover, press and the gliding choice come from the werk option presets (data-opt on the root); the script builds
          // the indicator itself (class werk-product-finder_opt-ind – named here so the build keeps its CSS)
          this.opts = window.werkOptions?.(this, 'werk-product-finder', this.ac.signal);
          this.addEventListener(
            'click',
            (e) => {
              const t = e.target.closest('button');
              if (!t || !this.contains(t)) return;
              if (t.matches('[data-start]')) {
                this.pub('start', {});
                this.go(0);
              } else if (t.matches('[data-next]')) this.next();
              else if (t.matches('[data-back]')) this.back();
              else if (t.matches('[data-retake]')) this.retake();
              else if (t.matches('[data-share]')) this.share(t);
              else if (t.matches('[data-vote]')) this.vote(this.steps[this.pos], +t.dataset.vote);
              else if (t.matches('[data-add]')) this.add(t);
            },
            o
          );
          this.addEventListener(
            'change',
            (e) => {
              const st = this.steps[this.pos];
              if (st && !st.swipe && st.el.contains(e.target)) {
                this.mark(st);
                this.syncNext(st);
              }
            },
            o
          );
          this.addEventListener(
            'keydown',
            (e) => {
              const deck = e.target.closest?.('[data-deck]');
              if (!deck || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
              e.preventDefault();
              this.vote(this.steps[this.pos], e.key === 'ArrowRight' ? 1 : -1);
            },
            o
          );
          this.addEventListener('pointerdown', (e) => this.drag(e), o);
          document.addEventListener(
            'shopify:block:select',
            (e) => {
              if (!this.contains(e.target)) return;
              const panel = e.target.closest('[data-panel]');
              const r = this.results.find((x) => x.el === panel);
              if (r) return this.showResult(r, null, true);
              const i = this.steps.findIndex((x) => x.el === panel);
              if (i > -1) this.go(i, true);
            },
            o
          );
        }

        // ---------- moving between steps ----------
        go(i, quiet) {
          clearTimeout(this.tm);
          if (i >= this.steps.length) return this.finish();
          if (i < 0 && !this.intro) i = 0;
          this.pos = i;
          const st = this.steps[i];
          this.show(i < 0 ? this.intro : st?.el, quiet);
          this.head.hidden = i < 0 || !st;
          this.setHead('step');
          if (!st) return;
          const n = this.steps.length;
          const back = this.querySelector('[data-back]');
          back.setAttribute('aria-disabled', i === 0 && !this.intro ? 'true' : 'false');
          this.progress(i, n, quiet === true);
          if (st.swipe) {
            if (quiet !== true && st.votes.length && st.votes.length === st.items.length) this.undo(st);
            this.paint(st);
          } else {
            this.mark(st);
            this.syncNext(st);
          }
        }

        // the hairline fills up to the step, the number rolls to the new one
        progress(i, n, quiet) {
          const fill = this.querySelector('[data-fill]');
          if (fill) fill.style.scale = `${(i + 1) / n} 1`;
          const now = this.querySelector('[data-count]');
          if (!now) return;
          const txt = this.pad(i + 1);
          if (now.dataset.n === txt) return;
          const up = !now.dataset.n || +now.dataset.n < i + 1;
          now.dataset.n = txt;
          const old = now.querySelector('span:last-child');
          const el = document.createElement('span');
          el.textContent = txt;
          now.append(el);
          if (!old || quiet || !this.speed) return old?.remove();
          const d = 520 * this.speed;
          const ease = getComputedStyle(this.querySelector('.werk-product-finder_inner')).getPropertyValue('--werk-ease').trim() || 'ease';
          old.animate([{ translate: '0 0' }, { translate: `0 ${up ? -110 : 110}%` }], { duration: d, easing: ease, fill: 'forwards' }).finished.then(() => old.remove(), () => old.remove());
          el.animate([{ translate: `0 ${up ? 110 : -110}%` }, { translate: '0 0' }], { duration: d, easing: ease });
        }

        // the chosen answers carry aria-current – the option presets draw the choice from it
        mark(st) {
          for (const it of st.items) it.el.closest('.werk-product-finder_opt')?.setAttribute('aria-current', it.el.checked ? 'true' : 'false');
          st.el.querySelector('[data-options]')?.classList.toggle('has-pick', st.items.some((x) => x.el.checked));
        }

        pad(n) {
          return String(n).padStart(2, '0');
        }

        show(panel, quiet) {
          if (!panel) return;
          const prev = [...this.querySelectorAll('[data-panel]')].find((p) => !p.hidden && p !== panel);
          this.outAnim?.cancel();
          const swap = () => {
            for (const p of this.querySelectorAll('[data-panel]')) p.hidden = p !== panel;
            panel.classList.remove('is-in');
            if (quiet === true) return;
            if (this.speed) {
              void panel.offsetWidth;
              panel.classList.add('is-in');
              // a choice made while the answers still rise was measured mid-way: put the indicator in place once they stand
              Promise.allSettled(panel.getAnimations({ subtree: true }).map((x) => x.finished)).then(() => this.isConnected && this.opts?.refresh());
            }
            panel.querySelector('[data-focus]')?.focus({ preventScroll: true });
            // the whole step in view, right below a sticky theme header
            const top = this.querySelector('.werk-product-finder_inner').getBoundingClientRect().top - this.headerH();
            const bottom = this.stage.getBoundingClientRect().bottom;
            if (top < -1 || bottom > innerHeight + 1) scrollBy({ top, behavior: this.speed ? 'smooth' : 'auto' });
          };
          // the old step leaves first – quick and small – then the new one builds up (raus schneller als rein)
          if (prev && quiet !== true && this.speed) {
            this.stage.style.minHeight = `${this.stage.offsetHeight}px`;
            this.outAnim = prev.animate([{ opacity: 1, translate: '0 0' }, { opacity: 0, translate: `0 ${-10 * this.speed}px` }], { duration: 220 * this.speed, easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)', fill: 'forwards' });
            this.outAnim.finished.then(
              () => {
                this.outAnim.cancel();
                this.outAnim = null;
                swap();
                this.stage.style.minHeight = '';
              },
              () => {}
            );
          } else swap();
        }

        // height of a fixed / sticky header at the top of the window (theme header), 0 without one
        headerH() {
          let h = 0;
          for (const el of document.elementsFromPoint(innerWidth / 2, 2)) {
            if (this.contains(el)) continue;
            for (let n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
              const cs = getComputedStyle(n);
              if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
              const r = n.getBoundingClientRect();
              if (r.top <= 2 && r.bottom > 0 && r.bottom < innerHeight * 0.4) h = Math.max(h, r.bottom);
              break;
            }
          }
          return h;
        }

        // shrink the design (--werk-fit) until the tallest panel – head, step or result with its products – fits the
        // window below the header; never below 66 % (82 % on phones), so text stays readable
        fit() {
          const inner = this.querySelector('.werk-product-finder_inner');
          const stage = this.querySelector('[data-stage]');
          if (!inner || !stage) return;
          const avail = innerHeight - this.headerH() - 8;
          this.style.setProperty('--werk-fit', '1');
          const panels = [...this.querySelectorAll('[data-panel]')];
          const hidden = panels.map((p) => p.hidden);
          const headHidden = this.head.hidden;
          const profiles = this.results.map((r) => { const pr = r.el.querySelector('[data-profile]'); return pr && [pr, pr.hidden, pr.innerHTML]; }).filter(Boolean);
          if (this.d.profile) {
            const fake = {};
            this.results.forEach((r, i) => (fake[r.key] = this.results.length - i));
            for (const [pr] of profiles) { pr.hidden = false; pr.innerHTML = this.profile(fake, this.results[0]); }
          }
          const boosted = this.d.liked ? this.steps.flatMap((st) => (st.swipe ? st.items.filter((it) => it.boost && it.product).map((it) => it.product) : [])) : [];
          const boxes = this.results.map((r) => { const b = r.el.querySelector('[data-products]'); return b && [b, b.innerHTML, r]; }).filter(Boolean);
          // the products a result can show: its own, or liked ones first (same de-duplication as showResult)
          const fill = (withLiked) => {
            for (const [b, , r] of boxes) {
              const seen = new Set();
              const list = [...(withLiked ? boosted : []), ...r.products].filter((p) => p && !seen.has(String(p.k)) && seen.add(String(p.k))).slice(0, this.d.max || 3);
              b.innerHTML = list.map((p, i) => this.card(p, withLiked && boosted.includes(p), i)).join('');
            }
          };
          this.head.hidden = false;
          // phones: the steps fit, a result with its products may scroll like any product list
          const phone = this.getBoundingClientRect().width < 750;
          const measured = panels.filter((p) => !(phone && p.dataset.panel === 'result'));
          const tallest = () => {
            const pt = parseFloat(getComputedStyle(inner).paddingTop) || 0;
            let max = 0;
            for (const withLiked of boosted.length ? [false, true] : [false]) {
              fill(withLiked);
              for (const p of measured) {
                if (withLiked && p.dataset.panel !== 'result') continue;
                panels.forEach((q) => (q.hidden = q !== p));
                max = Math.max(max, pt + stage.getBoundingClientRect().bottom - this.head.getBoundingClientRect().top);
              }
            }
            return max;
          };
          const floor = phone ? 0.82 : 0.66;
          let f = 1;
          // up to three passes: a few sizes are in px and don't shrink with the design; aim 1 % below to stay clear
          for (let pass = 0; pass < 3; pass++) {
            const max = tallest();
            if (!max || max <= avail) break;
            f = Math.min(1, Math.max(floor, (f * avail * 0.99) / max));
            this.style.setProperty('--werk-fit', f.toFixed(4));
            if (f === floor) break;
          }
          panels.forEach((p, i) => (p.hidden = hidden[i]));
          this.head.hidden = headHidden;
          for (const [pr, h, html] of profiles) { pr.hidden = h; pr.innerHTML = html; }
          for (const [b, html] of boxes) b.innerHTML = html;
          this.style.setProperty('--werk-fit', f.toFixed(4));
          this.dataset.fit = f.toFixed(2);
        }

        setHead(mode) {
          const res = mode === 'result';
          for (const el of this.head.querySelectorAll('[data-back], [data-progress-bar]')) el.hidden = res;
          for (const el of this.head.querySelectorAll('[data-retake], [data-share]')) el.hidden = !res;
        }

        syncNext(st) {
          const any = st.items.some((x) => x.el.checked);
          const btn = st.el.querySelector('[data-next]');
          if (btn) btn.disabled = !any;
          const label = st.el.querySelector('[data-next-label]');
          if (label) label.textContent = this.pos === this.steps.length - 1 ? this.t.result || this.t.next : this.t.next;
        }

        next() {
          const st = this.steps[this.pos];
          if (!st) return;
          if (!st.swipe && !st.items.some((x) => x.el.checked)) return;
          this.pub('step', { step: this.pos + 1, type: st.swipe ? 'swipe' : 'question', question: st.heading, answers: this.answers(st) });
          this.go(this.pos + 1);
        }

        back() {
          const st = this.steps[this.pos];
          if (st?.swipe && st.votes.length) return this.undo(st);
          if (this.pos > 0) this.go(this.pos - 1);
          else if (this.intro) this.go(-1);
        }

        retake() {
          for (const st of this.steps) {
            st.votes = [];
            for (const it of st.items) {
              if (st.swipe) this.reset(it.el);
              else it.el.checked = false;
            }
            if (!st.swipe) this.mark(st);
          }
          this.go(this.intro ? -1 : 0);
        }

        answers(st) {
          return st.swipe ? st.votes.map((v) => `${st.items[v.i].label}: ${v.dir > 0 ? 'like' : 'nope'}`) : st.items.filter((x) => x.el.checked).map((x) => x.label);
        }

        // ---------- swipe ----------
        paint(st) {
          const left = st.items.map((_, i) => i).filter((i) => !st.votes.some((v) => v.i === i));
          st.items.forEach((it, i) => {
            const d = left.indexOf(i);
            const el = it.el;
            el.classList.toggle('is-top', d === 0);
            el.classList.toggle('is-later', d > 2);
            if (d > -1) {
              el.classList.remove('is-out');
              el.style.transform = '';
              el.style.setProperty('--d', Math.min(d, 3));
              el.style.zIndex = 50 - d;
              el.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
            } else el.setAttribute('aria-hidden', 'true');
          });
          const done = st.el.querySelector('[data-done]');
          if (done) done.hidden = left.length > 0;
          for (const b of st.el.querySelectorAll('[data-vote]')) b.disabled = !left.length;
          const n = st.items.length;
          const cur = Math.min(n - left.length + 1, n);
          const cc = st.el.querySelector('[data-card-count]');
          if (cc) cc.innerHTML = `<b>${cur}</b><span>/ ${n}</span>`;
          const dots = st.el.querySelector('[data-dots]');
          if (dots) dots.innerHTML = st.items.map((_, i) => `<i${i === n - left.length ? ' class="is-on"' : ''}></i>`).join('');
          if (!left.length && this.steps[this.pos] === st) {
            clearTimeout(this.tm);
            this.tm = setTimeout(() => this.steps[this.pos] === st && this.next(), 700 * this.speed + 200);
          }
        }

        vote(st, dir, el) {
          if (!st?.swipe) return;
          const i = st.items.findIndex((it, k) => !st.votes.some((v) => v.i === k));
          if (i < 0) return;
          const card = st.items[i].el;
          if (el && el !== card) return;
          st.votes.push({ i, dir });
          this.say(`${st.items[i].label}: ${dir > 0 ? st.el.querySelector('.werk-product-finder_vote--like')?.getAttribute('aria-label') : st.el.querySelector('.werk-product-finder_vote--nope')?.getAttribute('aria-label')}`);
          card.classList.remove('is-drag', 'is-top');
          card.style.setProperty(dir > 0 ? '--like' : '--nope', 1);
          card.classList.add('is-out');
          if (this.speed) card.style.transform = `translate(${dir * 130}%, -4%) rotate(${dir * 18}deg)`;
          clearTimeout(this.paintTm);
          this.paintTm = setTimeout(() => this.paint(st), 180 * this.speed);
        }

        undo(st) {
          clearTimeout(this.tm);
          const v = st.votes.pop();
          if (v) this.reset(st.items[v.i].el);
          this.paint(st);
        }

        reset(el) {
          el.classList.remove('is-out', 'is-drag');
          el.style.transform = '';
          el.style.removeProperty('--like');
          el.style.removeProperty('--nope');
        }

        drag(e) {
          const card = e.target.closest?.('.werk-product-finder_card.is-top');
          if (!card || !this.contains(card) || e.button > 0) return;
          const st = this.steps[this.pos];
          if (!st?.swipe) return;
          const x0 = e.clientX;
          const y0 = e.clientY;
          const t0 = performance.now();
          let dx = 0;
          let dy = 0;
          let live = false;
          const move = (ev) => {
            if (ev.pointerId !== e.pointerId) return;
            dx = ev.clientX - x0;
            dy = ev.clientY - y0;
            if (!live) {
              if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) {
                if (Math.abs(dy) > 10) stop();
                return;
              }
              live = true;
              card.classList.add('is-drag');
              try {
                card.setPointerCapture(e.pointerId);
              } catch {}
            }
            ev.preventDefault();
            card.style.transform = `translate(${dx}px, ${dy * 0.25}px) rotate(${dx * 0.06}deg)`;
            card.style.setProperty('--like', Math.max(0, Math.min(1, dx / 100)));
            card.style.setProperty('--nope', Math.max(0, Math.min(1, -dx / 100)));
          };
          const up = (ev) => {
            if (ev.pointerId !== e.pointerId) return;
            stop();
            if (!live) return;
            const v = Math.abs(dx) / Math.max(1, performance.now() - t0);
            if (Math.abs(dx) > 110 || (Math.abs(dx) > 40 && v > 0.6)) this.vote(st, Math.sign(dx), card);
            else {
              card.classList.remove('is-drag');
              this.reset(card);
            }
          };
          const stop = () => {
            removeEventListener('pointermove', move);
            removeEventListener('pointerup', up);
            removeEventListener('pointercancel', up);
          };
          addEventListener('pointermove', move, { passive: false, signal: this.ac.signal });
          addEventListener('pointerup', up, { signal: this.ac.signal });
          addEventListener('pointercancel', up, { signal: this.ac.signal });
        }

        // ---------- scoring ----------
        caps(st) {
          const cap = {};
          for (const it of st.items) {
            for (const [k, w] of st.swipe ? it.like : it.pts) {
              if (w <= 0) continue;
              cap[k] = st.swipe || st.multi ? (cap[k] || 0) + w : Math.max(cap[k] || 0, w);
            }
          }
          return cap;
        }

        norm(st) {
          return Math.max(1, ...Object.values(this.caps(st)));
        }

        score() {
          const totals = {};
          for (const r of this.results) totals[r.key] = 0;
          const liked = [];
          for (const st of this.steps) {
            const raw = {};
            const addPts = (list) => list.forEach(([k, w]) => (raw[k] = (raw[k] || 0) + w));
            if (st.swipe) {
              for (const v of st.votes) {
                const it = st.items[v.i];
                addPts(v.dir > 0 ? it.like : it.nope);
                if (v.dir > 0 && it.boost && it.product) liked.push(it.product);
              }
            } else st.items.filter((x) => x.el.checked).forEach((x) => addPts(x.pts));
            const n = this.norm(st);
            for (const k in raw) if (k in totals) totals[k] += (raw[k] / n) * st.weight;
          }
          let win = null;
          for (const r of this.results) if (!win || totals[r.key] > totals[win.key]) win = r;
          if (!win || totals[win.key] <= 0) win = this.results.find((r) => r.fallback) || this.results[0];
          return { totals, win, liked };
        }

        finish() {
          const { totals, win, liked } = this.score();
          if (!win) return;
          const last = this.steps[this.steps.length - 1];
          if (last) this.pub('step', { step: this.steps.length, type: last.swipe ? 'swipe' : 'question', question: last.heading, answers: this.answers(last) });
          this.pub('complete', { result: win.key, title: win.el.querySelector('[data-focus]')?.textContent.trim(), scores: totals });
          this.showResult(win, totals, false, liked);
        }

        showResult(r, totals, quiet, liked = []) {
          clearTimeout(this.tm);
          this.pos = this.steps.length;
          this.current = r;
          this.show(r.el, quiet);
          this.head.hidden = false;
          this.setHead('result');
          const prof = r.el.querySelector('[data-profile]');
          if (prof) {
            prof.hidden = !(this.d.profile && totals);
            if (totals && this.d.profile) prof.innerHTML = this.profile(totals, r);
          }
          let list = [...(this.d.liked ? liked : []), ...r.products];
          const seen = new Set();
          list = list.filter((p) => p && !seen.has(String(p.k)) && seen.add(String(p.k))).slice(0, this.d.max || 3);
          const likedKeys = new Set((this.d.liked ? liked : []).map((p) => String(p.k)));
          const box = r.el.querySelector('[data-products]');
          if (box) box.innerHTML = list.map((p, i) => this.card(p, likedKeys.has(String(p.k)), i)).join('');
          const wrap = r.el.querySelector('[data-products-wrap]');
          if (wrap) wrap.hidden = !list.length && !wrap.querySelector('.werk-product-finder_link');
          if (!quiet) this.say(r.el.querySelector('[data-focus]')?.textContent.trim() || '');
        }

        profile(totals, win) {
          const rows = [...this.results].sort((a, b) => totals[b.key] - totals[a.key]);
          const max = Math.max(0.0001, ...rows.map((r) => Math.max(0, totals[r.key])));
          if (this.d.look === 'minimal') {
            const sum = rows.reduce((a, r) => a + Math.max(0, totals[r.key]), 0) || 1;
            const shade = (k) => `color-mix(in srgb, var(--werk-fg) ${Math.max(14, 100 - k * 32)}%, var(--werk-bg))`;
            const parts = rows.map((r, k) => ({ r, pc: Math.round((Math.max(0, totals[r.key]) / sum) * 100), c: shade(k) }));
            return `<div class="werk-product-finder_stack" aria-hidden="true">${parts.filter((x) => x.pc > 0).map((x) => `<i style="--w:${x.pc};--werk-c:${x.c}"></i>`).join('')}</div><p class="werk-product-finder_legend">${parts.map((x) => `<span class="werk-product-finder_legend-item"><i style="--werk-c:${x.c}"></i>${this.esc(x.r.label)} ${x.pc}%</span>`).join('')}</p>`;
          }
          // shares of the whole, not raw points – the bars grow one after another
          const sum = rows.reduce((a, r) => a + Math.max(0, totals[r.key]), 0) || 1;
          return rows
            .map((r, k) => {
              const v = Math.max(0, totals[r.key]);
              return `<div class="werk-product-finder_prow${r === win ? ' is-win' : ''}" style="--k:${k}"><span class="werk-product-finder_prow-label">${this.esc(r.label)}</span><span class="werk-product-finder_prow-track"><i style="--w:${Math.round((v / max) * 100)}%"></i></span><span class="werk-product-finder_prow-val">${Math.round((v / sum) * 100)}%</span></div>`;
            })
            .join('');
        }

        card(p, liked, i) {
          const e = (s) => this.esc(s);
          const img = p.i ? `<img class="werk-product-finder_img" src="${e(p.i)}" srcset="${e(p.s)} 400w, ${e(p.i)} 800w" sizes="(min-width: 990px) 220px, 160px" alt="" loading="lazy">` : '';
          const meta = [p.unit, this.t.tax].filter(Boolean).map(e).join(' · ');
          const bc = 'werk-product-finder_btn werk-product-finder_add' + (this.classList.contains('is-theme-buttons') ? ' button' : '');
          const dot = '<span class="werk-product-finder_btn-dot" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M5 12h14m-5.5-5.5L19 12l-5.5 5.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
          const plus = '<svg class="werk-product-finder_plus" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
          const icons = '<svg class="werk-product-finder_spin" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-opacity=".25" stroke-width="2"/><path d="M20 12a8 8 0 0 0-8-8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><svg class="werk-product-finder_check" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          let btn;
          if (!p.ok) btn = `<button type="button" class="${bc}" disabled><span class="werk-product-finder_btn-roll"><span class="werk-product-finder_btn-row"><span class="werk-product-finder_add-label">${e(this.t.sold)}</span></span></span></button>`;
          else if (p.multi) btn = `<a class="${bc}" href="${e(p.u)}"><span class="werk-product-finder_btn-roll"><span class="werk-product-finder_btn-row">${dot}${plus}<span class="werk-product-finder_add-label">${e(this.t.options)}</span></span></span></a>`;
          else btn = `<button type="button" class="${bc}" data-add data-id="${p.id ?? ''}" data-k="${e(String(p.k))}"${p.demo ? ' data-demo' : ''} aria-label="${e(this.t.add)}: ${e(p.t)}"><span class="werk-product-finder_btn-roll"><span class="werk-product-finder_btn-row">${dot}${plus}<span class="werk-product-finder_add-label">${e(this.t.add)}</span></span><span class="werk-product-finder_btn-row" aria-hidden="true">${icons}</span><span class="werk-product-finder_btn-row" aria-hidden="true">${icons}<span class="werk-product-finder_add-label">${e(this.t.added)}</span></span></span></button>`;
          return `<article class="werk-product-finder_product" style="--i:${i}"><a class="werk-product-finder_media werk-product-finder_product-media" href="${e(p.u)}" tabindex="-1" aria-hidden="true">${img}</a><div class="werk-product-finder_product-body"><div class="werk-product-finder_product-head">${liked && this.t.liked ? `<span class="werk-product-finder_liked">${e(this.t.liked)}</span>` : ''}<a class="werk-product-finder_product-title" href="${e(p.u)}">${e(p.t)}</a></div><p class="werk-product-finder_product-price">${p.c ? `<s>${e(p.c)}</s>` : ''}${e(p.p)}</p>${meta ? `<p class="werk-product-finder_product-meta">${meta}</p>` : ''}<div class="werk-product-finder_add-wrap">${btn}</div></div></article>`;
        }

        // ---------- cart ----------
        async add(btn) {
          if (btn.dataset.state) return;
          const wrap = btn.closest('.werk-product-finder_product-body');
          wrap?.querySelector('.werk-product-finder_error')?.remove();
          btn.dataset.state = 'loading';
          const done = () => {
            btn.dataset.state = 'added';
            clearTimeout(btn._tm);
            btn._tm = setTimeout(() => delete btn.dataset.state, 1800);
          };
          this.pub('add_to_cart', { result: this.current?.key, product: btn.dataset.k, variant: btn.dataset.id || null });
          if ('demo' in btn.dataset || !btn.dataset.id) {
            await new Promise((r) => setTimeout(r, 700));
            return done();
          }
          try {
            const items = [{ id: +btn.dataset.id, quantity: 1 }];
            const res = await fetch(this.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            const cartP = fetch(this.root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: items.map((x) => ({ merchandiseId: x.id, quantity: x.quantity })),
              promise: cartP.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            await window.werkThemeCart?.(this.root);
            done();
            if (this.d.after === 'cart_drawer') {
              const horizon = document.querySelector('theme-drawer#cart-drawer');
              const dawn = document.querySelector('cart-drawer');
              const drawer = typeof horizon?.open === 'function' ? horizon : typeof dawn?.open === 'function' ? dawn : null;
              setTimeout(() => (drawer ? drawer.open(btn) : (location.href = this.d.cart)), 700);
            }
          } catch (err) {
            delete btn.dataset.state;
            const p = document.createElement('p');
            p.className = 'werk-product-finder_error';
            p.setAttribute('role', 'alert');
            p.textContent = (err && (err.description || err.message)) || this.t.error;
            wrap?.append(p);
          }
        }

        // ---------- share link ----------
        async share(btn) {
          if (!this.current) return;
          const u = new URL(location.href);
          u.searchParams.set(this.d.param, this.current.key);
          try {
            await navigator.clipboard.writeText(u.toString());
          } catch {
            history.replaceState(history.state, '', u);
          }
          btn.textContent = this.t.copied || this.t.share;
          this.say(btn.textContent);
          clearTimeout(this.copyTm);
          this.copyTm = setTimeout(() => (btn.textContent = this.t.share), 2200);
        }

        // ---------- helpers ----------
        pub(name, data) {
          if (!this.d.analytics) return;
          try {
            window.Shopify?.analytics?.publish?.('werk:finder_' + name, { section: this.id, ...data });
          } catch {}
        }

        say(text) {
          if (!this.live) return;
          this.live.textContent = '';
          setTimeout(() => (this.live.textContent = text), 40);
        }

        fill(s, vars) {
          return String(s || '').replace(/\[(\w+)\]/g, (m, k) => (k in vars ? vars[k] : m));
        }

        esc(s) {
          return String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
        }

        // ---------- theme editor: which answer counts for which result ----------
        check() {
          const box = this.querySelector('[data-check]');
          if (!box) return;
          const e = (s) => this.esc(s);
          const keys = this.results.map((r) => r.key);
          const notes = [];
          const near = (k) => {
            let best = keys[0];
            let bd = Infinity;
            for (const c of keys) {
              const m = [...Array(c.length + 1).keys()];
              for (let i = 1; i <= k.length; i++) {
                let p = m[0];
                m[0] = i;
                for (let j = 1; j <= c.length; j++) {
                  const t = m[j];
                  m[j] = Math.min(m[j] + 1, m[j - 1] + 1, p + (k[i - 1] === c[j - 1] ? 0 : 1));
                  p = t;
                }
              }
              if (m[c.length] < bd) (bd = m[c.length]), (best = c);
            }
            return best;
          };
          if (!this.results.length) notes.push(['error', 'Add at least one Result block – answers give points to a result’s key.']);
          if (!this.steps.length) notes.push(['error', 'Add a Question or Swipe block, then Answer or Card blocks right below it.']);
          this.steps.forEach((st, si) => {
            if (!st.items.length) notes.push(['error', `Step ${si + 1} has no ${st.swipe ? 'cards' : 'answers'} – add them right below the step block.`]);
            for (const it of st.items) {
              const all = st.swipe ? [...it.like, ...it.nope] : it.pts;
              for (const [k] of all) if (!keys.includes(k)) notes.push(['error', `“${e(k)}” is no result key (step ${si + 1}, ${e(it.label)}).${keys.length ? ` Did you mean “${e(near(k))}”?` : ''}`]);
              if (!all.length) notes.push(['warn', `“${e(it.label)}” (step ${si + 1}) gives no points.`]);
            }
          });
          for (const o of this.querySelectorAll('template[data-orphan]')) notes.push(['error', `${o.dataset.kind === 'card' ? 'Card' : 'Answer'} “${e(o.dataset.label)}” has no ${o.dataset.kind === 'card' ? 'Swipe' : 'Question'} block above it, so it’s not shown. Move it below one.`]);
          const reach = {};
          for (const k of keys) reach[k] = 0;
          for (const st of this.steps) {
            const c = this.caps(st);
            const n = this.norm(st);
            for (const k in c) if (k in reach) reach[k] += (c[k] / n) * st.weight;
          }
          const top = Math.max(0, ...Object.values(reach));
          for (const k of keys) {
            if (!reach[k]) notes.push(['error', `Result “${e(k)}” can never win – no answer gives it points.`]);
            else if (reach[k] < top * 0.6) notes.push(['warn', `Result “${e(k)}” is hard to reach (max ${reach[k].toFixed(1)} of ${top.toFixed(1)}).`]);
          }
          const dupes = keys.filter((k, i) => keys.indexOf(k) !== i);
          if (dupes.length) notes.push(['error', `Two results share the key “${e(dupes[0])}”. Keys must be unique.`]);
          if (!notes.length) notes.push(['ok', 'All keys are linked and every result can win.']);
          const sign = (w) => (w > 0 ? `<span data-sign="+">+${w}</span>` : w < 0 ? `<span data-sign="-">${w}</span>` : '');
          const rows = this.steps
            .map((st, si) => {
              const head = `<tr data-group><td colspan="${keys.length + 1}">${si + 1} · ${st.swipe ? 'Swipe' : 'Question'} “${e(st.heading)}” · weight ${st.weight}${st.multi ? ' · multiple' : ''}</td></tr>`;
              return (
                head +
                st.items
                  .map(
                    (it) =>
                      `<tr><td>${e(it.label)}${it.boost ? ' ♡' : ''}</td>${keys
                        .map((k) => {
                          if (st.swipe) {
                            const l = it.like.find((x) => x[0] === k);
                            const n = it.nope.find((x) => x[0] === k);
                            return `<td>${l ? sign(l[1]) : ''}${l && n ? ' / ' : ''}${n ? sign(n[1]) : ''}</td>`;
                          }
                          const p = it.pts.find((x) => x[0] === k);
                          return `<td>${p ? sign(p[1]) : ''}</td>`;
                        })
                        .join('')}</tr>`
                  )
                  .join('')
              );
            })
            .join('');
          box.innerHTML = `<summary><span>werk · Product Finder · check (only in the editor)</span><span>${this.d.blocks} / 50 blocks</span></summary><div class="werk-product-finder_audit-body"><ul>${notes.map(([l, t]) => `<li data-level="${l}">${t}</li>`).join('')}</ul>${keys.length && this.steps.length ? `<div class="werk-product-finder_audit-scroll"><table><thead><tr><th></th>${keys.map((k) => `<th>${e(k)}</th>`).join('')}</tr></thead><tbody>${rows}</tbody><tfoot><tr><td>max. reachable</td>${keys.map((k) => `<td>${reach[k].toFixed(1)}</td>`).join('')}</tr></tfoot></table></div>` : ''}<p>Answers and cards belong to the Question or Swipe block above them. Points per step are scaled to 1 and multiplied by the step’s weight. ♡ = a liked product goes into the result.</p></div>`;
          box.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-product-showcase"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-product-showcase')) {
    customElements.define(
      'werk-product-showcase',
      class extends HTMLElement {
        connectedCallback() {
          const q = (s) => this.querySelector(s);
          const qa = (s) => [...this.querySelectorAll(s)];
          const raw = q('script[data-werk]');
          if (!raw) return;
          try {
            this.d = JSON.parse(raw.textContent);
          } catch {
            return;
          }
          try {
            this.t = JSON.parse(q('script[data-werk-t]')?.textContent || '{}');
          } catch {
            this.t = {};
          }
          this.v = this.d.variants.find((x) => x.id === this.d.current) || this.d.variants[0];
          this.sel = this.v ? [...this.v.o] : [];
          this.qty = 1;
          this.i = -1;
          this.spot = this.classList.contains('werk-product-showcase--spotlight');
          this.click = this.spot && this.classList.contains('is-click');
          this.inner = q('.werk-product-showcase_inner');
          this.grid = q('.werk-product-showcase_grid');
          this.media = q('.werk-product-showcase_media');
          this.stage = q('.werk-product-showcase_stage');
          this.stick = q('.werk-product-showcase_stick');
          this.slidesEl = q('.werk-product-showcase_slides');
          this.slides = qa('.werk-product-showcase_slide');
          this.cols = qa('.werk-product-showcase_col');
          this.rail = q('.werk-product-showcase_rail');
          this.nav = q('.werk-product-showcase_nav');
          this.vals = qa('.werk-product-showcase_val');
          this.adds = qa('[data-add]');
          this.buy = q('.werk-product-showcase_buy');
          this.form = q('.werk-product-showcase_form');
          this.bar = q('.werk-product-showcase_bar');
          this.del = q('.werk-product-showcase_delivery');
          this.stockEl = q('.werk-product-showcase_stock');
          this.receipt = q('[data-receipt]');
          this.qtyEl = q('[data-qty]');
          this.steps = qa('.werk-product-showcase_step');
          this.noCap = !this.slides.some((s) => s.querySelector('.werk-product-showcase_fig-cap'));
          this.speed = this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, opts) => el?.addEventListener(type, fn, { signal: ac.signal, ...opts });
          on(this, 'click', (e) => this.onClick(e));
          on(this, 'submit', (e) => this.onSubmit(e));
          on(this.stage, 'keydown', (e) => {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            e.preventDefault();
            this.go(this.i + (e.key === 'ArrowLeft' ? -1 : 1));
          });
          // window and inner scrollers (Horizon scrolls a wrapper, the phone row scrolls sideways)
          on(document, 'scroll', () => this.onScroll(), { capture: true, passive: true });
          on(document, 'scrollend', () => (this.unhold(), this.measure()), { capture: true });
          on(window, 'resize', () => this.measure());
          on(document, 'shopify:block:select', (e) => {
            const link = e.target.closest?.('.werk-product-showcase_more-link');
            if (link && this.contains(link)) this.toggle(link, true);
          });

          this.delivery();
          this.update(true);
          this.fitLabels();
          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => (this.fitLabels(), this.measure()));
          });
          this.ro.observe(this);
          this.cols.forEach((c) => this.ro.observe(c.firstElementChild || c));
          if (this.del) this.timer = setInterval(() => (this.delivery(), this.renderReceipt()), 30000);

          this.io = new IntersectionObserver(
            ([en]) => {
              this.seen = en.isIntersecting;
              if (!en.isIntersecting || this.classList.contains('is-inview')) return;
              requestAnimationFrame(() => this.classList.add('is-inview'));
            },
            // the section is taller than most screens, so a share of it may never be on screen
            { rootMargin: '0px 0px -15% 0px' }
          );
          this.io.observe(this);
          if (window.Shopify?.designMode) this.classList.add('is-inview');

          const anchor = this.buy || this.receipt;
          // one bar per page: the showcase passed last shows it, only on phones and only while no buy buttons are on screen
          if (anchor) {
            this.anchorEl = anchor;
            this.so = new IntersectionObserver(() => this.where(), { threshold: 0 });
            this.so.observe(anchor);
            if (this.bar && 'showPopover' in this.bar) on(document, 'werk-product-showcase:anchor', () => this.pickBar());
          }
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          this.so?.disconnect();
          this.ro?.disconnect();
          this.anim?.cancel();
          cancelAnimationFrame(this.raf);
          cancelAnimationFrame(this.sraf);
          clearTimeout(this.lt);
          clearInterval(this.timer);
          clearTimeout(this.bt);
          clearTimeout(this.st);
          clearTimeout(this.ft);
          try {
            this.bar?.hidePopover();
          } catch {}
        }

        // one label column for all option rows: grows for long option names (up to 45 % of the label)
        fitLabels() {
          const labs = [...this.querySelectorAll('.werk-product-showcase_opt:not(.werk-product-showcase_opt--rows) > .werk-product-showcase_lab, .werk-product-showcase_spec-k')];
          if (!labs.length) return;
          this.style.removeProperty('--lab-min');
          const max = Math.max(...labs.map((l) => (l.classList.contains('werk-product-showcase_spec-k') ? this.wordWidth(l) : l.scrollWidth)));
          const room = labs[0].closest('.werk-product-showcase_label-in').clientWidth * 0.45;
          if (max > labs[0].clientWidth + 1) this.style.setProperty('--lab-min', Math.ceil(Math.min(max, room)) + 'px');
        }

        // spec labels wrap: their width is the one of the longest word
        wordWidth(el) {
          const r = document.createRange();
          let w = 0;
          const words = el.textContent.split(/\s+/).filter(Boolean);
          if (!words.length) return 0;
          const pad = parseFloat(getComputedStyle(el).paddingRight) || 0;
          const probe = el.cloneNode();
          probe.style.cssText = 'position:absolute;visibility:hidden;width:auto;white-space:nowrap';
          el.parentNode.append(probe);
          for (const word of words) {
            probe.textContent = word;
            r.selectNodeContents(probe);
            w = Math.max(w, r.getBoundingClientRect().width);
          }
          probe.remove();
          return w + pad;
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }

        load(slide, lazy) {
          const img = slide?.querySelector('img');
          if (!img) return img;
          if (!lazy) img.loading = 'eager';
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          if (img.dataset.src) img.src = img.dataset.src;
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-src');
          return img;
        }

        h(x) {
          return String(x).toLowerCase().trim().replace(/['"]/g, '').replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '');
        }

        // the #tag of an option value, as Liquid's handleize made it (Grün → grun); h() only as a fallback
        tagOf(oi, val) {
          const o = this.d.options[oi];
          const k = o?.keys?.[o.values.indexOf(val)];
          return k != null ? k : this.h(val);
        }

        find(sel) {
          return this.d.variants.find((x) => x.o.every((o, j) => o === sel[j]));
        }

        pick(oi, val) {
          const sel = [...this.sel];
          sel[oi] = val;
          const withVal = this.d.variants.filter((x) => x.o[oi] === val);
          const v = this.find(sel) || withVal.find((x) => x.available) || withVal[0];
          if (!v) return;
          this.v = v;
          this.sel = [...v.o];
          this.update();
        }

        update(first) {
          const v = this.v;
          if (!v) return;
          this.vals.forEach((b) => {
            const oi = +b.dataset.opt;
            const val = b.dataset.val;
            b.setAttribute('aria-checked', this.sel[oi] === val ? 'true' : 'false');
            const cand = this.d.variants.filter((x) => x.o[oi] === val && x.o.every((o, j) => j === oi || o === this.sel[j]));
            b.classList.toggle('is-out', !cand.some((x) => x.available));
          });
          this.querySelectorAll('[data-opt-sel]').forEach((el) => (el.textContent = this.sel[+el.dataset.optSel] ?? ''));
          this.querySelectorAll('[data-price]').forEach((el) => this.roll(el, v.price, first));
          this.querySelectorAll('[data-compare]').forEach((el) => (el.textContent = v.compare || ''));
          this.adds.forEach((b) => {
            b.disabled = !v.available;
            b.classList.toggle('is-soldout', !v.available);
            const l = b.querySelector('[data-add-label]');
            if (l) l.textContent = v.available ? this.t.add : this.t.soldOut;
          });
          if (this.form?.elements.id) this.form.elements.id.value = v.id;
          const sel = this.querySelector('[data-bar-sel]');
          if (sel) sel.textContent = this.d.options.length ? v.o.join(' / ') : '';
          this.unsplit();
          this.setQty(this.qty, first);
          this.renderStock();
          this.gallery(first);
          if (!first && this.d.page) {
            const u = new URL(location.href);
            u.searchParams.set('variant', v.id);
            history.replaceState(history.state, '', u);
          }
        }

        unsplit() {
          if (!this.buy?.classList.contains('is-split')) return;
          this.buy.classList.remove('is-split');
          this.buy.querySelector('.werk-product-showcase_split').inert = true;
        }

        max() {
          const q = this.v?.qty;
          return q == null ? 999 : Math.max(1, q);
        }

        setQty(n, first) {
          n = Math.min(Math.max(1, n), this.max());
          this.qty = n;
          if (this.qtyEl) this.roll(this.qtyEl, String(n), first);
          if (this.form?.elements.quantity) this.form.elements.quantity.value = n;
          this.steps.forEach((b) => (b.disabled = +b.dataset.step < 0 ? n <= 1 : n >= this.max()));
          this.renderReceipt();
        }

        // only the characters that change move (aligned from the right)
        roll(el, next, instant) {
          const prev = el.dataset.v;
          el.dataset.v = next;
          if (prev === next) return;
          clearTimeout(el._t);
          if (instant || prev == null || !this.speed) {
            el.textContent = next;
            return;
          }
          const a = [...prev];
          const b = [...next];
          while (a.length < b.length) a.unshift('');
          while (b.length < a.length) b.unshift('');
          const esc = (c) => c.replace(/&/g, '&amp;').replace(/</g, '&lt;');
          el.innerHTML = b.map((c, k) => (c === a[k] ? esc(c) : `<span class="werk-product-showcase_ch"><i aria-hidden="true">${esc(a[k])}</i><i>${esc(c)}</i></span>`)).join('');
          el._t = setTimeout(() => (el.textContent = next), 480);
        }

        renderStock() {
          const el = this.stockEl;
          if (!el) return;
          const v = this.v;
          const t = +el.dataset.threshold || 5;
          // without options, [variant] goes together with the word in front of it ("in")
          const say = (s) =>
            this.d.options.length ? this.fill(s, { variant: v.o.join(' / '), count: n }) : this.fill((s || '').replace(/\s*\S*\s*\[variant\]/, '').replace(/^[\s:,–-]+/, ''), { count: n });
          let text = '';
          let n = 0;
          if (!v.available) text = say(this.t.stockOut);
          else if (v.qty != null && v.qty > 0 && v.qty <= t) {
            n = v.qty;
            text = say(n === 1 ? this.t.stockOne : this.t.stockFew);
          }
          el.hidden = !text;
          el.classList.toggle('is-last', n === 1);
          el.querySelector('[data-stock]').textContent = text;
          const filled = n ? Math.max(1, Math.min(5, Math.round((n / t) * 5))) : 0;
          el.querySelectorAll('i').forEach((d, k) => {
            d.style.setProperty('--d', k);
            d.classList.toggle('is-on', k < filled);
          });
        }

        renderReceipt() {
          const el = this.receipt;
          if (!el || el.classList.contains('is-error')) return;
          const parts = [];
          if (this.d.options.length) parts.push(this.v.o.join(' / '));
          if (this.t.qty) parts.push(this.fill(this.t.qty, { n: this.qty }));
          if (this.ships) parts.push(this.ships);
          const spans = [...el.children];
          if (spans.length !== parts.length) {
            el.innerHTML = parts.map((p) => `<span>${p.replace(/</g, '&lt;')}</span>`).join(' · ');
            return;
          }
          parts.forEach((p, k) => {
            if (spans[k].textContent === p) return;
            spans[k].textContent = p;
            if (this.speed) spans[k].animate([{ opacity: 0, filter: 'blur(2px)' }, { opacity: 1, filter: 'blur(0)' }], { duration: 400, easing: 'ease-out' });
          });
        }

        // "[count] left in [variant]" → "3 left in Sage / M"
        fill(s, map = {}) {
          return (s || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? String(map[k]) : m));
        }

        flash(msg) {
          const el = this.receipt;
          if (!el) return;
          el.classList.add('is-error');
          el.textContent = msg;
          clearTimeout(this.ft);
          this.ft = setTimeout(() => {
            el.classList.remove('is-error');
            el.textContent = '';
            this.renderReceipt();
          }, 4000);
        }

        // ---------- gallery: the images of the chosen colour ----------
        gallery(first) {
          if (!this.slides.length) return;
          const v = this.v;
          const tags = new Set(this.sel.map((x, oi) => this.tagOf(oi, x)));
          let list = this.slides.filter((s) => !this.hasAttribute('data-filter') || !s.dataset.tag || tags.has(s.dataset.tag));
          if (!list.length) list = [...this.slides];
          const m = v.media != null && this.slides.find((s) => s.dataset.id == v.media);
          if (m) list = [m, ...list.filter((s) => s !== m)];
          const key = list.map((s) => s.dataset.id).join();
          if (key === this.key) return;
          this.key = key;
          const ghost = first ? null : this.ghost();
          const n = list.length;
          const was = new Set(list.filter((s) => s.classList.contains('is-in')));
          const from = this.i;
          this.list = list;
          this.slides.forEach((s) => list.includes(s) || s.classList.remove('is-in', 'is-active', 'is-leaving'));
          list.forEach((s) => s.classList.add('is-in'));
          // DOM order = order on screen (the variant image first)
          const order = [...this.slidesEl.children].filter((c) => list.includes(c));
          if (order.some((c, k) => c !== list[k])) this.slidesEl.append(...list);
          const segs = n > 1 ? list.map((s, k) => `<button type="button" class="werk-product-showcase_seg" data-seg="${k}" aria-label="${this.esc(this.railText(k, true))}"></button>`).join('') : '';
          this.querySelectorAll('.werk-product-showcase_segs').forEach((el) => (el.innerHTML = segs));
          if (this.rail) this.rail.hidden = n < 2;
          if (this.nav) this.nav.hidden = n < 2;
          this.style.setProperty('--steps', Math.max(0, n - 1));
          const thumb = this.querySelector('[data-bar-thumb]');
          const img = list[0].querySelector('img');
          if (thumb && img) thumb.src = (img.currentSrc || img.src).replace(/([?&]width=)\d+/, '$1120');
          this.i = -1;
          this.cur = null;
          this.measure();
          if (first) {
            this.show(0, 0, true);
            this.spy();
            return;
          }
          // a new colour: back to its first image; the old images fade out over the new ones (crossfade, no cut)
          this.show(0, -1, !!ghost || !this.spot || this.row);
          this.go(0, true, from);
          if (!this.speed) return;
          const under = ghost ? ghost.childElementCount : 0;
          const ease = this.ease();
          list.forEach((s, k) => {
            if (was.has(s) || k > 4) return;
            // the new image settles from a touch larger while the old one fades away
            s.querySelector('.werk-product-showcase_img')?.animate([{ scale: 1.035 }, { scale: 1 }], { duration: 1100, easing: ease });
            // images below the old ones (more images in the new colour) fade in on their own
            if (!this.spot && k >= under) s.firstElementChild?.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 600, delay: Math.min(k - under, 4) * 70, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' });
          });
          if (!ghost) return;
          const lead = this.load(list[0]);
          const ready = lead && !lead.complete ? Promise.race([(lead.decode ? lead.decode() : Promise.resolve()).catch(() => {}), new Promise((r) => setTimeout(r, 700))]) : Promise.resolve();
          ready.then(() => {
            if (ghost !== this.ghostEl) return;
            ghost.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 650, easing: ease, fill: 'forwards' }).finished.then(
              () => ghost.remove(),
              () => {}
            );
          });
        }

        // colour switch: a still copy of the images on screen, laid over the stage so the new colour can fade in under it
        ghost() {
          this.ghostEl?.remove();
          this.ghostEl = null;
          if (!this.speed) return null;
          const shown = this.spot && !this.row ? [this.cur].filter(Boolean) : (this.list || []).filter((s) => s.classList.contains('is-in'));
          if (!shown.length) return null;
          const el = this.slidesEl;
          const g = el.cloneNode(false);
          g.classList.add('werk-product-showcase_ghost');
          g.setAttribute('aria-hidden', 'true');
          g.inert = true;
          g.style.cssText = `left:${el.offsetLeft}px;top:${el.offsetTop}px;width:${el.offsetWidth}px;height:${el.offsetHeight}px`;
          shown.forEach((s) => {
            const c = s.cloneNode(true);
            c.removeAttribute('data-id');
            c.classList.remove('is-leaving');
            // the same file that is already on screen, so the copy shows at once
            c.querySelectorAll('img').forEach((img, j) => {
              const src = s.querySelectorAll('img')[j]?.currentSrc;
              if (!src) return;
              img.removeAttribute('srcset');
              img.removeAttribute('sizes');
              img.loading = 'eager';
              img.src = src;
            });
            g.append(c);
          });
          el.after(g);
          if (this.row) g.scrollLeft = el.scrollLeft;
          return (this.ghostEl = g);
        }

        // sr: the screen reader pattern (Image number), else the visible "01 / 05"
        railText(k, sr) {
          const s = this.list[k];
          const pad = (x) => String(x).padStart(2, '0');
          const c = s?.dataset.caption;
          const no = sr ? this.fill(this.t.count || '[n] / [total]', { n: pad(k + 1), total: pad(this.list.length) }) : `${pad(k + 1)} / ${pad(this.list.length)}`;
          return no + (c ? ` · ${c}` : '');
        }

        // counter + caption in the rail, the nav and on the image (Spotlight)
        mark(k, instant) {
          const list = this.list || [];
          const t = this.railText(k);
          const at = t.indexOf(' · ');
          const count = at < 0 ? t : t.slice(0, at);
          const cap = at < 0 || (this.noCap && !this.spot) ? '' : t.slice(at);
          this.querySelectorAll('.werk-product-showcase_rail-n').forEach((n) => this.roll(n, count, instant));
          this.querySelectorAll('.werk-product-showcase_rail-c').forEach((c) => (c.textContent = cap));
          this.querySelectorAll('.werk-product-showcase_seg').forEach((b) => b.setAttribute('aria-current', +b.dataset.seg === k ? 'true' : 'false'));
          const [prev, next] = this.querySelectorAll('.werk-product-showcase_arrow');
          if (prev) prev.disabled = k <= 0;
          if (next) next.disabled = k >= list.length - 1;
        }

        // Spotlight: the new image wipes in from the direction of travel, the old one eases back underneath
        show(k, dir = 0, instant) {
          const list = this.list || [];
          const next = list[k];
          if (!next) return;
          if (k === this.i && this.cur === next) return;
          this.i = k;
          this.mark(k, instant);
          if (!this.spot) {
            this.cur = next;
            return;
          }
          const token = (this.token = (this.token || 0) + 1);
          const img = this.load(next);
          const go = () => {
            if (token !== this.token) return;
            const prev = this.cur;
            this.cur = next;
            this.anim?.cancel();
            this.slides.forEach((s) => s !== next && s !== prev && s.classList.remove('is-active', 'is-leaving'));
            next.classList.remove('is-leaving');
            next.classList.add('is-active');
            [list[k + 1], list[k - 1]].forEach((s) => this.load(s));
            if (!prev || prev === next) return;
            prev.classList.remove('is-active');
            if (instant || !this.speed || this.row) {
              prev.classList.remove('is-leaving');
              return;
            }
            prev.classList.add('is-leaving');
            const from = dir >= 0 ? 'inset(100% 0 0 0)' : 'inset(0 0 100% 0)';
            this.anim = next.animate([{ clipPath: from }, { clipPath: 'inset(0 0 0 0)' }], { duration: 900, easing: this.ease() });
            this.anim.finished.then(
              () => prev.classList.remove('is-leaving'),
              () => {}
            );
          };
          if (instant || !img || img.complete) go();
          else {
            const t = setTimeout(go, 900);
            (img.decode ? img.decode() : Promise.resolve()).catch(() => {}).then(() => (clearTimeout(t), go()));
          }
        }

        ease() {
          return getComputedStyle(this.inner).getPropertyValue('--werk-ease').trim() || 'ease';
        }

        isRow() {
          // the phone swipe row snaps; Spotlight's stage also clips, so overflow alone doesn't tell
          return getComputedStyle(this.slidesEl).scrollSnapType.startsWith('x');
        }

        // the scrolling element around the section (the window, or a wrapper such as Horizon's page wrapper)
        scroller() {
          for (let el = this.parentElement; el && el !== document.body; el = el.parentElement) {
            const o = getComputedStyle(el).overflowY;
            if ((o === 'auto' || o === 'scroll' || o === 'overlay') && el.scrollHeight > el.clientHeight + 1) return el;
          }
          return window;
        }

        // the bottom of a sticky / fixed theme header at the top of the screen
        headerBottom() {
          let b = 0;
          for (const hit of document.elementsFromPoint(innerWidth / 2, 2)) {
            if (this.contains(hit) || hit === document.documentElement || hit === document.body) continue;
            for (let el = hit; el && el !== document.body; el = el.parentElement) {
              const p = getComputedStyle(el).position;
              if (p !== 'fixed' && p !== 'sticky') continue;
              const r = el.getBoundingClientRect();
              if (r.top <= 2 && r.height < innerHeight * 0.4) b = Math.max(b, r.bottom);
              break;
            }
          }
          return Math.max(0, Math.round(b));
        }

        // the top of a fixed bar at the bottom of the screen (a docked nav, a cookie or chat bar)
        footerTop() {
          let t = innerHeight;
          const xs = [innerWidth / 2, innerWidth * 0.2, innerWidth * 0.8];
          const ys = [innerHeight - 4, innerHeight - 32, innerHeight - 64];
          for (const x of xs)
            for (const y of ys)
              for (const hit of document.elementsFromPoint(x, y)) {
                if (this.contains(hit) || hit === document.documentElement || hit === document.body) continue;
                for (let el = hit; el && el !== document.body; el = el.parentElement) {
                  if (getComputedStyle(el).position !== 'fixed') continue;
                  const r = el.getBoundingClientRect();
                  if (r.bottom >= innerHeight - 80 && r.height < innerHeight * 0.3 && r.top > innerHeight * 0.5) t = Math.min(t, r.top);
                  break;
                }
              }
          return Math.round(t);
        }

        // sticky columns: 48 below the header and as tall as the screen; a taller column sticks with its end in view
        measure() {
          if (!this.isConnected || !this.slidesEl) return;
          const row = this.isRow();
          if (row !== this.row) {
            this.row = row;
            this.pickBar();
          }
          const u = parseFloat(getComputedStyle(this.inner).getPropertyValue('--werk-u')) || 1;
          const gap = 48 * u;
          const top = this.headerBottom() + gap;
          // above a docked nav / bar at the bottom, the gap is kept from its top edge
          const foot = this.footerTop();
          const bottom = foot < innerHeight ? innerHeight - foot + 16 * u : gap;
          const room = Math.max(200, innerHeight - top - bottom);
          // a column taller than the screen ends 24 above the edge, or 16 above a docked bar
          const end = foot < innerHeight ? bottom : 24 * u;
          // the phone buy bar rises above a docked bar too
          this.style.setProperty('--bar-lift', (foot < innerHeight ? innerHeight - foot : 0) + 'px');
          this.top0 = top;
          this.style.setProperty('--stick-top', top + 'px');
          this.style.setProperty('--room', room + 'px');
          this.cols.forEach((c) => {
            if (row || getComputedStyle(c).position !== 'sticky') {
              c.style.removeProperty('--stick');
              c.style.removeProperty('--fill');
              return;
            }
            c.style.setProperty('--fill', 'auto');
            const h = c.offsetHeight;
            const fits = h <= room;
            c.style.setProperty('--fill', fits ? room + 'px' : 'auto');
            c.style.setProperty('--stick', Math.round(fits ? top : Math.min(top, innerHeight - h - end)) + 'px');
          });
          // phones with Change images by scrolling: the whole grid pins instead of the picture alone
          this.pin = this.spot && !row && getComputedStyle(this.grid).position === 'sticky';
          if (this.spot && this.stick) {
            if (row || this.pin) this.stick.style.removeProperty('--stick');
            else {
              const h = this.stick.offsetHeight;
              this.stick.style.setProperty('--stick', Math.round(h <= room ? top : Math.min(top, innerHeight - h - end)) + 'px');
            }
            this.stepPx = (innerHeight * (parseFloat(getComputedStyle(this).getPropertyValue('--werk-per')) || 70)) / 100;
          }
          this.spy();
        }

        onScroll() {
          if (this.sraf) return;
          this.sraf = requestAnimationFrame(() => {
            this.sraf = 0;
            // a jump (anchor link, scrollTo) can pass the buy buttons without the observer seeing them
            if (this.bar) this.where();
            if (this.seen && !this.lock) this.spy();
          });
        }

        // where the buy buttons are: on screen, scrolled past (above) or still to come (below)
        where() {
          const el = this.anchorEl;
          if (!el) return;
          const r = el.getBoundingClientRect();
          const a = r.bottom <= 0 ? 'above' : r.top >= innerHeight ? 'below' : 'visible';
          if (a === this.anchor) return;
          this.anchor = a;
          document.dispatchEvent(new CustomEvent('werk-product-showcase:anchor'));
        }

        // where the Spotlight scroll track starts: the top of the picture column – or, pinned on phones, where the grid
        // would be if it didn't stick (top of the inner box below its padding)
        trackTop() {
          if (!this.pin) return this.media.getBoundingClientRect().top;
          return this.inner.getBoundingClientRect().top + (parseFloat(getComputedStyle(this.inner).paddingTop) || 0);
        }

        // which image is current: Spotlight = the scroll step; Stack = the image on the line at 45 % of the screen;
        // swipe row = the one most in view. Ties keep the current image.
        spy() {
          const list = this.list || [];
          if (!list.length || this.lock) return;
          if (this.spot && !this.row) {
            if (this.click) return;
            const r = { top: this.trackTop() };
            const st = parseFloat(this.stick.style.getPropertyValue('--stick')) || this.top0 || 0;
            const k = Math.max(0, Math.min(list.length - 1, Math.round((st - r.top) / (this.stepPx || innerHeight * 0.7))));
            if (k !== this.i) this.show(k, k > this.i ? 1 : -1);
            return;
          }
          const box = this.row && this.slidesEl.getBoundingClientRect();
          const line = innerHeight * 0.45;
          const val = (s) => {
            if (!s) return 0;
            const r = s.getBoundingClientRect();
            if (box) return Math.max(0, Math.min(r.right, box.right) - Math.max(r.left, box.left)) / (r.width || 1);
            return r.top <= line && r.bottom > line ? 1 : 0;
          };
          let best = Math.max(0, this.i);
          let top = val(list[best]);
          list.forEach((s, k) => {
            const v = val(s);
            if (v > top + 0.01) {
              best = k;
              top = v;
            }
          });
          if (best !== this.i) this.show(best, best > this.i ? 1 : -1);
        }

        // arrows, dots, rail, ← →: scroll to the image (Spotlight: to its step)
        go(k, back, from) {
          const list = this.list || [];
          if (!list.length) return;
          k = Math.max(0, Math.min(k, list.length - 1));
          const s = list[k];
          let behavior = this.speed ? 'smooth' : 'auto';
          if (this.row) {
            const left = Math.max(0, s.offsetLeft - parseFloat(getComputedStyle(this.slidesEl).paddingLeft));
            if (back) behavior = 'auto';
            if (Math.abs(this.slidesEl.scrollLeft - left) > 1) {
              this.hold();
              this.slidesEl.scrollTo({ left, behavior });
            }
            this.show(k, 0, true);
            return;
          }
          if (this.spot && this.click) {
            if (k !== this.i) this.show(k, k >= this.i ? 1 : -1);
            return;
          }
          if (this.spot) {
            const r = { top: this.trackTop() };
            const st = parseFloat(this.stick.style.getPropertyValue('--stick')) || this.top0 || 0;
            const delta = r.top - st + k * (this.stepPx || innerHeight * 0.7);
            // after a colour switch only scroll back when the section is already scrolled into
            if (back && !(from > 0 && r.top < st)) return;
            if (Math.abs(delta) > 1) {
              this.hold();
              this.scroller().scrollBy({ top: delta, behavior });
            }
            this.show(k, k >= this.i ? 1 : -1);
            return;
          }
          const gap = s.getBoundingClientRect().top - (parseFloat(getComputedStyle(s).scrollMarginTop) || 0);
          // after a colour switch only scroll when the gallery's top is above the screen
          if (!(back && this.media.getBoundingClientRect().top >= 0) && Math.abs(gap) > 1) {
            this.hold();
            s.scrollIntoView({ block: 'start', behavior });
          }
          this.show(k, 0, true);
        }

        hold() {
          this.lock = true;
          clearTimeout(this.lt);
          this.lt = setTimeout(() => this.unhold(), 1200);
        }

        unhold() {
          if (!this.lock) return;
          this.lock = false;
          clearTimeout(this.lt);
          this.spy();
        }

        esc(x) {
          return String(x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
        }

        // ---------- clicks ----------
        onClick(e) {
          const t = e.target;
          const seg = t.closest('.werk-product-showcase_seg');
          if (seg) {
            this.go(+seg.dataset.seg);
            return;
          }
          const arrow = t.closest('.werk-product-showcase_arrow');
          if (arrow) {
            this.go(this.i + +arrow.dataset.go);
            return;
          }
          const val = t.closest('.werk-product-showcase_val');
          if (val) {
            this.pick(+val.dataset.opt, val.dataset.val);
            return;
          }
          const step = t.closest('.werk-product-showcase_step');
          if (step) {
            this.setQty(this.qty + +step.dataset.step);
            this.unsplit();
            return;
          }
          const link = t.closest('.werk-product-showcase_more-link');
          if (link) this.toggle(link);
        }

        toggle(link, force) {
          const open = force ?? link.getAttribute('aria-expanded') !== 'true';
          this.querySelectorAll('.werk-product-showcase_more-link').forEach((l) => {
            const on = l === link && open;
            l.setAttribute('aria-expanded', on ? 'true' : 'false');
            const p = document.getElementById(l.getAttribute('aria-controls'));
            if (!p) return;
            p.classList.toggle('is-open', on);
            p.inert = !on;
          });
        }

        // ---------- add to cart ----------
        async onSubmit(e) {
          const form = e.target.closest('.werk-product-showcase_form');
          if (!form) return;
          e.preventDefault();
          const v = this.v;
          if (this.busy || !v || !v.available) return;
          this.busy = true;
          this.unsplit();
          this.adds.forEach((b) => (b.dataset.state = 'loading'));
          const done = () => {
            this.adds.forEach((b) => (b.dataset.state = 'added'));
            clearTimeout(this.st);
            const split = this.buy?.hasAttribute('data-split');
            this.st = setTimeout(() => {
              if (split) {
                this.buy.classList.add('is-split');
                this.buy.querySelector('.werk-product-showcase_split').inert = false;
              }
              this.adds.forEach((b) => delete b.dataset.state);
            }, split ? 1100 : 2400);
          };
          try {
            if (this.d.demo) {
              await new Promise((r) => setTimeout(r, 700));
              done();
              return;
            }
            const root = window.Shopify?.routes?.root || '/';
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: v.id, quantity: this.qty }] }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            done();
            const cart = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: v.id, quantity: this.qty }],
              promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart(root);
          } catch (err) {
            this.adds.forEach((b) => delete b.dataset.state);
            if (err && err.description) this.flash(err.description);
            else form.submit();
          } finally {
            this.busy = false;
          }
        }

        // ---------- sticky bar (phones) ----------
        pickBar() {
          if (!this.bar || !('showPopover' in this.bar)) return;
          const all = [...document.querySelectorAll('werk-product-showcase')].filter((e) => e.anchor);
          const last = all.filter((e) => e.anchor === 'above').pop();
          this.sticky(!!this.row && last === this && !all.some((e) => e.anchor === 'visible'));
        }

        sticky(on) {
          if (on === !!this.barOn) return;
          this.barOn = on;
          const b = this.bar;
          clearTimeout(this.bt);
          if (on) {
            try {
              b.showPopover();
            } catch {}
            b.inert = false;
            requestAnimationFrame(() => requestAnimationFrame(() => b.classList.add('is-on')));
          } else {
            b.classList.remove('is-on');
            b.inert = true;
            this.bt = setTimeout(() => {
              try {
                if (!this.barOn) b.hidePopover();
              } catch {}
            }, 520 * this.speed + 20);
          }
        }

        // ---------- delivery promise (shop time zone) ----------
        delivery() {
          const el = this.del;
          this.ships = '';
          if (!el) return;
          const cut = (el.dataset.cutoff || '').trim().match(/^(\d{1,2})(?:[:.](\d{2}))?$/);
          if (!cut) {
            el.hidden = true;
            return;
          }
          const tz = this.dataset.tz || '+0000';
          const off = (tz[0] === '-' ? -1 : 1) * (+tz.slice(1, 3) * 60 + +tz.slice(3, 5));
          const now = Date.now() + off * 6e4;
          const day = Math.floor(now / 864e5);
          const mins = Math.floor((now % 864e5) / 6e4);
          const cutMin = +cut[1] * 60 + +(cut[2] || 0);
          const mode = el.dataset.days;
          const hol = (el.dataset.holidays || '').split(/[\s,;]+/).filter(Boolean);
          const wd = (d) => (((d + 4) % 7) + 7) % 7;
          const md = (d) => {
            const x = new Date(d * 864e5);
            return String(x.getUTCMonth() + 1).padStart(2, '0') + '-' + String(x.getUTCDate()).padStart(2, '0');
          };
          const open = (d) => {
            const w = wd(d);
            if (mode !== 'every' && (w === 0 || (w === 6 && mode !== 'mon_sat'))) return false;
            return !hol.includes(md(d));
          };
          let ship = day;
          if (!(open(day) && mins < cutMin)) {
            ship = day + 1;
            while (!open(ship)) ship++;
          }
          const add = (d, n) => {
            while (n > 0) {
              d++;
              if (open(d)) n--;
            }
            return d;
          };
          const tmin = Math.max(1, +el.dataset.min || 2);
          const tmax = Math.max(tmin, +el.dataset.max || tmin);
          const a1 = add(ship, tmin);
          const a2 = add(ship, tmax);
          const T = this.t;
          const esc = (c) => c.replace(/&/g, '&amp;').replace(/</g, '&lt;');
          const list = (s, n) => {
            const l = (s || '').split(',').map((x) => x.trim());
            return Array.from({ length: n }, (_, k) => l[k] || '');
          };
          const W = list(T.days, 7);
          const WS = list(T.daysShort, 7);
          const WM = list(T.daysMin, 7);
          const M = list(T.months, 12);
          const dt = (d) => new Date(d * 864e5);
          // a range in one month names the month once: "Wed 3 – Fri 5 Oct"
          const fmt = (d, month = true) =>
            this.fill(month ? T.date : (T.date || '').replace(/[\s,]*\[month\][.,]?/, ''), { weekday: WS[wd(d)], d: dt(d).getUTCDate(), month: M[dt(d).getUTCMonth()] })
              .replace(/\s{2,}/g, ' ')
              .trim();
          let a;
          if (ship === day) {
            const left = cutMin - mins;
            a = left >= 60 ? this.fill(T.countdown, { h: Math.floor(left / 60), m: left % 60 }) : this.fill(T.countdownMin, { m: left });
            this.ships = this.fill(T.shipsToday);
          } else if (ship === day + 1) {
            a = this.ships = this.fill(T.shipsTomorrow);
          } else {
            a = this.fill(T.shipsOn, { day: W[wd(ship)] });
            this.ships = this.fill(T.shipsOn, { day: WS[wd(ship)] });
          }
          const sameMonth = dt(a1).getUTCMonth() === dt(a2).getUTCMonth();
          const b = a1 === a2 ? this.fill(T.arrives, { date: fmt(a1) }) : this.fill(T.arrivesRange, { from: fmt(a1, !sameMonth), to: fmt(a2) });
          el.querySelector('[data-del-a]').textContent = a;
          el.querySelector('[data-del-b]').textContent = b;

          const len = Math.min(14, Math.max(7, a2 - day + 1));
          const pos = (d) => (((d - day + 0.5) / len) * 100).toFixed(3) + '%';
          let html = `<span class="werk-product-showcase_route" style="--a: ${pos(day)}; --b: ${pos(a1)}"></span>`;
          if (a2 > a1) html += `<span class="werk-product-showcase_range" style="--a: ${pos(a1)}; --b: ${pos(a2)}"></span>`;
          for (let k = 0; k < len; k++) {
            const d = day + k;
            const c = [];
            if (d === day) c.push('is-today');
            else if (d === a1 || d === a2) c.push('is-arrive');
            else if (d === ship) c.push('is-ship');
            else if (d < a1) c.push('is-way');
            if (!open(d)) c.push('is-off');
            html += `<span class="werk-product-showcase_day ${c.join(' ')}"><i></i><span>${esc(WM[wd(d)])}</span></span>`;
          }
          const strip = el.querySelector('[data-strip]');
          strip.style.setProperty('--n', len);
          strip.innerHTML = html;
          el.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-product-slider"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-product-slider')) {
    const SIZE_LIKE = /^(size|sizes|größe|groesse|grösse|taille|maat|talla|taglia)$/i;
    const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
    const damp = (a, b, k, dt) => a + (b - a) * (1 - Math.exp(-dt * k));

    customElements.define(
      'werk-product-slider',
      class extends HTMLElement {
        connectedCallback() {
          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          this.on = on;
          this.still = matchMedia('(prefers-reduced-motion: reduce)');
          this.fine = matchMedia('(hover: hover) and (pointer: fine)');
          this.editor = !!window.Shopify?.designMode;
          try {
            this.d = JSON.parse(this.querySelector('script[data-werk]')?.textContent || '{}');
          } catch {
            this.d = {};
          }
          this.d.products ||= [];
          // descriptions come as HTML text: “&amp;” back to “&” (a textarea never runs anything)
          const plain = document.createElement('textarea');
          this.d.products.forEach((p) => {
            if (!p.d || !p.d.includes('&')) return;
            plain.innerHTML = p.d;
            p.d = plain.value;
          });
          this.t = this.d.t || {};
          this.sel = {};
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          // Safari: bake the tile colour into every multiplied picture (now and whenever one loads or is added)
          // every browser on iOS / iPadOS is WebKit, plus Safari on the Mac
          const ua = navigator.userAgent;
          this.baking = CSS.supports('font', '-apple-system-body') || /iP(hone|ad|od)/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) || (/Safari/.test(ua) && /Apple/.test(navigator.vendor || '') && !/Chrome|Chromium|Edg/.test(ua));
          if (this.baking) {
            this.classList.add('is-bake');
            this.addEventListener('load', (e) => e.target.tagName === 'IMG' && this.bake(e.target), { capture: true, signal: ac.signal });
            this.querySelectorAll('img').forEach((im) => im.complete && im.naturalWidth && this.bake(im));
            this.bakeMO = new MutationObserver((ms) =>
              ms.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && (n.tagName === 'IMG' ? [n] : n.querySelectorAll('img')).forEach((im) => im.complete && im.naturalWidth && this.bake(im))))
            );
            this.bakeMO.observe(this, { childList: true, subtree: true });
          }

          this.stage = this.querySelector('[data-stage]');
          this.view = this.querySelector('[data-view]');
          this.track = this.querySelector('[data-track]');
          this.dual = this.querySelector('[data-dual]');
          if (!this.track) return;
          this.items = [...this.track.children];
          this.items.forEach((li, k) => li.style.setProperty('--k', k));
          this.cards = [...this.track.querySelectorAll('.werk-product-slider_card')];

          // ---------- reveal ----------
          if (this.moves() && !this.editor && 'IntersectionObserver' in window) {
            this.classList.add('is-reveal');
            this.io = new IntersectionObserver((es) => {
              if (es.some((x) => x.isIntersecting)) {
                this.classList.add('is-in');
                this.io.disconnect();
              }
            }, { threshold: 0.15 });
            this.io.observe(this.track);
          }

          // ---------- scroller: arrows, progress, drag + throw, tilt, parallax ----------
          this.arrows = [...this.querySelectorAll('[data-arrows]')];
          this.prev = this.querySelectorAll('[data-prev]');
          this.next = this.querySelectorAll('[data-next]');
          this.prev.forEach((b) => on(b, 'click', () => this.page(-1)));
          this.next.forEach((b) => on(b, 'click', () => this.page(1)));
          this.bar = this.querySelector('[data-bar]');
          this.thumb = this.querySelector('[data-thumb]');
          on(this.track, 'scroll', () => this.wake(), { passive: true });
          this.ro = new ResizeObserver(() => this.wake(true));
          this.ro.observe(this.track);
          this.drag(on);
          this.scrub(on);
          on(this.track, 'keydown', (e) => {
            if (e.target !== this.track) return;
            if (e.key === 'ArrowRight') (e.preventDefault(), this.page(1, 1));
            if (e.key === 'ArrowLeft') (e.preventDefault(), this.page(-1, 1));
          });
          this.vis = true;
          if ('IntersectionObserver' in window) {
            this.vio = new IntersectionObserver((es) => {
              this.vis = es[0].isIntersecting;
              if (this.vis) this.wake(true);
              if (this.vis && !this.fitted) {
                this.fitted = true;
                this.cards.forEach((card) => this.fitCard(card, this.d.products[+card.dataset.p]));
              }
            });
            this.vio.observe(this);
            // lazy pictures inside a sideways scroller only start once they are swiped into view – too late. As soon as the
            // section comes near, the whole row loads; on a mouse device the first hover pictures follow when idle.
            this.nio = new IntersectionObserver((es) => {
              if (!es.some((x) => x.isIntersecting)) return;
              this.nio.disconnect();
              this.track.querySelectorAll('img[loading="lazy"]').forEach((im) => (im.loading = 'eager'));
              if (!this.fine.matches) return;
              (window.requestIdleCallback || ((fn) => setTimeout(fn, 1200)))(() => {
                if (!this.isConnected) return;
                this.cards.slice(0, 6).forEach((card) => this.warm(card));
              });
            }, { rootMargin: '700px 0px' });
            this.nio.observe(this);
          }
          // a CORS-ready picture that will not load that way (a CDN without the header) loads the plain way
          this.addEventListener('error', (e) => {
            const im = e.target;
            if (im.tagName !== 'IMG' || !im.hasAttribute('crossorigin') || im.dataset.plain) return;
            im.dataset.plain = '1';
            im.removeAttribute('crossorigin');
            const s = im.getAttribute('src');
            if (s && !/^blob:/.test(s)) im.src = s;
          }, { capture: true, signal: ac.signal });
          this.wake(true);

          // ---------- cards: hover picture, magnet “+”, quick add, colours, open the dual view ----------
          this.cards.forEach((card) => this.card(card, on));
          this.querySelectorAll('[data-open-p]').forEach((b) => on(b, 'click', (e) => this.openFrom(e, +b.dataset.openP, b.closest('.werk-product-slider_piece') || b, b.closest('.werk-product-slider_look'))));
          this.querySelectorAll('[data-look-add]').forEach((b) => on(b, 'click', () => this.addLook(b)));
          on(document, 'pointerdown', (e) => {
            if (!e.target.closest?.('.werk-product-slider_qa')) this.closeQA();
          }, { passive: true });
          on(this, 'keydown', (e) => {
            if (e.key !== 'Escape') return;
            if (this.openQA) return this.closeQA(true);
            if (this.isDual) this.closeDual();
          });

          if (this.dual) this.dualSetup(on);

          // ---------- theme editor ----------
          on(document, 'shopify:block:select', (e) => {
            const li = this.querySelector(`[data-block="${e.detail?.blockId}"]`);
            if (!li) return;
            if (this.isDual) this.closeDual(true);
            this.classList.add('is-in');
            this.scrollToItem(li, true);
          });
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          this.vio?.disconnect();
          this.nio?.disconnect();
          this.ro?.disconnect();
          this.indRO?.disconnect();
          this.bakeMO?.disconnect();
          cancelAnimationFrame(this.raf);
          cancelAnimationFrame(this.sraf);
          this.qaTs?.forEach((t) => clearTimeout(t));
          clearTimeout(this.snapT);
          this.raf = this.sraf = 0;
        }

        moves() {
          return this.dataset.motion === 'on' && !this.still.matches;
        }

        // ================= scroller =================
        max() {
          return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        }
        // the snap points: where each item starts (scroll-padding = the side padding)
        points() {
          const pad = parseFloat(getComputedStyle(this.track).scrollPaddingLeft) || 0;
          const base = this.track.getBoundingClientRect().left + pad - this.track.scrollLeft;
          const max = this.max();
          const pts = this.items.map((li) => clamp(li.getBoundingClientRect().left - base, 0, max));
          pts.push(max);
          return [...new Set(pts.map((x) => Math.round(x)))].sort((a, b) => a - b);
        }
        // one page = as many cards as are fully in view
        page(dir, one) {
          if (this.isDual) return;
          const pts = this.points();
          const x = this.track.scrollLeft;
          let target;
          if (one) {
            target = dir > 0 ? pts.find((p) => p > x + 2) : [...pts].reverse().find((p) => p < x - 2);
          } else {
            const w = this.track.clientWidth - (parseFloat(getComputedStyle(this.track).paddingLeft) || 0) * 2;
            const want = x + dir * w * 0.98;
            target = dir > 0 ? pts.filter((p) => p <= want).pop() : pts.find((p) => p >= want);
            if (target == null || Math.abs(target - x) < 4) target = dir > 0 ? pts.find((p) => p > x + 2) : [...pts].reverse().find((p) => p < x - 2);
          }
          if (target != null) this.glide(target, 760);
        }
        // eased scroll in our own frames (no smooth scroll: themes may already ease the page)
        glide(to, ms) {
          cancelAnimationFrame(this.sraf);
          const from = this.track.scrollLeft;
          const d = to - from;
          if (Math.abs(d) < 1) return;
          if (!this.moves()) return void (this.track.scrollLeft = to);
          const t0 = performance.now();
          const ease = (t) => 1 - Math.pow(1 - t, 4);
          this.track.classList.add('is-free');
          const step = (now) => {
            const t = Math.min(1, (now - t0) / ms);
            this.track.scrollLeft = from + d * ease(t);
            this.vel = (d * 4 * Math.pow(1 - t, 3)) / ms * 16; // px per frame, for the tilt
            if (t < 1 && this.isConnected) this.sraf = requestAnimationFrame(step);
            else {
              this.sraf = 0;
              this.vel = 0;
              this.track.classList.remove('is-free');
            }
          };
          this.sraf = requestAnimationFrame(step);
        }
        scrollToItem(li, instant) {
          const pts = this.points();
          const idx = this.items.indexOf(li);
          const x = pts[Math.min(idx, pts.length - 1)] ?? 0;
          if (instant) this.track.scrollLeft = x;
          else this.glide(x, 640);
        }

        // mouse drag with throw (touch and trackpads use the native scroller)
        drag(on) {
          const tr = this.track;
          let st = null;
          // the browser would start its own link / picture drag before our threshold is reached (slow drags did nothing)
          on(tr, 'dragstart', (e) => e.preventDefault());
          on(tr, 'pointerdown', (e) => {
            if (e.pointerType !== 'mouse' || e.button !== 0 || this.isDual) return;
            if (e.target.closest('button, .werk-product-slider_qa, .werk-product-slider_swatches, input, select')) return;
            cancelAnimationFrame(this.sraf);
            this.sraf = 0;
            st = { x: e.clientX, left: tr.scrollLeft, moved: false, id: e.pointerId, s: [{ t: e.timeStamp, x: e.clientX }] };
          });
          on(window, 'pointermove', (e) => {
            if (!st || e.pointerId !== st.id) return;
            const dx = e.clientX - st.x;
            if (!st.moved && Math.abs(dx) < 6) return;
            if (!st.moved) {
              st.moved = true;
              tr.classList.add('is-drag');
              try { tr.setPointerCapture(st.id); } catch {}
              this.closeQA();
            }
            tr.scrollLeft = st.left - dx;
            st.s.push({ t: e.timeStamp, x: e.clientX });
            if (st.s.length > 6) st.s.shift();
          });
          const end = (e) => {
            if (!st || (e && e.pointerId !== st.id)) return;
            const s = st;
            st = null;
            if (!s.moved) return;
            this.dragged = performance.now();
            tr.classList.remove('is-drag');
            // flick: speed of the last ~80 ms; an old last move means the pointer stood still
            const now = e?.timeStamp ?? performance.now();
            const recent = s.s.filter((p) => now - p.t < 90);
            let v = 0;
            if (recent.length > 1) v = (recent[recent.length - 1].x - recent[0].x) / Math.max(16, recent[recent.length - 1].t - recent[0].t);
            const aim = tr.scrollLeft - v * 260;
            const pts = this.points();
            const target = pts.reduce((a, b) => (Math.abs(b - aim) < Math.abs(a - aim) ? b : a), pts[0] ?? 0);
            this.glide(target, clamp(380 + Math.abs(target - tr.scrollLeft) * 0.5, 420, 900));
          };
          on(window, 'pointerup', end);
          on(window, 'pointercancel', end);
          // a click right after a drag is not a click
          on(tr, 'click', (e) => {
            if (this.dragged && performance.now() - this.dragged < 60) (e.preventDefault(), e.stopPropagation());
          }, { capture: true });
        }

        // the progress bar: click or drag to scrub
        scrub(on) {
          if (!this.bar) return;
          let active = false;
          const go = (e, instant) => {
            const r = this.bar.getBoundingClientRect();
            const tw = r.width * Math.min(1, this.track.clientWidth / this.track.scrollWidth);
            const f = clamp((e.clientX - r.left - tw / 2) / Math.max(1, r.width - tw), 0, 1);
            const x = f * this.max();
            if (instant) this.track.scrollLeft = x;
            else this.glide(x, 520);
          };
          on(this.bar, 'pointerdown', (e) => {
            active = true;
            this.bar.setPointerCapture(e.pointerId);
            this.track.classList.add('is-free');
            go(e, false);
          });
          on(this.bar, 'pointermove', (e) => active && (cancelAnimationFrame(this.sraf), go(e, true)));
          const stop = () => {
            if (!active) return;
            active = false;
            const pts = this.points();
            const x = this.track.scrollLeft;
            this.glide(pts.reduce((a, b) => (Math.abs(b - x) < Math.abs(a - x) ? b : a), 0), 420);
          };
          on(this.bar, 'pointerup', stop);
          on(this.bar, 'pointercancel', stop);
        }

        wake(measure) {
          if (measure) this.measured = false;
          if (!this.raf && this.isConnected) {
            this.last = performance.now();
            this.raf = requestAnimationFrame((t) => this.tick(t));
          }
        }
        // one loop for progress, tilt and parallax – runs only while something moves
        tick(now) {
          this.raf = 0;
          if (!this.isConnected) return;
          const dt = Math.min((now - this.last) / 1000, 1 / 30);
          this.last = now;
          const tr = this.track;
          const x = tr.scrollLeft;
          const max = this.max();
          // progress + arrows
          if (this.thumb) {
            const tw = Math.min(1, tr.clientWidth / Math.max(1, tr.scrollWidth));
            const tx = max ? (x / max) * (1 / tw - 1) : 0;
            this.thumb.style.setProperty('--tw', tw.toFixed(4));
            this.thumb.style.setProperty('--tx', tx.toFixed(4));
          }
          const atStart = x < 2;
          const atEnd = x > max - 2;
          this.prev.forEach((b) => (b.disabled = atStart));
          this.next.forEach((b) => (b.disabled = atEnd));
          this.arrows.forEach((a) => (a.hidden = max < 2));
          // tilt: the cards lean with the speed of the row and spring back
          const dx = this.lastX == null ? 0 : x - this.lastX;
          this.lastX = x;
          const speed = dt > 0 ? dx / (dt * 60) : 0; // px per 60 fps frame
          const tiltOn = this.dataset.tilt === 'on' && this.moves() && this.fine.matches;
          const goal = tiltOn ? clamp(-speed * 0.035, -0.8, 0.8) : 0; // a hint of lean, not a swing
          this.tilt = damp(this.tilt || 0, goal, Math.abs(goal) > Math.abs(this.tilt || 0) ? 8 : 6, dt);
          if (Math.abs(this.tilt) < 0.005 && !goal) this.tilt = 0;
          tr.style.setProperty('--tilt', this.tilt.toFixed(3));
          // parallax: the picture runs a little slower than its card
          if (this.dataset.parallax === 'on' && this.moves() && (dx || !this.measured)) {
            const r = tr.getBoundingClientRect();
            const mid = r.left + r.width / 2;
            for (const card of this.cards) {
              const li = card.parentElement;
              const b = li.getBoundingClientRect();
              if (b.right < r.left - 50 || b.left > r.right + 50) continue;
              const f = clamp(((b.left + b.width / 2 - mid) / r.width) * -6, -6, 6);
              card.style.setProperty('--px', f.toFixed(2));
            }
          }
          this.measured = true;
          const busy = Math.abs(dx) > 0.1 || Math.abs(this.tilt) > 0.005 || this.sraf;
          if (busy && this.vis) this.raf = requestAnimationFrame((t) => this.tick(t));
          else this.lastX = null;
        }

        // ================= cards =================
        card(card, on) {
          const p = this.d.products[+card.dataset.p];
          if (!p) return;
          const hov = card.querySelector('.werk-product-slider_img--hover');
          const add = card.querySelector('.werk-product-slider_add');
          // a block's own hover picture is not one of the product's pictures: it belongs to the first colour's gallery,
          // always – however the dual view is opened (else the thumbnails come and go)
          if (hov?.dataset.src && !p.hx) {
            const own = this.bare(hov.dataset.src);
            if (!p.m.some((m) => this.bare(m[0]) === own)) p.hx = [own, 'f'];
          }
          on(card, 'pointerdown', () => this.sort(p), { passive: true });
          on(card, 'pointerenter', (e) => {
            if (e.pointerType !== 'mouse') return;
            this.sort(p);
            card.classList.add('is-hover');
            this.warm(card);
            // staying on a card: its big picture is on the way before the click
            clearTimeout(card.bigT);
            card.bigT = setTimeout(() => {
              const m = this.media(p, p.ci >= 0 ? this.selection(p)[p.ci] : null)[0];
              if (m && !m.big && this.dual && this.dataset.dual === 'on') (m.big = new Image()).src = this.url(m, 1400);
            }, 180);
          });
          on(card, 'pointerleave', () => clearTimeout(card.bigT));
          on(card, 'pointerleave', () => card.classList.remove('is-hover'));
          if (add) on(add, 'click', (e) => (e.preventDefault(), this.quick(card, p)));
          // press: the card gives a little (not when the pointer starts a drag)
          on(card, 'pointerdown', (e) => {
            if (e.target.closest('button, .werk-product-slider_qa, .werk-product-slider_swatches')) return;
            card.classList.add('is-press');
          });
          const unpress = () => card.classList.remove('is-press');
          on(card, 'pointerup', unpress);
          on(card, 'pointerleave', unpress);
          on(card, 'pointercancel', unpress);
          on(this.track, 'scroll', unpress, { passive: true });
          // open: card picture or name → dual view (cmd/ctrl/shift click keeps the link)
          card.querySelectorAll('[data-open]').forEach((a) =>
            on(a, 'click', (e) => this.openFrom(e, +card.dataset.p, card))
          );
          // colours
          card.querySelectorAll('.werk-product-slider_swatch').forEach((sw) => {
            this.paint(sw.firstElementChild, p, p.ov[p.ci]?.indexOf(sw.dataset.v));
            on(sw, 'click', () => this.pickColor(card, p, sw.dataset.v, sw));
            on(sw, 'pointerenter', (e) => e.pointerType === 'mouse' && this.previewColor(card, p, sw.dataset.v));
            on(sw, 'pointerleave', (e) => e.pointerType === 'mouse' && this.previewColor(card, p, null));
          });
        }

        openFrom(e, i, from, look) {
          if (this.dataset.dual !== 'on' || !this.dual) {
            // no dual view: a link keeps its link, a look piece (a button) goes to its product page
            const u = this.d.products[i]?.u;
            if (u && !e.target.closest('a[href]')) location.assign(u);
            return;
          }
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
          e.preventDefault();
          this.openDual(i, from, look);
        }

        // ----- data helpers -----
        selection(p) {
          const key = p.id;
          if (!this.sel[key]) {
            const v = p.v.find((x) => x.id === p.sel) || p.v.find((x) => x.a) || p.v[0];
            this.sel[key] = v ? [...v.o] : [];
          }
          return this.sel[key];
        }
        variant(p, sel = this.selection(p)) {
          return p.v.find((v) => v.o.every((o, k) => o === sel[k])) || null;
        }
        soldValue(p, k, value) {
          const sel = [...this.selection(p)];
          sel[k] = value;
          const v = this.variant(p, sel);
          return !v || !v.a;
        }
        // other options than colour and size need the dual view
        simple(p) {
          return p.o.every((_, k) => k === p.ci || k === p.si);
        }
        // the hover picture of a card: load it (once)
        warm(card) {
          const hov = card.querySelector('.werk-product-slider_img--hover');
          if (!hov || hov.src || !hov.dataset.src) return;
          hov.src = hov.dataset.src;
          hov.decode?.().then(() => hov.classList.add('is-ready'), () => {});
        }
        // the picture a card shows right now, if it is this medium (the dual view starts with it, sharpens after)
        cardSrc(i, m) {
          const img = this.cardOf(i)?.querySelector('[data-main]');
          if (!img || img.tagName !== 'IMG' || !m) return '';
          const now = img.dataset.o || img.dataset.cur || img.currentSrc || img.src;
          return now && this.bare(now) === this.bare(m[0]) ? img.currentSrc || img.src : '';
        }
        // cut-out or photo? Shops mix both. A picture with a light, even border is a cut-out (sits on the tile, multiplied);
        // every other picture fills its tile. Looked at once per product on a 48 px copy, before its dual view shows.
        kind(m) {
          if (!m || m[1] !== 'c' || this.d.demo || this.d.fit !== 'contain') return Promise.resolve();
          return (m.k ||= (async () => {
            try {
              const bmp = await createImageBitmap(await (await fetch(this.url(m, 48), { mode: 'cors' })).blob());
              const c = document.createElement('canvas');
              const w = (c.width = bmp.width);
              const h = (c.height = bmp.height);
              const x = c.getContext('2d', { willReadFrequently: true });
              x.drawImage(bmp, 0, 0);
              const d = x.getImageData(0, 0, w, h).data;
              let n = 0;
              let light = 0;
              for (let y = 0; y < h; y++)
                for (let k = 0; k < w; k++) {
                  if (y > 0 && y < h - 1 && k > 0 && k < w - 1) continue;
                  const i = (y * w + k) * 4;
                  const mn = Math.min(d[i], d[i + 1], d[i + 2]);
                  const mx = Math.max(d[i], d[i + 1], d[i + 2]);
                  n++;
                  if (d[i + 3] < 16 || (mn >= 225 && mx - mn <= 20)) light++;
                }
              if (light / n < 0.9) m[1] = 'f';
            } catch {
              /* not readable: stays as the setting says */
            }
          })());
        }
        sort(p) {
          if (!p || this.d.demo || this.d.fit !== 'contain') return Promise.resolve();
          return (p.sorted ||= Promise.all(p.m.map((m) => this.kind(m))).then(() => this.refit(p)));
        }
        // the card picture: a photo fills the tile, a cut-out sits on it
        fitCard(card, p) {
          const img = card.querySelector('[data-main]');
          if (!img || img.tagName !== 'IMG' || this.d.demo || this.d.fit !== 'contain') return;
          const now = this.bare(img.dataset.cur || img.currentSrc || img.src);
          const m = p.m.find((x) => this.bare(x[0]) === now);
          if (!m) return; // the block's own picture: as the setting says
          this.kind(m).then(() => {
            if (this.bare(img.dataset.cur || img.currentSrc || img.src) !== now && !/^blob:/.test(img.src)) return;
            const fill = m[1] === 'f';
            if (fill && /^blob:/.test(img.src)) img.src = this.url(m, 800); // a baked cut-out copy: back to the photo
            img.classList.toggle('is-fill', fill);
            if (m[2]) img.style.setProperty('--fp', m[2]);
            else img.style.removeProperty('--fp');
          });
        }
        // pictures already on screen that turned out to be photos
        refit(p) {
          if (!this.dual || !p.m.some((m) => m[1] === 'f')) return;
          this.dual.querySelectorAll('img.is-contain[data-u]').forEach((im) => {
            const m = p.m.find((x) => x[0] === im.dataset.u);
            if (!m || m[1] !== 'f') return;
            im.classList.remove('is-contain', 'is-baked');
            if (/^blob:/.test(im.src)) im.src = this.url(m, +im.dataset.w || 400);
          });
        }
        // a picture address without its width (to compare pictures)
        bare(u) {
          return new URL(u, location.href).href.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
        }
        media(p, color) {
          const list = color != null && p.cm && p.cm[color] ? p.cm[color] : null;
          const out = list && list.length ? list.map((k) => p.m[k]).filter(Boolean) : p.m;
          if (!p.hx || (p.ci >= 0 && color != null && color !== p.ov[p.ci][0])) return out;
          return out.length ? [out[0], p.hx, ...out.slice(1)] : [p.hx];
        }
        money(cents) {
          const f = (n, d, ts, ds) => {
            const [i, fr] = (n / 100).toFixed(d).split('.');
            return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (fr ? ds + fr : '');
          };
          const map = {
            amount: () => f(cents, 2, ',', '.'),
            amount_no_decimals: () => f(cents, 0, ',', '.'),
            amount_with_comma_separator: () => f(cents, 2, '.', ','),
            amount_no_decimals_with_comma_separator: () => f(cents, 0, '.', ','),
            amount_with_space_separator: () => f(cents, 2, ' ', ','),
            amount_no_decimals_with_space_separator: () => f(cents, 0, ' ', ','),
            amount_with_apostrophe_separator: () => f(cents, 2, "'", '.'),
          };
          // fallback built in pieces: two curly braces in a row would be read as Liquid
          return (this.d.money || '$' + '{' + '{amount}' + '}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (map[k] || map.amount)());
        }
        priceHTML(v) {
          if (!v) return '';
          return (v.c > v.p ? `<s>${this.money(v.c)}</s> ` : '') + this.money(v.p);
        }
        esc(v) {
          return String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
        }
        swap(img, src) {
          if (!img || !src || img.dataset.cur === src) return;
          img.dataset.cur = src;
          const next = new Image();
          next.src = src;
          const done = () => {
            if (img.dataset.cur !== src) return; // a newer change came in while this one was decoding
            img.removeAttribute('srcset');
            img.src = src;
            img.classList.remove('is-swap');
          };
          if (!this.moves()) return void next.decode().then(done, done);
          img.classList.add('is-swap');
          next.decode().then(() => setTimeout(done, 140), done);
        }

        // ----- colours on the card: hover = preview, click = keep -----
        previewColor(card, p, color) {
          if (p.ci < 0) return;
          const img = card.querySelector('[data-main]');
          const cur = this.selection(p)[p.ci];
          const show = color ?? cur;
          const src = this.media(p, show)[0];
          if (src) {
            this.swap(img, src[0] + (src[0].includes('?') ? '&' : '?') + 'width=800');
            this.fitCard(card, p);
          }
          const meta = card.querySelector('[data-meta]');
          if (meta) meta.textContent = this.metaText(p, show);
        }
        pickColor(card, p, color, sw) {
          if (p.ci < 0) return;
          const sel = this.selection(p);
          sel[p.ci] = color;
          // keep the size if it still exists, else the first available
          if (!this.variant(p) || !this.variant(p).a) {
            const alt = p.v.find((v) => v.o[p.ci] === color && v.a) || p.v.find((v) => v.o[p.ci] === color);
            if (alt) this.sel[p.id] = [...alt.o];
          }
          card.querySelectorAll('.werk-product-slider_swatch').forEach((x) => {
            x.setAttribute('aria-pressed', String(x === sw));
            x.classList.toggle('is-draw', x === sw && this.moves());
          });
          // the hover picture follows the colour: its second picture (the block's own one for the first colour);
          // a colour without one shows no hover picture rather than another colour's
          const hov = card.querySelector('.werk-product-slider_img--hover');
          const second = p.cm?.[color]?.length || color === p.ov[p.ci]?.[0] ? this.media(p, color)[1] : null;
          card.classList.toggle('is-swatched', !second);
          if (hov && second && this.bare(hov.dataset.src || '') !== this.bare(second[0])) {
            hov.dataset.src = this.url(second, 900);
            hov.classList.remove('is-ready');
            hov.removeAttribute('src');
            // the pointer is usually still on the card: load it now, there is no new pointerenter
            if (card.classList.contains('is-hover')) {
              hov.src = hov.dataset.src;
              hov.decode?.().then(() => hov.classList.add('is-ready'), () => {});
            }
          }
          this.previewColor(card, p, null);
          this.paintCard(card, p);
          this.closeQA();
        }
        // a swatch dot: Shopify's swatch or a CSS colour name as it is; else the middle of the colour's picture; else neutral
        paint(dot, p, j) {
          if (!dot) return;
          const raw = String(p.sw?.[j] ?? '').trim();
          dot.classList.remove('is-pic', 'is-none');
          if (raw && (/^url\(/i.test(raw) || CSS.supports('color', raw))) return void dot.style.setProperty('--sw', raw);
          const m = this.media(p, p.ov[p.ci]?.[j]);
          const own = p.cm?.[p.ov[p.ci]?.[j]]?.length ? m[0] : null;
          if (own) {
            dot.style.setProperty('--sw', `url("${this.url(own, 240)}")`);
            dot.classList.add('is-pic');
          } else {
            dot.style.removeProperty('--sw');
            dot.classList.add('is-none');
          }
        }
        metaText(p, color) {
          if (p.ci < 0) return p.ty || '';
          const n = p.ov[p.ci].length;
          return n > 1 ? `${color} · ${(this.t.colours || '[n] colors').replace('[n]', n)}` : color;
        }
        paintCard(card, p) {
          const v = this.variant(p);
          const price = card.querySelector('[data-price]');
          if (price && v) price.innerHTML = this.priceHTML(v);
          const sizes = card.querySelector('[data-sizes]');
          if (sizes && p.si >= 0) {
            sizes.innerHTML = this.esc(sizes.dataset.label || '') + ' ' + p.ov[p.si].map((x) => (this.soldValue(p, p.si, x) ? `<s>${this.esc(x)}</s>` : this.esc(x))).join(sizes.dataset.sep || ' ');
          }
          const add = card.querySelector('.werk-product-slider_add');
          if (add) {
            const any = p.v.some((x) => x.a && (p.ci < 0 || x.o[p.ci] === this.selection(p)[p.ci]));
            add.disabled = !any;
            const l = add.querySelector('.werk-product-slider_add-label');
            if (l) l.textContent = any ? this.t.add : this.t.sold;
          }
        }

        // ----- quick add: one variant → straight in; a size → size bar; more options → dual view -----
        quick(card, p) {
          const qa = card.querySelector('[data-qa]');
          if (!qa || qa.dataset.state) return;
          // more to choose than a size: the dual view – or, without it, the product page
          if (!this.simple(p)) return this.dual && this.dataset.dual === 'on' ? this.openDual(+card.dataset.p, card) : void (p.u && location.assign(p.u));
          const sel = this.selection(p);
          const choices = p.si >= 0 ? p.ov[p.si] : [];
          if (choices.length <= 1) {
            const v = this.variant(p) || p.v.find((x) => x.a);
            return v && this.addQA(card, qa, p, v, choices[0] || '');
          }
          this.closeQA();
          let bar = qa.querySelector('.werk-product-slider_sizes');
          if (!bar) {
            bar = document.createElement('div');
            bar.className = 'werk-product-slider_sizes';
            bar.setAttribute('role', 'group');
            qa.prepend(bar);
          }
          bar.setAttribute('aria-label', p.o[p.si]);
          const longest = Math.max(2, ...choices.map((x) => String(x).length));
          bar.style.setProperty('--n', longest);
          bar.classList.toggle('is-long', longest > 14); // “Special Selling Plans Ski Wax”: two lines instead of “…”
          bar.innerHTML = choices
            .map((x, k) => {
              const sold = this.soldValue(p, p.si, x);
              return `<button type="button" class="werk-product-slider_chip" style="--c:${k}" data-v="${this.esc(x)}"${sold ? ' aria-disabled="true"' : ''}>${this.esc(x)}</button>`;
            })
            .join('');
          bar.querySelectorAll('.werk-product-slider_chip').forEach((c) =>
            c.addEventListener('click', (e) => {
              e.preventDefault();
              if (c.getAttribute('aria-disabled') === 'true') return;
              const s2 = [...sel];
              s2[p.si] = c.dataset.v;
              const v = this.variant(p, s2);
              if (!v || !v.a) return;
              this.sel[p.id] = s2;
              const r = c.getBoundingClientRect();
              c.style.setProperty('--cx', (e.clientX ? e.clientX - r.left : r.width / 2) + 'px');
              c.style.setProperty('--cy', (e.clientY ? e.clientY - r.top : r.height / 2) + 'px');
              const cx = e.clientX ? e.clientX - r.left : r.width / 2;
              const cy = e.clientY ? e.clientY - r.top : r.height / 2;
              c.style.setProperty('--cr', Math.ceil(Math.hypot(Math.max(cx, r.width - cx), Math.max(cy, r.height - cy))) + 1 + 'px');
              c.classList.add('is-pick');
              setTimeout(() => this.addQA(card, qa, p, v, c.dataset.v), this.moves() ? 560 : 0); // the fill first
            }, { signal: this.ac.signal })
          );
          void bar.offsetWidth;
          qa.classList.add('is-open');
          this.openQA = qa;
          bar.querySelector('.werk-product-slider_chip:not([aria-disabled])')?.focus({ preventScroll: true });
        }
        closeQA(focus) {
          const qa = this.openQA;
          if (!qa) return;
          this.openQA = null;
          qa.classList.remove('is-open');
          if (focus) qa.querySelector('.werk-product-slider_add')?.focus({ preventScroll: true });
        }
        async addQA(card, qa, p, v, label) {
          this.openQA = null;
          // one timer per card: adding on the next card must not keep this one from folding back
          this.qaTs ||= new Map();
          clearTimeout(this.qaTs.get(qa));
          let st = qa.querySelector('.werk-product-slider_state');
          if (!st) {
            st = document.createElement('div');
            st.className = 'werk-product-slider_state';
            st.setAttribute('role', 'status');
            qa.append(st);
          }
          st.getAnimations({ subtree: true }).forEach((x) => x.cancel());
          const tag = label ? ' · ' + label : '';
          st.innerHTML = `<svg class="werk-product-slider_state-check" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="werk-product-slider_state-text"></span>`;
          const text = st.querySelector('.werk-product-slider_state-text');
          text.textContent = this.t.adding + tag;
          text.dataset.text = text.textContent;
          const pick = qa.querySelector('.werk-product-slider_chip.is-pick');
          qa.dataset.state = 'adding';
          qa.classList.remove('is-open');
          const moving = this.moves() && !!st.animate;
          if (moving) {
            // the picked chip (already dark) grows into the whole bar; one press becomes the answer
            const r = st.getBoundingClientRect();
            const c = (pick || qa.querySelector('.werk-product-slider_add'))?.getBoundingClientRect();
            const from = c
              ? `inset(${c.top - r.top}px ${r.right - c.right}px ${r.bottom - c.bottom}px ${c.left - r.left}px round ${pick ? getComputedStyle(pick).borderRadius : '999px'})`
              : 'inset(50% 50% 50% 50% round 999px)';
            st.animate([{ clipPath: from }, { clipPath: `inset(0 0 0 0 round ${getComputedStyle(st).borderRadius})` }], { duration: 620, easing: 'cubic-bezier(0.5, 0, 0.15, 1)' });
            text.animate([{ opacity: 0, translate: '0 60%' }, { opacity: 1, translate: '0 0' }], { duration: 480, delay: 160, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' });
          }
          const t0 = performance.now();
          const ok = await this.cartAdd([{ id: v.id, quantity: 1 }]);
          await new Promise((res) => setTimeout(res, Math.max(0, (moving ? 900 : 0) - (performance.now() - t0))));
          if (ok !== true) {
            this.qaEnd(qa, st);
            if (typeof ok === 'string') this.flash(card, ok);
            return;
          }
          if (this.t.bag) {
            const bag = document.createElement('a');
            bag.className = 'werk-product-slider_state-bag';
            bag.href = this.d.cart || '/cart';
            bag.textContent = this.t.bag;
            st.append(bag);
            if (moving) bag.animate([{ opacity: 0, translate: '0 60%' }, { opacity: 0.7, translate: '0 0' }], { duration: 480, delay: 200, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' });
          }
          qa.dataset.state = 'added';
          text.textContent = text.dataset.text = this.t.added + tag; // no second text animation – the check pushes it over
          this.qaTs.set(qa, setTimeout(() => this.qaEnd(qa, st), 2400));
        }
        // the dark bar folds back into the + and hands over to it
        qaEnd(qa, st) {
          const done = () => {
            delete qa.dataset.state;
            qa.querySelectorAll('.is-pick').forEach((c) => c.classList.remove('is-pick'));
          };
          const add = qa.querySelector('.werk-product-slider_add');
          if (!this.moves() || !st.animate || !add) return done();
          const r = st.getBoundingClientRect();
          const c = add.getBoundingClientRect();
          const to = `inset(${c.top - r.top}px ${r.right - c.right}px ${r.bottom - c.bottom}px ${c.left - r.left}px round 999px)`;
          [...st.children].forEach((el) => el.animate([{ opacity: getComputedStyle(el).opacity }, { opacity: 0 }], { duration: 200, fill: 'forwards' }));
          st.animate([{ clipPath: `inset(0 0 0 0 round ${getComputedStyle(st).borderRadius})` }, { clipPath: to }], { duration: 520, delay: 40, easing: this.ease(), fill: 'forwards' })
            .finished.then(() => {
              done(); // the + fades in where the dark dot sits, the dot fades out (opacity transition of the state)
              setTimeout(() => st.getAnimations({ subtree: true }).forEach((x) => x.cancel()), 260);
            }, () => {});
        }
        flash(card, text) {
          const el = document.createElement('p');
          el.className = 'werk-product-slider_flash';
          el.setAttribute('role', 'status');
          el.textContent = text;
          const at = card.querySelector('.werk-product-slider_info') || card;
          at.querySelector('.werk-product-slider_flash')?.remove();
          at.append(el);
          setTimeout(() => el.remove(), 3200);
        }

        // cart: one request, the theme hears about it (Horizon events, Dawn sections). true = added, string = message
        async cartAdd(items) {
          if (this.d.demo || items.some((x) => !x.id || x.id < 100000)) {
            await new Promise((r) => setTimeout(r, 700));
            return true;
          }
          const root = window.Shopify?.routes?.root || '/';
          try {
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) return json.description || json.message || this.t.error || 'Could not add';
            const cart = fetch(root + 'cart.js').then((r) => r.json());
            const count = cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } }));
            count.catch(() => {}); // the cart did not answer: the add itself went through, nothing to report
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: items.map((x) => ({ merchandiseId: x.id, quantity: x.quantity })),
              promise: count,
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart?.(root);
            return true;
          } catch {
            return this.t.error || 'Could not add';
          }
        }

        // the look: every piece in one request when nothing needs choosing, else the dual view with the pieces
        async addLook(btn) {
          if (btn.dataset.state) return;
          const look = btn.closest('.werk-product-slider_look');
          const ids = (look.dataset.look || '').split(',').filter(Boolean).map(Number);
          const ps = ids.map((i) => this.d.products[i]).filter(Boolean);
          const needs = ps.some((p) => p.v.filter((v) => v.a).length > 1);
          if (needs && this.dual && this.dataset.dual === 'on') return this.openDual(ids[0], look.querySelector('.werk-product-slider_piece') || look, look);
          const items = ps.map((p) => (this.variant(p) || p.v.find((v) => v.a))).filter((v) => v && v.a).map((v) => ({ id: v.id, quantity: 1 }));
          if (!items.length) return;
          btn.dataset.state = 'loading';
          const ok = await this.cartAdd(items);
          if (ok !== true) {
            delete btn.dataset.state;
            if (typeof ok === 'string') this.flash(look, ok);
            return;
          }
          btn.dataset.state = 'added';
          setTimeout(() => delete btn.dataset.state, 2400);
        }

        // ================= dual view =================
        dualSetup(on) {
          const q = (s) => this.dual.querySelector(s);
          this.dm = q('[data-dmedia]');
          this.gal = q('[data-gallery]');
          this.gn = q('[data-gn]');
          this.dots = q('[data-dots]');
          this.thumbsEl = q('[data-thumbs]');
          this.detail = q('[data-detail]');
          this.railEl = q('[data-rail]');
          this.countEl = q('[data-count]');
          this.dual.querySelectorAll('[data-close]').forEach((b) => on(b, 'click', () => this.closeDual()));
          on(q('[data-dprev]'), 'click', () => this.step(-1));
          on(q('[data-dnext]'), 'click', () => this.step(1));
          on(this.dual, 'keydown', (e) => {
            if (e.target.closest('input, select, textarea')) return;
            if (e.key === 'ArrowRight') this.step(1);
            if (e.key === 'ArrowLeft') this.step(-1);
          });
          // swipe the big picture (touch) to go through the pictures
          let sw = null;
          on(this.dm, 'pointerdown', (e) => {
            if (e.pointerType === 'mouse') return;
            sw = { x: e.clientX, y: e.clientY, id: e.pointerId };
          });
          on(this.dm, 'pointerup', (e) => {
            if (!sw || e.pointerId !== sw.id) return;
            const dx = e.clientX - sw.x;
            const dy = e.clientY - sw.y;
            sw = null;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) this.showImg(this.gi + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
          });
          on(this.dm, 'pointercancel', () => (sw = null));
        }

        list() {
          return this.lookList || this.d.rail || [];
        }

        cardOf(i) {
          return this.cards.find((c) => +c.dataset.p === i);
        }

        async openDual(i, from, look) {
          const p = this.d.products[i];
          if (!p || !this.dual || this.dataset.dual !== 'on' || this.busy || this.opening) return;
          // know which pictures are cut-outs before the first one grows (usually known since the hover, else a moment)
          this.opening = true;
          await Promise.race([this.sort(p), new Promise((r) => setTimeout(r, 250))]);
          this.opening = false;
          if (!this.isConnected) return;
          this.closeQA();
          this.lookList = look ? (look.dataset.look || '').split(',').filter(Boolean).map(Number) : null;
          this.lookEl = look || null;
          this.cur = i;
          this.opener = from;
          // the picture that shows at the moment of the click is the one that grows: a card on its hover picture opens on that one
          const hv = from?.matches?.('.werk-product-slider_card.is-hover:not(.is-swatched)') ? from.querySelector('.werk-product-slider_img--hover.is-ready') : null;
          this.startSrc = hv ? hv.currentSrc || hv.src : '';
          this.render(i);
          const anim = this.moves() && !!this.dm.animate;
          const src = (from?.querySelector?.('.werk-product-slider_media') || from)?.getBoundingClientRect();
          const h0 = this.stage.offsetHeight;
          this.dual.hidden = false;
          this.stage.classList.add('is-dual');
          this.isDual = true;
          const h1 = this.stage.offsetHeight;
          this.dual.querySelector('.werk-product-slider_close')?.focus({ preventScroll: true });
          if (!anim || !src) {
            this.stage.classList.add('is-dual-done');
            this.reveal(false);
            return;
          }
          this.busy = true;
          const ease = this.ease();
          const run = [];
          // the others step aside, the stage grows (or shrinks) to the dual view
          const card = from.closest('.werk-product-slider_item');
          this.items.forEach((li) => {
            if (li === card) return;
            const dir = card && this.items.indexOf(li) < this.items.indexOf(card) ? -1 : 1;
            run.push(li.animate([{ opacity: 1, translate: '0 0' }, { opacity: 0, translate: `${dir * 24}px 0` }], { duration: 260, easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)', fill: 'forwards' }));
          });
          if (card) run.push(card.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, delay: 160, fill: 'forwards' }));
          this.view.querySelectorAll('.werk-product-slider_head, .werk-product-slider_foot').forEach((el) => run.push(el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, fill: 'forwards' })));
          this.stage.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 640, easing: ease });
          // FLIP: the big picture starts where the card picture is (uniform scale + clip, so nothing stretches)
          const dst = this.dm.getBoundingClientRect();
          const sc = src.width / dst.width;
          const cut = Math.max(0, (dst.height - src.height / sc) / 2);
          const r = parseFloat(getComputedStyle(this.dm).borderTopLeftRadius) || 12;
          const from1 = { transform: `translate(${src.left - dst.left}px, ${src.top - dst.top - cut * sc}px) scale(${sc})`, clipPath: `inset(${cut}px 0 ${cut}px 0 round ${r / sc}px)` };
          const to1 = { transform: 'translate(0, 0) scale(1)', clipPath: `inset(0px 0 0px 0 round ${r}px)` };
          this.dm.style.transformOrigin = '0 0';
          const fly = this.dm.animate([from1, to1], { duration: 700, delay: 120, easing: ease, fill: 'backwards' });
          this.reveal(true);
          await fly.finished.catch(() => {});
          run.forEach((a) => a.cancel());
          this.dm.style.transformOrigin = '';
          this.stage.classList.add('is-dual-done');
          this.busy = false;
        }

        reveal(anim) {
          const parts = [...this.dual.querySelectorAll('.werk-product-slider_dual-top, .werk-product-slider_thumbs, .werk-product-slider_detail > *, .werk-product-slider_dual-foot')];
          if (!anim) return;
          const soft = 'cubic-bezier(0.22, 1, 0.36, 1)';
          parts.forEach((el, k) => el.animate([{ opacity: 0, translate: '0 12px' }, { opacity: 1, translate: '0 0' }], { duration: 620, delay: 360 + Math.min(k, 9) * 40, easing: soft, fill: 'backwards' }));
        }

        async closeDual(instant) {
          if (!this.isDual || this.busy) return;
          const i = this.cur;
          const back = this.lookEl || this.cardOf(i)?.closest('.werk-product-slider_item');
          const anim = !instant && this.moves() && !!this.dm.animate;
          const h0 = this.stage.offsetHeight;
          if (back && back.closest('.werk-product-slider_item')) this.scrollToItem(back.closest('.werk-product-slider_item'), true);
          if (!anim) {
            this.finishClose(back, i);
            return;
          }
          this.busy = true;
          const ease = this.ease();
          const out = 'cubic-bezier(0.55, 0, 0.8, 0.2)';
          const parts = [...this.dual.querySelectorAll('.werk-product-slider_dual-top, .werk-product-slider_thumbs, .werk-product-slider_detail, .werk-product-slider_dual-foot')];
          const fades = parts.map((el) => el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: out, fill: 'forwards' }));
          // the page must not get shorter mid-flight: if it would (section near the end), it scrolls up smoothly instead of jumping at the end
          const sc = this.scroller();
          const sTop = sc.scrollTop;
          this.style.minHeight = this.offsetHeight + 'px';
          // the slider comes back underneath (measured in place), the big picture flies home to its card
          this.stage.classList.remove('is-dual-done');
          this.stage.classList.remove('is-dual');
          this.dual.style.position = 'absolute';
          this.dual.style.inset = '0 0 auto';
          this.dual.style.pointerEvents = 'none';
          const h1 = this.stage.offsetHeight;
          const piece = this.lookEl && [...this.lookEl.querySelectorAll('[data-open-p]')].find((b) => +b.dataset.openP === i)?.closest('.werk-product-slider_piece');
          const target = this.lookEl ? piece || this.lookEl.querySelector('.werk-product-slider_media') : this.cardOf(i)?.querySelector('.werk-product-slider_media') || back?.querySelector('.werk-product-slider_media');
          const lift = Math.max(0, sTop - (sc.scrollHeight - (h0 - h1) - sc.clientHeight));
          const r0 = target?.getBoundingClientRect();
          const dst = r0 && { left: r0.left, top: r0.top + lift, width: r0.width, height: r0.height };
          const src = this.dm.getBoundingClientRect();
          if (lift > 0.5) {
            const t0 = performance.now();
            const step = (t) => {
              const k = Math.min(1, (t - t0) / 560);
              sc.scrollTop = sTop - lift * (k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2);
              if (k < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
          }
          this.stage.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 560, easing: ease });
          const runs = [];
          this.items.forEach((li, k) => {
            const isBack = target && li.contains(target);
            runs.push(li.animate([{ opacity: 0 }, { opacity: 1 }], { duration: isBack ? 160 : 420, delay: isBack ? 460 : 180 + Math.min(Math.abs(k - this.items.indexOf(back)), 6) * 40, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' }));
          });
          this.view.querySelectorAll('.werk-product-slider_head, .werk-product-slider_foot').forEach((el) => runs.push(el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 400, delay: 200, fill: 'backwards' })));
          if (dst && dst.width && piece) {
            // a look piece is a free cut-out: the big picture shrinks into it (fits inside), then hands over
            const sc = Math.min(dst.width / src.width, dst.height / src.height);
            const x = dst.left + (dst.width - src.width * sc) / 2 - src.left;
            const y = dst.top + (dst.height - src.height * sc) / 2 - src.top;
            this.dm.style.transformOrigin = '0 0';
            const fly = this.dm.animate(
              [
                { transform: 'translate(0, 0) scale(1)', opacity: 1, offset: 0 },
                { transform: `translate(${x * 0.92}px, ${y * 0.92}px) scale(${1 - (1 - sc) * 0.92})`, opacity: 1, offset: 0.72 },
                { transform: `translate(${x}px, ${y}px) scale(${sc})`, opacity: 0, offset: 1 },
              ],
              { duration: 620, easing: ease, fill: 'forwards' }
            );
            const pa = piece.animate([{ opacity: 0, scale: 0.96 }, { opacity: 1, scale: 1 }], { duration: 300, delay: 380, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' });
            runs.push(pa);
            await fly.finished.catch(() => {});
            fly.cancel();
            this.dm.style.transformOrigin = '';
          } else if (dst && dst.width) {
            const sc = dst.width / src.width;
            const cut = Math.max(0, (src.height - dst.height / sc) / 2);
            const r = parseFloat(getComputedStyle(this.dm).borderTopLeftRadius) || 12;
            this.dm.style.transformOrigin = '0 0';
            const fly = this.dm.animate(
              [
                { transform: 'translate(0, 0) scale(1)', clipPath: `inset(0px 0 0px 0 round ${r}px)` },
                { transform: `translate(${dst.left - src.left}px, ${dst.top - src.top - cut * sc}px) scale(${sc})`, clipPath: `inset(${cut}px 0 ${cut}px 0 round ${r / sc}px)` },
              ],
              { duration: 560, easing: ease, fill: 'forwards' }
            );
            await fly.finished.catch(() => {});
            fly.cancel();
            this.dm.style.transformOrigin = '';
          } else {
            await new Promise((r) => setTimeout(r, 300));
          }
          fades.forEach((a) => a.cancel());
          this.style.minHeight = '';
          this.finishClose(back, i);
          this.busy = false;
        }

        // multiply, done once in the pixels: out = min(1, px · 1.035) · tile (same as the CSS blend + lift). Cached per picture.
        async bake(img, force) {
          const src = img.currentSrc || img.src;
          if (!this.baking || !src || /^(blob|data):/.test(src)) return;
          img.classList.remove('is-baked');
          if (!force && getComputedStyle(img).mixBlendMode !== 'multiply') return;
          if (!this.tileRGB) {
            const pr = document.createElement('span');
            pr.style.cssText = 'position:absolute;width:0;height:0;background:var(--werk-tile)';
            this.append(pr);
            this.tileRGB = (getComputedStyle(pr).backgroundColor.match(/[\d.]+/g) || [255, 255, 255]).slice(0, 3).map(Number);
            pr.remove();
          }
          const [tr, tg, tb] = this.tileRGB;
          const key = src + '|' + this.tileRGB;
          const cache = (window.werkBaked ||= new Map());
          if (!cache.has(key)) {
            cache.set(
              key,
              (async () => {
                // a CORS-ready picture is read as it is; any other is fetched once more
                const bmp = img.crossOrigin != null && img.complete && img.naturalWidth && !img.dataset.plain ? await createImageBitmap(img) : await createImageBitmap(await (await fetch(src, { mode: 'cors' })).blob());
                const c = document.createElement('canvas');
                c.width = bmp.width;
                c.height = bmp.height;
                const x = c.getContext('2d', { willReadFrequently: true });
                x.drawImage(bmp, 0, 0);
                const d = x.getImageData(0, 0, c.width, c.height);
                const p = d.data;
                const kr = (1.035 * tr) / 255, kg = (1.035 * tg) / 255, kb = (1.035 * tb) / 255;
                for (let i = 0; i < p.length; i += 4) {
                  p[i] = Math.min(255 * kr / 1.035, p[i] * kr);
                  p[i + 1] = Math.min(255 * kg / 1.035, p[i + 1] * kg);
                  p[i + 2] = Math.min(255 * kb / 1.035, p[i + 2] * kb);
                }
                x.putImageData(d, 0, 0);
                const blob = await new Promise((r) => c.toBlob(r, 'image/jpeg', 0.92));
                return URL.createObjectURL(blob);
              })().catch(() => null)
            );
          }
          const url = await cache.get(key);
          if ((img.currentSrc || img.src) !== src) return; // changed meanwhile – its own load bakes it
          if (!url) return void img.classList.add('is-baked'); // could not read it: show it as it is
          img.dataset.o = src;
          img.src = url; // first the new source, then drop srcset – the other way round reloads the old fallback
          img.removeAttribute('srcset');
          img.classList.add('is-baked');
        }

        // the element that scrolls the page (Horizon: div.page-wrapper, else the document)
        scroller() {
          for (let el = this.parentElement; el && el !== document.body; el = el.parentElement) {
            const o = getComputedStyle(el).overflowY;
            if ((o === 'auto' || o === 'scroll') && el.scrollHeight > el.clientHeight) return el;
          }
          return document.scrollingElement || document.documentElement;
        }

        finishClose(back, i) {
          this.stage.classList.remove('is-dual', 'is-dual-done');
          this.dual.hidden = true;
          this.dual.removeAttribute('style');
          this.isDual = false;
          this.lookList = null;
          this.lookEl = null;
          const card = this.cardOf(i);
          if (card) this.paintCard(card, this.d.products[i]);
          (card?.querySelector('.werk-product-slider_name') || [...(back?.querySelectorAll('[data-open-p]') || [])].find((b) => +b.dataset.openP === i) || back?.querySelector('button, a'))?.focus({ preventScroll: true });
          this.wake(true);
        }

        ease() {
          return getComputedStyle(this.querySelector('.werk-product-slider_inner')).getPropertyValue('--werk-ease').trim() || 'ease-out';
        }

        step(dir) {
          if (!this.isDual || this.busy) return;
          const list = this.list();
          const k = list.indexOf(this.cur);
          const next = list[(k + dir + list.length) % list.length];
          if (next == null || next === this.cur) return;
          this.cur = next;
          this.render(next, dir);
        }

        // ----- render the dual view for product i -----
        render(i, dir) {
          const p = this.d.products[i];
          const list = this.list();
          const k = list.indexOf(i);
          const pad = (n) => String(n).padStart(2, '0');
          this.countEl.textContent = k >= 0 ? `${pad(k + 1)} / ${pad(list.length)}` : '';
          const all = this.dual.querySelector('[data-all]');
          const one = list.length === 1;
          if (all) all.textContent = (this.lookList ? (one && this.t.piecesOne) || this.t.pieces || this.t.all : (one && this.t.allOne) || this.t.all || '').replace('[n]', list.length);
          this.renderGallery(p, dir || 0, dir ? 'product' : 'init');
          this.renderDetail(p, !!dir);
          // rail: every product of the row (or the look's pieces)
          this.railEl.innerHTML = list
            .map((j) => {
              const q = this.d.products[j];
              const m = this.media(q, q.ci >= 0 ? this.selection(q)[q.ci] : null)[0];
              const img = m ? `<img src="${this.esc(m[0] + (m[0].includes('?') ? '&' : '?') + 'width=160')}" alt=""${this.baking && m[1] === 'c' ? ' crossorigin="anonymous"' : ''} data-u="${this.esc(m[0])}" data-w="160"${m[1] === 'c' ? ' class="is-contain"' : ''}>` : '';
              return `<button type="button" class="werk-product-slider_tn${j === i ? ' is-on' : ''}" data-j="${j}" aria-label="${this.esc(q.t)}"${j === i ? ' aria-current="true"' : ''}>${img}</button>`;
            })
            .join('');
          this.railEl.querySelectorAll('[data-j]').forEach((b) =>
            b.addEventListener('click', () => {
              const j = +b.dataset.j;
              if (j === this.cur) return;
              const d = list.indexOf(j) > list.indexOf(this.cur) ? 1 : -1;
              this.cur = j;
              this.render(j, d);
            }, { signal: this.ac.signal })
          );
          this.railEl.querySelector('.is-on')?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          list.forEach((j) => this.sort(this.d.products[j])); // the neighbours, before someone steps to them
        }

        // ----- gallery: every picture on its own tile (so multiply never meets an empty backdrop while it moves) -----
        url(m, w) {
          return m[0] + (m[0].includes('?') ? '&' : '?') + 'width=' + w;
        }
        // first = a picture that is already loaded (the card's): it shows at once, the big one replaces it when ready
        slide(m, alt, first) {
          const d = document.createElement('div');
          d.className = 'werk-product-slider_slide';
          const im = new Image();
          const big = this.url(m, 1400);
          const cut = m[1] === 'c';
          im.alt = alt || '';
          im.decoding = 'async';
          im.dataset.u = m[0];
          im.dataset.w = 1400;
          if (m[2]) im.style.setProperty('--fp', m[2]);
          if (cut) im.className = 'is-contain';
          if (cut && this.baking) im.crossOrigin = 'anonymous';
          if (!first || this.bare(first) === this.bare(big)) im.src = big;
          else {
            im.src = first;
            if (/^blob:/.test(first)) im.classList.add('is-baked');
            const hi = new Image();
            if (cut && this.baking) hi.crossOrigin = 'anonymous';
            hi.decoding = 'async';
            hi.src = big;
            hi.decode().then(async () => {
              if (cut && this.baking) await this.bake(hi, true);
              if (!im.isConnected || im.dataset.u !== m[0]) return;
              im.src = hi.src;
              if (/^blob:/.test(hi.src)) im.classList.add('is-baked');
            }, () => {});
          }
          d.append(im);
          return d;
        }
        renderGallery(p, dir = 0, mode = 'init') {
          const color = p.ci >= 0 ? this.selection(p)[p.ci] : null;
          const imgs = this.media(p, color);
          let k0 = 0;
          const shown = mode === 'init' ? this.startSrc : '';
          if (shown) {
            const want = this.bare(this.startSrc);
            k0 = Math.max(0, imgs.findIndex((m) => this.bare(m[0]) === want));
          }
          this.startSrc = '';
          this.gimgs = imgs;
          this.gp = p;
          // (one picture still gets its thumbnail – an empty column reads as “something is missing”)
          this.thumbsEl.innerHTML = imgs.map((m, k) => `<button type="button" class="werk-product-slider_tn" data-g="${k}" aria-label="${this.esc((this.t.pic || '[n] / [total]').replace('[n]', k + 1).replace('[total]', imgs.length))}"><img src="${this.esc(this.url(m, 200))}" alt=""${this.baking && m[1] === 'c' ? ' crossorigin="anonymous"' : ''} data-u="${this.esc(m[0])}" data-w="200" class="${m[1] === 'c' ? 'is-contain' : ''}"></button>`).join('');
          this.thumbsEl.querySelectorAll('[data-g]').forEach((b) => b.addEventListener('click', () => this.showImg(+b.dataset.g), { signal: this.ac.signal }));
          this.dots.innerHTML = imgs.length > 1 ? imgs.map(() => '<i></i>').join('') : '';
          this.gi = k0;
          this.markImg(k0);
          if (!imgs.length) return void this.gal.replaceChildren();
          // opening: start with the file the card already shows (no empty tile while it flies), then sharpen
          const slide = this.slide(imgs[k0], p.t, mode === 'init' ? shown || this.cardSrc(this.cur, imgs[k0]) : '');
          if (mode === 'init' || !this.moves() || !this.gal.firstElementChild) return void this.gal.replaceChildren(slide);
          this.swapSlide(slide, dir, mode);
        }
        markImg(k) {
          const n = this.gimgs?.length || 0;
          this.thumbsEl.querySelectorAll('.werk-product-slider_tn').forEach((b, j) => b.classList.toggle('is-on', j === k));
          [...this.dots.children].forEach((d, j) => d.classList.toggle('is-on', j === k));
          this.gn.textContent = n > 1 ? `${k + 1} / ${n}` : '';
        }
        showImg(k, dir) {
          const n = this.gimgs?.length || 0;
          if (n < 2) return;
          k = (k + n) % n;
          if (k === this.gi) return;
          const d = dir || (k > this.gi ? 1 : -1);
          this.gi = k;
          this.markImg(k);
          const slide = this.slide(this.gimgs[k], this.gp?.t);
          if (!this.moves()) return void this.gal.replaceChildren(slide);
          this.swapSlide(slide, d, 'image');
        }
        // product / picture: the new one wipes in from the side it comes from, its picture glides the last bit;
        // the old one drifts back and dims. Colour: a soft cross-fade with a settle. Always decoded first.
        async swapSlide(slide, dir, mode) {
          const token = (this.gTok = (this.gTok || 0) + 1);
          const img = slide.firstChild;
          try {
            await img.decode();
          } catch {}
          if (this.baking && img.classList.contains('is-contain')) {
            await this.bake(img, true);
            try {
              await img.decode();
            } catch {}
          }
          if (token !== this.gTok) return;
          const old = [...this.gal.children];
          this.gal.append(slide);
          const ease = this.ease();
          const soft = 'cubic-bezier(0.22, 1, 0.36, 1)';
          const D = mode === 'color' ? 620 : mode === 'image' ? 760 : 900;
          if (mode === 'color') {
            slide.animate([{ opacity: 0 }, { opacity: 1 }], { duration: D, easing: soft });
            img.animate([{ scale: '1.035', filter: img.className && !img.classList.contains('is-baked') ? 'brightness(1.035) blur(6px)' : 'blur(6px)' }, { scale: '1', filter: img.className && !img.classList.contains('is-baked') ? 'brightness(1.035) blur(0px)' : 'blur(0px)' }], { duration: D + 180, easing: soft });
          } else {
            const from = dir < 0 ? 'inset(0 100% 0 0)' : 'inset(0 0 0 100%)';
            slide.animate([{ clipPath: from }, { clipPath: 'inset(0 0 0 0)' }], { duration: D, easing: ease });
            img.animate([{ translate: `${dir * 14}% 0`, scale: '1.08' }, { translate: '0 0', scale: '1' }], { duration: D + 160, easing: ease });
            old.forEach((o) => o.animate([{ translate: '0 0', filter: 'brightness(1)' }, { translate: `${-dir * 8}% 0`, filter: 'brightness(0.86)' }], { duration: D, easing: ease, fill: 'forwards' }));
          }
          await new Promise((r) => setTimeout(r, D + 200));
          if (token === this.gTok) old.forEach((o) => o.remove());
        }

        // text that changes rolls: the old line leaves upwards, the new one comes from below
        roll(el, text) {
          if (!el) return;
          const now = el.dataset.text ?? el.textContent;
          if (now === text) return;
          el.dataset.text = text;
          if (!this.moves() || !el.animate) return void (el.textContent = text);
          const a = document.createElement('span');
          const b = document.createElement('span');
          a.textContent = now;
          b.textContent = text;
          el.replaceChildren(a, b);
          el.classList.add('is-rolling');
          a.animate([{ translate: '0 0', opacity: 1 }, { translate: '0 -105%', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)', fill: 'forwards' });
          b.animate([{ translate: '0 105%', opacity: 0 }, { translate: '0 0', opacity: 1 }], { duration: 520, delay: 60, easing: this.ease(), fill: 'backwards' }).finished.then(() => {
            if (el.dataset.text !== text) return;
            el.textContent = text;
            el.classList.remove('is-rolling');
          }, () => {});
        }

        atcLabel(p) {
          const v = this.variant(p);
          return v && v.a ? `${this.t.cartAdd}  ·  ${this.money(v.p)}` : this.t.sold;
        }

        // ----- the small buy box: built once per product, option clicks update it in place -----
        renderDetail(p, anim) {
          const v = this.variant(p);
          const sel = this.selection(p);
          const opts = p.o
            .map((name, k) => {
              const vals = p.ov[k] || [];
              if (vals.length < 2 && k !== p.si) return '';
              const label = `<p class="werk-product-slider_opt-label">${this.esc(name)} <b data-ol="${k}">${this.esc(sel[k] || '')}</b></p>`;
              if (k === p.ci) {
                return `<div class="werk-product-slider_opt">${label}<div class="werk-product-slider_swatches werk-product-slider_opt-values" role="group" aria-label="${this.esc(name)}">${vals
                  .map((x, j) => `<button type="button" class="werk-product-slider_swatch" data-k="${k}" data-v="${this.esc(x)}" aria-pressed="${x === sel[k]}" aria-label="${this.esc(x)}" title="${this.esc(x)}"><span></span></button>`)
                  .join('')}</div></div>`;
              }
              return `<div class="werk-product-slider_opt">${label}<div class="werk-product-slider_opt-values" role="group" aria-label="${this.esc(name)}">${vals
                .map((x) => `<button type="button" class="werk-product-slider_chip" data-k="${k}" data-v="${this.esc(x)}" aria-pressed="${x === sel[k]}"${this.soldValue(p, k, x) ? ' aria-disabled="true"' : ''}>${this.esc(x)}</button>`)
                .join('')}</div></div>`;
            })
            .join('');
          const theme = this.classList.contains('is-theme-buttons') ? ' button' : '';
          const html = `
            <div class="werk-product-slider_dhead"><h3 class="werk-product-slider_dname">${this.esc(p.t)}</h3><p class="werk-product-slider_dprice" data-dp>${this.priceHTML(v || p.v[0])}</p></div>
            ${p.d ? `<p class="werk-product-slider_desc">${this.esc(p.d)}</p>` : ''}
            ${opts}
            <div class="werk-product-slider_buy">
              ${p.sp ? `<a class="werk-product-slider_atc${theme}" href="${this.esc(p.u)}"><span class="werk-product-slider_atc-in"><span class="werk-product-slider_atc-label">${this.esc(this.t.details || this.t.cartAdd)}</span></span></a>` : `
              <button type="button" class="werk-product-slider_atc${theme}" data-atc${v && v.a ? '' : ' disabled'}>
                <span class="werk-product-slider_atc-fill" aria-hidden="true"></span>
                <span class="werk-product-slider_atc-in">
                  <span class="werk-product-slider_atc-label" data-al>${this.esc(this.atcLabel(p))}</span>
                  <span class="werk-product-slider_atc-done" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3.2 3L13 4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span data-done></span></span>
                </span>
              </button>`}
              ${p.u && this.t.details && !p.sp ? `<a class="werk-product-slider_link werk-product-slider_more-link" href="${this.esc(p.u)}"><span class="werk-product-slider_link-dot" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M5 12h14m-5.5-5.5L19 12l-5.5 5.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span class="werk-product-slider_link-text"><span>${this.esc(this.t.details)} →</span></span></a>` : ''}
            </div>`;
          const token = (this.dTok = (this.dTok || 0) + 1);
          const fill = () => {
            if (token !== this.dTok) return;
            this.detail.innerHTML = html;
            this.wireDetail(p);
            if (anim && this.moves()) {
              [...this.detail.children].forEach((el, k) => el.animate([{ opacity: 0, translate: '0 14px' }, { opacity: 1, translate: '0 0' }], { duration: 640, delay: 40 + k * 55, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' }));
            }
          };
          // another product: the old buy box steps out first
          if (anim && this.moves() && this.detail.firstElementChild) {
            const outs = [...this.detail.children].map((el, k) => el.animate([{ opacity: 1, translate: '0 0' }, { opacity: 0, translate: '0 -8px' }], { duration: 200, delay: k * 18, easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)', fill: 'forwards' }));
            Promise.all(outs.map((a) => a.finished.catch(() => {}))).then(fill);
          } else fill();
        }

        // the dark indicator under the chosen chip of every chip group
        placeInd(still) {
          this.detail.querySelectorAll('.werk-product-slider_opt-values:not(.werk-product-slider_swatches)').forEach((g) => {
            let ind = g.querySelector('.werk-product-slider_ind');
            if (!ind) {
              ind = document.createElement('span');
              ind.className = 'werk-product-slider_ind';
              ind.setAttribute('aria-hidden', 'true');
              g.prepend(ind);
              still = true;
            }
            const on = g.querySelector('.werk-product-slider_chip[aria-pressed="true"]');
            ind.classList.toggle('is-still', !!still || !this.moves());
            if (!on) return void (ind.style.opacity = '0');
            ind.style.opacity = '1';
            ind.style.width = on.offsetWidth + 'px';
            ind.style.height = on.offsetHeight + 'px';
            ind.style.translate = `${on.offsetLeft}px ${on.offsetTop}px`;
            if (still) requestAnimationFrame(() => ind.classList.remove('is-still'));
          });
        }

        wireDetail(p) {
          this.detail.querySelectorAll('.werk-product-slider_swatch').forEach((sw, j) => this.paint(sw.firstElementChild, p, j));
          this.placeInd(true);
          if (!this.indRO) {
            this.indRO = new ResizeObserver(() => this.isDual && this.placeInd(true));
            this.indRO.observe(this.detail);
          }
          this.detail.querySelectorAll('[data-k]').forEach((b) =>
            b.addEventListener('click', () => this.pickOpt(p, +b.dataset.k, b.dataset.v, b), { signal: this.ac.signal })
          );
          const atc = this.detail.querySelector('[data-atc]');
          atc?.addEventListener('click', () => this.addDual(p, atc), { signal: this.ac.signal });
        }

        pickOpt(p, k, value, btn) {
          if (btn.getAttribute('aria-disabled') === 'true') return;
          const before = [...this.selection(p)];
          const s2 = [...before];
          s2[k] = value;
          if (!this.variant(p, s2)?.a && k === p.ci) {
            const alt = p.v.find((x) => x.o[k] === value && x.a);
            if (alt) s2.splice(0, s2.length, ...alt.o);
          }
          this.sel[p.id] = s2;
          // pressed states, sold-out marks, the labels above each group
          this.detail.querySelectorAll('[data-k]').forEach((b) => {
            const kk = +b.dataset.k;
            b.setAttribute('aria-pressed', String(b.dataset.v === s2[kk]));
            if (b.classList.contains('werk-product-slider_chip')) {
              if (this.soldValue(p, kk, b.dataset.v)) b.setAttribute('aria-disabled', 'true');
              else b.removeAttribute('aria-disabled');
            }
          });
          this.detail.querySelectorAll('[data-ol]').forEach((el) => this.roll(el, s2[+el.dataset.ol] || ''));
          this.placeInd(false);
          if (k === p.ci && this.moves()) {
            btn.classList.remove('is-draw');
            void btn.offsetWidth;
            btn.classList.add('is-draw');
          }
          // price and button roll to the new variant
          const v = this.variant(p);
          const dp = this.detail.querySelector('[data-dp]');
          if (dp && v && dp.innerHTML !== this.priceHTML(v)) {
            if (v.c > v.p || !this.moves()) dp.innerHTML = this.priceHTML(v);
            else this.roll(dp, this.money(v.p));
          }
          const atc = this.detail.querySelector('[data-atc]');
          if (atc && !atc.dataset.state) {
            atc.disabled = !(v && v.a);
            this.roll(atc.querySelector('[data-al]'), this.atcLabel(p));
          }
          if (k === p.ci && s2[k] !== before[k]) this.renderGallery(p, 0, 'color');
          // the rail shows the chosen colour too
          const tn = this.railEl.querySelector(`[data-j="${this.cur}"] img`);
          const m = this.media(p, p.ci >= 0 ? s2[p.ci] : null)[0];
          if (tn && m) tn.src = this.url(m, 160);
        }

        async addDual(p, atc) {
          const v = this.variant(p);
          if (!v || !v.a || atc.dataset.state) return;
          const size = p.si >= 0 ? this.selection(p)[p.si] : '';
          atc.querySelector('[data-done]').textContent = this.t.added + (size && p.ov[p.si].length > 1 ? ' · ' + size : '');
          atc.dataset.state = 'loading';
          const fillEl = atc.querySelector('.werk-product-slider_atc-fill');
          const moving = this.moves() && !!fillEl.animate;
          // the fill crawls towards the end while the cart answers, then completes before “Added” shows
          const crawl = moving ? fillEl.animate([{ scale: '0 1' }, { scale: '0.9 1' }], { duration: 900, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }) : null;
          const t0 = performance.now();
          const ok = await this.cartAdd([{ id: v.id, quantity: 1 }]);
          await new Promise((r) => setTimeout(r, Math.max(0, (moving ? 650 : 0) - (performance.now() - t0))));
          if (crawl) {
            const now = getComputedStyle(fillEl).scale;
            crawl.cancel();
            if (ok === true) await fillEl.animate([{ scale: now }, { scale: '1 1' }], { duration: 240, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }).finished.then((a) => a, () => {});
            fillEl.getAnimations().forEach((a) => a.cancel());
          }
          if (ok !== true) {
            delete atc.dataset.state;
            const f = document.createElement('p');
            f.className = 'werk-product-slider_flash';
            f.setAttribute('role', 'status');
            f.textContent = typeof ok === 'string' ? ok : this.t.error;
            this.detail.append(f);
            setTimeout(() => f.remove(), 3200);
            return;
          }
          atc.dataset.state = 'added';
          // a look: the next piece comes by itself
          const list = this.lookList;
          const k = list ? list.indexOf(this.cur) : -1;
          if (list && k >= 0 && k < list.length - 1) {
            setTimeout(() => this.isDual && this.cur === list[k] && this.step(1), 1100);
          }
          setTimeout(() => atc.isConnected && delete atc.dataset.state, 2000);
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-product-stage"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-product-stage')) {
    customElements.define(
      'werk-product-stage',
      class extends HTMLElement {
        connectedCallback() {
          const q = (this.q = (s) => this.querySelector(s));
          const qa = (this.qa = (s) => [...this.querySelectorAll(s)]);
          try {
            this.d = JSON.parse(q('script[data-werk]').textContent);
            this.t = JSON.parse(q('script[data-werk-t]').textContent);
          } catch {
            return;
          }
          this.n = this.d.length;
          this.i = 0;
          this.inner = q('.werk-product-stage_inner');
          this.stage = q('.werk-product-stage_stage');
          this.media = q('.werk-product-stage_media');
          this.bgs = qa('.werk-product-stage_bg');
          this.heads = qa('.werk-product-stage_head');
          this.shots = qa('.werk-product-stage_shot');
          this.thumbs = qa('.werk-product-stage_thumb');
          this.card = q('.werk-product-stage_card');
          this.cfg = q('.werk-product-stage_cfg');
          this.form = q('.werk-product-stage_form');
          this.addBtn = q('[data-add]');
          this.addWrap = q('.werk-product-stage_add');
          this.qtyEl = q('[data-qty]');
          this.receipt = q('[data-receipt]');
          this.cursor = q('.werk-product-stage_cursor');
          this.sr = q('.werk-product-stage_sr');
          this.portrait = this.classList.contains('is-portrait');
          this.auto = +this.dataset.autoplay || 0;
          this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.speed = this.dataset.motion === 'on' && !this.reduced ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          this.holds = new Set();
          this.anims = [];
          this.qty = 1;
          const cs = getComputedStyle(this.inner);
          this.easeCss = cs.getPropertyValue('--werk-ease').trim() || 'ease';
          this.ease = this.bezier(this.easeCss);
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.heads.forEach((h) => this.split(h));

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, opts) => el?.addEventListener(type, fn, { signal: ac.signal, ...opts });
          on(this, 'click', (e) => this.onClick(e), { capture: true });
          on(this, 'submit', (e) => this.onSubmit(e));
          on(this, 'animationend', (e) => {
            if (e.target.classList.contains('werk-product-stage_timer') && e.target.classList.contains('is-run')) this.go(this.i + 1, { dir: 1 });
          });
          on(this.stage, 'keydown', (e) => {
            if (e.target !== this.stage) return;
            if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
              e.preventDefault();
              const d = e.key === 'ArrowLeft' ? -1 : 1;
              this.go(this.i + d, { dir: d });
            }
          });
          on(document, 'keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) this.close();
          });
          on(document, 'pointerdown', (e) => {
            if (this.isOpen && !this.cfg.contains(e.target) && !e.target.closest?.('[data-choose]')) this.close();
          });
          on(document, 'visibilitychange', () => this.hold('tab', document.hidden));
          on(document, 'shopify:block:select', (e) => {
            const h = e.target.closest?.('.werk-product-stage_head');
            if (!h || !this.contains(h)) return;
            this.go(+h.dataset.i, { instant: true });
            this.hold('editor', true);
          });
          on(document, 'shopify:block:deselect', () => this.hold('editor', false));

          // pause while the pointer or focus is on something to read or press
          // read from what is under the pointer, not from enter/leave per element: a card that is hidden
          // under the pointer never gets its pointerleave, and overlapping holds (card + options) cancel each other
          const hover = (e) => this.hold('hover', !!e.target.closest?.('[data-hold]'));
          on(this, 'pointerover', hover);
          on(this, 'pointermove', hover);
          on(this, 'pointerleave', () => this.hold('hover', false));
          // only keyboard focus pauses – a clicked button keeps focus and would otherwise stop the timer for good;
          // focus handed back to the opener on close does not count either
          on(this, 'focusin', (e) => this.hold('focus', !this.refocus && !!e.target.closest('[data-hold]') && e.target.matches(':focus-visible')));
          on(this, 'focusout', (e) => {
            if (!this.contains(e.relatedTarget)) this.hold('focus', false);
          });

          // drag / swipe
          if (this.hasAttribute('data-drag')) {
            on(this.stage, 'pointerdown', (e) => this.onDown(e));
            on(this.stage, 'pointermove', (e) => this.onDrag(e));
            on(this.stage, 'pointerup', (e) => this.onUp(e));
            on(this.stage, 'pointercancel', (e) => this.onUp(e));
          }
          on(this.stage, 'pointerdown', (e) => (this.pointer = e.pointerType));
          on(this.stage, 'dragstart', (e) => e.preventDefault());
          const grab = q('[data-grab]');
          ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'].forEach((t) => on(grab, t, (e) => this.onGrab(e)));
          // keyboard: the grabber is a button
          on(grab, 'click', (e) => e.detail === 0 && this.close());

          // cursor (mouse only)
          if (this.hasAttribute('data-cursor') && matchMedia('(hover: hover) and (pointer: fine)').matches) {
            this.classList.add('has-cursor');
            on(this.stage, 'pointermove', (e) => this.onMove(e));
            on(this.stage, 'pointerleave', () => this.cursor.classList.remove('is-on'));
            const measure = () =>
              qa('.werk-product-stage_cursor-l').forEach((l) => this.cursor.style.setProperty('--cw-' + l.dataset.c, Math.ceil(l.scrollWidth + 28) + 'px'));
            measure();
            document.fonts?.ready.then(measure);
          }
          // the card lifts under the "View product" cursor
          if (this.card) {
            const shotsLink = q('.werk-product-stage_shots');
            on(shotsLink, 'pointerenter', (e) => e.pointerType === 'mouse' && this.card.classList.add('is-hover'));
            on(shotsLink, 'pointerleave', () => this.card.classList.remove('is-hover'));
          }
          // Filmstrip: hovering a thumbnail shows its product
          if (this.hasAttribute('data-preview')) {
            this.thumbs.forEach((th) => {
              on(th, 'pointerenter', (e) => {
                if (e.pointerType !== 'mouse') return;
                clearTimeout(this.pt);
                this.pt = setTimeout(() => this.go(+th.dataset.i, { fast: true }), 120);
              });
              on(th, 'pointerleave', () => clearTimeout(this.pt));
            });
          }

          this.render(0, true);
          const refit = () => {
            cancelAnimationFrame(this.fr);
            this.fr = requestAnimationFrame(() => (this.fit(), this.fitStrip(), this.fitAdd()));
          };
          this.ro = new ResizeObserver(refit);
          this.ro.observe(this.stage);
          document.fonts?.ready.then(() => (this.fit(), this.fitStrip()));
          this.io = new IntersectionObserver(
            ([en]) => {
              this.hold('view', !en.isIntersecting);
              if (en.isIntersecting && !this.classList.contains('is-inview')) {
                this.load(1);
                this.load(this.n - 1);
                setTimeout(() => this.classList.add('is-inview'), 40);
              }
            },
            { threshold: 0.25 }
          );
          this.io.observe(this.stage);
          this.hold('tab', document.hidden);
          this.restart();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          this.ro?.disconnect();
          this.anims.forEach((a) => a.cancel());
          cancelAnimationFrame(this.raf);
          cancelAnimationFrame(this.craf);
          clearTimeout(this.pt);
          clearTimeout(this.st);
          clearTimeout(this.ct);
          clearTimeout(this.at);
        }

        // ---------- helpers ----------
        bezier(css) {
          const m = css.match(/cubic-bezier\(([^)]+)\)/);
          if (!m) return (x) => x;
          const [x1, y1, x2, y2] = m[1].split(',').map(Number);
          const bx = (s) => 3 * (1 - s) * (1 - s) * s * x1 + 3 * (1 - s) * s * s * x2 + s * s * s;
          const by = (s) => 3 * (1 - s) * (1 - s) * s * y1 + 3 * (1 - s) * s * s * y2 + s * s * s;
          return (x) => {
            let s = x;
            for (let k = 0; k < 8; k++) {
              const d = 3 * (1 - s) * (1 - s) * x1 + 6 * (1 - s) * s * (x2 - x1) + 3 * s * s * (1 - x2);
              if (Math.abs(d) < 1e-6) break;
              s = Math.min(1, Math.max(0, s - (bx(s) - x) / d));
            }
            return by(s);
          };
        }

        esc(s) {
          return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
        }

        fill(s, map = {}) {
          return (s || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? String(map[k]) : m));
        }

        px() {
          return parseFloat(getComputedStyle(this.inner).getPropertyValue('--werk-u')) || 1;
        }

        mobile() {
          return this.clientWidth < 750;
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-surface', bg);
          this.style.setProperty('--werk-ink', getComputedStyle(this).color);
        }

        // titles: letters (words for long names) rise out of a mask
        split(h) {
          const el = h.querySelector('.werk-product-stage_title');
          if (!el) return;
          const txt = el.textContent.trim();
          el.setAttribute('aria-label', txt);
          const byWord = txt.length > 18;
          let k = 0;
          el.innerHTML = txt
            .split(/\s+/)
            .map((w) => {
              const inner = byWord ? `<span class="werk-product-stage_c" style="--k:${k++}">${this.esc(w)}</span>` : [...w].map((c) => `<span class="werk-product-stage_c" style="--k:${k++}">${this.esc(c)}</span>`).join('');
              return `<span class="werk-product-stage_w" aria-hidden="true">${inner}</span>`;
            })
            .join(' ');
        }

        load(i) {
          const b = this.bgs[((i % this.n) + this.n) % this.n];
          if (!b) return;
          b.querySelectorAll('[data-src], [data-srcset]').forEach((el) => {
            if (el.dataset.srcset) el.srcset = el.dataset.srcset;
            if (el.dataset.src) el.src = el.dataset.src;
            el.removeAttribute('data-srcset');
            el.removeAttribute('data-src');
          });
        }

        // ---------- autoplay ----------
        hold(key, on) {
          if (on) this.holds.add(key);
          else this.holds.delete(key);
          this.classList.toggle('is-paused', this.holds.size > 0);
        }

        timerEl() {
          const next = this.classList.contains('is-timer-next');
          if (this.portrait) {
            if (next) return this.q('.werk-product-stage_nb--next .werk-product-stage_timer');
            return this.q(this.classList.contains('is-cta-pill') ? '.werk-product-stage_pill > .werk-product-stage_timer' : '.werk-product-stage_ring .werk-product-stage_timer');
          }
          return this.thumbs[next ? (this.i + 1) % this.n : this.i]?.querySelector('.werk-product-stage_timer');
        }

        restart() {
          this.qa('.werk-product-stage_timer.is-run').forEach((e) => e.classList.remove('is-run'));
          this.thumbs.forEach((t) => t.classList.remove('is-timing'));
          if (!this.auto || this.n < 2) return;
          const el = this.timerEl();
          if (!el) return;
          el.closest('.werk-product-stage_thumb')?.classList.add('is-timing');
          void el.getBoundingClientRect();
          el.classList.add('is-run');
        }

        // ---------- slides ----------
        settle() {
          this.anims.forEach((a) => a.cancel());
          this.anims = [];
          cancelAnimationFrame(this.raf);
          this.qa('.is-out').forEach((el) => el.classList.remove('is-out'));
          this.bgs.forEach((b) => (b.style.clipPath = ''));
        }

        run(el, frames, opts) {
          const a = el.animate(frames, opts);
          this.anims.push(a);
          return a;
        }

        go(to, o = {}) {
          const n = this.n;
          if (n < 2) return;
          to = ((to % n) + n) % n;
          if (to === this.i) return;
          if (this.isOpen) this.close(true);
          const from = this.i;
          const dir = o.dir || ((to - from + n) % n <= n / 2 ? 1 : -1);
          // where the next picture opens from (Aperture): the card, or the thumbnail of the next product
          const anchor = this.portrait ? this.q('.werk-product-stage_shots') : this.thumbs[to];
          const ar = anchor?.getBoundingClientRect();
          this.settle();
          this.i = to;
          [to, to + 1, to - 1].forEach((k) => this.load(k));
          const f = (o.fast ? 0.6 : 1) * this.speed;
          const instant = o.instant || (!this.speed && !this.reduced);

          const swap = (list) => {
            const a = list[from];
            const b = list[to];
            if (!a || !b) return [];
            a.classList.remove('is-active');
            if (!instant) a.classList.add('is-out');
            b.classList.add('is-active');
            return [a, b];
          };
          const [bo, bi] = swap(this.bgs);
          const [ho, hi] = swap(this.heads);
          ho?.setAttribute('aria-hidden', 'true');
          hi?.removeAttribute('aria-hidden');
          const [so, si] = swap(this.shots);
          this.thumbs.forEach((t, k) => t.classList.toggle('is-active', k === to));
          this.render(to);
          this.restart();
          if (instant) return;

          const done = () => this.settle();
          if (!this.speed) {
            // reduced motion: a plain crossfade
            this.run(bi, [{ opacity: 0 }, { opacity: 1 }], { duration: 300 }).finished.then(done, () => {});
            this.run(hi, [{ opacity: 0 }, { opacity: 1 }], { duration: 300 });
            if (ho) this.run(ho, [{ opacity: 1 }, { opacity: 0 }], { duration: 200, fill: 'forwards' });
            return;
          }

          // background
          const D = 1150 * f;
          const type = this.dataset.transition;
          let main;
          if (type === 'blinds') main = this.blinds(bi, dir, D);
          else if (type === 'drift') {
            main = this.run(bi, [{ opacity: 0, transform: `translateX(${dir * 1.6}%) scale(1.035)` }, { opacity: 1, transform: 'none' }], {
              duration: D * 1.3,
              easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
            }).finished;
            this.run(bo, [{ transform: 'none' }, { transform: `translateX(${dir * -1.2}%) scale(1.01)` }], { duration: D * 1.3, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'forwards' });
          } else {
            const m = this.media.getBoundingClientRect();
            const ins = ar
              ? [ar.top - m.top, m.right - ar.right, m.bottom - ar.bottom, ar.left - m.left].map((x) => Math.max(0, Math.round(x)) + 'px').join(' ')
              : '45% 45% 45% 45%';
            main = this.run(bi, [{ clipPath: `inset(${ins})` }, { clipPath: 'inset(0px 0px 0px 0px)' }], { duration: D, easing: this.easeCss }).finished;
            this.run(bo, [{ transform: 'scale(1)', filter: 'brightness(1)' }, { transform: 'scale(0.96)', filter: 'brightness(0.55)' }], { duration: D, easing: this.easeCss, fill: 'forwards' });
          }
          main.then(done, () => {});

          // title: the old one sinks, the new one rises letter by letter
          if (ho) {
            ho.querySelectorAll('.werk-product-stage_c').forEach((c, k) =>
              this.run(c, [{ transform: 'translateY(0)' }, { transform: 'translateY(105%)' }], { duration: 380 * f, delay: k * 10 * f, easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)', fill: 'forwards' })
            );
            ho.querySelectorAll('.werk-product-stage_eyebrow, .werk-product-stage_notes').forEach((el) => this.run(el, [{ opacity: el === ho.querySelector('.werk-product-stage_eyebrow') ? 0.85 : 0.85 }, { opacity: 0 }], { duration: 300 * f, fill: 'forwards' }));
          }
          if (hi) {
            hi.querySelectorAll('.werk-product-stage_c').forEach((c, k) =>
              this.run(c, [{ transform: 'translateY(105%)' }, { transform: 'translateY(0)' }], { duration: 950 * f, delay: (260 + k * 22) * f, easing: this.easeCss, fill: 'backwards' })
            );
            hi.querySelectorAll('.werk-product-stage_eyebrow, .werk-product-stage_notes').forEach((el, k) =>
              this.run(el, [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 0.85, transform: 'none' }], { duration: 700 * f, delay: (380 + k * 180) * f, easing: this.easeCss, fill: 'backwards' })
            );
          }

          // packshot: the old card tips back, the new one comes to the front
          if (so && si) {
            const u = this.px();
            this.run(so, [{ transform: 'none', opacity: 1 }, { transform: `translateY(${10 * u}px) scale(0.94)`, opacity: 0 }], { duration: 600 * f, easing: this.easeCss, fill: 'forwards' });
            this.run(si, [{ transform: `translateY(${-16 * u}px)`, opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 800 * f, delay: 150 * f, easing: this.easeCss, fill: 'backwards' });
          }
        }

        // six stripes open the next picture from the bottom, one after another in the direction of travel
        blinds(el, dir, D) {
          return new Promise((resolve) => {
            const N = 6;
            const lag = D * 0.07;
            const len = D - lag * (N - 1);
            const t0 = performance.now();
            const tick = (now) => {
              const t = now - t0;
              const pts = ['0% 100%'];
              for (let k = 0; k < N; k++) {
                const idx = dir > 0 ? k : N - 1 - k;
                const p = this.ease(Math.min(1, Math.max(0, (t - idx * lag) / len)));
                const y = (100 - p * 100).toFixed(2) + '%';
                pts.push(`${((k * 100) / N).toFixed(3)}% ${y}`, `${(((k + 1) * 100) / N).toFixed(3)}% ${y}`);
              }
              pts.push('100% 100%');
              el.style.clipPath = `polygon(${pts.join(',')})`;
              if (t < D) this.raf = requestAnimationFrame(tick);
              else {
                el.style.clipPath = '';
                resolve();
              }
            };
            this.raf = requestAnimationFrame(tick);
          });
        }

        // everything that shows the active product outside the card
        // giant type follows the room: no word wider than the stage, the head block stays clear of the card / strip / neighbours
        fit() {
          const h = this.heads[this.i];
          const top = this.q('.werk-product-stage_top');
          if (!h || !top) return;
          const title = h.querySelector('.werk-product-stage_title');
          const u = this.px();
          const R = (n) => n.getBoundingClientRect();
          title.style.setProperty('--fit', 1);
          top.style.setProperty('--shift', '0px');
          const cs = getComputedStyle(top);
          const room = top.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
          const widest = Math.max(1, ...[...title.querySelectorAll('.werk-product-stage_w')].map((w) => R(w).width));
          let fit = Math.min(1, room / widest);
          title.style.setProperty('--fit', fit);
          const st = R(this.stage);
          const below = this.qa('.werk-product-stage_card, .werk-product-stage_strip, .werk-product-stage_nb, .werk-product-stage_pb, .werk-product-stage_actions')
            .filter((n) => n.offsetParent !== null)
            .map((n) => R(n).top);
          const limit = Math.min(st.bottom, ...below) - 28 * u;
          const minTop = st.top + 36 * u;
          let r = R(top);
          for (let k = 0; k < 4 && r.height > limit - minTop + 1; k++) {
            const th = R(title).height;
            fit *= Math.max(0.25, (th - (r.height - (limit - minTop))) / th);
            title.style.setProperty('--fit', fit);
            r = R(top);
          }
          let shift = 0;
          if (r.bottom > limit) shift = limit - r.bottom;
          if (r.top + shift < minTop) shift = minTop - r.top;
          top.style.setProperty('--shift', shift + 'px');
        }

        // Filmstrip: thumbnails get smaller until the strip fits (not below 60 %), then the strip scrolls
        fitStrip() {
          const strip = this.q('.werk-product-stage_strip');
          if (!strip) return;
          const u = this.px();
          const top = this.q('.werk-product-stage_top');
          // the side edge: --werk-gx (side padding setting), read back from the title row that uses it
          const pad = top ? parseFloat(getComputedStyle(top).paddingLeft) || 0 : 48 * u;
          const w = this.stage.clientWidth;
          let room = w - 2 * pad;
          if (this.clientWidth >= 990) {
            const side = Math.max(this.q('.werk-product-stage_pb')?.offsetWidth || 0, this.q('.werk-product-stage_actions')?.offsetWidth || 0) + 32 * u;
            room = w - 2 * (pad + side);
          }
          const t = this.thumbs;
          const a = t.find((x) => x.classList.contains('is-active')) || t[0];
          const b = t.find((x) => x !== a) || a;
          const val = (x, k) => parseFloat(getComputedStyle(x).getPropertyValue(k)) * u;
          const gap = parseFloat(getComputedStyle(strip).columnGap) / (parseFloat(strip.style.getPropertyValue('--sk')) || 1);
          const need = val(a, '--tw') + (t.length - 1) * (val(b, '--tw') + gap);
          const sk = Math.max(0.6, Math.min(1, room / need));
          strip.style.setProperty('--sk', sk);
          strip.style.setProperty('--strip-max', room + 'px');
          strip.classList.toggle('is-scroll', need * sk > room + 1);
          if (strip.classList.contains('is-scroll')) {
            const x = this.thumbs[this.i];
            if (x) strip.scrollTo({ left: x.offsetLeft - (room - x.offsetWidth) / 2, behavior: this.speed ? 'smooth' : 'auto' });
          }
        }

        // the add button drops its price (it's in the receipt line) when the label wouldn't fit
        fitAdd() {
          const b = this.addBtn;
          if (!b || this.cfg.hidden) return;
          b.classList.remove('is-tight');
          const row = b.querySelector('.werk-product-stage_btn-row');
          const cs = getComputedStyle(b);
          const room = b.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
          b.classList.toggle('is-tight', row.scrollWidth > room + 1);
        }

        render(i, first) {
          const s = this.d[i];
          if (!s) return;
          this.dataset.tone = s.tone;
          this.cur = s;
          this.v = s.vars.find((x) => x.id === s.cur) || s.vars.find((x) => x.available) || s.vars[0];
          this.syncOutside(first);
          this.qa('[data-url]').forEach((a) => (a.href = s.u));
          const shots = this.q('.werk-product-stage_shots');
          if (shots) shots.setAttribute('aria-label', `${this.t.view}: ${s.t}`);
          const n = this.n;
          const pad = (x) => String(x).padStart(2, '0');
          const nb = (sel, k) => {
            const b = this.q(sel);
            if (!b) return;
            b.querySelector('[data-nb-no]').textContent = pad(k + 1);
            b.querySelector('[data-nb-name]').textContent = this.d[k].t;
          };
          nb('.werk-product-stage_nb--prev', (i - 1 + n) % n);
          nb('.werk-product-stage_nb--next', (i + 1) % n);
          if (!first && this.sr) this.sr.textContent = `${this.fill(this.t.slide, { n: i + 1, total: n })}: ${s.t}`;
          this.fit();
          this.fitStrip();
        }

        // price tag / pill / price block / choose button follow the active product (and the chosen variant)
        syncOutside(instant) {
          const s = this.cur;
          const v = this.v;
          if (!s || !v) return;
          this.qa('[data-price]').forEach((el) => this.roll(el, v.price, instant));
          const sub = [s.no, !s.single && v.o.length ? v.o.join(' / ') : ''].filter(Boolean).join(' · ');
          this.qa('[data-sub]').forEach((el) => {
            if (el.textContent === sub) return;
            el.textContent = sub;
            if (!instant && this.speed) el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 400 });
          });
          const any = s.vars.some((x) => x.available);
          const label = !any ? this.t.soldOut : s.single ? this.t.add : this.t.choose;
          this.qa('[data-choose]').forEach((b) => {
            b.disabled = !any;
            b.setAttribute('aria-label', label);
          });
          this.qa('[data-choose-label]').forEach((el) => (el.textContent = label));
        }

        // only the characters that change move (aligned from the right)
        roll(el, next, instant) {
          const prev = el.dataset.v ?? el.textContent;
          el.dataset.v = next;
          if (prev === next) return;
          clearTimeout(el._t);
          if (instant || !this.speed) {
            el.textContent = next;
            return;
          }
          const a = [...prev];
          const b = [...next];
          while (a.length < b.length) a.unshift('');
          while (b.length < a.length) b.unshift('');
          el.innerHTML = b.map((c, k) => (c === a[k] ? this.esc(c) : `<span class="werk-product-stage_ch"><i aria-hidden="true">${this.esc(a[k])}</i><i>${this.esc(c)}</i></span>`)).join('');
          el._t = setTimeout(() => (el.textContent = next), 480);
        }

        // ---------- drag ----------
        onDown(e) {
          if (this.isOpen || e.button !== 0) return;
          if (e.target.closest('button, input, .werk-product-stage_cfg, .werk-product-stage_nb, .werk-product-stage_actions')) return;
          this.dg = { x: e.clientX, y: e.clientY, t: performance.now(), id: e.pointerId, lock: null, dx: 0, v: 0 };
        }

        onDrag(e) {
          const g = this.dg;
          if (!g || e.pointerId !== g.id) return;
          const dx = e.clientX - g.x;
          const dy = e.clientY - g.y;
          if (!g.lock) {
            if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
            g.lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
            if (g.lock === 'x') {
              try {
                this.stage.setPointerCapture(g.id);
              } catch {}
              this.classList.add('is-dragging');
              this.hold('drag', true);
            }
          }
          if (g.lock !== 'x') return;
          const now = performance.now();
          g.v = (dx - g.dx) / Math.max(1, now - (g.lt || g.t));
          g.dx = dx;
          g.lt = now;
          this.style.setProperty('--dx', (dx * 0.85) / (1 + Math.abs(dx) / 1400) + 'px');
        }

        onUp(e) {
          const g = this.dg;
          this.dg = null;
          if (!g || g.lock !== 'x') return;
          this.classList.remove('is-dragging');
          this.hold('drag', false);
          this.style.setProperty('--dx', '0px');
          this.swiped = true;
          setTimeout(() => (this.swiped = false), 80);
          if (Math.abs(g.dx) > 70 || (Math.abs(g.dx) > 20 && Math.abs(g.v) > 0.45)) {
            const d = g.dx < 0 ? 1 : -1;
            this.go(this.i + d, { dir: d });
          }
        }

        // ---------- cursor ----------
        onMove(e) {
          const r = this.stage.getBoundingClientRect();
          this.tx = e.clientX - r.left;
          this.ty = e.clientY - r.top;
          const t = e.target;
          const mode = this.isOpen && this.cfg.contains(t) ? 'dot' : t.closest('[data-view]') ? 'view' : t.closest('button, a, input, .werk-product-stage_cfg') ? 'dot' : 'drag';
          if (this.cursor.dataset.mode !== mode) this.cursor.dataset.mode = mode;
          if (!this.cursor.classList.contains('is-on')) {
            this.cx = this.tx;
            this.cy = this.ty;
            this.cursor.classList.add('is-on');
          }
          if (!this.craf) this.craf = requestAnimationFrame(() => this.follow());
        }

        follow() {
          this.cx += (this.tx - this.cx) * (this.speed ? 0.22 : 1);
          this.cy += (this.ty - this.cy) * (this.speed ? 0.22 : 1);
          this.cursor.style.setProperty('--cx', this.cx + 'px');
          this.cursor.style.setProperty('--cy', this.cy + 'px');
          this.craf = Math.abs(this.tx - this.cx) + Math.abs(this.ty - this.cy) > 0.4 ? requestAnimationFrame(() => this.follow()) : 0;
        }

        // ---------- clicks ----------
        onClick(e) {
          if (this.swiped) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          const t = e.target;
          const nb = t.closest('[data-go]');
          if (nb) {
            this.go(this.i + +nb.dataset.go, { dir: +nb.dataset.go });
            return;
          }
          const th = t.closest('.werk-product-stage_thumb');
          if (th && +th.dataset.i !== this.i && this.pointer !== 'mouse') {
            // touch: the first tap shows the product, the second opens its page
            e.preventDefault();
            this.go(+th.dataset.i);
            return;
          }
          const ch = t.closest('[data-choose]');
          if (ch) {
            this.choose(ch);
            return;
          }
          if (t.closest('[data-close]')) {
            this.close();
            return;
          }
          const val = t.closest('.werk-product-stage_val');
          if (val) {
            this.pick(+val.dataset.opt, val.dataset.val);
            return;
          }
          const step = t.closest('.werk-product-stage_step');
          if (step) this.setQty(this.qty + +step.dataset.step);
        }

        choose(btn) {
          const s = this.cur;
          if (!s || btn.disabled) return;
          if (s.single) this.quickAdd(btn);
          else if (this.isOpen) this.close();
          else this.open(btn);
        }

        // ---------- choose options ----------
        open(opener) {
          const s = this.cur;
          this.isOpen = true;
          this.opener = opener;
          this.hold('open', true);
          this.cursor?.classList.remove('is-on');
          const set = (sel, v) => {
            const el = this.q(sel);
            if (el) el.textContent = v || '';
          };
          set('[data-cfg-no]', [s.no, s.e].filter(Boolean).join(' · '));
          set('[data-cfg-title]', s.t);
          set('[data-cfg-notes]', s.n);
          const img = this.q('[data-cfg-img]');
          if (img) img.src = s.img || '';
          this.q('[data-opts]').innerHTML = s.opts
            .map(
              (o, oi) =>
                `<div class="werk-product-stage_row" role="radiogroup" aria-label="${this.esc(o.name)}"><span class="werk-product-stage_lab">${this.esc(o.name)}</span><span class="werk-product-stage_vals">${o.values
                  .map((v) => `<button type="button" class="werk-product-stage_val" role="radio" aria-checked="false" data-opt="${oi}" data-val="${this.esc(v)}">${this.esc(v)}</button>`)
                  .join('')}</span></div>`
            )
            .join('');
          this.sel = [...this.v.o];
          this.qty = 1;
          this.unsplit();
          this.update(true);

          const cfg = this.cfg;
          cfg.hidden = false;
          this.classList.add('is-open');
          this.fitAdd();
          if (this.mobile()) {
            const r = cfg.getBoundingClientRect();
            // works for any scroll container (some themes scroll a wrapper, not the page)
            if (r.bottom > innerHeight + 2) cfg.scrollIntoView({ block: 'end', behavior: this.speed ? 'smooth' : 'auto' });
          }
          if (!this.speed) {
            this.focusFirst();
            return;
          }
          // the card grows out of what was pressed: the card's bottom edge (Portrait), the button (Filmstrip), the sheet slides up (mobile Portrait)
          const c = cfg.getBoundingClientRect();
          const px = (list) => list.map((x) => Math.max(0, x).toFixed(1) + 'px').join(' ');
          const kids = [...cfg.querySelector('.werk-product-stage_cfg-in').children];
          this.openAnim?.cancel();
          this.morph = null;
          let wait = 430;
          if (this.portrait) {
            let a;
            if (this.mobile()) a = { left: c.left, right: c.right };
            else {
              const w = this.card.offsetWidth;
              a = { left: c.left + (c.width - w) / 2, right: c.right - (c.width - w) / 2 };
            }
            this.openAnim = cfg.animate([{ clipPath: `inset(${px([c.height, c.right - a.right, 0, a.left - c.left])})` }, { clipPath: 'inset(0px 0px 0px 0px)' }], {
              duration: 650,
              easing: this.easeCss,
            });
          } else {
            // Filmstrip: the button widens to the card's width (its label stays put and fades), then grows upwards
            const a = opener.getBoundingClientRect();
            const bs = getComputedStyle(opener);
            const lab = this.q('.werk-product-stage_cfg-label');
            lab.textContent = opener.querySelector('[data-choose-label]')?.textContent || '';
            Object.assign(lab.style, { width: a.width + 'px', height: a.height + 'px', right: c.right - a.right + 'px', bottom: c.bottom - a.bottom + 'px', color: bs.color });
            const start = `inset(${px([a.top - c.top, c.right - a.right, c.bottom - a.bottom, a.left - c.left])})`;
            const bar = `inset(${px([a.top - c.top, 0, c.bottom - a.bottom, 0])})`;
            const surface = getComputedStyle(cfg).backgroundColor;
            this.morph = { start, bar, bg: bs.backgroundColor, surface };
            this.openAnim = cfg.animate(
              [
                { clipPath: start, backgroundColor: bs.backgroundColor, easing: 'cubic-bezier(0.5, 0, 0.2, 1)' },
                { clipPath: bar, backgroundColor: surface, offset: 0.38, easing: 'cubic-bezier(0.6, 0, 0.15, 1)' },
                { clipPath: 'inset(0px 0px 0px 0px)', backgroundColor: surface },
              ],
              { duration: 820 }
            );
            this.labAnim = lab.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(-10px)' }], { duration: 240, easing: 'ease-out', fill: 'forwards' });
            wait = 600;
          }
          // the content follows only when the card is (almost) complete
          this.inAnims = kids.map((el, k) =>
            el.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: wait + k * 40, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' })
          );
          setTimeout(() => this.focusFirst(), 480);
        }

        focusFirst() {
          if (!this.isOpen) return;
          const el = this.cfg.querySelector('.werk-product-stage_val[aria-checked="true"]') || this.cfg.querySelector('.werk-product-stage_val, [data-add]');
          el?.focus({ preventScroll: true });
        }

        close(fast, pulled) {
          if (!this.isOpen) return;
          this.isOpen = false;
          clearTimeout(this.ct);
          const cfg = this.cfg;
          const kids = [...cfg.querySelector('.werk-product-stage_cfg-in').children];
          const end = () => {
            this.inAnims?.forEach((a) => a.cancel());
            this.outAnims?.forEach((a) => a.cancel());
            this.openAnim?.cancel();
            this.openAnim = null;
            this.labAnim?.cancel();
            // the button is back in the same frame the card disappears (no fade gap)
            const o = this.opener;
            if (o) o.style.transition = 'none';
            this.classList.remove('is-open');
            void o?.offsetWidth;
            if (o) setTimeout(() => (o.style.transition = ''), 60);
            cfg.style.transform = '';
            cfg.hidden = true;
            this.hold('open', false);
            // the card was under the pointer and is gone now – the next pointer move tells what is under it
            this.hold('hover', false);
            // the timer starts over for the product on show
            this.restart();
          };
          if (cfg.contains(document.activeElement)) {
            this.refocus = true;
            this.opener?.focus({ preventScroll: true });
            this.refocus = false;
          }
          this.inAnims?.forEach((a) => a.cancel());
          if (fast || !this.speed) return end();
          // pulled down by the grabber: the sheet keeps going down
          if (pulled != null) {
            this.openAnim?.cancel();
            this.classList.remove('is-open');
            cfg.animate([{ transform: `translateY(${pulled}px)` }, { transform: 'translateY(100%)' }], { duration: 320, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }).finished.then(end, () => {});
            return;
          }
          if (!this.openAnim) return end();
          // the content goes first, then the card folds back into what opened it
          this.outAnims = kids.map((el) => el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, easing: 'ease-out', fill: 'forwards' }));
          const m = this.morph;
          const kf = this.openAnim.effect.getKeyframes();
          this.openAnim.cancel();
          if (m) {
            // Filmstrip: down to a bar, then back into the button, whose label fades back in
            this.openAnim = cfg.animate(
              [
                { clipPath: 'inset(0px 0px 0px 0px)', backgroundColor: m.surface, easing: 'cubic-bezier(0.6, 0, 0.4, 1)' },
                { clipPath: m.bar, backgroundColor: m.surface, offset: 0.55, easing: 'cubic-bezier(0.5, 0, 0.2, 1)' },
                { clipPath: m.start, backgroundColor: m.bg },
              ],
              { duration: 700, delay: 120, fill: 'both' }
            );
            this.labAnim?.cancel();
            this.labAnim = this.q('.werk-product-stage_cfg-label').animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, delay: 620, fill: 'both' });
          } else {
            this.openAnim = cfg.animate([{ clipPath: kf[kf.length - 1].clipPath }, { clipPath: kf[0].clipPath }], {
              duration: 480,
              delay: 120,
              easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)',
              fill: 'both',
            });
          }
          this.openAnim.finished.then(end, () => {});
        }

        // grabber: tap closes, pulling down drags the sheet and closes past 90 px (or a quick flick)
        onGrab(e) {
          const cfg = this.cfg;
          if (e.type === 'pointerdown') {
            this.gd = { y: e.clientY, t: performance.now(), dy: 0 };
            try {
              e.target.setPointerCapture(e.pointerId);
            } catch {}
            return;
          }
          const g = this.gd;
          if (!g) return;
          if (e.type === 'pointermove') {
            g.dy = Math.max(0, e.clientY - g.y);
            cfg.style.transform = `translateY(${g.dy}px)`;
            return;
          }
          this.gd = null;
          const v = g.dy / Math.max(1, performance.now() - g.t);
          if (g.dy < 6) {
            cfg.style.transform = '';
            this.close();
          } else if (g.dy > 90 || v > 0.5) this.close(false, g.dy);
          else {
            cfg.style.transform = '';
            cfg.animate([{ transform: `translateY(${g.dy}px)` }, { transform: 'none' }], { duration: 300, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
          }
        }

        find(sel) {
          return this.cur.vars.find((x) => x.o.every((o, j) => o === sel[j]));
        }

        pick(oi, val) {
          const sel = [...this.sel];
          sel[oi] = val;
          const withVal = this.cur.vars.filter((x) => x.o[oi] === val);
          const v = this.find(sel) || withVal.find((x) => x.available) || withVal[0];
          if (!v) return;
          this.v = v;
          this.sel = [...v.o];
          this.cur.cur = v.id;
          this.update();
        }

        update(first) {
          const v = this.v;
          this.qa('.werk-product-stage_val').forEach((b) => {
            const oi = +b.dataset.opt;
            const val = b.dataset.val;
            b.setAttribute('aria-checked', this.sel[oi] === val ? 'true' : 'false');
            const cand = this.cur.vars.filter((x) => x.o[oi] === val && x.o.every((o, j) => j === oi || o === this.sel[j]));
            b.classList.toggle('is-out', !cand.some((x) => x.available));
          });
          const price = this.q('[data-cfg-price]');
          if (price) this.roll(price, v.price, first);
          this.addBtn.disabled = !v.available;
          const l = this.addBtn.querySelector('[data-add-label]');
          if (l) l.textContent = v.available ? this.t.add : this.t.soldOut;
          this.form.elements.id.value = v.id;
          this.unsplit();
          this.setQty(first ? 1 : this.qty);
          this.syncOutside(first);
          this.fitAdd();
        }

        setQty(n) {
          this.qty = Math.min(Math.max(1, n), 999);
          if (this.qtyEl) this.roll(this.qtyEl, String(this.qty));
          this.form.elements.quantity.value = this.qty;
          this.qa('.werk-product-stage_step').forEach((b) => (b.disabled = +b.dataset.step < 0 && this.qty <= 1));
          if (this.receipt) {
            const variant = this.cur.single ? '' : this.v.o.join(' / ');
            let text = this.fill(this.t.receipt, { variant, qty: this.qty, price: this.v.price });
            text = text.replace(/^[\s·|–-]+|[\s·|–-]+$/g, '').replace(/(\s*·\s*){2,}/g, ' · ');
            if (!this.receipt.classList.contains('is-error')) this.receipt.textContent = text;
          }
        }

        unsplit() {
          this.addWrap?.classList.remove('is-split');
          const sp = this.q('.werk-product-stage_split');
          if (sp) sp.inert = true;
        }

        flash(msg) {
          const el = this.receipt;
          if (!el) return;
          el.classList.add('is-error');
          el.textContent = msg;
          clearTimeout(this.ft);
          this.ft = setTimeout(() => {
            el.classList.remove('is-error');
            this.setQty(this.qty);
          }, 4000);
        }

        // ---------- add to cart ----------
        async cartAdd(id, qty) {
          if (this.cur.demo) {
            await new Promise((r) => setTimeout(r, 700));
            return;
          }
          const root = window.Shopify?.routes?.root || '/';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: qty }] }),
          });
          const json = await res.json().catch(() => ({}));
          if (!res.ok) throw json;
          const cart = fetch(root + 'cart.js').then((r) => r.json());
          const ev = new Event('shopify:cart:lines-update', { bubbles: true });
          Object.assign(ev, {
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: id, quantity: qty }],
            promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
          });
          this.dispatchEvent(ev);
          this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.werkThemeCart(root);
        }

        added() {
          this.classList.add('is-added');
          clearTimeout(this.at);
          this.at = setTimeout(() => this.classList.remove('is-added'), 2200);
        }

        async onSubmit(e) {
          if (!e.target.closest('.werk-product-stage_form')) return;
          e.preventDefault();
          const v = this.v;
          if (this.busy || !v || !v.available) return;
          this.busy = true;
          this.unsplit();
          const b = this.addBtn;
          b.dataset.state = 'loading';
          try {
            await this.cartAdd(v.id, this.qty);
            b.dataset.state = 'added';
            const split = this.hasAttribute('data-split');
            clearTimeout(this.st);
            this.st = setTimeout(() => {
              if (split) {
                this.addWrap.classList.add('is-split');
                this.q('.werk-product-stage_split').inert = false;
              }
              delete b.dataset.state;
            }, split ? 1100 : 2000);
            const sec = +this.dataset.autoClose;
            if (sec > 0) {
              // closes on its own, but never under the pointer (tries again a moment later)
              const later = (ms) => {
                clearTimeout(this.ct);
                this.ct = setTimeout(() => {
                  if (!this.isOpen) return;
                  if (this.cfg.matches(':hover')) return later(1500);
                  this.close();
                  this.added();
                }, ms);
              };
              later(sec * 1000 + 1100);
            }
          } catch (err) {
            delete b.dataset.state;
            if (err && err.description) this.flash(err.description);
            else this.form.submit();
          } finally {
            this.busy = false;
          }
        }

        // products without options: the button adds right away
        async quickAdd(btn) {
          const v = this.v;
          if (this.busy || !v?.available) return;
          this.busy = true;
          btn.dataset.state = 'loading';
          try {
            await this.cartAdd(v.id, 1);
            btn.dataset.state = 'added';
            this.added();
            setTimeout(() => delete btn.dataset.state, 2200);
          } catch {
            delete btn.dataset.state;
          } finally {
            this.busy = false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-ritual-timeline"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-ritual-timeline')) {
    const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
    // cubic-bezier as a function (Newton steps, bisection fallback) – the snap scroll follows the section's easing
    const bezier = (x1, y1, x2, y2) => {
      const f = (t, a, b) => ((1 - 3 * b + 3 * a) * t + (3 * b - 6 * a)) * t * t + 3 * a * t;
      const d = (t, a, b) => 3 * (1 - 3 * b + 3 * a) * t * t + 2 * (3 * b - 6 * a) * t + 3 * a;
      return (x) => {
        if (x <= 0 || x >= 1) return x <= 0 ? 0 : 1;
        let t = x;
        for (let i = 0; i < 6; i++) {
          const sl = d(t, x1, x2);
          if (Math.abs(sl) < 1e-6) break;
          t -= (f(t, x1, x2) - x) / sl;
        }
        if (t < 0 || t > 1 || Math.abs(f(t, x1, x2) - x) > 1e-4) {
          let lo = 0, hi = 1;
          for (let i = 0; i < 24; i++) {
            t = (lo + hi) / 2;
            f(t, x1, x2) < x ? (lo = t) : (hi = t);
          }
        }
        return f(t, y1, y2);
      };
    };
    customElements.define(
      'werk-ritual-timeline',
      class extends HTMLElement {
        connectedCallback() {
          this.look = this.dataset.look || 'spine';
          this.steps = [...this.querySelectorAll('[data-step]')];
          this.n = this.steps.length;
          if (!this.n) return;
          this.track = this.querySelector('[data-track]');
          this.pin = this.querySelector('[data-pin]');
          this.list = this.querySelector('[data-list]');
          this.reel = this.querySelector('[data-reel]');
          this.rail = this.querySelector('[data-rail]');
          this.shots = [...this.querySelectorAll('[data-shot]')];
          this.dots = [...this.querySelectorAll('.werk-ritual-timeline_dot')];
          this.count = this.querySelector('[data-count]');
          this.msgEl = this.querySelector('[data-msg]');
          this.inner = this.querySelector('.werk-ritual-timeline_inner');
          this.root = window.Shopify?.routes?.root || '/';
          this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.reduce) this.dataset.motion = 'off';
          this.still = this.dataset.motion !== 'on';
          this.snapOn = this.dataset.snap !== 'false';
          // the four numbers of --werk-ease (Shopify minifies it to ".6234, .058, 0, .9095"); a bad read falls back
          const eb = getComputedStyle(this.inner).getPropertyValue('--werk-ease').match(/cubic-bezier\(([^)]+)\)/);
          let ep = eb ? eb[1].split(',').map(Number) : [];
          if (ep.length !== 4 || ep.some((v) => !Number.isFinite(v))) ep = [0.6234, 0.058, 0, 0.9095];
          this.ease = bezier(ep[0], ep[1], ep[2], ep[3]);
          this.cur = -1;
          this.pos = 0;
          this.target = 0;
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          // Horizon scrolls div.page-wrapper, not the window – a capturing listener hears every scroller
          on(document, 'scroll', () => (this.schedule(), this.queueSnap()), { passive: true, capture: true });
          // the visitor takes over: a running snap stops at once
          on(window, 'wheel', () => this.stopScroll(), { passive: true });
          on(window, 'touchstart', () => ((this.touching = true), this.stopScroll()), { passive: true });
          on(window, 'touchend', () => ((this.touching = false), this.queueSnap()), { passive: true });
          on(window, 'pointerdown', () => this.stopScroll(), { passive: true });
          on(window, 'keydown', () => this.stopScroll(), { passive: true });
          on(window, 'resize', () => this.measure());
          on(window, 'load', () => ((this.stick = this.base = undefined), this.measure()));
          on(this, 'click', (e) => this.onClick(e));
          on(document, 'shopify:block:select', (e) => this.onEditor(e));

          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.mraf);
            this.mraf = requestAnimationFrame(() => this.measure());
          });
          this.ro.observe(this);
          if (this.pin) this.ro.observe(this.pin);
          this.io = new IntersectionObserver(([e]) => {
            this.visible = e.isIntersecting;
            if (e.isIntersecting && !this.seen) {
              this.seen = true;
              this.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
              this.syncCart();
            }
          });
          this.io.observe(this);
          document.fonts?.ready.then(() => this.isConnected && this.measure());

          // go live without transitions: the steps close at once, then the pin is measured in its real shape
          this.classList.add('is-live', 'is-init');
          this.measure();
          this.setCurrent(Math.round(this.target), true);
          this.stick = undefined;
          this.measure();
          this.pos = this.target;
          this.rpos = this.railTarget ?? this.target;
          this.apply();
          requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('is-init')));
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.ro?.disconnect();
          this.io?.disconnect();
          cancelAnimationFrame(this.raf);
          cancelAnimationFrame(this.mraf);
          clearTimeout(this.leaveT);
          clearTimeout(this.msgT);
          clearTimeout(this.snapT);
          cancelAnimationFrame(this.scrollRaf);
        }

        // ---------- geometry ----------
        u() {
          return parseFloat(getComputedStyle(this.inner).getPropertyValue('--werk-u')) || 1;
        }

        measure() {
          if (!this.isConnected || !this.n) return;
          const w = this.clientWidth;
          const widthChanged = w !== this.lastW;
          this.lastW = w;
          if (widthChanged) this.sc = null; // the theme's scroller is looked up again
          if (widthChanged) this.track.style.height = ''; // a height held while a step opens belongs to the old width
          // Reel pins only on desktop – tablets and phones swipe the row
          this.pinned = this.n > 1 && (this.look !== 'reel' || w >= 990);
          this.classList.toggle('is-pinned', this.pinned);
          // phones change the window height while scrolling (the address bar comes and goes) – only a real change
          // (rotation, a new width, more than an address bar) measures again, so nothing jumps under the finger
          const ih = window.innerHeight;
          if (widthChanged || !this.vhs || Math.abs(ih - this.vhs) > 160) this.vhs = ih;
          const vh = this.vhs;
          // the free band between a sticky / fixed theme header and a bar docked at the bottom (a docked nav, a chat bar)
          const top = this.pinned ? this.headerBottom() : 0;
          // the docked bar moves with the address bar – keep its distance from the bottom, not its position
          const bottom = this.pinned ? vh - (ih - this.footerTop()) : vh;
          const band = Math.max(200, bottom - top);
          this.style.setProperty('--werk-band', band + 'px');
          const run = (parseFloat(this.dataset.run) || 60) / 100;
          this.L = Math.max(120, vh * run); // scroll distance per step
          if (this.pinned) {
            this.style.setProperty('--werk-run', (this.n - 1) * this.L + 'px');
            // the spine's open picture gives way on short screens (see --werk-rest)
            if (!this.opening) this.even();
            const fr = this.look === 'spine' && !this.opening && this.steps[this.cur]?.querySelector('.werk-ritual-timeline_frame');
            if (fr && fr.offsetHeight) {
              // first the rows move closer together (down to a third of their padding), only then the picture shrinks.
              // Like the pin's place, this holds per width and screen height and only ever grows – no row moves
              // because another step opened
              const sqKey = w + ':' + band;
              if (sqKey !== this.sqKey) (this.sqKey = sqKey), (this.sq = 0), this.style.removeProperty('--werk-sq'), this.even();
              const full = parseFloat(getComputedStyle(fr).maxHeight) || fr.offsetHeight;
              const pad = parseFloat(getComputedStyle(this.steps[this.cur]).paddingTop) + this.sq / 2;
              const need = this.pin.offsetHeight + this.sq * this.n + (full - fr.offsetHeight) + 32 - band;
              const sq = clamp(Math.ceil(need / this.n), this.sq, Math.floor((pad * 4) / 3));
              const squeezed = sq !== this.sq;
              if (squeezed) (this.sq = sq), this.style.setProperty('--werk-sq', sq + 'px'), this.even();
              // (with even heights the pinned part is as tall for every step, so this no longer changes per step)
              const rest = this.pin.offsetHeight - fr.offsetHeight + 'px';
              if (rest !== this.rest) (this.rest = rest), this.style.setProperty('--werk-rest', rest), this.even();
            }
            // the pinned part stays where it stands while steps open and close: centred once per width and screen
            // height, lowered only when a taller step would run off the bottom
            // (while a step opens the list is in between two heights – its last full height counts)
            const h = this.opening && this.pinH ? this.pinH : (this.pinH = this.pin.offsetHeight);
            const key = vh + ':' + top + ':' + bottom;
            if (widthChanged || key !== this.vh || this.stick === undefined) {
              this.vh = key;
              this.stick = Math.round(h < band ? top + (band - h) / 2 : bottom - h);
              // progress counts from the first place per width and screen height, so a pin that moves never moves
              // the steps – not when it is lowered, and not when a theme header slides in and out while scrolling
              // (Dawn shows its header on the way up: the steps jumped, and the snap went to the wrong one)
              const frame = w + ':' + vh;
              if (frame !== this.baseKey || this.base === undefined) (this.baseKey = frame), (this.base = this.stick);
            } else if (!this.opening && this.stick + h > bottom) {
              this.stick = Math.round(Math.max(bottom - h, Math.min(this.stick, top + (band - h) / 2)));
            }
            this.style.setProperty('--werk-stick', this.stick + 'px');
            // a section at the very top of the page starts counting above its place (see read()): the track gets
            // that way back at its end, or the pinned part would leave during the last step
            const sc = (this.sc ||= this.scroller());
            const top0 = this.track.getBoundingClientRect().top + sc.scrollTop - (sc === document.scrollingElement || sc === document.documentElement ? 0 : sc.getBoundingClientRect().top);
            this.style.setProperty('--werk-run', (this.n - 1) * this.L + Math.max(0, Math.round(this.base - top0)) + 'px');
          } else {
            this.style.removeProperty('--werk-run');
            this.style.removeProperty('--werk-stick');
          }
          if (this.rail) {
            const cards = this.steps;
            this.step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
            this.anchor = 430 * this.u();
          }
          this.read();
          if (widthChanged) (this.pos = this.target), (this.rpos = this.railTarget ?? this.target); // a resize jumps
          this.apply();
        }

        // the bottom of a sticky / fixed theme header at the top of the screen
        headerBottom() {
          let b = 0;
          for (const hit of document.elementsFromPoint(innerWidth / 2, 2)) {
            if (this.contains(hit) || hit === document.documentElement || hit === document.body) continue;
            for (let el = hit; el && el !== document.body; el = el.parentElement) {
              const p = getComputedStyle(el).position;
              if (p !== 'fixed' && p !== 'sticky') continue;
              const r = el.getBoundingClientRect();
              if (r.top <= 2 && r.height < innerHeight * 0.4) b = Math.max(b, r.bottom);
              break;
            }
          }
          return Math.max(0, Math.round(b));
        }

        // the top of a fixed bar at the bottom of the screen (a docked nav, a cookie or chat bar)
        footerTop() {
          let t = innerHeight;
          for (const x of [innerWidth / 2, innerWidth * 0.2, innerWidth * 0.8])
            for (const y of [innerHeight - 4, innerHeight - 32, innerHeight - 64])
              for (const hit of document.elementsFromPoint(x, y)) {
                if (this.contains(hit) || hit === document.documentElement || hit === document.body) continue;
                for (let el = hit; el && el !== document.body; el = el.parentElement) {
                  if (getComputedStyle(el).position !== 'fixed') continue;
                  const r = el.getBoundingClientRect();
                  if (r.bottom >= innerHeight - 80 && r.height < innerHeight * 0.3 && r.top > innerHeight * 0.5) t = Math.min(t, r.top);
                  break;
                }
              }
          return Math.round(t);
        }

        read() {
          if (this.pinned) {
            const r = this.track.getBoundingClientRect();
            // a section at the very top of the page starts where the page can scroll to: there, step 1 is current
            this.sc ||= this.scroller();
            const sc = this.sc;
            const top0 = r.top + sc.scrollTop - (sc === document.scrollingElement || sc === document.documentElement ? 0 : sc.getBoundingClientRect().top);
            this.from = Math.min(this.base, top0);
            const p = (this.from - r.top) / ((this.n - 1) * this.L);
            this.p = p;
            this.raw = clamp(p, 0, 1) * (this.n - 1);
            // the line follows the scroll (visitors see that something happens), the Reel's cards move from step to step
            this.target = this.raw;
            this.railTarget = this.snapOn ? Math.round(this.raw) : this.raw;
          } else if (this.reel && this.step) {
            this.target = this.railTarget = this.raw = clamp(this.reel.scrollLeft / this.step, 0, this.n - 1);
          } else {
            this.target = Math.max(0, this.cur);
          }
        }

        schedule() {
          if (!this.isConnected) return;
          this.read();
          const c = Math.round(this.raw ?? this.target);
          if (c !== this.cur) this.setCurrent(c);
          if (!this.raf) {
            this.last = performance.now();
            this.raf = requestAnimationFrame((t) => this.tick(t));
          }
        }

        tick(t) {
          this.raf = 0;
          if (!this.isConnected) return;
          const dt = Math.min(1 / 30, (t - this.last) / 1000);
          this.last = t;
          // framerate-independent damping: the line follows the scroll with a little lag
          const rt = this.railTarget ?? this.target;
          this.pos = this.still ? this.target : this.pos + (this.target - this.pos) * (1 - Math.exp(-dt * 12));
          // the rail follows a little slower than the line: the line runs on to the next marker, the cards come after
          this.rpos = this.still ? rt : (this.rpos ?? rt) + (rt - (this.rpos ?? rt)) * (1 - Math.exp(-dt * 6));
          if (Math.abs(this.target - this.pos) < 0.001) this.pos = this.target;
          if (Math.abs(rt - this.rpos) < 0.001) this.rpos = rt;
          this.apply();
          if (this.pos !== this.target || this.rpos !== rt || this.opening) this.raf = requestAnimationFrame((x) => this.tick(x));
        }

        apply() {
          const pos = this.pos;
          if (this.rail) {
            const x = pos * (this.step || 0);
            if (this.pinned) this.rail.style.setProperty('--rx', (this.anchor - (this.rpos ?? pos) * (this.step || 0)).toFixed(2) + 'px');
            const first = this.steps[0];
            this.rail.style.setProperty('--fx', (first.offsetLeft + x).toFixed(2) + 'px');
            return;
          }
          if (!this.list) return;
          // the line runs from the first marker to the last; the fill ends between the markers it is passing
          const top = this.list.getBoundingClientRect().top;
          const c = this.steps.map((st) => {
            const m = st.querySelector('.werk-ritual-timeline_marker').getBoundingClientRect();
            return m.top + m.height / 2 - top;
          });
          const a = Math.floor(pos);
          const b = Math.min(this.n - 1, a + 1);
          const y = c[a] + (c[b] - c[a]) * (pos - a);
          const span = c[this.n - 1] - c[0];
          const line = this.list.querySelector('.werk-ritual-timeline_line');
          line.style.setProperty('--lt', c[0].toFixed(1) + 'px');
          line.style.setProperty('--lh', Math.max(0, span).toFixed(1) + 'px');
          line.style.setProperty('--fill', span > 0 ? clamp((y - c[0]) / span, 0, 1).toFixed(4) : 0);
        }

        // ---------- the current step ----------
        setCurrent(i, first) {
          i = clamp(i, 0, this.n - 1);
          if (i === this.cur) return;
          const prev = this.cur;
          const dir = prev < 0 || i > prev ? 1 : -1;
          this.dataset.dir = dir;
          this.cur = i;
          this.steps.forEach((st, k) => {
            st.classList.toggle('is-current', k === i);
            st.classList.toggle('is-done', k < i);
            const head = st.querySelector('[data-go]');
            if (head && k === i) head.setAttribute('aria-current', 'step');
            else head?.removeAttribute('aria-current');
          });
          this.dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
          if (this.count) this.count.textContent = `${i + 1} / ${this.n}`;
          if (this.shots.length && !first) this.swap(prev, i);
          // the list changes height while a step opens – the line follows for that time
          if (this.list && !first) {
            this.opening = true;
            clearTimeout(this.openT);
            // the track keeps its height while the step closes and opens: on the last step the page below is on
            // screen, and Chrome's scroll anchoring would pull the page along with every pixel the list loses
            // (the timeline then fell back a step)
            if (this.pinned && !this.still && !this.track.style.height) this.track.style.height = this.track.offsetHeight + 'px';
            this.openT = setTimeout(() => {
              this.opening = false;
              this.freeTrack();
              this.measure();
            }, this.still ? 0 : 1100);
            if (!this.raf) {
              this.last = performance.now();
              this.raf = requestAnimationFrame((t) => this.tick(t));
            }
          }
        }

        // Spine: measures every step closed and open and fixes the heights (see .is-even in the CSS)
        even() {
          if (this.look !== 'spine' || this.n < 2 || !this.list) return;
          const cur = clamp(this.cur, 0, this.n - 1);
          this.classList.add('is-m');
          this.steps.forEach((st) => st.classList.add('is-current'));
          const open = Math.max(...this.steps.map((st) => st.getBoundingClientRect().height));
          this.steps.forEach((st) => st.classList.remove('is-current'));
          const closed = this.steps.map((st) => st.getBoundingClientRect().height);
          this.steps[cur].classList.add('is-current');
          this.steps.forEach((st, i) => st.style.setProperty('--hc', Math.ceil(closed[i] * 100) / 100 + 'px'));
          this.style.setProperty('--werk-oh', Math.ceil(open) + 'px');
          this.classList.add('is-even');
          void this.pin.offsetHeight; // the fixed heights apply before transitions are back
          this.classList.remove('is-m');
        }

        // gives the track its own height back; what the new step is taller or shorter by is taken out of the scroll
        freeTrack() {
          if (!this.track.style.height) return;
          const top = this.track.getBoundingClientRect().top;
          this.track.style.height = '';
          const d = this.track.getBoundingClientRect().top - top;
          const sc = this.scroller();
          if (Math.abs(d) >= 1 && Number.isFinite(sc.scrollTop + d)) sc.scrollTo({ top: sc.scrollTop + d, behavior: 'instant' });
        }

        swap(prev, i) {
          const next = this.shots[i];
          const old = this.shots[prev];
          if (!next) return;
          this.shots.forEach((s) => s !== old && s !== next && s.classList.remove('is-leaving', 'is-on', 'is-from'));
          if (old) {
            old.classList.remove('is-on', 'is-from');
            old.classList.add('is-leaving');
          }
          if (this.still) {
            next.classList.add('is-on');
            old?.classList.remove('is-leaving');
            return;
          }
          // CSS state machine: start state without transition → reflow → target state
          next.classList.add('is-from', 'is-on');
          void next.offsetWidth;
          next.classList.remove('is-from');
          clearTimeout(this.leaveT);
          this.leaveT = setTimeout(() => this.shots.forEach((s) => s !== this.shots[this.cur] && s.classList.remove('is-leaving')), 820);
        }

        // ---------- moving to a step ----------
        scroller() {
          let el = this.parentElement;
          while (el && el !== document.body) {
            const o = getComputedStyle(el).overflowY;
            if ((o === 'auto' || o === 'scroll') && el.scrollHeight > el.clientHeight + 1) return el;
            el = el.parentElement;
          }
          return document.scrollingElement || document.documentElement;
        }

        goTo(i, instant) {
          i = clamp(i, 0, this.n - 1);
          const behavior = instant || this.still ? 'auto' : 'smooth';
          if (this.pinned) {
            this.scrollToStep(i, instant);
          } else if (this.reel) {
            this.reel.scrollTo({ left: i * this.step, behavior });
          }
          if (instant) {
            this.setCurrent(i);
            this.read();
            this.pos = this.target;
            this.rpos = this.railTarget ?? this.target;
            this.apply();
          }
        }

        // scrolls the page so step i is the current one – with the section's easing, frame by frame
        scrollToStep(i, instant) {
          cancelAnimationFrame(this.scrollRaf);
          this.settled = i;
          const sc = this.scroller();
          this.read();
          const by = this.track.getBoundingClientRect().top - this.from + i * this.L + 1;
          if (Math.abs(by) < 1) return;
          // 'instant': themes with scroll-behavior: smooth (Horizon's page-wrapper) would ease every single step again
          // never scroll to a value that isn't a number – a theme would read it as 0 and send the page to the top
          const set = (y) => Number.isFinite(y) && sc.scrollTo({ top: y, behavior: 'instant' });
          const from = sc.scrollTop;
          if (!Number.isFinite(by) || !Number.isFinite(from)) return;
          const dur = instant || this.still ? 0 : clamp(420 + (Math.abs(by) / this.L) * 260, 420, 1100);
          if (!dur) return set(from + by);
          this.animating = true;
          const t0 = performance.now();
          const tick = (now) => {
            const t = clamp((now - t0) / dur, 0, 1);
            set(from + by * this.ease(t));
            if (t < 1 && this.animating) this.scrollRaf = requestAnimationFrame(tick);
            else this.animating = false;
          };
          this.scrollRaf = requestAnimationFrame(tick);
        }

        stopScroll() {
          clearTimeout(this.snapT);
          if (!this.animating) return;
          cancelAnimationFrame(this.scrollRaf);
          this.animating = false;
        }

        // fixed points: once the visitor stops scrolling inside the timeline, it settles on the nearest step
        queueSnap() {
          if (!this.snapOn || !this.pinned || this.animating || this.touching) return;
          clearTimeout(this.snapT);
          this.snapT = setTimeout(() => this.snap(), 160);
        }

        snap() {
          if (!this.isConnected || this.animating || this.touching) return;
          this.read();
          // before or after the timeline: leave the page alone
          if (!(this.p > 0 && this.p < 1)) return void (this.settled = Math.round(this.raw));
          // direction counts: a short, deliberate scroll (12 % of a step) already brings the next step that way;
          // less than that falls back to where it was
          const from = this.settled ?? Math.round(this.raw);
          const d = this.raw - from;
          const k = clamp(Math.abs(d) < 0.12 ? from : d > 0 ? Math.ceil(this.raw - 0.12) : Math.floor(this.raw + 0.12), 0, this.n - 1);
          this.settled = k;
          if (Math.abs(this.raw - k) * this.L > 2) this.scrollToStep(k);
        }

        onClick(e) {
          const add = e.target.closest('[data-add]');
          if (add && this.contains(add)) return this.addOne(add);
          const all = e.target.closest('[data-add-all]');
          if (all) return this.addAll(all);
          const go = e.target.closest('[data-go]');
          if (go) return this.goTo(+go.dataset.go);
          // Reel on desktop: a click on a neighbouring card brings it to the front
          const card = this.pinned && e.target.closest('.werk-ritual-timeline_card');
          if (card && !card.classList.contains('is-current') && !e.target.closest('a')) this.goTo(this.steps.indexOf(card));
        }

        onEditor(e) {
          if (!this.contains(e.target)) return;
          const i = this.steps.findIndex((st) => st.dataset.block === e.detail?.blockId);
          if (i >= 0) this.goTo(i, true);
        }

        // ---------- cart ----------
        // where every step's product sits: in the step itself, in Stage in its shot
        boxes() {
          return this.shots.length ? this.shots : this.steps;
        }

        async syncCart() {
          const ids = this.boxes().map((st) => st.querySelector('[data-variant]')?.dataset.variant).filter(Boolean);
          if (!ids.length) return;
          try {
            const cart = await fetch(this.root + 'cart.js').then((r) => r.json());
            const inCart = new Set((cart.items || []).map((x) => String(x.variant_id)));
            this.boxes().forEach((st) => {
              const v = st.querySelector('[data-variant]')?.dataset.variant;
              if (v) st.classList.toggle('is-in-cart', inCart.has(v));
            });
          } catch {}
        }

        addOne(btn) {
          if (btn.disabled) return;
          const st = btn.closest('[data-step], [data-shot]');
          const v = btn.dataset.variant;
          const sib = st ? [...st.querySelectorAll('[data-add]')] : [btn];
          this.cart(btn, v ? [{ id: +v, quantity: 1 }] : [], st ? [st] : [], sib);
        }

        addAll(btn) {
          const picked = [];
          const items = [];
          this.boxes().forEach((st) => {
            const b = st.querySelector('[data-add]:not(:disabled)');
            if (!b) return;
            picked.push(st);
            if (b.dataset.variant && !items.some((x) => x.id === +b.dataset.variant)) items.push({ id: +b.dataset.variant, quantity: 1 });
          });
          if (picked.length) this.cart(btn, items, picked, [btn]);
        }

        async cart(btn, items, steps, group) {
          if (btn.dataset.state) return;
          const set = (state) => group.forEach((b) => (state ? (b.dataset.state = state) : delete b.dataset.state));
          set('loading');
          const done = () => {
            set('added');
            steps.forEach((st) => st.classList.add('is-in-cart'));
            setTimeout(() => set(null), 1800);
          };
          if (!items.length) return setTimeout(done, 700); // demo pieces without products
          try {
            const res = await fetch(this.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            done();
            const cart = fetch(this.root + 'cart.js').then((x) => x.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: items.map((x) => ({ merchandiseId: x.id, quantity: x.quantity })),
              promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart?.(this.root);
          } catch (err) {
            set(null);
            this.msg((err && (err.description || err.message)) || this.msgEl?.dataset.error || 'Could not add to cart.');
          }
        }

        msg(text) {
          if (!this.msgEl) return;
          this.msgEl.textContent = text;
          this.msgEl.hidden = false;
          clearTimeout(this.msgT);
          this.msgT = setTimeout(() => (this.msgEl.hidden = true), 4000);
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-scratch-card"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('werk-scratch-card')) {
    customElements.define(
      'werk-scratch-card',
      class extends HTMLElement {
        connectedCallback() {
          const q = (sel) => this.querySelector(sel);
          try {
            this.d = JSON.parse(q('script[data-werk]').textContent);
            this.t = JSON.parse(q('script[data-werk-t]').textContent);
          } catch {
            return;
          }
          this.speed = this.dataset.motion === 'on' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0;
          if (!this.speed) this.dataset.motion = 'off';
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.root = window.Shopify?.routes?.root || '/';
          this.design = !!(this.d.design || window.Shopify?.designMode);
          this.card = q('[data-card]');
          this.stage = q('[data-stage]');
          this.grid = q('[data-grid]');
          this.stub = q('[data-stub]');
          this.coin = q('[data-coin]');
          this.form = q('.werk-scratch-card_form');
          // the section shows its own error under the field (native bubbles only without JS)
          if (this.form) this.form.noValidate = true;
          this.art = {};
          this.querySelectorAll('template[data-art]').forEach((t) => (this.art[t.dataset.art] = t.innerHTML));
          this.cells = [...this.querySelectorAll('[data-cell]')].map((el, i) => ({ el, i, sym: el.querySelector('[data-sym]'), w: 0, h: 0, x: 0, y: 0 }));
          this.rows = [...this.querySelectorAll('[data-prize]')];
          this.key = 'werk-scratch-card:' + this.d.section;
          this.timers = new Set();
          this.anims = new Set();
          this.crumbs = 0;
          this.tilt = 0;
          this.coinOn = !!(this.d.coin && this.speed && this.coin && matchMedia('(hover: hover) and (pointer: fine)').matches);

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          on(this.card, 'pointerdown', (e) => this.down(e));
          on(window, 'pointermove', (e) => this.move(e), { passive: true });
          on(window, 'pointerup', (e) => this.up(e));
          on(window, 'pointercancel', (e) => this.up(e));
          on(this.grid, 'pointerover', (e) => this.glint(e));
          on(this.grid, 'pointerleave', () => !this.drag && this.showCoin(false));
          on(this, 'click', (e) => this.click(e));
          on(this.form, 'submit', (e) => this.submit(e));
          on(this.form, 'input', () => this.error(false));
          on(this.form, 'change', () => this.error(false));
          on(document, 'shopify:block:select', (e) => this.onBlock(e));
          on(document, 'visibilitychange', () => !document.hidden && this.tick());
          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.rr);
            this.rr = requestAnimationFrame(() => this.measure());
          });
          this.ro.observe(this.stub);
          this.start();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.ro?.disconnect();
          cancelAnimationFrame(this.rr);
          this.clear();
          clearTimeout(this.tickT);
          clearTimeout(this.copyT);
          this.anims?.forEach((a) => a.cancel());
        }

        // ---------- the card: drawn once, kept in the browser ----------
        start() {
          const stored = this.read();
          this.mail = this.readMail();
          this.st = this.valid(stored) && !this.expired(stored) ? stored : this.fresh();
          if (this.st !== stored) this.save();
          const back = this.restore();
          this.paint(this.st === stored);
          if (back) this.card.scrollIntoView({ block: 'center', behavior: 'auto' });
        }

        // The browser draws the prize (weight per block). Exactly one symbol lies three times, every other one at most
        // twice. Symbols land on the fields only while they are rubbed, so the third match is always the 8th or 9th field.
        fresh(force) {
          const list = this.d.prizes || [];
          if (!list.length) return null;
          const w = (x) => Math.max(1, +x.weight || 1);
          let p = list.find((x) => x.id === force);
          if (!p) {
            let r = Math.random() * list.reduce((a, x) => a + w(x), 0);
            p = list.find((x) => (r -= w(x)) < 0) || list[0];
          }
          const pool = this.shuffle(['sparkle', 'diamond', 'star', 'ring', 'triangle'].filter((k) => k !== p.key).flatMap((k) => [k, k])).slice(0, 6);
          const third = Math.random() < 0.5 ? 7 : 8;
          const early = this.shuffle([...Array(third).keys()]).slice(0, 2);
          const seq = [];
          for (let i = 0, f = 0; i < 9; i++) seq.push(i === third || early.includes(i) ? p.key : pool[f++]);
          return { v: 1, id: p.id, seq, next: 0, keys: Array(9).fill(null), open: Array(9).fill(false), won: false, at: Date.now(), serial: Math.floor(Math.random() * 1e6) };
        }

        shuffle(a) {
          for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
          }
          return a;
        }

        get prize() {
          return (this.d.prizes || []).find((x) => x.id === this.st?.id);
        }

        valid(st) {
          if (!st || st.v !== 1 || !Array.isArray(st.seq) || st.seq.length !== 9 || !Array.isArray(st.keys) || !Array.isArray(st.open)) return false;
          const p = (this.d.prizes || []).find((x) => x.id === st.id);
          return !!p && st.seq.filter((k) => k === p.key).length === 3;
        }

        period() {
          return { daily: 864e5, weekly: 6048e5 }[this.d.renew] || 0;
        }

        expired(st) {
          return !!this.period() && st.won && Date.now() >= st.at + this.period();
        }

        read() {
          if (this.design) return null;
          try {
            return JSON.parse(localStorage.getItem(this.key) || 'null');
          } catch {
            return null;
          }
        }

        save() {
          if (this.design || !this.st) return;
          try {
            localStorage.setItem(this.key, JSON.stringify(this.st));
          } catch {}
        }

        readMail() {
          if (this.design) return false;
          try {
            return localStorage.getItem(this.key + ':mail') === '1';
          } catch {
            return false;
          }
        }

        // after Shopify's reload: a sent form opens the card (before scratching) or shows the code (before the code)
        restore() {
          if (!this.form) return false;
          let p = null;
          try {
            p = JSON.parse(sessionStorage.getItem('werk-scratch-card-pending') || 'null');
          } catch {}
          if (!p || p.s !== this.d.section) return false;
          try {
            sessionStorage.removeItem('werk-scratch-card-pending');
          } catch {}
          const flag = this.form.querySelector('[data-posted]');
          const url = new URL(location.href);
          if (flag?.dataset.posted === '1' || url.searchParams.get('customer_posted') === 'true' || url.searchParams.get('contact_posted') === 'true') {
            this.mail = true;
            try {
              localStorage.setItem(this.key + ':mail', '1');
            } catch {}
            url.searchParams.delete('customer_posted');
            url.searchParams.delete('contact_posted');
            history.replaceState(history.state, '', url.pathname + url.search);
          } else if (flag?.dataset.errors) {
            const inp = this.form.querySelector('input[type="email"]');
            if (inp) inp.value = p.email || '';
            this.failed = flag.dataset.errors;
          }
          return true;
        }

        // ---------- draw the whole card from the state ----------
        paint(instant) {
          this.clear();
          const st = this.st;
          if (instant) this.classList.add('is-instant');
          this.spent?.splice(0).forEach((cv) => cv.remove());
          for (const c of this.cells) {
            cancelAnimationFrame(c.raf);
            c.el.classList.remove('is-open', 'is-hit', 'is-dim', 'is-live', 'is-glint');
            c.el.style.removeProperty('--k');
            c.cv?.remove();
            c.cv = null;
            c.auto = false;
            c.started = false;
            c.dirty = false;
            const k = st?.keys[c.i];
            c.sym.innerHTML = k ? this.art[k] || '' : '';
            c.open = !!st?.open[c.i];
            if (c.open) c.el.classList.add('is-open');
            else if (st) this.foil(c);
            this.label(c);
          }
          this.measure();
          this.rowsUpdate();
          if (st?.won) this.win(true);
          else this.stubState();
          if (this.failed) {
            // Shopify's own reason (e.g. the address is taken), in the store's language
            this.error(true, this.failed);
            this.failed = false;
          }
          if (instant) requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('is-instant')));
        }

        foil(c) {
          const cv = document.createElement('canvas');
          cv.className = 'werk-scratch-card_scratch';
          cv.setAttribute('aria-hidden', 'true');
          c.el.append(cv);
          c.cv = cv;
          c.ctx = cv.getContext('2d', { willReadFrequently: true });
          c.painted = false;
          c.el.classList.add('is-live');
        }

        measure() {
          if (!this.isConnected) return;
          const r = getComputedStyle(this.stage).rotate;
          this.tilt = r && r !== 'none' ? (parseFloat(r) * Math.PI) / 180 : 0;
          this.dpr = Math.min(window.devicePixelRatio || 1, 2);
          for (const c of this.cells) {
            const w = c.el.offsetWidth;
            const h = c.el.offsetHeight;
            c.x = c.el.offsetLeft;
            c.y = c.el.offsetTop;
            if (c.cv && w && (w !== c.w || h !== c.h || !c.painted)) this.paintFoil(c, w, h);
            c.w = w;
            c.h = h;
          }
          this.fitActions();
        }

        fitActions() {
          const row = this.querySelector('[data-won-actions]');
          const code = this.querySelector('[data-code]');
          if (!row || !code) return;
          row.classList.remove('is-stack');
          if (code.offsetParent && code.scrollWidth > code.clientWidth + 1) row.classList.add('is-stack');
        }

        // the foil gradient of the design, derived from the Foil color (the canvas can't read CSS gradients)
        stops() {
          if (this.stopList) return this.stopList;
          const m = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})/i.exec(this.d.foil || '') || [0, 'c6', 'c4', 'bf'];
          const base = [1, 2, 3].map((i) => parseInt(m[i], 16));
          const mix = (t) => 'rgb(' + base.map((v) => Math.round(t > 0 ? v + (255 - v) * t : v * (1 + t))).join(',') + ')';
          return (this.stopList = [[0.14286, mix(-0.045)], [0.34286, mix(0.72)], [0.5, mix(0)], [0.67143, mix(0.77)], [0.85714, mix(-0.09)]]);
        }

        paintFoil(c, w, h) {
          const cv = c.cv;
          const ctx = c.ctx;
          let old = null;
          // a resize keeps what is rubbed off already
          if (c.dirty && cv.width) {
            old = document.createElement('canvas');
            old.width = cv.width;
            old.height = cv.height;
            old.getContext('2d').drawImage(cv, 0, 0);
          }
          cv.width = Math.round(w * this.dpr);
          cv.height = Math.round(h * this.dpr);
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.globalCompositeOperation = 'source-over';
          if (old) ctx.drawImage(old, 0, 0, cv.width, cv.height);
          ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
          if (!old) {
            // CSS angle 126.87°: the gradient line runs along (0.8, 0.6), as long as the box seen from that angle
            const len = w * 0.8 + h * 0.6;
            const g = ctx.createLinearGradient(w / 2 - 0.4 * len, h / 2 - 0.3 * len, w / 2 + 0.4 * len, h / 2 + 0.3 * len);
            for (const [o, col] of this.stops()) g.addColorStop(o, col);
            ctx.fillStyle = g;
            ctx.fillRect(0, 0, w, h);
          }
          c.painted = true;
        }

        // pointer → the element's own (unrotated) coordinates: the card is tilted, its bounding box is not
        local(e, el) {
          const r = el.getBoundingClientRect();
          const dx = e.clientX - (r.left + r.width / 2);
          const dy = e.clientY - (r.top + r.height / 2);
          const cos = Math.cos(-this.tilt);
          const sin = Math.sin(-this.tilt);
          return [dx * cos - dy * sin + el.offsetWidth / 2, dx * sin + dy * cos + el.offsetHeight / 2];
        }

        locked() {
          return this.d.gate === 'before_scratch' && !this.mail && !this.st?.won;
        }

        // ---------- rubbing: one stroke can run over several fields ----------
        down(e) {
          if (e.button > 0 || !this.st || e.target.closest('[data-stub]')) return;
          // a stroke may start anywhere on the card above the stub – on a field, an open one, a gap or the edge
          const el = e.target.closest('[data-cell]');
          const c = el ? this.cells[+el.dataset.cell] : null;
          if (this.locked()) {
            e.preventDefault();
            return this.nudge();
          }
          if (this.st.won) return;
          if (e.pointerType === 'mouse') e.preventDefault(); // no text selection or focus ring while rubbing
          const p = this.local(e, this.grid);
          this.drag = { id: e.pointerId, last: p, moved: 0, run: 0, start: c, hit: new Set(), t: 0, touch: e.pointerType !== 'mouse' };
          this.rub(p, p);
        }

        move(e) {
          if (this.coinOn && e.pointerType === 'mouse' && (this.coinShown || this.grid.contains(e.target))) this.coinAt(e);
          const d = this.drag;
          if (!d || d.id !== e.pointerId) return;
          const p = this.local(e, this.grid);
          const step = Math.hypot(p[0] - d.last[0], p[1] - d.last[1]);
          if (!step) return;
          d.moved += step;
          d.run += step;
          if (this.rub(d.last, p) && d.run > 12) {
            d.run = 0;
            this.crumb(p);
          }
          d.last = p;
          const now = performance.now();
          if (now - d.t > 120) {
            d.t = now;
            d.hit.forEach((c) => this.check(c));
          }
        }

        up(e) {
          const d = this.drag;
          if (!d || d.id !== e.pointerId) return;
          this.drag = null;
          if (!this.grid.contains(e.target)) this.showCoin(false);
          // a click or tap without dragging wipes the field by itself
          if (d.moved < (d.touch ? 12 : 6)) d.start && this.auto(d.start);
          else d.hit.forEach((c) => this.check(c));
          this.sweep();
        }

        // canvases of opened fields leave the page only after the stroke: removing the element under the finger
        // would end the touch on some phones
        sweep() {
          if (this.drag || !this.spent?.length) return;
          const list = this.spent.splice(0);
          this.later(() => list.forEach((cv) => cv.remove()), 450);
        }

        rub(a, b) {
          let any = false;
          for (const c of this.cells) {
            if (c.open || !c.cv || c.auto) continue;
            const r = c.w * 0.1;
            if (Math.max(a[0], b[0]) + r < c.x || Math.min(a[0], b[0]) - r > c.x + c.w || Math.max(a[1], b[1]) + r < c.y || Math.min(a[1], b[1]) - r > c.y + c.h) continue;
            this.rubCell(c, a, b, r * 2);
            this.drag?.hit.add(c);
            any = true;
          }
          return any;
        }

        rubCell(c, a, b, size) {
          this.begin(c);
          const ctx = c.ctx;
          ctx.globalCompositeOperation = 'destination-out';
          ctx.lineCap = 'round';
          ctx.lineJoin = 'round';
          ctx.lineWidth = size;
          ctx.beginPath();
          ctx.moveTo(a[0] - c.x, a[1] - c.y);
          ctx.lineTo(b[0] - c.x + 0.01, b[1] - c.y);
          ctx.stroke();
          c.dirty = true;
        }

        // the field gets its symbol the moment it is first rubbed
        begin(c) {
          if (c.started) return;
          c.started = true;
          c.el.classList.remove('is-glint');
          if (!this.st.keys[c.i]) {
            this.st.keys[c.i] = this.st.seq[this.st.next++];
            c.sym.innerHTML = this.art[this.st.keys[c.i]] || '';
            this.save();
          }
        }

        // share rubbed off, read from a coarse grid of the canvas: the whole field, and the middle where the symbol sits
        // (inset 28 %, a little more around it)
        cleared(c) {
          const W = c.cv.width;
          const H = c.cv.height;
          if (!W || !H) return { all: 0, mid: 0 };
          const d = c.ctx.getImageData(0, 0, W, H).data;
          const n = 20;
          let all = 0;
          let mid = 0;
          let midN = 0;
          for (let y = 0; y < n; y++)
            for (let x = 0; x < n; x++) {
              const fx = (x + 0.5) / n;
              const fy = (y + 0.5) / n;
              const free = d[((Math.floor(fy * H) * W + Math.floor(fx * W)) << 2) + 3] < 40;
              if (free) all++;
              if (fx > 0.24 && fx < 0.76 && fy > 0.24 && fy < 0.76) {
                midN++;
                if (free) mid++;
              }
            }
          return { all: all / (n * n), mid: mid / midN };
        }

        // a field counts as open once its symbol can be seen (¾ of the middle free) or 60 % of it is rubbed off
        check(c) {
          if (c.open || !c.cv || c.auto) return;
          const r = this.cleared(c);
          if (r.mid >= 0.75 || r.all >= 0.6) this.open(c);
        }

        // click, tap, Enter, Space: the coin wipes the field in a few strokes
        auto(c) {
          if (!this.st || c.open || c.auto || this.st.won) return;
          if (this.locked()) return this.nudge();
          this.begin(c);
          if (!this.speed || !c.cv) return this.open(c);
          c.auto = true;
          const t0 = performance.now();
          const dur = 380;
          const at = (t) => {
            const rows = 4;
            const ph = (t * rows) % 1;
            const back = Math.floor(t * rows) % 2;
            return [c.x + c.w * (0.12 + 0.76 * (back ? 1 - ph : ph)), c.y + c.h * (0.12 + 0.76 * t)];
          };
          let last = at(0);
          const step = (now) => {
            if (!this.isConnected || !c.auto) return;
            const t = Math.min(1, (now - t0) / dur);
            const p = at(t);
            this.rubCell(c, last, p, c.w * 0.42);
            if (Math.random() < 0.35) this.crumb(p);
            last = p;
            if (t < 1) c.raf = requestAnimationFrame(step);
            else {
              c.auto = false;
              this.open(c);
            }
          };
          c.raf = requestAnimationFrame(step);
        }

        open(c) {
          if (c.open || !this.st) return;
          this.begin(c);
          c.open = true;
          c.auto = false;
          cancelAnimationFrame(c.raf);
          this.st.open[c.i] = true;
          this.save();
          c.el.classList.add('is-open');
          if (c.cv) (this.spent ||= []).push(c.cv);
          c.cv = null;
          this.sweep();
          this.label(c);
          this.rowsUpdate();
          const k = this.prize?.key;
          if (!this.st.won && this.cells.filter((x) => x.open && this.st.keys[x.i] === k).length >= 3) this.win(false);
        }

        revealAll() {
          if (!this.st || this.st.won) return;
          if (this.locked()) return this.nudge();
          this.cells.filter((c) => !c.open).forEach((c, k) => this.later(() => this.open(c), k * 80));
        }

        label(c) {
          const k = this.st?.keys[c.i];
          const base = (this.t.field || '').replace('[n]', c.i + 1);
          c.el.setAttribute('aria-label', c.open && k ? `${base}: ${this.t.names[k] || k}` : base);
        }

        // ---------- the win: rings, the rest dims, the stub turns, the prize rolls in ----------
        win(instant) {
          const p = this.prize;
          if (!p) return;
          this.st.won = true;
          this.showCoin(false);
          const wait = (fn, ms) => (instant || !this.speed ? fn() : this.later(fn, ms));
          let k = 0;
          for (const c of this.cells) {
            if (!this.st.keys[c.i]) {
              this.st.keys[c.i] = this.st.seq[this.st.next++];
              c.sym.innerHTML = this.art[this.st.keys[c.i]] || '';
            }
            const hit = this.st.keys[c.i] === p.key;
            if (hit) c.el.style.setProperty('--k', k++);
            wait(() => c.el.classList.add(hit ? 'is-hit' : 'is-dim'), hit ? 150 : 300);
            // foils still closed dissolve
            if (!c.open) wait(() => this.open(c), 300);
          }
          this.save();
          wait(() => this.rowsUpdate(), 300);
          wait(() => this.stubState(!instant), 700);
        }

        rowsUpdate() {
          const st = this.st;
          const count = {};
          for (const c of this.cells) {
            const k = st?.keys[c.i];
            if (k && c.open) count[k] = (count[k] || 0) + 1;
          }
          const winKey = st?.won ? this.prize?.key : null;
          for (const row of this.rows) {
            const k = row.dataset.key;
            const n = Math.min(3, count[k] || 0);
            row.querySelectorAll('[data-dot]').forEach((m, i) => m.classList.toggle('is-found', i < n));
            row.classList.toggle('is-won', !!winKey && k === winKey);
            row.classList.toggle('is-lost', !!winKey && k !== winKey);
          }
        }

        stubState(roll) {
          const st = this.st;
          const p = this.prize;
          const t = this.t;
          const g = this.d.gate;
          let state = 'locked';
          if (st?.won) state = g === 'before_code' && !this.mail ? 'gate-b' : 'won';
          else if (g === 'before_scratch' && !this.mail) state = 'gate-a';
          const was = this.stub.dataset.state;
          this.stub.dataset.state = state;
          this.dataset.state = state;
          const won = state === 'won' || state === 'gate-b';
          this.querySelector('[data-top-left]').textContent = won ? t.won : t.prize;
          this.querySelector('[data-top-right]').textContent = { 'gate-a': t.emailPlay, 'gate-b': t.emailCode, won: t.applied, locked: t.locked }[state];
          this.querySelector('[data-value]').textContent = won && p ? p.label : t.unknown;
          const copy = this.querySelector('[data-copy]');
          copy.hidden = !p?.code;
          this.querySelector('[data-code]').textContent = p?.code || '';
          const shop = this.querySelector('[data-shop]');
          shop.href = p?.code ? `${this.root}discount/${encodeURIComponent(p.code)}?redirect=${encodeURIComponent(this.d.shop || '/collections/all')}` : this.d.shop || this.root;
          this.fitActions();
          if (roll && this.speed && was !== state) {
            this.stub.classList.remove('is-roll');
            void this.stub.offsetWidth;
            this.stub.classList.add('is-roll');
            this.later(() => this.stub.classList.remove('is-roll'), 1400);
          }
          this.tick();
        }

        // "New card in 6 d 04 h" – only with a new card daily / weekly
        tick() {
          clearTimeout(this.tickT);
          const per = this.period();
          if (!this.st?.won || !per) return;
          const left = this.st.at + per - Date.now();
          if (left <= 0) {
            if (this.design) return;
            this.st = this.fresh();
            this.save();
            return this.paint(false);
          }
          if (this.stub.dataset.state === 'won') this.querySelector('[data-top-right]').textContent = this.t.next.replace('[time]', this.fmt(left));
          this.tickT = setTimeout(() => this.tick(), Math.min(left + 50, 30000));
        }

        fmt(ms) {
          const m = Math.ceil(ms / 6e4);
          const d = Math.floor(m / 1440);
          const h = Math.floor((m % 1440) / 60);
          const p = (n) => String(n).padStart(2, '0');
          const t = d ? this.t.days : this.t.hours;
          return t.replace('[d]', d).replace('[h]', p(h)).replace('[m]', p(m % 60));
        }

        // ---------- clicks: keyboard on a field, reveal, copy ----------
        click(e) {
          const cell = e.target.closest('[data-cell]');
          // Enter / Space on a field (detail 0); mouse and touch are handled by the pointer events
          if (cell && e.detail === 0) return this.auto(this.cells[+cell.dataset.cell]);
          if (e.target.closest('[data-reveal]')) return this.revealAll();
          const copy = e.target.closest('[data-copy]');
          if (copy) this.copy(copy);
        }

        async copy(btn) {
          const code = this.prize?.code;
          if (!code) return;
          const label = btn.querySelector('[data-copy-label]');
          clearTimeout(this.copyT);
          try {
            await navigator.clipboard.writeText(code);
            label.textContent = this.t.copied;
            btn.dataset.state = 'copied';
          } catch {
            // the browser won't let us: select the code and say which keys copy it
            const r = document.createRange();
            r.selectNodeContents(btn.querySelector('[data-code]'));
            getSelection().removeAllRanges();
            getSelection().addRange(r);
            label.textContent = this.t.blocked.replace('[key]', /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent) ? '⌘C' : 'Ctrl+C');
            btn.dataset.state = 'blocked';
          }
          this.copyT = setTimeout(() => {
            label.textContent = this.t.copy;
            delete btn.dataset.state;
          }, btn.dataset.state === 'copied' ? 2000 : 4000);
        }

        // ---------- email step ----------
        submit(e) {
          const f = this.form;
          const inp = f.querySelector('input[type="email"]');
          const ok = f.querySelector('[data-consent]');
          const v = inp.value.trim();
          if (!/^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(v)) {
            e.preventDefault();
            return this.error(true);
          }
          if (ok && !ok.checked) {
            e.preventDefault();
            return this.error(true, this.t.consent, 'consent');
          }
          const p = this.prize;
          const body = f.querySelector('[data-body]');
          if (body) body.value = `Scratch Card: ${p?.label || ''}${p?.code ? ' (' + p.code + ')' : ''}`;
          this.save();
          e.preventDefault();
          // Shopify's captcha script listens on the form too and would send it the normal way (reload) – send() runs
          // the captcha itself
          e.stopImmediatePropagation();
          if (f.classList.contains('is-sending')) return;
          if (this.design) {
            // theme editor: no form is sent, the next state shows right away
            this.mail = true;
            return this.stubState(true);
          }
          try {
            sessionStorage.setItem('werk-scratch-card-pending', JSON.stringify({ s: this.d.section, email: v }));
          } catch {}
          this.send(f);
        }

        // Shopify guards customer and contact forms with an invisible hCaptcha, bound to the form on its first focus. A
        // background post needs its answer: run the form's own widget and put the token in (hCaptcha shows a puzzle only
        // to visitors it doubts). 'none' = the store has no captcha, null = it couldn't run.
        async captcha(f) {
          const bound = () => f.hasAttribute('data-hcaptcha-bound');
          for (let i = 0; i < 30 && !bound() && window.Shopify?.captcha; i++) await new Promise((r) => setTimeout(r, 100));
          if (!bound()) return window.Shopify?.captcha ? null : 'none';
          const id = f.querySelector('.h-captcha iframe[data-hcaptcha-widget-id]')?.dataset.hcaptchaWidgetId;
          if (!window.hcaptcha?.execute || id == null) return null;
          try {
            window.hcaptcha.reset(id);
          } catch {}
          const { response } = await window.hcaptcha.execute(id, { async: true });
          if (!response) return null;
          const fields = f.querySelectorAll('[name="h-captcha-response"]');
          if (!fields.length) f.append(Object.assign(document.createElement('input'), { type: 'hidden', name: 'h-captcha-response' }));
          for (const n of f.querySelectorAll('[name="h-captcha-response"]')) n.value = response;
          return response;
        }

        // Sends the Shopify form in the background, so the page doesn't reload and jump: Shopify answers with the page,
        // and our form in it says whether it went through. If the captcha can't run, Shopify still asks for a check, or
        // the answer can't be read, the form is sent the normal way (Shopify's own submit, with its captcha) and
        // restore() carries on after the reload.
        async send(f) {
          const label = f.querySelector('[data-submit-label]');
          const idle = label?.textContent;
          f.classList.add('is-sending');
          if (label) label.textContent = this.t.sending;
          const done = () => {
            f.classList.remove('is-sending');
            if (label) label.textContent = idle;
          };
          // f.submit is Shopify's captcha submit once the form is bound, the plain one otherwise
          const native = () => (typeof f.submit === 'function' ? f.submit() : HTMLFormElement.prototype.submit.call(f));
          let doc = null;
          try {
            const token = await this.captcha(f);
            if (!token) return native();
          } catch {
            // the visitor closed the puzzle: nothing sent, try again
            done();
            try {
              sessionStorage.removeItem('werk-scratch-card-pending');
            } catch {}
            return;
          }
          try {
            const r = await fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' }, credentials: 'same-origin' });
            if (!r.ok || /\/challenge/.test(r.url)) return native();
            doc = new DOMParser().parseFromString(await r.text(), 'text/html');
          } catch {
            return native();
          }
          const flag = doc.getElementById(f.id)?.querySelector('[data-posted]');
          if (!flag) return native();
          if (flag.dataset.posted !== '1' && /captcha/i.test(flag.dataset.errors || '')) return native();
          done();
          try {
            sessionStorage.removeItem('werk-scratch-card-pending');
          } catch {}
          if (flag.dataset.posted !== '1') return this.error(true, flag.dataset.errors || this.t.error);
          this.mail = true;
          try {
            localStorage.setItem(this.key + ':mail', '1');
          } catch {}
          this.stubState(true);
        }

        // field = 'email' (the address) or 'consent' (the tick box)
        error(on, text, field = 'email') {
          if (!this.form) return;
          this.form.classList.toggle('is-error', on && field === 'email');
          this.form.classList.toggle('is-consent-error', on && field === 'consent');
          const msg = this.form.querySelector('[data-error]');
          if (msg) {
            msg.hidden = !on;
            if (on) msg.textContent = text || this.t.error;
          }
          const inp = this.form.querySelector('input[type="email"]');
          const box = this.form.querySelector('[data-consent]');
          inp?.setAttribute('aria-invalid', on && field === 'email' ? 'true' : 'false');
          box?.setAttribute('aria-invalid', on && field === 'consent' ? 'true' : 'false');
          if (on) (field === 'consent' ? box : inp)?.focus();
        }

        // rubbing while the card is locked: focus the field, give the form a short shake
        nudge() {
          const f = this.form;
          if (!f) return;
          f.querySelector('input[type="email"]')?.focus({ preventScroll: true });
          f.classList.remove('is-shake');
          void f.offsetWidth;
          f.classList.add('is-shake');
          this.later(() => f.classList.remove('is-shake'), 500);
        }

        // ---------- coin, glint, crumbs (mouse; off with animations off / reduced motion) ----------
        coinAt(e) {
          const show = (!!this.drag || this.grid.contains(e.target)) && !!this.st && !this.st.won && !this.locked();
          this.showCoin(show);
          if (show) {
            const [x, y] = this.local(e, this.card);
            this.coin.style.translate = `${x}px ${y}px`;
          }
        }

        showCoin(on) {
          if (!this.coin || this.coinShown === on) return;
          this.coinShown = on;
          this.coin.classList.toggle('is-on', on);
          this.grid.classList.toggle('is-coin', on);
        }

        glint(e) {
          if (!this.speed || e.pointerType !== 'mouse') return;
          const el = e.target.closest('[data-cell]');
          if (!el || el.contains(e.relatedTarget)) return;
          const c = this.cells[+el.dataset.cell];
          if (c.started || c.open || el.classList.contains('is-glint') || this.locked()) return;
          el.classList.add('is-glint');
          this.later(() => el.classList.remove('is-glint'), 950);
        }

        crumb(p) {
          if (!this.speed || this.crumbs > 36) return;
          const n = Math.random() < 0.4 ? 2 : 1;
          for (let i = 0; i < n; i++) {
            const s = document.createElement('span');
            s.className = 'werk-scratch-card_crumb';
            const x = p[0] + this.grid.offsetLeft + (Math.random() - 0.5) * 10;
            const y = p[1] + this.grid.offsetTop + (Math.random() - 0.5) * 6;
            s.style.rotate = `${Math.round(Math.random() * 180)}deg`;
            this.card.append(s);
            this.crumbs++;
            const a = s.animate(
              [
                { translate: `${x}px ${y}px`, opacity: 1 },
                { translate: `${x + (Math.random() - 0.5) * 28}px ${y + 18 + Math.random() * 40}px`, opacity: 0 },
              ],
              { duration: 600 + Math.random() * 300, easing: 'cubic-bezier(0.3, 0.6, 0.5, 1)', fill: 'forwards' }
            );
            this.anims.add(a);
            a.onfinish = a.oncancel = () => {
              s.remove();
              this.crumbs--;
              this.anims.delete(a);
            };
          }
        }

        // ---------- theme editor, timers, theme colors ----------
        // a selected prize block wins right away – to style the finished card
        onBlock(e) {
          const row = e.target.closest?.('[data-prize]');
          if (!row || !this.contains(row)) return;
          this.st = this.fresh(row.dataset.prize);
          if (!this.st) return;
          this.st.keys = [...this.st.seq];
          this.st.next = 9;
          this.st.open = Array(9).fill(true);
          this.st.won = true;
          this.mail = true;
          this.paint(true);
        }

        later(fn, ms) {
          const id = setTimeout(() => {
            this.timers.delete(id);
            if (this.isConnected) fn();
          }, ms * this.speed);
          this.timers.add(id);
        }

        clear() {
          this.timers?.forEach(clearTimeout);
          this.timers?.clear();
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-shoppable-film"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  // werk options · the moving parts of the option presets (src/_shared/werk-options.css). Glide: one indicator per group
  // (.werk-shoppable-film_opts) glides to the new choice – the leading edge first, the trailing one follows (clip-path or translate,
  // WAAPI). Ink drop: the ink floods in from the click point and drains from the old choice towards the new one; a light
  // follows the cursor on light grounds (data-opt-tone); thumbs get an ink bar along their foot. Sections set ARIA as usual – a MutationObserver picks
  // every change up, nothing else to call. werkOptions(root, prefix, signal) – once per section instance.
  window.werkOptions ||= (root, p, signal) => {
    const SEL = '[aria-checked="true"],[aria-pressed="true"],[aria-current="true"]';
    const on = (el) => el.matches(SEL);
    const preset = () => root.dataset.opt || '';
    const css = (name, fb) => getComputedStyle(root).getPropertyValue(name).trim() || fb;
    const speed = () => {
      const s = parseFloat(css('--werk-speed', '1'));
      return Number.isFinite(s) ? s : 1;
    };
    const ease = () => css('--werk-ease', 'cubic-bezier(0.6234, 0.058, 0, 0.9095)');
    const groups = () => [...root.querySelectorAll(`.${p}_opts`)];
    const items = (g) => [...g.children].filter((el) => el.classList.contains(`${p}_opt`));
    const shapeOf = (el) => ({ swatch: 'ring', thumb: 'ring', value: 'line', row: 'row' })[el.dataset.kind] || 'fill';
    const last = new WeakMap(); // group → control the indicator stands on
    const tap = new WeakMap(); // control → last pointer point inside it

    // ---------- glide ----------
    const box = (g, el) => {
      const a = g.getBoundingClientRect(), b = el.getBoundingClientRect();
      const r = { l: b.left - a.left, t: b.top - a.top, r: b.right - a.left, b: b.bottom - a.top, w: b.width, h: b.height };
      if (shapeOf(el) === 'line') r.t = r.b - 2;
      if (shapeOf(el) === 'ring') {
        const o = 4;
        Object.assign(r, { l: r.l - o, t: r.t - o, r: r.r + o, b: r.b + o, w: r.w + 2 * o, h: r.h + 2 * o });
      }
      return r;
    };
    const radius = (el) => {
      const k = shapeOf(el);
      if (k === 'line') return 1;
      const r = parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0;
      return k === 'ring' ? (el.dataset.kind === 'swatch' ? 999 : r + 4) : r;
    };
    const clip = (g, r, rad) => `inset(${r.t}px ${g.clientWidth - r.r}px ${g.clientHeight - r.b}px ${r.l}px round ${rad}px)`;
    const indOf = (g) => {
      let ind = g.querySelector(`:scope > .${p}_opt-ind`);
      if (!ind) {
        ind = document.createElement('span');
        ind.className = `${p}_opt-ind`;
        ind.setAttribute('aria-hidden', 'true');
        g.prepend(ind);
      }
      return ind;
    };
    const place = (g, el, from) => {
      const ind = indOf(g), k = shapeOf(el), b = box(g, el), rad = radius(el);
      ind.dataset.shape = k;
      ind.getAnimations().forEach((a) => a.cancel());
      if (k === 'row') ind.style.setProperty('--ind-cy', `${(b.t + b.b) / 2 - 10}px`);
      if (k === 'ring') {
        ind.style.setProperty('--ind-w', `${b.w}px`);
        ind.style.setProperty('--ind-h', `${b.h}px`);
        ind.style.setProperty('--ind-r', `${rad}px`);
        ind.style.setProperty('--ind-x', `${b.l}px`);
        ind.style.setProperty('--ind-y', `${b.t}px`);
      } else ind.style.setProperty('--ind-clip', clip(g, b, rad));
      g.classList.add('has-ind');
      if (!from || from === el || !speed()) return;
      const a = box(g, from), d = 460 * speed();
      if (k === 'ring') {
        const dx = a.l - b.l, dy = a.t - b.t;
        ind.animate(
          [{ translate: `${a.l}px ${a.t}px`, scale: '1' }, { scale: '0.86', offset: 0.45 }, { translate: `${b.l}px ${b.t}px`, scale: '1' }],
          { duration: d, easing: ease() }
        );
        return;
      }
      // leading edge first: the edge on the side of travel runs ahead, the other one follows
      const mid = {};
      for (const [lo, hi] of [['l', 'r'], ['t', 'b']]) {
        const fwd = b[lo] >= a[lo];
        const lead = fwd ? hi : lo, trail = fwd ? lo : hi;
        mid[lead] = a[lead] + (b[lead] - a[lead]) * 0.82;
        mid[trail] = a[trail] + (b[trail] - a[trail]) * 0.22;
      }
      ind.animate([{ clipPath: clip(g, a, radius(from)) }, { clipPath: clip(g, mid, rad), offset: 0.42 }, { clipPath: clip(g, b, rad) }], {
        duration: d,
        easing: ease(),
      });
    };
    const sync = (g, animate) => {
      if (preset() !== 'glide') return g.classList.remove('has-ind');
      const el = items(g).find(on);
      if (!el) return g.classList.remove('has-ind');
      place(g, el, animate ? last.get(g) : null);
      last.set(g, el);
    };

    // ---------- ink drop ----------
    const reach = (el, x, y) => Math.hypot(Math.max(x, el.offsetWidth - x), Math.max(y, el.offsetHeight - y)) + 2;
    const toward = (el, other) => {
      // the point on el's edge facing the other control
      const a = el.getBoundingClientRect(), b = other.getBoundingClientRect();
      const cx = Math.min(Math.max(b.left + b.width / 2, a.left), a.right) - a.left;
      const cy = Math.min(Math.max(b.top + b.height / 2, a.top), a.bottom) - a.top;
      return [cx, cy];
    };
    const ink = (el, open, at) => {
      if (preset() !== 'ink' || !speed() || el.dataset.kind === 'swatch') return;
      const w = el.offsetWidth, [x, y] = at || [w / 2, el.offsetHeight / 2];
      const r = reach(el, x, y);
      // thumbs: a bar along the foot runs out from the click; everything else: a circle of ink
      const [big, none] = el.dataset.kind === 'thumb'
        ? ['inset(0px 0px 0px 0px)', `inset(0px ${w - x}px 0px ${x}px)`]
        : [`circle(${r}px at ${x}px ${y}px)`, `circle(0px at ${x}px ${y}px)`];
      // bigger controls take longer, so a wide row doesn't flood in a blink
      const d = Math.min(380 + r * 1.8, 900) * (open ? 1 : 0.68) * speed();
      el.animate(
        { clipPath: open ? [none, big] : [big, none], opacity: [1, 1] },
        { pseudoElement: '::after', duration: d, easing: open ? 'cubic-bezier(0.16, 1, 0.3, 1)' : 'cubic-bezier(0.55, 0, 0.8, 0.2)' }
      );
    };

    // ---------- watch ARIA ----------
    const mo = new MutationObserver((list) => {
      const seen = new Set();
      for (const m of list) {
        const el = m.target;
        if (!el.classList?.contains(`${p}_opt`) || seen.has(el)) continue;
        seen.add(el);
        const g = el.parentElement?.classList.contains(`${p}_opts`) ? el.parentElement : null;
        if (on(el)) {
          const prev = g && last.get(g);
          if (preset() === 'ink') {
            ink(el, true, tap.get(el) || (prev && prev !== el ? toward(el, prev) : null));
            if (prev && prev !== el) ink(prev, false, toward(prev, el));
          }
          if (g) {
            if (preset() === 'glide') sync(g, true);
            else last.set(g, el);
          }
        } else if (!g) ink(el, false, tap.get(el));
        tap.delete(el);
      }
    });
    mo.observe(root, { subtree: true, attributes: true, attributeFilter: ['aria-checked', 'aria-pressed', 'aria-current'] });
    signal?.addEventListener('abort', () => mo.disconnect());

    // ---------- pointer: click point, light ----------
    const pt = (el, e) => {
      const r = el.getBoundingClientRect();
      return [e.clientX - r.left, e.clientY - r.top, r];
    };
    root.addEventListener('pointerdown', (e) => {
      const el = e.target.closest?.(`.${p}_opt`);
      if (el) tap.set(el, pt(el, e).slice(0, 2));
    }, { signal });
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    root.addEventListener('pointermove', (e) => {
      if (!fine.matches || preset() !== 'ink') return;
      const el = e.target.closest?.(`.${p}_opt`);
      if (!el) return;
      const [x, y] = pt(el, e);
      el.style.setProperty('--mx', `${x}px`);
      el.style.setProperty('--my', `${y}px`);
    }, { signal });

    // ---------- keep indicators in place ----------
    // light or dark ground from the paper colour's luminance (theme colours can be anything)
    const probe = document.createElement('i');
    probe.setAttribute('aria-hidden', 'true');
    const tone = () => {
      probe.style.cssText = 'position:absolute;width:0;height:0;color:var(--opt-paper)';
      root.append(probe);
      const [r, g, b] = (getComputedStyle(probe).color.match(/[\d.]+/g) || [255, 255, 255]).map(Number);
      probe.remove();
      const t = 0.2126 * r + 0.7152 * g + 0.0722 * b < 128 ? 'dark' : 'light';
      if (root.dataset.optTone !== t) root.dataset.optTone = t;
    };
    const all = () => {
      tone();
      groups().forEach((g) => sync(g, false));
    };
    const ro = new ResizeObserver(() => requestAnimationFrame(all));
    groups().forEach((g) => ro.observe(g));
    signal?.addEventListener('abort', () => ro.disconnect());
    const mp = new MutationObserver(all);
    mp.observe(root, { attributes: true, attributeFilter: ['data-opt', 'class', 'style'] });
    signal?.addEventListener('abort', () => mp.disconnect());
    document.fonts?.ready.then(all);
    all();
    return { refresh: all };
  };
  if (!customElements.get('werk-shoppable-film')) {
    customElements.define(
      'werk-shoppable-film',
      class extends HTMLElement {
        connectedCallback() {
          try {
            this.d = JSON.parse(this.querySelector('script[data-werk]').textContent);
            this.t = JSON.parse(this.querySelector('script[data-werk-t]').textContent);
          } catch {
            return;
          }
          this.ac = new AbortController();
          const signal = this.ac.signal;
          const on = (el, ev, fn, o) => el && el.addEventListener(ev, fn, { signal, ...o });
          this.uid = this.getAttribute('id');
          this.stage = this.querySelector('.werk-shoppable-film_stage');
          this.player = this.querySelector('.werk-shoppable-film_player');
          if (!this.player) return;
          this.card = this.querySelector('[data-card]');
          this.cap = this.querySelector('[data-cap]');
          this.outro = this.querySelector('[data-outro]');
          this.label = this.querySelector('[data-label]');
          this.bars = [...this.querySelectorAll('.werk-shoppable-film_bar > span')];
          // chapter list rows or chapter ticks – whichever the layout shows
          this.items = [...this.querySelectorAll('.werk-shoppable-film_ch, .werk-shoppable-film_tick')];
          this.marks = this.items.map((b) => b.querySelector('.werk-shoppable-film_ch-bar > span, .werk-shoppable-film_tick > span'));
          this.story = this.querySelector('[data-story]');
          const film = this.querySelector('[data-film]');
          const clips = [...this.querySelectorAll('[data-clip]')];
          this.film = film?.querySelector('video');
          this.ch = this.d.ch.map((c, i) => {
            const box = c.clip ? clips.find((x) => +x.dataset.clip === i) : film;
            const lines = String(c.c || '').split(/\r?\n/).map((x) => x.trim()).filter(Boolean);
            return { ...c, i, box, el: box?.querySelector('video'), s: c.clip ? 0 : this.secs(c.s), lines };
          });
          if (!this.ch.length || this.ch.some((c) => !c.el)) return;
          this.n = this.ch.length;
          this.holds = new Set(['view']); // reasons to stand still: view, tab, press, card, editor
          if (document.hidden) this.holds.add('tab');
          this.sel = new Map();
          this.pending = new Map();
          this.still = matchMedia('(prefers-reduced-motion: reduce)');
          this.want = !!this.d.auto && this.moving();
          this.cc = !!this.d.cc;
          this.cur = -1;
          this.gen = 0;
          this.cardFor = -1;
          this.cardFree = 0;
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          // hover / press / gliding choice of the size chips; the script builds the indicator itself (class werk-shoppable-film_opt-ind –
          // named here so the build keeps its styles)
          window.werkOptions?.(this, 'werk-shoppable-film', signal);

          // the videos never loop on their own and stay muted until the sound button
          [...new Set(this.ch.map((c) => c.el))].forEach((v) => {
            v.muted = true;
            v.defaultMuted = true;
            v.loop = false;
            v.playsInline = true;
            v.removeAttribute('autoplay');
            v.removeAttribute('controls');
            on(v, 'play', () => v === this.ch[this.cur]?.el && this.frames());
            on(v, 'ended', () => v === this.ch[this.cur]?.el && this.next());
            on(v, 'loadedmetadata', () => {
              if (this.pending.has(v)) {
                v.currentTime = this.pending.get(v);
                this.pending.delete(v);
              }
              this.times();
            });
          });

          on(this, 'click', (e) => this.onClick(e));
          on(this, 'change', (e) => this.onChange(e));
          on(this.player, 'keydown', (e) => this.onKey(e));

          // tap left / right = chapter back / forward (Reels), click = pause (Cinema), press and hold = pause
          const hit = this.querySelector('.werk-shoppable-film_hit');
          on(hit, 'pointerdown', (e) => {
            if (e.button) return;
            this.tap = { x: e.clientX, t: performance.now() };
            clearTimeout(this.pressTm);
            this.pressTm = setTimeout(() => {
              this.pressed = true;
              this.holds.add('press');
              this.sync();
            }, 260);
          });
          const up = (e) => {
            clearTimeout(this.pressTm);
            const tap = this.tap;
            this.tap = null;
            if (this.pressed) {
              this.pressed = false;
              this.holds.delete('press');
              return this.sync();
            }
            if (!e || !tap) return;
            if (this.dataset.look === 'cinema') return this.toggle();
            const r = hit.getBoundingClientRect();
            this.want = true;
            tap.x - r.left < r.width / 3 ? this.prev() : this.next();
          };
          on(hit, 'pointerup', up);
          on(hit, 'pointercancel', () => up());
          on(hit, 'pointerleave', () => up());
          on(hit, 'contextmenu', (e) => e.preventDefault());

          // the film waits while visitors choose a size
          const hold = (on_) => {
            on_ ? this.holds.add('card') : this.holds.delete('card');
            this.sync();
          };
          on(this.card, 'pointerenter', (e) => e.pointerType === 'mouse' && hold(true));
          on(this.card, 'pointerleave', (e) => e.pointerType === 'mouse' && hold(false));
          on(this.card, 'pointerdown', (e) => {
            if (e.pointerType === 'mouse') return;
            clearTimeout(this.cardTm);
            hold(true);
            this.cardTm = setTimeout(() => hold(false), 4000);
          });
          on(this.card, 'focusin', (e) => e.target.matches(':focus-visible') && hold(true));
          on(this.card, 'focusout', (e) => !this.card.contains(e.relatedTarget) && hold(false));

          this.io = new IntersectionObserver(
            ([en]) => {
              if (en.isIntersecting) {
                this.holds.delete('view');
                this.seen = true;
                this.prime();
              } else this.holds.add('view');
              this.sync();
            },
            { threshold: 0.35 }
          );
          this.io.observe(this.player);
          on(document, 'visibilitychange', () => {
            document.hidden ? this.holds.add('tab') : this.holds.delete('tab');
            this.sync();
          });
          on(this.still, 'change', () => {
            if (!this.moving()) this.want = false;
            this.sync();
          });

          // theme editor: a selected chapter plays from its start, with its card, and waits
          on(document, 'shopify:block:select', (e) => {
            const i = this.items.findIndex((b) => b === e.target || b.contains(e.target) || e.target.contains?.(b));
            if (i < 0 || !this.contains(e.target)) return;
            this.holds.add('editor');
            this.go(i);
            this.showCard();
          });
          on(document, 'shopify:block:deselect', (e) => {
            if (!this.contains(e.target)) return;
            this.holds.delete('editor');
            this.sync();
          });

          this.go(0);
          this.times();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          this.gen++;
          [this.pressTm, this.cardTm, this.addTm, this.nudgeTm].forEach(clearTimeout);
          this.ch?.forEach((c) => c.el?.pause());
        }

        moving() {
          return this.dataset.motion !== 'off' && !this.still.matches;
        }
        speed() {
          return this.moving() ? 1 : 0;
        }

        // ---------- time ----------
        secs(v) {
          const n = String(v ?? '').trim().split(':').reduce((a, x) => a * 60 + (parseFloat(x.replace(',', '.')) || 0), 0);
          return Number.isFinite(n) ? Math.max(0, n) : 0;
        }
        offset(c) {
          return c.clip ? 0 : c.s;
        }
        // a film chapter runs to the start of the next film chapter (or the film's end), a clip to its own end
        end(c) {
          if (c.clip) return c.el.duration || c.ms / 1000 || 0;
          const nx = this.ch.slice(c.i + 1).find((x) => !x.clip && x.s > c.s);
          return nx ? nx.s : this.film.duration || this.d.film / 1000 || 0;
        }
        len(c) {
          return Math.max(0, this.end(c) - this.offset(c));
        }
        clock(sec) {
          const t = Math.round(sec);
          return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, '0')}`;
        }
        // chapter list: where each chapter starts on the film's whole timeline
        times() {
          let at = 0;
          this.ch.forEach((c, i) => {
            const el = this.items[i]?.querySelector('[data-time]');
            if (el) el.textContent = this.clock(at);
            at += this.len(c);
          });
        }

        // ---------- playback ----------
        seek(v, at) {
          if (v.readyState >= 1) v.currentTime = at;
          else this.pending.set(v, at);
        }
        // load the chapter that plays and the next one only once the player was in view
        prime() {
          if (!this.seen) return;
          [this.ch[this.cur], this.ch[this.cur + 1]].forEach((c) => {
            if (!c || c.el.preload === 'auto') return;
            c.el.preload = 'auto';
            if (c.el.readyState === 0) c.el.load();
          });
        }
        go(i) {
          i = Math.max(0, Math.min(this.n - 1, i));
          const prev = this.ch[this.cur];
          const c = this.ch[i];
          this.ended = false;
          this.classList.remove('is-ended');
          if (this.outroOpen) this.closeOutro();
          if (prev && prev.box !== c.box) {
            prev.el.pause();
            prev.box.classList.remove('is-on');
          }
          c.box.classList.add('is-on');
          this.cur = i;
          this.flow = this.inflow();
          const at = this.offset(c);
          // a film chapter that follows on seamlessly needs no seek
          if (prev?.el !== c.el || Math.abs(c.el.currentTime - at) > 0.3) this.seek(c.el, at);
          this.hideCard();
          this.paint();
          this.prime();
          this.sync();
        }
        next() {
          if (this.cur < this.n - 1) return this.go(this.cur + 1);
          this.finish();
        }
        prev() {
          const c = this.ch[this.cur];
          const lt = c.el.currentTime - this.offset(c);
          this.go(lt > 1.5 || this.cur === 0 ? this.cur : this.cur - 1);
        }
        finish() {
          if (this.d.end === 'loop') return this.go(0);
          if (this.d.end === 'outro' && this.openOutro()) return;
          this.ended = true;
          this.classList.add('is-ended');
          this.want = false;
          this.hideCard(true);
          this.sync();
        }
        toggle() {
          if (this.ended || this.outroOpen) {
            this.want = true;
            return this.go(0);
          }
          this.want = !this.want;
          this.seen = true;
          this.sync();
        }
        sync() {
          const c = this.ch[this.cur];
          if (!c) return;
          const run = this.want && !this.holds.size && !this.outroOpen && !this.ended;
          this.classList.toggle('is-paused', !this.want || this.ended);
          const btn = this.querySelector('.werk-shoppable-film_icon[data-act="play"]');
          btn?.setAttribute('aria-label', this.want && !this.ended ? this.t.pause : this.t.play);
          if (run) {
            this.prime();
            c.el.play()?.catch((err) => {
              // autoplay blocked (e.g. low power mode) → poster and play button
              if (err?.name === 'NotAllowedError' && c === this.ch[this.cur]) {
                this.want = false;
                this.sync();
              }
            });
          } else if (!c.el.paused) c.el.pause();
        }
        // progress, captions and the card follow the video frame by frame
        frames() {
          const g = ++this.gen;
          const v = this.ch[this.cur].el;
          const step = () => {
            if (g !== this.gen || !this.isConnected) return;
            this.tick();
            if (v.paused || v.ended || v !== this.ch[this.cur].el) return;
            v.requestVideoFrameCallback ? v.requestVideoFrameCallback(step) : requestAnimationFrame(step);
          };
          step();
        }
        tick() {
          const c = this.ch[this.cur];
          const len = this.len(c);
          const lt = Math.max(0, c.el.currentTime - this.offset(c));
          const k = len ? Math.min(1, lt / len) : 0;
          if (this.bars[this.cur]) this.bars[this.cur].style.scale = `${k} 1`;
          if (this.marks[this.cur]) this.marks[this.cur].style.scale = `${k} 1`;
          if (c.lines.length) {
            const j = len ? Math.min(c.lines.length - 1, Math.floor(k * c.lines.length)) : 0;
            if (j !== this.line) {
              this.line = j;
              this.cap.innerHTML = `<span>${this.esc(c.lines[j])}</span>`;
            }
          }
          // a card in the flow (product stage, Cinema on phones) changes at the chapter start, one in the film after its delay
          const wait = this.flow ? 0 : +c.d || 0;
          if (this.cardFor !== this.cur && c.p && !this.outroOpen && ((lt >= wait && performance.now() >= this.cardFree) || this.card.classList.contains('is-in'))) this.showCard();
          if (!c.clip && len && lt >= len - 0.05 && this.cur < this.n - 1 && c.el.currentTime < (this.film.duration || Infinity) - 0.1) this.next();
        }
        paint() {
          const c = this.ch[this.cur];
          this.label.innerHTML = `<span class="werk-shoppable-film_label-n">${this.pad(this.cur + 1)} / ${this.pad(this.n)}</span><span>${this.esc(c.t)}</span>`;
          this.items.forEach((b, j) => b.setAttribute('aria-current', String(j === this.cur)));
          this.bars.forEach((b, j) => (b.style.scale = `${j < this.cur ? 1 : 0} 1`));
          this.marks.forEach((b, j) => b && (b.style.scale = `${j < this.cur ? 1 : 0} 1`));
          this.line = -1;
          this.cap.hidden = !c.lines.length;
          this.cap.innerHTML = '';
          if (this.story) {
            const set = (sel, text) => (this.story.querySelector(sel).textContent = text);
            set('[data-story-n]', `${this.pad(this.cur + 1)} / ${this.pad(this.n)}`);
            set('[data-story-title]', c.t || '');
            set('[data-story-text]', c.st || c.lines.join(' '));
            this.story.classList.remove('is-swap');
            if (this.painted) {
              void this.story.offsetWidth;
              this.story.classList.add('is-swap');
            }
            this.painted = true;
          }
          this.tick();
          // keep the active chapter in view in the phone strip, without moving the page
          const list = this.items[this.cur]?.closest('.werk-shoppable-film_list');
          const it = this.items[this.cur]?.parentElement;
          if (list && it && list.scrollWidth > list.clientWidth + 2) {
            list.scrollTo({ left: it.offsetLeft - list.firstElementChild.offsetLeft, behavior: this.speed() ? 'smooth' : 'auto' });
          }
        }

        // ---------- product card ----------
        showCard() {
          const c = this.ch[this.cur];
          this.cardFor = this.cur;
          if (!c?.p) return;
          const p = c.p;
          if (!this.sel.has(p.id)) this.sel.set(p.id, p.o.map((_, k) => ((p.ov[k] || []).length === 1 ? p.ov[k][0] : null)));
          const swap = this.card.classList.contains('is-in');
          this.card.innerHTML = this.cardHTML(c);
          this.update();
          this.card.classList.remove('is-swap');
          void this.card.offsetWidth;
          this.card.classList.add('is-in');
          if (swap) this.card.classList.add('is-swap');
          // Reels: captions and bottom AI labels move up over the card
          if (this.dataset.look === 'reels' && !this.flow) this.stage.style.setProperty('--card-h', this.card.offsetHeight + 12 + 'px');
        }
        // Cinema on phones: the card sits in the flow below the film
        inflow() {
          return getComputedStyle(this.card).position !== 'absolute';
        }
        hideCard(force) {
          this.cardFor = -1;
          if (!this.card.classList.contains('is-in')) return;
          const next = this.ch[this.cur];
          if (!force && next?.p && this.inflow()) return;
          this.card.classList.remove('is-in');
          this.stage.style.removeProperty('--card-h');
          this.cardFree = performance.now() + 320 * this.speed();
          if (this.holds.delete('card')) clearTimeout(this.cardTm);
        }
        cardHTML(c) {
          const p = c.p;
          const href = this.esc(p.u || '#');
          const pic = p.img ? `<img src="${this.esc(p.img)}" alt="" width="104" height="130"${p.fp ? ` style="object-position:${this.esc(p.fp)}"` : ''}>` : '';
          let opts = '';
          if (p.o.length) {
            const long = p.o.length > 2 || p.ov.some((v) => v.length > 6 || v.join('').length > 28);
            opts = `<div class="werk-shoppable-film_opts-wrap">${p.o
              .map((name, k) => {
                const vals = p.ov[k] || [];
                const lid = `${this.uid}-o${k}`;
                if (long) return `<label class="werk-shoppable-film_select" data-k="${k}"><span class="werk-shoppable-film_opt-name">${this.esc(name)}</span><select data-opt="${k}"><option value="">${this.esc(name)}</option>${vals.map((v) => `<option value="${this.esc(v)}">${this.esc(v)}</option>`).join('')}</select></label>`;
                return `<div class="werk-shoppable-film_option" data-k="${k}"><p class="werk-shoppable-film_opt-name" id="${lid}">${this.esc(name)}</p><div class="werk-shoppable-film_values werk-shoppable-film_opts" role="radiogroup" aria-labelledby="${lid}">${vals.map((v) => `<button type="button" class="werk-shoppable-film_value werk-shoppable-film_opt" data-kind="chip" role="radio" aria-checked="false" data-opt="${k}" data-value="${this.esc(v)}"><span class="werk-shoppable-film_opt-label">${this.esc(v)}</span></button>`).join('')}</div></div>`;
              })
              .join('')}</div>`;
          }
          const desc = p.d ? `<p class="werk-shoppable-film_card-desc">${this.esc(p.d)}</p>` : '';
          return `<div class="werk-shoppable-film_card-main"><a class="werk-shoppable-film_card-pic" href="${href}" tabindex="-1" aria-hidden="true">${pic}</a><div class="werk-shoppable-film_card-info"><p class="werk-shoppable-film_card-kicker">${this.pad(c.i + 1)} · ${this.esc(c.t)}</p><a class="werk-shoppable-film_card-name" href="${href}">${this.esc(p.t)}</a><p class="werk-shoppable-film_card-price" data-price></p>${desc}</div></div>${opts}<div class="werk-shoppable-film_card-buy">${this.button(p, 'data-add')}</div><p class="werk-shoppable-film_error" data-error role="status" hidden></p>`;
        }
        button(p, attr, label) {
          const arrow = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14m-5.5-5.5L19 12l-5.5 5.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          const icons = '<svg class="werk-shoppable-film_spin" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-opacity=".25" stroke-width="2"/><path d="M20 12a8 8 0 0 0-8-8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><svg class="werk-shoppable-film_check" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          const cls = 'werk-shoppable-film_btn' + (this.classList.contains('is-theme-buttons') ? ' button' : '');
          if (p?.sp) return this.t.link ? `<a class="${cls}" href="${this.esc(p.u || '#')}"><span class="werk-shoppable-film_btn-roll"><span class="werk-shoppable-film_btn-row"><span class="werk-shoppable-film_btn-dot" aria-hidden="true">${arrow}</span><span>${this.esc(this.t.link)}</span></span></span></a>` : '';
          const price = p ? '<span class="werk-shoppable-film_sep" aria-hidden="true">·</span><span data-add-price></span>' : '';
          return `<button type="button" class="${cls}" ${attr}><span class="werk-shoppable-film_btn-roll"><span class="werk-shoppable-film_btn-row"><span class="werk-shoppable-film_btn-dot" aria-hidden="true">${arrow}</span><span data-label>${this.esc(label || this.t.add)}</span>${price}</span><span class="werk-shoppable-film_btn-row" aria-hidden="true">${icons}</span><span class="werk-shoppable-film_btn-row" aria-hidden="true">${icons}${this.esc(this.t.added)}</span></span></button>`;
        }
        variant(p, sel = this.sel.get(p.id) || []) {
          if (!p.o.length) return p.v[0] || null;
          if (sel.some((x) => x == null)) return null;
          return p.v.find((v) => v.o.every((x, k) => x === sel[k])) || null;
        }
        soldValue(p, k, val) {
          const sel = this.sel.get(p.id) || [];
          return !p.v.some((v) => v.a && v.o[k] === val && v.o.every((x, j) => j === k || sel[j] == null || x === sel[j]));
        }
        update() {
          const p = this.ch[this.cardFor]?.p;
          if (!p) return;
          const sel = this.sel.get(p.id) || [];
          const v = this.variant(p);
          this.card.querySelectorAll('.werk-shoppable-film_value').forEach((b) => {
            const k = +b.dataset.opt;
            b.setAttribute('aria-checked', String(sel[k] === b.dataset.value));
            b.toggleAttribute('data-out', this.soldValue(p, k, b.dataset.value));
          });
          this.card.querySelectorAll('select[data-opt]').forEach((s) => {
            const k = +s.dataset.opt;
            [...s.options].forEach((o) => o.value && (o.textContent = o.value + (this.soldValue(p, k, o.value) ? ' – ' + (this.t.soldOut || '') : '')));
            s.value = sel[k] || '';
          });
          const shown = v || p.v.find((x) => x.a) || p.v[0];
          this.card.querySelectorAll('[data-price]').forEach((el) => (el.textContent = shown ? this.money(shown.p) : ''));
          const btn = this.card.querySelector('[data-add]');
          if (!btn) return;
          const miss = p.o.findIndex((_, k) => sel[k] == null);
          const ok = !!v && v.a;
          btn.dataset.need = miss >= 0 ? miss : '';
          btn.disabled = !!v && !v.a;
          btn.querySelector('[data-label]').textContent = miss >= 0 ? this.fill(this.t.choose, { option: p.o[miss] }) : ok ? this.t.add : this.t.soldOut;
          btn.querySelectorAll('.werk-shoppable-film_sep, [data-add-price]').forEach((el) => (el.hidden = !ok));
          const ap = btn.querySelector('[data-add-price]');
          if (ap && ok) ap.textContent = this.money(v.p);
        }
        // “Choose Size” on the button: the missing option shakes and takes the focus
        nudge(k) {
          const el = this.card.querySelector(`[data-k="${k}"]`);
          if (!el) return;
          el.classList.remove('is-nudge');
          void el.offsetWidth;
          el.classList.add('is-nudge');
          clearTimeout(this.nudgeTm);
          this.nudgeTm = setTimeout(() => el.classList.remove('is-nudge'), 600);
          el.querySelector('button:not([data-out]), select')?.focus({ preventScroll: true });
        }

        // ---------- cart ----------
        async post(items) {
          // demo products (no product picked yet) only pretend; real ones go to the cart
          const fake = new Set(this.ch.flatMap((c) => (c.p?.dm ? c.p.v.map((v) => v.id) : [])));
          items = items.filter((x) => !fake.has(x.id));
          if (!items.length) return new Promise((r) => setTimeout(r, 500));
          const root = window.Shopify?.routes?.root || '/';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const json = await res.json().catch(() => ({}));
          if (!res.ok) throw json;
          const cartP = fetch(root + 'cart.js').then((r) => r.json());
          const ev = new Event('shopify:cart:lines-update', { bubbles: true });
          Object.assign(ev, {
            action: 'add',
            context: 'product',
            lines: items.map((x) => ({ merchandiseId: x.id, quantity: x.quantity })),
            promise: cartP.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
          });
          this.dispatchEvent(ev);
          this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.werkThemeCart?.(root);
        }
        async buy(btn, items, err) {
          if (!items.length || btn.dataset.state) return;
          if (err) err.hidden = true;
          btn.dataset.state = 'loading';
          try {
            await this.post(items);
            btn.dataset.state = 'added';
            clearTimeout(this.addTm);
            this.addTm = setTimeout(() => delete btn.dataset.state, 1800);
          } catch (e) {
            delete btn.dataset.state;
            if (err) {
              err.textContent = this.fill(this.t.error, { message: e?.description || e?.message || '' }).trim();
              err.hidden = false;
            }
          }
        }
        add(btn) {
          const p = this.ch[this.cardFor]?.p;
          if (!p) return;
          if (btn.dataset.need !== '') return this.nudge(+btn.dataset.need);
          const v = this.variant(p);
          if (v?.a) this.buy(btn, [{ id: v.id, quantity: 1 }], this.card.querySelector('[data-error]'));
        }

        // ---------- shop the look ----------
        openOutro() {
          const ids = new Set();
          this.looks = this.ch.map((c) => c.p).filter((p) => p && !ids.has(p.id) && ids.add(p.id));
          if (!this.looks.length || !this.outro) return false;
          const rows = this.looks
            .map((p, i) => {
              const v0 = this.variant(p) || p.v.find((x) => x.a) || p.v[0];
              const any = !p.sp && p.v.some((x) => x.a);
              const pic = p.img ? `<img src="${this.esc(p.img)}" alt="" loading="lazy" width="88" height="110">` : '';
              const opts = any && p.o.length ? `<span class="werk-shoppable-film_row-opts">${p.o.map((name, k) => `<select data-row="${i}" data-opt="${k}" aria-label="${this.esc(p.t)} – ${this.esc(name)}">${(p.ov[k] || []).map((val) => `<option value="${this.esc(val)}"${v0?.o[k] === val ? ' selected' : ''}>${this.esc(val)}</option>`).join('')}</select>`).join('')}</span>` : '';
              const out = any ? '' : `<span class="werk-shoppable-film_row-out">${this.esc(p.sp ? this.t.link : this.t.soldOut)}</span>`;
              return `<li class="werk-shoppable-film_row-item"><input type="checkbox" class="werk-shoppable-film_check-box" data-row="${i}" ${any ? 'checked' : 'disabled'} aria-label="${this.esc(p.t)}"><span class="werk-shoppable-film_row-pic">${pic}</span><span class="werk-shoppable-film_row-text"><span class="werk-shoppable-film_row-name">${this.esc(p.t)}</span>${opts}${out}</span><span class="werk-shoppable-film_row-price" data-row-price="${i}"></span></li>`;
            })
            .join('');
          const replay = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4.5 12a7.5 7.5 0 1 0 2.2-5.3M4.5 4.5v4h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          this.outro.innerHTML = `<div class="werk-shoppable-film_outro-in">${this.t.outroTitle ? `<p class="werk-shoppable-film_outro-title" tabindex="-1">${this.esc(this.t.outroTitle)}</p>` : ''}${this.t.outroText ? `<p class="werk-shoppable-film_outro-text">${this.esc(this.t.outroText)}</p>` : ''}<ul class="werk-shoppable-film_rows" role="list">${rows}</ul><div class="werk-shoppable-film_outro-buy">${this.button(null, 'data-add-all', ' ')}<button type="button" class="werk-shoppable-film_replay" data-replay>${replay}${this.esc(this.t.replay)}</button></div><p class="werk-shoppable-film_error" data-error role="status" hidden></p></div>`;
          const focusIn = this.contains(document.activeElement);
          // the product stage stays beside Shop the look; a card in the film makes room
          if (!this.card.closest('.werk-shoppable-film_aside')) this.hideCard(true);
          this.outroOpen = true;
          this.outro.hidden = false;
          this.classList.add('is-outro');
          this.bars.forEach((b) => (b.style.scale = '1 1'));
          this.marks.forEach((b) => b && (b.style.scale = '0 1'));
          this.items.forEach((b) => b.setAttribute('aria-current', 'false'));
          this.cap.hidden = true;
          this.sum();
          this.sync();
          if (focusIn) (this.outro.querySelector('.werk-shoppable-film_outro-title') || this.outro.querySelector('button'))?.focus({ preventScroll: true });
          return true;
        }
        closeOutro() {
          this.outroOpen = false;
          this.outro.hidden = true;
          this.outro.innerHTML = '';
          this.classList.remove('is-outro');
        }
        rowVariant(i) {
          const p = this.looks[i];
          const vals = [...this.outro.querySelectorAll(`select[data-row="${i}"]`)].map((s) => s.value);
          return p.o.length ? p.v.find((v) => v.o.every((x, k) => x === vals[k])) : p.v[0];
        }
        picked() {
          return [...this.outro.querySelectorAll('.werk-shoppable-film_check-box:checked')].map((b) => this.rowVariant(+b.dataset.row)).filter((v) => v?.a);
        }
        sum() {
          this.looks.forEach((p, i) => {
            const v = this.rowVariant(i);
            const el = this.outro.querySelector(`[data-row-price="${i}"]`);
            if (el) el.textContent = v ? this.money(v.p) : '';
          });
          const vs = this.picked();
          const btn = this.outro.querySelector('[data-add-all]');
          btn.disabled = !vs.length;
          btn.querySelector('[data-label]').textContent = this.fill(this.t.outroAdd, { price: this.money(vs.reduce((a, v) => a + v.p, 0)), count: vs.length });
        }

        // ---------- input ----------
        onClick(e) {
          const act = e.target.closest('[data-act]')?.dataset.act;
          if (act === 'play') return this.toggle();
          if (act === 'sound') return this.sound();
          if (act === 'prev' || act === 'next') {
            this.want = true;
            this.seen = true;
            return act === 'next' ? this.next() : this.go(this.outroOpen ? this.n - 1 : this.cur - 1);
          }
          if (act === 'cc') {
            this.cc = !this.cc;
            this.classList.toggle('is-cc-off', !this.cc);
            return e.target.closest('[data-act]').setAttribute('aria-pressed', String(this.cc));
          }
          const go = e.target.closest('[data-go]');
          if (go) {
            this.want = true;
            this.seen = true;
            return this.go(+go.dataset.go);
          }
          const val = e.target.closest('.werk-shoppable-film_value');
          if (val && this.card.contains(val)) {
            const p = this.ch[this.cardFor]?.p;
            if (!p) return;
            this.sel.get(p.id)[+val.dataset.opt] = val.dataset.value;
            return this.update();
          }
          const add = e.target.closest('[data-add]');
          if (add) return this.add(add);
          if (e.target.closest('[data-replay]')) return this.toggle();
          const all = e.target.closest('[data-add-all]');
          if (all) return this.buy(all, this.picked().map((v) => ({ id: v.id, quantity: 1 })), this.outro.querySelector('[data-error]'));
          // demo products have no page
          if (e.target.closest('a[href="#"]')) e.preventDefault();
        }
        onChange(e) {
          const s = e.target;
          if (this.outro.contains(s)) return this.sum();
          if (s.matches('select[data-opt]') && this.card.contains(s)) {
            const p = this.ch[this.cardFor]?.p;
            if (!p) return;
            this.sel.get(p.id)[+s.dataset.opt] = s.value || null;
            this.update();
          }
        }
        onKey(e) {
          if (e.target !== this.player) return;
          const k = e.key.toLowerCase();
          if (k === ' ' || k === 'k') this.toggle();
          else if (k === 'arrowleft') this.prev();
          else if (k === 'arrowright') this.next();
          else if (k === 'm') this.sound();
          else if (k === 'c') this.querySelector('[data-act="cc"]')?.click();
          else return;
          e.preventDefault();
        }
        sound() {
          const on = this.ch[0].el.muted;
          [...new Set(this.ch.map((c) => c.el))].forEach((v) => (v.muted = !on));
          this.querySelector('[data-act="sound"]')?.setAttribute('aria-pressed', String(on));
        }

        // ---------- helpers ----------
        pad(n) {
          return String(n).padStart(2, '0');
        }
        esc(v) {
          return String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
        }
        fill(text, map) {
          return String(text || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));
        }
        money(cents) {
          const f = (n, d, ts, ds) => {
            const [i, fr] = (n / 100).toFixed(d).split('.');
            return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (fr ? ds + fr : '');
          };
          const map = {
            amount: () => f(cents, 2, ',', '.'),
            amount_no_decimals: () => f(cents, 0, ',', '.'),
            amount_with_comma_separator: () => f(cents, 2, '.', ','),
            amount_no_decimals_with_comma_separator: () => f(cents, 0, '.', ','),
            amount_with_space_separator: () => f(cents, 2, ' ', ','),
            amount_no_decimals_with_space_separator: () => f(cents, 0, ' ', ','),
            amount_with_apostrophe_separator: () => f(cents, 2, "'", '.'),
            amount_with_period_and_space_separator: () => f(cents, 2, ' ', '.'),
          };
          // fallback built in pieces: two curly braces in a row would be read as Liquid
          const html = (this.d.money || '$' + '{' + '{amount}' + '}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (map[k] || map.amount)());
          const tmp = document.createElement('span');
          tmp.innerHTML = html;
          return tmp.textContent;
        }
        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-stack-to-bento"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-stack-to-bento')) {
    // timeline in units – one unit ≈ one card landing, so every card keeps its pace however many there are
    const U = { start: 0.3, enter: 1, gap: 1, hold: 0.3, deal: 2, stagger: 0.35 };
    const ROT = [-6, 5, -3, 7, -4, 6, -2];
    const DX = [-26, 22, -12, 18, -20, 14, -8];
    const DY = [14, -8, -16, 10, 6, -12, 16];
    const clamp = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
    const lerp = (a, b, t) => a + (b - a) * t;
    const outCubic = (t) => 1 - (1 - t) ** 3;
    // cubic-bezier as a function (Newton steps, bisection fallback) – the deal follows the section's easing
    const bezier = (x1, y1, x2, y2) => {
      const f = (t, a, b) => ((1 - 3 * b + 3 * a) * t + (3 * b - 6 * a)) * t * t + 3 * a * t;
      const d = (t, a, b) => 3 * (1 - 3 * b + 3 * a) * t * t + 2 * (3 * b - 6 * a) * t + 3 * a;
      return (x) => {
        if (x <= 0 || x >= 1) return x <= 0 ? 0 : 1;
        let t = x;
        for (let i = 0; i < 6; i++) {
          const s = d(t, x1, x2);
          if (Math.abs(s) < 1e-6) break;
          t -= (f(t, x1, x2) - x) / s;
        }
        if (t < 0 || t > 1 || Math.abs(f(t, x1, x2) - x) > 1e-4) {
          let lo = 0, hi = 1;
          for (let i = 0; i < 24; i++) {
            t = (lo + hi) / 2;
            f(t, x1, x2) < x ? (lo = t) : (hi = t);
          }
        }
        return f(t, y1, y2);
      };
    };

    customElements.define(
      'werk-stack-to-bento',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.werk-stack-to-bento_track');
          this.stage = this.querySelector('.werk-stack-to-bento_stage');
          this.countEl = this.querySelector('[data-count]');
          this.cards = [...this.querySelectorAll('.werk-stack-to-bento_card')].map((el) => ({
            el,
            inner: el.querySelector('.werk-stack-to-bento_card-in'),
            cell: el.parentElement,
            k: +el.dataset.k || 0,
            d: +el.dataset.d || 0,
            hero: el.hasAttribute('data-hero'),
          }));
          this.n = this.cards.length;
          this.still = matchMedia('(prefers-reduced-motion: reduce)');
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          // Horizon scrolls div.page-wrapper, not the window – listen to every scroll on the page
          on(document, 'scroll', () => this.wake(), { capture: true, passive: true });
          on(window, 'resize', () => this.wake(true), { passive: true });
          on(this.still, 'change', () => this.setup());
          on(document, 'shopify:block:select', (e) => this.onSelect(e));
          this.buyBar(on);
          this.setup();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          this.ro?.disconnect();
          cancelAnimationFrame(this.raf);
          clearTimeout(this.st);
          this.running = false;
        }

        // ---------- stack or static grid ----------
        setup() {
          this.io?.disconnect();
          this.ro?.disconnect();
          cancelAnimationFrame(this.raf);
          this.running = false;
          this.live = this.n > 1 && this.dataset.motion === 'on' && !this.still.matches && !!this.track;
          this.classList.toggle('is-live', this.live);
          if (!this.live) {
            this.classList.remove('is-stack');
            for (const c of this.cards) {
              c.el.removeAttribute('style');
              c.el.inert = false;
            }
            ['--intro', '--head', '--count'].forEach((v) => this.style.removeProperty(v));
            return;
          }
          const n = this.n;
          const stackEnd = U.start + (n - 1) * U.gap + U.enter;
          const dealStart = stackEnd + U.hold;
          const dealEnd = dealStart + U.deal + U.stagger * (n - 1);
          this.T = { stackEnd, dealStart, dealEnd, total: dealEnd + 0.4 };
          this.style.setProperty('--total', this.T.total);
          for (const c of this.cards) {
            c.rot = c.hero ? -1.5 : ROT[c.k % ROT.length];
            c.dx = c.hero ? 0 : DX[c.k % DX.length];
            c.dy = c.hero ? 0 : DY[c.k % DY.length];
            c.landed = false;
          }
          const m = getComputedStyle(this.querySelector('.werk-stack-to-bento_inner')).getPropertyValue('--werk-ease').match(/cubic-bezier\(([^)]+)\)/);
          const b = m ? m[1].split(',').map(parseFloat) : [0.6234, 0.058, 0, 0.9095];
          this.ease = bezier(...b);
          this.bounceOn = this.dataset.bounce !== 'false';
          this.measure();
          this.p = this.read();
          this.render(this.p, false);

          this.io = new IntersectionObserver(([e]) => {
            this.vis = e.isIntersecting;
            this.wake(true);
          });
          this.io.observe(this.track);
          this.ro = new ResizeObserver(() => this.wake(true));
          this.ro.observe(this);
          document.fonts?.ready.then(() => this.isConnected && this.live && this.wake(true));
        }

        measure() {
          const s = this.stage.getBoundingClientRect();
          this.W = s.width;
          this.H = s.height;
          for (const c of this.cards) {
            const r = c.cell.getBoundingClientRect();
            c.box = { x: r.left - s.left, y: r.top - s.top, w: r.width, h: r.height };
          }
          // the pile: right of the intro on desktop, below it on tablet & phone (same 990 px switch as the grid)
          const phone = this.offsetWidth < 990;
          this.dw = Math.min(phone ? 250 : 340, this.W * 0.68);
          this.dh = this.dw * 1.3;
          if (this.dh > this.H * 0.62) {
            this.dh = this.H * 0.62;
            this.dw = this.dh / 1.3;
          }
          this.cx = phone ? this.W / 2 : this.W * 0.62;
          this.cy = phone ? this.H * 0.6 : this.H * 0.52;
          // tablet & phone: the pile stays below the intro, however long its text is (smaller if it has to)
          const intro = this.querySelector('.werk-stack-to-bento_intro');
          if (phone && intro) {
            const top = intro.getBoundingClientRect().bottom - s.top + 28;
            const room = this.H - 20 - top;
            if (this.dh > room) {
              this.dh = Math.max(room, 160);
              this.dw = this.dh / 1.3;
            }
            this.cy = Math.max(this.cy, top + this.dh / 2);
          }
        }

        read() {
          const r = this.track.getBoundingClientRect();
          const len = r.height - this.stage.offsetHeight;
          return len > 0 ? clamp(-r.top / len) : 1;
        }

        // ---------- loop: only while the section is in view and something moves ----------
        wake(remeasure) {
          if (!this.live) return;
          if (remeasure) this.dirty = true;
          if (!this.vis || this.running) return;
          this.running = true;
          this.idle = 0;
          this.last = performance.now();
          this.raf = requestAnimationFrame((t) => this.tick(t));
        }

        tick(now) {
          if (!this.isConnected || !this.live) return (this.running = false);
          if (this.dirty) {
            this.dirty = false;
            this.measure();
          }
          const dt = Math.min((now - this.last) / 1000, 1 / 20);
          this.last = now;
          const goal = this.read();
          const down = goal > this.p;
          // scroll only sets the goal; the shown value glides after it, frame-rate independent
          this.p += (goal - this.p) * (1 - Math.exp(-dt * 14));
          if (Math.abs(goal - this.p) < 0.0004) this.p = goal;
          this.render(this.p, down);
          this.idle = this.p === goal ? this.idle + 1 : 0;
          if (this.idle > 20 || !this.vis) return (this.running = false);
          this.raf = requestAnimationFrame((t) => this.tick(t));
        }

        render(p, down) {
          const T = this.T;
          const u0 = p * T.total;
          let landed = 0;
          for (const c of this.cards) {
            const t = clamp((u0 - (U.start + c.k * U.gap)) / U.enter);
            const uRaw = clamp((u0 - T.dealStart - c.d * U.stagger) / U.deal);
            const u = this.ease(uRaw);
            const deckX = this.cx - this.dw / 2 + c.dx;
            const deckY = this.cy - this.dh / 2 + c.dy;
            let x = deckX;
            let y = lerp(deckY + this.H * 0.95, deckY, outCubic(t));
            let w = this.dw;
            let h = this.dh;
            let rot = c.rot * t * t;
            const box = c.box;
            if (uRaw > 0) {
              x = lerp(deckX, box.x, u);
              y = lerp(deckY, box.y, u);
              w = lerp(this.dw, box.w, u);
              h = lerp(this.dh, box.h, u);
              rot = c.rot * (1 - u);
            }
            const lift = Math.sin(Math.PI * uRaw) * 0.03;
            const st = c.el.style;
            st.width = w.toFixed(1) + 'px';
            st.height = h.toFixed(1) + 'px';
            st.transform = `translate3d(${(x - box.x).toFixed(2)}px,${(y - box.y).toFixed(2)}px,0) rotate(${rot.toFixed(3)}deg) scale(${(1 + lift).toFixed(4)})`;
            st.zIndex = uRaw > 0 ? 20 + (this.n - c.d) : 10 + c.k;
            st.visibility = t > 0 ? 'visible' : 'hidden';
            st.setProperty('--sh', (Math.min(t * 3, 1) * (1 - clamp(u))).toFixed(3));
            st.setProperty('--chip', (1 - clamp(u)).toFixed(3));
            // links and the buy bar only work once the card sits in its cell
            const off = uRaw < 1;
            if (c.el.inert !== off) c.el.inert = off;
            if (t >= 1) landed++;
            if (t >= 1 && !c.landed) {
              c.landed = true;
              if (down && uRaw === 0) this.bounce(c.inner);
            }
            if (t < 0.97) c.landed = false;
          }
          this.style.setProperty('--intro', (1 - clamp((u0 - T.stackEnd) / 0.8)).toFixed(3));
          this.style.setProperty('--head', clamp((u0 - (T.dealEnd - 0.9)) / 1).toFixed(3));
          this.style.setProperty('--count', (landed / this.n).toFixed(3));
          if (this.countEl) {
            const label = String(landed).padStart(2, '0') + ' / ' + String(this.n).padStart(2, '0');
            if (this.countEl.textContent !== label) this.countEl.textContent = label;
          }
        }

        // squash on impact, then an under-damped spring back – it was dropped, so it may wobble
        bounce(el) {
          if (!this.bounceOn || !el.animate) return;
          el.animate(
            [
              { transform: 'scale(1,1)' },
              { transform: 'scale(1.035,0.975)', offset: 0.12 },
              { transform: 'scale(0.99,1.012)', offset: 0.34 },
              { transform: 'scale(1.006,0.996)', offset: 0.56 },
              { transform: 'scale(1,1)' },
            ],
            { duration: 700, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
          );
        }

        // ---------- theme editor: picking a block jumps to the bento and points at the card ----------
        onSelect(e) {
          if (!this.contains(e.target)) return;
          const c = this.cards.find((x) => x.el.dataset.block === e.detail?.blockId);
          if (this.live) {
            this.track.scrollIntoView({ block: 'end' });
            this.measure();
            this.p = this.read();
            this.render(this.p, false);
          }
          c?.inner.animate?.(
            [{ boxShadow: 'inset 0 0 0 0 transparent' }, { boxShadow: 'inset 0 0 0 3px var(--werk-accent)' }, { boxShadow: 'inset 0 0 0 0 transparent' }],
            { duration: 1200, easing: 'ease-in-out' }
          );
        }

        // ---------- hero: colours and add to cart ----------
        buyBar(on) {
          const bar = this.querySelector('.werk-stack-to-bento_buy');
          if (!bar) return;
          const form = bar.querySelector('[data-add]');
          const btn = bar.querySelector('.werk-stack-to-bento_btn');
          const price = bar.querySelector('[data-price]');
          const img = bar.parentElement.querySelector('img.werk-stack-to-bento_img');
          bar.querySelectorAll('.werk-stack-to-bento_swatch').forEach((sw) =>
            on(sw, 'click', () => {
              bar.querySelectorAll('.werk-stack-to-bento_swatch').forEach((x) => x.setAttribute('aria-pressed', String(x === sw)));
              if (!sw.dataset.id || !form) return;
              form.querySelector('[name="id"]').value = sw.dataset.id;
              if (price && sw.dataset.price) price.textContent = sw.dataset.price;
              const sold = sw.hasAttribute('data-soldout');
              if (btn) {
                btn.disabled = sold;
                const label = btn.querySelector('[data-label]');
                if (label) label.textContent = sold ? form.dataset.soldLabel : form.dataset.addLabel;
              }
              if (img && sw.dataset.img) {
                const next = new Image();
                next.src = sw.dataset.img;
                next.decode().then(() => {
                  img.removeAttribute('srcset');
                  img.src = sw.dataset.img;
                }, () => {});
              }
            })
          );
          if (btn?.hasAttribute('data-demo')) on(btn, 'click', () => this.add(btn, null));
          if (form) on(form, 'submit', (e) => (e.preventDefault(), this.add(btn, form)));
        }

        async add(btn, form) {
          if (!btn || btn.dataset.state) return;
          btn.dataset.state = 'loading';
          const done = () => {
            btn.dataset.state = 'added';
            clearTimeout(this.st);
            this.st = setTimeout(() => delete btn.dataset.state, 2400);
          };
          if (!form) return setTimeout(done, 700); // demo hero without a product
          const root = window.Shopify?.routes?.root || '/';
          const id = +form.querySelector('[name="id"]').value;
          try {
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            done();
            const cart = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: id, quantity: 1 }],
              promise: cart.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart?.(root);
          } catch (err) {
            delete btn.dataset.state;
            if (err && err.description) this.flash(btn, err.description);
            else form.submit();
          }
        }

        flash(btn, text) {
          const bar = btn.closest('.werk-stack-to-bento_buy');
          const el = document.createElement('p');
          el.className = 'werk-stack-to-bento_flash';
          el.setAttribute('role', 'status');
          el.textContent = text;
          bar.querySelector('.werk-stack-to-bento_flash')?.remove();
          bar.append(el);
          setTimeout(() => el.remove(), 3200);
        }

        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-store-locator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('werk-store-locator')) {
    // ---------- werk's own map: Natural Earth tiles from the demo store's Files (scripts/store-locator-map.mjs) ----------
    // Tile levels: 0 (one world tile, 1:110m), 2 (4 × 4, 1:50m), 5 (32 × 32 land tiles, 1:10m). Coordinates inside a
    // tile run 0…4096, every ring / line is delta-encoded. L5 says which level-5 tiles exist (bit = x * 32 + y).
    const EXT = 4096;
    const TILE = 256;
    const MAX_OWN = 11.5;
    const L5 = atob('wCcXwMDnB/jAxwf8gAMH/OAfBP7wfwD++P8E/vz/Af/+/wn+/v9///7f///+j8/4/gNn+P7RQ/z+8Qn+RP8K/xj/If/4/w//+P8P/4j/F//s/5f//H+D//j/Of/8/4D//P+D//j/gf/g/4//wP+P/+D/n//wrx//wMe3/8DHO8o=');
    const has5 = (x, y) => {
      const t = x * 32 + y;
      return (L5.charCodeAt(t >> 3) >> (t & 7)) & 1;
    };
    const MAPBOX = 'https://api.mapbox.com/mapbox-gl-js/v3.9.4/mapbox-gl';
    const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
    const mx = (lng) => (lng + 180) / 360;
    const my = (lat) => {
      const s = Math.sin((clamp(lat, -85.0511, 85.0511) * Math.PI) / 180);
      return 0.5 - Math.log((1 + s) / (1 - s)) / (4 * Math.PI);
    };
    const lngOf = (x) => x * 360 - 180;
    const latOf = (y) => (Math.atan(Math.sinh(Math.PI * (1 - 2 * y))) * 180) / Math.PI;
    // cubic-bezier as a function (Newton steps, bisection fallback) – fly-tos follow the section's easing
    const bezier = (x1, y1, x2, y2) => {
      const f = (t, a, b) => ((1 - 3 * b + 3 * a) * t + (3 * b - 6 * a)) * t * t + 3 * a * t;
      const d = (t, a, b) => 3 * (1 - 3 * b + 3 * a) * t * t + 2 * (3 * b - 6 * a) * t + 3 * a;
      return (x) => {
        if (x <= 0 || x >= 1) return x <= 0 ? 0 : 1;
        let t = x;
        for (let i = 0; i < 6; i++) {
          const sl = d(t, x1, x2);
          if (Math.abs(sl) < 1e-6) break;
          t -= (f(t, x1, x2) - x) / sl;
        }
        if (t < 0 || t > 1 || Math.abs(f(t, x1, x2) - x) > 1e-4) {
          let lo = 0, hi = 1;
          for (let i = 0; i < 24; i++) {
            t = (lo + hi) / 2;
            f(t, x1, x2) < x ? (lo = t) : (hi = t);
          }
        }
        return f(t, y1, y2);
      };
    };
    const curveOf = (css) => {
      const m = /cubic-bezier\(([^)]+)\)/.exec(css || '');
      const v = m ? m[1].split(',').map(Number) : [];
      return v.length === 4 && v.every((n) => !isNaN(n)) ? bezier(...v) : bezier(0.6234, 0.058, 0, 0.9095);
    };

    // one cache for every map on the page – tiles are the same everywhere
    const TILES = new Map();
    const tile = (cdn, z, x, y, done) => {
      const key = z + '-' + x + '-' + y;
      let t = TILES.get(key);
      if (!t) {
        t = { d: null, cb: [] };
        TILES.set(key, t);
        fetch(cdn + 'werk-store-locator-map-' + key + '.json')
          .then((r) => (r.ok ? r.json() : null))
          .then((j) => {
            t.d = j ? decode(j) : { empty: true };
            t.cb.splice(0).forEach((f) => f());
          })
          .catch(() => {
            TILES.delete(key);
          });
      }
      if (!t.d && done) t.cb.push(done);
      return t.d;
    };
    const decode = (j) => {
      const out = { p: j.p || [] };
      const ring = (path, a, close) => {
        let x = 0, y = 0;
        for (let i = 0; i < a.length; i += 2) {
          x += a[i];
          y += a[i + 1];
          i ? path.lineTo(x, y) : path.moveTo(x, y);
        }
        if (close) path.closePath();
      };
      for (const [k, items] of Object.entries(j.l || {})) {
        const p = new Path2D();
        const area = k === 'land' || k === 'lake' || k === 'urban';
        for (const it of items) {
          if (area) it.forEach((r) => ring(p, r, true));
          else ring(p, it, false);
        }
        out[k] = p;
      }
      return out;
    };

    // ---------- the canvas map ----------
    class Atlas {
      constructor(host) {
        this.h = host;
        this.box = host.mapBox;
        this.cv = host.querySelector('.werk-store-locator_canvas');
        this.ctx = this.cv.getContext('2d');
        this.cx = 0.53;
        this.cy = 0.33;
        this.z = 4;
        this.w = this.hh = 0;
        this.raf = 0;
        this.min = 1.2;
        this.max = MAX_OWN;
      }
      get zoom() {
        return this.z;
      }
      scale(z = this.z) {
        return TILE * 2 ** z;
      }
      resize() {
        const r = this.box.getBoundingClientRect();
        this.w = r.width;
        this.hh = r.height;
        this.dpr = Math.min(devicePixelRatio || 1, 2);
        this.cv.width = Math.round(this.w * this.dpr);
        this.cv.height = Math.round(this.hh * this.dpr);
        // never smaller than the box: the world fills the map at the lowest zoom
        this.min = Math.max(1.2, Math.log2(Math.max(this.w, this.hh) / TILE));
        this.set(this.cx, this.cy, this.z);
      }
      project(lng, lat) {
        const s = this.scale();
        return [(mx(lng) - this.cx) * s + this.w / 2, (my(lat) - this.cy) * s + this.hh / 2];
      }
      set(cx, cy, z) {
        this.z = clamp(z, this.min, this.max);
        const s = this.scale();
        // keep the world on screen (no wrap): half a screen of slack at the edges
        const hx = this.w / 2 / s, hy = this.hh / 2 / s;
        this.cx = hx >= 0.5 ? 0.5 : clamp(cx, hx, 1 - hx);
        this.cy = hy >= 0.5 ? 0.5 : clamp(cy, hy, 1 - hy);
        this.draw();
        this.h.moved();
      }
      draw() {
        if (!this.raf) this.raf = requestAnimationFrame(() => ((this.raf = 0), this.render()));
      }
      stop() {
        cancelAnimationFrame(this.anim);
        this.anim = 0;
      }
      // fly: centre glides, the zoom dips on long ways so the start and the goal stay in sight;
      // off = where the point lands, in px from the middle of the map
      fly(lng, lat, z, off = [0, 0], instant) {
        this.stop();
        z = clamp(z, this.min, this.max);
        const s1 = this.scale(z);
        const x1 = mx(lng) - off[0] / s1, y1 = my(lat) - off[1] / s1;
        const x0 = this.cx, y0 = this.cy, z0 = this.z;
        const dur = this.h.speed * 1100;
        if (instant || !dur || !this.w) return this.set(x1, y1, z);
        const dist = Math.hypot(x1 - x0, y1 - y0) * this.scale(Math.min(z0, z));
        const dip = clamp(Math.log2(dist / (0.7 * Math.min(this.w, this.hh) || 1)), 0, 4);
        const ease = this.h.curve;
        const t0 = performance.now();
        const step = (now) => {
          const t = clamp((now - t0) / dur, 0, 1);
          const e = ease(t);
          this.set(x0 + (x1 - x0) * e, y0 + (y1 - y0) * e, z0 + (z - z0) * e - dip * 4 * e * (1 - e));
          this.anim = t < 1 ? requestAnimationFrame(step) : 0;
        };
        this.anim = requestAnimationFrame(step);
      }
      fit(pts, pad, maxZ, instant) {
        if (!pts.length) return;
        if (!this.w) this.resize();
        const xs = pts.map((p) => mx(p[0])), ys = pts.map((p) => my(p[1]));
        const x0 = Math.min(...xs), x1 = Math.max(...xs), y0 = Math.min(...ys), y1 = Math.max(...ys);
        const aw = Math.max(40, this.w - pad[1] - pad[3]), ah = Math.max(40, this.hh - pad[0] - pad[2]);
        let z = Math.min(Math.log2(aw / (Math.max(x1 - x0, 1e-9) * TILE)), Math.log2(ah / (Math.max(y1 - y0, 1e-9) * TILE)));
        z = clamp(Math.min(z, maxZ), this.min, this.max);
        // the middle of the free area (between the paddings) shows the middle of the points
        const off = [(pad[3] - pad[1]) / 2, (pad[0] - pad[2]) / 2];
        this.fly(lngOf((x0 + x1) / 2), latOf((y0 + y1) / 2), z, off, instant);
      }
      zoomAt(px, py, dz, animate) {
        this.stop();
        const s0 = this.scale();
        const wx = this.cx + (px - this.w / 2) / s0, wy = this.cy + (py - this.hh / 2) / s0;
        const z0 = this.z, z1 = clamp(this.z + dz, this.min, this.max);
        const go = (z) => {
          const s = this.scale(z);
          this.set(wx - (px - this.w / 2) / s, wy - (py - this.hh / 2) / s, z);
        };
        if (!animate || !this.h.speed) return go(z1);
        const t0 = performance.now(), dur = 380 * this.h.speed, ease = this.h.curve;
        const step = (now) => {
          const t = clamp((now - t0) / dur, 0, 1);
          go(z0 + (z1 - z0) * ease(t));
          this.anim = t < 1 ? requestAnimationFrame(step) : 0;
        };
        this.anim = requestAnimationFrame(step);
      }
      zoomBy(d) {
        this.zoomAt(this.w / 2, this.hh / 2, d, true);
      }
      pan(dx, dy) {
        const s = this.scale();
        this.set(this.cx - dx / s, this.cy - dy / s, this.z);
      }
      render() {
        const { ctx, w, hh: h, dpr } = this;
        if (!w || !h || !this.h.isConnected) return;
        const c = this.h.colors;
        const cdn = this.h.d.cdn;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.fillStyle = c.water;
        ctx.fillRect(0, 0, w, h);
        const L = this.z < 2.5 ? 0 : this.z < 5.5 ? 2 : 5;
        const N = 2 ** L;
        const s = this.scale();
        const ts = s / N;
        const tx0 = clamp(Math.floor((this.cx * s - w / 2) / ts), 0, N - 1), tx1 = clamp(Math.floor((this.cx * s + w / 2) / ts), 0, N - 1);
        const ty0 = clamp(Math.floor((this.cy * s - h / 2) / ts), 0, N - 1), ty1 = clamp(Math.floor((this.cy * s + h / 2) / ts), 0, N - 1);
        const places = [];
        const redraw = () => this.draw();
        for (let x = tx0; x <= tx1; x++) {
          for (let y = ty0; y <= ty1; y++) {
            if (L === 5 && !has5(x, y)) {
              // open sea at this level: the coarser tile still knows the small islands
              const d2 = tile(cdn, 2, x >> 3, y >> 3, redraw);
              if (d2 && !d2.empty) this.paint(d2, 2, x >> 3, y >> 3, [x, y, L], null);
              continue;
            }
            const d = tile(cdn, L, x, y, redraw);
            if (d && !d.empty) {
              this.paint(d, L, x, y, null, places);
              continue;
            }
            // still loading: the next coarser level that is there stands in, clipped to this tile
            for (const P of [2, 0]) {
              if (P >= L) continue;
              const k = L - P;
              const dp = tile(cdn, P, x >> k, y >> k, P === 0 ? redraw : null);
              if (dp && !dp.empty) {
                this.paint(dp, P, x >> k, y >> k, [x, y, L], null);
                break;
              }
            }
          }
        }
        if (this.h.d.places) this.labels(places);
      }
      paint(d, z, x, y, clip, places) {
        const { ctx, dpr, w, hh: h } = this;
        const c = this.h.colors;
        const s = this.scale();
        const k = s / 2 ** z / EXT;
        const ox = (x / 2 ** z - this.cx) * s + w / 2, oy = (y / 2 ** z - this.cy) * s + h / 2;
        ctx.save();
        if (clip) {
          const cs = s / 2 ** clip[2];
          ctx.beginPath();
          ctx.rect((clip[0] / 2 ** clip[2] - this.cx) * s + w / 2, (clip[1] / 2 ** clip[2] - this.cy) * s + h / 2, cs, cs);
          ctx.clip();
        }
        ctx.setTransform(dpr * k, 0, 0, dpr * k, dpr * ox, dpr * oy);
        if (d.land) {
          ctx.fillStyle = c.land;
          ctx.fill(d.land, 'evenodd');
        }
        if (d.urban && this.z >= 6) {
          ctx.fillStyle = c.urban;
          ctx.fill(d.urban, 'evenodd');
        }
        ctx.lineJoin = ctx.lineCap = 'round';
        // rivers only once the map is close enough to need them (city level), else the overview gets busy
        if (d.river && this.z >= 6.5) {
          ctx.strokeStyle = c.water;
          ctx.lineWidth = (this.z >= 8.5 ? 2.2 : 1.4) / k;
          ctx.stroke(d.river);
        }
        if (d.lake) {
          ctx.fillStyle = c.water;
          ctx.fill(d.lake, 'evenodd');
        }
        if (d.border) {
          ctx.strokeStyle = c.line;
          ctx.lineWidth = 0.9 / k;
          ctx.stroke(d.border);
        }
        ctx.restore();
        if (places) for (const p of d.p) places.push([ox + p[0] * k, oy + p[1] * k, p[2], p[3]]);
      }
      // city names: only the bigger towns for the zoom, never on a pin or on each other
      labels(places) {
        const { ctx, dpr, w, hh: h } = this;
        if (this.z < 4) return;
        const max = this.z - 2.2;
        const u = this.h.u;
        const size = Math.max(9, 11 * u);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.font = `500 ${size}px ${this.h.monoFont}`;
        if ('letterSpacing' in ctx) ctx.letterSpacing = size * 0.08 + 'px';
        ctx.fillStyle = this.h.colors.label;
        ctx.textBaseline = 'middle';
        const taken = this.h.pinRects();
        places.sort((a, b) => a[2] - b[2]);
        for (const [x, y, rank, name] of places) {
          if (rank > max || x < -50 || y < -20 || x > w + 50 || y > h + 20) continue;
          const text = name.toUpperCase();
          const tw = ctx.measureText(text).width;
          const r = [x + 6, y - size * 0.7, x + 10 + tw, y + size * 0.7];
          if (taken.some((t) => r[0] < t[2] && r[2] > t[0] && r[1] < t[3] && r[3] > t[1])) continue;
          taken.push([r[0] - 8, r[1] - 4, r[2] + 8, r[3] + 4]);
          ctx.fillText(text, x + 8, y);
        }
      }
    }

    // ---------- Mapbox (only with a token): the same few calls on mapbox-gl ----------
    let mapboxLoad = null;
    const loadMapbox = () =>
      (mapboxLoad ||= new Promise((ok, no) => {
        if (window.mapboxgl) return ok(window.mapboxgl);
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = MAPBOX + '.css';
        document.head.append(css);
        const js = document.createElement('script');
        js.src = MAPBOX + '.js';
        js.onload = () => (window.mapboxgl ? ok(window.mapboxgl) : no());
        js.onerror = no;
        document.head.append(js);
      }));
    class Mapbox {
      constructor(host, gl) {
        this.h = host;
        const el = document.createElement('div');
        el.className = 'werk-store-locator_mapbox';
        host.mapBox.prepend(el);
        const night = host.classList.contains('werk-store-locator--night');
        gl.accessToken = host.d.mapbox.token;
        this.m = new gl.Map({
          container: el,
          style: host.d.mapbox.style || (night ? 'mapbox://styles/mapbox/dark-v11' : 'mapbox://styles/mapbox/light-v11'),
          center: [10, 50],
          zoom: 3,
          attributionControl: false,
          cooperativeGestures: true,
          locale: Object.fromEntries(Object.entries(host.t.mb || {}).filter((x) => x[1])),
          dragRotate: false,
          pitchWithRotate: false,
          touchPitch: false,
        });
        this.m.addControl(new gl.AttributionControl({ compact: true }), 'bottom-left');
        this.m.on('move', () => host.moved());
        this.m.on('click', (e) => host.mapClick(e.originalEvent));
        // a wrong or blocked token (401 / 403 – e.g. a URL restriction without this domain) leaves Mapbox blank:
        // then the werk map takes over
        this.m.on('error', (e) => {
          const st = e?.error?.status;
          if (st === 401 || st === 403) host.noMapbox();
        });
        this.max = 18;
      }
      get zoom() {
        return this.m.getZoom();
      }
      resize() {
        this.m.resize();
      }
      project(lng, lat) {
        const p = this.m.project([lng, lat]);
        return [p.x, p.y];
      }
      fly(lng, lat, z, off = [0, 0], instant) {
        const o = { center: [lng, lat], zoom: z, offset: off, essential: false, duration: instant ? 0 : 1100 * this.h.speed };
        instant ? this.m.jumpTo(o) : this.m.flyTo(o);
      }
      fit(pts, pad, maxZ, instant) {
        if (!pts.length) return;
        const lng = pts.map((p) => p[0]), lat = pts.map((p) => p[1]);
        this.m.fitBounds(
          [
            [Math.min(...lng), Math.min(...lat)],
            [Math.max(...lng), Math.max(...lat)],
          ],
          { padding: { top: pad[0], right: pad[1], bottom: pad[2], left: pad[3] }, maxZoom: maxZ, duration: instant ? 0 : 900 * this.h.speed }
        );
      }
      zoomBy(d) {
        this.m.easeTo({ zoom: this.m.getZoom() + d, duration: 380 * this.h.speed });
      }
      stop() {
        this.m.stop();
      }
    }

    // ---------- places: a Google Maps link, “lat, lng” or 52°29′43.8″N 13°25′26.4″E ----------
    const parseLoc = (raw) => {
      if (!raw) return null;
      let s = raw.trim();
      try {
        s = decodeURIComponent(s);
      } catch {}
      const n = '(-?\\d{1,3}(?:\\.\\d+)?)';
      const tries = [new RegExp('!3d' + n + '!4d' + n), new RegExp('@' + n + ',' + n), new RegExp('[?&](?:q|query|ll|sll|destination|daddr|center)=' + n + '\\s*,\\s*' + n), new RegExp('^\\s*' + n + '\\s*[,;\\s]\\s*' + n + '\\s*$')];
      for (const re of tries) {
        const m = re.exec(s);
        if (m) {
          const lat = +m[1], lng = +m[2];
          if (Math.abs(lat) <= 90 && Math.abs(lng) <= 180) return [lng, lat];
        }
      }
      const dms = /(\d+)°\s*(\d+)['′]\s*([\d.]+)["″]?\s*([NS])[\s,]+(\d+)°\s*(\d+)['′]\s*([\d.]+)["″]?\s*([EW])/i.exec(s);
      if (dms) {
        const v = (d, m, x, h) => (+d + m / 60 + x / 3600) * (/[SW]/i.test(h) ? -1 : 1);
        return [v(dms[5], dms[6], dms[7], dms[8]), v(dms[1], dms[2], dms[3], dms[4])];
      }
      return null;
    };

    // ---------- opening hours: “Mon–Fri 7:30–18:00”, “Sat 9–17”, “Sun closed”, “Daily 8am–6pm” ----------
    const DAYS_EN = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    const DAYS_DE = ['mo', 'di', 'mi', 'do', 'fr', 'sa', 'so'];
    const FULL = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday', 'montag', 'dienstag', 'mittwoch', 'donnerstag', 'freitag', 'samstag', 'sonntag'];
    const norm = (t) => (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    const dayIndex = (tok, own) => {
      const t = norm(tok).replace(/[^a-z]/g, '');
      if (!t) return -1;
      const o = own.findIndex((d) => d && (t === d || t.slice(0, d.length) === d));
      if (o >= 0) return o;
      const f = FULL.indexOf(t);
      if (f >= 0) return f % 7;
      const e = DAYS_EN.findIndex((d) => t.startsWith(d));
      if (e >= 0) return e;
      return DAYS_DE.indexOf(t.slice(0, 2));
    };
    const parseDays = (label, own) => {
      const t = norm(label);
      if (/daily|every ?day|taglich|all week/.test(t)) return [0, 1, 2, 3, 4, 5, 6];
      if (/weekdays|werktags/.test(t)) return [0, 1, 2, 3, 4];
      if (/weekends?|wochenende/.test(t)) return [5, 6];
      const out = [];
      for (const part of label.split(/[,&/+]|\band\b|\bund\b/i)) {
        const r = part.split(/\s*[-–—]\s*|\s+(?:to|bis)\s+/i).filter((x) => x.trim());
        const a = dayIndex(r[0], own);
        if (a < 0) continue;
        const b = r[1] ? dayIndex(r[1], own) : a;
        if (b < 0) {
          out.push(a);
          continue;
        }
        for (let i = a, g = 0; g < 7; i = (i + 1) % 7, g++) {
          out.push(i);
          if (i === b) break;
        }
      }
      return out;
    };
    const parseHours = (text, own) => {
      const week = [[], [], [], [], [], [], []];
      const rows = [];
      let any = false;
      for (const raw of (text || '').split(/\n/)) {
        const line = raw.trim();
        if (!line) continue;
        const m = /^(.*?)\s*[:]?\s+((?:\d|closed|geschlossen|ruhetag|zu\b|open 24|24).*)$/i.exec(line);
        if (!m) {
          rows.push({ label: line, value: '', days: [] });
          continue;
        }
        let days = parseDays(m[1], own);
        // “Open 24/7”, “Open 8–20”, “8–20”: no day named – every day
        if (!days.length && (!m[1].trim() || /^(open|geoffnet|ge\u00f6ffnet)$/i.test(m[1].trim()))) days = [0, 1, 2, 3, 4, 5, 6];
        const spans = [];
        if (!/closed|geschlossen|ruhetag|^zu\b/i.test(m[2])) {
          if (/open 24|24\s*h|24\/7/i.test(m[2])) spans.push([0, 1440]);
          const re = /(\d{1,2})(?:[:.](\d{2}))?\s*(a\.?m\.?|p\.?m\.?)?\s*(?:[-–—]|to|bis)\s*(\d{1,2})(?:[:.](\d{2}))?\s*(a\.?m\.?|p\.?m\.?)?/gi;
          let t;
          while ((t = re.exec(m[2]))) {
            const mins = (h, mm, ap) => {
              h = +h;
              if (ap && /p/i.test(ap) && h < 12) h += 12;
              if (ap && /a/i.test(ap) && h === 12) h = 0;
              return h * 60 + (+mm || 0);
            };
            const o = mins(t[1], t[2], t[3] || t[6]);
            let c = mins(t[4], t[5], t[6]);
            if (c <= o) c += 1440; // past midnight
            spans.push([o, c]);
          }
        }
        days.forEach((d) => week[d].push(...spans));
        if (days.length) any = true;
        rows.push({ label: m[1], value: m[2], days });
      }
      return { week, rows, ok: any };
    };

    customElements.define(
      'werk-store-locator',
      class extends HTMLElement {
        connectedCallback() {
          this.mapBox = this.querySelector('.werk-store-locator_map');
          this.side = this.querySelector('.werk-store-locator_side');
          this.list = this.querySelector('.werk-store-locator_list');
          if (!this.mapBox || !this.list) return;
          try {
            this.d = JSON.parse(this.querySelector('[data-werk]').textContent);
            this.t = JSON.parse(this.querySelector('[data-werk-t]').textContent);
          } catch {
            return;
          }
          this.night = this.classList.contains('werk-store-locator--night');
          this.main = this.querySelector('.werk-store-locator_main');
          this.pinsEl = this.querySelector('.werk-store-locator_pins');
          this.pop = this.querySelector('.werk-store-locator_pop');
          this.dialog = this.querySelector('.werk-store-locator_dialog');
          this.msg = this.querySelector('.werk-store-locator_msg');
          this.input = this.querySelector('.werk-store-locator_input');
          this.detail = this.querySelector('.werk-store-locator_detail');
          this.sheetCard = this.querySelector('.werk-store-locator_sheetcard');
          this.own = (this.d.days || '').split(',').map((x) => norm(x).replace(/[^a-z]/g, ''));
          this.fine = matchMedia('(hover: hover) and (pointer: fine)');
          this.still = matchMedia('(prefers-reduced-motion: reduce)');
          this.active = -1;
          this.type = '';
          this.query = '';
          this.me = null;
          if (this.classList.contains('is-theme-colors')) this.themeColors();
          this.readStyle();

          const apple = /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent);
          this.items = [...this.list.querySelectorAll('.werk-store-locator_item')].map((el) => {
            const loc = parseLoc(el.dataset.loc);
            const hoursEl = el.querySelector('.werk-store-locator_hours');
            const it = {
              el,
              i: +el.dataset.i,
              loc,
              type: el.dataset.type || '',
              kind: el.dataset.pin === 'outline' ? 'outline' : 'dot',
              tz: el.dataset.tz || '',
              name: el.querySelector('.werk-store-locator_select')?.textContent.trim() || '',
              text: norm(el.textContent),
              status: el.querySelector('.werk-store-locator_status'),
              dist: el.querySelector('.werk-store-locator_dist'),
              hours: parseHours(hoursEl?.dataset.hours || '', this.own),
              hoursEl,
              visible: true,
            };
            // directions: Apple Maps on Apple devices (auto), else Google Maps – to the exact spot when we have it
            const dir = el.querySelector('[data-dir]');
            if (dir) {
              const useApple = this.d.dir === 'apple' || (this.d.dir === 'auto' && apple);
              const addr = el.querySelector('.werk-store-locator_address')?.textContent.trim() || it.name;
              const to = loc ? loc[1] + ',' + loc[0] : encodeURIComponent(addr);
              dir.href = useApple ? 'https://maps.apple.com/?daddr=' + to + (loc ? '&q=' + encodeURIComponent(it.name) : '') : 'https://www.google.com/maps/dir/?api=1&destination=' + to;
            }
            if (!loc) el.querySelector('.werk-store-locator_warn')?.removeAttribute('hidden');
            this.hoursRows(it);
            return it;
          });

          const ac = (this.ac = new AbortController());
          const on = (el, type, fn, o) => el?.addEventListener(type, fn, { signal: ac.signal, ...o });
          // cards: a click anywhere on the card picks the store (links and buttons inside keep their own job)
          on(this.list, 'click', (e) => {
            const li = e.target.closest('.werk-store-locator_item');
            if (!li || (e.target.closest('a, input') && !e.target.closest('.werk-store-locator_select'))) return;
            const it = this.items[+li.dataset.i];
            if (it.i === this.active && !this.night && e.target.closest('.werk-store-locator_select')) return this.select(-1);
            this.select(it.i, 'list');
          });
          on(this.input, 'input', () => {
            clearTimeout(this.qt);
            this.qt = setTimeout(() => ((this.query = norm(this.input.value).trim()), this.apply(true)), 140);
          });
          on(this.input, 'focus', () => this.night && this.sheetMode() && this.snap('full'));
          on(this.input, 'keydown', (e) => e.key === 'Enter' && (e.preventDefault(), this.input.blur()));
          this.querySelectorAll('.werk-store-locator_chip').forEach((b) =>
            on(b, 'click', () => {
              this.type = b.dataset.type;
              this.querySelectorAll('.werk-store-locator_chip').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
              this.apply(true);
            })
          );
          this.querySelectorAll('.werk-store-locator_near').forEach((b) => on(b, 'click', () => this.near()));
          this.querySelectorAll('.werk-store-locator_zoom-btn').forEach((b) => on(b, 'click', () => this.map?.zoomBy(+b.dataset.zoom)));
          on(this.querySelector('.werk-store-locator_mapbtn'), 'click', () => this.openMap());
          on(this.querySelector('.werk-store-locator_close'), 'click', () => this.dialog.close());
          on(this.dialog, 'close', () => this.closeMap());
          on(this.querySelector('.werk-store-locator_back'), 'click', () => this.select(-1));
          on(this, 'keydown', (e) => {
            if (e.key !== 'Escape' || this.dialog.open || this.active < 0) return;
            this.select(-1);
          });
          // theme editor: picking a block shows its store
          on(this, 'shopify:block:select', (e) => {
            const li = e.target.closest?.('.werk-store-locator_item');
            if (li) this.select(+li.dataset.i, 'editor');
          });
          this.mapEvents(on);
          this.sheetEvents(on);

          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.rr);
            this.rr = requestAnimationFrame(() => this.layout());
          });
          this.ro.observe(this);
          this.ro.observe(this.mapBox);
          // fixed bars at the bottom of the screen (a docked nav, a cookie or chat bar): the Map pill and the sheet keep clear
          on(document, 'scroll', () => this.below(), { capture: true, passive: true });
          on(window, 'resize', () => this.below(), { passive: true });
          this.below();
          this.tick();
          this.timer = setInterval(() => !document.hidden && this.tick(), 30000);
          document.fonts?.ready.then(() => this.isConnected && (this.readStyle(), this.map?.draw?.()));
          this.boot();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.ro?.disconnect();
          clearInterval(this.timer);
          clearTimeout(this.qt);
          clearTimeout(this.ft);
          clearTimeout(this.bt);
          cancelAnimationFrame(this.rr);
          cancelAnimationFrame(this.pr);
          cancelAnimationFrame(this.ir);
          this.map?.stop?.();
          if (this.map instanceof Mapbox) this.map.m.remove();
          if (this.dialog?.open) this.dialog.close();
        }

        get speed() {
          return this.dataset.motion === 'off' || this.still.matches ? 0 : 1;
        }
        get u() {
          return parseFloat(getComputedStyle(this.querySelector('.werk-store-locator_inner')).getPropertyValue('--werk-u')) || 1;
        }
        get wide() {
          return this.clientWidth >= 990;
        }
        get phone() {
          return this.clientWidth < 750;
        }
        sheetMode() {
          return this.night && !this.wide;
        }

        async boot() {
          if (this.d.mapbox) {
            try {
              this.map = new Mapbox(this, await loadMapbox());
            } catch {
              this.dataset.map = 'werk';
            }
          }
          if (!this.map) this.map = new Atlas(this);
          this.pins();
          this.layout(true);
          this.view(true);
        }

        noMapbox() {
          const m = this.map?.m;
          if (!m) return;
          this.map = null;
          try {
            m.remove();
          } catch {}
          this.querySelector('.werk-store-locator_mapbox')?.remove();
          this.dataset.map = 'werk';
          this.map = new Atlas(this);
          this.layout(true);
          this.view(true);
        }

        // colours of the canvas map, read through probes so color-mix() and theme colours just work
        readStyle() {
          const inner = this.querySelector('.werk-store-locator_inner');
          const probe = document.createElement('i');
          probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none';
          inner.append(probe);
          this.colors = {};
          for (const k of ['water', 'land', 'line', 'urban', 'label']) {
            probe.style.color = `var(--map-${k})`;
            this.colors[k] = getComputedStyle(probe).color;
          }
          probe.style.fontFamily = 'var(--werk-mono)';
          this.monoFont = getComputedStyle(probe).fontFamily;
          probe.remove();
          this.curve = curveOf(getComputedStyle(inner).getPropertyValue('--werk-ease'));
        }

        below() {
          if (this.wide || this.bt) return;
          this.bt = setTimeout(() => {
            this.bt = 0;
            if (!this.isConnected) return;
            let top = innerHeight;
            for (const x of [innerWidth / 2, innerWidth * 0.2, innerWidth * 0.8])
              for (const y of [innerHeight - 4, innerHeight - 32, innerHeight - 64])
                for (const hit of document.elementsFromPoint(x, y)) {
                  if (this.contains(hit) || hit === document.documentElement || hit === document.body) continue;
                  for (let el = hit; el && el !== document.body; el = el.parentElement) {
                    if (getComputedStyle(el).position !== 'fixed') continue;
                    const r = el.getBoundingClientRect();
                    if (r.bottom >= innerHeight - 80 && r.height < innerHeight * 0.3 && r.top > innerHeight * 0.5) top = Math.min(top, r.top);
                    break;
                  }
                }
            const v = Math.max(0, Math.round(innerHeight - top)) + 'px';
            if (this.style.getPropertyValue('--werk-below') === v) return;
            this.style.setProperty('--werk-below', v);
            // the sheet's resting height grows with the bar
            if (this.sheetMode() && this.sheet === 'peek') this.snap('peek');
          }, 120);
        }

        // ---------- layout: map size, sheet, paddings ----------
        layout(first) {
          if (!this.map) return;
          const wasWide = this.wasWide;
          this.wasWide = this.wide;
          this.map.resize();
          if (this.sheetMode()) this.snap(this.sheet || 'peek', true);
          else this.side.style.removeProperty('--sy');
          if (!first && wasWide !== this.wide) this.view(true);
          this.moved();
        }
        // the free part of the map, as paddings [top, right, bottom, left] – panels and sheets cover the rest
        pad() {
          const u = this.u;
          // room for the pins' names and the zoom buttons
          const p = [72 * u, 96 * u, 72 * u, 72 * u];
          if (this.night && this.wide) {
            const r = this.side.getBoundingClientRect(), m = this.mapBox.getBoundingClientRect();
            p[3] = r.right - m.left + 48 * u;
          } else if (this.sheetMode()) {
            p[2] = this.mapBox.getBoundingClientRect().bottom - this.side.getBoundingClientRect().top + 32 * u;
            p[0] = 72 * u;
          } else if (this.dialog?.open) {
            p[0] = 96 * u;
            if (!this.sheetCard.hidden) p[2] = this.sheetCard.offsetHeight + 40 * u;
          }
          return p;
        }
        shown() {
          return this.items.filter((it) => it.visible && it.loc);
        }
        // fit every store that is shown (or: you + the nearest three)
        view(instant) {
          if (!this.map) return;
          let pts = this.shown().map((it) => it.loc);
          if (this.me) pts = [this.me, ...this.shown().sort((a, b) => a.km - b.km).slice(0, 3).map((it) => it.loc)];
          if (!pts.length) return;
          this.map.fit(pts, this.pad(), Math.min(this.d.zoom, this.map.max), instant);
        }

        // ---------- pins ----------
        pins() {
          this.pinsEl.textContent = '';
          for (const it of this.items) {
            if (!it.loc) continue;
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'werk-store-locator_pin' + (this.speed ? ' is-new' : '');
            b.dataset.kind = it.kind;
            b.setAttribute('aria-label', this.fill(this.t.show, { store: it.name }));
            b.innerHTML = '<span class="werk-store-locator_pin-ring"></span><span class="werk-store-locator_pin-target"></span><span class="werk-store-locator_pin-dot"></span><span class="werk-store-locator_pin-label"></span>';
            b.querySelector('.werk-store-locator_pin-label').textContent = it.name;
            b.addEventListener('click', (e) => (e.stopPropagation(), this.select(it.i, 'pin')), { signal: this.ac.signal });
            this.pinsEl.append(b);
            it.pin = b;
          }
          if (this.speed) {
            // pins drop in one after another
            const list = this.items.filter((it) => it.pin);
            list.forEach((it, k) => setTimeout(() => it.pin?.classList.remove('is-new'), 200 + Math.min(k, 10) * 60));
          }
          this.groups = [];
        }
        // touching pins become one with a count; the chosen store always keeps its own pin
        cluster() {
          this.groups.forEach((g) => g.el.remove());
          this.groups = [];
          const r = 30 * this.u;
          this.items.forEach((it) => (it.g = null));
          const list = this.shown().filter((it) => it.i !== this.active);
          list.forEach((it) => ((it.p = this.map.project(...it.loc)), (it.g = null)));
          for (const a of list) {
            if (a.g) continue;
            const members = list.filter((b) => !b.g && Math.hypot(b.p[0] - a.p[0], b.p[1] - a.p[1]) < r);
            if (members.length < 2) continue;
            const g = { members, el: document.createElement('button') };
            members.forEach((m) => (m.g = g));
            g.el.type = 'button';
            g.el.className = 'werk-store-locator_pin';
            g.el.dataset.kind = 'group';
            g.el.setAttribute('aria-label', this.fill(this.t.group, { count: members.length }));
            g.el.innerHTML = '<span class="werk-store-locator_pin-target"></span><span class="werk-store-locator_pin-dot"></span>';
            g.el.querySelector('.werk-store-locator_pin-dot').textContent = members.length;
            g.el.addEventListener(
              'click',
              (e) => {
                e.stopPropagation();
                // stores on (almost) one spot can't be zoomed apart – the first one opens, the list shows the rest
                if (this.map.zoom >= this.map.max - 0.05) return this.select(members[0].i, 'pin');
                // zoom in until the closest two of them are a pin apart
                let near = Infinity;
                for (const a of members) for (const b of members) if (a !== b) near = Math.min(near, Math.hypot(a.p[0] - b.p[0], a.p[1] - b.p[1]));
                const apart = this.map.zoom + Math.log2((44 * this.u) / Math.max(near, 0.5));
                this.map.fit(
                  members.map((m) => m.loc),
                  this.pad(),
                  Math.min(Math.max(apart, this.map.zoom + 1), this.map.max)
                );
              },
              { signal: this.ac.signal }
            );
            this.pinsEl.append(g.el);
            this.groups.push(g);
          }
          this.cz = this.map.zoom;
        }
        moved() {
          if (!this.pr) this.pr = requestAnimationFrame(() => ((this.pr = 0), this.place()));
        }
        place() {
          if (!this.map || !this.items) return;
          if (this.cz == null || Math.abs(this.map.zoom - this.cz) > 0.02 || this.dirty) {
            this.dirty = false;
            this.cluster();
          }
          for (const it of this.items) {
            if (!it.pin) continue;
            const show = it.visible && !it.g;
            it.pin.hidden = !show;
            if (!show) continue;
            const [x, y] = this.map.project(...it.loc);
            it.p = [x, y];
            it.pin.style.setProperty('--x', x + 'px');
            it.pin.style.setProperty('--y', y + 'px');
          }
          for (const g of this.groups) {
            let x = 0, y = 0;
            for (const m of g.members) {
              const p = this.map.project(...m.loc);
              x += p[0];
              y += p[1];
            }
            g.el.style.setProperty('--x', x / g.members.length + 'px');
            g.el.style.setProperty('--y', y / g.members.length + 'px');
          }
          if (this.meEl && this.me) {
            const [x, y] = this.map.project(...this.me);
            this.meEl.style.setProperty('--x', x + 'px');
            this.meEl.style.setProperty('--y', y + 'px');
          }
          this.placePop();
        }
        // pin boxes keep the city names off the pins
        pinRects() {
          const u = this.u, out = [];
          for (const it of this.items) if (it.pin && !it.pin.hidden && it.p) out.push([it.p[0] - 12 * u, it.p[1] - 12 * u, it.p[0] + 12 * u, it.p[1] + 12 * u]);
          for (const g of this.groups) {
            const x = parseFloat(g.el.style.getPropertyValue('--x')), y = parseFloat(g.el.style.getPropertyValue('--y'));
            out.push([x - 20 * u, y - 20 * u, x + 20 * u, y + 20 * u]);
          }
          const zb = this.querySelector('.werk-store-locator_zoom');
          if (zb && zb.offsetParent) {
            const z = zb.getBoundingClientRect(), m = this.mapBox.getBoundingClientRect();
            out.push([z.left - m.left - 8, z.top - m.top - 8, z.right - m.left + 8, z.bottom - m.top + 8]);
          }
          if (this.active >= 0) {
            const p = this.items[this.active].p;
            if (p) out.push([p[0] - 20 * u, p[1] - 20 * u, p[0] + 200 * u, p[1] + 20 * u]);
          }
          return out;
        }

        // ---------- choosing a store ----------
        select(i, from) {
          const prev = this.active;
          this.active = i;
          for (const it of this.items) {
            const on = it.i === i;
            it.el.classList.toggle('is-open', on);
            it.el.querySelector('.werk-store-locator_select')?.setAttribute('aria-expanded', String(on));
            it.pin?.classList.toggle('is-active', on);
          }
          this.dirty = true;
          if (i < 0) {
            this.pop.hidden = true;
            this.sheetCard.hidden = true;
            if (this.sheetMode() && this.sheet === 'store') {
              this.showView('list');
              this.snap(this.before || 'peek');
            }
            this.moved();
            if (prev >= 0 && from !== 'filter') this.view();
            return;
          }
          const it = this.items[i];
          if (this.sheetMode()) {
            if (this.sheet !== 'store') this.before = this.sheet;
            this.fillClone(this.detail.querySelector('.werk-store-locator_detail-in'), it);
            this.showView('store');
            this.snap('store');
          } else if (this.night && this.wide) {
            // the glass card stands on the pin – a store without a position stays a highlighted row
            if (it.loc) this.fillClone(this.pop, it);
            this.pop.hidden = !it.loc;
          }
          if (this.dialog.open) {
            this.fillClone(this.sheetCard, it);
            this.sheetCard.hidden = false;
          }
          // the list follows a pin (wide screens: inside the list; never scrolls the page)
          if (from === 'pin' || from === 'editor') {
            const list = this.list;
            if (this.wide || from === 'editor') {
              const r = it.el.getBoundingClientRect(), lr = list.getBoundingClientRect();
              // the card grows while it opens – bring its top near the top of the list unless it is there already
              if (list.scrollHeight > list.clientHeight + 2 && (r.top < lr.top || r.top > lr.top + lr.height * 0.3)) {
                list.scrollTo({ top: list.scrollTop + r.top - lr.top - 8 * this.u, behavior: this.speed ? 'smooth' : 'auto' });
              }
            }
          }
          if (it.loc && this.map) {
            const z = Math.min(this.d.zoom, this.map.max);
            let off = [0, 0];
            const p = this.pad();
            // the pin lands in the middle of the free area; with the glass card it sits a bit lower
            off[0] = (p[3] - p[1]) / 2;
            off[1] = (p[0] - p[2]) / 2 + (this.night && this.wide ? 150 * this.u : 0);
            this.map.fly(it.loc[0], it.loc[1], Math.max(z, this.map.zoom), off);
          }
          this.moved();
        }
        fillClone(box, it) {
          const card = it.el.querySelector('.werk-store-locator_card').cloneNode(true);
          card.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
          card.removeAttribute('aria-labelledby');
          card.querySelector('.werk-store-locator_select')?.setAttribute('tabindex', '-1');
          box.textContent = '';
          box.append(card);
        }
        placePop() {
          if (this.pop.hidden || this.active < 0) return;
          const it = this.items[this.active];
          if (!it.p) return;
          const u = this.u;
          const w = this.pop.offsetWidth, h = this.pop.offsetHeight;
          const bw = this.mapBox.clientWidth;
          let x = clamp(it.p[0] - w / 2, 16 * u, bw - w - 16 * u);
          let y = it.p[1] - 34 * u - h;
          const below = y < 16 * u;
          if (below) y = it.p[1] + 34 * u;
          this.pop.classList.toggle('is-below', below);
          this.pop.style.setProperty('--x', x + 'px');
          this.pop.style.setProperty('--y', y + 'px');
        }

        // ---------- search, filters, near me ----------
        apply(fit) {
          const words = this.query.split(/\s+/).filter(Boolean);
          let n = 0;
          for (const it of this.items) {
            it.visible = (!this.type || it.type === this.type) && words.every((w) => it.text.includes(w));
            it.el.hidden = !it.visible;
            if (it.visible) n++;
          }
          if (this.active >= 0 && !this.items[this.active].visible) this.select(-1, 'filter');
          this.say(n ? '' : this.fill(this.t.none, { query: this.input?.value.trim() || '' }));
          this.dirty = true;
          this.moved();
          if (fit && n) {
            clearTimeout(this.ft);
            this.ft = setTimeout(() => this.active < 0 && this.view(), 260);
          }
        }
        say(text) {
          this.msg.textContent = text;
          this.msg.hidden = !text;
        }
        near() {
          const btns = this.querySelectorAll('.werk-store-locator_near');
          if (this.me) {
            this.me = null;
            this.meEl?.remove();
            this.meEl = null;
            btns.forEach((b) => b.setAttribute('aria-pressed', 'false'));
            this.items.forEach((it) => (it.dist.hidden = true));
            this.items.forEach((it) => this.list.append(it.el));
            this.view();
            return;
          }
          if (!navigator.geolocation) return this.say(this.t.denied);
          btns.forEach((b) => b.setAttribute('aria-busy', 'true'));
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              btns.forEach((b) => (b.removeAttribute('aria-busy'), b.setAttribute('aria-pressed', 'true')));
              this.say('');
              this.me = [pos.coords.longitude, pos.coords.latitude];
              this.located();
            },
            () => {
              btns.forEach((b) => b.removeAttribute('aria-busy'));
              this.say(this.t.denied);
            },
            { timeout: 12000, maximumAge: 300000 }
          );
        }
        located() {
          const R = 6371, rad = Math.PI / 180;
          const mi = this.d.units === 'mi';
          const nf = (v) => new Intl.NumberFormat(document.documentElement.lang || undefined, { maximumFractionDigits: v < 10 ? 1 : 0 }).format(v);
          for (const it of this.items) {
            if (!it.loc) {
              it.km = Infinity;
              continue;
            }
            const [a, b] = [this.me[1] * rad, it.loc[1] * rad];
            const h = Math.sin((b - a) / 2) ** 2 + Math.cos(a) * Math.cos(b) * Math.sin(((it.loc[0] - this.me[0]) * rad) / 2) ** 2;
            it.km = 2 * R * Math.asin(Math.sqrt(h));
            const v = mi ? it.km / 1.609344 : it.km;
            it.dist.textContent = [nf(v), mi ? this.t.mi : this.t.km].filter(Boolean).join(' ');
            it.dist.hidden = false;
          }
          [...this.items].sort((a, b) => a.km - b.km).forEach((it) => this.list.append(it.el));
          this.list.scrollTo({ top: 0 });
          if (!this.meEl) {
            this.meEl = document.createElement('span');
            this.meEl.className = 'werk-store-locator_me';
            this.pinsEl.prepend(this.meEl);
          }
          if (this.active >= 0) this.select(-1, 'filter');
          this.view();
          this.moved();
        }

        // ---------- open now ----------
        hoursRows(it) {
          if (!it.hoursEl) return;
          const rows = it.hoursEl.querySelectorAll('.werk-store-locator_hour');
          it.hours.rows.forEach((r, k) => {
            const p = rows[k];
            if (!p) return;
            r.el = p;
            if (!r.value) return;
            p.textContent = '';
            const a = document.createElement('span'), b = document.createElement('span');
            a.textContent = r.label;
            b.textContent = r.value;
            p.append(a, b);
          });
        }
        now(tz) {
          const d = new Date();
          if (tz) {
            try {
              const parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(d);
              const g = (t) => parts.find((p) => p.type === t)?.value;
              return [DAYS_EN.indexOf(g('weekday').toLowerCase().slice(0, 3)), (+g('hour') % 24) * 60 + +g('minute')];
            } catch {}
          }
          const m = /([+-])(\d\d):?(\d\d)/.exec(this.d.tz || '');
          const off = m ? (m[1] === '-' ? -1 : 1) * (+m[2] * 60 + +m[3]) : -d.getTimezoneOffset();
          const t = new Date(d.getTime() + off * 60000);
          return [(t.getUTCDay() + 6) % 7, t.getUTCHours() * 60 + t.getUTCMinutes()];
        }
        clock(mins) {
          const h = Math.floor(mins / 60) % 24, m = mins % 60;
          if (this.d.clock === '12h') {
            const ap = h < 12 ? this.t.am : this.t.pm;
            return (h % 12 || 12) + (m ? ':' + String(m).padStart(2, '0') : '') + (ap ? ' ' + ap : '');
          }
          return h + ':' + String(m).padStart(2, '0');
        }
        tick() {
          const names = (this.d.days || 'Mon,Tue,Wed,Thu,Fri,Sat,Sun').split(',').map((x) => x.trim());
          for (const it of this.items) {
            const H = it.hours;
            if (!H.ok) continue;
            const [day, m] = this.now(it.tz);
            H.rows.forEach((r) => r.el?.classList.toggle('is-today', r.days.includes(day)));
            if (!this.d.status) continue;
            let state = 'closed', text = '';
            const today = H.week[day], yest = H.week[(day + 6) % 7];
            const open = today.find(([o, c]) => m >= o && m < c) || yest.filter(([, c]) => c > 1440).map(([o, c]) => [o - 1440, c - 1440]).find(([o, c]) => m >= o && m < c);
            if (open) {
              // a span to midnight that the next day picks up at 0:00 keeps going (late bars, 24/7)
              let end = open[1], dd = day, hops = 0;
              while (end >= 1440 * (hops + 1) - 1 && hops < 7) {
                dd = (dd + 1) % 7;
                const next = H.week[dd].find(([o]) => o === 0);
                if (!next) break;
                hops++;
                end = 1440 * hops + next[1];
              }
              const left = end - m;
              if (hops >= 7 || left > 1440 * 6) (state = 'open'), (text = this.t.always);
              else if (left <= 30) (state = 'soon'), (text = this.fill(this.t.soon, { minutes: left }));
              else (state = 'open'), (text = this.fill(this.t.open, { time: this.clock(end % 1440) }));
            } else {
              for (let k = 0; k < 8; k++) {
                const dd = (day + k) % 7;
                const next = H.week[dd].filter(([o]) => k > 0 || o > m).sort((a, b) => a[0] - b[0])[0];
                if (next) {
                  text = this.fill(this.t.closed, { day: k === 0 ? this.t.today : names[dd] || DAYS_EN[dd], time: this.clock(next[0]) });
                  break;
                }
              }
              if (!text) continue;
            }
            it.status.dataset.state = state;
            it.status.querySelector('.werk-store-locator_status-text').textContent = text;
            it.status.hidden = false;
          }
        }

        // ---------- map gestures (own map; Mapbox brings its own) ----------
        mapEvents(on) {
          const box = this.mapBox;
          const pts = new Map();
          let start = null, pinch = null, moved = false, samples = [];
          const own = () => this.map instanceof Atlas;
          on(box, 'pointerdown', (e) => {
            if (!own() || e.button > 0 || e.target.closest('button, a, .werk-store-locator_pop, .werk-store-locator_sheetcard')) return;
            this.map.stop();
            cancelAnimationFrame(this.ir);
            pts.set(e.pointerId, [e.clientX, e.clientY]);
            if (pts.size === 1) {
              start = { x: e.clientX, y: e.clientY, id: e.pointerId };
              moved = false;
              samples = [[e.clientX, e.clientY, performance.now()]];
            } else if (pts.size === 2) {
              const [a, b] = [...pts.values()];
              const r = box.getBoundingClientRect();
              pinch = { d: Math.hypot(a[0] - b[0], a[1] - b[1]), z: this.map.zoom, m: [(a[0] + b[0]) / 2 - r.left, (a[1] + b[1]) / 2 - r.top] };
              moved = true;
            }
          });
          on(box, 'pointermove', (e) => {
            if (!pts.has(e.pointerId) || !own()) return;
            const prev = pts.get(e.pointerId);
            pts.set(e.pointerId, [e.clientX, e.clientY]);
            if (pts.size >= 2 && pinch) {
              const [a, b] = [...pts.values()];
              const r = box.getBoundingClientRect();
              const m = [(a[0] + b[0]) / 2 - r.left, (a[1] + b[1]) / 2 - r.top];
              const d = Math.hypot(a[0] - b[0], a[1] - b[1]);
              this.map.zoomAt(pinch.m[0], pinch.m[1], pinch.z + Math.log2(d / (pinch.d || 1)) - this.map.zoom);
              this.map.pan(m[0] - pinch.m[0], m[1] - pinch.m[1]);
              pinch.m = m;
              return;
            }
            if (!start) return;
            if (!moved) {
              const lim = e.pointerType === 'touch' ? 10 : 5;
              if (Math.hypot(e.clientX - start.x, e.clientY - start.y) < lim) return;
              moved = true;
              box.classList.add('is-dragging');
              try {
                box.setPointerCapture(e.pointerId);
              } catch {}
            }
            this.map.pan(e.clientX - prev[0], e.clientY - prev[1]);
            samples.push([e.clientX, e.clientY, performance.now()]);
            if (samples.length > 6) samples.shift();
          });
          const up = (e) => {
            if (!pts.has(e.pointerId)) return;
            pts.delete(e.pointerId);
            if (pts.size < 2) pinch = null;
            if (pts.size) return;
            box.classList.remove('is-dragging');
            if (!start) return;
            if (!moved && e.type === 'pointerup') this.mapClick(e);
            else if (moved && samples.length > 1 && this.speed) {
              // a flick keeps gliding and slows down
              const a = samples[0], b = samples[samples.length - 1];
              const dt = b[2] - a[2];
              if (performance.now() - b[2] < 90 && dt > 0) {
                let vx = ((b[0] - a[0]) / dt) * 16, vy = ((b[1] - a[1]) / dt) * 16;
                let last = performance.now();
                const glide = (now) => {
                  const k = Math.exp(-((now - last) / 1000) * 5);
                  last = now;
                  vx *= k;
                  vy *= k;
                  this.map.pan(vx, vy);
                  this.ir = Math.hypot(vx, vy) > 0.3 ? requestAnimationFrame(glide) : 0;
                };
                this.ir = requestAnimationFrame(glide);
              }
            }
            start = null;
          };
          on(box, 'pointerup', up);
          on(box, 'pointercancel', up);
          // the page keeps scrolling – zoom with pinch, ⌘ / Ctrl + wheel, the buttons or a double click
          on(
            box,
            'wheel',
            (e) => {
              if (!own() || !(e.ctrlKey || e.metaKey)) return;
              e.preventDefault();
              const r = box.getBoundingClientRect();
              const k = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? 100 : 1;
              this.map.zoomAt(e.clientX - r.left, e.clientY - r.top, clamp(-e.deltaY * k * (e.ctrlKey ? 0.012 : 0.004), -1, 1));
            },
            { passive: false }
          );
          on(box, 'dblclick', (e) => {
            if (!own() || e.target.closest('button, a, .werk-store-locator_pop')) return;
            const r = box.getBoundingClientRect();
            this.map.zoomAt(e.clientX - r.left, e.clientY - r.top, e.shiftKey ? -1 : 1, true);
          });
          on(box, 'keydown', (e) => {
            if (e.target !== box || !this.map) return;
            const step = 80;
            const k = { ArrowLeft: [step, 0], ArrowRight: [-step, 0], ArrowUp: [0, step], ArrowDown: [0, -step] }[e.key];
            if (k && own()) {
              e.preventDefault();
              this.map.pan(...k);
            } else if (e.key === '+' || e.key === '=') this.map.zoomBy(1);
            else if (e.key === '-') this.map.zoomBy(-1);
          });
        }
        mapClick(e) {
          if (e?.target?.closest?.('button, a, .werk-store-locator_pop')) return;
          if (this.active >= 0) this.select(-1);
        }

        // ---------- night sheet (tablet / phone) ----------
        sheetEvents(on) {
          let drag = null;
          const startDrag = (e) => {
            if (!this.sheetMode() || e.button > 0) return;
            if (e.target.closest('button, a, input') && !e.target.closest('.werk-store-locator_grab')) return;
            drag = { y: e.clientY, sy: this.sy, moved: false, t: performance.now(), v: 0, ly: e.clientY, lt: performance.now() };
          };
          on(this.querySelector('.werk-store-locator_grab'), 'pointerdown', startDrag);
          on(this.querySelector('.werk-store-locator_head'), 'pointerdown', startDrag);
          on(window, 'pointermove', (e) => {
            if (!drag) return;
            const dy = e.clientY - drag.y;
            if (!drag.moved) {
              if (Math.abs(dy) < 6) return;
              drag.moved = true;
              this.side.classList.add('is-dragging');
            }
            const now = performance.now();
            drag.v = (e.clientY - drag.ly) / Math.max(1, now - drag.lt);
            drag.ly = e.clientY;
            drag.lt = now;
            this.setSy(clamp(drag.sy + dy, 0, this.side.offsetHeight - 60 * this.u));
          });
          const end = (e) => {
            if (!drag) return;
            const d = drag;
            drag = null;
            this.side.classList.remove('is-dragging');
            if (!d.moved) {
              if (e.target.closest?.('.werk-store-locator_grab')) this.snap(this.sheet === 'full' ? (this.active >= 0 ? 'store' : 'peek') : 'full');
              return;
            }
            const stops = { full: 0, peek: this.peekY(), store: this.storeY() };
            const keys = this.active >= 0 ? ['full', 'store'] : ['full', 'peek'];
            const aim = this.sy + d.v * 220;
            const best = keys.sort((a, b) => Math.abs(stops[a] - aim) - Math.abs(stops[b] - aim))[0];
            this.snap(best);
          };
          on(window, 'pointerup', end);
          on(window, 'pointercancel', end);
        }
        peekY() {
          const peek = parseFloat(getComputedStyle(this.side).getPropertyValue('--werk-peek')) || 300;
          return Math.max(0, this.side.offsetHeight - peek);
        }
        storeY() {
          const inner = this.detail.querySelector('.werk-store-locator_detail-in');
          const h = (inner?.scrollHeight || 0) + this.querySelector('.werk-store-locator_grab').offsetHeight + 8;
          return clamp(this.side.offsetHeight - h, 0, this.peekY());
        }
        setSy(y) {
          this.sy = y;
          this.side.style.setProperty('--sy', y + 'px');
        }
        snap(state, instant) {
          if (!this.sheetMode()) return;
          this.sheet = state;
          this.side.dataset.sheet = state;
          const y = state === 'full' ? 0 : state === 'store' ? this.storeY() : this.peekY();
          if (instant) this.side.classList.add('is-dragging');
          this.setSy(y);
          if (instant) requestAnimationFrame(() => this.side.classList.remove('is-dragging'));
        }
        showView(v) {
          this.querySelector('.werk-store-locator_view[data-view="list"]').hidden = v !== 'list';
          this.detail.hidden = v !== 'store';
        }

        // ---------- Classic on phones: the map opens as a full screen sheet ----------
        openMap() {
          this.home = this.main.parentElement;
          this.dialog.append(this.main);
          this.dialog.showModal();
          this.mapBox.focus({ preventScroll: true });
          this.sheetCard.hidden = true;
          requestAnimationFrame(() => {
            this.map.resize();
            if (this.active >= 0) {
              this.fillClone(this.sheetCard, this.items[this.active]);
              this.sheetCard.hidden = false;
              this.select(this.active, 'dialog');
            } else this.view(true);
          });
        }
        closeMap() {
          if (this.home && this.main.parentElement !== this.home) this.home.append(this.main);
          this.sheetCard.hidden = true;
          this.querySelector('.werk-store-locator_mapbtn')?.focus({ preventScroll: true });
          requestAnimationFrame(() => this.map?.resize());
        }

        fill(s, vars) {
          return String(s || '').replace(/\[(\w+)\]/g, (m, k) => (k in vars ? vars[k] : m));
        }
        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
          const [r, g, b] = (bg.match(/[\d.]+/g) || [255, 255, 255]).map(Number);
          this.classList.toggle('is-dark', (r * 299 + g * 587 + b * 114) / 1000 < 128);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-tear-reveal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('werk-tear-reveal')) {
    // cubic-bezier as a function (Newton + bisection), for the rAF-driven tear
    const bezier = (x1, y1, x2, y2) => {
      const cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx;
      const cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
      const sx = (t) => ((ax * t + bx) * t + cx) * t;
      const sy = (t) => ((ay * t + by) * t + cy) * t;
      const dx = (t) => (3 * ax * t + 2 * bx) * t + cx;
      return (x) => {
        if (x <= 0) return 0;
        if (x >= 1) return 1;
        let t = x;
        for (let i = 0; i < 6; i++) {
          const e = sx(t) - x;
          const d = dx(t);
          if (Math.abs(e) < 1e-5) return sy(t);
          if (Math.abs(d) < 1e-6) break;
          t -= e / d;
        }
        let lo = 0, hi = 1;
        t = x;
        while (hi - lo > 1e-5) {
          if (sx(t) < x) lo = t;
          else hi = t;
          t = (lo + hi) / 2;
        }
        return sy(t);
      };
    };

    customElements.define('werk-tear-reveal', class extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.stage = this.querySelector('[data-stage]');
        this.b = this.querySelector('[data-b]');
        this.edge = this.querySelector('[data-edge]');
        this.gapEl = this.querySelector('[data-gap]');
        this.handle = this.querySelector('[data-handle]');
        if (!this.stage || !this.b) return;
        if (this.classList.contains('is-theme-colors')) this.themeColors();

        this.cut = d.look === 'cut';
        this.down = d.dir === 'down';
        this.seam = this.target = Math.min(95, Math.max(5, parseFloat(d.seam) || 50));
        this.rough = (parseFloat(d.rough) || 0) / 100;
        this.angle = (parseFloat(d.angle) || 0) * Math.PI / 180;
        this.gap = parseFloat(d.gap) || 0;
        this.p = 0;
        this.seed();

        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const still = reduce || d.motion === 'off' || d.design === 'true' || !!window.Shopify?.designMode;

        const ac = (this.ac = new AbortController());
        const on = (el, type, fn, o) => el.addEventListener(type, fn, { signal: ac.signal, ...o });
        this.ro = new ResizeObserver(() => this.measure());
        this.ro.observe(this.stage);
        this.measure();
        document.fonts?.ready.then(() => this.isConnected && this.measure());
        if (this.handle) this.bindDrag(on);

        if (still) {
          this.finish();
          return;
        }
        this.dataset.phase = 'wait';
        this.draw();
        const go = () => this.ready().then(() => this.isConnected && this.start());
        if (d.trigger === 'view') {
          this.io = new IntersectionObserver((es) => {
            if (es.some((e) => e.isIntersecting)) {
              this.io.disconnect();
              go();
            }
          }, { threshold: 0.35 });
          this.io.observe(this);
        } else go();
      }

      disconnectedCallback() {
        this.ac?.abort();
        this.ro?.disconnect();
        this.io?.disconnect();
        cancelAnimationFrame(this.raf);
        cancelAnimationFrame(this.dragRaf);
        clearTimeout(this.timer);
      }

      themeColors() {
        let el = this.parentElement;
        let bg = 'rgb(255, 255, 255)';
        while (el) {
          const c = getComputedStyle(el).backgroundColor;
          if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
            bg = c;
            break;
          }
          el = el.parentElement;
        }
        this.style.setProperty('--werk-bg', bg);
        this.style.setProperty('--werk-fg', getComputedStyle(this).color);
      }

      // a new tear on every load: smoothed random walk, offsets in Figma px (× --u when drawn)
      seed() {
        const n = 64;
        const amp = this.rough * 20;
        const pts = [];
        const fray = [];
        let x = 0, v = 0, f = 3;
        for (let i = 0; i <= n; i++) {
          v += (Math.random() - 0.5) * amp * 0.9;
          v *= 0.78;
          x += v;
          x *= 0.97;
          pts.push(x + (Math.random() - 0.5) * amp * 0.55);
          f += (Math.random() - 0.5) * 2.4;
          f = Math.min(6, Math.max(1.5, f));
          fray.push(f);
        }
        this.pts = pts;
        this.fray = fray;
      }

      measure() {
        const r = this.stage.getBoundingClientRect();
        this.w = r.width;
        this.h = r.height;
        this.u = parseFloat(getComputedStyle(this.querySelector('.werk-tear-reveal_inner')).getPropertyValue('--werk-u')) || 1;
        this.style.setProperty('--werk-gap-x', `${(this.gap * this.u).toFixed(2)}px`);
        this.fit();
        this.draw();
      }

      // one line for the title: shrink the font until it fits (never grow)
      fit() {
        const t = this.querySelector('.werk-tear-reveal_layer--a .werk-tear-reveal_title');
        if (!t) return;
        this.classList.add('is-fit');
        this.style.setProperty('--werk-fit', '1');
        const need = t.scrollWidth, room = t.clientWidth;
        this.style.setProperty('--werk-fit', need > room + 1 ? Math.max(0.3, room / need - 0.005).toFixed(3) : '1');
      }

      ready() {
        const img = [...this.querySelectorAll('.werk-tear-reveal_layer--a img')][0];
        const loaded = !img || img.complete ? Promise.resolve() : new Promise((r) => {
          img.addEventListener('load', r, { once: true });
          img.addEventListener('error', r, { once: true });
        });
        const decoded = loaded.then(() => img?.decode?.().catch(() => {}));
        return Promise.race([decoded, new Promise((r) => setTimeout(r, 4000))]);
      }

      // x of the seam at row i (0 = where the tear starts) in px
      xAt(i) {
        const n = this.pts.length - 1;
        const base = (this.seam / 100) * this.w;
        if (this.cut) {
          const t = this.down ? i / n : 1 - i / n; // 0 top … 1 bottom
          return base + (t - 0.5) * this.h * Math.tan(this.angle);
        }
        return base + this.pts[i] * this.u;
      }
      yAt(i) {
        const n = this.pts.length - 1;
        return this.down ? (i / n) * this.h : this.h - (i / n) * this.h;
      }

      // the tear so far as polygons: the right half (b), the light paper edge, the cut gap
      draw() {
        if (!this.w || !this.pts) return;
        const n = this.pts.length - 1;
        const p = this.p;
        const k = Math.max(1, Math.round(p * n));
        const w = this.w, h = this.h;
        const seg = [];
        for (let i = 0; i <= k; i++) seg.push([this.xAt(i), this.yAt(i)]);
        const tipY = seg[seg.length - 1][1];
        // ahead of the tip the right half stays closed along a slant, so the tear reads as travelling
        const far = p >= 1 ? (this.down ? h : 0) : this.down ? Math.min(h, tipY + h * 0.16) : Math.max(0, tipY - h * 0.16);
        const close = this.down ? ` ${w}px ${far}px, ${w}px 0px` : ` ${w}px ${far}px, ${w}px ${h}px`;
        const poly = (arr) => `polygon(${arr.map(([x, y]) => `${x.toFixed(1)}px ${y.toFixed(1)}px`).join(', ')},${close})`;
        if (p <= 0) {
          this.b.style.clipPath = 'polygon(0 0, 0 0, 0 0)';
          if (this.edge) this.edge.style.clipPath = 'polygon(0 0, 0 0, 0 0)';
        } else {
          this.b.style.clipPath = poly(seg);
          if (this.edge) this.edge.style.clipPath = poly(seg.map(([x, y], i) => [x - this.fray[i] * this.u, y]));
        }
        if (this.gapEl) {
          if (p >= 1) {
            const g = this.gap * this.u;
            const a = [this.xAt(0), this.yAt(0)], z = [this.xAt(n), this.yAt(n)];
            this.gapEl.style.clipPath = `polygon(${a[0]}px ${a[1]}px, ${z[0]}px ${z[1]}px, ${z[0] + g}px ${z[1]}px, ${a[0] + g}px ${a[1]}px)`;
          } else this.gapEl.style.clipPath = 'polygon(0 0, 0 0, 0 0)';
        }
        if (this.handle) {
          const mid = Math.round(n / 2);
          const gx = this.cut && this.dataset.phase === 'done' ? (this.gap * this.u) / 2 : 0;
          const r = 30 * this.u;
          this.style.setProperty('--werk-hx', `${Math.min(this.w - r, Math.max(r, this.xAt(mid) + gx)).toFixed(1)}px`);
          const v = Math.round(this.seam);
          this.handle.setAttribute('aria-valuenow', v);
          this.handle.setAttribute('aria-valuetext', `${v} %`);
        }
      }

      start() {
        const cs = getComputedStyle(this.querySelector('.werk-tear-reveal_inner'));
        const m = cs.getPropertyValue('--werk-ease').match(/cubic-bezier\(([^)]+)\)/);
        const ease = m ? bezier(...m[1].split(',').map(Number)) : (x) => x;
        const dur = Math.max(0.2, parseFloat(this.dataset.duration) || 1.6) * 1000;
        const delay = Math.max(0, parseFloat(this.dataset.delay) || 0) * 1000;
        this.timer = setTimeout(() => {
          this.dataset.phase = 'tear';
          const t0 = performance.now();
          const tick = (now) => {
            if (!this.isConnected) return;
            const x = Math.min(1, (now - t0) / dur);
            this.p = Math.min(1, Math.max(0, ease(x)));
            if (x >= 1) {
              this.finish();
              return;
            }
            this.draw();
            this.raf = requestAnimationFrame(tick);
          };
          this.raf = requestAnimationFrame(tick);
        }, delay);
      }

      // play the intro again with a new tear (used by the preview videos)
      replay() {
        cancelAnimationFrame(this.raf);
        clearTimeout(this.timer);
        this.seam = this.target = Math.min(95, Math.max(5, parseFloat(this.dataset.seam) || 50));
        this.seed();
        this.p = 0;
        this.dataset.phase = 'wait';
        this.draw();
        return new Promise((r) => requestAnimationFrame(() => { this.start(); r(); }));
      }

      finish() {
        this.p = 1;
        this.dataset.phase = 'done';
        this.draw();
      }

      // interactive seam: drag the handle or anywhere on the picture (not on links), arrows on the handle
      bindDrag(on) {
        const H = this.handle;
        let start = null;
        const toSeam = (e) => {
          const r = this.stage.getBoundingClientRect();
          // move the seam so the tear follows the pointer at the grabbed row
          return ((e.clientX - r.left) / r.width) * 100 - this.grab;
        };
        const set = (v) => {
          this.target = Math.min(95, Math.max(5, v));
          if (!this.dragRaf) this.dragRaf = requestAnimationFrame((t) => this.follow(t));
        };
        on(this.stage, 'pointerdown', (e) => {
          if (this.dataset.phase !== 'done' || e.button > 0) return;
          if (e.target.closest('a, button:not([data-handle])')) return;
          start = { x: e.clientX, y: e.clientY, id: e.pointerId, live: e.target.closest('[data-handle]') === H };
          const r = this.stage.getBoundingClientRect();
          const mid = this.xAt(Math.round((this.pts.length - 1) / 2));
          this.grab = start.live ? ((e.clientX - r.left) / r.width) * 100 - this.seam : (mid / r.width) * 100 - this.seam;
          if (start.live) {
            this.stage.setPointerCapture(e.pointerId);
            this.classList.add('is-dragging');
          }
        });
        on(this.stage, 'pointermove', (e) => {
          if (!start || e.pointerId !== start.id) return;
          if (!start.live) {
            const dx = Math.abs(e.clientX - start.x), dy = Math.abs(e.clientY - start.y);
            if (dy > dx && dy > 8) { start = null; return; }
            if (dx < (e.pointerType === 'touch' ? 12 : 8)) return;
            start.live = true;
            this.stage.setPointerCapture(e.pointerId);
            this.classList.add('is-dragging');
          }
          set(toSeam(e));
        });
        const end = () => {
          start = null;
          this.classList.remove('is-dragging');
        };
        on(this.stage, 'pointerup', end);
        on(this.stage, 'pointercancel', end);
        on(this.stage, 'lostpointercapture', end);
        on(H, 'keydown', (e) => {
          const step = e.shiftKey ? 10 : 2;
          const keys = { ArrowLeft: -step, ArrowDown: -step, ArrowRight: step, ArrowUp: step };
          if (e.key in keys) set(this.target + keys[e.key]);
          else if (e.key === 'Home') set(5);
          else if (e.key === 'End') set(95);
          else return;
          e.preventDefault();
        });
      }

      // damped follow, frame-rate independent; stops when it has arrived
      follow(now) {
        const dt = Math.min(1 / 30, (now - (this.last || now)) / 1000 || 1 / 60);
        this.last = now;
        const instant = getComputedStyle(this.querySelector('.werk-tear-reveal_inner')).getPropertyValue('--werk-speed').trim() === '0';
        this.seam = instant ? this.target : this.seam + (this.target - this.seam) * (1 - Math.exp(-dt * 18));
        if (Math.abs(this.target - this.seam) < 0.02) this.seam = this.target;
        this.draw();
        if (this.seam !== this.target && this.isConnected) this.dragRaf = requestAnimationFrame((t) => this.follow(t));
        else {
          this.dragRaf = 0;
          this.last = 0;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werk-testimonial-orbit"] && !Shopify.designMode) return;
  try {
    
  // Theme cart after an add from this section. Horizon & co. listen for shopify:cart:lines-update; Dawn and the
  // themes built on it (Sense, Craft, Refresh …) only re-render their own sections – so their cart bubble and
  // drawer are refreshed here from the Section Rendering API, without opening anything.
  window.werkThemeCart ||= async (root) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const drawer = document.querySelector('cart-drawer');
    const ids = ['cart-icon-bubble', ...(drawer?.querySelector('#CartDrawer') ? ['cart-drawer'] : [])];
    try {
      const [sections, cart] = await Promise.all([
        fetch(`${root}?sections=${ids.join(',')}`).then((r) => r.json()),
        fetch(root + 'cart.js').then((r) => r.json()),
      ]);
      const part = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel)?.innerHTML;
      const b = sections['cart-icon-bubble'] && part(sections['cart-icon-bubble'], '.shopify-section');
      if (b != null) bubble.innerHTML = b;
      const d = sections['cart-drawer'] && part(sections['cart-drawer'], '#CartDrawer');
      if (d != null) {
        drawer.querySelector('#CartDrawer').innerHTML = d;
        drawer.classList.toggle('is-empty', !cart.item_count);
      }
    } catch {}
  };
  if (!customElements.get('werk-testimonial-orbit')) {
    // cubic-bezier as a function (rAF tweens follow the section's easing)
    const bezier = (x1, y1, x2, y2) => {
      const a = (t, p1, p2) => 3 * p1 * t * (1 - t) ** 2 + 3 * p2 * t * t * (1 - t) + t ** 3;
      const d = (t, p1, p2) => 3 * p1 * (1 - t) ** 2 + 6 * (p2 - p1) * t * (1 - t) + 3 * (1 - p2) * t * t;
      return (x) => {
        if (x <= 0 || x >= 1) return x <= 0 ? 0 : 1;
        let t = x;
        for (let i = 0; i < 8; i++) {
          const dx = a(t, x1, x2) - x;
          const dd = d(t, x1, x2);
          if (Math.abs(dx) < 1e-5 || !dd) break;
          t -= dx / dd;
        }
        return a(Math.min(1, Math.max(0, t)), y1, y2);
      };
    };
    const wrap = (v, m) => ((((v + m / 2) % m) + m) % m) - m / 2;
    const RAD = Math.PI / 180;

    customElements.define(
      'werk-testimonial-orbit',
      class extends HTMLElement {
        connectedCallback() {
          this.ac = new AbortController();
          const on = (el, type, fn, opts) => el && el.addEventListener(type, fn, { signal: this.ac.signal, ...opts });
          this.on = on;
          this.inner = this.querySelector('.werk-testimonial-orbit_inner');
          this.ring = this.querySelector('.werk-testimonial-orbit_ring');
          if (!this.ring) return;
          this.orbit = this.querySelector('.werk-testimonial-orbit_orbit');
          this.cards = [...this.ring.querySelectorAll('.werk-testimonial-orbit_card')];
          this.captions = [...this.querySelectorAll('.werk-testimonial-orbit_caption')];
          this.entries = [...this.querySelectorAll('.werk-testimonial-orbit_entry')];
          this.reader = this.querySelector('.werk-testimonial-orbit_reader');
          this.panel = this.querySelector('.werk-testimonial-orbit_panel');
          this.countEl = this.querySelector('[data-count]');
          this.slot = this.querySelector('.werk-testimonial-orbit_slot');
          this.n = Number(this.dataset.n) || 0;
          this.m = this.cards.length;
          try { this.t = JSON.parse(this.querySelector('[data-werk-t]').textContent); } catch { this.t = {}; }
          this.P1 = 650; // opening: the picture to its place (ms)
          this.P2 = 850; // opening: the white part to the right (ms)
          this.view = 0; // rendered position (cards), animates
          this.active = 0; // voice at the front
          this.holds = new Set();
          this.styleCache = new WeakMap();
          this.lean = { x: 0, y: 0, tx: 0, ty: 0 };
          this.hover = matchMedia('(hover: hover) and (pointer: fine)');
          if (this.classList.contains('is-theme-colors')) this.themeColors();

          this.measure();
          this.render();
          this.setActive(0, true);
          requestAnimationFrame(() => {
            this.classList.add('is-entering', 'is-ready');
            setTimeout(() => this.classList.remove('is-entering'), 800);
          });

          new ResizeObserver(() => { this.measure(); this.render(); if (this.isOpen && !this.sheet) this.place(); }).observe(this.inner);
          this.ro = null;
          this.io = new IntersectionObserver(([e]) => this.hold('view', !e.isIntersecting), { threshold: 0.15 });
          this.io.observe(this);
          on(document, 'visibilitychange', () => this.hold('tab', document.hidden));

          // hover pauses over the ring, the quote and the arrows; keyboard focus too
          on(this, 'pointerover', (e) => { if (e.pointerType === 'mouse') this.hold('hover', !!e.target.closest('[data-hold]')); });
          on(this, 'pointerleave', () => { this.hold('hover', false); this.lean.tx = this.lean.ty = 0; this.kick(); });
          on(this, 'focusin', () => this.hold('focus', !!this.querySelector(':focus-visible')));
          on(this, 'focusout', () => requestAnimationFrame(() => this.hold('focus', !!this.querySelector(':focus-visible'))));
          if (this.dataset.lean === 'true') on(this, 'pointermove', (e) => this.onLean(e));

          on(this.ring, 'click', (e) => this.onCardClick(e));
          // hovering or focusing a card fetches its review picture already
          const early = (e) => { const c = e.target.closest?.('.werk-testimonial-orbit_card'); if (c) this.preload(Number(c.dataset.v)); };
          on(this.ring, 'pointerover', early);
          on(this.ring, 'focusin', early);
          on(this, 'keydown', (e) => this.onKey(e));
          if (this.dataset.drag !== 'false' && this.n > 1) {
            on(this.ring, 'pointerdown', (e) => this.onDown(e));
            on(this.ring, 'wheel', (e) => this.onWheel(e), { passive: false });
          }
          this.querySelectorAll('[data-go]').forEach((b) => on(b, 'click', () => this.go(Number(b.dataset.go), 'nav')));

          // review card
          // detail 0 = Enter / Space on the X: then the focus goes back to the card
          on(this.querySelector('.werk-testimonial-orbit_close'), 'click', (e) => this.close(e.detail === 0));
          on(this.reader, 'cancel', (e) => { e.preventDefault(); this.close(true); });
          on(this.reader, 'keydown', (e) => this.onReaderKey(e));
          on(this.reader, 'scroll', (e) => e.target.classList?.contains('werk-testimonial-orbit_quote') && this.more(e.target), { capture: true, passive: true });
          on(this.reader, 'click', (e) => { if (e.target === this.reader) this.close(); });
          on(this.reader, 'click', (e) => { const b = e.target.closest('.werk-testimonial-orbit_add'); if (b) this.add(b); });
          on(document, 'pointerdown', (e) => {
            if (!this.isOpen || this.sheet || this.busy) return;
            if (this.panel.contains(e.target) || e.target.closest('.werk-testimonial-orbit_nav') || (this.contains(e.target) && e.target.closest('.werk-testimonial-orbit_card'))) return;
            this.close();
          });
          this.sheetDrag();

          // theme editor: selecting a block brings its card to the front and opens it
          if (window.Shopify && Shopify.designMode) {
            on(document, 'shopify:block:select', (e) => {
              const card = this.cards.find((c) => c.getAttribute('data-shopify-editor-block')?.includes(e.detail.blockId));
              if (!card || !this.contains(e.target)) return;
              this.hold('editor', true);
              this.open(Number(card.dataset.v), true);
            });
            on(document, 'shopify:block:deselect', (e) => {
              if (!this.contains(e.target)) return;
              this.close();
              this.hold('editor', false);
            });
          }
          this.schedule();
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
          cancelAnimationFrame(this.raf);
          clearTimeout(this.timer);
          clearTimeout(this.addTm);
          clearTimeout(this.ringBack);
          clearTimeout(this.landTm);
          clearTimeout(this.moreTm);
          this.anims?.forEach((a) => a.cancel());
          this.capAnims?.forEach((a) => a.cancel());
        }

        // ---------- geometry ----------
        measure() {
          const cs = getComputedStyle(this.inner);
          this.u = parseFloat(cs.getPropertyValue('--werk-u')) || 1;
          this.R = parseFloat(cs.getPropertyValue('--werk-rr')) || 600;
          this.P = parseFloat(cs.getPropertyValue('--werk-pp')) || 1500;
          this.step = parseFloat(cs.getPropertyValue('--werk-step')) || 36;
          this.speed = parseFloat(cs.getPropertyValue('--werk-speed'));
          if (Number.isNaN(this.speed)) this.speed = 1;
          const e = (cs.getPropertyValue('--werk-ease').match(/[-\d.]+/g) || []).map(Number);
          this.ease = e.length === 4 ? bezier(...e) : bezier(0.6234, 0.058, 0, 0.9095);
          this.snapEase = bezier(0.16, 1, 0.3, 1);
          this.sheet = this.inner.clientWidth < 750;
          this.phi = (Number(this.dataset.tilt) || 0) / 100 * 20;
          // screen distance between the front card and its neighbour – one card per that many pixels of drag
          const c1 = Math.cos(this.step * RAD);
          const sc1 = (this.P * 2.2) / (this.P * 2.2 + this.R * (1 - c1));
          this.pxStep = Math.max(80, this.R * Math.sin(this.step * RAD) * sc1);
        }

        // one frame of the ring: every card from its angle to the front
        render() {
          const m = this.m;
          const single = this.n === 1;
          const phi = (this.phi + this.lean.y) * RAD;
          const sinP = Math.sin(phi);
          const cosP = Math.cos(phi);
          let front = null;
          let best = 1e9;
          for (let j = 0; j < m; j++) {
            const card = this.cards[j];
            const k = single ? (j === 0 ? 0 : 99) : wrap(j - this.view, m);
            const a = k * this.step + this.lean.x;
            const abs = Math.abs(a);
            const c = Math.cos(a * RAD);
            const s = Math.sin(a * RAD);
            const d = (1 - c) / 2;
            const z = this.R * (c - 1) * cosP;
            const sc = this.P / (this.P - z);
            // sideways the ring spreads wider than its depth shrinks the cards (as designed): x uses a flatter perspective
            const x = this.R * s * (this.P * 2.2) / (this.P * 2.2 - z);
            const y = this.R * sinP * (c - 1) * sc;
            const ry = Math.atan2(s, Math.abs(c)) / RAD;
            let vis = abs > 180 ? Math.max(0, 1 - (abs - 180) / 18) : 1;
            if (single && j > 0) vis = 0;
            // the open review takes the front card's place – not on phones: the sheet slides over it (no gap while it comes)
            if (this.isOpen && !this.classList.contains('is-sheet')) vis *= Math.min(1, abs / (this.step * 0.6));
            const st = {
              t: `translate(${x.toFixed(2)}px, ${y.toFixed(2)}px) scale(${sc.toFixed(4)}) perspective(${this.P.toFixed(0)}px) rotateY(${ry.toFixed(2)}deg)`,
              f: (0.5 * d).toFixed(3),
              b: Math.max(0, (d - 0.35) * 4.6).toFixed(2),
              sh: Math.max(0, 1 - d * 10).toFixed(3),
              v: vis.toFixed(3),
              z: String(Math.round(200 + 100 * c)),
            };
            const old = this.styleCache.get(card) || {};
            if (old.t !== st.t) card.style.transform = st.t;
            if (old.f !== st.f) card.style.setProperty('--f', st.f);
            if (old.b !== st.b) card.style.setProperty('--b', st.b);
            if (old.sh !== st.sh) card.style.setProperty('--sh', st.sh);
            if (old.v !== st.v) card.style.setProperty('--vis', st.v);
            if (old.z !== st.z) card.style.zIndex = st.z;
            if (old.vis0 !== (vis === 0)) card.style.pointerEvents = vis === 0 ? 'none' : '';
            st.vis0 = vis === 0;
            this.styleCache.set(card, st);
            if (abs < best) { best = abs; front = card; }
          }
          if (front !== this.front) {
            this.front?.classList.remove('is-front');
            front.classList.add('is-front');
            this.front = front;
          }
        }

        // the loop runs while something moves: a tween, a drag, the lean towards the pointer
        kick() {
          if (this.raf) return;
          let last = performance.now();
          const tick = (now) => {
            this.raf = 0;
            if (!this.isConnected) return;
            const dt = Math.min((now - last) / 1000, 1 / 30);
            last = now;
            let moving = false;
            if (this.tw) {
              const p = Math.min(1, (now - this.tw.t0) / this.tw.dur);
              this.view = this.tw.from + (this.tw.to - this.tw.from) * this.tw.ease(p);
              if (p >= 1) {
                this.view = this.tw.to;
                const done = this.tw.done;
                this.tw = null;
                done?.();
              } else moving = true;
            }
            if (this.dragging) moving = true;
            const L = this.lean;
            const k = 1 - Math.exp(-dt * 5);
            L.x += (L.tx - L.x) * k;
            L.y += (L.ty - L.y) * k;
            if (Math.abs(L.tx - L.x) > 0.01 || Math.abs(L.ty - L.y) > 0.01) moving = true;
            this.render();
            this.syncActive();
            if (moving) this.raf = requestAnimationFrame(tick);
          };
          this.raf = requestAnimationFrame(tick);
        }

        // ---------- moving the ring ----------
        // go(+1) = the next voice comes to the front; returns a promise that settles when it stands
        go(delta, why) {
          if (this.n < 2) return Promise.resolve();
          const base = this.tw ? this.tw.to : Math.round(this.view);
          return this.to(base + delta, why === 'auto' ? 1200 : 1000);
        }
        to(target, ms, ease) {
          return new Promise((resolve) => {
            const prev = this.tw;
            prev?.done?.();
            if (!this.speed || ms === 0) {
              this.view = target;
              this.tw = null;
              this.render();
              this.syncActive();
              if (!this.speed) this.ring.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
              resolve();
              return;
            }
            this.tw = { from: this.view, to: target, t0: performance.now(), dur: ms * this.speed, ease: ease || this.ease, done: resolve };
            this.kick();
          }).then(() => this.schedule());
        }
        // shortest way to bring a voice to the front
        toVoice(v, ms = 1000) {
          const m = this.m;
          let best = null;
          for (let j = v; j < m; j += this.n) {
            const k = wrap(j - this.view, m);
            if (!best || Math.abs(k) < Math.abs(best)) best = k;
          }
          if (best == null || Math.abs(best) < 0.01) return Promise.resolve();
          return this.to(this.view + best, ms);
        }
        syncActive() {
          const j = ((Math.round(this.view) % this.m) + this.m) % this.m;
          const v = this.n ? j % this.n : 0;
          if (v !== this.active) this.setActive(v);
        }
        setActive(v, first) {
          this.active = v;
          this.captions.forEach((c, i) => {
            c.classList.toggle('is-active', i === v);
            c.toggleAttribute('aria-hidden', i !== v);
          });
          if (this.countEl) this.countEl.textContent = String(v + 1).padStart(2, '0');
          // roving tab stop: the front voice's own card
          this.cards.forEach((c) => {
            if (c.getAttribute('aria-hidden') === 'true') return;
            c.tabIndex = Number(c.dataset.v) === v ? 0 : -1;
          });
          if (!first) this.captionIn(v);
          if (!first && this.isOpen) this.swap(v);
        }

        // ---------- autoplay ----------
        hold(why, on) {
          const had = this.holds.size;
          if (on) this.holds.add(why);
          else this.holds.delete(why);
          if (this.holds.size !== had) this.schedule();
        }
        schedule() {
          clearTimeout(this.timer);
          const sec = Number(this.dataset.auto) || 0;
          if (!sec || this.n < 2 || !this.speed || this.holds.size || this.tw || this.dragging) return;
          this.timer = setTimeout(() => this.go(1, 'auto'), sec * 1000);
        }

        // ---------- input ----------
        onCardClick(e) {
          const card = e.target.closest('.werk-testimonial-orbit_card');
          if (!card) return;
          if (this.suppress) {
            this.suppress = false;
            e.preventDefault();
            return;
          }
          this.open(Number(card.dataset.v));
        }
        onKey(e) {
          if (e.target.closest('.werk-testimonial-orbit_reader')) return; // the open card has its own keys
          if (e.key === 'Escape' && this.isOpen) {
            e.preventDefault();
            this.close(true);
            return;
          }
          if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && e.target.closest('.werk-testimonial-orbit_ring, .werk-testimonial-orbit_nav')) {
            e.preventDefault();
            if (this.isOpen) {
              this.go(e.key === 'ArrowRight' ? 1 : -1, 'key');
              return;
            }
            const onCard = !!e.target.closest('.werk-testimonial-orbit_card');
            this.go(e.key === 'ArrowRight' ? 1 : -1, 'key').then(() => {
              if (onCard) this.cards.find((c) => c.tabIndex === 0)?.focus({ preventScroll: true });
            });
          }
        }
        onWheel(e) {
          // only sideways swipes on a trackpad turn the ring – scrolling down stays with the page
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
          e.preventDefault();
          const now = performance.now();
          if (now < (this.wheelLock || 0)) return;
          this.wheelAcc = (now - (this.wheelT || 0) > 200 ? 0 : this.wheelAcc || 0) + e.deltaX * (e.deltaMode === 1 ? 16 : 1);
          this.wheelT = now;
          if (Math.abs(this.wheelAcc) > 40) {
            this.go(Math.sign(this.wheelAcc), 'wheel');
            this.wheelAcc = 0;
            this.wheelLock = now + 450;
          }
        }
        onDown(e) {
          if (e.button !== 0 || this.isOpen) return;
          const sx = e.clientX;
          const sy = e.clientY;
          const from = this.view;
          const touch = e.pointerType !== 'mouse';
          let moved = false;
          const samples = [];
          const move = (ev) => {
            const dx = ev.clientX - sx;
            const dy = ev.clientY - sy;
            if (!moved) {
              if (Math.abs(dx) < (touch ? 12 : 8) || Math.abs(dx) < Math.abs(dy)) {
                if (touch && Math.abs(dy) > 12) up(null);
                return;
              }
              // capture only once it is a drag – a plain click must reach the card
              moved = true;
              this.dragging = true;
              this.ring.setPointerCapture?.(e.pointerId);
              this.ring.classList.add('is-dragging');
              if (this.tw) { this.tw = null; }
              clearTimeout(this.timer);
              this.kick();
            }
            this.view = from - dx / this.pxStep;
            samples.push([ev.timeStamp, ev.clientX]);
            if (samples.length > 6) samples.shift();
          };
          const up = (ev) => {
            ctl.abort();
            if (!moved) return;
            this.dragging = false;
            this.ring.classList.remove('is-dragging');
            this.suppress = true;
            setTimeout(() => (this.suppress = false), 60);
            let v = 0;
            const a = samples[0];
            const b = samples[samples.length - 1];
            if (ev && a && b && b[0] > a[0] && ev.timeStamp - b[0] < 90) v = (b[1] - a[1]) / (b[0] - a[0]); // px per ms
            const fling = (-v * 220) / this.pxStep;
            const target = Math.round(this.view + Math.max(-3, Math.min(3, fling)));
            const dist = Math.abs(target - this.view);
            this.to(target, Math.min(1000, 520 + dist * 220), this.snapEase);
          };
          const ctl = new AbortController();
          const o = { signal: ctl.signal };
          window.addEventListener('pointermove', move, o);
          window.addEventListener('pointerup', up, o);
          window.addEventListener('pointercancel', up, o);
          this.ac.signal.addEventListener('abort', () => ctl.abort(), o);
        }
        onLean(e) {
          if (!this.hover.matches || this.isOpen || this.dragging || !this.speed) return;
          const r = this.ring.getBoundingClientRect();
          const px = (e.clientX - r.left) / r.width - 0.5;
          const py = (e.clientY - (r.top + r.height / 2)) / Math.max(r.height, 1);
          // at most 4° towards the pointer
          this.lean.tx = Math.max(-4, Math.min(4, px * 8));
          this.lean.ty = Math.max(-4, Math.min(4, py * 6));
          this.kick();
        }

        // ---------- review card ----------
        async open(v, fromEditor) {
          if (this.busy || !this.reader) return;
          if (this.isOpen) {
            if (v !== this.active) this.toVoice(v);
            return;
          }
          this.busy = true;
          clearTimeout(this.timer);
          this.hold('open', true);
          // the review's picture is bigger than the card's – load and decode it while the ring turns, so never a
          // grey box flies (at most 0.4 s more)
          const ready = this.preload(v);
          await this.toVoice(v, 900);
          await Promise.race([ready, new Promise((r) => setTimeout(r, 400))]);
          this.lean.tx = this.lean.ty = 0;
          this.lean.x = this.lean.y = 0;
          this.render();
          this.measure();
          const from = this.front.getBoundingClientRect();
          const ir = this.inner.getBoundingClientRect();
          // the front card's place, kept relative to the section – the card shrinks back to it even after a scroll
          this.rest = { x: from.left - ir.left, y: from.top - ir.top, w: from.width, h: from.height };
          this.showEntry(this.active);
          this.sheet ? this.openSheet() : this.openCard(from);
          this.isOpen = true;
          this.classList.add('is-reading');
          this.render();
          this.busy = false;
          if (!fromEditor) this.panel.focus({ preventScroll: true });
        }
        preload(v) {
          const img = this.entries[v]?.querySelector('.werk-testimonial-orbit_media img');
          if (!img) return Promise.resolve();
          img.loading = 'eager';
          return img.decode ? img.decode().catch(() => {}) : Promise.resolve();
        }
        place() {
          // the card starts a little below the top of the front card; bottom: above the arrows
          const ir = this.inner.getBoundingClientRect();
          const top = (this.rest ? this.rest.y : this.front.getBoundingClientRect().top - ir.top) + 24 * this.u;
          const nav = this.querySelector('.werk-testimonial-orbit_nav');
          const limit = nav ? nav.getBoundingClientRect().top - ir.top - 20 * this.u : ir.height - parseFloat(getComputedStyle(this.inner).paddingBottom);
          this.inner.style.setProperty('--werk-rt', `${Math.round(top)}px`);
          this.inner.style.setProperty('--werk-rmax', `${Math.max(240, Math.round(limit - top))}px`);
        }
        anim(el, frames, o) {
          const a = el.animate(frames, { fill: 'both', ...o, duration: (o.duration || 0) * this.speed, delay: (o.delay || 0) * this.speed });
          // kept until settle(): a finished animation still holds its end state (fill) and must be cancelled with the rest
          (this.anims ||= new Set()).add(a);
          return a;
        }
        // transform that lays a box over a rect (uniform scale, it covers the rect – the panel's clip cuts the rest)
        flip(rect, box) {
          const r = box.getBoundingClientRect();
          const s = Math.max(rect.width / r.width, rect.height / r.height);
          const dx = rect.left + rect.width / 2 - (r.left + r.width / 2);
          const dy = rect.top + rect.height / 2 - (r.top + r.height / 2);
          return `translate(${dx}px, ${dy}px) scale(${s})`;
        }
        settle() {
          this.anims?.forEach((a) => a.cancel());
          this.anims?.clear();
        }
        // in the section: the card grows out of the front card, picture first, then the words
        openCard(from) {
          this.settle();
          this.place();
          this.reader.show();
          this.classList.add('is-open');
          const rr = this.panel.getBoundingClientRect();
          const media = this.entry?.querySelector('.werk-testimonial-orbit_media');
          const body = this.entry?.querySelector('.werk-testimonial-orbit_body');
          const ease = this.css('--werk-ease');
          // two steps: 1) the picture travels from the front card to its place on the left and grows to its size,
          // 2) the white part opens to the right – both with the section's easing; then the words
          const { card, pic, full, o } = this.clips(from, rr, media);
          const T = this.P1 + this.P2;
          this.anim(this.panel, [{ clipPath: card, easing: ease }, { clipPath: pic, offset: o, easing: ease }, { clipPath: full }], { duration: T, easing: 'linear' });
          // the picture box itself moves – its children would be cut by its overflow
          // its own rounded corners: the white part comes out from behind the picture, only then its right corners turn square
          if (media) {
            const { round } = this.corners();
            const white = rr.right - media.getBoundingClientRect().right;
            this.anim(media, [
              { transform: this.flip(from, media), clipPath: round, easing: ease },
              ...this.cornerFrames(o, 1, white, false),
            ], { duration: T, easing: 'linear' });
          }
          // the shadow of the open card only once the white part has (almost) arrived
          this.anim(this.reader, [{ '--rs': 0 }, { '--rs': 1 }], { duration: 500, delay: this.P1 + this.P2 * 0.8, easing: 'ease-out' });
          if (body) this.stagger(this.entry, this.P1 + this.P2 * 0.72);
        }
        // the words come in line by line, then name and stars, then the product row
        split(q) {
          if (q.dataset.split) return [...q.querySelectorAll('.werk-testimonial-orbit_w')];
          const walk = (node) => {
            for (const n of [...node.childNodes]) {
              if (n.nodeType === 3) {
                const frag = document.createDocumentFragment();
                for (const part of n.textContent.split(/(\s+)/)) {
                  if (!part) continue;
                  if (/^\s+$/.test(part)) frag.append(part);
                  else {
                    // the word sits in its own mask (werk-testimonial-orbit_w), the inner span (werk-testimonial-orbit_wi) rises through it
                    const w = document.createElement('span');
                    w.className = 'werk-testimonial-orbit_w';
                    const wi = document.createElement('span');
                    wi.className = 'werk-testimonial-orbit_wi';
                    wi.textContent = part;
                    w.append(wi);
                    frag.append(w);
                  }
                }
                n.replaceWith(frag);
              } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
            }
          };
          walk(q);
          q.dataset.split = '1';
          return [...q.querySelectorAll('.werk-testimonial-orbit_w')];
        }
        // the quote under the ring: line by line out of masks, then the name line – like the words in the review
        captionIn(v) {
          this.capAnims?.forEach((a) => a.cancel());
          this.capAnims = [];
          const cap = this.captions[v];
          if (!cap || !this.speed) return;
          const words = [...cap.children].flatMap((n) => this.split(n));
          let line = -1;
          let top = null;
          for (const w of words) {
            const t = w.offsetTop;
            if (top === null || Math.abs(t - top) > 3) {
              line++;
              top = t;
            }
            const a = w.firstChild.animate([{ transform: 'translateY(110%)' }, { transform: 'none' }], { duration: 900 * this.speed, delay: (160 + line * 80) * this.speed, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' });
            this.capAnims.push(a);
          }
        }
        stagger(entry, start) {
          const q = entry.querySelector('.werk-testimonial-orbit_quote p');
          const words = q ? this.split(q) : [];
          const view = entry.querySelector('.werk-testimonial-orbit_quote');
          const vb = view && view.getBoundingClientRect();
          let line = -1;
          let top = null;
          let shown = 0;
          for (const w of words) {
            const t = w.offsetTop;
            if (top === null || Math.abs(t - top) > 3) {
              line++;
              top = t;
            }
            // lines below the visible part of a long review simply stand there (no animation nobody sees)
            const r = w.getBoundingClientRect();
            if (vb && r.top > vb.bottom) continue;
            shown = line + 1;
            // every line rises out of its mask, one after the other
            this.anim(w.firstChild, [{ transform: 'translateY(110%)' }, { transform: 'none' }], { duration: 900, delay: start + line * 80, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
          }
          const rest = [entry.querySelector('.werk-testimonial-orbit_who'), entry.querySelector('.werk-testimonial-orbit_stars'), entry.querySelector('.werk-testimonial-orbit_foot')].filter(Boolean);
          rest.forEach((n, k) => this.anim(n, [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 800, delay: start + shown * 80 + 60 + k * 80, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }));
          // words still moving count as overflow – ask again once they stand whether the review needs to scroll
          clearTimeout(this.moreTm);
          if (view) this.moreTm = setTimeout(() => this.more(view), (start + shown * 80 + 950) * this.speed + 30);
        }
        // the picture's own corners: all round (in the ring / flying), only the left ones (in the open card)
        corners() {
          const r = 14 * this.u;
          return { round: `inset(0px round ${r}px)`, half: `inset(0px round ${r}px 0px 0px ${r}px)` };
        }
        // the picture's right corners follow the edge of the white part: as many px as the white has come out, that much
        // less radius – square once it is out by one radius (open), round again just as it disappears (close).
        // Sampled from the section's easing, the white edge runs on the same curve between offsets a and b.
        cornerFrames(a, b, white, closing) {
          const R = 14 * this.u;
          const out = [];
          const N = 48;
          for (let k = 0; k <= N; k++) {
            const q = k / N;
            const e = this.ease(q);
            const d = white * (closing ? 1 - e : e);
            const r = Math.max(0, R - d);
            out.push({ transform: 'none', clipPath: `inset(0px round ${R}px ${r.toFixed(2)}px ${r.toFixed(2)}px ${R}px)`, offset: a + (b - a) * q });
          }
          return out;
        }
        // clip paths of the review card: the front card, the picture column alone, everything
        clips(from, rr, media) {
          const r = 14 * this.u;
          const mr = media ? media.getBoundingClientRect() : rr;
          return {
            card: `inset(${from.top - rr.top}px ${rr.right - from.right}px ${rr.bottom - from.bottom}px ${from.left - rr.left}px round ${10 * this.u}px)`,
            pic: `inset(0px ${Math.max(0, rr.right - mr.right)}px 0px 0px round ${r}px)`,
            full: `inset(0px 0px 0px 0px round ${r}px)`,
            o: this.P1 / (this.P1 + this.P2),
          };
        }
        openSheet() {
          this.settle();
          this.classList.add('is-open', 'is-sheet');
          this.reader.showModal();
          this.panel.scrollTop = 0;
          this.anim(this.panel, [{ transform: 'translateY(100%)' }, { transform: 'none' }], { duration: 620, easing: this.css('--werk-ease') });
          this.anim(this.reader, [{ opacity: 0 }, { opacity: 1 }], { duration: 300, easing: 'ease-out', pseudoElement: '::backdrop' });
          if (this.entry) this.stagger(this.entry, 360);
        }
        async close(byKey) {
          if (!this.isOpen || this.closing) return;
          this.closing = true;
          // the card gets the focus back only when the review was closed with the keyboard (no ring after a click)
          const refocus = byKey && (this.panel.contains(document.activeElement) || this.reader.contains(document.activeElement));
          const sheet = this.reader.matches(':modal');
          this.settle();
          if (sheet) {
            const y = this.panel.style.translate ? parseFloat(this.panel.style.translate.split(' ')[1]) || 0 : 0;
            this.panel.style.translate = '';
            const a = this.anim(this.panel, [{ transform: `translateY(${y}px)` }, { transform: 'translateY(100%)' }], { duration: 420, easing: 'cubic-bezier(0.55, 0, 0.8, 0.2)' });
            this.anim(this.reader, [{ opacity: 1 }, { opacity: 0 }], { duration: 380, easing: 'ease-in', pseudoElement: '::backdrop' });
            this.classList.remove('is-open');
            await a.finished.catch(() => {});
          } else {
            const ir = this.inner.getBoundingClientRect();
            const rr = this.panel.getBoundingClientRect();
            const to = this.rest && { left: ir.left + this.rest.x, top: ir.top + this.rest.y, width: this.rest.w, height: this.rest.h, right: ir.left + this.rest.x + this.rest.w, bottom: ir.top + this.rest.y + this.rest.h };
            const body = this.entry?.querySelector('.werk-testimonial-orbit_body');
            const media = this.entry?.querySelector('.werk-testimonial-orbit_media');
            const ease = this.css('--werk-ease');
            // backwards: the words go, the white part closes to the left, then the picture flies back into the ring
            if (body) this.anim(body, [{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-in' });
            this.anim(this.reader, [{ '--rs': 1 }, { '--rs': 0 }], { duration: 300, easing: 'ease-in' });
            let a;
            if (to) {
              const { card, pic, full } = this.clips(to, rr, media);
              const hold = 120;
              const T = hold + this.P2 + this.P1;
              const o1 = hold / T;
              const o2 = (hold + this.P2) / T;
              a = this.anim(this.panel, [{ clipPath: full }, { clipPath: full, offset: o1, easing: ease }, { clipPath: pic, offset: o2, easing: ease }, { clipPath: card }], { duration: T, easing: 'linear' });
              if (media) {
                const { round, half } = this.corners();
                const white = rr.right - media.getBoundingClientRect().right;
                const frames = this.cornerFrames(o1, o2, white, true);
                frames[frames.length - 1].easing = ease;
                this.anim(media, [{ transform: 'none', clipPath: half }, ...frames, { transform: this.flip(to, media), clipPath: round }], { duration: T, easing: 'linear' });
              }
              // the ring comes back while the picture flies home
              this.ringBack = setTimeout(() => this.classList.remove('is-open'), (hold + this.P2 * 0.5) * this.speed);
            } else {
              this.classList.remove('is-open');
              a = this.anim(this.panel, [{ opacity: 1 }, { opacity: 0 }], { duration: 300 });
            }
            await a.finished.catch(() => {});
          }
          clearTimeout(this.ringBack);
          this.reader.close();
          // closing a dialog gives the focus back to what had it before (the tapped card) – only keep that for keyboard use
          if (!refocus && document.activeElement?.closest?.('.werk-testimonial-orbit_card') && this.contains(document.activeElement)) document.activeElement.blur();
          this.settle();
          this.classList.remove('is-open', 'is-sheet', 'is-reading');
          this.isOpen = false;
          this.closing = false;
          this.render();
          this.hold('open', false);
          this.hold('hover', false);
          if (refocus) this.cards.find((c) => c.tabIndex === 0)?.focus({ preventScroll: true });
          else if (this.reader.contains(document.activeElement)) document.activeElement.blur();
          // the front card lands: its shadow fades in instead of popping up
          this.classList.add('is-landing');
          clearTimeout(this.landTm);
          this.landTm = setTimeout(() => this.classList.remove('is-landing'), 600);
        }
        showEntry(v) {
          this.entries.forEach((en, i) => (en.hidden = i !== v));
          this.entry = this.entries[v];
          const img = this.entry?.querySelector('img');
          if (img) img.loading = 'eager';
          this.panel.scrollTop = 0;
          const q = this.entry?.querySelector('.werk-testimonial-orbit_quote');
          if (q) {
            q.scrollTop = 0;
            requestAnimationFrame(() => this.more(q));
          }
        }
        more(q) {
          q.classList.toggle('is-more', getComputedStyle(q).overflowY === 'auto' && q.scrollTop + q.clientHeight < q.scrollHeight - 4);
        }
        // arrows while the card is open: the ring turns along, the card changes its words and picture
        swap(v) {
          const old = this.entry;
          if (!old || old === this.entries[v]) return;
          const next = this.entries[v];
          [...(this.anims || [])].forEach((a) => a.effect?.target && (a.effect.target === old || old.contains(a.effect.target)) && a.cancel());
          this.showEntry(v);
          const media = next.querySelector('.werk-testimonial-orbit_media');
          if (media) this.anim(media, [{ opacity: 0 }, { opacity: 1 }], { duration: 420, easing: 'ease-out' });
          this.stagger(next, 60);
        }
        onReaderKey(e) {
          if (e.key === 'Escape') {
            e.preventDefault();
            this.close(true);
            return;
          }
          if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && !e.target.closest('input, textarea')) {
            e.preventDefault();
            this.go(e.key === 'ArrowRight' ? 1 : -1, 'key');
            return;
          }
          // keep the focus inside the card (in the section, the dialog is not modal)
          if (e.key === 'Tab' && !this.reader.matches(':modal')) {
            const list = [...this.panel.querySelectorAll('a[href], button:not([disabled])')].filter((el) => el.offsetParent && !el.closest('[hidden]') && el.tabIndex >= 0);
            if (!list.length) return;
            const first = list[0];
            const last = list[list.length - 1];
            if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
              e.preventDefault();
              last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        }
        // phones: pull the sheet down to close it (touch events – the browser would take a pointer drag as a scroll)
        sheetDrag() {
          let y0 = 0;
          let dy = 0;
          let t0 = 0;
          let track = false;
          let pulling = false;
          this.on(this.panel, 'touchstart', (e) => {
            if (!this.reader.matches(':modal') || e.touches.length > 1) return;
            track = this.panel.scrollTop <= 0;
            pulling = false;
            y0 = e.touches[0].clientY;
            dy = 0;
            t0 = e.timeStamp;
          }, { passive: true });
          this.on(this.panel, 'touchmove', (e) => {
            if (!track) return;
            dy = e.touches[0].clientY - y0;
            if (!pulling && dy > 6) pulling = true;
            if (!pulling) {
              if (dy < -6) track = false;
              return;
            }
            e.preventDefault();
            this.panel.style.translate = `0 ${Math.max(0, dy)}px`;
          }, { passive: false });
          const end = (e) => {
            if (!pulling) return;
            track = pulling = false;
            const fast = dy > 30 && e.timeStamp - t0 < 220;
            if (dy > 90 || fast) this.close();
            else {
              this.panel.style.translate = '';
              if (dy > 0) this.anim(this.panel, [{ transform: `translateY(${dy}px)` }, { transform: 'none' }], { duration: 380, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
            }
          };
          this.on(this.panel, 'touchend', end);
          this.on(this.panel, 'touchcancel', end);
        }

        // ---------- add to cart ----------
        async add(btn) {
          if (btn.dataset.state) return;
          const row = btn.closest('.werk-testimonial-orbit_product');
          const err = row.parentElement.querySelector('.werk-testimonial-orbit_error');
          if (err) err.hidden = true;
          btn.dataset.state = 'loading';
          const done = () => {
            btn.dataset.state = 'added';
            row.classList.add('is-added');
            clearTimeout(this.addTm);
            this.addTm = setTimeout(() => {
              delete btn.dataset.state;
              row.classList.remove('is-added');
            }, 2000);
          };
          try {
            if (btn.dataset.id === 'demo') {
              await new Promise((r) => setTimeout(r, 450));
              return done();
            }
            const root = window.Shopify?.routes?.root || '/';
            const items = [{ id: Number(btn.dataset.id), quantity: 1 }];
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw json;
            const cartP = fetch(root + 'cart.js').then((r) => r.json());
            const ev = new Event('shopify:cart:lines-update', { bubbles: true });
            Object.assign(ev, {
              action: 'add',
              context: 'product',
              lines: items.map((x) => ({ merchandiseId: x.id, quantity: x.quantity })),
              promise: cartP.then((c) => ({ cart: { totalQuantity: c.item_count }, detail: { itemCount: c.item_count } })),
            });
            this.dispatchEvent(ev);
            this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.werkThemeCart?.(root);
            done();
          } catch (e) {
            delete btn.dataset.state;
            if (err) {
              err.textContent = String(this.t.error || '').replace('[message]', e?.description || e?.message || '').trim();
              err.hidden = false;
            }
          }
        }

        css(name) {
          return getComputedStyle(this.inner).getPropertyValue(name).trim() || 'ease';
        }
        themeColors() {
          let el = this.parentElement;
          let bg = 'rgb(255, 255, 255)';
          while (el) {
            const c = getComputedStyle(el).backgroundColor;
            if (c && !/^(transparent|rgba\(.*,\s*0\))$/.test(c)) {
              bg = c;
              break;
            }
            el = el.parentElement;
          }
          this.style.setProperty('--werk-bg', bg);
          this.style.setProperty('--werk-fg', getComputedStyle(this).color);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
